{
  "DESKTOP.json": {
    "$id": "urn:dm:schemas:DESKTOP.json",
    "DesignQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "DataQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "PropertyQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "VariantsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StyleId": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "MobileHintsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BehaviorQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ConnectionQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ControllersQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "LayoutQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AnchorQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BreakpointVariantsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransformationQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransitionQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "Bindings": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContextsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ModesDefinition": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeId",
              "type"
            ],
            "properties": {
              "label": {
                "type": "string"
              },
              "modeId": {
                "type": "string"
              },
              "params": {
                "type": "string"
              },
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": {
                    "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                  }
                },
                "unevaluatedProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "unevaluatedProperties": false
          }
        },
        "isHiddenByModes": {
          "type": "boolean"
        },
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeIds"
            ],
            "properties": {
              "isHiddenByModes": {
                "type": "boolean"
              },
              "modeIds": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "layout": {
                "$ref": "#/LayoutObjectForComponents"
              },
              "designQuery": {
                "$ref": "#/DesignQuery"
              },
              "propertyQuery": {
                "$ref": "#/PropertyQuery"
              },
              "styleId": {
                "$ref": "#/StyleId"
              }
            },
            "unevaluatedProperties": false
          }
        }
      },
      "unevaluatedProperties": false
    },
    "AnchorDefinition": {
      "type": "object",
      "properties": {
        "distance": {
          "type": "number",
          "default": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": {
          "type": "boolean",
          "default": false
        },
        "targetComponent": {
          "type": "string"
        }
      },
      "unevaluatedProperties": false
    },
    "PartialLayoutObjectForMasterPage": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      },
      "unevaluatedProperties": false
    },
    "DockingUnitSize": {
      "type": "object",
      "properties": {
        "px": {
          "type": "number"
        },
        "pct": {
          "type": "number"
        },
        "vw": {
          "type": "number"
        },
        "vh": {
          "type": "number"
        }
      },
      "unevaluatedProperties": false
    },
    "DockingDefinition": {
      "type": "object",
      "properties": {
        "left": {
          "$ref": "#/DockingUnitSize"
        },
        "right": {
          "$ref": "#/DockingUnitSize"
        },
        "top": {
          "$ref": "#/DockingUnitSize"
        },
        "bottom": {
          "$ref": "#/DockingUnitSize"
        },
        "hCenter": {
          "$ref": "#/DockingUnitSize"
        },
        "vCenter": {
          "$ref": "#/DockingUnitSize"
        }
      },
      "unevaluatedProperties": false
    },
    "BaseComponentObject": {
      "type": "object",
      "required": [
        "id",
        "type"
      ],
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "unevaluatedProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "$ref": "#/Parent"
        }
      },
      "unevaluatedProperties": false
    },
    "MetaDataForComponents": {
      "type": "object",
      "properties": {},
      "unevaluatedProperties": false
    },
    "LayoutObjectForComponents": {
      "type": "object",
      "properties": {
        "x": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "y": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "width": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "height": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "rotationInDegrees": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "fixedPosition": {
          "type": "boolean"
        },
        "scale": {
          "type": "number"
        },
        "docked": {
          "$ref": "#/DockingDefinition"
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      },
      "unevaluatedProperties": false
    },
    "ShouldReallyBeAnIntAtSomePoint": {
      "type": "number",
      "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
      "default": 0,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "ComponentsList": {
      "uniqueItems": true,
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "Component": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/BaseComponentObject--unrestricted-root"
        },
        {
          "$ref": "#/ComponentQueries--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentType"
          ],
          "properties": {
            "componentType": {
              "type": "string"
            },
            "skin": {
              "type": "string"
            },
            "modes": {
              "$ref": "#/ModesDefinition"
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "ComponentQueries": {
      "type": "object",
      "properties": {
        "dataQuery": {
          "$ref": "#/DataQuery"
        },
        "propertyQuery": {
          "$ref": "#/PropertyQuery"
        },
        "designQuery": {
          "$ref": "#/DesignQuery"
        },
        "mobileHintsQuery": {
          "$ref": "#/MobileHintsQuery"
        },
        "behaviorQuery": {
          "$ref": "#/BehaviorQuery"
        },
        "connectionQuery": {
          "$ref": "#/ConnectionQuery"
        },
        "controllersQuery": {
          "$ref": "#/ControllersQuery"
        },
        "layoutQuery": {
          "$ref": "#/LayoutQuery"
        },
        "anchorQuery": {
          "$ref": "#/AnchorQuery"
        },
        "breakpointVariantsQuery": {
          "$ref": "#/BreakpointVariantsQuery"
        },
        "transformationQuery": {
          "$ref": "#/TransformationQuery"
        },
        "transitionQuery": {
          "$ref": "#/TransitionQuery"
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "bindings": {
          "$ref": "#/Bindings"
        },
        "styleId": {
          "$ref": "#/StyleId"
        },
        "layout": {
          "$ref": "#/LayoutObjectForComponents"
        },
        "accessibilityQuery": {
          "$ref": "#/AccessibilityQuery"
        },
        "classnamesQuery": {
          "$ref": "#/ClassnamesQuery"
        },
        "contentRoleQuery": {
          "$ref": "#/ContentRoleQuery"
        },
        "cursorQuery": {
          "$ref": "#/CursorQuery"
        },
        "discussionsQuery": {
          "$ref": "#/DiscussionsQuery"
        },
        "editorsettingsQuery": {
          "$ref": "#/EditorsettingsQuery"
        },
        "effectsQuery": {
          "$ref": "#/EffectsQuery"
        },
        "groupingQuery": {
          "$ref": "#/GroupingQuery"
        },
        "innerElementsQuery": {
          "$ref": "#/InnerElementsQuery"
        },
        "intentQuery": {
          "$ref": "#/IntentQuery"
        },
        "layoutSettingsQuery": {
          "$ref": "#/LayoutSettingsQuery"
        },
        "manifestQuery": {
          "$ref": "#/ManifestQuery"
        },
        "measurementsQuery": {
          "$ref": "#/MeasurementsQuery"
        },
        "migrationQuery": {
          "$ref": "#/MigrationQuery"
        },
        "namingQuery": {
          "$ref": "#/NamingQuery"
        },
        "notificationsQuery": {
          "$ref": "#/NotificationsQuery"
        },
        "pageSectionsQuery": {
          "$ref": "#/PageSectionsQuery"
        },
        "presetsQuery": {
          "$ref": "#/PresetsQuery"
        },
        "reactionsQuery": {
          "$ref": "#/ReactionsQuery"
        },
        "slotsQuery": {
          "$ref": "#/SlotsQuery"
        },
        "sourceQuery": {
          "$ref": "#/SourceQuery"
        },
        "statesQuery": {
          "$ref": "#/StatesQuery"
        },
        "triggersQuery": {
          "$ref": "#/TriggersQuery"
        },
        "variablesQuery": {
          "$ref": "#/VariablesQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "RefComponent": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "RepeaterContainer": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/RepeaterQueries--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "RepeaterVariantsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "RepeaterQueries": {
      "type": "object",
      "properties": {
        "variantsQuery": {
          "$ref": "#/RepeaterVariantsQuery"
        },
        "patternsQuery": {
          "$ref": "#/PatternsQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "ContainerQueries": {
      "type": "object",
      "properties": {
        "contexts": {
          "$ref": "#/ContextsQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "Container": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "$ref": "#/ContainerQueries--unrestricted-root"
        },
        {
          "required": [
            "components"
          ],
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "PageQueries": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "Page": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/PageQueries--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "DocumentProperties": {
      "type": "object",
      "required": [
        "documentType",
        "components"
      ],
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "$ref": "#/PartialLayoutObjectForMasterPage"
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        },
        "themeConfigQuery": {
          "$ref": "#/ThemeConfigQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "Document": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/DocumentProperties--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "Parent": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AccessibilityQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ClassnamesQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContentRoleQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "CursorQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "DiscussionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EditorsettingsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EffectsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "FixerVersionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "GroupingQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "InnerElementsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "IntentQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "LayoutSettingsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ManifestQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MeasurementsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MigrationQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NamingQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NotificationsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PageSectionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PatternsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PresetsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ReactionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SlotsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SourceQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StatesQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ThemeConfigQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "TriggersQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "VariablesQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "DesignQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "DataQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "PropertyQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "VariantsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StyleId--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "MobileHintsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BehaviorQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ConnectionQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ControllersQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "LayoutQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AnchorQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BreakpointVariantsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransformationQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransitionQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "Bindings--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContextsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ModesDefinition--unrestricted-root": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeId",
              "type"
            ],
            "properties": {
              "label": {
                "type": "string"
              },
              "modeId": {
                "type": "string"
              },
              "params": {
                "type": "string"
              },
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": {
                    "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                  }
                },
                "unevaluatedProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "unevaluatedProperties": false
          }
        },
        "isHiddenByModes": {
          "type": "boolean"
        },
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeIds"
            ],
            "properties": {
              "isHiddenByModes": {
                "type": "boolean"
              },
              "modeIds": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "layout": {
                "$ref": "#/LayoutObjectForComponents"
              },
              "designQuery": {
                "$ref": "#/DesignQuery"
              },
              "propertyQuery": {
                "$ref": "#/PropertyQuery"
              },
              "styleId": {
                "$ref": "#/StyleId"
              }
            },
            "unevaluatedProperties": false
          }
        }
      }
    },
    "AnchorDefinition--unrestricted-root": {
      "type": "object",
      "properties": {
        "distance": {
          "type": "number",
          "default": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": {
          "type": "boolean",
          "default": false
        },
        "targetComponent": {
          "type": "string"
        }
      }
    },
    "PartialLayoutObjectForMasterPage--unrestricted-root": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      }
    },
    "DockingUnitSize--unrestricted-root": {
      "type": "object",
      "properties": {
        "px": {
          "type": "number"
        },
        "pct": {
          "type": "number"
        },
        "vw": {
          "type": "number"
        },
        "vh": {
          "type": "number"
        }
      }
    },
    "DockingDefinition--unrestricted-root": {
      "type": "object",
      "properties": {
        "left": {
          "$ref": "#/DockingUnitSize"
        },
        "right": {
          "$ref": "#/DockingUnitSize"
        },
        "top": {
          "$ref": "#/DockingUnitSize"
        },
        "bottom": {
          "$ref": "#/DockingUnitSize"
        },
        "hCenter": {
          "$ref": "#/DockingUnitSize"
        },
        "vCenter": {
          "$ref": "#/DockingUnitSize"
        }
      }
    },
    "BaseComponentObject--unrestricted-root": {
      "type": "object",
      "required": [
        "id",
        "type"
      ],
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "unevaluatedProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "$ref": "#/Parent"
        }
      }
    },
    "MetaDataForComponents--unrestricted-root": {
      "type": "object",
      "properties": {}
    },
    "LayoutObjectForComponents--unrestricted-root": {
      "type": "object",
      "properties": {
        "x": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "y": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "width": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "height": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "rotationInDegrees": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "fixedPosition": {
          "type": "boolean"
        },
        "scale": {
          "type": "number"
        },
        "docked": {
          "$ref": "#/DockingDefinition"
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      }
    },
    "ShouldReallyBeAnIntAtSomePoint--unrestricted-root": {
      "type": "number",
      "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
      "default": 0,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "ComponentsList--unrestricted-root": {
      "uniqueItems": true,
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "Component--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/BaseComponentObject--unrestricted-root"
        },
        {
          "$ref": "#/ComponentQueries--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentType"
          ],
          "properties": {
            "componentType": {
              "type": "string"
            },
            "skin": {
              "type": "string"
            },
            "modes": {
              "$ref": "#/ModesDefinition"
            }
          }
        }
      ]
    },
    "ComponentQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "dataQuery": {
          "$ref": "#/DataQuery"
        },
        "propertyQuery": {
          "$ref": "#/PropertyQuery"
        },
        "designQuery": {
          "$ref": "#/DesignQuery"
        },
        "mobileHintsQuery": {
          "$ref": "#/MobileHintsQuery"
        },
        "behaviorQuery": {
          "$ref": "#/BehaviorQuery"
        },
        "connectionQuery": {
          "$ref": "#/ConnectionQuery"
        },
        "controllersQuery": {
          "$ref": "#/ControllersQuery"
        },
        "layoutQuery": {
          "$ref": "#/LayoutQuery"
        },
        "anchorQuery": {
          "$ref": "#/AnchorQuery"
        },
        "breakpointVariantsQuery": {
          "$ref": "#/BreakpointVariantsQuery"
        },
        "transformationQuery": {
          "$ref": "#/TransformationQuery"
        },
        "transitionQuery": {
          "$ref": "#/TransitionQuery"
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "bindings": {
          "$ref": "#/Bindings"
        },
        "styleId": {
          "$ref": "#/StyleId"
        },
        "layout": {
          "$ref": "#/LayoutObjectForComponents"
        },
        "accessibilityQuery": {
          "$ref": "#/AccessibilityQuery"
        },
        "classnamesQuery": {
          "$ref": "#/ClassnamesQuery"
        },
        "contentRoleQuery": {
          "$ref": "#/ContentRoleQuery"
        },
        "cursorQuery": {
          "$ref": "#/CursorQuery"
        },
        "discussionsQuery": {
          "$ref": "#/DiscussionsQuery"
        },
        "editorsettingsQuery": {
          "$ref": "#/EditorsettingsQuery"
        },
        "effectsQuery": {
          "$ref": "#/EffectsQuery"
        },
        "groupingQuery": {
          "$ref": "#/GroupingQuery"
        },
        "innerElementsQuery": {
          "$ref": "#/InnerElementsQuery"
        },
        "intentQuery": {
          "$ref": "#/IntentQuery"
        },
        "layoutSettingsQuery": {
          "$ref": "#/LayoutSettingsQuery"
        },
        "manifestQuery": {
          "$ref": "#/ManifestQuery"
        },
        "measurementsQuery": {
          "$ref": "#/MeasurementsQuery"
        },
        "migrationQuery": {
          "$ref": "#/MigrationQuery"
        },
        "namingQuery": {
          "$ref": "#/NamingQuery"
        },
        "notificationsQuery": {
          "$ref": "#/NotificationsQuery"
        },
        "pageSectionsQuery": {
          "$ref": "#/PageSectionsQuery"
        },
        "presetsQuery": {
          "$ref": "#/PresetsQuery"
        },
        "reactionsQuery": {
          "$ref": "#/ReactionsQuery"
        },
        "slotsQuery": {
          "$ref": "#/SlotsQuery"
        },
        "sourceQuery": {
          "$ref": "#/SourceQuery"
        },
        "statesQuery": {
          "$ref": "#/StatesQuery"
        },
        "triggersQuery": {
          "$ref": "#/TriggersQuery"
        },
        "variablesQuery": {
          "$ref": "#/VariablesQuery"
        }
      }
    },
    "RefComponent--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ]
    },
    "RepeaterContainer--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/RepeaterQueries--unrestricted-root"
        }
      ]
    },
    "RepeaterVariantsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "RepeaterQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "variantsQuery": {
          "$ref": "#/RepeaterVariantsQuery"
        },
        "patternsQuery": {
          "$ref": "#/PatternsQuery"
        }
      }
    },
    "ContainerQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "contexts": {
          "$ref": "#/ContextsQuery"
        }
      }
    },
    "Container--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "$ref": "#/ContainerQueries--unrestricted-root"
        },
        {
          "required": [
            "components"
          ],
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ]
    },
    "PageQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        }
      }
    },
    "Page--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/PageQueries--unrestricted-root"
        }
      ]
    },
    "DocumentProperties--unrestricted-root": {
      "type": "object",
      "required": [
        "documentType",
        "components"
      ],
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "$ref": "#/PartialLayoutObjectForMasterPage"
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        },
        "themeConfigQuery": {
          "$ref": "#/ThemeConfigQuery"
        }
      }
    },
    "Document--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/DocumentProperties--unrestricted-root"
        }
      ]
    },
    "Parent--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AccessibilityQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ClassnamesQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContentRoleQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "CursorQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "DiscussionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EditorsettingsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EffectsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "FixerVersionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "GroupingQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "InnerElementsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "IntentQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "LayoutSettingsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ManifestQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MeasurementsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MigrationQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NamingQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NotificationsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PageSectionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PatternsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PresetsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ReactionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SlotsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SourceQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StatesQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ThemeConfigQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "TriggersQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "VariablesQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    }
  },
  "MOBILE.json": {
    "$id": "urn:dm:schemas:MOBILE.json",
    "DesignQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "DataQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "PropertyQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "VariantsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StyleId": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "MobileHintsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BehaviorQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ConnectionQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ControllersQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "LayoutQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AnchorQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BreakpointVariantsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransformationQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransitionQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "Bindings": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContextsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ModesDefinition": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeId",
              "type"
            ],
            "properties": {
              "label": {
                "type": "string"
              },
              "modeId": {
                "type": "string"
              },
              "params": {
                "type": "string"
              },
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": {
                    "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                  }
                },
                "unevaluatedProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "unevaluatedProperties": false
          }
        },
        "isHiddenByModes": {
          "type": "boolean"
        },
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeIds"
            ],
            "properties": {
              "isHiddenByModes": {
                "type": "boolean"
              },
              "modeIds": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "layout": {
                "$ref": "#/LayoutObjectForComponents"
              },
              "designQuery": {
                "$ref": "#/DesignQuery"
              },
              "propertyQuery": {
                "$ref": "#/PropertyQuery"
              },
              "styleId": {
                "$ref": "#/StyleId"
              }
            },
            "unevaluatedProperties": false
          }
        }
      },
      "unevaluatedProperties": false
    },
    "AnchorDefinition": {
      "type": "object",
      "properties": {
        "distance": {
          "type": "number",
          "default": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": {
          "type": "boolean",
          "default": false
        },
        "targetComponent": {
          "type": "string"
        }
      },
      "unevaluatedProperties": false
    },
    "PartialLayoutObjectForMasterPage": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      },
      "unevaluatedProperties": false
    },
    "DockingUnitSize": {
      "type": "object",
      "properties": {
        "px": {
          "type": "number"
        },
        "pct": {
          "type": "number"
        },
        "vw": {
          "type": "number"
        },
        "vh": {
          "type": "number"
        }
      },
      "unevaluatedProperties": false
    },
    "DockingDefinition": {
      "type": "object",
      "properties": {
        "left": {
          "$ref": "#/DockingUnitSize"
        },
        "right": {
          "$ref": "#/DockingUnitSize"
        },
        "top": {
          "$ref": "#/DockingUnitSize"
        },
        "bottom": {
          "$ref": "#/DockingUnitSize"
        },
        "hCenter": {
          "$ref": "#/DockingUnitSize"
        },
        "vCenter": {
          "$ref": "#/DockingUnitSize"
        }
      },
      "unevaluatedProperties": false
    },
    "BaseComponentObject": {
      "type": "object",
      "required": [
        "id",
        "type"
      ],
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "unevaluatedProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "$ref": "#/Parent"
        }
      },
      "unevaluatedProperties": false
    },
    "MetaDataForComponents": {
      "type": "object",
      "properties": {},
      "unevaluatedProperties": false
    },
    "LayoutObjectForComponents": {
      "type": "object",
      "properties": {
        "x": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "y": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "width": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "height": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "rotationInDegrees": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "fixedPosition": {
          "type": "boolean"
        },
        "scale": {
          "type": "number"
        },
        "docked": {
          "$ref": "#/DockingDefinition"
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      },
      "unevaluatedProperties": false
    },
    "ShouldReallyBeAnIntAtSomePoint": {
      "type": "number",
      "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
      "default": 0,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "ComponentsList": {
      "uniqueItems": true,
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "Component": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/BaseComponentObject--unrestricted-root"
        },
        {
          "$ref": "#/ComponentQueries--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentType"
          ],
          "properties": {
            "componentType": {
              "type": "string"
            },
            "skin": {
              "type": "string"
            },
            "modes": {
              "$ref": "#/ModesDefinition"
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "ComponentQueries": {
      "type": "object",
      "properties": {
        "dataQuery": {
          "$ref": "#/DataQuery"
        },
        "propertyQuery": {
          "$ref": "#/PropertyQuery"
        },
        "designQuery": {
          "$ref": "#/DesignQuery"
        },
        "mobileHintsQuery": {
          "$ref": "#/MobileHintsQuery"
        },
        "behaviorQuery": {
          "$ref": "#/BehaviorQuery"
        },
        "connectionQuery": {
          "$ref": "#/ConnectionQuery"
        },
        "controllersQuery": {
          "$ref": "#/ControllersQuery"
        },
        "layoutQuery": {
          "$ref": "#/LayoutQuery"
        },
        "anchorQuery": {
          "$ref": "#/AnchorQuery"
        },
        "breakpointVariantsQuery": {
          "$ref": "#/BreakpointVariantsQuery"
        },
        "transformationQuery": {
          "$ref": "#/TransformationQuery"
        },
        "transitionQuery": {
          "$ref": "#/TransitionQuery"
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "bindings": {
          "$ref": "#/Bindings"
        },
        "styleId": {
          "$ref": "#/StyleId"
        },
        "layout": {
          "$ref": "#/LayoutObjectForComponents"
        },
        "accessibilityQuery": {
          "$ref": "#/AccessibilityQuery"
        },
        "classnamesQuery": {
          "$ref": "#/ClassnamesQuery"
        },
        "contentRoleQuery": {
          "$ref": "#/ContentRoleQuery"
        },
        "cursorQuery": {
          "$ref": "#/CursorQuery"
        },
        "discussionsQuery": {
          "$ref": "#/DiscussionsQuery"
        },
        "editorsettingsQuery": {
          "$ref": "#/EditorsettingsQuery"
        },
        "effectsQuery": {
          "$ref": "#/EffectsQuery"
        },
        "groupingQuery": {
          "$ref": "#/GroupingQuery"
        },
        "innerElementsQuery": {
          "$ref": "#/InnerElementsQuery"
        },
        "intentQuery": {
          "$ref": "#/IntentQuery"
        },
        "layoutSettingsQuery": {
          "$ref": "#/LayoutSettingsQuery"
        },
        "manifestQuery": {
          "$ref": "#/ManifestQuery"
        },
        "measurementsQuery": {
          "$ref": "#/MeasurementsQuery"
        },
        "migrationQuery": {
          "$ref": "#/MigrationQuery"
        },
        "namingQuery": {
          "$ref": "#/NamingQuery"
        },
        "notificationsQuery": {
          "$ref": "#/NotificationsQuery"
        },
        "pageSectionsQuery": {
          "$ref": "#/PageSectionsQuery"
        },
        "presetsQuery": {
          "$ref": "#/PresetsQuery"
        },
        "reactionsQuery": {
          "$ref": "#/ReactionsQuery"
        },
        "slotsQuery": {
          "$ref": "#/SlotsQuery"
        },
        "sourceQuery": {
          "$ref": "#/SourceQuery"
        },
        "statesQuery": {
          "$ref": "#/StatesQuery"
        },
        "triggersQuery": {
          "$ref": "#/TriggersQuery"
        },
        "variablesQuery": {
          "$ref": "#/VariablesQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "RefComponent": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "RepeaterContainer": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/RepeaterQueries--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "RepeaterVariantsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "RepeaterQueries": {
      "type": "object",
      "properties": {
        "variantsQuery": {
          "$ref": "#/RepeaterVariantsQuery"
        },
        "patternsQuery": {
          "$ref": "#/PatternsQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "ContainerQueries": {
      "type": "object",
      "properties": {
        "contexts": {
          "$ref": "#/ContextsQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "Container": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "$ref": "#/ContainerQueries--unrestricted-root"
        },
        {
          "required": [
            "components"
          ],
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "PageQueries": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "Page": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/PageQueries--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "DocumentProperties": {
      "type": "object",
      "required": [
        "documentType",
        "components"
      ],
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "$ref": "#/PartialLayoutObjectForMasterPage"
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        },
        "themeConfigQuery": {
          "$ref": "#/ThemeConfigQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "Document": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/DocumentProperties--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "Parent": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AccessibilityQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ClassnamesQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContentRoleQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "CursorQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "DiscussionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EditorsettingsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EffectsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "FixerVersionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "GroupingQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "InnerElementsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "IntentQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "LayoutSettingsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ManifestQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MeasurementsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MigrationQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NamingQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NotificationsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PageSectionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PatternsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PresetsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ReactionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SlotsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SourceQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StatesQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ThemeConfigQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "TriggersQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "VariablesQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "DesignQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "DataQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "PropertyQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "VariantsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StyleId--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "MobileHintsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BehaviorQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ConnectionQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ControllersQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "LayoutQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AnchorQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BreakpointVariantsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransformationQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransitionQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "Bindings--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContextsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ModesDefinition--unrestricted-root": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeId",
              "type"
            ],
            "properties": {
              "label": {
                "type": "string"
              },
              "modeId": {
                "type": "string"
              },
              "params": {
                "type": "string"
              },
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": {
                    "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                  }
                },
                "unevaluatedProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "unevaluatedProperties": false
          }
        },
        "isHiddenByModes": {
          "type": "boolean"
        },
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeIds"
            ],
            "properties": {
              "isHiddenByModes": {
                "type": "boolean"
              },
              "modeIds": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "layout": {
                "$ref": "#/LayoutObjectForComponents"
              },
              "designQuery": {
                "$ref": "#/DesignQuery"
              },
              "propertyQuery": {
                "$ref": "#/PropertyQuery"
              },
              "styleId": {
                "$ref": "#/StyleId"
              }
            },
            "unevaluatedProperties": false
          }
        }
      }
    },
    "AnchorDefinition--unrestricted-root": {
      "type": "object",
      "properties": {
        "distance": {
          "type": "number",
          "default": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": {
          "type": "boolean",
          "default": false
        },
        "targetComponent": {
          "type": "string"
        }
      }
    },
    "PartialLayoutObjectForMasterPage--unrestricted-root": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      }
    },
    "DockingUnitSize--unrestricted-root": {
      "type": "object",
      "properties": {
        "px": {
          "type": "number"
        },
        "pct": {
          "type": "number"
        },
        "vw": {
          "type": "number"
        },
        "vh": {
          "type": "number"
        }
      }
    },
    "DockingDefinition--unrestricted-root": {
      "type": "object",
      "properties": {
        "left": {
          "$ref": "#/DockingUnitSize"
        },
        "right": {
          "$ref": "#/DockingUnitSize"
        },
        "top": {
          "$ref": "#/DockingUnitSize"
        },
        "bottom": {
          "$ref": "#/DockingUnitSize"
        },
        "hCenter": {
          "$ref": "#/DockingUnitSize"
        },
        "vCenter": {
          "$ref": "#/DockingUnitSize"
        }
      }
    },
    "BaseComponentObject--unrestricted-root": {
      "type": "object",
      "required": [
        "id",
        "type"
      ],
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "unevaluatedProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "$ref": "#/Parent"
        }
      }
    },
    "MetaDataForComponents--unrestricted-root": {
      "type": "object",
      "properties": {}
    },
    "LayoutObjectForComponents--unrestricted-root": {
      "type": "object",
      "properties": {
        "x": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "y": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "width": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "height": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "rotationInDegrees": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "fixedPosition": {
          "type": "boolean"
        },
        "scale": {
          "type": "number"
        },
        "docked": {
          "$ref": "#/DockingDefinition"
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      }
    },
    "ShouldReallyBeAnIntAtSomePoint--unrestricted-root": {
      "type": "number",
      "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
      "default": 0,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "ComponentsList--unrestricted-root": {
      "uniqueItems": true,
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "Component--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/BaseComponentObject--unrestricted-root"
        },
        {
          "$ref": "#/ComponentQueries--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentType"
          ],
          "properties": {
            "componentType": {
              "type": "string"
            },
            "skin": {
              "type": "string"
            },
            "modes": {
              "$ref": "#/ModesDefinition"
            }
          }
        }
      ]
    },
    "ComponentQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "dataQuery": {
          "$ref": "#/DataQuery"
        },
        "propertyQuery": {
          "$ref": "#/PropertyQuery"
        },
        "designQuery": {
          "$ref": "#/DesignQuery"
        },
        "mobileHintsQuery": {
          "$ref": "#/MobileHintsQuery"
        },
        "behaviorQuery": {
          "$ref": "#/BehaviorQuery"
        },
        "connectionQuery": {
          "$ref": "#/ConnectionQuery"
        },
        "controllersQuery": {
          "$ref": "#/ControllersQuery"
        },
        "layoutQuery": {
          "$ref": "#/LayoutQuery"
        },
        "anchorQuery": {
          "$ref": "#/AnchorQuery"
        },
        "breakpointVariantsQuery": {
          "$ref": "#/BreakpointVariantsQuery"
        },
        "transformationQuery": {
          "$ref": "#/TransformationQuery"
        },
        "transitionQuery": {
          "$ref": "#/TransitionQuery"
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "bindings": {
          "$ref": "#/Bindings"
        },
        "styleId": {
          "$ref": "#/StyleId"
        },
        "layout": {
          "$ref": "#/LayoutObjectForComponents"
        },
        "accessibilityQuery": {
          "$ref": "#/AccessibilityQuery"
        },
        "classnamesQuery": {
          "$ref": "#/ClassnamesQuery"
        },
        "contentRoleQuery": {
          "$ref": "#/ContentRoleQuery"
        },
        "cursorQuery": {
          "$ref": "#/CursorQuery"
        },
        "discussionsQuery": {
          "$ref": "#/DiscussionsQuery"
        },
        "editorsettingsQuery": {
          "$ref": "#/EditorsettingsQuery"
        },
        "effectsQuery": {
          "$ref": "#/EffectsQuery"
        },
        "groupingQuery": {
          "$ref": "#/GroupingQuery"
        },
        "innerElementsQuery": {
          "$ref": "#/InnerElementsQuery"
        },
        "intentQuery": {
          "$ref": "#/IntentQuery"
        },
        "layoutSettingsQuery": {
          "$ref": "#/LayoutSettingsQuery"
        },
        "manifestQuery": {
          "$ref": "#/ManifestQuery"
        },
        "measurementsQuery": {
          "$ref": "#/MeasurementsQuery"
        },
        "migrationQuery": {
          "$ref": "#/MigrationQuery"
        },
        "namingQuery": {
          "$ref": "#/NamingQuery"
        },
        "notificationsQuery": {
          "$ref": "#/NotificationsQuery"
        },
        "pageSectionsQuery": {
          "$ref": "#/PageSectionsQuery"
        },
        "presetsQuery": {
          "$ref": "#/PresetsQuery"
        },
        "reactionsQuery": {
          "$ref": "#/ReactionsQuery"
        },
        "slotsQuery": {
          "$ref": "#/SlotsQuery"
        },
        "sourceQuery": {
          "$ref": "#/SourceQuery"
        },
        "statesQuery": {
          "$ref": "#/StatesQuery"
        },
        "triggersQuery": {
          "$ref": "#/TriggersQuery"
        },
        "variablesQuery": {
          "$ref": "#/VariablesQuery"
        }
      }
    },
    "RefComponent--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ]
    },
    "RepeaterContainer--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/RepeaterQueries--unrestricted-root"
        }
      ]
    },
    "RepeaterVariantsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "RepeaterQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "variantsQuery": {
          "$ref": "#/RepeaterVariantsQuery"
        },
        "patternsQuery": {
          "$ref": "#/PatternsQuery"
        }
      }
    },
    "ContainerQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "contexts": {
          "$ref": "#/ContextsQuery"
        }
      }
    },
    "Container--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "$ref": "#/ContainerQueries--unrestricted-root"
        },
        {
          "required": [
            "components"
          ],
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ]
    },
    "PageQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        }
      }
    },
    "Page--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/PageQueries--unrestricted-root"
        }
      ]
    },
    "DocumentProperties--unrestricted-root": {
      "type": "object",
      "required": [
        "documentType",
        "components"
      ],
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "$ref": "#/PartialLayoutObjectForMasterPage"
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        },
        "themeConfigQuery": {
          "$ref": "#/ThemeConfigQuery"
        }
      }
    },
    "Document--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/DocumentProperties--unrestricted-root"
        }
      ]
    },
    "Parent--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AccessibilityQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ClassnamesQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContentRoleQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "CursorQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "DiscussionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EditorsettingsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EffectsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "FixerVersionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "GroupingQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "InnerElementsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "IntentQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "LayoutSettingsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ManifestQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MeasurementsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MigrationQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NamingQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NotificationsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PageSectionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PatternsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PresetsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ReactionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SlotsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SourceQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StatesQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ThemeConfigQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "TriggersQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "VariablesQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    }
  },
  "accessibility.json": {
    "$id": "urn:dm:schemas:accessibility.json",
    "Accessibility": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "ruleAction",
            "ruleId"
          ],
          "properties": {
            "ruleAction": {
              "type": "string",
              "enum": [
                "UNKNOWN_RULE_ACTION",
                "SKIPPED",
                "COMPLETED_MANUALLY",
                "COMPLETED_AUTOMATICALLY"
              ],
              "description": "The action which was performed by the user on that rule"
            },
            "ruleId": {
              "type": "string",
              "maxLength": 256,
              "description": "The ID of the rule"
            },
            "userSelectionRuleData": {
              "$ref": "#/UserSelectionRuleData",
              "description": "The user selection rule data"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "UserSelectionRuleData": {
      "type": "object",
      "description": "User selection rule data with rule-specific information",
      "additionalProperties": false,
      "properties": {
        "mediaAlternativesRuleData": {
          "$ref": "#/MediaAlternativesRuleData"
        }
      },
      "unevaluatedProperties": false
    },
    "MediaAlternativesRuleData": {
      "type": "object",
      "description": "Media alternatives rule-specific data",
      "required": [
        "mediaType"
      ],
      "additionalProperties": false,
      "properties": {
        "mediaType": {
          "type": "string",
          "enum": [
            "UNKNOWN_MEDIA_TYPE",
            "AUDIO",
            "VIDEO",
            "VIDEO_WITH_AUDIO",
            "DECORATIVE"
          ],
          "description": "The media type determined by the user"
        }
      },
      "unevaluatedProperties": false
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "Accessibility--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "ruleAction",
            "ruleId"
          ],
          "properties": {
            "ruleAction": {
              "type": "string",
              "enum": [
                "UNKNOWN_RULE_ACTION",
                "SKIPPED",
                "COMPLETED_MANUALLY",
                "COMPLETED_AUTOMATICALLY"
              ],
              "description": "The action which was performed by the user on that rule"
            },
            "ruleId": {
              "type": "string",
              "maxLength": 256,
              "description": "The ID of the rule"
            },
            "userSelectionRuleData": {
              "$ref": "#/UserSelectionRuleData",
              "description": "The user selection rule data"
            }
          }
        }
      ],
      "type": "object"
    },
    "UserSelectionRuleData--unrestricted-root": {
      "type": "object",
      "description": "User selection rule data with rule-specific information",
      "properties": {
        "mediaAlternativesRuleData": {
          "$ref": "#/MediaAlternativesRuleData"
        }
      }
    },
    "MediaAlternativesRuleData--unrestricted-root": {
      "type": "object",
      "description": "Media alternatives rule-specific data",
      "required": [
        "mediaType"
      ],
      "properties": {
        "mediaType": {
          "type": "string",
          "enum": [
            "UNKNOWN_MEDIA_TYPE",
            "AUDIO",
            "VIDEO",
            "VIDEO_WITH_AUDIO",
            "DECORATIVE"
          ],
          "description": "The media type determined by the user"
        }
      }
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    }
  },
  "anchors_data.json": {
    "$id": "urn:dm:schemas:anchors_data.json",
    "AnchorInfo": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "urlFragment": {
              "type": "string",
              "maxLength": 60
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AnchorInfo--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "urlFragment": {
              "type": "string",
              "maxLength": 60
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "atomicScopes.json": {
    "$id": "urn:dm:schemas:atomicScopes.json",
    "AtomicScope": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object"
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AtomicScope--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object"
        }
      ],
      "type": "object"
    }
  },
  "behaviors_data.json": {
    "$id": "urn:dm:schemas:behaviors_data.json",
    "ObsoleteBehaviorsList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "type": [
                "string"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ObsoleteBehaviorsList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "type": [
                "string"
              ]
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "bindings.json": {
    "$id": "urn:dm:schemas:bindings.json",
    "BindingsList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "values": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ContextBindingConfig": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "contextProvider": {
              "type": "string"
            },
            "schemaRef": {
              "type": "string"
            },
            "properties": {
              "type": "object",
              "additionalProperties": {
                "type": "string"
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BindingsList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "values": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "ContextBindingConfig--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "contextProvider": {
              "type": "string"
            },
            "schemaRef": {
              "type": "string"
            },
            "properties": {
              "type": "object",
              "additionalProperties": {
                "type": "string"
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "classnames.json": {
    "$id": "urn:dm:schemas:classnames.json",
    "Classnames": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "classnames"
          ],
          "properties": {
            "classnames": {
              "type": "array",
              "items": {
                "type": "string",
                "pattern": "^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$",
                "maxLength": 200
              },
              "default": [],
              "maxItems": 20
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Classnames--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "classnames"
          ],
          "properties": {
            "classnames": {
              "type": "array",
              "items": {
                "type": "string",
                "pattern": "^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$",
                "maxLength": 200
              },
              "default": [],
              "maxItems": 20
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "common.json": {
    "$id": "urn:dm:schemas:common.json",
    "color": {
      "type": "string",
      "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
    },
    "nullableColor": {
      "type": [
        "string",
        "null"
      ],
      "pattern": "^(^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$)$"
    },
    "hexColor": {
      "type": "string",
      "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$"
    },
    "nullableHexColor": {
      "type": [
        "string",
        "null"
      ],
      "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$"
    },
    "numeric": {
      "type": "string",
      "pattern": "^\\d+$"
    },
    "uri": {
      "type": "string",
      "pattern": "[-a-zA-Z0-9@:%_\\+.~#?&//=]{2,256}\\.[a-z]{2,4}\\b(\\/[-a-zA-Z0-9@:%_\\+.~#?&//=]*)?"
    },
    "border": {
      "type": "string",
      "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
    },
    "nullableBorder": {
      "type": [
        "string",
        "null"
      ],
      "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
    },
    "padding": {
      "type": "string",
      "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
    },
    "radius": {
      "type": "string",
      "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
    },
    "webThemeUrl": {
      "type": "string",
      "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
    },
    "themeUrl": {
      "type": "string",
      "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
    },
    "font": {
      "type": [
        "string"
      ]
    },
    "nullableFont": {
      "type": [
        "string",
        "null"
      ]
    },
    "cssMeasure": {
      "type": "string",
      "pattern": "^\\d+(.\\d+)?(em|px)?$"
    },
    "cssMeasureWithUnit": {
      "type": "string",
      "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
    },
    "Int": {
      "type": "number",
      "multipleOf": 1
    },
    "NullableInt": {
      "type": [
        "number",
        "null"
      ],
      "multipleOf": 1
    },
    "JavaInt": {
      "type": "number",
      "default": 0,
      "multipleOf": 1,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "JavaBool": {
      "type": "boolean",
      "default": false
    },
    "NullableBool": {
      "type": [
        "boolean",
        "null"
      ]
    },
    "reference": {
      "type": [
        "string"
      ],
      "pseudoType": [
        "ref"
      ],
      "_wixReference": true
    },
    "nullableReference": {
      "type": [
        "null",
        "string"
      ],
      "pseudoType": [
        "ref"
      ],
      "_wixReference": true
    },
    "weakReference": {
      "type": [
        "string"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "_wixReference": true
    },
    "nullableWeakReference": {
      "type": [
        "null",
        "string"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "_wixReference": true
    },
    "referenceList": {
      "type": [
        "array"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ]
        }
      ],
      "pseudoType": [
        "refList"
      ],
      "_wixReference": true
    },
    "nullableReferenceList": {
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ]
        }
      ],
      "pseudoType": [
        "refList"
      ],
      "_wixReference": true
    },
    "DataNode": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "unevaluatedProperties": false
        }
      },
      "unevaluatedProperties": false
    },
    "PropDataNode": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "unevaluatedProperties": false
        }
      },
      "unevaluatedProperties": false
    },
    "color--unrestricted-root": {
      "type": "string",
      "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
    },
    "nullableColor--unrestricted-root": {
      "type": [
        "string",
        "null"
      ],
      "pattern": "^(^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$)$"
    },
    "hexColor--unrestricted-root": {
      "type": "string",
      "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$"
    },
    "nullableHexColor--unrestricted-root": {
      "type": [
        "string",
        "null"
      ],
      "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$"
    },
    "numeric--unrestricted-root": {
      "type": "string",
      "pattern": "^\\d+$"
    },
    "uri--unrestricted-root": {
      "type": "string",
      "pattern": "[-a-zA-Z0-9@:%_\\+.~#?&//=]{2,256}\\.[a-z]{2,4}\\b(\\/[-a-zA-Z0-9@:%_\\+.~#?&//=]*)?"
    },
    "border--unrestricted-root": {
      "type": "string",
      "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
    },
    "nullableBorder--unrestricted-root": {
      "type": [
        "string",
        "null"
      ],
      "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
    },
    "padding--unrestricted-root": {
      "type": "string",
      "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
    },
    "radius--unrestricted-root": {
      "type": "string",
      "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
    },
    "webThemeUrl--unrestricted-root": {
      "type": "string",
      "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
    },
    "themeUrl--unrestricted-root": {
      "type": "string",
      "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
    },
    "font--unrestricted-root": {
      "type": [
        "string"
      ]
    },
    "nullableFont--unrestricted-root": {
      "type": [
        "string",
        "null"
      ]
    },
    "cssMeasure--unrestricted-root": {
      "type": "string",
      "pattern": "^\\d+(.\\d+)?(em|px)?$"
    },
    "cssMeasureWithUnit--unrestricted-root": {
      "type": "string",
      "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
    },
    "Int--unrestricted-root": {
      "type": "number",
      "multipleOf": 1
    },
    "NullableInt--unrestricted-root": {
      "type": [
        "number",
        "null"
      ],
      "multipleOf": 1
    },
    "JavaInt--unrestricted-root": {
      "type": "number",
      "default": 0,
      "multipleOf": 1,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "JavaBool--unrestricted-root": {
      "type": "boolean",
      "default": false
    },
    "NullableBool--unrestricted-root": {
      "type": [
        "boolean",
        "null"
      ]
    },
    "reference--unrestricted-root": {
      "type": [
        "string"
      ],
      "pseudoType": [
        "ref"
      ],
      "_wixReference": true
    },
    "nullableReference--unrestricted-root": {
      "type": [
        "null",
        "string"
      ],
      "pseudoType": [
        "ref"
      ],
      "_wixReference": true
    },
    "weakReference--unrestricted-root": {
      "type": [
        "string"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "_wixReference": true
    },
    "nullableWeakReference--unrestricted-root": {
      "type": [
        "null",
        "string"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "_wixReference": true
    },
    "referenceList--unrestricted-root": {
      "type": [
        "array"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ]
        }
      ],
      "pseudoType": [
        "refList"
      ],
      "_wixReference": true
    },
    "nullableReferenceList--unrestricted-root": {
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ]
        }
      ],
      "pseudoType": [
        "refList"
      ],
      "_wixReference": true
    },
    "DataNode--unrestricted-root": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "unevaluatedProperties": false
        }
      }
    },
    "PropDataNode--unrestricted-root": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "unevaluatedProperties": false
        }
      }
    }
  },
  "commonSchemas.json": {
    "$id": "urn:dm:schemas:commonSchemas.json",
    "RefArray": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "values": {
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ],
              "default": [],
              "type": [
                "array"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VariantRelation": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "variants",
            "from",
            "to"
          ],
          "properties": {
            "variants": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            },
            "remoteVariants": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              }
            },
            "from": {
              "type": [
                "string"
              ]
            },
            "to": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MinimalUnitSize": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "percentage"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "UnitSize": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "fr",
            "percentage",
            "vh",
            "vw",
            "spx",
            "siteWidthPercentage"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "SPXReferenceDefinition": {
      "type": "object",
      "required": [
        "refWidth",
        "resolverType"
      ],
      "properties": {
        "refWidth": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        },
        "resolverType": {
          "type": "string",
          "enum": [
            "scale",
            "fixed"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "UnitLength": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "UnitLengthPercentage": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "percentage",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "UnitAngle": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "deg",
            "percentage"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "UnitSizeArea": {
      "type": "object",
      "properties": {
        "width": {
          "$ref": "#/UnitLengthPercentage"
        },
        "height": {
          "$ref": "#/UnitLengthPercentage"
        }
      },
      "unevaluatedProperties": false
    },
    "UnitSizePoint": {
      "type": "object",
      "properties": {
        "x": {
          "$ref": "#/UnitLengthPercentage"
        },
        "y": {
          "$ref": "#/UnitLengthPercentage"
        }
      },
      "unevaluatedProperties": false
    },
    "NumberThatCanConnectToAVariable": {
      "type": "number"
    },
    "LinkReference": {
      "pattern": "^$|^#",
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "Common_Image": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "#/LinkReference"
            },
            "title": {
              "type": "string",
              "default": "",
              "maxLength": 100,
              "description": "Title or caption for the image."
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "description": "Name identifier for the image."
            },
            "uri": {
              "type": "string",
              "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$",
              "default": "3963cf22f5e14a25a77ebe37298a8d3b.png",
              "description": "Represents the URI or path to the image."
            },
            "description": {
              "type": "string",
              "maxLength": 1200,
              "description": "Textual description or details about the image."
            },
            "height": {
              "type": "number",
              "default": 200,
              "description": "Height dimension of the image."
            },
            "width": {
              "type": "number",
              "default": 200,
              "description": "Width dimension of the image."
            },
            "borderSize": {
              "type": "string",
              "description": "Size of the border around the image."
            },
            "alt": {
              "type": "string",
              "default": "",
              "description": "Alternative text for the image (for accessibility purposes)."
            },
            "decorative": {
              "type": "boolean"
            },
            "hasAnimation": {
              "type": "boolean",
              "description": "Indicates whether the image has animation valid for images in webP format"
            },
            "originalImageDataRef": {
              "description": "Original Image before edit",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "opacity": {
              "type": "number",
              "description": "Opacity level of the image."
            },
            "crop": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "minProperties": 4,
                  "properties": {
                    "x": {
                      "type": "number",
                      "minimum": 0
                    },
                    "y": {
                      "type": "number",
                      "minimum": 0
                    },
                    "width": {
                      "type": "number",
                      "minimum": 0
                    },
                    "height": {
                      "type": "number",
                      "minimum": 0
                    },
                    "svgId": {
                      "type": "string",
                      "description": "Defines an svg uri for a mask inside the crop boundaries"
                    },
                    "flip": {
                      "type": "string",
                      "enum": [
                        "x",
                        "y",
                        "xy",
                        "none"
                      ],
                      "description": "Defines whether the mask is flipped on the v or h axis"
                    },
                    "rotate": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 360,
                      "description": "Defines a rotation angle for the mask"
                    }
                  }
                }
              ],
              "description": "Defines cropping boundaries and additional transformations for the image."
            },
            "upscaleMethod": {
              "type": "string",
              "description": "used for upscaling method when building an image url , expected values default|super"
            },
            "focalPoint": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "minProperties": 2,
                  "properties": {
                    "x": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 100
                    },
                    "y": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 100
                    }
                  }
                }
              ],
              "description": "Specifies the focal point within the image."
            },
            "artist": {
              "type": "object",
              "description": "Information about the artist of the image.",
              "properties": {
                "name": {
                  "type": "string"
                },
                "id": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Common_SVGItem": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "svgId": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ColorLayers": {
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "GradientLinearLayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "$ref": "#/GradientLinear"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GradientCircleLayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "$ref": "#/GradientCircle"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GradientEllipseLayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "$ref": "#/GradientEllipse"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GradientMeshLayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "GradientMesh"
                  ]
                },
                "gradients": {
                  "type": "array",
                  "items": {
                    "$ref": "#/GradientCircle"
                  }
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GradientConicLayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "$ref": "#/GradientConic"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SolidColorLayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "$ref": "#/SolidColor"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GradientLinear": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientLinear"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "#/BlendMode"
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "#/GradientColorStop"
          }
        }
      },
      "unevaluatedProperties": false
    },
    "GradientCircleSize": {
      "type": "object",
      "oneOf": [
        {
          "required": [
            "value",
            "type"
          ]
        },
        {
          "required": [
            "keyword"
          ]
        },
        {
          "required": [],
          "maxProperties": 0
        }
      ],
      "properties": {
        "keyword": {
          "type": "string",
          "enum": [
            "closest-side",
            "closest-corner",
            "farthest-side",
            "farthest-corner"
          ]
        },
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "GradientCircle": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientCircle"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "#/BlendMode"
        },
        "size": {
          "$ref": "#/GradientCircleSize"
        },
        "position": {
          "$ref": "#/UnitSizePoint"
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "#/GradientColorStop"
          }
        }
      },
      "unevaluatedProperties": false
    },
    "GradientEllipseSize": {
      "type": "object",
      "oneOf": [
        {
          "required": [
            "width",
            "height"
          ]
        },
        {
          "required": [
            "keyword"
          ]
        }
      ],
      "properties": {
        "keyword": {
          "type": "string",
          "enum": [
            "closest-side",
            "closest-corner",
            "farthest-side",
            "farthest-corner"
          ]
        },
        "width": {
          "$ref": "#/UnitLengthPercentage"
        },
        "height": {
          "$ref": "#/UnitLengthPercentage"
        }
      },
      "unevaluatedProperties": false
    },
    "GradientEllipse": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientEllipse"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "#/BlendMode"
        },
        "size": {
          "$ref": "#/GradientEllipseSize"
        },
        "position": {
          "$ref": "#/UnitSizePoint"
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "#/GradientColorStop"
          }
        }
      },
      "unevaluatedProperties": false
    },
    "GradientConic": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientConic"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "#/BlendMode"
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "position": {
          "$ref": "#/UnitSizePoint"
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "#/GradientAngularColorStop"
          }
        }
      },
      "unevaluatedProperties": false
    },
    "SolidColor": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SolidColor"
          ]
        },
        "color": {
          "$ref": "urn:dm:schemas:common.json#/color"
        }
      },
      "unevaluatedProperties": false
    },
    "BlendMode": {
      "type": "string",
      "enum": [
        "normal",
        "multiply",
        "screen",
        "darken",
        "lighten",
        "overlay",
        "colorDodge",
        "colorBurn",
        "hardLight",
        "softLight",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ]
    },
    "GradientColorStop": {
      "type": "object",
      "properties": {
        "size": {
          "$ref": "#/UnitLengthPercentage"
        },
        "color": {
          "$ref": "urn:dm:schemas:common.json#/color"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "unevaluatedProperties": false
    },
    "GradientAngularColorStop": {
      "type": "object",
      "properties": {
        "size": {
          "$ref": "#/UnitAngle"
        },
        "color": {
          "$ref": "urn:dm:schemas:common.json#/color"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "unevaluatedProperties": false
    },
    "RefArray--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "values": {
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ],
              "default": [],
              "type": [
                "array"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "VariantRelation--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "variants",
            "from",
            "to"
          ],
          "properties": {
            "variants": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            },
            "remoteVariants": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              }
            },
            "from": {
              "type": [
                "string"
              ]
            },
            "to": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "MinimalUnitSize--unrestricted-root": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "percentage"
          ]
        }
      }
    },
    "UnitSize--unrestricted-root": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "fr",
            "percentage",
            "vh",
            "vw",
            "spx",
            "siteWidthPercentage"
          ]
        }
      }
    },
    "SPXReferenceDefinition--unrestricted-root": {
      "type": "object",
      "required": [
        "refWidth",
        "resolverType"
      ],
      "properties": {
        "refWidth": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        },
        "resolverType": {
          "type": "string",
          "enum": [
            "scale",
            "fixed"
          ]
        }
      }
    },
    "UnitLength--unrestricted-root": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      }
    },
    "UnitLengthPercentage--unrestricted-root": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "percentage",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      }
    },
    "UnitAngle--unrestricted-root": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "deg",
            "percentage"
          ]
        }
      }
    },
    "UnitSizeArea--unrestricted-root": {
      "type": "object",
      "properties": {
        "width": {
          "$ref": "#/UnitLengthPercentage"
        },
        "height": {
          "$ref": "#/UnitLengthPercentage"
        }
      }
    },
    "UnitSizePoint--unrestricted-root": {
      "type": "object",
      "properties": {
        "x": {
          "$ref": "#/UnitLengthPercentage"
        },
        "y": {
          "$ref": "#/UnitLengthPercentage"
        }
      }
    },
    "NumberThatCanConnectToAVariable--unrestricted-root": {
      "type": "number"
    },
    "LinkReference--unrestricted-root": {
      "pattern": "^$|^#",
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "Common_Image--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "#/LinkReference"
            },
            "title": {
              "type": "string",
              "default": "",
              "maxLength": 100,
              "description": "Title or caption for the image."
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "description": "Name identifier for the image."
            },
            "uri": {
              "type": "string",
              "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$",
              "default": "3963cf22f5e14a25a77ebe37298a8d3b.png",
              "description": "Represents the URI or path to the image."
            },
            "description": {
              "type": "string",
              "maxLength": 1200,
              "description": "Textual description or details about the image."
            },
            "height": {
              "type": "number",
              "default": 200,
              "description": "Height dimension of the image."
            },
            "width": {
              "type": "number",
              "default": 200,
              "description": "Width dimension of the image."
            },
            "borderSize": {
              "type": "string",
              "description": "Size of the border around the image."
            },
            "alt": {
              "type": "string",
              "default": "",
              "description": "Alternative text for the image (for accessibility purposes)."
            },
            "decorative": {
              "type": "boolean"
            },
            "hasAnimation": {
              "type": "boolean",
              "description": "Indicates whether the image has animation valid for images in webP format"
            },
            "originalImageDataRef": {
              "description": "Original Image before edit",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "opacity": {
              "type": "number",
              "description": "Opacity level of the image."
            },
            "crop": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "minProperties": 4,
                  "properties": {
                    "x": {
                      "type": "number",
                      "minimum": 0
                    },
                    "y": {
                      "type": "number",
                      "minimum": 0
                    },
                    "width": {
                      "type": "number",
                      "minimum": 0
                    },
                    "height": {
                      "type": "number",
                      "minimum": 0
                    },
                    "svgId": {
                      "type": "string",
                      "description": "Defines an svg uri for a mask inside the crop boundaries"
                    },
                    "flip": {
                      "type": "string",
                      "enum": [
                        "x",
                        "y",
                        "xy",
                        "none"
                      ],
                      "description": "Defines whether the mask is flipped on the v or h axis"
                    },
                    "rotate": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 360,
                      "description": "Defines a rotation angle for the mask"
                    }
                  }
                }
              ],
              "description": "Defines cropping boundaries and additional transformations for the image."
            },
            "upscaleMethod": {
              "type": "string",
              "description": "used for upscaling method when building an image url , expected values default|super"
            },
            "focalPoint": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "minProperties": 2,
                  "properties": {
                    "x": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 100
                    },
                    "y": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 100
                    }
                  }
                }
              ],
              "description": "Specifies the focal point within the image."
            },
            "artist": {
              "type": "object",
              "description": "Information about the artist of the image.",
              "properties": {
                "name": {
                  "type": "string"
                },
                "id": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "Common_SVGItem--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "svgId": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "ColorLayers--unrestricted-root": {
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "GradientLinearLayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "$ref": "#/GradientLinear"
            }
          }
        }
      ],
      "type": "object"
    },
    "GradientCircleLayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "$ref": "#/GradientCircle"
            }
          }
        }
      ],
      "type": "object"
    },
    "GradientEllipseLayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "$ref": "#/GradientEllipse"
            }
          }
        }
      ],
      "type": "object"
    },
    "GradientMeshLayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "GradientMesh"
                  ]
                },
                "gradients": {
                  "type": "array",
                  "items": {
                    "$ref": "#/GradientCircle"
                  }
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "GradientConicLayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "$ref": "#/GradientConic"
            }
          }
        }
      ],
      "type": "object"
    },
    "SolidColorLayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fill": {
              "$ref": "#/SolidColor"
            }
          }
        }
      ],
      "type": "object"
    },
    "GradientLinear--unrestricted-root": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientLinear"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "#/BlendMode"
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "#/GradientColorStop"
          }
        }
      }
    },
    "GradientCircleSize--unrestricted-root": {
      "type": "object",
      "oneOf": [
        {
          "required": [
            "value",
            "type"
          ]
        },
        {
          "required": [
            "keyword"
          ]
        },
        {
          "required": [],
          "maxProperties": 0
        }
      ],
      "properties": {
        "keyword": {
          "type": "string",
          "enum": [
            "closest-side",
            "closest-corner",
            "farthest-side",
            "farthest-corner"
          ]
        },
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      }
    },
    "GradientCircle--unrestricted-root": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientCircle"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "#/BlendMode"
        },
        "size": {
          "$ref": "#/GradientCircleSize"
        },
        "position": {
          "$ref": "#/UnitSizePoint"
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "#/GradientColorStop"
          }
        }
      }
    },
    "GradientEllipseSize--unrestricted-root": {
      "type": "object",
      "oneOf": [
        {
          "required": [
            "width",
            "height"
          ]
        },
        {
          "required": [
            "keyword"
          ]
        }
      ],
      "properties": {
        "keyword": {
          "type": "string",
          "enum": [
            "closest-side",
            "closest-corner",
            "farthest-side",
            "farthest-corner"
          ]
        },
        "width": {
          "$ref": "#/UnitLengthPercentage"
        },
        "height": {
          "$ref": "#/UnitLengthPercentage"
        }
      }
    },
    "GradientEllipse--unrestricted-root": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientEllipse"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "#/BlendMode"
        },
        "size": {
          "$ref": "#/GradientEllipseSize"
        },
        "position": {
          "$ref": "#/UnitSizePoint"
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "#/GradientColorStop"
          }
        }
      }
    },
    "GradientConic--unrestricted-root": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientConic"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "#/BlendMode"
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "position": {
          "$ref": "#/UnitSizePoint"
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "#/GradientAngularColorStop"
          }
        }
      }
    },
    "SolidColor--unrestricted-root": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SolidColor"
          ]
        },
        "color": {
          "$ref": "urn:dm:schemas:common.json#/color"
        }
      }
    },
    "BlendMode--unrestricted-root": {
      "type": "string",
      "enum": [
        "normal",
        "multiply",
        "screen",
        "darken",
        "lighten",
        "overlay",
        "colorDodge",
        "colorBurn",
        "hardLight",
        "softLight",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ]
    },
    "GradientColorStop--unrestricted-root": {
      "type": "object",
      "properties": {
        "size": {
          "$ref": "#/UnitLengthPercentage"
        },
        "color": {
          "$ref": "urn:dm:schemas:common.json#/color"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      }
    },
    "GradientAngularColorStop--unrestricted-root": {
      "type": "object",
      "properties": {
        "size": {
          "$ref": "#/UnitAngle"
        },
        "color": {
          "$ref": "urn:dm:schemas:common.json#/color"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      }
    }
  },
  "component_properties.json": {
    "$id": "urn:dm:schemas:component_properties.json",
    "FontsEnum": {
      "langsKey": "System.font",
      "type": "string",
      "default": "arial",
      "enum": [
        "lucidaSansConsole",
        "palatinoLinotype",
        "americantypwrteritcw01--731025",
        "anton",
        "arial",
        "arialBlack",
        "avenida-w01",
        "basic",
        "caudex",
        "clarendon-w01-medium-692107",
        "comicSansMS",
        "cookie",
        "coquette-w00-light",
        "courierNew",
        "din-next-w01-light",
        "droid-serif-w01-regular",
        "eb garamond",
        "enriqueta",
        "forum",
        "georgia",
        "helvetica-w01-roman",
        "helvetica-w01-bold",
        "helvetica-w01-light",
        "impact",
        "jockey one",
        "jura",
        "kelly slab",
        "lobster",
        "lucidaConsole",
        "marck script",
        "monoton",
        "noticia text",
        "open sans",
        "open sans condensed",
        "palatino linotype",
        "patrick hand",
        "play",
        "reklamescriptw00-medium",
        "sacramento",
        "sarina",
        "signika",
        "soho-w01-thin-condensed",
        "tahoma",
        "timesNewRoman",
        "verdana",
        "bodoni-w01-poster",
        "ｍｓ ゴシック",
        "ｍｓ 明朝",
        "ｍｓ ｐゴシック",
        "ｍｓ ｐ明朝",
        "meiryo",
        "メイリオ",
        "bm-hanna",
        "돋움",
        "fbbluegothicl",
        "fbchamblue",
        "fbgreen",
        "fbneogothic",
        "fbplum",
        "굴림",
        "맑은 고딕",
        "nanumgothic-regular",
        "ahmedltw20-outlineregul",
        "amiri",
        "arabictypesettingw23-re",
        "arian-lt-w20-regular",
        "arian-lt-w20-light",
        "coheadlinew23-arabicbol",
        "dinnextltw23-ultralight",
        "droid-naskh",
        "janna-lt-w20-regular",
        "kufi-lt-w20-regular",
        "midan-w20",
        "helveticaneueltw20-ligh",
        "tanseekmodernw20-light",
        "adler-w26-regular",
        "alef-regular",
        "almoni-dl-aaa-700",
        "almoni-dl-aaa-300",
        "almoni-dl-aaa-400",
        "asimon-aaa-400",
        "atlas-aaa-500",
        "chips-w26-normal",
        "frank-ruhl-w26-regular",
        "gulash-w26-regular",
        "haim-arukeem-w26-medium",
        "miriam-w26-medium",
        "mixtape-aaa-400",
        "museum-aaa-400",
        "nekudot-w26-bold",
        "omes-aaa-400",
        "opensanshebrewcondensed-regular",
        "shabazi-w26-bold",
        "amatic sc",
        "braggadocio-w01",
        "chelsea market",
        "corben",
        "fredericka the great",
        "geotica-w01-four-open",
        "helvetica neue",
        "helvetica neue italic",
        "helvetica neue medium",
        "helvetica neue thin",
        "itc-arecibo-w01-regular",
        "josefin slab",
        "lucida sans unicode",
        "marzo-w00-regular",
        "mr de haviland",
        "museo-w01-700",
        "museo-slab-w01-100",
        "niconne",
        "nimbus-sans-tw01con",
        "overlock",
        "pacifica-w00-condensed",
        "raleway",
        "rosewood-w01-regular",
        "snellroundhandw01-scrip",
        "spinnaker",
        "stencil-w01-bold"
      ]
    },
    "DefaultProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isHidden": {
              "type": "boolean",
              "description": "sets visibility:hidden to the component style node"
            },
            "isCollapsed": {
              "type": "boolean",
              "description": "sets isCollapsed for component"
            },
            "ghost": {
              "type": "string",
              "enum": [
                "COLLAPSED"
              ],
              "description": "sets collapsed to hidden ref component"
            },
            "fontScale": {
              "type": "number"
            },
            "deleted": {
              "type": "boolean",
              "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlipProperties": {
      "type": "object",
      "properties": {
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "horizontal",
            "vertical",
            "both",
            "none"
          ],
          "default": "none",
          "description": "Defines a flip axis for the content"
        }
      },
      "unevaluatedProperties": false
    },
    "VideoBackgroundProperties": {
      "type": "object",
      "properties": {
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      },
      "unevaluatedProperties": false
    },
    "CardsLayoutProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right",
                    "justify"
                  ],
                  "default": "left"
                },
                "gap": {
                  "type": "object",
                  "default": {},
                  "properties": {
                    "vertical": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 100,
                      "default": 0,
                      "description": "sets the vertical gap (in px) between items of a repeater"
                    },
                    "horizontal": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 100,
                      "default": 0,
                      "description": "sets the horizontal gap (in px) between items of a repeater"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "direction": {
                  "enum": [
                    "rtl",
                    "ltr"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VerticalLayoutProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "gap": {
                  "type": "number",
                  "default": 10,
                  "description": "sets the gap (in px) between items of a vertical repeater"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DisableableProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "isDisabled": {
                  "type": "boolean",
                  "description": "disables the component"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ClassicSectionProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "mediaBackgroundPadding": {
                  "type": [
                    "object",
                    "null"
                  ],
                  "maxProperties": 1,
                  "properties": {
                    "top": {
                      "type": [
                        "number",
                        "null"
                      ],
                      "minimum": 0,
                      "description": "value of the mediaBackgroundPadding"
                    },
                    "bottom": {
                      "type": [
                        "number",
                        "null"
                      ],
                      "minimum": 0,
                      "description": "value of the mediaBackgroundPadding"
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripColumnsContainerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "columnsMargin": {
                  "type": "number",
                  "default": 15
                },
                "frameMargin": {
                  "type": "number",
                  "default": 15
                },
                "fullWidth": {
                  "type": "boolean",
                  "default": true
                },
                "fullHeight": {
                  "type": "boolean",
                  "default": false
                },
                "rowMargin": {
                  "type": "number",
                  "default": 15
                },
                "siteMargin": {
                  "type": "number",
                  "default": 30
                },
                "horizontalPaddingOnMobile": {
                  "type": "number"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ColumnProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "background": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                },
                "alignment": {
                  "type": "number",
                  "default": 50,
                  "minimum": 0,
                  "maximum": 100,
                  "description": "The alignment of the content relative to the whole column, represented as percentage (e.g. 0 for left, 50 for center and 100 for right)"
                },
                "mediaBackgroundPadding": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "object",
                      "maxProperties": 1,
                      "properties": {
                        "top": {
                          "oneOf": [
                            {
                              "type": "null"
                            },
                            {
                              "type": "number",
                              "default": 18,
                              "minimum": 0,
                              "description": "value of the mediaBackgroundPadding"
                            }
                          ]
                        },
                        "bottom": {
                          "oneOf": [
                            {
                              "type": "null"
                            },
                            {
                              "type": "number",
                              "default": 18,
                              "minimum": 0,
                              "description": "value of the mediaBackgroundPadding"
                            }
                          ]
                        }
                      }
                    }
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "InputProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "label": {
                  "type": "string",
                  "description": "input label"
                },
                "required": {
                  "type": "boolean",
                  "description": "is the input field required to have a value"
                },
                "autoFocus": {
                  "type": "boolean",
                  "description": "should the field be focused when loading the page"
                },
                "readOnly": {
                  "type": "boolean",
                  "description": "is the field readonly"
                },
                "tabIndex": {
                  "type": "number",
                  "description": "the tab index in the form"
                },
                "inputHeight": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "Height of input",
                  "minimum": 25
                },
                "inputHeightMobile": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "Height of input",
                  "minimum": 25
                },
                "labelMargin": {
                  "type": "number",
                  "default": 14,
                  "description": "Margin between label to input",
                  "minimum": 0,
                  "maximum": 100
                },
                "labelPadding": {
                  "type": "number",
                  "default": 0,
                  "description": "Padding of label",
                  "minimum": 0,
                  "maximum": 100
                },
                "labelMobileFontSize": {
                  "type": "number"
                },
                "inputMobileFontSize": {
                  "type": "number"
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "InputElementsErrorProperties": {
      "type": "object",
      "properties": {
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "QuickActionBarProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "colorScheme": {
                  "type": "string",
                  "enum": [
                    "black",
                    "grey",
                    "brand"
                  ],
                  "default": "brand"
                },
                "invertColors": {
                  "type": "boolean",
                  "default": true
                },
                "hideText": {
                  "type": "boolean",
                  "default": true
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "right",
                    "left"
                  ],
                  "default": "right"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PhotoProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageSize": {
                  "type": "string",
                  "enum": [
                    "small",
                    "medium",
                    "large"
                  ],
                  "default": "medium",
                  "description": "size of the image in runtime"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FacebookLikeBoxProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transparentBg": {
                  "type": "boolean",
                  "default": false,
                  "description": "Sets a transparent background for the like box"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "none",
                    "fade"
                  ],
                  "default": "fade"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MultiSelectionProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "placeholder": {
                  "type": "string",
                  "default": "Enter text here...",
                  "description": "The placeholder for the input skinpart",
                  "maxLength": 4000
                },
                "newItemText": {
                  "type": "string",
                  "default": "(New)",
                  "description": "The text that will appear on a new item in the dropdown"
                },
                "selectionOnly": {
                  "type": "boolean",
                  "default": false,
                  "description": "Restricts component to selection only"
                },
                "maxTextLength": {
                  "type": "number",
                  "default": 30,
                  "description": "The max text length for the input skinpart"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MultiSelectionItemProperties": {
      "$ref": "#/DefaultProperties"
    },
    "NumericStepperProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "minValue": {
                  "type": "number",
                  "default": 0,
                  "description": "Min value for input"
                },
                "maxValue": {
                  "type": "number",
                  "default": 999,
                  "description": "Max value for input"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PinterestPinItProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "size": {
                  "type": "string",
                  "enum": [
                    "small",
                    "large"
                  ],
                  "default": "small"
                },
                "color": {
                  "type": "string",
                  "enum": [
                    "gray",
                    "red",
                    "white"
                  ],
                  "default": "gray"
                },
                "counterPosition": {
                  "type": "string",
                  "enum": [
                    "none",
                    "above",
                    "beside"
                  ],
                  "default": "none"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SingleAudioPlayerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "volume": {
                  "type": "number",
                  "default": 50,
                  "description": "Volume"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": "Autoplay MP3"
                },
                "loop": {
                  "type": "boolean",
                  "default": false,
                  "description": "Loop MP3"
                },
                "showArtist": {
                  "type": "boolean",
                  "default": true,
                  "description": "Display Artist"
                },
                "showTrack": {
                  "type": "boolean",
                  "default": true,
                  "description": "Display Track"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SkypeCallButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageSize": {
                  "type": "string",
                  "enum": [
                    "small",
                    "medium",
                    "large"
                  ],
                  "default": "medium"
                },
                "imageColor": {
                  "type": "string",
                  "enum": [
                    "blue",
                    "white"
                  ],
                  "default": "blue"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SpotifyFollowProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "size": {
                  "type": "string",
                  "enum": [
                    "small",
                    "large"
                  ],
                  "default": "large"
                },
                "theme": {
                  "type": "string",
                  "enum": [
                    "light",
                    "dark"
                  ],
                  "default": "light"
                },
                "showFollowersCount": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SpotifyPlayerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "size": {
                  "type": "string",
                  "enum": [
                    "compact",
                    "large"
                  ],
                  "default": "compact",
                  "description": "Size of the player"
                },
                "color": {
                  "type": "string",
                  "enum": [
                    "black",
                    "white"
                  ],
                  "default": "black",
                  "description": "Theme of the player"
                },
                "style": {
                  "type": "string",
                  "enum": [
                    "list",
                    "coverart"
                  ],
                  "default": "list",
                  "description": "Style of the player"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SubscribeFormProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "hiddenFirstNameField": {
                  "type": "boolean",
                  "default": false
                },
                "hiddenLastNameField": {
                  "type": "boolean",
                  "default": false
                },
                "hiddenEmailField": {
                  "type": "boolean",
                  "default": true
                },
                "hiddenPhoneField": {
                  "type": "boolean",
                  "default": false
                },
                "requiredFirstNameField": {
                  "type": "boolean",
                  "default": false
                },
                "requiredLastNameField": {
                  "type": "boolean",
                  "default": false
                },
                "requiredEmailField": {
                  "type": "boolean",
                  "default": true
                },
                "requiredPhoneField": {
                  "type": "boolean",
                  "default": false
                },
                "useCookie": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VerticalMenuProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "itemsAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the menu items"
                },
                "subMenuOpenSide": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "right",
                  "description": "Opening direction of sub-menus"
                },
                "originalHeight": {
                  "type": "number",
                  "description": "Used to determine if comp was saved with correct height (if value not empty), or height needs to be fixed in DataFixer (if value is empty)"
                },
                "menuItemHeight": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number"
                    }
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "YouTubeSubscribeButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "layout": {
                  "type": "string",
                  "enum": [
                    "default",
                    "full"
                  ],
                  "default": "full",
                  "description": "the layout of the youtube subscribe button"
                },
                "theme": {
                  "type": "string",
                  "enum": [
                    "light",
                    "dark"
                  ],
                  "default": "light",
                  "description": "the theme of the youtube subscribe button"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgImageStripProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "bgUrl": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "default": "",
                  "description": "Set image background"
                },
                "bgSize": {
                  "type": "string",
                  "enum": [
                    "auto",
                    "cover",
                    "contain"
                  ],
                  "default": "auto",
                  "description": "Set background mode"
                },
                "bgRepeat": {
                  "type": "string",
                  "enum": [
                    "no-repeat",
                    "repeat-x",
                    "repeat-y",
                    "repeat"
                  ],
                  "default": "repeat",
                  "description": "Set background tile direction"
                },
                "bgPosition": {
                  "type": "string",
                  "enum": [
                    "top left",
                    "top center",
                    "top right",
                    "center left",
                    "center",
                    "center right",
                    "bottom left",
                    "bottom center",
                    "bottom right"
                  ],
                  "default": "center",
                  "description": "Set background position"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgImageStripUnifiedProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "fittingType": {
                  "type": "string",
                  "enum": [
                    "fill",
                    "fit",
                    "actual_size",
                    "tile",
                    "fit_and_tile",
                    "tile_horizontal",
                    "tile_vertical",
                    "legacy_strip_tile",
                    "legacy_strip_tile_horizontal",
                    "legacy_strip_tile_vertical",
                    "legacy_strip_original_size",
                    "legacy_strip_fill",
                    "legacy_strip_fit",
                    "legacy_strip_fit_and_tile"
                  ],
                  "default": "fill",
                  "description": "Set image fitting type"
                },
                "alignType": {
                  "type": "string",
                  "enum": [
                    "top_left",
                    "top",
                    "top_right",
                    "left",
                    "center",
                    "right",
                    "bottom_left",
                    "bottom",
                    "bottom_right"
                  ],
                  "default": "center",
                  "description": "Set image alignment"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FileUploaderProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "buttonAlignment": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ],
                  "default": "ltr",
                  "description": "alignment of the label to the button"
                },
                "filesAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the file name to the component"
                },
                "showPlaceholder": {
                  "type": "boolean",
                  "default": true,
                  "description": "should show placeholder"
                },
                "filesType": {
                  "type": "string",
                  "enum": [
                    "Image",
                    "Document",
                    "Video",
                    "Audio",
                    "Archive",
                    "Gallery"
                  ],
                  "default": "Image",
                  "description": "the file type allowed for upload by the component"
                },
                "filesSizeLimit": {
                  "type": "number",
                  "default": 15,
                  "minimum": 1,
                  "maximum": 15,
                  "description": "the maximum file size allowed to upload by the component"
                },
                "numFilesLimit": {
                  "type": "number",
                  "default": 1,
                  "minimum": 1,
                  "maximum": 50,
                  "description": "the maximum number of files allowed to be uploaded by the component"
                },
                "showFileName": {
                  "type": "boolean"
                },
                "textBelowButtonMobileFontSize": {
                  "type": "number"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "UploadNameProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "$ref": "#/DefaultProperties--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "align": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "center",
                  "description": "alignment of the menu"
                },
                "margin": {
                  "type": "number",
                  "default": 0,
                  "description": "text left and right margins"
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LoginSocialBarProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "buttonsDirection": {
                  "type": "string",
                  "default": "ltr",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "description": "alignment of the buttons"
                },
                "iconSize": {
                  "type": "number",
                  "default": 26,
                  "description": "size of the buttons' icons"
                },
                "loggedOutIconSize": {
                  "type": "number",
                  "description": "size of the loggedOut buttons' icons"
                },
                "dropDownTextAlignment": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "description": "alignment of the text in the dropdown menu"
                },
                "buttonsAlignment": {
                  "type": "string",
                  "default": "right",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "description": "alignment of the bar of the component itself"
                },
                "arrowShape": {
                  "type": "string",
                  "default": "line",
                  "enum": [
                    "none",
                    "line",
                    "full"
                  ],
                  "description": "arrow shape of login bar"
                },
                "arrowSize": {
                  "type": "number",
                  "default": 14,
                  "description": "arrow size of login bar"
                },
                "showBellIcon": {
                  "type": "boolean",
                  "default": true,
                  "description": "should show bell icon"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ComboBoxInputProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "textAlignment": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string",
                      "default": "center",
                      "enum": [
                        "left",
                        "right",
                        "center"
                      ],
                      "description": "the direction of the text",
                      "maxLength": 100
                    }
                  ]
                },
                "textPadding": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number",
                      "default": 18,
                      "minimum": 0,
                      "maximum": 100,
                      "description": "the value of the textPadding"
                    }
                  ]
                },
                "placeholder": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "object",
                      "properties": {
                        "value": {
                          "type": "string",
                          "default": "-1",
                          "description": "the value of the placeholder option",
                          "maxLength": 400
                        },
                        "text": {
                          "type": "string",
                          "default": "",
                          "description": "the text of the placeholder option",
                          "maxLength": 400
                        }
                      }
                    }
                  ],
                  "description": "the placeholder option in case nothing is selected"
                },
                "size": {
                  "type": [
                    "null",
                    "number"
                  ],
                  "description": "Amount of options to display"
                },
                "designableList": {
                  "type": "boolean",
                  "default": true,
                  "description": "is the list designable"
                },
                "dropdownItemsSpacing": {
                  "type": "number",
                  "default": 16,
                  "minimum": 0,
                  "maximum": 100,
                  "description": "the value of the dropdownItemsSpacing"
                },
                "autocomplete": {
                  "type": "boolean",
                  "description": "is the autocomplete enabled"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            },
            {
              "$ref": "#/InputElementsErrorProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RadioButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RadioGroupProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the text"
                },
                "layout": {
                  "type": "string",
                  "enum": [
                    "vertical",
                    "horizontal"
                  ],
                  "default": "vertical",
                  "description": "the layout of the radio buttons child components"
                },
                "buttonsMargin": {
                  "type": "number",
                  "default": 24,
                  "description": "Margin between each button item",
                  "minimum": 0,
                  "maximum": 100
                },
                "spacing": {
                  "type": "number",
                  "default": 12,
                  "description": "Spacing between radio icon and text",
                  "minimum": 0,
                  "maximum": 100
                },
                "buttonSize": {
                  "type": "number",
                  "default": 18,
                  "description": "radio button size size",
                  "minimum": 6,
                  "maximum": 100
                },
                "labelMargin": {
                  "type": "number",
                  "default": 24,
                  "description": "Margin between label to buttons",
                  "minimum": 0,
                  "maximum": 100
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            },
            {
              "$ref": "#/InputElementsErrorProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CheckboxGroupProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the text"
                },
                "layout": {
                  "type": "string",
                  "enum": [
                    "vertical",
                    "horizontal"
                  ],
                  "default": "vertical",
                  "description": "the layout of the checkboxes components"
                },
                "buttonsMargin": {
                  "type": "number",
                  "default": 24,
                  "description": "Margin between each button item",
                  "minimum": 0,
                  "maximum": 100
                },
                "spacing": {
                  "type": "number",
                  "default": 12,
                  "description": "Spacing between checkbox and text",
                  "minimum": 0,
                  "maximum": 100
                },
                "buttonSize": {
                  "type": "number",
                  "default": 18,
                  "description": "checkbox size",
                  "minimum": 6,
                  "maximum": 100
                },
                "labelMargin": {
                  "type": "number",
                  "default": 24,
                  "description": "Margin between label to checkbox",
                  "minimum": 0,
                  "maximum": 100
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            },
            {
              "$ref": "#/InputElementsErrorProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ContactFormProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "hidden_emailFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "hidden_nameFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "hidden_phoneFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "hidden_addressFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "hidden_subjectFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "hidden_messageFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "required_emailFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "required_nameFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "required_phoneFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "required_addressFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "required_subjectFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "required_messageFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "useCookie": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DocumentMediaProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showTitle": {
                  "type": "boolean",
                  "default": true,
                  "description": "Toggle Document Title Display"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "EbayItemsBySellerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "headerImage": {
                  "enum": [
                    "0",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "10",
                    "11"
                  ],
                  "default": "0",
                  "description": "The widget's header"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FiveGridLineProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "fullScreenModeOn": {
                  "type": "boolean",
                  "default": false,
                  "description": "Toggle full screen mode"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlashComponentProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "displayMode": {
                  "type": "string",
                  "enum": [
                    "original",
                    "fit",
                    "stretch"
                  ],
                  "default": "original",
                  "description": "displayMode of the movie"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GalleryExpandProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "expandEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "goToLinkText": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Go to link"
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ],
                  "default": "zoomMode"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GoogleMapProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showZoom": {
                  "type": "boolean",
                  "default": true,
                  "description": "show zoom control"
                },
                "fullscreenControl": {
                  "type": "boolean",
                  "default": true,
                  "description": "show fullscreen control"
                },
                "showPosition": {
                  "type": "boolean",
                  "default": true,
                  "description": "show position control"
                },
                "showStreetView": {
                  "type": "boolean",
                  "default": true,
                  "description": "show Street View control"
                },
                "showMapType": {
                  "type": "boolean",
                  "default": true,
                  "description": "show map type control"
                },
                "zoom": {
                  "type": "number",
                  "default": 14,
                  "description": "default map zoom level",
                  "minimum": 0,
                  "maximum": 20
                },
                "mapDragging": {
                  "type": "boolean",
                  "default": true,
                  "description": "show map type control"
                },
                "showDirectionsLink": {
                  "type": "boolean",
                  "default": true,
                  "description": "show directions link in infoWindow"
                },
                "mapType": {
                  "type": "string",
                  "enum": [
                    "ROADMAP",
                    "TERRAIN",
                    "SATELLITE",
                    "HYBRID"
                  ],
                  "default": "ROADMAP",
                  "description": "show zoom control"
                },
                "language": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "cs",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "hi",
                    "it",
                    "ja",
                    "ko",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "zh",
                    "th",
                    "uk",
                    "tr"
                  ],
                  "default": "en",
                  "description": "Possible languages taken from https://developers.google.com/maps/faq?hl=en#languagesupport"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "HorizontalMenuProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignButtons": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "center",
                  "description": "alignment of the menu buttons"
                },
                "alignText": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "center",
                  "description": "alignment of the menu buttons' text"
                },
                "sameWidthButtons": {
                  "type": "boolean",
                  "default": false,
                  "description": "Keep buttons the same size"
                },
                "moreButtonLabel": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "More",
                  "description": "Label to use for 'more button'"
                },
                "moreItemHeight": {
                  "type": "number",
                  "default": 15,
                  "description": "height of items in the more menu"
                },
                "stretchButtonsToMenuWidth": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "rtl": {
                  "type": "boolean",
                  "default": false,
                  "description": "should display menu in RTL mode"
                },
                "autoTextDirection": {
                  "$ref": "urn:dm:schemas:common.json#/NullableBool"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImpressProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "textMode": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "titleAndDescription",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "descriptionOnly",
                    "noText"
                  ]
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 5,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "showPagination": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "cropAndFitStage": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "crop",
                  "enum": [
                    "crop",
                    "fit"
                  ]
                },
                "transition": {
                  "type": "string",
                  "default": "random",
                  "enum": [
                    "none",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "random"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MasonryProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "numCols": {
                  "type": "number",
                  "default": 3,
                  "description": "Number of columns",
                  "minimum": 1,
                  "maximum": 10
                },
                "margin": {
                  "type": "number",
                  "default": 25,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 100
                },
                "textMode": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "titleAndDescription",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "descriptionOnly",
                    "noText"
                  ]
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "boxShadowIsOn": {
                  "type": "boolean",
                  "default": true
                },
                "boxShadow": {
                  "type": "string",
                  "default": "0 1px 3px 0 rgba(0,0,0,0.33)"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripShowcaseProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "galleryImageOnClickAction": {
                  "langsKey": "System.centerImageClick",
                  "type": "string",
                  "default": "disabled",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "cropAndFitStage": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "fit",
                  "enum": [
                    "crop",
                    "fit"
                  ]
                },
                "imageScale": {
                  "type": "string",
                  "default": "4:3",
                  "enum": [
                    "16:9",
                    "4:3",
                    "1:1",
                    "3:4",
                    "9:16"
                  ]
                },
                "imageMargin": {
                  "type": "number",
                  "default": 5,
                  "description": "Margin between thumbnails",
                  "minimum": 0,
                  "maximum": 100
                },
                "showThumbnails": {
                  "type": "boolean",
                  "default": true
                },
                "thumbsScale": {
                  "type": "string",
                  "default": "4:3",
                  "enum": [
                    "16:9",
                    "4:3",
                    "1:1",
                    "3:4",
                    "9:16"
                  ]
                },
                "thumbsMargin": {
                  "type": "number",
                  "default": 5,
                  "description": "Margin between thumbnails",
                  "minimum": 0,
                  "maximum": 100
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 5,
                  "minimum": 0,
                  "maximum": 30
                },
                "arrowMode": {
                  "type": "boolean",
                  "default": false
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripSlideshowProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "textMode": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "titleAndDescription",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "descriptionOnly",
                    "noText"
                  ]
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 5,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "showPlaybackControl": {
                  "type": "boolean"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "transition": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "scroll",
                  "enum": [
                    "none",
                    "crossFade",
                    "slide",
                    "scroll",
                    "zoom",
                    "random"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ThumbnailsProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "cropAndFitStage": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "crop",
                  "enum": [
                    "crop",
                    "fit"
                  ]
                },
                "componentScale": {
                  "type": "string",
                  "default": "4:3",
                  "enum": [
                    "16:9",
                    "4:3",
                    "1:1"
                  ]
                },
                "margin": {
                  "type": "number",
                  "default": 5,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 100
                },
                "textMode": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "titleAndDescription",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "descriptionOnly",
                    "noText"
                  ]
                },
                "arrowMode": {
                  "type": "boolean",
                  "default": true
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 5,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "transition": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "crossFade",
                  "enum": [
                    "none",
                    "crossFade",
                    "slide",
                    "scroll",
                    "zoom",
                    "random"
                  ]
                },
                "thumbnailsGravity": {
                  "langsKey": "System.gravity",
                  "type": "string",
                  "default": "bottom",
                  "enum": [
                    "top",
                    "bottom",
                    "left",
                    "right"
                  ]
                },
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "disabled",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AccordionProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "descFont": {
                  "$ref": "#/FontsEnum"
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "textMode": {
                  "langsKey": "System.textMode",
                  "type": "string",
                  "default": "titleOnly",
                  "enum": [
                    "titleOnly",
                    "noText"
                  ]
                },
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "borderWidth": {
                  "type": "number",
                  "default": 0,
                  "description": "Borer width between images",
                  "minimum": 0,
                  "maximum": 30
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CollageProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "alignText": {
                  "type": "string",
                  "default": "center",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "textMode": {
                  "langsKey": "System.textMode",
                  "type": "string",
                  "default": "titleOnly",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "noText"
                  ]
                },
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "minImageSize": {
                  "type": "number",
                  "default": 1,
                  "description": "minimum image size",
                  "minimum": 1,
                  "maximum": 10
                },
                "maxImageSize": {
                  "type": "number",
                  "default": 3,
                  "description": "maximum image size",
                  "minimum": 1,
                  "maximum": 10
                },
                "avergeImageSize": {
                  "type": "number",
                  "default": 1,
                  "description": "averge image size",
                  "minimum": 1,
                  "maximum": 10
                },
                "margin": {
                  "type": "number",
                  "default": 5,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 30
                },
                "fitToScreenWidth": {
                  "type": "boolean",
                  "default": false,
                  "description": "fit component width to screen"
                },
                "showNavButtons": {
                  "type": "boolean",
                  "default": true,
                  "description": "show navigation buttons"
                },
                "numOfCells": {
                  "type": "number",
                  "default": 5,
                  "description": "number of grid cells",
                  "minimum": 2,
                  "maximum": 10
                },
                "orientation": {
                  "langsKey": "System.orientation",
                  "type": "string",
                  "default": "vertical",
                  "enum": [
                    "vertical",
                    "horizontal"
                  ]
                },
                "layoutSeed": {
                  "type": "number",
                  "default": 50,
                  "description": "seed for layout calculation",
                  "minimum": 1,
                  "maximum": 100
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FreestyleProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "layoutSeed": {
                  "type": "number",
                  "default": 50,
                  "description": "seed for layout calculation",
                  "minimum": 1,
                  "maximum": 100
                },
                "cropAndFitStage": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "fit",
                  "enum": [
                    "crop",
                    "fit"
                  ]
                },
                "imageDecoration": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "none",
                  "enum": [
                    "none",
                    "polaroid",
                    "scotchTape",
                    "vintageFrame",
                    "random"
                  ]
                },
                "borderWidth": {
                  "type": "number",
                  "default": 3,
                  "description": "image border width",
                  "minimum": 0,
                  "maximum": 15
                },
                "orientation": {
                  "type": "string",
                  "default": "horizontal",
                  "enum": [
                    "vertical",
                    "horizontal"
                  ]
                },
                "applyRotationInLayout": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ItunesButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "language": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "it",
                    "ja",
                    "ko",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "tr"
                  ],
                  "default": "en",
                  "description": "Language of the button"
                },
                "openIn": {
                  "type": "string",
                  "enum": [
                    "_self",
                    "_blank"
                  ],
                  "default": "_blank",
                  "description": "Where the link will be opened"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LayoutProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "x": {
                  "type": "number",
                  "default": 0,
                  "description": "x position"
                },
                "y": {
                  "type": "number",
                  "default": 0,
                  "description": "y position"
                },
                "w": {
                  "type": "number",
                  "default": 100,
                  "description": "width"
                },
                "h": {
                  "type": "number",
                  "default": 100,
                  "description": "height"
                },
                "anchors": {
                  "type": [
                    "null",
                    "array"
                  ],
                  "description": "list of anchors"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LinkBarProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "gallery": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "clipart",
                  "description": "gallery type (photos, icons, backgrounds, etc..)"
                },
                "iconSize": {
                  "type": "number",
                  "default": 30,
                  "description": "Icon Size",
                  "minimum": 16,
                  "maximum": 128
                },
                "spacing": {
                  "type": "number",
                  "default": 5,
                  "description": "Spacing",
                  "minimum": 1,
                  "maximum": 50
                },
                "bgScale": {
                  "type": "number",
                  "default": 1,
                  "description": "Background scale",
                  "minimum": 0,
                  "maximum": 2
                },
                "orientation": {
                  "type": "string",
                  "enum": [
                    "HORIZ",
                    "VERT"
                  ],
                  "default": "HORIZ",
                  "description": "Orientation"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MatrixGalleryProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageMode": {
                  "type": "string",
                  "enum": [
                    "clipImage",
                    "flexibleWidthFixed"
                  ],
                  "default": "clipImage"
                },
                "itemHeight": {
                  "type": [
                    "null",
                    "number"
                  ],
                  "description": "height of specific item"
                },
                "numCols": {
                  "type": "number",
                  "default": 3,
                  "description": "Number of columns",
                  "minimum": 1,
                  "maximum": 10
                },
                "maxRows": {
                  "type": "number",
                  "default": 3,
                  "description": "Maximum number of rows",
                  "minimum": 1,
                  "maximum": 10
                },
                "incRows": {
                  "type": "number",
                  "default": 2,
                  "description": "Row number increase",
                  "minimum": 1,
                  "maximum": 10
                },
                "margin": {
                  "type": "number",
                  "default": 15,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 250
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "showMoreLabel": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Show More",
                  "description": "Show More"
                },
                "expandEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "goToLinkText": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Go to link"
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ],
                  "default": "zoomMode"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "NumberInputProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "minValue": {
                  "type": "number",
                  "default": 0,
                  "description": "minimum allowed value"
                },
                "maxValue": {
                  "type": "number",
                  "default": 999,
                  "description": "maximum allowed value"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PageGroupProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "none",
                    "swipeHorizontalFullScreen",
                    "swipeVerticalFullScreen",
                    "crossfade",
                    "outIn",
                    "slide"
                  ],
                  "default": "swipeHorizontalFullScreen",
                  "description": "page transition"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PaginatedGridGalleryProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageMode": {
                  "type": "string",
                  "enum": [
                    "clipImage"
                  ],
                  "default": "clipImage"
                },
                "numCols": {
                  "type": "number",
                  "default": 3,
                  "description": "Number of columns",
                  "minimum": 1,
                  "maximum": 10
                },
                "maxRows": {
                  "type": "number",
                  "default": 3,
                  "description": "Maximum number of rows",
                  "minimum": 1,
                  "maximum": 10
                },
                "margin": {
                  "type": "number",
                  "default": 0,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 250
                },
                "transition": {
                  "type": "string",
                  "default": "seq_crossFade_All",
                  "enum": [
                    "none",
                    "seq_crossFade_All",
                    "seq_shrink_All",
                    "swipe_horiz_All",
                    "swipe_vert_All",
                    "seq_random"
                  ]
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 3,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "showAutoplay": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "showNavigation": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "showCounter": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "expandEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "goToLinkText": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Go to link"
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PayPalButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "buttonType": {
                  "type": "string",
                  "enum": [
                    "buy",
                    "donate"
                  ],
                  "default": "buy",
                  "description": "buy or donate button"
                },
                "itemName": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "description": "some amazing description"
                },
                "itemID": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "description": "some amazing description"
                },
                "organizationName": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "description": "some amazing description"
                },
                "organizationID": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "description": "some amazing description"
                },
                "amount": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "description": "some amazing description"
                },
                "currencyCode": {
                  "type": "string",
                  "default": "USD",
                  "description": "Currency Code"
                },
                "target": {
                  "type": "string",
                  "enum": [
                    "_self",
                    "_blank"
                  ],
                  "default": "_blank",
                  "description": "Currency Code"
                },
                "showCreditCards": {
                  "type": "boolean",
                  "default": true,
                  "description": "Show credit card symbols"
                },
                "smallButton": {
                  "type": "boolean",
                  "default": false,
                  "description": "use small button"
                },
                "language": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "it",
                    "ja",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "tr"
                  ],
                  "default": "en",
                  "description": "https://developer.paypal.com/docs/classic/api/locale_codes/"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SiteSegmentContainerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "fixedPosition": {
                  "type": "boolean",
                  "default": false,
                  "description": "fixed positioning for components that inherit from SiteSegmentContainers"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SliderGalleryProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageMode": {
                  "type": "string",
                  "default": "clipImage",
                  "enum": [
                    "clipImage",
                    "flexibleWidth"
                  ]
                },
                "margin": {
                  "type": "number",
                  "default": 15,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 250
                },
                "maxSpeed": {
                  "type": "number",
                  "default": 5,
                  "minimum": 1,
                  "maximum": 30,
                  "description": "Speed"
                },
                "aspectRatio": {
                  "type": "number",
                  "minimum": 0.1,
                  "maximum": 3,
                  "default": 1,
                  "description": ""
                },
                "aspectRatioPreset": {
                  "type": "string",
                  "enum": [
                    "16:9",
                    "4:3",
                    "1:1",
                    "3:4",
                    "9:16"
                  ],
                  "default": "4:3"
                },
                "loop": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "showCounter": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "expandEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "goToLinkText": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Go to link"
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ],
                  "default": "zoomMode"
                },
                "autoplayInterval": {
                  "$ref": "urn:dm:schemas:common.json#/NullableInt"
                },
                "transDuration": {
                  "$ref": "urn:dm:schemas:common.json#/NullableInt"
                },
                "showAutoplay": {
                  "$ref": "urn:dm:schemas:common.json#/NullableBool"
                },
                "autoplay": {
                  "$ref": "urn:dm:schemas:common.json#/NullableBool"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SlideShowGalleryProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageMode": {
                  "type": "string",
                  "enum": [
                    "clipImage",
                    "flexibleHeight",
                    "flexibleWidthFixed"
                  ],
                  "default": "clipImage"
                },
                "transition": {
                  "type": "string",
                  "enum": [
                    "none",
                    "swipeVertical",
                    "swipeHorizontal",
                    "crossfade",
                    "outIn"
                  ],
                  "default": "swipeHorizontal",
                  "description": "Transition between items of the gallery"
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 5,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "bidirectional": {
                  "type": "boolean",
                  "default": true,
                  "description": "Decides whether the transition direction reflects Prev/Next"
                },
                "reverse": {
                  "type": "boolean",
                  "default": false,
                  "description": "If bidirectional, inverts the direction of transitions"
                },
                "showAutoplay": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "showNavigation": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "showCounter": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "expandEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "goToLinkText": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Go to link"
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "right"
                  ]
                },
                "showSocial": {
                  "type": [
                    "boolean",
                    "null"
                  ]
                },
                "showExpand": {
                  "type": [
                    "boolean",
                    "null"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SvgShapeProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "maintainAspectRatio": {
                  "type": "boolean",
                  "default": true,
                  "description": "should the shape maintain it's aspect ratio or stretch"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VectorImageProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "displayMode": {
                  "type": "string",
                  "enum": [
                    "legacyFit",
                    "fit",
                    "stretch"
                  ],
                  "description": "should the shape maintain it's aspect ratio or stretch, 'legacy-fit' is for converted SvgShape"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/FlipProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TableComponentProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "minHeight": {
                  "type": "number",
                  "default": -1,
                  "description": "minimum allowed value"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TinyMenuProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ExpandableMenuProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "itemsAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the menu items"
                },
                "subMenuOpenSide": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "right",
                  "description": "Opening direction of sub-menus"
                },
                "originalHeight": {
                  "type": "number",
                  "description": "Used to determine if comp was saved with correct height (if value not empty), or height needs to be fixed in DataFixer (if value is empty)"
                },
                "menuItemHeight": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number"
                    }
                  ]
                },
                "menuArrowDirection": {
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TwitterFeedProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "numOfTweets": {
                  "type": "number",
                  "default": 5,
                  "description": "Number of tweets in feed"
                },
                "subject": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "What's being said about...",
                  "description": "subject line"
                },
                "title": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Me...",
                  "description": "title line"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VideoProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": "video autoplay on load"
                },
                "loop": {
                  "type": "boolean",
                  "default": false,
                  "description": "play video in a loop"
                },
                "showinfo": {
                  "type": "boolean",
                  "default": false,
                  "description": "show video title and author"
                },
                "lightTheme": {
                  "type": "boolean",
                  "default": false,
                  "description": "show video with light theme"
                },
                "showControls": {
                  "type": "string",
                  "enum": [
                    "always_show",
                    "always_hide",
                    "temp_show"
                  ],
                  "default": "always_show",
                  "description": "show / hide controls"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VKShareProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "rightAngles": {
                  "type": "boolean",
                  "default": false,
                  "description": "Button Right angles"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WFacebookCommentProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "numPosts": {
                  "type": "number",
                  "default": 2,
                  "minimum": 0,
                  "maximum": 10,
                  "description": "the number of posts display by default"
                },
                "width": {
                  "type": "number",
                  "default": 555,
                  "description": "the width of the plugin, in pixels"
                },
                "colorScheme": {
                  "type": "string",
                  "enum": [
                    "light",
                    "dark"
                  ],
                  "default": "light",
                  "description": "the color scheme of the plugin"
                },
                "canBeShownOnAllPagesBug": {
                  "type": "boolean",
                  "default": false,
                  "description": "The component was added after the bug who-145 fix, and will be shown on all pages"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DisqusCommentsProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "disqusId": {
                  "type": "string",
                  "description": "User id in disqus"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WFacebookLikeProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "layout": {
                  "type": "string",
                  "enum": [
                    "standard",
                    "button_count",
                    "box_count"
                  ],
                  "default": "standard",
                  "description": "the layout of the button"
                },
                "send": {
                  "type": "boolean",
                  "default": false,
                  "description": "enable/disable the send button"
                },
                "show_faces": {
                  "type": "boolean",
                  "default": false,
                  "description": "show the faces of your friends that liked this item"
                },
                "width": {
                  "type": [
                    "null",
                    "string",
                    "number"
                  ],
                  "default": "225",
                  "description": "the width of the Like button"
                },
                "action": {
                  "type": "string",
                  "enum": [
                    "like",
                    "recommend"
                  ],
                  "default": "like",
                  "description": " the verb to display on the button. Options: *like*, *recommend*"
                },
                "font": {
                  "type": "string",
                  "enum": [
                    "helvetica",
                    "arial",
                    "lucida grande",
                    "segoe ui",
                    "tahoma",
                    "trebuchet ms",
                    "verdana"
                  ],
                  "default": "helvetica",
                  "description": "the font to display in the button"
                },
                "colorScheme": {
                  "type": "string",
                  "enum": [
                    "light",
                    "dark"
                  ],
                  "default": "dark",
                  "description": "the color scheme for the like button"
                },
                "language": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "it",
                    "ja",
                    "kr",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "tr"
                  ],
                  "default": "en"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WGooglePlusOneProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "size": {
                  "type": "string",
                  "enum": [
                    "small",
                    "medium",
                    "standard",
                    "tall"
                  ],
                  "default": "standard",
                  "description": "The button size to render"
                },
                "annotation": {
                  "type": "string",
                  "enum": [
                    "none",
                    "bubble",
                    "inline"
                  ],
                  "default": "inline",
                  "description": "The annotation to display next to the button."
                },
                "width": {
                  "type": [
                    "null",
                    "number"
                  ],
                  "description": "If annotation is set to *inline*, the width in pixels to use for the button and its inline annotation. If omitted, a button and its inline annotation use 450px."
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WPhotoProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "displayMode": {
                  "type": "string",
                  "enum": [
                    "fit",
                    "fill",
                    "full",
                    "stretch",
                    "fitWidth",
                    "fitWidthStrict",
                    "fitHeightStrict"
                  ],
                  "default": "fill",
                  "description": "displayMode of the photo"
                },
                "autoFill": {
                  "type": "boolean",
                  "default": false,
                  "description": "Should the photo should enable auto crop in the editor"
                },
                "onClickBehavior": {
                  "type": "string",
                  "enum": [
                    "disabled",
                    "goToLink",
                    "zoomMode",
                    "zoomAndPanMode"
                  ],
                  "default": "goToLink",
                  "description": "goToLink"
                },
                "effectName": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "An effect to apply on the image",
                  "default": "none"
                },
                "filterEffect": {
                  "type": [
                    "object",
                    "null"
                  ],
                  "description": "An effect to apply on the image",
                  "properties": {
                    "effectType": {
                      "type": "string"
                    },
                    "brightness": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 10
                    },
                    "contrast": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 10
                    },
                    "saturation": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 10
                    },
                    "hue": {
                      "type": "number",
                      "minimum": -180,
                      "maximum": 180
                    },
                    "duotoneDark": {
                      "type": "string"
                    },
                    "duotoneLight": {
                      "type": "string"
                    },
                    "invert": {
                      "type": "boolean",
                      "default": false
                    },
                    "isCustom": {
                      "type": "boolean"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "overrideCrop": {
                  "description": "Overriding the image crop for Mobile view",
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "object",
                      "minProperties": 4,
                      "allOf": [
                        {
                          "properties": {
                            "x": {
                              "type": "number",
                              "minimum": 0
                            },
                            "y": {
                              "type": "number",
                              "minimum": 0
                            },
                            "width": {
                              "type": "number",
                              "minimum": 0
                            },
                            "height": {
                              "type": "number",
                              "minimum": 0
                            },
                            "svgId": {
                              "type": "string",
                              "description": "Defines an svg uri for a mask inside the crop boundaries"
                            },
                            "rotate": {
                              "type": "number",
                              "minimum": 0,
                              "maximum": 360,
                              "description": "Defines a rotation angle for the mask"
                            }
                          }
                        },
                        {
                          "$ref": "#/FlipProperties--unrestricted-root"
                        }
                      ]
                    }
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WRichTextProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "packed": {
                  "type": "boolean",
                  "default": false,
                  "description": "Is the text component packed"
                },
                "brightness": {
                  "type": "number",
                  "default": 1
                },
                "overrideAlignment": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "left",
                        "right",
                        "center",
                        "justify"
                      ]
                    }
                  ]
                },
                "overrideColor": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string"
                    }
                  ]
                },
                "minHeight": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number"
                    }
                  ]
                },
                "minWidth": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number"
                    }
                  ]
                },
                "verticalText": {
                  "type": "boolean",
                  "default": false,
                  "description": "Vertical oriented text flag"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RefComponentProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "minHeight": {
                  "type": "number"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WTwitterFollowProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showCount": {
                  "type": "boolean",
                  "default": true,
                  "description": "Followers count display"
                },
                "showScreenName": {
                  "type": "boolean",
                  "default": true,
                  "description": "Show screen name"
                },
                "textColor": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$",
                  "description": "HEX color code for the text color"
                },
                "linkColor": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$",
                  "description": "HEX color code for the Username link color"
                },
                "width": {
                  "type": "number",
                  "default": 100,
                  "description": "width of the Follow Button"
                },
                "dataLang": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "hi",
                    "it",
                    "ja",
                    "ko",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "tr"
                  ],
                  "default": "en",
                  "description": "The language for the Tweet Button (from https://dev.twitter.com/overview/general/adding-international-support-to-your-apps)"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WTwitterTweetProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "dataCount": {
                  "type": "string",
                  "enum": [
                    "none",
                    "horizontal",
                    "vertical"
                  ],
                  "default": "horizontal",
                  "description": "Count box position"
                },
                "dataLang": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "hi",
                    "it",
                    "ja",
                    "ko",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "tr"
                  ],
                  "default": "en",
                  "description": "The language for the Tweet Button (from https://dev.twitter.com/overview/general/adding-international-support-to-your-apps)"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "HoverBoxProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "mobileDisplayedModeId": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "The mode to activate when in mobile view"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TPAGluedProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "placement": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "BOTTOM_RIGHT",
                  "description": "widget placement"
                },
                "verticalMargin": {
                  "type": [
                    "null",
                    "string",
                    "number"
                  ],
                  "default": "",
                  "description": "widget vertical margin"
                },
                "horizontalMargin": {
                  "type": [
                    "null",
                    "string",
                    "number"
                  ],
                  "default": "",
                  "description": "widget horizontal margin"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "HoneycombProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "textMode": {
                  "langsKey": "System.textMode",
                  "type": "string",
                  "default": "titleAndDescription",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "descriptionOnly",
                    "noText"
                  ]
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "margin": {
                  "type": "number",
                  "default": 1,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 30
                },
                "numOfColumns": {
                  "type": "number",
                  "default": 4,
                  "description": "number of columns",
                  "minimum": 2,
                  "maximum": 10
                },
                "numOfHoles": {
                  "type": "number",
                  "default": 2,
                  "description": "number of holes in the honeycomb",
                  "minimum": 2,
                  "maximum": 8
                },
                "layoutSeed": {
                  "type": "number",
                  "default": 50,
                  "description": "seed for layout calculation",
                  "minimum": 1,
                  "maximum": 100
                },
                "rolloverAnimation": {
                  "type": "string",
                  "default": "colorOnly",
                  "enum": [
                    "colorOnly",
                    "glow",
                    "bounce"
                  ]
                },
                "imageShape": {
                  "type": "string",
                  "default": "hexagon",
                  "enum": [
                    "hexagon",
                    "square",
                    "triangle"
                  ]
                },
                "imageScale": {
                  "type": "string",
                  "default": "x1",
                  "enum": [
                    "x1",
                    "x2",
                    "x3"
                  ]
                },
                "expandEnabled": {
                  "$ref": "urn:dm:schemas:common.json#/NullableBool"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AppPartProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": "string",
                  "default": "ltr",
                  "enum": [
                    "ltr",
                    "rtl"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RssButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "none",
                    "fade",
                    "float",
                    "expand",
                    "spin",
                    "fly",
                    "turn",
                    "reveal",
                    "slide",
                    "puff",
                    "flip",
                    "fold",
                    "arc"
                  ],
                  "default": "fade"
                },
                "type": {
                  "type": "string"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BoxSlideShowProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "NoTransition",
                    "SlideVertical",
                    "SlideHorizontal",
                    "CrossFade",
                    "OutIn"
                  ],
                  "default": "SlideHorizontal",
                  "description": "Transition between items of the gallery"
                },
                "autoPlay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "autoPlayInterval": {
                  "type": "number",
                  "default": 3,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "showPlaybackControl": {
                  "type": "boolean"
                },
                "direction": {
                  "type": "string",
                  "default": "RTL",
                  "enum": [
                    "LTR",
                    "RTL"
                  ]
                },
                "pauseAutoPlayOnMouseOver": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "shouldHideOverflowContent": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "flexibleBoxHeight": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "showNavigationButton": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "navigationButtonSize": {
                  "type": "number",
                  "minimum": 8,
                  "maximum": 72,
                  "default": 21,
                  "description": "Size of the navigation arrow buttons"
                },
                "navigationButtonMargin": {
                  "type": "number",
                  "minimum": -72,
                  "maximum": 72,
                  "default": 0,
                  "description": "Margin from the sides of the navigation arrow buttons"
                },
                "showNavigationDots": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "navigationDotsAlignment": {
                  "type": "string",
                  "default": "center",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "description": "Alignment of the navigation dots"
                },
                "navigationDotsSize": {
                  "type": "number",
                  "minimum": 6,
                  "maximum": 24,
                  "default": 6,
                  "description": "Size of the navigation dots"
                },
                "navigationDotsMargin": {
                  "type": "number",
                  "minimum": -50,
                  "maximum": 50,
                  "default": 0,
                  "description": "Margin from the sides of the navigation dots"
                },
                "navigationDotsGap": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 24,
                  "default": 0,
                  "description": "Gap size (spacing) of the navigation dots"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BoxSlideShowSlideProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StateBoxProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "NoTransition",
                    "SlideVertical",
                    "SlideHorizontal",
                    "CrossFade",
                    "OutIn"
                  ],
                  "default": "NoTransition",
                  "description": "Transition between states"
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StateBoxStateProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StateBoxFormStateProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripContainerSlideShowProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "NoTransition",
                    "SlideVertical",
                    "SlideHorizontal",
                    "CrossFade",
                    "OutIn"
                  ],
                  "default": "SlideHorizontal",
                  "description": "Transition between items of the gallery"
                },
                "autoPlay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "showPlaybackControl": {
                  "type": "boolean"
                },
                "autoPlayInterval": {
                  "type": "number",
                  "default": 2,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "direction": {
                  "type": "string",
                  "default": "RTL",
                  "enum": [
                    "LTR",
                    "RTL"
                  ]
                },
                "pauseAutoPlayOnMouseOver": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "shouldHideOverflowContent": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "flexibleBoxHeight": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "showNavigationButton": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "navigationButtonSize": {
                  "type": "number",
                  "minimum": 8,
                  "maximum": 72,
                  "default": 21,
                  "description": "Size of the navigation arrow buttons"
                },
                "navigationButtonMargin": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 0,
                  "description": "Margin from the sides of the navigation arrow buttons"
                },
                "showNavigationDots": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "navigationDotsAlignment": {
                  "type": "string",
                  "default": "center",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "description": "Alignment of the navigation dots"
                },
                "navigationDotsSize": {
                  "type": "number",
                  "minimum": 6,
                  "maximum": 24,
                  "default": 6,
                  "description": "Size of the navigation dots"
                },
                "navigationDotsMargin": {
                  "type": "number",
                  "minimum": -50,
                  "maximum": 50,
                  "default": 0,
                  "description": "Margin from the sides of the navigation dots"
                },
                "navigationDotsGap": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 24,
                  "default": 0,
                  "description": "Gap size (spacing) of the navigation dots"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripContainerSlideShowSlideProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VerticalAnchorsMenuProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "itemsAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the menu items"
                },
                "orientation": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "right",
                  "description": "menu orientation"
                },
                "autoColor": {
                  "type": "boolean",
                  "default": false,
                  "description": "does the menu color change automatically according to the background brightness"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextInputProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "textAlignment": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "left",
                        "right",
                        "center"
                      ],
                      "maxLength": 100
                    }
                  ],
                  "default": "left",
                  "description": "the direction of the text"
                },
                "textPadding": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 100
                    }
                  ],
                  "default": 14,
                  "description": "the value of the textPadding"
                },
                "placeholder": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected",
                  "default": "Add your name"
                },
                "defaultTextType": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "none",
                        "initialText",
                        "placeholderText",
                        "placeholderAndInitialText"
                      ],
                      "maxLength": 100
                    }
                  ],
                  "default": "placeholderText",
                  "description": "the type of the default text for the input"
                },
                "autoComplete": {
                  "type": "boolean",
                  "description": "can the field be auto completed by the browser"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            },
            {
              "$ref": "#/InputElementsErrorProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextAreaInputProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "textAlignment": {
                  "type": "string",
                  "default": "center",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "description": "the direction of the text",
                  "maxLength": 100
                },
                "textPadding": {
                  "type": "number",
                  "default": 18,
                  "minimum": 0,
                  "maximum": 100,
                  "description": "the value of the textPadding"
                },
                "placeholder": {
                  "type": "string",
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected"
                },
                "defaultTextType": {
                  "type": "string",
                  "default": "none",
                  "enum": [
                    "none",
                    "initialText",
                    "placeholderText",
                    "placeholderAndInitialText"
                  ],
                  "description": "the type of the default text for the input",
                  "maxLength": 100
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            },
            {
              "$ref": "#/InputElementsErrorProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CheckboxProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the text"
                },
                "buttonSize": {
                  "type": "number",
                  "default": 18,
                  "description": "checkbox size",
                  "minimum": 12,
                  "maximum": 100
                },
                "spacing": {
                  "type": "number",
                  "default": 12,
                  "description": "Spacing between checkbox and label",
                  "minimum": 0,
                  "maximum": 100
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DatePickerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "textAlignment": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "description": "the direction of the text"
                },
                "textPadding": {
                  "type": "number",
                  "default": 18,
                  "description": "the value of the text padding"
                },
                "placeholder": {
                  "type": "string",
                  "default": "",
                  "maxLength": 200,
                  "description": "placeholder text for date in input field"
                },
                "dateFormat": {
                  "type": "string",
                  "default": "MM/DD/YYYY",
                  "enum": [
                    "MM/DD/YYYY",
                    "DD/MM/YYYY",
                    "YYYY/MM/DD",
                    "YYYY/M/D"
                  ],
                  "description": "date format for selected date presentation inside the date input field"
                },
                "defaultTextType": {
                  "type": "string",
                  "default": "none",
                  "enum": [
                    "none",
                    "today",
                    "placeholder"
                  ],
                  "description": "the type of the default text for the date input"
                },
                "dayToStart": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "Sunday",
                        "Monday"
                      ],
                      "description": "the day which the week starts on"
                    }
                  ]
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GridProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "columns": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "properties": {
                      "id": {
                        "type": "string"
                      },
                      "dataPath": {
                        "type": "string"
                      },
                      "linkPath": {
                        "type": "string"
                      },
                      "label": {
                        "type": "string"
                      },
                      "width": {
                        "type": "number",
                        "default": 100
                      },
                      "visible": {
                        "type": "boolean",
                        "default": true
                      },
                      "type": {
                        "type": "string",
                        "enum": [
                          "number",
                          "string",
                          "date",
                          "image",
                          "bool",
                          "richText"
                        ]
                      },
                      "imageAltPath": {
                        "type": "string"
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "showHeader": {
                  "type": "boolean"
                },
                "headerHeight": {
                  "type": "number"
                },
                "rowHeight": {
                  "type": "number"
                },
                "allowUserSorting": {
                  "type": "boolean"
                },
                "allowUserFiltering": {
                  "type": "boolean"
                },
                "allowUserEditing": {
                  "type": "boolean"
                },
                "heightLayout": {
                  "type": "string",
                  "enum": [
                    "manual",
                    "auto"
                  ]
                },
                "pagination": {
                  "type": "object",
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "type": "string",
                      "enum": [
                        "normal",
                        "pagination",
                        "virtual"
                      ]
                    },
                    "rowsPerPage": {
                      "type": "number",
                      "multipleOf": 1
                    },
                    "manualHeightProps": {
                      "type": "object",
                      "properties": {
                        "rowsPerPage": {
                          "type": "number",
                          "multipleOf": 1
                        },
                        "gridHeight": {
                          "type": "number",
                          "multipleOf": 1
                        },
                        "type": {
                          "type": "string",
                          "enum": [
                            "normal",
                            "pagination",
                            "virtual"
                          ]
                        }
                      },
                      "unevaluatedProperties": false
                    },
                    "style": {
                      "type": "string",
                      "enum": [
                        "text",
                        "number",
                        "simple"
                      ],
                      "default": "text"
                    },
                    "alignment": {
                      "type": "string",
                      "enum": [
                        "left",
                        "center",
                        "right",
                        "spread"
                      ],
                      "default": "right"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "userSelectionType": {
                  "type": "string",
                  "enum": [
                    "none",
                    "cell",
                    "row"
                  ],
                  "default": "none"
                },
                "dateFormat": {
                  "type": "string"
                },
                "sorting": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "properties": {
                      "colId": {
                        "type": "string"
                      },
                      "sort": {
                        "type": "string",
                        "default": "none",
                        "enum": [
                          "asc",
                          "desc",
                          "none"
                        ]
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "linkTarget": {
                  "type": "string",
                  "enum": [
                    "_self",
                    "_blank"
                  ]
                },
                "columnLayout": {
                  "type": "string",
                  "enum": [
                    "equal",
                    "fitContent",
                    "manual"
                  ]
                },
                "horizontalAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PagePropertiesForDevice": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "minHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "minimum page size"
        },
        "popup": {
          "type": "object",
          "properties": {
            "closeOnOverlayClick": {
              "type": "boolean",
              "default": true
            }
          },
          "unevaluatedProperties": false
        }
      },
      "unevaluatedProperties": false
    },
    "PageProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "type": "object",
              "properties": {
                "desktop": {
                  "$ref": "#/PagePropertiesForDevice"
                },
                "mobile": {
                  "$ref": "#/PagePropertiesForDevice"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PopupContainerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "horizontalAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "default": "center",
                  "description": ""
                },
                "verticalAlignment": {
                  "type": "string",
                  "enum": [
                    "top",
                    "bottom",
                    "center"
                  ],
                  "default": "top",
                  "description": ""
                },
                "alignmentType": {
                  "type": "string",
                  "enum": [
                    "nineGrid",
                    "fullHeight",
                    "fullWidth"
                  ],
                  "default": "nineGrid",
                  "description": ""
                },
                "horizontalOffset": {
                  "type": "number",
                  "default": 0,
                  "description": ""
                },
                "verticalOffset": {
                  "type": "number",
                  "default": 0,
                  "description": ""
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MediaPlayerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "autoplay": {
                  "type": "boolean",
                  "default": false
                },
                "playerInteraction": {
                  "type": "object",
                  "description": "The way the player itself interacts with user input",
                  "default": {},
                  "properties": {
                    "click": {
                      "type": [
                        "string",
                        "null"
                      ],
                      "enum": [
                        "none",
                        "play",
                        "toggle"
                      ],
                      "default": "toggle"
                    },
                    "rollIn": {
                      "type": [
                        "string",
                        "null"
                      ],
                      "enum": [
                        "none",
                        "play",
                        "pause"
                      ],
                      "default": "none"
                    },
                    "rollOut": {
                      "type": [
                        "string",
                        "null"
                      ],
                      "enum": [
                        "none",
                        "play",
                        "pause"
                      ],
                      "default": "none"
                    },
                    "allowReplay": {
                      "type": "boolean",
                      "default": true
                    }
                  },
                  "unevaluatedProperties": false
                },
                "playerAudioInteraction": {
                  "type": "object",
                  "description": "The way the player itself interacts with user input",
                  "default": {},
                  "properties": {
                    "rollIn": {
                      "type": [
                        "string",
                        "null"
                      ],
                      "enum": [
                        "none",
                        "mute",
                        "unmute"
                      ],
                      "default": "none"
                    },
                    "rollOut": {
                      "type": [
                        "string",
                        "null"
                      ],
                      "enum": [
                        "none",
                        "mute",
                        "unmute"
                      ],
                      "default": "none"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "animatePoster": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "enum": [
                    "none",
                    "fade"
                  ],
                  "default": "none"
                },
                "mute": {
                  "type": "boolean",
                  "description": "mute on load",
                  "default": false
                },
                "disableAudio": {
                  "type": "boolean",
                  "description": "don't allow audio in player",
                  "default": false
                },
                "loop": {
                  "type": "boolean",
                  "default": false
                },
                "overrideMask": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "urn:dm:schemas:design_data.json#/ImageMask--unrestricted-root"
                    }
                  ]
                }
              }
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            },
            {
              "$ref": "#/FlipProperties--unrestricted-root"
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MediaControlsProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showStoryboard": {
                  "type": "string",
                  "enum": [
                    "videoAndTime",
                    "time",
                    "none"
                  ],
                  "default": "videoAndTime",
                  "description": "The options of displaying video preview when hovering on the progress bar"
                },
                "playerId": {
                  "type": "string",
                  "default": ""
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MediaOverlayControlsProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "playerId": {
                  "type": "string",
                  "default": ""
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LanguageSelectorProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "displayMode": {
                  "type": "string",
                  "default": "dropdown",
                  "enum": [
                    "horizontal",
                    "dropdown"
                  ],
                  "description": "the direction of the language labels"
                },
                "iconType": {
                  "type": "string",
                  "default": "circle",
                  "enum": [
                    "none",
                    "circle",
                    "square",
                    "rounded"
                  ],
                  "description": "language selector flag shape"
                },
                "iconSize": {
                  "type": [
                    "null",
                    "number"
                  ],
                  "description": "language selector icon size"
                },
                "hasArrow": {
                  "type": "boolean"
                },
                "itemFormat": {
                  "type": "string",
                  "default": "shortName",
                  "enum": [
                    "shortName",
                    "fullName",
                    "iconOnly",
                    "fullLocalizedName"
                  ],
                  "description": "language selector labels type"
                },
                "alignTabs": {
                  "type": "string",
                  "default": "center",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "description": "language selector tabs alignment"
                },
                "languagesOrder": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "string",
                    "maxLength": 50
                  },
                  "description": "Override for the order of the languages in the selection"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MediaBoxProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "allowOverflowContent": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PopoverProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "position": {
                  "type": "string",
                  "enum": [
                    "top",
                    "bottom",
                    "left",
                    "right"
                  ],
                  "default": "top"
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "start",
                    "center",
                    "end"
                  ],
                  "default": "center"
                },
                "horizontalOffset": {
                  "type": "number",
                  "default": 0
                },
                "verticalOffset": {
                  "type": "number",
                  "default": 0
                },
                "closeMethod": {
                  "type": "string",
                  "enum": [
                    "mouseOut",
                    "outerClick",
                    "manual"
                  ],
                  "default": "mouseOut"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiPickerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "allOf": [
            {
              "properties": {
                "required": {
                  "default": false,
                  "type": "boolean"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MobuiPickerItemType": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "subtitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isSelected": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiTextInputProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "allOf": [
            {
              "properties": {
                "hasInitialValue": {
                  "default": true,
                  "type": "boolean"
                },
                "multiline": {
                  "default": false,
                  "type": "boolean"
                },
                "readOnly": {
                  "default": false,
                  "type": "boolean"
                },
                "hasPrefix": {
                  "default": false,
                  "type": "boolean"
                },
                "hasSuffix": {
                  "default": false,
                  "type": "boolean"
                },
                "required": {
                  "default": false,
                  "type": "boolean"
                },
                "autoCorrect": {
                  "default": false,
                  "type": "boolean"
                },
                "hasAutoComplete": {
                  "default": false,
                  "type": "boolean"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AccordionContainerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "defaultOpened": {
              "type": "string",
              "enum": [
                "close_all",
                "open_first",
                "open_all"
              ],
              "default": "close_all"
            },
            "multiple": {
              "type": "boolean",
              "default": false
            },
            "animated": {
              "type": "boolean",
              "default": false
            },
            "animationTime": {
              "type": "number",
              "minimum": 0,
              "default": 0.25
            },
            "icon": {
              "type": "string",
              "enum": [
                "arrow",
                "plus"
              ],
              "default": "arrow"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AccordionItemProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isParentFullWidth": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AddressInputProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left"
                },
                "iconVisible": {
                  "type": "boolean",
                  "default": false
                },
                "dividerVisible": {
                  "type": "boolean",
                  "default": false
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BoltComponentProperties": {
      "type": "object",
      "anyOf": [
        {
          "properties": {}
        }
      ],
      "unevaluatedProperties": false
    },
    "BreadcrumbsProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "separator": {
                  "type": "string",
                  "enum": [
                    "greater-than",
                    "slash"
                  ],
                  "default": "slash",
                  "description": "Defines type of separator between breadcrumbs items"
                },
                "shouldWrap": {
                  "type": "boolean",
                  "default": true,
                  "description": "Defines flex wrapping of items"
                },
                "direction": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ],
                  "default": "ltr",
                  "description": "Direction of breadcrumbs items"
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "flex-start",
                    "center",
                    "flex-end"
                  ],
                  "default": "flex-start",
                  "description": "Alignment of breadcrumbs items"
                },
                "showHomePage": {
                  "type": "boolean",
                  "default": true,
                  "description": "Should show home item"
                },
                "showHomePageAsIcon": {
                  "type": "boolean",
                  "default": false,
                  "description": "Breadcrumbs will show HOME item as icon"
                },
                "showCurrentPage": {
                  "type": "boolean",
                  "default": true,
                  "description": "Should show current page in breadcrumbs"
                },
                "showOnlyPreviousPageOnMobile": {
                  "type": "boolean",
                  "default": false,
                  "description": "Show only previous page in mobile breadcrumbs"
                },
                "horizontalMargin": {
                  "type": "number",
                  "default": 0
                },
                "verticalMargin": {
                  "type": "number",
                  "default": 0
                },
                "isCollapsedByDefault": {
                  "type": "boolean",
                  "default": true
                },
                "itemsBeforeCollapse": {
                  "type": "number",
                  "default": 1
                },
                "itemsAfterCollapse": {
                  "type": "number",
                  "default": 1
                },
                "align": {
                  "type": "string",
                  "enum": [
                    "start",
                    "center",
                    "end"
                  ],
                  "description": "Alignment of breadcrumbs items updated to new approach"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CaptchaProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "theme": {
                  "type": "string",
                  "enum": [
                    "light",
                    "dark"
                  ],
                  "default": "light",
                  "description": "When set changes the theme of the captcha (dark or light)"
                },
                "size": {
                  "type": "string",
                  "enum": [
                    "normal",
                    "compact"
                  ],
                  "default": "normal",
                  "description": "When set changes the size of the captcha (normal or compact)"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CollapsibleTextProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "ellipsis": {
                  "type": "boolean",
                  "default": true
                },
                "showExpandControl": {
                  "type": "boolean",
                  "default": false
                },
                "direction": {
                  "type": "string",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "default": "ltr"
                },
                "align": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "default": "left"
                },
                "alignButton": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "default": "left"
                },
                "maxLines": {
                  "type": "number",
                  "default": 3
                },
                "wrappingStyle": {
                  "type": "string",
                  "enum": [
                    "single-line",
                    "multi-line"
                  ],
                  "default": "multi-line"
                },
                "expandControlSpacing": {
                  "type": "number",
                  "default": 10
                },
                "expandMode": {
                  "type": "string",
                  "enum": [
                    "button",
                    "link"
                  ],
                  "default": "link"
                },
                "isExpanded": {
                  "type": "boolean",
                  "default": false
                },
                "lastUserDefinedWidth": {
                  "type": "number",
                  "default": 300
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "HamburgerCloseButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/StylableButtonProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "HamburgerMenuContainerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "fullWidth": {
              "type": "boolean",
              "default": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "HamburgerOpenButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/StylableButtonProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LineShareButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "buttonType": {
                  "type": "string",
                  "default": "button",
                  "enum": [
                    "button",
                    "classicWithButton",
                    "classicBig",
                    "classicMedium",
                    "classicSmall",
                    "bubbleBig",
                    "bubbleMedium",
                    "bubbleSmall"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MusicPlayerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "layout": {
                  "type": "string",
                  "enum": [
                    "classic",
                    "icon"
                  ],
                  "default": "classic"
                },
                "source": {
                  "type": "string",
                  "enum": [
                    "uploads",
                    "url",
                    "wixMusic"
                  ],
                  "default": "uploads"
                },
                "showCover": {
                  "type": "boolean",
                  "default": true
                },
                "showArtistName": {
                  "type": "boolean",
                  "default": true
                },
                "showTrackName": {
                  "type": "boolean",
                  "default": true
                },
                "showProgressBar": {
                  "type": "boolean",
                  "default": true
                },
                "showTimeStamp": {
                  "type": "boolean",
                  "default": true
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": "Autoplay audio"
                },
                "loop": {
                  "type": "boolean",
                  "default": false,
                  "description": "Play audio on loop"
                },
                "showPlaylist": {
                  "type": "boolean",
                  "default": true,
                  "description": "Show Tracklist"
                },
                "playlistTracksInfo": {
                  "type": "string",
                  "enum": [
                    "trackName",
                    "trackNameAndArtistName"
                  ],
                  "default": "trackName",
                  "description": "Show track name or track name w/ artist name"
                },
                "playlistTracksAction": {
                  "type": "string",
                  "enum": [
                    "onActive",
                    "onAll"
                  ],
                  "default": "onActive",
                  "description": "Show track actions on active track or all tracks"
                },
                "playlistTrackSpacing": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 30,
                  "description": "How much vertical space must be between each track in playlist",
                  "default": 0
                },
                "iconId": {
                  "type": "string",
                  "default": "icon0",
                  "description": "Design IconLayout id"
                },
                "consentToShareAlbum": {
                  "type": "boolean",
                  "default": false,
                  "description": "Agreement to share album"
                },
                "consentToShareTracks": {
                  "type": "boolean",
                  "default": false,
                  "description": "Agreement to share tracks"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PaginationProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showFirstLastNavButtons": {
                  "type": "boolean",
                  "default": false
                },
                "showFirstPage": {
                  "type": "boolean",
                  "default": false
                },
                "showLastPage": {
                  "type": "boolean",
                  "default": false
                },
                "showInputModeTotalPages": {
                  "type": "boolean",
                  "default": true
                },
                "paginationMode": {
                  "type": "string",
                  "enum": [
                    "pages",
                    "input",
                    "arrows"
                  ],
                  "default": "pages"
                },
                "navigationType": {
                  "type": "string",
                  "enum": [
                    "arrows",
                    "text"
                  ],
                  "default": "arrows"
                },
                "paginationDirection": {
                  "type": "string",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "default": "ltr"
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "spread",
                    "right"
                  ],
                  "default": "center"
                },
                "showPageNumbersBar": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ProGalleryProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "options": {
                  "type": "object",
                  "properties": {
                    "controllers_optionsMap_behaviourParams_item_video_volume": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_layoutParams_info_allowTitleAndDescription": {
                      "type": "string",
                      "default": ""
                    },
                    "layoutParams_structure_galleryLayout": {
                      "type": "number",
                      "default": 0
                    },
                    "layoutParams_structure_scrollDirection": {
                      "type": "string",
                      "default": "VERTICAL"
                    },
                    "layoutParams_structure_layoutOrientation": {
                      "type": "string",
                      "default": "VERTICAL"
                    },
                    "behaviourParams_gallery_layoutDirection": {
                      "type": "string",
                      "default": "LEFT_TO_RIGHT"
                    },
                    "layoutParams_structure_itemSpacing": {
                      "type": "number",
                      "default": 10
                    },
                    "layoutParams_structure_numberOfGridRows": {
                      "type": "number",
                      "default": 1
                    },
                    "layoutParams_structure_numberOfColumns": {
                      "type": "number",
                      "default": 3
                    },
                    "layoutParams_groups_density": {
                      "type": "number",
                      "default": 0.8
                    },
                    "layoutParams_targetItemSize_value": {
                      "type": "number",
                      "default": 48
                    },
                    "layoutParams_crop_method": {
                      "type": "string",
                      "default": "FILL"
                    },
                    "layoutParams_crop_ratios": {
                      "type": "number",
                      "default": 1
                    },
                    "layoutParams_structure_responsiveMode": {
                      "type": "string",
                      "default": "FIT_TO_SCREEN"
                    },
                    "layoutParams_thumbnails_alignment": {
                      "type": "string",
                      "default": "BOTTOM"
                    },
                    "layoutParams_thumbnails_size": {
                      "type": "number",
                      "default": 120
                    },
                    "layoutParams_thumbnails_spacing": {
                      "type": "number",
                      "default": 4
                    },
                    "controllers_layoutParams_thumbnails_marginToGallery": {
                      "type": "number",
                      "default": 4
                    },
                    "behaviourParams_gallery_vertical_loadMore_enable": {
                      "type": "boolean",
                      "default": false
                    },
                    "behaviourParams_gallery_vertical_loadMore_text": {
                      "type": "string",
                      "default": "Load More"
                    },
                    "behaviourParams_gallery_horizontal_navigationDuration": {
                      "type": "number",
                      "default": 800
                    },
                    "behaviourParams_gallery_horizontal_loop": {
                      "type": "boolean",
                      "default": false
                    },
                    "behaviourParams_gallery_horizontal_autoSlide_interval": {
                      "type": "number",
                      "default": 4
                    },
                    "behaviourParams_gallery_horizontal_autoSlide_speed": {
                      "type": "number",
                      "default": 50
                    },
                    "behaviourParams_gallery_horizontal_autoSlide_pauseOnHover": {
                      "type": "boolean",
                      "default": true
                    },
                    "behaviourParams_gallery_blockContextMenu": {
                      "type": "boolean",
                      "default": true
                    },
                    "layoutParams_navigationArrows_enable": {
                      "type": "boolean",
                      "default": true
                    },
                    "layoutParams_navigationArrows_size": {
                      "type": "number",
                      "default": 23
                    },
                    "layoutParams_navigationArrows_position": {
                      "type": "string",
                      "default": "ON_GALLERY"
                    },
                    "layoutParams_navigationArrows_container_type": {
                      "type": "string",
                      "default": "NONE"
                    },
                    "layoutParams_navigationArrows_mouseCursorContainerMaxWidth": {
                      "type": "string",
                      "default": "100"
                    },
                    "layoutParams_navigationArrows_verticalAlignment": {
                      "type": "string",
                      "default": "ITEM_CENTER"
                    },
                    "controllers_behaviourParams_item_overlay_hoverAnimationBehavior": {
                      "type": "string",
                      "default": "APPEARS"
                    },
                    "behaviourParams_item_content_hoverAnimation": {
                      "type": "string",
                      "default": "NO_EFFECT"
                    },
                    "behaviourParams_item_content_loader": {
                      "type": "string",
                      "default": "MAIN_COLOR"
                    },
                    "behaviourParams_item_content_placementAnimation": {
                      "type": "string",
                      "default": "NO_EFFECT"
                    },
                    "behaviourParams_gallery_scrollAnimation": {
                      "type": "string",
                      "default": "NO_EFFECT"
                    },
                    "behaviourParams_gallery_horizontal_slideAnimation": {
                      "type": "string",
                      "default": "SCROLL"
                    },
                    "behaviourParams_item_video_enablePlayButton": {
                      "type": "boolean",
                      "default": true
                    },
                    "behaviourParams_item_video_playTrigger": {
                      "type": "string",
                      "default": "HOVER"
                    },
                    "behaviourParams_item_video_speed": {
                      "type": "number",
                      "default": 1
                    },
                    "behaviourParams_item_video_volume": {
                      "type": "number",
                      "default": 0
                    },
                    "behaviourParams_item_video_loop": {
                      "type": "boolean",
                      "default": true
                    },
                    "behaviourParams_item_clickAction": {
                      "type": "string",
                      "default": "NOTHING"
                    },
                    "behaviourParams_item_content_magnificationValue": {
                      "type": "number",
                      "default": 2
                    },
                    "layoutParams_navigationArrows_padding": {
                      "type": "number",
                      "default": 23
                    },
                    "behaviourParams_gallery_vertical_loadMore_amount": {
                      "type": "string",
                      "default": "ALL"
                    },
                    "behaviourParams_gallery_horizontal_autoSlide_behaviour": {
                      "type": "string",
                      "default": "OFF"
                    },
                    "behaviourParams_gallery_horizontal_slideTransition": {
                      "type": "string",
                      "default": "cubic-bezier(0.46,0.1,0.25,1)"
                    },
                    "controllers_layoutParams_external_info_placement": {
                      "type": "string",
                      "default": "BELOW"
                    },
                    "controllers_layoutParams_external_info_CustomButtonHorizontalAlignment": {
                      "type": "string",
                      "default": "CENTER"
                    },
                    "controllers_layoutParams_internal_info_CustomButtonHorizontalAlignment": {
                      "type": "string",
                      "default": "CENTER"
                    },
                    "controllers_layoutParams_internal_info_CustomButtonCustomButtonText": {
                      "type": "string",
                      "default": "Click here"
                    },
                    "controllers_layoutParams_external_info_CustomButtonCustomButtonText": {
                      "type": "string",
                      "default": "Click here"
                    },
                    "controllers_layoutParams_external_info_SocialButtonsHorizontalAlignment": {
                      "type": "string",
                      "default": "LEFT"
                    },
                    "controllers_layoutParams_internal_info_SocialButtonsHorizontalAlignment": {
                      "type": "string",
                      "default": "LEFT"
                    },
                    "layoutParams_info_placement": {
                      "type": "string",
                      "default": "OVERLAY"
                    },
                    "controllers_layoutParams_info_allowTitle": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_layoutParams_info_allowDescription": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_layoutParams_info_verticalPadding": {
                      "type": "number",
                      "default": 0
                    },
                    "controllers_layoutParams_info_horizontalPadding": {
                      "type": "number",
                      "default": 0
                    },
                    "controllers_layoutParams_infoElementOptions_external_enabled": {
                      "type": "string",
                      "default": ""
                    },
                    "controllers_layoutParams_infoElementOptions_internal_enabled": {
                      "type": "string",
                      "default": ""
                    },
                    "controllers_experimental_useNewInfo": {
                      "type": "string",
                      "default": ""
                    },
                    "controllers_layoutParams_infoElementOptions_external_order": {
                      "type": "string",
                      "default": "top,Title,Description,CustomButton,middle,bottom,Social"
                    },
                    "controllers_layoutParams_infoElementOptions_internal_order": {
                      "type": "string",
                      "default": "top,Title,Description,CustomButton,middle,bottom,Social"
                    },
                    "controllers_layoutParams_info_verticalAlignment": {
                      "type": "string",
                      "default": "CENTER"
                    },
                    "controllers_layoutParams_info_horizontalAlignment": {
                      "type": "string",
                      "default": "CENTER"
                    },
                    "controllers_layoutParams_structure_imageWidth_method": {
                      "type": "string",
                      "default": "FIXED"
                    },
                    "controllers_layoutParams_structure_numberOfDisplayedItems": {
                      "type": "number",
                      "default": 3
                    },
                    "layoutParams_info_sizeUnits": {
                      "type": "string",
                      "default": "PIXEL"
                    },
                    "layoutParams_info_height": {
                      "type": "number",
                      "default": 200
                    },
                    "controllers_layoutParams_info_width_pixel": {
                      "type": "number",
                      "default": 200
                    },
                    "controllers_layoutParams_info_width_percent": {
                      "type": "number",
                      "default": 50
                    },
                    "behaviourParams_item_overlay_hoveringBehaviour": {
                      "type": "string",
                      "default": "NEVER_SHOW"
                    },
                    "controllers_behaviourParams_item_overlay_overlayType": {
                      "type": "string",
                      "default": "FULL"
                    },
                    "behaviourParams_item_overlay_sizeUnits": {
                      "type": "string",
                      "default": "PERCENT"
                    },
                    "controllers_behaviourParams_item_overlay_size_percent": {
                      "type": "number",
                      "default": 100
                    },
                    "controllers_behaviourParams_item_overlay_size_pixel": {
                      "type": "number",
                      "default": 100
                    },
                    "behaviourParams_item_overlay_position": {
                      "type": "string",
                      "default": "BOTTOM"
                    },
                    "behaviourParams_item_overlay_padding": {
                      "type": "number",
                      "default": 0
                    },
                    "behaviourParams_item_secondaryMedia_enableHoverTrigger": {
                      "type": "boolean",
                      "default": false
                    },
                    "behaviourParams_item_overlay_hoverAnimation": {
                      "type": "string",
                      "default": "NO_EFFECT"
                    },
                    "controllers_layoutParams_structure_galleryRatio_method": {
                      "type": "string",
                      "default": "MANUAL"
                    },
                    "controllers_layoutParams_structure_galleryRatio_value": {
                      "type": "number",
                      "default": 1
                    },
                    "controllers_fullscreen_allowTitleExpand": {
                      "type": "boolean",
                      "default": true
                    },
                    "controllers_behaviourParams_item_overlay_enabled": {
                      "type": "boolean",
                      "default": true
                    },
                    "controllers_layoutParams_info_newInfo_external_enabled": {
                      "type": "boolean",
                      "default": true
                    },
                    "controllers_fullscreen_allowDescriptionExpand": {
                      "type": "boolean",
                      "default": true
                    },
                    "controllers_fullscreen_allowLinkExpand": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_fullscreen_expandInfoPosition": {
                      "type": "string",
                      "default": "SIDE"
                    },
                    "controllers_fullscreen_showInfoExpandButton": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_fullscreen_whenToShowInfo": {
                      "type": "string",
                      "default": "ALWAYS"
                    },
                    "controllers_fullscreen_allowFullscreenExpand": {
                      "type": "boolean",
                      "default": true
                    },
                    "controllers_fullscreen_fullscreenLoop": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_fullscreen_allowFullscreenMagnifyImage": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_fullscreen_fullscreenMagnificationLevel": {
                      "type": "number",
                      "default": 2
                    },
                    "controllers_fullscreen_fullscreenMagnificationPercent": {
                      "type": "number",
                      "default": 200
                    },
                    "controllers_fullscreen_backgroundBlurFilter": {
                      "type": "number",
                      "default": 1
                    },
                    "controllers_fullscreen_backgroundGrayscaleFilter": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_showManageMedia": {
                      "type": "boolean",
                      "default": false
                    },
                    "variant_count": {
                      "type": "number",
                      "default": 0
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ProgressBarProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ],
                  "default": "ltr"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RangeSliderProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "align": {
                  "type": "string",
                  "enum": [
                    "start",
                    "center",
                    "end"
                  ],
                  "description": "Alignment of range slider"
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RatingsDisplayProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showReviewsCount": {
                  "type": "boolean",
                  "default": true
                },
                "showRating": {
                  "type": "boolean",
                  "default": true
                },
                "noReviewsMode": {
                  "type": "string",
                  "enum": [
                    "nothing",
                    "emptyIcons",
                    "placeholderText"
                  ],
                  "default": "emptyIcons"
                },
                "ratingPosition": {
                  "type": "string",
                  "enum": [
                    "before",
                    "after"
                  ],
                  "default": "before"
                },
                "shapeSize": {
                  "type": "number",
                  "minimum": 15,
                  "maximum": 100,
                  "default": 24
                },
                "shapeSpacing": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 50,
                  "default": 5
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "default": "left"
                },
                "direction": {
                  "type": "string",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "default": "ltr"
                },
                "renderSeo": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RatingsInputProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showTitle": {
                  "type": "boolean",
                  "default": true
                },
                "showLabels": {
                  "type": "boolean",
                  "default": true
                },
                "labelPosition": {
                  "type": "string",
                  "enum": [
                    "top",
                    "bottom",
                    "side"
                  ],
                  "default": "top"
                },
                "a11yLabelPosition": {
                  "type": "string",
                  "enum": [
                    "top",
                    "bottom",
                    "side"
                  ],
                  "default": "side"
                },
                "labelAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "center"
                },
                "a11yLabelAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "center"
                },
                "shapeSize": {
                  "type": "number",
                  "minimum": 15,
                  "maximum": 100,
                  "default": 24
                },
                "shapeSpacing": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 50,
                  "default": 5
                },
                "direction": {
                  "type": "string",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "default": "ltr"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RichTextBoxProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "textAlignment": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "description": "the text alignment",
                  "maxLength": 100
                },
                "textPadding": {
                  "type": "number",
                  "default": 18,
                  "minimum": 0,
                  "maximum": 100,
                  "description": "the value of the textPadding"
                },
                "toolbarPosition": {
                  "type": "string",
                  "default": "top",
                  "enum": [
                    "top",
                    "bottom",
                    "inline"
                  ],
                  "description": "the location of the toolbar",
                  "maxLength": 20
                },
                "placeholder": {
                  "type": "string",
                  "description": "the placeholder",
                  "default": "",
                  "maxLength": 4000
                },
                "defaultTextType": {
                  "type": "string",
                  "default": "placeholderText",
                  "enum": [
                    "none",
                    "initialText",
                    "placeholderText",
                    "placeholderAndInitialText"
                  ],
                  "description": "the type of the default text for the input",
                  "maxLength": 100
                },
                "allowLinks": {
                  "type": "boolean",
                  "description": "Are links allowed"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SearchBoxProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "layout": {
                  "type": "string",
                  "enum": [
                    "icon",
                    "button",
                    "icon-only",
                    "expandable"
                  ],
                  "default": "icon"
                },
                "iconAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left"
                },
                "textAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center"
                  ],
                  "default": "left"
                },
                "textSpacing": {
                  "type": "number",
                  "default": 12,
                  "description": "Setting the spacing from the side the text is aligned to",
                  "minimum": 0,
                  "maximum": 50
                },
                "iconSpacing": {
                  "type": "number",
                  "default": 12,
                  "description": "In icon layout affects the side to which the icon is aligend to, for button layout affects both - left and right sides",
                  "minimum": 0,
                  "maximum": 50
                },
                "trendingItemsEnabled": {
                  "type": "boolean",
                  "default": true,
                  "description": "Controls trending items visibility."
                },
                "isExpandable": {
                  "type": "boolean",
                  "default": false,
                  "description": "Is component able to expand/collapse"
                },
                "expandedDirection": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left",
                  "description": "Which direction the component should expand to"
                },
                "expandedWidth": {
                  "type": "number",
                  "default": 100,
                  "description": "What's the expanded component width",
                  "minimum": 0,
                  "maximum": 1000
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SearchButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/StylableButtonProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SelectionTagsListProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ],
                  "default": "ltr",
                  "description": "Direction of tags"
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left",
                  "description": "Alignment of tags"
                },
                "hasAutoHeight": {
                  "type": "boolean",
                  "description": "used in mapper to avoid adding min-height property"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SignatureInputProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ]
                },
                "required": {
                  "type": "boolean"
                },
                "titlePaddingStart": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "titleMarginBottom": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "labelMobileFontSize": {
                  "type": "number"
                },
                "inputMobileFontSize": {
                  "type": "number"
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SingleTabProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isParentFullWidth": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SliderProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "trackSize": {
                  "type": "number",
                  "default": 25
                },
                "orientation": {
                  "type": "string",
                  "enum": [
                    "horizontal",
                    "vertical"
                  ],
                  "default": "horizontal"
                },
                "thumbShape": {
                  "type": "string",
                  "enum": [
                    "circle",
                    "square",
                    "rectangle",
                    "bar"
                  ],
                  "default": "circle"
                },
                "thumbSize": {
                  "type": "number",
                  "minimum": 18,
                  "maximum": 100,
                  "description": "Size of the slider thumb"
                },
                "tickMarksShape": {
                  "type": "string",
                  "enum": [
                    "none",
                    "line",
                    "dot"
                  ],
                  "default": "line"
                },
                "tooltipVisibility": {
                  "type": "string",
                  "enum": [
                    "none",
                    "hover",
                    "always"
                  ],
                  "default": "hover"
                },
                "tooltipPosition": {
                  "type": "string",
                  "enum": [
                    "normal",
                    "across"
                  ],
                  "default": "normal"
                },
                "tooltipPrefix": {
                  "type": "string",
                  "maxLength": 30
                },
                "tooltipSuffix": {
                  "type": "string",
                  "maxLength": 30
                },
                "tickMarksPosition": {
                  "type": "string",
                  "enum": [
                    "normal",
                    "middle",
                    "across"
                  ],
                  "default": "normal"
                },
                "dir": {
                  "type": "string",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "default": "ltr"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SlideshowProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "required": [
            "isHidden",
            "isCollapsed"
          ],
          "type": "object",
          "properties": {
            "isHidden": {
              "type": "boolean"
            },
            "isCollapsed": {
              "type": "boolean"
            },
            "type": {
              "default": "SlideshowProperties",
              "maxLength": 120,
              "type": "string"
            },
            "isPlaying": {
              "default": true,
              "type": "boolean"
            },
            "slideDuration": {
              "default": 5,
              "minimum": 1,
              "maximum": 30,
              "type": "number"
            },
            "pauseOnHover": {
              "default": true,
              "type": "boolean"
            },
            "showPlaybackControl": {
              "default": false,
              "type": "boolean"
            },
            "loop": {
              "default": true,
              "type": "boolean"
            },
            "previewItemId": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SlideshowButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "action": {
                  "type": "string",
                  "enum": [
                    "prev",
                    "next"
                  ],
                  "default": "next"
                }
              }
            },
            {
              "$ref": "#/StylableButtonProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SocialAuthProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "isSmallIcons": {
                  "type": "boolean",
                  "default": true
                },
                "isSocialLoginGoogleEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "isSocialLoginFacebookEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "mode": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "enum": [
                    "signup",
                    "login"
                  ]
                },
                "formType": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "enum": [
                    "default",
                    "custom",
                    "corvid"
                  ],
                  "default": "corvid"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StylableButtonProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "iconCollapsed": {
                  "type": "boolean",
                  "default": false
                },
                "isMaxContent": {
                  "type": "boolean",
                  "default": false
                },
                "isWrapText": {
                  "type": "boolean",
                  "default": false
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StylableHorizontalMenuProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "menuMode": {
                  "type": "string",
                  "enum": [
                    "wrap",
                    "scroll"
                  ],
                  "default": "wrap"
                },
                "submenuMode": {
                  "type": "string",
                  "enum": [
                    "columnMenu",
                    "columnStretched",
                    "flyout"
                  ],
                  "description": "Submenu view modes",
                  "default": "columnMenu"
                },
                "slotMap": {
                  "type": "object",
                  "unevaluatedProperties": false
                },
                "isContainerStretched": {
                  "type": "boolean",
                  "default": true
                },
                "submenuOrder": {
                  "type": "string",
                  "enum": [
                    "vertical",
                    "horizontal"
                  ],
                  "description": "Submenu items order",
                  "default": "vertical"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TabsProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "itemSpacing": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 0
                },
                "itemRowSpacing": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 0
                },
                "containerSpacing": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 0
                },
                "tabWidth": {
                  "type": "number",
                  "minimum": 10,
                  "maximum": 500
                },
                "stretchTabsToMenuWidth": {
                  "type": "boolean",
                  "default": false
                },
                "fitTabsToTextWidth": {
                  "type": "boolean",
                  "default": false
                },
                "itemsOrientation": {
                  "type": "string",
                  "enum": [
                    "horizontal",
                    "vertical"
                  ],
                  "default": "horizontal"
                },
                "itemsAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left"
                },
                "contentAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left"
                },
                "itemsLogicalAlign": {
                  "type": "string",
                  "enum": [
                    "start",
                    "center",
                    "end"
                  ],
                  "default": "start"
                },
                "contentLogicalAlign": {
                  "type": "string",
                  "enum": [
                    "start",
                    "center",
                    "end"
                  ],
                  "default": "start"
                },
                "horizontalTabPadding": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 20
                },
                "verticalTabPadding": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 20
                },
                "menuMode": {
                  "type": "string",
                  "enum": [
                    "wrap",
                    "scroll"
                  ],
                  "default": "scroll"
                },
                "itemsDirection": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ],
                  "default": "ltr"
                },
                "tabEnterAnimationName": {
                  "type": "string",
                  "enum": [
                    "none",
                    "fadeIn",
                    "floatFromTop",
                    "floatFromBottom"
                  ],
                  "default": "none",
                  "description": "The animation that will be played when a tab is entered"
                },
                "tabExitAnimationName": {
                  "type": "string",
                  "enum": [
                    "none",
                    "fadeOut"
                  ],
                  "default": "none",
                  "description": "The animation that will be played when a tab is exited"
                },
                "animationDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 0.3,
                  "description": "Duration of the transition in sec"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TimePickerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left"
                },
                "useAmPmFormat": {
                  "type": "boolean",
                  "default": false,
                  "description": "Should the display format be 12 hours (or 24)"
                },
                "controller": {
                  "type": "string",
                  "enum": [
                    "text",
                    "stepper",
                    "dropdown"
                  ],
                  "default": "text",
                  "description": "The display of the time picker"
                },
                "initialTime": {
                  "type": "string",
                  "enum": [
                    "none",
                    "current",
                    "value",
                    "placeholder"
                  ],
                  "default": "current",
                  "description": "What the time picker should display on load"
                },
                "margin": {
                  "type": "number",
                  "multipleOf": 1,
                  "description": ""
                },
                "disabledTimes": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "required": [
                      "startTime",
                      "endTime"
                    ],
                    "properties": {
                      "startTime": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "endTime": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  },
                  "default": [],
                  "maxItems": 5,
                  "description": "array of disabled times"
                },
                "enabledTimes": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "required": [
                      "startTime",
                      "endTime"
                    ],
                    "properties": {
                      "startTime": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "endTime": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  },
                  "default": [],
                  "maxItems": 5,
                  "description": "array of enabled times"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ToggleSwitchProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "displayKnobIcons": {
                  "type": "boolean"
                },
                "trackHeight": {
                  "type": "number",
                  "default": 100
                },
                "knobSize": {
                  "type": "number",
                  "default": 90
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left"
                },
                "switchHeight": {
                  "type": "number",
                  "default": 24
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VideoPlayerProperties": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showVideoTitle": {
                  "type": "boolean",
                  "default": true
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": "Autoplay video"
                },
                "loop": {
                  "type": "boolean",
                  "default": false,
                  "description": "Play video on loop"
                },
                "share": {
                  "type": "boolean",
                  "default": true,
                  "description": "Allow to share video"
                },
                "controlsVisibility": {
                  "type": "string",
                  "enum": [
                    "hover",
                    "never"
                  ],
                  "default": "hover"
                },
                "animatePoster": {
                  "type": "string",
                  "enum": [
                    "fade",
                    "none"
                  ],
                  "default": "none",
                  "description": "Animate video poster"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontsEnum--unrestricted-root": {
      "langsKey": "System.font",
      "type": "string",
      "default": "arial",
      "enum": [
        "lucidaSansConsole",
        "palatinoLinotype",
        "americantypwrteritcw01--731025",
        "anton",
        "arial",
        "arialBlack",
        "avenida-w01",
        "basic",
        "caudex",
        "clarendon-w01-medium-692107",
        "comicSansMS",
        "cookie",
        "coquette-w00-light",
        "courierNew",
        "din-next-w01-light",
        "droid-serif-w01-regular",
        "eb garamond",
        "enriqueta",
        "forum",
        "georgia",
        "helvetica-w01-roman",
        "helvetica-w01-bold",
        "helvetica-w01-light",
        "impact",
        "jockey one",
        "jura",
        "kelly slab",
        "lobster",
        "lucidaConsole",
        "marck script",
        "monoton",
        "noticia text",
        "open sans",
        "open sans condensed",
        "palatino linotype",
        "patrick hand",
        "play",
        "reklamescriptw00-medium",
        "sacramento",
        "sarina",
        "signika",
        "soho-w01-thin-condensed",
        "tahoma",
        "timesNewRoman",
        "verdana",
        "bodoni-w01-poster",
        "ｍｓ ゴシック",
        "ｍｓ 明朝",
        "ｍｓ ｐゴシック",
        "ｍｓ ｐ明朝",
        "meiryo",
        "メイリオ",
        "bm-hanna",
        "돋움",
        "fbbluegothicl",
        "fbchamblue",
        "fbgreen",
        "fbneogothic",
        "fbplum",
        "굴림",
        "맑은 고딕",
        "nanumgothic-regular",
        "ahmedltw20-outlineregul",
        "amiri",
        "arabictypesettingw23-re",
        "arian-lt-w20-regular",
        "arian-lt-w20-light",
        "coheadlinew23-arabicbol",
        "dinnextltw23-ultralight",
        "droid-naskh",
        "janna-lt-w20-regular",
        "kufi-lt-w20-regular",
        "midan-w20",
        "helveticaneueltw20-ligh",
        "tanseekmodernw20-light",
        "adler-w26-regular",
        "alef-regular",
        "almoni-dl-aaa-700",
        "almoni-dl-aaa-300",
        "almoni-dl-aaa-400",
        "asimon-aaa-400",
        "atlas-aaa-500",
        "chips-w26-normal",
        "frank-ruhl-w26-regular",
        "gulash-w26-regular",
        "haim-arukeem-w26-medium",
        "miriam-w26-medium",
        "mixtape-aaa-400",
        "museum-aaa-400",
        "nekudot-w26-bold",
        "omes-aaa-400",
        "opensanshebrewcondensed-regular",
        "shabazi-w26-bold",
        "amatic sc",
        "braggadocio-w01",
        "chelsea market",
        "corben",
        "fredericka the great",
        "geotica-w01-four-open",
        "helvetica neue",
        "helvetica neue italic",
        "helvetica neue medium",
        "helvetica neue thin",
        "itc-arecibo-w01-regular",
        "josefin slab",
        "lucida sans unicode",
        "marzo-w00-regular",
        "mr de haviland",
        "museo-w01-700",
        "museo-slab-w01-100",
        "niconne",
        "nimbus-sans-tw01con",
        "overlock",
        "pacifica-w00-condensed",
        "raleway",
        "rosewood-w01-regular",
        "snellroundhandw01-scrip",
        "spinnaker",
        "stencil-w01-bold"
      ]
    },
    "DefaultProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isHidden": {
              "type": "boolean",
              "description": "sets visibility:hidden to the component style node"
            },
            "isCollapsed": {
              "type": "boolean",
              "description": "sets isCollapsed for component"
            },
            "ghost": {
              "type": "string",
              "enum": [
                "COLLAPSED"
              ],
              "description": "sets collapsed to hidden ref component"
            },
            "fontScale": {
              "type": "number"
            },
            "deleted": {
              "type": "boolean",
              "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
            }
          }
        }
      ],
      "type": "object"
    },
    "FlipProperties--unrestricted-root": {
      "type": "object",
      "properties": {
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "horizontal",
            "vertical",
            "both",
            "none"
          ],
          "default": "none",
          "description": "Defines a flip axis for the content"
        }
      }
    },
    "VideoBackgroundProperties--unrestricted-root": {
      "type": "object",
      "properties": {
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      }
    },
    "CardsLayoutProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right",
                    "justify"
                  ],
                  "default": "left"
                },
                "gap": {
                  "type": "object",
                  "default": {},
                  "properties": {
                    "vertical": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 100,
                      "default": 0,
                      "description": "sets the vertical gap (in px) between items of a repeater"
                    },
                    "horizontal": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 100,
                      "default": 0,
                      "description": "sets the horizontal gap (in px) between items of a repeater"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "direction": {
                  "enum": [
                    "rtl",
                    "ltr"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "VerticalLayoutProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "gap": {
                  "type": "number",
                  "default": 10,
                  "description": "sets the gap (in px) between items of a vertical repeater"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "DisableableProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "isDisabled": {
                  "type": "boolean",
                  "description": "disables the component"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ClassicSectionProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "mediaBackgroundPadding": {
                  "type": [
                    "object",
                    "null"
                  ],
                  "maxProperties": 1,
                  "properties": {
                    "top": {
                      "type": [
                        "number",
                        "null"
                      ],
                      "minimum": 0,
                      "description": "value of the mediaBackgroundPadding"
                    },
                    "bottom": {
                      "type": [
                        "number",
                        "null"
                      ],
                      "minimum": 0,
                      "description": "value of the mediaBackgroundPadding"
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "StripColumnsContainerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "columnsMargin": {
                  "type": "number",
                  "default": 15
                },
                "frameMargin": {
                  "type": "number",
                  "default": 15
                },
                "fullWidth": {
                  "type": "boolean",
                  "default": true
                },
                "fullHeight": {
                  "type": "boolean",
                  "default": false
                },
                "rowMargin": {
                  "type": "number",
                  "default": 15
                },
                "siteMargin": {
                  "type": "number",
                  "default": 30
                },
                "horizontalPaddingOnMobile": {
                  "type": "number"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ColumnProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "background": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                },
                "alignment": {
                  "type": "number",
                  "default": 50,
                  "minimum": 0,
                  "maximum": 100,
                  "description": "The alignment of the content relative to the whole column, represented as percentage (e.g. 0 for left, 50 for center and 100 for right)"
                },
                "mediaBackgroundPadding": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "object",
                      "maxProperties": 1,
                      "properties": {
                        "top": {
                          "oneOf": [
                            {
                              "type": "null"
                            },
                            {
                              "type": "number",
                              "default": 18,
                              "minimum": 0,
                              "description": "value of the mediaBackgroundPadding"
                            }
                          ]
                        },
                        "bottom": {
                          "oneOf": [
                            {
                              "type": "null"
                            },
                            {
                              "type": "number",
                              "default": 18,
                              "minimum": 0,
                              "description": "value of the mediaBackgroundPadding"
                            }
                          ]
                        }
                      }
                    }
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "InputProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "label": {
                  "type": "string",
                  "description": "input label"
                },
                "required": {
                  "type": "boolean",
                  "description": "is the input field required to have a value"
                },
                "autoFocus": {
                  "type": "boolean",
                  "description": "should the field be focused when loading the page"
                },
                "readOnly": {
                  "type": "boolean",
                  "description": "is the field readonly"
                },
                "tabIndex": {
                  "type": "number",
                  "description": "the tab index in the form"
                },
                "inputHeight": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "Height of input",
                  "minimum": 25
                },
                "inputHeightMobile": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "Height of input",
                  "minimum": 25
                },
                "labelMargin": {
                  "type": "number",
                  "default": 14,
                  "description": "Margin between label to input",
                  "minimum": 0,
                  "maximum": 100
                },
                "labelPadding": {
                  "type": "number",
                  "default": 0,
                  "description": "Padding of label",
                  "minimum": 0,
                  "maximum": 100
                },
                "labelMobileFontSize": {
                  "type": "number"
                },
                "inputMobileFontSize": {
                  "type": "number"
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "InputElementsErrorProperties--unrestricted-root": {
      "type": "object",
      "properties": {
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      }
    },
    "QuickActionBarProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "colorScheme": {
                  "type": "string",
                  "enum": [
                    "black",
                    "grey",
                    "brand"
                  ],
                  "default": "brand"
                },
                "invertColors": {
                  "type": "boolean",
                  "default": true
                },
                "hideText": {
                  "type": "boolean",
                  "default": true
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "right",
                    "left"
                  ],
                  "default": "right"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "PhotoProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageSize": {
                  "type": "string",
                  "enum": [
                    "small",
                    "medium",
                    "large"
                  ],
                  "default": "medium",
                  "description": "size of the image in runtime"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "FacebookLikeBoxProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transparentBg": {
                  "type": "boolean",
                  "default": false,
                  "description": "Sets a transparent background for the like box"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ImageButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "none",
                    "fade"
                  ],
                  "default": "fade"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "MultiSelectionProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "placeholder": {
                  "type": "string",
                  "default": "Enter text here...",
                  "description": "The placeholder for the input skinpart",
                  "maxLength": 4000
                },
                "newItemText": {
                  "type": "string",
                  "default": "(New)",
                  "description": "The text that will appear on a new item in the dropdown"
                },
                "selectionOnly": {
                  "type": "boolean",
                  "default": false,
                  "description": "Restricts component to selection only"
                },
                "maxTextLength": {
                  "type": "number",
                  "default": 30,
                  "description": "The max text length for the input skinpart"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "MultiSelectionItemProperties--unrestricted-root": {
      "$ref": "#/DefaultProperties"
    },
    "NumericStepperProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "minValue": {
                  "type": "number",
                  "default": 0,
                  "description": "Min value for input"
                },
                "maxValue": {
                  "type": "number",
                  "default": 999,
                  "description": "Max value for input"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "PinterestPinItProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "size": {
                  "type": "string",
                  "enum": [
                    "small",
                    "large"
                  ],
                  "default": "small"
                },
                "color": {
                  "type": "string",
                  "enum": [
                    "gray",
                    "red",
                    "white"
                  ],
                  "default": "gray"
                },
                "counterPosition": {
                  "type": "string",
                  "enum": [
                    "none",
                    "above",
                    "beside"
                  ],
                  "default": "none"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SingleAudioPlayerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "volume": {
                  "type": "number",
                  "default": 50,
                  "description": "Volume"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": "Autoplay MP3"
                },
                "loop": {
                  "type": "boolean",
                  "default": false,
                  "description": "Loop MP3"
                },
                "showArtist": {
                  "type": "boolean",
                  "default": true,
                  "description": "Display Artist"
                },
                "showTrack": {
                  "type": "boolean",
                  "default": true,
                  "description": "Display Track"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SkypeCallButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageSize": {
                  "type": "string",
                  "enum": [
                    "small",
                    "medium",
                    "large"
                  ],
                  "default": "medium"
                },
                "imageColor": {
                  "type": "string",
                  "enum": [
                    "blue",
                    "white"
                  ],
                  "default": "blue"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SpotifyFollowProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "size": {
                  "type": "string",
                  "enum": [
                    "small",
                    "large"
                  ],
                  "default": "large"
                },
                "theme": {
                  "type": "string",
                  "enum": [
                    "light",
                    "dark"
                  ],
                  "default": "light"
                },
                "showFollowersCount": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SpotifyPlayerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "size": {
                  "type": "string",
                  "enum": [
                    "compact",
                    "large"
                  ],
                  "default": "compact",
                  "description": "Size of the player"
                },
                "color": {
                  "type": "string",
                  "enum": [
                    "black",
                    "white"
                  ],
                  "default": "black",
                  "description": "Theme of the player"
                },
                "style": {
                  "type": "string",
                  "enum": [
                    "list",
                    "coverart"
                  ],
                  "default": "list",
                  "description": "Style of the player"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SubscribeFormProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "hiddenFirstNameField": {
                  "type": "boolean",
                  "default": false
                },
                "hiddenLastNameField": {
                  "type": "boolean",
                  "default": false
                },
                "hiddenEmailField": {
                  "type": "boolean",
                  "default": true
                },
                "hiddenPhoneField": {
                  "type": "boolean",
                  "default": false
                },
                "requiredFirstNameField": {
                  "type": "boolean",
                  "default": false
                },
                "requiredLastNameField": {
                  "type": "boolean",
                  "default": false
                },
                "requiredEmailField": {
                  "type": "boolean",
                  "default": true
                },
                "requiredPhoneField": {
                  "type": "boolean",
                  "default": false
                },
                "useCookie": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "VerticalMenuProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "itemsAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the menu items"
                },
                "subMenuOpenSide": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "right",
                  "description": "Opening direction of sub-menus"
                },
                "originalHeight": {
                  "type": "number",
                  "description": "Used to determine if comp was saved with correct height (if value not empty), or height needs to be fixed in DataFixer (if value is empty)"
                },
                "menuItemHeight": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number"
                    }
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "YouTubeSubscribeButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "layout": {
                  "type": "string",
                  "enum": [
                    "default",
                    "full"
                  ],
                  "default": "full",
                  "description": "the layout of the youtube subscribe button"
                },
                "theme": {
                  "type": "string",
                  "enum": [
                    "light",
                    "dark"
                  ],
                  "default": "light",
                  "description": "the theme of the youtube subscribe button"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "BgImageStripProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "bgUrl": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "default": "",
                  "description": "Set image background"
                },
                "bgSize": {
                  "type": "string",
                  "enum": [
                    "auto",
                    "cover",
                    "contain"
                  ],
                  "default": "auto",
                  "description": "Set background mode"
                },
                "bgRepeat": {
                  "type": "string",
                  "enum": [
                    "no-repeat",
                    "repeat-x",
                    "repeat-y",
                    "repeat"
                  ],
                  "default": "repeat",
                  "description": "Set background tile direction"
                },
                "bgPosition": {
                  "type": "string",
                  "enum": [
                    "top left",
                    "top center",
                    "top right",
                    "center left",
                    "center",
                    "center right",
                    "bottom left",
                    "bottom center",
                    "bottom right"
                  ],
                  "default": "center",
                  "description": "Set background position"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "BgImageStripUnifiedProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "fittingType": {
                  "type": "string",
                  "enum": [
                    "fill",
                    "fit",
                    "actual_size",
                    "tile",
                    "fit_and_tile",
                    "tile_horizontal",
                    "tile_vertical",
                    "legacy_strip_tile",
                    "legacy_strip_tile_horizontal",
                    "legacy_strip_tile_vertical",
                    "legacy_strip_original_size",
                    "legacy_strip_fill",
                    "legacy_strip_fit",
                    "legacy_strip_fit_and_tile"
                  ],
                  "default": "fill",
                  "description": "Set image fitting type"
                },
                "alignType": {
                  "type": "string",
                  "enum": [
                    "top_left",
                    "top",
                    "top_right",
                    "left",
                    "center",
                    "right",
                    "bottom_left",
                    "bottom",
                    "bottom_right"
                  ],
                  "default": "center",
                  "description": "Set image alignment"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "FileUploaderProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "buttonAlignment": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ],
                  "default": "ltr",
                  "description": "alignment of the label to the button"
                },
                "filesAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the file name to the component"
                },
                "showPlaceholder": {
                  "type": "boolean",
                  "default": true,
                  "description": "should show placeholder"
                },
                "filesType": {
                  "type": "string",
                  "enum": [
                    "Image",
                    "Document",
                    "Video",
                    "Audio",
                    "Archive",
                    "Gallery"
                  ],
                  "default": "Image",
                  "description": "the file type allowed for upload by the component"
                },
                "filesSizeLimit": {
                  "type": "number",
                  "default": 15,
                  "minimum": 1,
                  "maximum": 15,
                  "description": "the maximum file size allowed to upload by the component"
                },
                "numFilesLimit": {
                  "type": "number",
                  "default": 1,
                  "minimum": 1,
                  "maximum": 50,
                  "description": "the maximum number of files allowed to be uploaded by the component"
                },
                "showFileName": {
                  "type": "boolean"
                },
                "textBelowButtonMobileFontSize": {
                  "type": "number"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "UploadNameProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "$ref": "#/DefaultProperties--unrestricted-root"
        }
      ],
      "type": "object"
    },
    "ButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "align": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "center",
                  "description": "alignment of the menu"
                },
                "margin": {
                  "type": "number",
                  "default": 0,
                  "description": "text left and right margins"
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "LoginSocialBarProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "buttonsDirection": {
                  "type": "string",
                  "default": "ltr",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "description": "alignment of the buttons"
                },
                "iconSize": {
                  "type": "number",
                  "default": 26,
                  "description": "size of the buttons' icons"
                },
                "loggedOutIconSize": {
                  "type": "number",
                  "description": "size of the loggedOut buttons' icons"
                },
                "dropDownTextAlignment": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "description": "alignment of the text in the dropdown menu"
                },
                "buttonsAlignment": {
                  "type": "string",
                  "default": "right",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "description": "alignment of the bar of the component itself"
                },
                "arrowShape": {
                  "type": "string",
                  "default": "line",
                  "enum": [
                    "none",
                    "line",
                    "full"
                  ],
                  "description": "arrow shape of login bar"
                },
                "arrowSize": {
                  "type": "number",
                  "default": 14,
                  "description": "arrow size of login bar"
                },
                "showBellIcon": {
                  "type": "boolean",
                  "default": true,
                  "description": "should show bell icon"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ComboBoxInputProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "textAlignment": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string",
                      "default": "center",
                      "enum": [
                        "left",
                        "right",
                        "center"
                      ],
                      "description": "the direction of the text",
                      "maxLength": 100
                    }
                  ]
                },
                "textPadding": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number",
                      "default": 18,
                      "minimum": 0,
                      "maximum": 100,
                      "description": "the value of the textPadding"
                    }
                  ]
                },
                "placeholder": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "object",
                      "properties": {
                        "value": {
                          "type": "string",
                          "default": "-1",
                          "description": "the value of the placeholder option",
                          "maxLength": 400
                        },
                        "text": {
                          "type": "string",
                          "default": "",
                          "description": "the text of the placeholder option",
                          "maxLength": 400
                        }
                      }
                    }
                  ],
                  "description": "the placeholder option in case nothing is selected"
                },
                "size": {
                  "type": [
                    "null",
                    "number"
                  ],
                  "description": "Amount of options to display"
                },
                "designableList": {
                  "type": "boolean",
                  "default": true,
                  "description": "is the list designable"
                },
                "dropdownItemsSpacing": {
                  "type": "number",
                  "default": 16,
                  "minimum": 0,
                  "maximum": 100,
                  "description": "the value of the dropdownItemsSpacing"
                },
                "autocomplete": {
                  "type": "boolean",
                  "description": "is the autocomplete enabled"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            },
            {
              "$ref": "#/InputElementsErrorProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RadioButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RadioGroupProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the text"
                },
                "layout": {
                  "type": "string",
                  "enum": [
                    "vertical",
                    "horizontal"
                  ],
                  "default": "vertical",
                  "description": "the layout of the radio buttons child components"
                },
                "buttonsMargin": {
                  "type": "number",
                  "default": 24,
                  "description": "Margin between each button item",
                  "minimum": 0,
                  "maximum": 100
                },
                "spacing": {
                  "type": "number",
                  "default": 12,
                  "description": "Spacing between radio icon and text",
                  "minimum": 0,
                  "maximum": 100
                },
                "buttonSize": {
                  "type": "number",
                  "default": 18,
                  "description": "radio button size size",
                  "minimum": 6,
                  "maximum": 100
                },
                "labelMargin": {
                  "type": "number",
                  "default": 24,
                  "description": "Margin between label to buttons",
                  "minimum": 0,
                  "maximum": 100
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            },
            {
              "$ref": "#/InputElementsErrorProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "CheckboxGroupProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the text"
                },
                "layout": {
                  "type": "string",
                  "enum": [
                    "vertical",
                    "horizontal"
                  ],
                  "default": "vertical",
                  "description": "the layout of the checkboxes components"
                },
                "buttonsMargin": {
                  "type": "number",
                  "default": 24,
                  "description": "Margin between each button item",
                  "minimum": 0,
                  "maximum": 100
                },
                "spacing": {
                  "type": "number",
                  "default": 12,
                  "description": "Spacing between checkbox and text",
                  "minimum": 0,
                  "maximum": 100
                },
                "buttonSize": {
                  "type": "number",
                  "default": 18,
                  "description": "checkbox size",
                  "minimum": 6,
                  "maximum": 100
                },
                "labelMargin": {
                  "type": "number",
                  "default": 24,
                  "description": "Margin between label to checkbox",
                  "minimum": 0,
                  "maximum": 100
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            },
            {
              "$ref": "#/InputElementsErrorProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ContactFormProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "hidden_emailFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "hidden_nameFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "hidden_phoneFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "hidden_addressFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "hidden_subjectFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "hidden_messageFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "required_emailFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "required_nameFieldLabel": {
                  "type": "boolean",
                  "default": true
                },
                "required_phoneFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "required_addressFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "required_subjectFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "required_messageFieldLabel": {
                  "type": "boolean",
                  "default": false
                },
                "useCookie": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "DocumentMediaProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showTitle": {
                  "type": "boolean",
                  "default": true,
                  "description": "Toggle Document Title Display"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "EbayItemsBySellerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "headerImage": {
                  "enum": [
                    "0",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "10",
                    "11"
                  ],
                  "default": "0",
                  "description": "The widget's header"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "FiveGridLineProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "fullScreenModeOn": {
                  "type": "boolean",
                  "default": false,
                  "description": "Toggle full screen mode"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "FlashComponentProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "displayMode": {
                  "type": "string",
                  "enum": [
                    "original",
                    "fit",
                    "stretch"
                  ],
                  "default": "original",
                  "description": "displayMode of the movie"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "GalleryExpandProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "expandEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "goToLinkText": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Go to link"
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ],
                  "default": "zoomMode"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "GoogleMapProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showZoom": {
                  "type": "boolean",
                  "default": true,
                  "description": "show zoom control"
                },
                "fullscreenControl": {
                  "type": "boolean",
                  "default": true,
                  "description": "show fullscreen control"
                },
                "showPosition": {
                  "type": "boolean",
                  "default": true,
                  "description": "show position control"
                },
                "showStreetView": {
                  "type": "boolean",
                  "default": true,
                  "description": "show Street View control"
                },
                "showMapType": {
                  "type": "boolean",
                  "default": true,
                  "description": "show map type control"
                },
                "zoom": {
                  "type": "number",
                  "default": 14,
                  "description": "default map zoom level",
                  "minimum": 0,
                  "maximum": 20
                },
                "mapDragging": {
                  "type": "boolean",
                  "default": true,
                  "description": "show map type control"
                },
                "showDirectionsLink": {
                  "type": "boolean",
                  "default": true,
                  "description": "show directions link in infoWindow"
                },
                "mapType": {
                  "type": "string",
                  "enum": [
                    "ROADMAP",
                    "TERRAIN",
                    "SATELLITE",
                    "HYBRID"
                  ],
                  "default": "ROADMAP",
                  "description": "show zoom control"
                },
                "language": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "cs",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "hi",
                    "it",
                    "ja",
                    "ko",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "zh",
                    "th",
                    "uk",
                    "tr"
                  ],
                  "default": "en",
                  "description": "Possible languages taken from https://developers.google.com/maps/faq?hl=en#languagesupport"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "HorizontalMenuProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignButtons": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "center",
                  "description": "alignment of the menu buttons"
                },
                "alignText": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "center",
                  "description": "alignment of the menu buttons' text"
                },
                "sameWidthButtons": {
                  "type": "boolean",
                  "default": false,
                  "description": "Keep buttons the same size"
                },
                "moreButtonLabel": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "More",
                  "description": "Label to use for 'more button'"
                },
                "moreItemHeight": {
                  "type": "number",
                  "default": 15,
                  "description": "height of items in the more menu"
                },
                "stretchButtonsToMenuWidth": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "rtl": {
                  "type": "boolean",
                  "default": false,
                  "description": "should display menu in RTL mode"
                },
                "autoTextDirection": {
                  "$ref": "urn:dm:schemas:common.json#/NullableBool"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ImpressProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "textMode": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "titleAndDescription",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "descriptionOnly",
                    "noText"
                  ]
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 5,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "showPagination": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "cropAndFitStage": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "crop",
                  "enum": [
                    "crop",
                    "fit"
                  ]
                },
                "transition": {
                  "type": "string",
                  "default": "random",
                  "enum": [
                    "none",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "random"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "MasonryProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "numCols": {
                  "type": "number",
                  "default": 3,
                  "description": "Number of columns",
                  "minimum": 1,
                  "maximum": 10
                },
                "margin": {
                  "type": "number",
                  "default": 25,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 100
                },
                "textMode": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "titleAndDescription",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "descriptionOnly",
                    "noText"
                  ]
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "boxShadowIsOn": {
                  "type": "boolean",
                  "default": true
                },
                "boxShadow": {
                  "type": "string",
                  "default": "0 1px 3px 0 rgba(0,0,0,0.33)"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "StripShowcaseProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "galleryImageOnClickAction": {
                  "langsKey": "System.centerImageClick",
                  "type": "string",
                  "default": "disabled",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "cropAndFitStage": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "fit",
                  "enum": [
                    "crop",
                    "fit"
                  ]
                },
                "imageScale": {
                  "type": "string",
                  "default": "4:3",
                  "enum": [
                    "16:9",
                    "4:3",
                    "1:1",
                    "3:4",
                    "9:16"
                  ]
                },
                "imageMargin": {
                  "type": "number",
                  "default": 5,
                  "description": "Margin between thumbnails",
                  "minimum": 0,
                  "maximum": 100
                },
                "showThumbnails": {
                  "type": "boolean",
                  "default": true
                },
                "thumbsScale": {
                  "type": "string",
                  "default": "4:3",
                  "enum": [
                    "16:9",
                    "4:3",
                    "1:1",
                    "3:4",
                    "9:16"
                  ]
                },
                "thumbsMargin": {
                  "type": "number",
                  "default": 5,
                  "description": "Margin between thumbnails",
                  "minimum": 0,
                  "maximum": 100
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 5,
                  "minimum": 0,
                  "maximum": 30
                },
                "arrowMode": {
                  "type": "boolean",
                  "default": false
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "StripSlideshowProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "textMode": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "titleAndDescription",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "descriptionOnly",
                    "noText"
                  ]
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 5,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "showPlaybackControl": {
                  "type": "boolean"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "transition": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "scroll",
                  "enum": [
                    "none",
                    "crossFade",
                    "slide",
                    "scroll",
                    "zoom",
                    "random"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ThumbnailsProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "cropAndFitStage": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "crop",
                  "enum": [
                    "crop",
                    "fit"
                  ]
                },
                "componentScale": {
                  "type": "string",
                  "default": "4:3",
                  "enum": [
                    "16:9",
                    "4:3",
                    "1:1"
                  ]
                },
                "margin": {
                  "type": "number",
                  "default": 5,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 100
                },
                "textMode": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "titleAndDescription",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "descriptionOnly",
                    "noText"
                  ]
                },
                "arrowMode": {
                  "type": "boolean",
                  "default": true
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 5,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "transition": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "crossFade",
                  "enum": [
                    "none",
                    "crossFade",
                    "slide",
                    "scroll",
                    "zoom",
                    "random"
                  ]
                },
                "thumbnailsGravity": {
                  "langsKey": "System.gravity",
                  "type": "string",
                  "default": "bottom",
                  "enum": [
                    "top",
                    "bottom",
                    "left",
                    "right"
                  ]
                },
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "disabled",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "AccordionProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "descFont": {
                  "$ref": "#/FontsEnum"
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "textMode": {
                  "langsKey": "System.textMode",
                  "type": "string",
                  "default": "titleOnly",
                  "enum": [
                    "titleOnly",
                    "noText"
                  ]
                },
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "borderWidth": {
                  "type": "number",
                  "default": 0,
                  "description": "Borer width between images",
                  "minimum": 0,
                  "maximum": 30
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "CollageProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "alignText": {
                  "type": "string",
                  "default": "center",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "textMode": {
                  "langsKey": "System.textMode",
                  "type": "string",
                  "default": "titleOnly",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "noText"
                  ]
                },
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "minImageSize": {
                  "type": "number",
                  "default": 1,
                  "description": "minimum image size",
                  "minimum": 1,
                  "maximum": 10
                },
                "maxImageSize": {
                  "type": "number",
                  "default": 3,
                  "description": "maximum image size",
                  "minimum": 1,
                  "maximum": 10
                },
                "avergeImageSize": {
                  "type": "number",
                  "default": 1,
                  "description": "averge image size",
                  "minimum": 1,
                  "maximum": 10
                },
                "margin": {
                  "type": "number",
                  "default": 5,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 30
                },
                "fitToScreenWidth": {
                  "type": "boolean",
                  "default": false,
                  "description": "fit component width to screen"
                },
                "showNavButtons": {
                  "type": "boolean",
                  "default": true,
                  "description": "show navigation buttons"
                },
                "numOfCells": {
                  "type": "number",
                  "default": 5,
                  "description": "number of grid cells",
                  "minimum": 2,
                  "maximum": 10
                },
                "orientation": {
                  "langsKey": "System.orientation",
                  "type": "string",
                  "default": "vertical",
                  "enum": [
                    "vertical",
                    "horizontal"
                  ]
                },
                "layoutSeed": {
                  "type": "number",
                  "default": 50,
                  "description": "seed for layout calculation",
                  "minimum": 1,
                  "maximum": 100
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "FreestyleProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "galleryImageOnClickAction": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "layoutSeed": {
                  "type": "number",
                  "default": 50,
                  "description": "seed for layout calculation",
                  "minimum": 1,
                  "maximum": 100
                },
                "cropAndFitStage": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "fit",
                  "enum": [
                    "crop",
                    "fit"
                  ]
                },
                "imageDecoration": {
                  "langsPrefix": "System",
                  "type": "string",
                  "default": "none",
                  "enum": [
                    "none",
                    "polaroid",
                    "scotchTape",
                    "vintageFrame",
                    "random"
                  ]
                },
                "borderWidth": {
                  "type": "number",
                  "default": 3,
                  "description": "image border width",
                  "minimum": 0,
                  "maximum": 15
                },
                "orientation": {
                  "type": "string",
                  "default": "horizontal",
                  "enum": [
                    "vertical",
                    "horizontal"
                  ]
                },
                "applyRotationInLayout": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ItunesButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "language": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "it",
                    "ja",
                    "ko",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "tr"
                  ],
                  "default": "en",
                  "description": "Language of the button"
                },
                "openIn": {
                  "type": "string",
                  "enum": [
                    "_self",
                    "_blank"
                  ],
                  "default": "_blank",
                  "description": "Where the link will be opened"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "LayoutProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "x": {
                  "type": "number",
                  "default": 0,
                  "description": "x position"
                },
                "y": {
                  "type": "number",
                  "default": 0,
                  "description": "y position"
                },
                "w": {
                  "type": "number",
                  "default": 100,
                  "description": "width"
                },
                "h": {
                  "type": "number",
                  "default": 100,
                  "description": "height"
                },
                "anchors": {
                  "type": [
                    "null",
                    "array"
                  ],
                  "description": "list of anchors"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "LinkBarProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "gallery": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "clipart",
                  "description": "gallery type (photos, icons, backgrounds, etc..)"
                },
                "iconSize": {
                  "type": "number",
                  "default": 30,
                  "description": "Icon Size",
                  "minimum": 16,
                  "maximum": 128
                },
                "spacing": {
                  "type": "number",
                  "default": 5,
                  "description": "Spacing",
                  "minimum": 1,
                  "maximum": 50
                },
                "bgScale": {
                  "type": "number",
                  "default": 1,
                  "description": "Background scale",
                  "minimum": 0,
                  "maximum": 2
                },
                "orientation": {
                  "type": "string",
                  "enum": [
                    "HORIZ",
                    "VERT"
                  ],
                  "default": "HORIZ",
                  "description": "Orientation"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "MatrixGalleryProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageMode": {
                  "type": "string",
                  "enum": [
                    "clipImage",
                    "flexibleWidthFixed"
                  ],
                  "default": "clipImage"
                },
                "itemHeight": {
                  "type": [
                    "null",
                    "number"
                  ],
                  "description": "height of specific item"
                },
                "numCols": {
                  "type": "number",
                  "default": 3,
                  "description": "Number of columns",
                  "minimum": 1,
                  "maximum": 10
                },
                "maxRows": {
                  "type": "number",
                  "default": 3,
                  "description": "Maximum number of rows",
                  "minimum": 1,
                  "maximum": 10
                },
                "incRows": {
                  "type": "number",
                  "default": 2,
                  "description": "Row number increase",
                  "minimum": 1,
                  "maximum": 10
                },
                "margin": {
                  "type": "number",
                  "default": 15,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 250
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "showMoreLabel": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Show More",
                  "description": "Show More"
                },
                "expandEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "goToLinkText": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Go to link"
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ],
                  "default": "zoomMode"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "NumberInputProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "minValue": {
                  "type": "number",
                  "default": 0,
                  "description": "minimum allowed value"
                },
                "maxValue": {
                  "type": "number",
                  "default": 999,
                  "description": "maximum allowed value"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "PageGroupProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "none",
                    "swipeHorizontalFullScreen",
                    "swipeVerticalFullScreen",
                    "crossfade",
                    "outIn",
                    "slide"
                  ],
                  "default": "swipeHorizontalFullScreen",
                  "description": "page transition"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "PaginatedGridGalleryProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageMode": {
                  "type": "string",
                  "enum": [
                    "clipImage"
                  ],
                  "default": "clipImage"
                },
                "numCols": {
                  "type": "number",
                  "default": 3,
                  "description": "Number of columns",
                  "minimum": 1,
                  "maximum": 10
                },
                "maxRows": {
                  "type": "number",
                  "default": 3,
                  "description": "Maximum number of rows",
                  "minimum": 1,
                  "maximum": 10
                },
                "margin": {
                  "type": "number",
                  "default": 0,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 250
                },
                "transition": {
                  "type": "string",
                  "default": "seq_crossFade_All",
                  "enum": [
                    "none",
                    "seq_crossFade_All",
                    "seq_shrink_All",
                    "swipe_horiz_All",
                    "swipe_vert_All",
                    "seq_random"
                  ]
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 3,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "showAutoplay": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "showNavigation": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "showCounter": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "expandEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "goToLinkText": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Go to link"
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "PayPalButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "buttonType": {
                  "type": "string",
                  "enum": [
                    "buy",
                    "donate"
                  ],
                  "default": "buy",
                  "description": "buy or donate button"
                },
                "itemName": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "description": "some amazing description"
                },
                "itemID": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "description": "some amazing description"
                },
                "organizationName": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "description": "some amazing description"
                },
                "organizationID": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "description": "some amazing description"
                },
                "amount": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "description": "some amazing description"
                },
                "currencyCode": {
                  "type": "string",
                  "default": "USD",
                  "description": "Currency Code"
                },
                "target": {
                  "type": "string",
                  "enum": [
                    "_self",
                    "_blank"
                  ],
                  "default": "_blank",
                  "description": "Currency Code"
                },
                "showCreditCards": {
                  "type": "boolean",
                  "default": true,
                  "description": "Show credit card symbols"
                },
                "smallButton": {
                  "type": "boolean",
                  "default": false,
                  "description": "use small button"
                },
                "language": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "it",
                    "ja",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "tr"
                  ],
                  "default": "en",
                  "description": "https://developer.paypal.com/docs/classic/api/locale_codes/"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SiteSegmentContainerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "fixedPosition": {
                  "type": "boolean",
                  "default": false,
                  "description": "fixed positioning for components that inherit from SiteSegmentContainers"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SliderGalleryProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageMode": {
                  "type": "string",
                  "default": "clipImage",
                  "enum": [
                    "clipImage",
                    "flexibleWidth"
                  ]
                },
                "margin": {
                  "type": "number",
                  "default": 15,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 250
                },
                "maxSpeed": {
                  "type": "number",
                  "default": 5,
                  "minimum": 1,
                  "maximum": 30,
                  "description": "Speed"
                },
                "aspectRatio": {
                  "type": "number",
                  "minimum": 0.1,
                  "maximum": 3,
                  "default": 1,
                  "description": ""
                },
                "aspectRatioPreset": {
                  "type": "string",
                  "enum": [
                    "16:9",
                    "4:3",
                    "1:1",
                    "3:4",
                    "9:16"
                  ],
                  "default": "4:3"
                },
                "loop": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "showCounter": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "expandEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "goToLinkText": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Go to link"
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ],
                  "default": "zoomMode"
                },
                "autoplayInterval": {
                  "$ref": "urn:dm:schemas:common.json#/NullableInt"
                },
                "transDuration": {
                  "$ref": "urn:dm:schemas:common.json#/NullableInt"
                },
                "showAutoplay": {
                  "$ref": "urn:dm:schemas:common.json#/NullableBool"
                },
                "autoplay": {
                  "$ref": "urn:dm:schemas:common.json#/NullableBool"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SlideShowGalleryProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "imageMode": {
                  "type": "string",
                  "enum": [
                    "clipImage",
                    "flexibleHeight",
                    "flexibleWidthFixed"
                  ],
                  "default": "clipImage"
                },
                "transition": {
                  "type": "string",
                  "enum": [
                    "none",
                    "swipeVertical",
                    "swipeHorizontal",
                    "crossfade",
                    "outIn"
                  ],
                  "default": "swipeHorizontal",
                  "description": "Transition between items of the gallery"
                },
                "autoplayInterval": {
                  "type": "number",
                  "default": 5,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "bidirectional": {
                  "type": "boolean",
                  "default": true,
                  "description": "Decides whether the transition direction reflects Prev/Next"
                },
                "reverse": {
                  "type": "boolean",
                  "default": false,
                  "description": "If bidirectional, inverts the direction of transitions"
                },
                "showAutoplay": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "showNavigation": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "showCounter": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "expandEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "goToLinkText": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Go to link"
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "right"
                  ]
                },
                "showSocial": {
                  "type": [
                    "boolean",
                    "null"
                  ]
                },
                "showExpand": {
                  "type": [
                    "boolean",
                    "null"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SvgShapeProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "maintainAspectRatio": {
                  "type": "boolean",
                  "default": true,
                  "description": "should the shape maintain it's aspect ratio or stretch"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "VectorImageProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "displayMode": {
                  "type": "string",
                  "enum": [
                    "legacyFit",
                    "fit",
                    "stretch"
                  ],
                  "description": "should the shape maintain it's aspect ratio or stretch, 'legacy-fit' is for converted SvgShape"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/FlipProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "TableComponentProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "minHeight": {
                  "type": "number",
                  "default": -1,
                  "description": "minimum allowed value"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "TinyMenuProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ExpandableMenuProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "itemsAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the menu items"
                },
                "subMenuOpenSide": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "right",
                  "description": "Opening direction of sub-menus"
                },
                "originalHeight": {
                  "type": "number",
                  "description": "Used to determine if comp was saved with correct height (if value not empty), or height needs to be fixed in DataFixer (if value is empty)"
                },
                "menuItemHeight": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number"
                    }
                  ]
                },
                "menuArrowDirection": {
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "TwitterFeedProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "numOfTweets": {
                  "type": "number",
                  "default": 5,
                  "description": "Number of tweets in feed"
                },
                "subject": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "What's being said about...",
                  "description": "subject line"
                },
                "title": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "Me...",
                  "description": "title line"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "VideoProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": "video autoplay on load"
                },
                "loop": {
                  "type": "boolean",
                  "default": false,
                  "description": "play video in a loop"
                },
                "showinfo": {
                  "type": "boolean",
                  "default": false,
                  "description": "show video title and author"
                },
                "lightTheme": {
                  "type": "boolean",
                  "default": false,
                  "description": "show video with light theme"
                },
                "showControls": {
                  "type": "string",
                  "enum": [
                    "always_show",
                    "always_hide",
                    "temp_show"
                  ],
                  "default": "always_show",
                  "description": "show / hide controls"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "VKShareProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "rightAngles": {
                  "type": "boolean",
                  "default": false,
                  "description": "Button Right angles"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "WFacebookCommentProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "numPosts": {
                  "type": "number",
                  "default": 2,
                  "minimum": 0,
                  "maximum": 10,
                  "description": "the number of posts display by default"
                },
                "width": {
                  "type": "number",
                  "default": 555,
                  "description": "the width of the plugin, in pixels"
                },
                "colorScheme": {
                  "type": "string",
                  "enum": [
                    "light",
                    "dark"
                  ],
                  "default": "light",
                  "description": "the color scheme of the plugin"
                },
                "canBeShownOnAllPagesBug": {
                  "type": "boolean",
                  "default": false,
                  "description": "The component was added after the bug who-145 fix, and will be shown on all pages"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "DisqusCommentsProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "disqusId": {
                  "type": "string",
                  "description": "User id in disqus"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "WFacebookLikeProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "layout": {
                  "type": "string",
                  "enum": [
                    "standard",
                    "button_count",
                    "box_count"
                  ],
                  "default": "standard",
                  "description": "the layout of the button"
                },
                "send": {
                  "type": "boolean",
                  "default": false,
                  "description": "enable/disable the send button"
                },
                "show_faces": {
                  "type": "boolean",
                  "default": false,
                  "description": "show the faces of your friends that liked this item"
                },
                "width": {
                  "type": [
                    "null",
                    "string",
                    "number"
                  ],
                  "default": "225",
                  "description": "the width of the Like button"
                },
                "action": {
                  "type": "string",
                  "enum": [
                    "like",
                    "recommend"
                  ],
                  "default": "like",
                  "description": " the verb to display on the button. Options: *like*, *recommend*"
                },
                "font": {
                  "type": "string",
                  "enum": [
                    "helvetica",
                    "arial",
                    "lucida grande",
                    "segoe ui",
                    "tahoma",
                    "trebuchet ms",
                    "verdana"
                  ],
                  "default": "helvetica",
                  "description": "the font to display in the button"
                },
                "colorScheme": {
                  "type": "string",
                  "enum": [
                    "light",
                    "dark"
                  ],
                  "default": "dark",
                  "description": "the color scheme for the like button"
                },
                "language": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "it",
                    "ja",
                    "kr",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "tr"
                  ],
                  "default": "en"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "WGooglePlusOneProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "size": {
                  "type": "string",
                  "enum": [
                    "small",
                    "medium",
                    "standard",
                    "tall"
                  ],
                  "default": "standard",
                  "description": "The button size to render"
                },
                "annotation": {
                  "type": "string",
                  "enum": [
                    "none",
                    "bubble",
                    "inline"
                  ],
                  "default": "inline",
                  "description": "The annotation to display next to the button."
                },
                "width": {
                  "type": [
                    "null",
                    "number"
                  ],
                  "description": "If annotation is set to *inline*, the width in pixels to use for the button and its inline annotation. If omitted, a button and its inline annotation use 450px."
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "WPhotoProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "displayMode": {
                  "type": "string",
                  "enum": [
                    "fit",
                    "fill",
                    "full",
                    "stretch",
                    "fitWidth",
                    "fitWidthStrict",
                    "fitHeightStrict"
                  ],
                  "default": "fill",
                  "description": "displayMode of the photo"
                },
                "autoFill": {
                  "type": "boolean",
                  "default": false,
                  "description": "Should the photo should enable auto crop in the editor"
                },
                "onClickBehavior": {
                  "type": "string",
                  "enum": [
                    "disabled",
                    "goToLink",
                    "zoomMode",
                    "zoomAndPanMode"
                  ],
                  "default": "goToLink",
                  "description": "goToLink"
                },
                "effectName": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "An effect to apply on the image",
                  "default": "none"
                },
                "filterEffect": {
                  "type": [
                    "object",
                    "null"
                  ],
                  "description": "An effect to apply on the image",
                  "properties": {
                    "effectType": {
                      "type": "string"
                    },
                    "brightness": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 10
                    },
                    "contrast": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 10
                    },
                    "saturation": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 10
                    },
                    "hue": {
                      "type": "number",
                      "minimum": -180,
                      "maximum": 180
                    },
                    "duotoneDark": {
                      "type": "string"
                    },
                    "duotoneLight": {
                      "type": "string"
                    },
                    "invert": {
                      "type": "boolean",
                      "default": false
                    },
                    "isCustom": {
                      "type": "boolean"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "overrideCrop": {
                  "description": "Overriding the image crop for Mobile view",
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "object",
                      "minProperties": 4,
                      "allOf": [
                        {
                          "properties": {
                            "x": {
                              "type": "number",
                              "minimum": 0
                            },
                            "y": {
                              "type": "number",
                              "minimum": 0
                            },
                            "width": {
                              "type": "number",
                              "minimum": 0
                            },
                            "height": {
                              "type": "number",
                              "minimum": 0
                            },
                            "svgId": {
                              "type": "string",
                              "description": "Defines an svg uri for a mask inside the crop boundaries"
                            },
                            "rotate": {
                              "type": "number",
                              "minimum": 0,
                              "maximum": 360,
                              "description": "Defines a rotation angle for the mask"
                            }
                          }
                        },
                        {
                          "$ref": "#/FlipProperties--unrestricted-root"
                        }
                      ]
                    }
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "WRichTextProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "packed": {
                  "type": "boolean",
                  "default": false,
                  "description": "Is the text component packed"
                },
                "brightness": {
                  "type": "number",
                  "default": 1
                },
                "overrideAlignment": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "left",
                        "right",
                        "center",
                        "justify"
                      ]
                    }
                  ]
                },
                "overrideColor": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string"
                    }
                  ]
                },
                "minHeight": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number"
                    }
                  ]
                },
                "minWidth": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number"
                    }
                  ]
                },
                "verticalText": {
                  "type": "boolean",
                  "default": false,
                  "description": "Vertical oriented text flag"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RefComponentProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "minHeight": {
                  "type": "number"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "WTwitterFollowProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showCount": {
                  "type": "boolean",
                  "default": true,
                  "description": "Followers count display"
                },
                "showScreenName": {
                  "type": "boolean",
                  "default": true,
                  "description": "Show screen name"
                },
                "textColor": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$",
                  "description": "HEX color code for the text color"
                },
                "linkColor": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$",
                  "description": "HEX color code for the Username link color"
                },
                "width": {
                  "type": "number",
                  "default": 100,
                  "description": "width of the Follow Button"
                },
                "dataLang": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "hi",
                    "it",
                    "ja",
                    "ko",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "tr"
                  ],
                  "default": "en",
                  "description": "The language for the Tweet Button (from https://dev.twitter.com/overview/general/adding-international-support-to-your-apps)"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "WTwitterTweetProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "dataCount": {
                  "type": "string",
                  "enum": [
                    "none",
                    "horizontal",
                    "vertical"
                  ],
                  "default": "horizontal",
                  "description": "Count box position"
                },
                "dataLang": {
                  "type": "string",
                  "enum": [
                    "userLang",
                    "da",
                    "de",
                    "en",
                    "es",
                    "fr",
                    "hi",
                    "it",
                    "ja",
                    "ko",
                    "nl",
                    "no",
                    "pl",
                    "pt",
                    "ru",
                    "sv",
                    "tr"
                  ],
                  "default": "en",
                  "description": "The language for the Tweet Button (from https://dev.twitter.com/overview/general/adding-international-support-to-your-apps)"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "HoverBoxProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "mobileDisplayedModeId": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "The mode to activate when in mobile view"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "TPAGluedProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "placement": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "BOTTOM_RIGHT",
                  "description": "widget placement"
                },
                "verticalMargin": {
                  "type": [
                    "null",
                    "string",
                    "number"
                  ],
                  "default": "",
                  "description": "widget vertical margin"
                },
                "horizontalMargin": {
                  "type": [
                    "null",
                    "string",
                    "number"
                  ],
                  "default": "",
                  "description": "widget horizontal margin"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "HoneycombProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "font": {
                  "$ref": "#/FontsEnum"
                },
                "alignText": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                },
                "textMode": {
                  "langsKey": "System.textMode",
                  "type": "string",
                  "default": "titleAndDescription",
                  "enum": [
                    "titleAndDescription",
                    "titleOnly",
                    "descriptionOnly",
                    "noText"
                  ]
                },
                "galleryImageOnClickAction": {
                  "type": "string",
                  "default": "zoomMode",
                  "enum": [
                    "disabled",
                    "zoomMode",
                    "goToLink"
                  ]
                },
                "margin": {
                  "type": "number",
                  "default": 1,
                  "description": "Margin around each item",
                  "minimum": 0,
                  "maximum": 30
                },
                "numOfColumns": {
                  "type": "number",
                  "default": 4,
                  "description": "number of columns",
                  "minimum": 2,
                  "maximum": 10
                },
                "numOfHoles": {
                  "type": "number",
                  "default": 2,
                  "description": "number of holes in the honeycomb",
                  "minimum": 2,
                  "maximum": 8
                },
                "layoutSeed": {
                  "type": "number",
                  "default": 50,
                  "description": "seed for layout calculation",
                  "minimum": 1,
                  "maximum": 100
                },
                "rolloverAnimation": {
                  "type": "string",
                  "default": "colorOnly",
                  "enum": [
                    "colorOnly",
                    "glow",
                    "bounce"
                  ]
                },
                "imageShape": {
                  "type": "string",
                  "default": "hexagon",
                  "enum": [
                    "hexagon",
                    "square",
                    "triangle"
                  ]
                },
                "imageScale": {
                  "type": "string",
                  "default": "x1",
                  "enum": [
                    "x1",
                    "x2",
                    "x3"
                  ]
                },
                "expandEnabled": {
                  "$ref": "urn:dm:schemas:common.json#/NullableBool"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "AppPartProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": "string",
                  "default": "ltr",
                  "enum": [
                    "ltr",
                    "rtl"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RssButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "none",
                    "fade",
                    "float",
                    "expand",
                    "spin",
                    "fly",
                    "turn",
                    "reveal",
                    "slide",
                    "puff",
                    "flip",
                    "fold",
                    "arc"
                  ],
                  "default": "fade"
                },
                "type": {
                  "type": "string"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "BoxSlideShowProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "NoTransition",
                    "SlideVertical",
                    "SlideHorizontal",
                    "CrossFade",
                    "OutIn"
                  ],
                  "default": "SlideHorizontal",
                  "description": "Transition between items of the gallery"
                },
                "autoPlay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "autoPlayInterval": {
                  "type": "number",
                  "default": 3,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "showPlaybackControl": {
                  "type": "boolean"
                },
                "direction": {
                  "type": "string",
                  "default": "RTL",
                  "enum": [
                    "LTR",
                    "RTL"
                  ]
                },
                "pauseAutoPlayOnMouseOver": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "shouldHideOverflowContent": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "flexibleBoxHeight": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "showNavigationButton": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "navigationButtonSize": {
                  "type": "number",
                  "minimum": 8,
                  "maximum": 72,
                  "default": 21,
                  "description": "Size of the navigation arrow buttons"
                },
                "navigationButtonMargin": {
                  "type": "number",
                  "minimum": -72,
                  "maximum": 72,
                  "default": 0,
                  "description": "Margin from the sides of the navigation arrow buttons"
                },
                "showNavigationDots": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "navigationDotsAlignment": {
                  "type": "string",
                  "default": "center",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "description": "Alignment of the navigation dots"
                },
                "navigationDotsSize": {
                  "type": "number",
                  "minimum": 6,
                  "maximum": 24,
                  "default": 6,
                  "description": "Size of the navigation dots"
                },
                "navigationDotsMargin": {
                  "type": "number",
                  "minimum": -50,
                  "maximum": 50,
                  "default": 0,
                  "description": "Margin from the sides of the navigation dots"
                },
                "navigationDotsGap": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 24,
                  "default": 0,
                  "description": "Gap size (spacing) of the navigation dots"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "BoxSlideShowSlideProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "StateBoxProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "NoTransition",
                    "SlideVertical",
                    "SlideHorizontal",
                    "CrossFade",
                    "OutIn"
                  ],
                  "default": "NoTransition",
                  "description": "Transition between states"
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "StateBoxStateProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "StateBoxFormStateProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "StripContainerSlideShowProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "transition": {
                  "type": "string",
                  "enum": [
                    "NoTransition",
                    "SlideVertical",
                    "SlideHorizontal",
                    "CrossFade",
                    "OutIn"
                  ],
                  "default": "SlideHorizontal",
                  "description": "Transition between items of the gallery"
                },
                "autoPlay": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "showPlaybackControl": {
                  "type": "boolean"
                },
                "autoPlayInterval": {
                  "type": "number",
                  "default": 2,
                  "minimum": 0,
                  "maximum": 30,
                  "description": "Autplay interval"
                },
                "direction": {
                  "type": "string",
                  "default": "RTL",
                  "enum": [
                    "LTR",
                    "RTL"
                  ]
                },
                "pauseAutoPlayOnMouseOver": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "transDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 1,
                  "description": "Duration of the transition in sec"
                },
                "shouldHideOverflowContent": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "flexibleBoxHeight": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                },
                "showNavigationButton": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "navigationButtonSize": {
                  "type": "number",
                  "minimum": 8,
                  "maximum": 72,
                  "default": 21,
                  "description": "Size of the navigation arrow buttons"
                },
                "navigationButtonMargin": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 0,
                  "description": "Margin from the sides of the navigation arrow buttons"
                },
                "showNavigationDots": {
                  "type": "boolean",
                  "default": true,
                  "description": ""
                },
                "navigationDotsAlignment": {
                  "type": "string",
                  "default": "center",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "description": "Alignment of the navigation dots"
                },
                "navigationDotsSize": {
                  "type": "number",
                  "minimum": 6,
                  "maximum": 24,
                  "default": 6,
                  "description": "Size of the navigation dots"
                },
                "navigationDotsMargin": {
                  "type": "number",
                  "minimum": -50,
                  "maximum": 50,
                  "default": 0,
                  "description": "Margin from the sides of the navigation dots"
                },
                "navigationDotsGap": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 24,
                  "default": 0,
                  "description": "Gap size (spacing) of the navigation dots"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "StripContainerSlideShowSlideProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "VerticalAnchorsMenuProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "itemsAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the menu items"
                },
                "orientation": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "right",
                  "description": "menu orientation"
                },
                "autoColor": {
                  "type": "boolean",
                  "default": false,
                  "description": "does the menu color change automatically according to the background brightness"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "TextInputProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "textAlignment": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "left",
                        "right",
                        "center"
                      ],
                      "maxLength": 100
                    }
                  ],
                  "default": "left",
                  "description": "the direction of the text"
                },
                "textPadding": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 100
                    }
                  ],
                  "default": 14,
                  "description": "the value of the textPadding"
                },
                "placeholder": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected",
                  "default": "Add your name"
                },
                "defaultTextType": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "none",
                        "initialText",
                        "placeholderText",
                        "placeholderAndInitialText"
                      ],
                      "maxLength": 100
                    }
                  ],
                  "default": "placeholderText",
                  "description": "the type of the default text for the input"
                },
                "autoComplete": {
                  "type": "boolean",
                  "description": "can the field be auto completed by the browser"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            },
            {
              "$ref": "#/InputElementsErrorProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "TextAreaInputProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "textAlignment": {
                  "type": "string",
                  "default": "center",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "description": "the direction of the text",
                  "maxLength": 100
                },
                "textPadding": {
                  "type": "number",
                  "default": 18,
                  "minimum": 0,
                  "maximum": 100,
                  "description": "the value of the textPadding"
                },
                "placeholder": {
                  "type": "string",
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected"
                },
                "defaultTextType": {
                  "type": "string",
                  "default": "none",
                  "enum": [
                    "none",
                    "initialText",
                    "placeholderText",
                    "placeholderAndInitialText"
                  ],
                  "description": "the type of the default text for the input",
                  "maxLength": 100
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            },
            {
              "$ref": "#/InputElementsErrorProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "CheckboxProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left",
                  "description": "alignment of the text"
                },
                "buttonSize": {
                  "type": "number",
                  "default": 18,
                  "description": "checkbox size",
                  "minimum": 12,
                  "maximum": 100
                },
                "spacing": {
                  "type": "number",
                  "default": 12,
                  "description": "Spacing between checkbox and label",
                  "minimum": 0,
                  "maximum": 100
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "DatePickerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "textAlignment": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "description": "the direction of the text"
                },
                "textPadding": {
                  "type": "number",
                  "default": 18,
                  "description": "the value of the text padding"
                },
                "placeholder": {
                  "type": "string",
                  "default": "",
                  "maxLength": 200,
                  "description": "placeholder text for date in input field"
                },
                "dateFormat": {
                  "type": "string",
                  "default": "MM/DD/YYYY",
                  "enum": [
                    "MM/DD/YYYY",
                    "DD/MM/YYYY",
                    "YYYY/MM/DD",
                    "YYYY/M/D"
                  ],
                  "description": "date format for selected date presentation inside the date input field"
                },
                "defaultTextType": {
                  "type": "string",
                  "default": "none",
                  "enum": [
                    "none",
                    "today",
                    "placeholder"
                  ],
                  "description": "the type of the default text for the date input"
                },
                "dayToStart": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "Sunday",
                        "Monday"
                      ],
                      "description": "the day which the week starts on"
                    }
                  ]
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "GridProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "columns": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "properties": {
                      "id": {
                        "type": "string"
                      },
                      "dataPath": {
                        "type": "string"
                      },
                      "linkPath": {
                        "type": "string"
                      },
                      "label": {
                        "type": "string"
                      },
                      "width": {
                        "type": "number",
                        "default": 100
                      },
                      "visible": {
                        "type": "boolean",
                        "default": true
                      },
                      "type": {
                        "type": "string",
                        "enum": [
                          "number",
                          "string",
                          "date",
                          "image",
                          "bool",
                          "richText"
                        ]
                      },
                      "imageAltPath": {
                        "type": "string"
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "showHeader": {
                  "type": "boolean"
                },
                "headerHeight": {
                  "type": "number"
                },
                "rowHeight": {
                  "type": "number"
                },
                "allowUserSorting": {
                  "type": "boolean"
                },
                "allowUserFiltering": {
                  "type": "boolean"
                },
                "allowUserEditing": {
                  "type": "boolean"
                },
                "heightLayout": {
                  "type": "string",
                  "enum": [
                    "manual",
                    "auto"
                  ]
                },
                "pagination": {
                  "type": "object",
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "type": "string",
                      "enum": [
                        "normal",
                        "pagination",
                        "virtual"
                      ]
                    },
                    "rowsPerPage": {
                      "type": "number",
                      "multipleOf": 1
                    },
                    "manualHeightProps": {
                      "type": "object",
                      "properties": {
                        "rowsPerPage": {
                          "type": "number",
                          "multipleOf": 1
                        },
                        "gridHeight": {
                          "type": "number",
                          "multipleOf": 1
                        },
                        "type": {
                          "type": "string",
                          "enum": [
                            "normal",
                            "pagination",
                            "virtual"
                          ]
                        }
                      },
                      "unevaluatedProperties": false
                    },
                    "style": {
                      "type": "string",
                      "enum": [
                        "text",
                        "number",
                        "simple"
                      ],
                      "default": "text"
                    },
                    "alignment": {
                      "type": "string",
                      "enum": [
                        "left",
                        "center",
                        "right",
                        "spread"
                      ],
                      "default": "right"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "userSelectionType": {
                  "type": "string",
                  "enum": [
                    "none",
                    "cell",
                    "row"
                  ],
                  "default": "none"
                },
                "dateFormat": {
                  "type": "string"
                },
                "sorting": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "properties": {
                      "colId": {
                        "type": "string"
                      },
                      "sort": {
                        "type": "string",
                        "default": "none",
                        "enum": [
                          "asc",
                          "desc",
                          "none"
                        ]
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "linkTarget": {
                  "type": "string",
                  "enum": [
                    "_self",
                    "_blank"
                  ]
                },
                "columnLayout": {
                  "type": "string",
                  "enum": [
                    "equal",
                    "fitContent",
                    "manual"
                  ]
                },
                "horizontalAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "PagePropertiesForDevice--unrestricted-root": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "minHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "minimum page size"
        },
        "popup": {
          "type": "object",
          "properties": {
            "closeOnOverlayClick": {
              "type": "boolean",
              "default": true
            }
          },
          "unevaluatedProperties": false
        }
      }
    },
    "PageProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "type": "object",
              "properties": {
                "desktop": {
                  "$ref": "#/PagePropertiesForDevice"
                },
                "mobile": {
                  "$ref": "#/PagePropertiesForDevice"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "PopupContainerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "horizontalAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "default": "center",
                  "description": ""
                },
                "verticalAlignment": {
                  "type": "string",
                  "enum": [
                    "top",
                    "bottom",
                    "center"
                  ],
                  "default": "top",
                  "description": ""
                },
                "alignmentType": {
                  "type": "string",
                  "enum": [
                    "nineGrid",
                    "fullHeight",
                    "fullWidth"
                  ],
                  "default": "nineGrid",
                  "description": ""
                },
                "horizontalOffset": {
                  "type": "number",
                  "default": 0,
                  "description": ""
                },
                "verticalOffset": {
                  "type": "number",
                  "default": 0,
                  "description": ""
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "MediaPlayerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "autoplay": {
                  "type": "boolean",
                  "default": false
                },
                "playerInteraction": {
                  "type": "object",
                  "description": "The way the player itself interacts with user input",
                  "default": {},
                  "properties": {
                    "click": {
                      "type": [
                        "string",
                        "null"
                      ],
                      "enum": [
                        "none",
                        "play",
                        "toggle"
                      ],
                      "default": "toggle"
                    },
                    "rollIn": {
                      "type": [
                        "string",
                        "null"
                      ],
                      "enum": [
                        "none",
                        "play",
                        "pause"
                      ],
                      "default": "none"
                    },
                    "rollOut": {
                      "type": [
                        "string",
                        "null"
                      ],
                      "enum": [
                        "none",
                        "play",
                        "pause"
                      ],
                      "default": "none"
                    },
                    "allowReplay": {
                      "type": "boolean",
                      "default": true
                    }
                  },
                  "unevaluatedProperties": false
                },
                "playerAudioInteraction": {
                  "type": "object",
                  "description": "The way the player itself interacts with user input",
                  "default": {},
                  "properties": {
                    "rollIn": {
                      "type": [
                        "string",
                        "null"
                      ],
                      "enum": [
                        "none",
                        "mute",
                        "unmute"
                      ],
                      "default": "none"
                    },
                    "rollOut": {
                      "type": [
                        "string",
                        "null"
                      ],
                      "enum": [
                        "none",
                        "mute",
                        "unmute"
                      ],
                      "default": "none"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "animatePoster": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "enum": [
                    "none",
                    "fade"
                  ],
                  "default": "none"
                },
                "mute": {
                  "type": "boolean",
                  "description": "mute on load",
                  "default": false
                },
                "disableAudio": {
                  "type": "boolean",
                  "description": "don't allow audio in player",
                  "default": false
                },
                "loop": {
                  "type": "boolean",
                  "default": false
                },
                "overrideMask": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "urn:dm:schemas:design_data.json#/ImageMask--unrestricted-root"
                    }
                  ]
                }
              }
            },
            {
              "$ref": "#/VideoBackgroundProperties--unrestricted-root"
            },
            {
              "$ref": "#/FlipProperties--unrestricted-root"
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "MediaControlsProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showStoryboard": {
                  "type": "string",
                  "enum": [
                    "videoAndTime",
                    "time",
                    "none"
                  ],
                  "default": "videoAndTime",
                  "description": "The options of displaying video preview when hovering on the progress bar"
                },
                "playerId": {
                  "type": "string",
                  "default": ""
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "MediaOverlayControlsProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "playerId": {
                  "type": "string",
                  "default": ""
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "LanguageSelectorProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "displayMode": {
                  "type": "string",
                  "default": "dropdown",
                  "enum": [
                    "horizontal",
                    "dropdown"
                  ],
                  "description": "the direction of the language labels"
                },
                "iconType": {
                  "type": "string",
                  "default": "circle",
                  "enum": [
                    "none",
                    "circle",
                    "square",
                    "rounded"
                  ],
                  "description": "language selector flag shape"
                },
                "iconSize": {
                  "type": [
                    "null",
                    "number"
                  ],
                  "description": "language selector icon size"
                },
                "hasArrow": {
                  "type": "boolean"
                },
                "itemFormat": {
                  "type": "string",
                  "default": "shortName",
                  "enum": [
                    "shortName",
                    "fullName",
                    "iconOnly",
                    "fullLocalizedName"
                  ],
                  "description": "language selector labels type"
                },
                "alignTabs": {
                  "type": "string",
                  "default": "center",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "description": "language selector tabs alignment"
                },
                "languagesOrder": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "string",
                    "maxLength": 50
                  },
                  "description": "Override for the order of the languages in the selection"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "MediaBoxProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "allowOverflowContent": {
                  "type": "boolean",
                  "default": false,
                  "description": ""
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "PopoverProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "position": {
                  "type": "string",
                  "enum": [
                    "top",
                    "bottom",
                    "left",
                    "right"
                  ],
                  "default": "top"
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "start",
                    "center",
                    "end"
                  ],
                  "default": "center"
                },
                "horizontalOffset": {
                  "type": "number",
                  "default": 0
                },
                "verticalOffset": {
                  "type": "number",
                  "default": 0
                },
                "closeMethod": {
                  "type": "string",
                  "enum": [
                    "mouseOut",
                    "outerClick",
                    "manual"
                  ],
                  "default": "mouseOut"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "mobui.MobuiPickerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "allOf": [
            {
              "properties": {
                "required": {
                  "default": false,
                  "type": "boolean"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "MobuiPickerItemType--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "subtitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isSelected": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiTextInputProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "allOf": [
            {
              "properties": {
                "hasInitialValue": {
                  "default": true,
                  "type": "boolean"
                },
                "multiline": {
                  "default": false,
                  "type": "boolean"
                },
                "readOnly": {
                  "default": false,
                  "type": "boolean"
                },
                "hasPrefix": {
                  "default": false,
                  "type": "boolean"
                },
                "hasSuffix": {
                  "default": false,
                  "type": "boolean"
                },
                "required": {
                  "default": false,
                  "type": "boolean"
                },
                "autoCorrect": {
                  "default": false,
                  "type": "boolean"
                },
                "hasAutoComplete": {
                  "default": false,
                  "type": "boolean"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "AccordionContainerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "defaultOpened": {
              "type": "string",
              "enum": [
                "close_all",
                "open_first",
                "open_all"
              ],
              "default": "close_all"
            },
            "multiple": {
              "type": "boolean",
              "default": false
            },
            "animated": {
              "type": "boolean",
              "default": false
            },
            "animationTime": {
              "type": "number",
              "minimum": 0,
              "default": 0.25
            },
            "icon": {
              "type": "string",
              "enum": [
                "arrow",
                "plus"
              ],
              "default": "arrow"
            }
          }
        }
      ],
      "type": "object"
    },
    "AccordionItemProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isParentFullWidth": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "AddressInputProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left"
                },
                "iconVisible": {
                  "type": "boolean",
                  "default": false
                },
                "dividerVisible": {
                  "type": "boolean",
                  "default": false
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "BoltComponentProperties--unrestricted-root": {
      "type": "object",
      "anyOf": [
        {
          "properties": {}
        }
      ]
    },
    "BreadcrumbsProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "separator": {
                  "type": "string",
                  "enum": [
                    "greater-than",
                    "slash"
                  ],
                  "default": "slash",
                  "description": "Defines type of separator between breadcrumbs items"
                },
                "shouldWrap": {
                  "type": "boolean",
                  "default": true,
                  "description": "Defines flex wrapping of items"
                },
                "direction": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ],
                  "default": "ltr",
                  "description": "Direction of breadcrumbs items"
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "flex-start",
                    "center",
                    "flex-end"
                  ],
                  "default": "flex-start",
                  "description": "Alignment of breadcrumbs items"
                },
                "showHomePage": {
                  "type": "boolean",
                  "default": true,
                  "description": "Should show home item"
                },
                "showHomePageAsIcon": {
                  "type": "boolean",
                  "default": false,
                  "description": "Breadcrumbs will show HOME item as icon"
                },
                "showCurrentPage": {
                  "type": "boolean",
                  "default": true,
                  "description": "Should show current page in breadcrumbs"
                },
                "showOnlyPreviousPageOnMobile": {
                  "type": "boolean",
                  "default": false,
                  "description": "Show only previous page in mobile breadcrumbs"
                },
                "horizontalMargin": {
                  "type": "number",
                  "default": 0
                },
                "verticalMargin": {
                  "type": "number",
                  "default": 0
                },
                "isCollapsedByDefault": {
                  "type": "boolean",
                  "default": true
                },
                "itemsBeforeCollapse": {
                  "type": "number",
                  "default": 1
                },
                "itemsAfterCollapse": {
                  "type": "number",
                  "default": 1
                },
                "align": {
                  "type": "string",
                  "enum": [
                    "start",
                    "center",
                    "end"
                  ],
                  "description": "Alignment of breadcrumbs items updated to new approach"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "CaptchaProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "theme": {
                  "type": "string",
                  "enum": [
                    "light",
                    "dark"
                  ],
                  "default": "light",
                  "description": "When set changes the theme of the captcha (dark or light)"
                },
                "size": {
                  "type": "string",
                  "enum": [
                    "normal",
                    "compact"
                  ],
                  "default": "normal",
                  "description": "When set changes the size of the captcha (normal or compact)"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "CollapsibleTextProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "ellipsis": {
                  "type": "boolean",
                  "default": true
                },
                "showExpandControl": {
                  "type": "boolean",
                  "default": false
                },
                "direction": {
                  "type": "string",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "default": "ltr"
                },
                "align": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "default": "left"
                },
                "alignButton": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "default": "left"
                },
                "maxLines": {
                  "type": "number",
                  "default": 3
                },
                "wrappingStyle": {
                  "type": "string",
                  "enum": [
                    "single-line",
                    "multi-line"
                  ],
                  "default": "multi-line"
                },
                "expandControlSpacing": {
                  "type": "number",
                  "default": 10
                },
                "expandMode": {
                  "type": "string",
                  "enum": [
                    "button",
                    "link"
                  ],
                  "default": "link"
                },
                "isExpanded": {
                  "type": "boolean",
                  "default": false
                },
                "lastUserDefinedWidth": {
                  "type": "number",
                  "default": 300
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "HamburgerCloseButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/StylableButtonProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "HamburgerMenuContainerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "fullWidth": {
              "type": "boolean",
              "default": false
            }
          }
        }
      ],
      "type": "object"
    },
    "HamburgerOpenButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/StylableButtonProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "LineShareButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "buttonType": {
                  "type": "string",
                  "default": "button",
                  "enum": [
                    "button",
                    "classicWithButton",
                    "classicBig",
                    "classicMedium",
                    "classicSmall",
                    "bubbleBig",
                    "bubbleMedium",
                    "bubbleSmall"
                  ]
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "MusicPlayerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "layout": {
                  "type": "string",
                  "enum": [
                    "classic",
                    "icon"
                  ],
                  "default": "classic"
                },
                "source": {
                  "type": "string",
                  "enum": [
                    "uploads",
                    "url",
                    "wixMusic"
                  ],
                  "default": "uploads"
                },
                "showCover": {
                  "type": "boolean",
                  "default": true
                },
                "showArtistName": {
                  "type": "boolean",
                  "default": true
                },
                "showTrackName": {
                  "type": "boolean",
                  "default": true
                },
                "showProgressBar": {
                  "type": "boolean",
                  "default": true
                },
                "showTimeStamp": {
                  "type": "boolean",
                  "default": true
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": "Autoplay audio"
                },
                "loop": {
                  "type": "boolean",
                  "default": false,
                  "description": "Play audio on loop"
                },
                "showPlaylist": {
                  "type": "boolean",
                  "default": true,
                  "description": "Show Tracklist"
                },
                "playlistTracksInfo": {
                  "type": "string",
                  "enum": [
                    "trackName",
                    "trackNameAndArtistName"
                  ],
                  "default": "trackName",
                  "description": "Show track name or track name w/ artist name"
                },
                "playlistTracksAction": {
                  "type": "string",
                  "enum": [
                    "onActive",
                    "onAll"
                  ],
                  "default": "onActive",
                  "description": "Show track actions on active track or all tracks"
                },
                "playlistTrackSpacing": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 30,
                  "description": "How much vertical space must be between each track in playlist",
                  "default": 0
                },
                "iconId": {
                  "type": "string",
                  "default": "icon0",
                  "description": "Design IconLayout id"
                },
                "consentToShareAlbum": {
                  "type": "boolean",
                  "default": false,
                  "description": "Agreement to share album"
                },
                "consentToShareTracks": {
                  "type": "boolean",
                  "default": false,
                  "description": "Agreement to share tracks"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "PaginationProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showFirstLastNavButtons": {
                  "type": "boolean",
                  "default": false
                },
                "showFirstPage": {
                  "type": "boolean",
                  "default": false
                },
                "showLastPage": {
                  "type": "boolean",
                  "default": false
                },
                "showInputModeTotalPages": {
                  "type": "boolean",
                  "default": true
                },
                "paginationMode": {
                  "type": "string",
                  "enum": [
                    "pages",
                    "input",
                    "arrows"
                  ],
                  "default": "pages"
                },
                "navigationType": {
                  "type": "string",
                  "enum": [
                    "arrows",
                    "text"
                  ],
                  "default": "arrows"
                },
                "paginationDirection": {
                  "type": "string",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "default": "ltr"
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "spread",
                    "right"
                  ],
                  "default": "center"
                },
                "showPageNumbersBar": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ProGalleryProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "options": {
                  "type": "object",
                  "properties": {
                    "controllers_optionsMap_behaviourParams_item_video_volume": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_layoutParams_info_allowTitleAndDescription": {
                      "type": "string",
                      "default": ""
                    },
                    "layoutParams_structure_galleryLayout": {
                      "type": "number",
                      "default": 0
                    },
                    "layoutParams_structure_scrollDirection": {
                      "type": "string",
                      "default": "VERTICAL"
                    },
                    "layoutParams_structure_layoutOrientation": {
                      "type": "string",
                      "default": "VERTICAL"
                    },
                    "behaviourParams_gallery_layoutDirection": {
                      "type": "string",
                      "default": "LEFT_TO_RIGHT"
                    },
                    "layoutParams_structure_itemSpacing": {
                      "type": "number",
                      "default": 10
                    },
                    "layoutParams_structure_numberOfGridRows": {
                      "type": "number",
                      "default": 1
                    },
                    "layoutParams_structure_numberOfColumns": {
                      "type": "number",
                      "default": 3
                    },
                    "layoutParams_groups_density": {
                      "type": "number",
                      "default": 0.8
                    },
                    "layoutParams_targetItemSize_value": {
                      "type": "number",
                      "default": 48
                    },
                    "layoutParams_crop_method": {
                      "type": "string",
                      "default": "FILL"
                    },
                    "layoutParams_crop_ratios": {
                      "type": "number",
                      "default": 1
                    },
                    "layoutParams_structure_responsiveMode": {
                      "type": "string",
                      "default": "FIT_TO_SCREEN"
                    },
                    "layoutParams_thumbnails_alignment": {
                      "type": "string",
                      "default": "BOTTOM"
                    },
                    "layoutParams_thumbnails_size": {
                      "type": "number",
                      "default": 120
                    },
                    "layoutParams_thumbnails_spacing": {
                      "type": "number",
                      "default": 4
                    },
                    "controllers_layoutParams_thumbnails_marginToGallery": {
                      "type": "number",
                      "default": 4
                    },
                    "behaviourParams_gallery_vertical_loadMore_enable": {
                      "type": "boolean",
                      "default": false
                    },
                    "behaviourParams_gallery_vertical_loadMore_text": {
                      "type": "string",
                      "default": "Load More"
                    },
                    "behaviourParams_gallery_horizontal_navigationDuration": {
                      "type": "number",
                      "default": 800
                    },
                    "behaviourParams_gallery_horizontal_loop": {
                      "type": "boolean",
                      "default": false
                    },
                    "behaviourParams_gallery_horizontal_autoSlide_interval": {
                      "type": "number",
                      "default": 4
                    },
                    "behaviourParams_gallery_horizontal_autoSlide_speed": {
                      "type": "number",
                      "default": 50
                    },
                    "behaviourParams_gallery_horizontal_autoSlide_pauseOnHover": {
                      "type": "boolean",
                      "default": true
                    },
                    "behaviourParams_gallery_blockContextMenu": {
                      "type": "boolean",
                      "default": true
                    },
                    "layoutParams_navigationArrows_enable": {
                      "type": "boolean",
                      "default": true
                    },
                    "layoutParams_navigationArrows_size": {
                      "type": "number",
                      "default": 23
                    },
                    "layoutParams_navigationArrows_position": {
                      "type": "string",
                      "default": "ON_GALLERY"
                    },
                    "layoutParams_navigationArrows_container_type": {
                      "type": "string",
                      "default": "NONE"
                    },
                    "layoutParams_navigationArrows_mouseCursorContainerMaxWidth": {
                      "type": "string",
                      "default": "100"
                    },
                    "layoutParams_navigationArrows_verticalAlignment": {
                      "type": "string",
                      "default": "ITEM_CENTER"
                    },
                    "controllers_behaviourParams_item_overlay_hoverAnimationBehavior": {
                      "type": "string",
                      "default": "APPEARS"
                    },
                    "behaviourParams_item_content_hoverAnimation": {
                      "type": "string",
                      "default": "NO_EFFECT"
                    },
                    "behaviourParams_item_content_loader": {
                      "type": "string",
                      "default": "MAIN_COLOR"
                    },
                    "behaviourParams_item_content_placementAnimation": {
                      "type": "string",
                      "default": "NO_EFFECT"
                    },
                    "behaviourParams_gallery_scrollAnimation": {
                      "type": "string",
                      "default": "NO_EFFECT"
                    },
                    "behaviourParams_gallery_horizontal_slideAnimation": {
                      "type": "string",
                      "default": "SCROLL"
                    },
                    "behaviourParams_item_video_enablePlayButton": {
                      "type": "boolean",
                      "default": true
                    },
                    "behaviourParams_item_video_playTrigger": {
                      "type": "string",
                      "default": "HOVER"
                    },
                    "behaviourParams_item_video_speed": {
                      "type": "number",
                      "default": 1
                    },
                    "behaviourParams_item_video_volume": {
                      "type": "number",
                      "default": 0
                    },
                    "behaviourParams_item_video_loop": {
                      "type": "boolean",
                      "default": true
                    },
                    "behaviourParams_item_clickAction": {
                      "type": "string",
                      "default": "NOTHING"
                    },
                    "behaviourParams_item_content_magnificationValue": {
                      "type": "number",
                      "default": 2
                    },
                    "layoutParams_navigationArrows_padding": {
                      "type": "number",
                      "default": 23
                    },
                    "behaviourParams_gallery_vertical_loadMore_amount": {
                      "type": "string",
                      "default": "ALL"
                    },
                    "behaviourParams_gallery_horizontal_autoSlide_behaviour": {
                      "type": "string",
                      "default": "OFF"
                    },
                    "behaviourParams_gallery_horizontal_slideTransition": {
                      "type": "string",
                      "default": "cubic-bezier(0.46,0.1,0.25,1)"
                    },
                    "controllers_layoutParams_external_info_placement": {
                      "type": "string",
                      "default": "BELOW"
                    },
                    "controllers_layoutParams_external_info_CustomButtonHorizontalAlignment": {
                      "type": "string",
                      "default": "CENTER"
                    },
                    "controllers_layoutParams_internal_info_CustomButtonHorizontalAlignment": {
                      "type": "string",
                      "default": "CENTER"
                    },
                    "controllers_layoutParams_internal_info_CustomButtonCustomButtonText": {
                      "type": "string",
                      "default": "Click here"
                    },
                    "controllers_layoutParams_external_info_CustomButtonCustomButtonText": {
                      "type": "string",
                      "default": "Click here"
                    },
                    "controllers_layoutParams_external_info_SocialButtonsHorizontalAlignment": {
                      "type": "string",
                      "default": "LEFT"
                    },
                    "controllers_layoutParams_internal_info_SocialButtonsHorizontalAlignment": {
                      "type": "string",
                      "default": "LEFT"
                    },
                    "layoutParams_info_placement": {
                      "type": "string",
                      "default": "OVERLAY"
                    },
                    "controllers_layoutParams_info_allowTitle": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_layoutParams_info_allowDescription": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_layoutParams_info_verticalPadding": {
                      "type": "number",
                      "default": 0
                    },
                    "controllers_layoutParams_info_horizontalPadding": {
                      "type": "number",
                      "default": 0
                    },
                    "controllers_layoutParams_infoElementOptions_external_enabled": {
                      "type": "string",
                      "default": ""
                    },
                    "controllers_layoutParams_infoElementOptions_internal_enabled": {
                      "type": "string",
                      "default": ""
                    },
                    "controllers_experimental_useNewInfo": {
                      "type": "string",
                      "default": ""
                    },
                    "controllers_layoutParams_infoElementOptions_external_order": {
                      "type": "string",
                      "default": "top,Title,Description,CustomButton,middle,bottom,Social"
                    },
                    "controllers_layoutParams_infoElementOptions_internal_order": {
                      "type": "string",
                      "default": "top,Title,Description,CustomButton,middle,bottom,Social"
                    },
                    "controllers_layoutParams_info_verticalAlignment": {
                      "type": "string",
                      "default": "CENTER"
                    },
                    "controllers_layoutParams_info_horizontalAlignment": {
                      "type": "string",
                      "default": "CENTER"
                    },
                    "controllers_layoutParams_structure_imageWidth_method": {
                      "type": "string",
                      "default": "FIXED"
                    },
                    "controllers_layoutParams_structure_numberOfDisplayedItems": {
                      "type": "number",
                      "default": 3
                    },
                    "layoutParams_info_sizeUnits": {
                      "type": "string",
                      "default": "PIXEL"
                    },
                    "layoutParams_info_height": {
                      "type": "number",
                      "default": 200
                    },
                    "controllers_layoutParams_info_width_pixel": {
                      "type": "number",
                      "default": 200
                    },
                    "controllers_layoutParams_info_width_percent": {
                      "type": "number",
                      "default": 50
                    },
                    "behaviourParams_item_overlay_hoveringBehaviour": {
                      "type": "string",
                      "default": "NEVER_SHOW"
                    },
                    "controllers_behaviourParams_item_overlay_overlayType": {
                      "type": "string",
                      "default": "FULL"
                    },
                    "behaviourParams_item_overlay_sizeUnits": {
                      "type": "string",
                      "default": "PERCENT"
                    },
                    "controllers_behaviourParams_item_overlay_size_percent": {
                      "type": "number",
                      "default": 100
                    },
                    "controllers_behaviourParams_item_overlay_size_pixel": {
                      "type": "number",
                      "default": 100
                    },
                    "behaviourParams_item_overlay_position": {
                      "type": "string",
                      "default": "BOTTOM"
                    },
                    "behaviourParams_item_overlay_padding": {
                      "type": "number",
                      "default": 0
                    },
                    "behaviourParams_item_secondaryMedia_enableHoverTrigger": {
                      "type": "boolean",
                      "default": false
                    },
                    "behaviourParams_item_overlay_hoverAnimation": {
                      "type": "string",
                      "default": "NO_EFFECT"
                    },
                    "controllers_layoutParams_structure_galleryRatio_method": {
                      "type": "string",
                      "default": "MANUAL"
                    },
                    "controllers_layoutParams_structure_galleryRatio_value": {
                      "type": "number",
                      "default": 1
                    },
                    "controllers_fullscreen_allowTitleExpand": {
                      "type": "boolean",
                      "default": true
                    },
                    "controllers_behaviourParams_item_overlay_enabled": {
                      "type": "boolean",
                      "default": true
                    },
                    "controllers_layoutParams_info_newInfo_external_enabled": {
                      "type": "boolean",
                      "default": true
                    },
                    "controllers_fullscreen_allowDescriptionExpand": {
                      "type": "boolean",
                      "default": true
                    },
                    "controllers_fullscreen_allowLinkExpand": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_fullscreen_expandInfoPosition": {
                      "type": "string",
                      "default": "SIDE"
                    },
                    "controllers_fullscreen_showInfoExpandButton": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_fullscreen_whenToShowInfo": {
                      "type": "string",
                      "default": "ALWAYS"
                    },
                    "controllers_fullscreen_allowFullscreenExpand": {
                      "type": "boolean",
                      "default": true
                    },
                    "controllers_fullscreen_fullscreenLoop": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_fullscreen_allowFullscreenMagnifyImage": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_fullscreen_fullscreenMagnificationLevel": {
                      "type": "number",
                      "default": 2
                    },
                    "controllers_fullscreen_fullscreenMagnificationPercent": {
                      "type": "number",
                      "default": 200
                    },
                    "controllers_fullscreen_backgroundBlurFilter": {
                      "type": "number",
                      "default": 1
                    },
                    "controllers_fullscreen_backgroundGrayscaleFilter": {
                      "type": "boolean",
                      "default": false
                    },
                    "controllers_showManageMedia": {
                      "type": "boolean",
                      "default": false
                    },
                    "variant_count": {
                      "type": "number",
                      "default": 0
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ProgressBarProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ],
                  "default": "ltr"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RangeSliderProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "align": {
                  "type": "string",
                  "enum": [
                    "start",
                    "center",
                    "end"
                  ],
                  "description": "Alignment of range slider"
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RatingsDisplayProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showReviewsCount": {
                  "type": "boolean",
                  "default": true
                },
                "showRating": {
                  "type": "boolean",
                  "default": true
                },
                "noReviewsMode": {
                  "type": "string",
                  "enum": [
                    "nothing",
                    "emptyIcons",
                    "placeholderText"
                  ],
                  "default": "emptyIcons"
                },
                "ratingPosition": {
                  "type": "string",
                  "enum": [
                    "before",
                    "after"
                  ],
                  "default": "before"
                },
                "shapeSize": {
                  "type": "number",
                  "minimum": 15,
                  "maximum": 100,
                  "default": 24
                },
                "shapeSpacing": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 50,
                  "default": 5
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "default": "left"
                },
                "direction": {
                  "type": "string",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "default": "ltr"
                },
                "renderSeo": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RatingsInputProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showTitle": {
                  "type": "boolean",
                  "default": true
                },
                "showLabels": {
                  "type": "boolean",
                  "default": true
                },
                "labelPosition": {
                  "type": "string",
                  "enum": [
                    "top",
                    "bottom",
                    "side"
                  ],
                  "default": "top"
                },
                "a11yLabelPosition": {
                  "type": "string",
                  "enum": [
                    "top",
                    "bottom",
                    "side"
                  ],
                  "default": "side"
                },
                "labelAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "center"
                },
                "a11yLabelAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "center"
                },
                "shapeSize": {
                  "type": "number",
                  "minimum": 15,
                  "maximum": 100,
                  "default": 24
                },
                "shapeSpacing": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 50,
                  "default": 5
                },
                "direction": {
                  "type": "string",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "default": "ltr"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RichTextBoxProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "textAlignment": {
                  "type": "string",
                  "default": "left",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "description": "the text alignment",
                  "maxLength": 100
                },
                "textPadding": {
                  "type": "number",
                  "default": 18,
                  "minimum": 0,
                  "maximum": 100,
                  "description": "the value of the textPadding"
                },
                "toolbarPosition": {
                  "type": "string",
                  "default": "top",
                  "enum": [
                    "top",
                    "bottom",
                    "inline"
                  ],
                  "description": "the location of the toolbar",
                  "maxLength": 20
                },
                "placeholder": {
                  "type": "string",
                  "description": "the placeholder",
                  "default": "",
                  "maxLength": 4000
                },
                "defaultTextType": {
                  "type": "string",
                  "default": "placeholderText",
                  "enum": [
                    "none",
                    "initialText",
                    "placeholderText",
                    "placeholderAndInitialText"
                  ],
                  "description": "the type of the default text for the input",
                  "maxLength": 100
                },
                "allowLinks": {
                  "type": "boolean",
                  "description": "Are links allowed"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SearchBoxProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "layout": {
                  "type": "string",
                  "enum": [
                    "icon",
                    "button",
                    "icon-only",
                    "expandable"
                  ],
                  "default": "icon"
                },
                "iconAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left"
                },
                "textAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center"
                  ],
                  "default": "left"
                },
                "textSpacing": {
                  "type": "number",
                  "default": 12,
                  "description": "Setting the spacing from the side the text is aligned to",
                  "minimum": 0,
                  "maximum": 50
                },
                "iconSpacing": {
                  "type": "number",
                  "default": 12,
                  "description": "In icon layout affects the side to which the icon is aligend to, for button layout affects both - left and right sides",
                  "minimum": 0,
                  "maximum": 50
                },
                "trendingItemsEnabled": {
                  "type": "boolean",
                  "default": true,
                  "description": "Controls trending items visibility."
                },
                "isExpandable": {
                  "type": "boolean",
                  "default": false,
                  "description": "Is component able to expand/collapse"
                },
                "expandedDirection": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left",
                  "description": "Which direction the component should expand to"
                },
                "expandedWidth": {
                  "type": "number",
                  "default": 100,
                  "description": "What's the expanded component width",
                  "minimum": 0,
                  "maximum": 1000
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SearchButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/StylableButtonProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SelectionTagsListProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ],
                  "default": "ltr",
                  "description": "Direction of tags"
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left",
                  "description": "Alignment of tags"
                },
                "hasAutoHeight": {
                  "type": "boolean",
                  "description": "used in mapper to avoid adding min-height property"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SignatureInputProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ]
                },
                "required": {
                  "type": "boolean"
                },
                "titlePaddingStart": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "titleMarginBottom": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "labelMobileFontSize": {
                  "type": "number"
                },
                "inputMobileFontSize": {
                  "type": "number"
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SingleTabProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isParentFullWidth": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "SliderProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "trackSize": {
                  "type": "number",
                  "default": 25
                },
                "orientation": {
                  "type": "string",
                  "enum": [
                    "horizontal",
                    "vertical"
                  ],
                  "default": "horizontal"
                },
                "thumbShape": {
                  "type": "string",
                  "enum": [
                    "circle",
                    "square",
                    "rectangle",
                    "bar"
                  ],
                  "default": "circle"
                },
                "thumbSize": {
                  "type": "number",
                  "minimum": 18,
                  "maximum": 100,
                  "description": "Size of the slider thumb"
                },
                "tickMarksShape": {
                  "type": "string",
                  "enum": [
                    "none",
                    "line",
                    "dot"
                  ],
                  "default": "line"
                },
                "tooltipVisibility": {
                  "type": "string",
                  "enum": [
                    "none",
                    "hover",
                    "always"
                  ],
                  "default": "hover"
                },
                "tooltipPosition": {
                  "type": "string",
                  "enum": [
                    "normal",
                    "across"
                  ],
                  "default": "normal"
                },
                "tooltipPrefix": {
                  "type": "string",
                  "maxLength": 30
                },
                "tooltipSuffix": {
                  "type": "string",
                  "maxLength": 30
                },
                "tickMarksPosition": {
                  "type": "string",
                  "enum": [
                    "normal",
                    "middle",
                    "across"
                  ],
                  "default": "normal"
                },
                "dir": {
                  "type": "string",
                  "enum": [
                    "ltr",
                    "rtl"
                  ],
                  "default": "ltr"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SlideshowProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "required": [
            "isHidden",
            "isCollapsed"
          ],
          "type": "object",
          "properties": {
            "isHidden": {
              "type": "boolean"
            },
            "isCollapsed": {
              "type": "boolean"
            },
            "type": {
              "default": "SlideshowProperties",
              "maxLength": 120,
              "type": "string"
            },
            "isPlaying": {
              "default": true,
              "type": "boolean"
            },
            "slideDuration": {
              "default": 5,
              "minimum": 1,
              "maximum": 30,
              "type": "number"
            },
            "pauseOnHover": {
              "default": true,
              "type": "boolean"
            },
            "showPlaybackControl": {
              "default": false,
              "type": "boolean"
            },
            "loop": {
              "default": true,
              "type": "boolean"
            },
            "previewItemId": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "SlideshowButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "action": {
                  "type": "string",
                  "enum": [
                    "prev",
                    "next"
                  ],
                  "default": "next"
                }
              }
            },
            {
              "$ref": "#/StylableButtonProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SocialAuthProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "isSmallIcons": {
                  "type": "boolean",
                  "default": true
                },
                "isSocialLoginGoogleEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "isSocialLoginFacebookEnabled": {
                  "type": "boolean",
                  "default": true
                },
                "mode": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "enum": [
                    "signup",
                    "login"
                  ]
                },
                "formType": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "enum": [
                    "default",
                    "custom",
                    "corvid"
                  ],
                  "default": "corvid"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "StylableButtonProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "iconCollapsed": {
                  "type": "boolean",
                  "default": false
                },
                "isMaxContent": {
                  "type": "boolean",
                  "default": false
                },
                "isWrapText": {
                  "type": "boolean",
                  "default": false
                }
              }
            },
            {
              "$ref": "#/DisableableProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "StylableHorizontalMenuProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "menuMode": {
                  "type": "string",
                  "enum": [
                    "wrap",
                    "scroll"
                  ],
                  "default": "wrap"
                },
                "submenuMode": {
                  "type": "string",
                  "enum": [
                    "columnMenu",
                    "columnStretched",
                    "flyout"
                  ],
                  "description": "Submenu view modes",
                  "default": "columnMenu"
                },
                "slotMap": {
                  "type": "object",
                  "unevaluatedProperties": false
                },
                "isContainerStretched": {
                  "type": "boolean",
                  "default": true
                },
                "submenuOrder": {
                  "type": "string",
                  "enum": [
                    "vertical",
                    "horizontal"
                  ],
                  "description": "Submenu items order",
                  "default": "vertical"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "TabsProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "itemSpacing": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 0
                },
                "itemRowSpacing": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 0
                },
                "containerSpacing": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 0
                },
                "tabWidth": {
                  "type": "number",
                  "minimum": 10,
                  "maximum": 500
                },
                "stretchTabsToMenuWidth": {
                  "type": "boolean",
                  "default": false
                },
                "fitTabsToTextWidth": {
                  "type": "boolean",
                  "default": false
                },
                "itemsOrientation": {
                  "type": "string",
                  "enum": [
                    "horizontal",
                    "vertical"
                  ],
                  "default": "horizontal"
                },
                "itemsAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left"
                },
                "contentAlignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left"
                },
                "itemsLogicalAlign": {
                  "type": "string",
                  "enum": [
                    "start",
                    "center",
                    "end"
                  ],
                  "default": "start"
                },
                "contentLogicalAlign": {
                  "type": "string",
                  "enum": [
                    "start",
                    "center",
                    "end"
                  ],
                  "default": "start"
                },
                "horizontalTabPadding": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 20
                },
                "verticalTabPadding": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 20
                },
                "menuMode": {
                  "type": "string",
                  "enum": [
                    "wrap",
                    "scroll"
                  ],
                  "default": "scroll"
                },
                "itemsDirection": {
                  "type": "string",
                  "enum": [
                    "rtl",
                    "ltr"
                  ],
                  "default": "ltr"
                },
                "tabEnterAnimationName": {
                  "type": "string",
                  "enum": [
                    "none",
                    "fadeIn",
                    "floatFromTop",
                    "floatFromBottom"
                  ],
                  "default": "none",
                  "description": "The animation that will be played when a tab is entered"
                },
                "tabExitAnimationName": {
                  "type": "string",
                  "enum": [
                    "none",
                    "fadeOut"
                  ],
                  "default": "none",
                  "description": "The animation that will be played when a tab is exited"
                },
                "animationDuration": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 5,
                  "default": 0.3,
                  "description": "Duration of the transition in sec"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "TimePickerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right"
                  ],
                  "default": "left"
                },
                "useAmPmFormat": {
                  "type": "boolean",
                  "default": false,
                  "description": "Should the display format be 12 hours (or 24)"
                },
                "controller": {
                  "type": "string",
                  "enum": [
                    "text",
                    "stepper",
                    "dropdown"
                  ],
                  "default": "text",
                  "description": "The display of the time picker"
                },
                "initialTime": {
                  "type": "string",
                  "enum": [
                    "none",
                    "current",
                    "value",
                    "placeholder"
                  ],
                  "default": "current",
                  "description": "What the time picker should display on load"
                },
                "margin": {
                  "type": "number",
                  "multipleOf": 1,
                  "description": ""
                },
                "disabledTimes": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "required": [
                      "startTime",
                      "endTime"
                    ],
                    "properties": {
                      "startTime": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "endTime": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  },
                  "default": [],
                  "maxItems": 5,
                  "description": "array of disabled times"
                },
                "enabledTimes": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "required": [
                      "startTime",
                      "endTime"
                    ],
                    "properties": {
                      "startTime": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "endTime": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  },
                  "default": [],
                  "maxItems": 5,
                  "description": "array of enabled times"
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ToggleSwitchProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "displayKnobIcons": {
                  "type": "boolean"
                },
                "trackHeight": {
                  "type": "number",
                  "default": 100
                },
                "knobSize": {
                  "type": "number",
                  "default": 90
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "right"
                  ],
                  "default": "left"
                },
                "switchHeight": {
                  "type": "number",
                  "default": 24
                }
              }
            },
            {
              "$ref": "#/InputProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "VideoPlayerProperties--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/PropDataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "showVideoTitle": {
                  "type": "boolean",
                  "default": true
                },
                "autoplay": {
                  "type": "boolean",
                  "default": false,
                  "description": "Autoplay video"
                },
                "loop": {
                  "type": "boolean",
                  "default": false,
                  "description": "Play video on loop"
                },
                "share": {
                  "type": "boolean",
                  "default": true,
                  "description": "Allow to share video"
                },
                "controlsVisibility": {
                  "type": "string",
                  "enum": [
                    "hover",
                    "never"
                  ],
                  "default": "hover"
                },
                "animatePoster": {
                  "type": "string",
                  "enum": [
                    "fade",
                    "none"
                  ],
                  "default": "none",
                  "description": "Animate video poster"
                }
              }
            },
            {
              "$ref": "#/DefaultProperties--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    }
  },
  "connections_data.json": {
    "$id": "urn:dm:schemas:connections_data.json",
    "ConnectionList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "type": "array",
              "items": {
                "type": "object",
                "anyOf": [
                  {
                    "$ref": "#/ConnectionItem--unrestricted-root"
                  },
                  {
                    "$ref": "#/WixCodeConnectionItem--unrestricted-root"
                  }
                ],
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ConnectionItem": {
      "type": "object",
      "required": [
        "controllerId"
      ],
      "properties": {
        "controllerId": {
          "$ref": "urn:dm:schemas:common.json#/weakReference"
        },
        "isPrimary": {
          "type": "boolean"
        },
        "config": {
          "type": "string",
          "maxLength": 2000
        },
        "subRole": {
          "type": "string",
          "maxLength": 100
        },
        "role": {
          "type": "string"
        },
        "type": {
          "type": "string",
          "enum": [
            "ConnectionItem"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "WixCodeConnectionItem": {
      "type": "object",
      "properties": {
        "role": {
          "type": "string"
        },
        "type": {
          "type": "string",
          "enum": [
            "WixCodeConnectionItem"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "ConnectionList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "type": "array",
              "items": {
                "type": "object",
                "anyOf": [
                  {
                    "$ref": "#/ConnectionItem--unrestricted-root"
                  },
                  {
                    "$ref": "#/WixCodeConnectionItem--unrestricted-root"
                  }
                ],
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "type": "object"
    },
    "ConnectionItem--unrestricted-root": {
      "type": "object",
      "required": [
        "controllerId"
      ],
      "properties": {
        "controllerId": {
          "$ref": "urn:dm:schemas:common.json#/weakReference"
        },
        "isPrimary": {
          "type": "boolean"
        },
        "config": {
          "type": "string",
          "maxLength": 2000
        },
        "subRole": {
          "type": "string",
          "maxLength": 100
        },
        "role": {
          "type": "string"
        },
        "type": {
          "type": "string",
          "enum": [
            "ConnectionItem"
          ]
        }
      }
    },
    "WixCodeConnectionItem--unrestricted-root": {
      "type": "object",
      "properties": {
        "role": {
          "type": "string"
        },
        "type": {
          "type": "string",
          "enum": [
            "WixCodeConnectionItem"
          ]
        }
      }
    }
  },
  "contentRole.json": {
    "$id": "urn:dm:schemas:contentRole.json",
    "ContainerRole": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "contentRole",
            "complexity"
          ],
          "properties": {
            "contentRole": {
              "type": "string",
              "maxLength": 50
            },
            "fieldRole": {
              "type": "string",
              "maxLength": 50
            },
            "listRole": {
              "type": "string",
              "maxLength": 30
            },
            "complexity": {
              "type": "string",
              "maxLength": 30
            },
            "allowedFlows": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Field": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "fieldRole"
          ],
          "properties": {
            "fieldRole": {
              "type": "string",
              "maxLength": 50
            },
            "listItemId": {
              "type": "number",
              "minimum": 0,
              "maximum": 128
            },
            "allowedFlows": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ContainerRole--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "contentRole",
            "complexity"
          ],
          "properties": {
            "contentRole": {
              "type": "string",
              "maxLength": 50
            },
            "fieldRole": {
              "type": "string",
              "maxLength": 50
            },
            "listRole": {
              "type": "string",
              "maxLength": 30
            },
            "complexity": {
              "type": "string",
              "maxLength": 30
            },
            "allowedFlows": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          }
        }
      ],
      "type": "object"
    },
    "Field--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "fieldRole"
          ],
          "properties": {
            "fieldRole": {
              "type": "string",
              "maxLength": 50
            },
            "listItemId": {
              "type": "number",
              "minimum": 0,
              "maximum": 128
            },
            "allowedFlows": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "contexts.json": {
    "$id": "urn:dm:schemas:contexts.json",
    "ContextsList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Ref List of contexts attached to a container",
          "type": "object",
          "properties": {
            "values": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ContextConfig": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "referredType",
            "contextType"
          ],
          "properties": {
            "referredType": {
              "type": "string"
            },
            "contextType": {
              "type": "string"
            },
            "data": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            },
            "bindings": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ContextsList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Ref List of contexts attached to a container",
          "type": "object",
          "properties": {
            "values": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "ContextConfig--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "referredType",
            "contextType"
          ],
          "properties": {
            "referredType": {
              "type": "string"
            },
            "contextType": {
              "type": "string"
            },
            "data": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            },
            "bindings": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "controllers.json": {
    "$id": "urn:dm:schemas:controllers.json",
    "ControllerList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "controllers": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ControllerList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "controllers": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "css-value-definitions.schema.json": {
    "$id": "urn:dm:schemas:css-value-definitions.schema.json",
    "title": "CSS Value Definitions",
    "description": "Individual JSON Schema definitions for CSS value types, suitable for format registration",
    "definitions": {
      "<positive-value>": {
        "type": "string",
        "pattern": "^[^-]",
        "description": "CSS positive value"
      },
      "<length>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<basic-math-functions-without-percentage>"
          },
          {
            "type": "string",
            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
          }
        ],
        "description": "CSS numeric length with all valid units"
      },
      "<positive-length>": {
        "allOf": [
          {
            "$ref": "#/definitions/<positive-value>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS positive numeric length with all valid units"
      },
      "<percentage>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<basic-math-functions>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+%$"
          }
        ],
        "description": "Number followed by %"
      },
      "<positive-percentage>": {
        "allOf": [
          {
            "$ref": "#/definitions/<positive-value>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "Positive number followed by %"
      },
      "<length-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "Accepts both <length> and <percentage>"
      },
      "<positive-length-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "$ref": "#/definitions/<positive-percentage>"
          }
        ],
        "description": "Accepts both <positive-length> and <positive-percentage>"
      },
      "<auto>": {
        "type": "string",
        "enum": [
          "auto"
        ],
        "description": "CSS auto keyword"
      },
      "<length-percentage-auto>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          },
          {
            "$ref": "#/definitions/<auto>"
          }
        ],
        "description": "CSS length, percentage, or auto"
      },
      "<positive-length-percentage-auto>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "$ref": "#/definitions/<positive-percentage>"
          },
          {
            "$ref": "#/definitions/<auto>"
          }
        ],
        "description": "CSS positive length, positive percentage, or auto"
      },
      "<number>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<all-math-functions-without-percentage>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+$"
          }
        ],
        "description": "Decimal or integer number"
      },
      "<positive-number>": {
        "allOf": [
          {
            "$ref": "#/definitions/<positive-value>"
          },
          {
            "$ref": "#/definitions/<number>"
          }
        ],
        "description": "Positive decimal or integer number"
      },
      "<integer>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<all-math-functions-without-percentage>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d+$"
          }
        ],
        "description": "Whole numbers only"
      },
      "height": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content"
            ]
          }
        ],
        "description": "CSS height value"
      },
      "<angle>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<all-math-functions>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(deg|rad|grad|turn)$"
          }
        ],
        "description": "Used in rotation, direction, etc."
      },
      "<time>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<basic-math-functions-without-percentage>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(ms|s)$"
          }
        ],
        "description": "CSS durations (s, ms)"
      },
      "<resolution>": {
        "type": "string",
        "pattern": "^-?\\d*\\.?\\d+(dpi|dpcm|dppx|x)$",
        "description": "Screen density/resolution units"
      },
      "<frequency>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<basic-math-functions>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(Hz|kHz)$"
          }
        ],
        "description": "Used in aural CSS or media queries"
      },
      "<dimension>": {
        "type": "string",
        "pattern": "^-?\\d*\\.?\\d+[a-zA-Z]+$",
        "description": "Generic dimension (unit required)"
      },
      "<percentage-or-number>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "Matches numbers or percentages"
      },
      "<custom-ident>": {
        "type": "string",
        "pattern": "^[a-zA-Z_][\\w-]*$",
        "description": "CSS identifiers (excluding keywords)"
      },
      "<ident>": {
        "type": "string",
        "pattern": "^[a-zA-Z_][\\w-]*$",
        "description": "Same as <custom-ident>"
      },
      "<string>": {
        "type": "string",
        "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
        "description": "Quoted strings with escapes"
      },
      "<url>": {
        "type": "string",
        "pattern": "^url\\((['\"]?).*?\\1\\)$",
        "description": "Matches url(...) with optional quotes"
      },
      "<hex-color>": {
        "type": "string",
        "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
        "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
      },
      "<rgb-color>": {
        "type": "string",
        "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
        "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
      },
      "<hsl-color>": {
        "type": "string",
        "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
        "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
      },
      "<named-color>": {
        "type": "string",
        "enum": [
          "transparent",
          "currentColor",
          "aliceblue",
          "antiquewhite",
          "aqua",
          "aquamarine",
          "azure",
          "beige",
          "bisque",
          "black",
          "blanchedalmond",
          "blue",
          "blueviolet",
          "brown",
          "burlywood",
          "cadetblue",
          "chartreuse",
          "chocolate",
          "coral",
          "cornflowerblue",
          "cornsilk",
          "crimson",
          "cyan",
          "darkblue",
          "darkcyan",
          "darkgoldenrod",
          "darkgray",
          "darkgrey",
          "darkgreen",
          "darkkhaki",
          "darkmagenta",
          "darkolivegreen",
          "darkorange",
          "darkorchid",
          "darkred",
          "darksalmon",
          "darkseagreen",
          "darkslateblue",
          "darkslategray",
          "darkslategrey",
          "darkturquoise",
          "darkviolet",
          "deeppink",
          "deepskyblue",
          "dimgray",
          "dimgrey",
          "dodgerblue",
          "firebrick",
          "floralwhite",
          "forestgreen",
          "fuchsia",
          "gainsboro",
          "ghostwhite",
          "gold",
          "goldenrod",
          "gray",
          "grey",
          "green",
          "greenyellow",
          "honeydew",
          "hotpink",
          "indianred",
          "indigo",
          "ivory",
          "khaki",
          "lavender",
          "lavenderblush",
          "lawngreen",
          "lemonchiffon",
          "lightblue",
          "lightcoral",
          "lightcyan",
          "lightgoldenrodyellow",
          "lightgray",
          "lightgrey",
          "lightgreen",
          "lightpink",
          "lightsalmon",
          "lightseagreen",
          "lightskyblue",
          "lightslategray",
          "lightslategrey",
          "lightsteelblue",
          "lightyellow",
          "lime",
          "limegreen",
          "linen",
          "magenta",
          "maroon",
          "mediumaquamarine",
          "mediumblue",
          "mediumorchid",
          "mediumpurple",
          "mediumseagreen",
          "mediumslateblue",
          "mediumspringgreen",
          "mediumturquoise",
          "mediumvioletred",
          "midnightblue",
          "mintcream",
          "mistyrose",
          "moccasin",
          "navajowhite",
          "navy",
          "oldlace",
          "olive",
          "olivedrab",
          "orange",
          "orangered",
          "orchid",
          "palegoldenrod",
          "palegreen",
          "paleturquoise",
          "palevioletred",
          "papayawhip",
          "peachpuff",
          "peru",
          "pink",
          "plum",
          "powderblue",
          "purple",
          "rebeccapurple",
          "red",
          "rosybrown",
          "royalblue",
          "saddlebrown",
          "salmon",
          "sandybrown",
          "seagreen",
          "seashell",
          "sienna",
          "silver",
          "skyblue",
          "slateblue",
          "slategray",
          "slategrey",
          "snow",
          "springgreen",
          "steelblue",
          "tan",
          "teal",
          "thistle",
          "tomato",
          "turquoise",
          "violet",
          "wheat",
          "white",
          "whitesmoke",
          "yellow",
          "yellowgreen"
        ],
        "description": "CSS named colors including transparent and currentColor"
      },
      "<color>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<hex-color>"
          },
          {
            "$ref": "#/definitions/<rgb-color>"
          },
          {
            "$ref": "#/definitions/<hsl-color>"
          },
          {
            "$ref": "#/definitions/<named-color>"
          }
        ],
        "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
      },
      "<image>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<url>"
          },
          {
            "type": "string",
            "pattern": "^(linear-gradient|radial-gradient|conic-gradient|repeating-linear-gradient|repeating-radial-gradient|repeating-conic-gradient)\\(.*\\)$",
            "description": "Gradient functions - arguments cannot be fully validated with regex"
          },
          {
            "type": "string",
            "pattern": "^image\\(.*\\)$",
            "description": "Image function - arguments cannot be fully validated with regex"
          }
        ],
        "description": "CSS image values including URLs, gradients, and image() functions"
      },
      "<position>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<position-one>"
          },
          {
            "$ref": "#/definitions/<position-two>"
          },
          {
            "$ref": "#/definitions/<position-four>"
          }
        ],
        "description": "Single position value. Full position syntax with multiple values and combinations requires complex parsing that cannot be fully validated with regex."
      },
      "<position-one>": {
        "anyOf": [
          {
            "enum": [
              "left",
              "center",
              "right",
              "top",
              "bottom",
              "x-start",
              "x-end",
              "y-start",
              "y-end",
              "block-start",
              "block-end",
              "inline-start",
              "inline-end"
            ]
          },
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          }
        ]
      },
      "<position-two>": {
        "anyOf": [
          {
            "pattern": "^(((left|center|right|x-start|x-end)\\s(top|center|bottom|y-start|y-end))|((top|center|bottom|y-start|y-end)\\s(left|center|right|x-start|x-end)))$"
          },
          {
            "pattern": "^(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))$"
          },
          {
            "pattern": "^((block-start|center|block-end)\\s(inline-start|center|inline-end))|((inline-start|center|inline-end)\\s(block-start|center|block-end))$"
          },
          {
            "pattern": "^((start|center|end)\\s*){2}$"
          }
        ]
      },
      "<position-four>": {
        "anyOf": [
          {
            "pattern": "^((left|right|x-start|x-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(top|bottom|y-start|y-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))|((top|bottom|y-start|y-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(left|right|x-start|x-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))$"
          },
          {
            "pattern": "^((block-start|block-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(inline-start|inline-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))|((inline-start|inline-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(block-start|block-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))$"
          },
          {
            "pattern": "^((start|end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s*){2}$"
          }
        ]
      },
      "<transform-function>": {
        "type": "string",
        "pattern": "^(matrix|matrix3d|perspective|rotate|rotate3d|rotateX|rotateY|rotateZ|scale|scale3d|scaleX|scaleY|scaleZ|skew|skewX|skewY|translate|translate3d|translateX|translateY|translateZ)\\(.*\\)$",
        "description": "Transform functions like rotate(), translate(), scale(). Function arguments cannot be fully validated with regex as they require parsing of nested expressions."
      },
      "<var()>": {
        "type": "string",
        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
        "description": "CSS var() function- resolving a variable value from the variable"
      },
      "<basic-math-functions>": {
        "type": "string",
        "pattern": "^(calc|min|max|clamp|round|mod|rem|abs)\\((?!.*\\/\\s*0\\b).+\\)$",
        "description": "Basic CSS math functions that work with any value type. Percentages allowed where contextually appropriate."
      },
      "<basic-math-functions-without-percentage>": {
        "type": "string",
        "pattern": "^(calc|min|max|clamp|round|mod|rem|abs)\\((?!.*\\/\\s*0\\b)[^%]+\\)$",
        "description": "Basic CSS math functions without percentages or division by zero."
      },
      "<basic-math-functions-with-percentage>": {
        "type": "string",
        "pattern": "(calc|min|max|clamp|round|mod|rem|abs)\\([^)]*%[^)]*\\)",
        "description": "Detects if any basic math function contains percentages"
      },
      "<all-math-functions>": {
        "type": "string",
        "pattern": "^(calc|min|max|clamp|round|mod|rem|abs|sin|cos|tan|asin|acos|atan|atan2|pow|sqrt|hypot|log|exp|sign)\\((?!.*\\/\\s*0\\b).+\\)$",
        "description": "All CSS math functions - basic, trigonometric, and advanced mathematical functions."
      },
      "<all-math-functions-without-percentage>": {
        "type": "string",
        "pattern": "^(calc|min|max|clamp|round|mod|rem|abs|sin|cos|tan|asin|acos|atan|atan2|pow|sqrt|hypot|log|exp|sign)\\((?!.*\\/\\s*0\\b)(?!.*%).+\\)$",
        "description": "All CSS math functions without percentages or division by zero."
      },
      "<attr()>": {
        "type": "string",
        "pattern": "^attr\\(.*\\)$",
        "description": "CSS attr() function. Cannot fully validate fallback values and type hints with regex."
      },
      "<image-set()>": {
        "type": "string",
        "pattern": "^image-set\\(.*\\)$",
        "description": "CSS image-set() function. Cannot parse comma-separated URLs and resolution descriptors with regex."
      },
      "<basic-shape>": {
        "type": "string",
        "pattern": "^(inset|rect|xywh|circle|ellipse|polygon|path|shape)\\(.*\\)$",
        "description": "CSS basic shape functions. Shape-specific arguments cannot be fully validated with regex."
      },
      "<filter-function>": {
        "type": "string",
        "pattern": "^(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\)$",
        "description": "CSS filter functions. Function arguments cannot be fully validated with regex."
      },
      "<filter-value-list>": {
        "type": "string",
        "pattern": "^((blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))(\\s+(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))*$",
        "description": "CSS filter functions - value separated list. Function arguments cannot be fully validated with regex."
      },
      "<filter>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<filter-value-list>"
          }
        ],
        "description": "CSS filter value"
      },
      "<line-width>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "type": "string",
            "enum": [
              "thin",
              "medium",
              "thick"
            ]
          }
        ],
        "description": "CSS line width: length values or predefined keywords"
      },
      "<line-style>": {
        "type": "string",
        "enum": [
          "none",
          "hidden",
          "dotted",
          "dashed",
          "solid",
          "double",
          "groove",
          "ridge",
          "inset",
          "outset"
        ],
        "description": "CSS line style keywords"
      },
      "<global-values>": {
        "type": "string",
        "enum": [
          "inherit",
          "initial",
          "unset",
          "revert",
          "revert-layer"
        ],
        "description": "Global values available for any CSS property"
      },
      "<flex>": {
        "type": "string",
        "pattern": "^\\d*\\.?\\d+fr$",
        "description": "CSS flex unit for grid and flexbox"
      },
      "<none>": {
        "type": "string",
        "enum": [
          "none"
        ],
        "description": "CSS none keyword"
      },
      "<normal>": {
        "type": "string",
        "enum": [
          "normal"
        ],
        "description": "CSS normal keyword"
      },
      "<shadow>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "pattern": "^(inset\\s+)?(-?\\d+\\w*\\s+){2,4}(#[a-fA-F0-9]{3,8}|rgba?\\(.*\\)|hsla?\\(.*\\)|[a-zA-Z]+)?$"
          }
        ],
        "description": "CSS shadow value (box-shadow, text-shadow). Complex syntax with optional inset, multiple length values, and color cannot be fully validated with regex."
      },
      "<font-family>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<family-name>"
          },
          {
            "$ref": "#/definitions/<generic-family>"
          },
          {
            "type": "string",
            "pattern": "^['\"]?([^\\d][\\p{L}\\s\\-\\d]*)['\"]?(,\\s*['\"]?([^\\d][\\p{L}\\s\\-\\d]*)['\"]?)*$",
            "description": "Complex family name with multiple family names separated by commas"
          }
        ],
        "description": "CSS font family: generic families, quoted family names, or unquoted family names"
      },
      "<font-weight>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "bold",
              "bolder",
              "lighter"
            ]
          },
          {
            "type": "string",
            "pattern": "^(100|200|300|400|500|600|700|800|900)$"
          }
        ],
        "description": "CSS font weight: keywords or numeric values"
      },
      "<font-style>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "italic",
              "oblique"
            ]
          },
          {
            "type": "string",
            "pattern": "^oblique\\s+\\d+deg$"
          }
        ],
        "description": "CSS font style: keywords or oblique with angle"
      },
      "<font-size>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<absolute-size>"
          },
          {
            "$ref": "#/definitions/<relative-size>"
          },
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "math"
            ]
          }
        ],
        "description": "CSS font size: length, percentage, or keyword values"
      },
      "<display>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "table-row-group",
              "table-header-group",
              "table-footer-group",
              "table-row",
              "table-cell",
              "table-column-group",
              "table-column",
              "table-caption",
              "ruby-base",
              "ruby-text",
              "ruby-base-container",
              "ruby-text-container",
              "contents",
              "none",
              "inline-block",
              "inline-table",
              "inline-flex",
              "inline-grid"
            ]
          },
          {
            "type": "string",
            "description": "complex display value that cannot be fully validated with regex"
          }
        ],
        "description": "CSS display property values"
      },
      "<overflow-block>": {
        "type": "string",
        "enum": [
          "visible",
          "hidden",
          "clip",
          "scroll",
          "auto"
        ],
        "description": "CSS overflow-x and overflow-y property values"
      },
      "<overflow>": {
        "type": "string",
        "pattern": "^(visible|hidden|scroll|auto|clip)(\\s+(visible|hidden|scroll|auto|clip))?$",
        "description": "CSS overflow property values"
      },
      "<text-align>": {
        "type": "string",
        "enum": [
          "left",
          "right",
          "center",
          "justify",
          "start",
          "end",
          "match-parent"
        ],
        "description": "CSS text-align property values"
      },
      "<align-items>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "type": "string",
            "enum": [
              "stretch"
            ]
          },
          {
            "$ref": "#/definitions/<baseline-position>"
          },
          {
            "type": "string",
            "pattern": "^((safe|unsafe)\\s+)?(center|start|end|self-start|self-end|flex-start|flex-end)$"
          }
        ],
        "description": "CSS align-items values"
      },
      "<vertical-align>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "baseline",
              "sub",
              "super",
              "text-top",
              "text-bottom",
              "middle",
              "top",
              "bottom"
            ]
          },
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS vertical-align: keywords, length, or percentage"
      },
      "<border-radius>": {
        "type": "string",
        "pattern": "^(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)\\s*){1,4}(/\\s*(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)\\s*){1,4})?$",
        "description": "CSS border-radius shorthand. Complex syntax combining multiple radius values cannot be fully validated with regex."
      },
      "<border-top-left-radius>": {
        "type": "string",
        "pattern": "^(calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))?$",
        "description": "CSS border-top-left-radius shorthand"
      },
      "<border-style>": {
        "type": "string",
        "pattern": "^(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)(\\s+(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)){0,3}$",
        "description": "CSS border-style shorthand"
      },
      "<border-width>": {
        "type": "string",
        "pattern": "^(thin|medium|thick|(calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))(\\s+(thin|medium|thick|(calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))){0,3}$",
        "description": "CSS border-width shorthand"
      },
      "<border>": {
        "type": "string",
        "pattern": "^(?!.*\\/\\s*0).*$",
        "description": "CSS border shorthand with division by zero rejection in calc expressions. Detailed syntax validation handled by css-tree."
      },
      "<background>": {
        "type": "string",
        "description": "CSS background shorthand. Extremely complex syntax combining multiple background layers with image, position, size, repeat, attachment, origin, clip, and color cannot be fully validated with regex."
      },
      "<transition>": {
        "type": "string",
        "description": "CSS transition shorthand. Complex syntax combining property, duration, timing-function, and delay cannot be fully validated with regex."
      },
      "<animation>": {
        "type": "string",
        "description": "CSS animation shorthand. Complex syntax combining name, duration, timing-function, delay, iteration-count, direction, fill-mode, and play-state cannot be fully validated with regex."
      },
      "<grid-template>": {
        "type": "string",
        "description": "CSS grid template properties. Complex syntax with track sizes, line names, and repeat functions cannot be fully validated with regex."
      },
      "<flex-shorthand>": {
        "type": "string",
        "description": "CSS flex shorthand combining flex-grow, flex-shrink, and flex-basis. Complex parsing required to validate the various combinations."
      },
      "<blend-mode>": {
        "type": "string",
        "enum": [
          "normal",
          "multiply",
          "screen",
          "overlay",
          "darken",
          "lighten",
          "color-dodge",
          "color-burn",
          "hard-light",
          "soft-light",
          "difference",
          "exclusion",
          "hue",
          "saturation",
          "color",
          "luminosity"
        ],
        "description": "CSS blend mode values for mix-blend-mode and background-blend-mode"
      },
      "<mix-blend-mode>": {
        "$ref": "#/definitions/<blend-mode>",
        "description": "CSS mix-blend-mode property values"
      },
      "<background-blend-mode>": {
        "$ref": "#/definitions/<blend-mode>",
        "description": "CSS background-blend-mode property values"
      },
      "<timing-function>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "ease",
              "ease-in",
              "ease-out",
              "ease-in-out",
              "linear",
              "step-start",
              "step-end"
            ]
          },
          {
            "type": "string",
            "pattern": "^cubic-bezier\\(\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*\\)$"
          },
          {
            "type": "string",
            "pattern": "^steps\\(\\s*\\d+\\s*(,\\s*(start|end)\\s*)?\\)$"
          }
        ],
        "description": "CSS timing function: keywords, cubic-bezier(), or steps()"
      },
      "<repeat-style>": {
        "type": "string",
        "enum": [
          "repeat",
          "repeat-x",
          "repeat-y",
          "no-repeat",
          "space",
          "round"
        ],
        "description": "CSS background-repeat values"
      },
      "<attachment>": {
        "type": "string",
        "enum": [
          "scroll",
          "fixed",
          "local"
        ],
        "description": "CSS background-attachment values"
      },
      "<origin>": {
        "type": "string",
        "enum": [
          "border-box",
          "padding-box",
          "content-box"
        ],
        "description": "CSS background-origin values"
      },
      "<clip>": {
        "type": "string",
        "enum": [
          "border-box",
          "padding-box",
          "content-box",
          "text"
        ],
        "description": "CSS background-clip values"
      },
      "<sizing>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto",
              "cover",
              "contain"
            ]
          },
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS background-size values"
      },
      "<cursor>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto",
              "default",
              "none",
              "context-menu",
              "help",
              "pointer",
              "progress",
              "wait",
              "cell",
              "crosshair",
              "text",
              "vertical-text",
              "alias",
              "copy",
              "move",
              "no-drop",
              "not-allowed",
              "grab",
              "grabbing",
              "all-scroll",
              "col-resize",
              "row-resize",
              "n-resize",
              "e-resize",
              "s-resize",
              "w-resize",
              "ne-resize",
              "nw-resize",
              "se-resize",
              "sw-resize",
              "ew-resize",
              "ns-resize",
              "nesw-resize",
              "nwse-resize",
              "zoom-in",
              "zoom-out"
            ]
          },
          {
            "$ref": "#/definitions/<url>"
          }
        ],
        "description": "CSS cursor: keywords or custom cursor URLs"
      },
      "<list-style-type>": {
        "type": "string",
        "enum": [
          "disc",
          "circle",
          "square",
          "decimal",
          "decimal-leading-zero",
          "lower-roman",
          "upper-roman",
          "lower-greek",
          "lower-latin",
          "upper-latin",
          "armenian",
          "georgian",
          "lower-alpha",
          "upper-alpha",
          "none"
        ],
        "description": "CSS list-style-type values"
      },
      "<z-index>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<integer>"
          }
        ],
        "description": "CSS z-index: auto or integer"
      },
      "<opacity>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS opacity: number (0-1) or percentage"
      },
      "<visibility>": {
        "type": "string",
        "enum": [
          "visible",
          "hidden",
          "collapse"
        ],
        "description": "CSS visibility values"
      },
      "<white-space>": {
        "type": "string",
        "enum": [
          "normal",
          "nowrap",
          "pre",
          "pre-wrap",
          "pre-line",
          "break-spaces"
        ],
        "description": "CSS white-space values"
      },
      "<text-decoration-line>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none",
              "underline",
              "overline",
              "line-through",
              "blink"
            ],
            "description": "single value text decoration line"
          },
          {
            "type": "string",
            "pattern": "^(underline|overline|line-through|blink)(\\s+(underline|overline|line-through|blink))*$",
            "description": "multiple values text decoration line that cannot be fully validated with regex"
          }
        ],
        "description": "CSS text-decoration-line values"
      },
      "<text-decoration-style>": {
        "type": "string",
        "enum": [
          "solid",
          "double",
          "dotted",
          "dashed",
          "wavy"
        ],
        "description": "CSS text-decoration-style values"
      },
      "<text-transform>": {
        "type": "string",
        "enum": [
          "none",
          "capitalize",
          "uppercase",
          "lowercase",
          "full-width",
          "full-size-kana"
        ],
        "description": "CSS text-transform values"
      },
      "<word-wrap>": {
        "type": "string",
        "enum": [
          "normal",
          "break-word",
          "anywhere"
        ],
        "description": "CSS word-wrap/overflow-wrap values"
      },
      "<user-select>": {
        "type": "string",
        "enum": [
          "auto",
          "text",
          "none",
          "contain",
          "all"
        ],
        "description": "CSS user-select values"
      },
      "<pointer-events>": {
        "type": "string",
        "enum": [
          "auto",
          "bounding-box",
          "none",
          "visiblePainted",
          "visibleFill",
          "visibleStroke",
          "visible",
          "painted",
          "fill",
          "stroke",
          "all"
        ],
        "description": "CSS pointer-events values"
      },
      "<box-sizing>": {
        "type": "string",
        "enum": [
          "content-box",
          "border-box"
        ],
        "description": "CSS box-sizing values"
      },
      "<resize>": {
        "type": "string",
        "enum": [
          "none",
          "both",
          "horizontal",
          "vertical",
          "block",
          "inline"
        ],
        "description": "CSS resize values"
      },
      "<outline>": {
        "type": "string",
        "description": "CSS outline shorthand. Complex syntax combining outline-width, outline-style, and outline-color cannot be fully validated with regex."
      },
      "<quotes>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none",
              "auto"
            ]
          },
          {
            "$ref": "#/definitions/<string>"
          }
        ],
        "description": "CSS quotes: none, auto, or quoted string pairs"
      },
      "<content>": {
        "type": "string",
        "description": "CSS content property. Complex syntax with strings, counters, attr(), and url() cannot be fully validated with regex."
      },
      "<will-change>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "type": "string",
            "enum": [
              "scroll-position",
              "contents"
            ]
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS will-change: auto or property names"
      },
      "<contain>": {
        "type": "string",
        "enum": [
          "none",
          "strict",
          "content",
          "size",
          "inline-size",
          "layout",
          "style",
          "paint"
        ],
        "description": "CSS contain values"
      },
      "<isolation>": {
        "type": "string",
        "enum": [
          "auto",
          "isolate"
        ],
        "description": "CSS isolation values"
      },
      "<writing-mode>": {
        "type": "string",
        "enum": [
          "horizontal-tb",
          "vertical-rl",
          "vertical-lr",
          "sideways-rl",
          "sideways-lr"
        ],
        "description": "CSS writing-mode values"
      },
      "<direction>": {
        "type": "string",
        "enum": [
          "ltr",
          "rtl"
        ],
        "description": "CSS direction values"
      },
      "<unicode-bidi>": {
        "type": "string",
        "enum": [
          "normal",
          "embed",
          "isolate",
          "bidi-override",
          "isolate-override",
          "plaintext"
        ],
        "description": "CSS unicode-bidi values"
      },
      "<object-fit>": {
        "type": "string",
        "enum": [
          "fill",
          "contain",
          "cover",
          "none",
          "scale-down"
        ],
        "description": "CSS object-fit values"
      },
      "<object-position>": {
        "$ref": "#/definitions/<position>",
        "description": "CSS object-position: similar to position."
      },
      "<scroll-behavior>": {
        "type": "string",
        "enum": [
          "auto",
          "smooth"
        ],
        "description": "CSS scroll-behavior values"
      },
      "<appearance>": {
        "type": "string",
        "enum": [
          "none",
          "auto",
          "base-select",
          "textfield",
          "searchfield",
          "textarea",
          "checkbox",
          "radio",
          "menulist",
          "menulist-button",
          "listbox",
          "meter",
          "progress-bar",
          "button"
        ],
        "description": "CSS appearance values"
      },
      "<outline-offset>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS outline-offset: length values"
      },
      "<tab-size>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<integer>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS tab-size: integer or length"
      },
      "<hyphens>": {
        "type": "string",
        "enum": [
          "none",
          "manual",
          "auto"
        ],
        "description": "CSS hyphens values"
      },
      "<word-break>": {
        "type": "string",
        "enum": [
          "normal",
          "break-all",
          "keep-all",
          "break-word"
        ],
        "description": "CSS word-break values"
      },
      "<line-break>": {
        "type": "string",
        "enum": [
          "auto",
          "loose",
          "normal",
          "strict",
          "anywhere"
        ],
        "description": "CSS line-break values"
      },
      "<letter-spacing>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS letter-spacing: normal or length"
      },
      "<word-spacing>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS word-spacing: normal, length, or percentage"
      },
      "<line-height>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<positive-number>"
          },
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          }
        ],
        "description": "CSS line-height: normal, number, length, or percentage"
      },
      "<text-indent>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "type": "string",
            "pattern": "(?:^((calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(?=(?:\\shanging|\\seach-line){0,2}$))|(?:^(?:hanging\\s?|each-line\\s?){1,2}\\s((calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s?(?:hanging|each-line)?$)",
            "description": "css text-indent string"
          }
        ],
        "description": "CSS text-indent: length or percentage, with optional 'hanging' or 'each-line' keywords"
      },
      "<text-overflow>": {
        "type": "string",
        "enum": [
          "clip",
          "ellipsis"
        ],
        "description": "CSS text-overflow values"
      },
      "<text-decoration>": {
        "type": "string",
        "description": "CSS text-decoration shorthand. Complex syntax combining text-decoration-line, text-decoration-style, text-decoration-color, and text-decoration-thickness cannot be fully validated with regex."
      },
      "<text-shadow>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "not": {
              "$ref": "#/definitions/<basic-math-functions-with-percentage>"
            }
          }
        ],
        "description": "CSS text-shadow: complex shadow value cannot be fully validated with regex"
      },
      "<box-shadow>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "not": {
              "$ref": "#/definitions/<basic-math-functions-with-percentage>"
            },
            "description": "complex shadow value that cannot be fully validated with regex"
          }
        ],
        "description": "CSS box-shadow: none or shadow values (h-offset v-offset take <length>, no percentages allowed)"
      },
      "<list-style>": {
        "type": "string",
        "description": "CSS list-style shorthand. Complex syntax combining list-style-type, list-style-position, and list-style-image cannot be fully validated with regex."
      },
      "<list-style-position>": {
        "type": "string",
        "enum": [
          "inside",
          "outside"
        ],
        "description": "CSS list-style-position values"
      },
      "<list-style-image>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          }
        ],
        "description": "CSS list-style-image: none or URL"
      },
      "<alpha-value>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS alpha value for colors: number (0-1) or percentage"
      },
      "<absolute-size>": {
        "type": "string",
        "enum": [
          "xx-small",
          "x-small",
          "small",
          "medium",
          "large",
          "x-large",
          "xx-large",
          "xxx-large"
        ],
        "description": "CSS absolute font sizes"
      },
      "<relative-size>": {
        "type": "string",
        "enum": [
          "larger",
          "smaller"
        ],
        "description": "CSS relative font sizes"
      },
      "<angle-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<angle>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS angle or percentage"
      },
      "<number-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS number or percentage"
      },
      "<time-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<time>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS time or percentage"
      },
      "<frequency-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<frequency>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS frequency or percentage"
      },
      "<baseline-position>": {
        "type": "string",
        "pattern": "^(first\\s+baseline|last\\s+baseline|baseline)$",
        "description": "CSS baseline position: baseline, first baseline, or last baseline"
      },
      "<content-distribution>": {
        "type": "string",
        "enum": [
          "space-between",
          "space-around",
          "space-evenly",
          "stretch"
        ],
        "description": "CSS content distribution values for alignment"
      },
      "<content-position>": {
        "type": "string",
        "enum": [
          "center",
          "start",
          "end",
          "flex-start",
          "flex-end"
        ],
        "description": "CSS content position values for alignment"
      },
      "<self-position>": {
        "type": "string",
        "enum": [
          "center",
          "start",
          "end",
          "self-start",
          "self-end",
          "flex-start",
          "flex-end"
        ],
        "description": "CSS self position values for alignment"
      },
      "<overflow-position>": {
        "type": "string",
        "enum": [
          "unsafe",
          "safe"
        ],
        "description": "CSS overflow position modifiers"
      },
      "<justify-content>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<content-distribution>"
          },
          {
            "$ref": "#/definitions/<content-position>"
          },
          {
            "type": "string",
            "enum": [
              "left",
              "right"
            ]
          },
          {
            "type": "string",
            "pattern": "^(safe|unsafe)?\\s+(left|right|center|start|end|flex-start|flex-end)$"
          }
        ],
        "description": "CSS justify-content values"
      },
      "<visual-box>": {
        "type": "string",
        "enum": [
          "content-box",
          "padding-box",
          "border-box"
        ],
        "description": "CSS visual box types"
      },
      "<shape-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<visual-box>"
          },
          {
            "type": "string",
            "enum": [
              "margin-box"
            ]
          }
        ],
        "description": "CSS shape box types"
      },
      "<geometry-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<shape-box>"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box",
              "view-box"
            ]
          }
        ],
        "description": "CSS geometry box types including visual box and additional geometry boxes"
      },
      "<paint-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<visual-box>"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box"
            ]
          }
        ],
        "description": "CSS paint box types"
      },
      "<coord-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<paint-box>"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box",
              "view-box"
            ]
          }
        ],
        "description": "CSS coordinate box types"
      },
      "<generic-family>": {
        "type": "string",
        "enum": [
          "serif",
          "sans-serif",
          "monospace",
          "cursive",
          "fantasy",
          "system-ui",
          "ui-serif",
          "ui-sans-serif",
          "ui-monospace",
          "ui-rounded",
          "math",
          "emoji",
          "fangsong"
        ],
        "description": "CSS generic font families"
      },
      "<family-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<string>"
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS font family name: quoted string or unquoted identifier"
      },
      "<system-family-name>": {
        "type": "string",
        "enum": [
          "caption",
          "icon",
          "menu",
          "message-box",
          "small-caption",
          "status-bar"
        ],
        "description": "CSS system font family names"
      },
      "<font-stretch-absolute>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "ultra-condensed",
              "extra-condensed",
              "condensed",
              "semi-condensed",
              "semi-expanded",
              "expanded",
              "extra-expanded",
              "ultra-expanded"
            ]
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS font stretch absolute values"
      },
      "<font-weight-absolute>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "bold"
            ]
          },
          {
            "type": "string",
            "pattern": "^(100|200|300|400|500|600|700|800|900|[1-9][0-9]{0,2})$"
          }
        ],
        "description": "CSS font weight absolute values: normal, bold, or number 1-1000"
      },
      "<grid-line>": {
        "type": "string",
        "description": "CSS grid line: auto, custom identifier, integer with optional identifier, or span notation. Complex syntax cannot be fully validated with regex."
      },
      "<track-breadth>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "$ref": "#/definitions/<flex>"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content",
              "auto"
            ]
          }
        ],
        "description": "CSS grid track breadth"
      },
      "<inflexible-breadth>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content",
              "auto"
            ]
          }
        ],
        "description": "CSS inflexible breadth (track breadth without flex)"
      },
      "<track-size>": {
        "type": "string",
        "description": "CSS grid track size: track-breadth, minmax(), or fit-content(). Complex syntax cannot be fully validated with regex."
      },
      "<easing-function>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<timing-function>"
          },
          {
            "type": "string",
            "pattern": "^linear\\(.*\\)$",
            "description": "Linear easing function - arguments cannot be fully validated with regex"
          },
          {
            "type": "string",
            "pattern": "^steps\\(\\s*\\d+\\s*(,\\s*(start|end|jump-start|jump-end|jump-none|jump-both)\\s*)?\\)$"
          }
        ],
        "description": "CSS easing functions including cubic-bezier, steps, and linear"
      },
      "<single-animation-direction>": {
        "type": "string",
        "enum": [
          "normal",
          "reverse",
          "alternate",
          "alternate-reverse"
        ],
        "description": "CSS animation direction values"
      },
      "<single-animation-fill-mode>": {
        "type": "string",
        "enum": [
          "none",
          "forwards",
          "backwards",
          "both"
        ],
        "description": "CSS animation fill mode values"
      },
      "<single-animation-play-state>": {
        "type": "string",
        "enum": [
          "running",
          "paused"
        ],
        "description": "CSS animation play state values"
      },
      "<single-animation-iteration-count>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "type": "string",
            "enum": [
              "infinite"
            ]
          }
        ],
        "description": "CSS animation iteration count: number or infinite"
      },
      "<keyframes-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<custom-ident>"
          },
          {
            "$ref": "#/definitions/<string>"
          }
        ],
        "description": "CSS keyframes name: identifier or string"
      },
      "<single-transition-property>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "all"
            ]
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS transition property: all or property name"
      },
      "<quote>": {
        "type": "string",
        "enum": [
          "open-quote",
          "close-quote",
          "no-open-quote",
          "no-close-quote"
        ],
        "description": "CSS quote values for generated content"
      },
      "<counter-style-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<custom-ident>"
          },
          {
            "type": "string",
            "enum": [
              "decimal",
              "decimal-leading-zero",
              "lower-roman",
              "upper-roman",
              "lower-greek",
              "lower-latin",
              "upper-latin",
              "armenian",
              "georgian",
              "lower-alpha",
              "upper-alpha",
              "disc",
              "circle",
              "square",
              "none"
            ]
          }
        ],
        "description": "CSS counter style: predefined or custom identifier"
      },
      "<ratio>": {
        "type": "string",
        "pattern": "^\\d+(\\.\\d+)?\\s*/\\s*\\d+(\\.\\d+)?$",
        "description": "CSS ratio: number/number"
      },
      "<dasharray>": {
        "type": "string",
        "description": "CSS dash array for stroke-dasharray. Complex syntax with multiple length/percentage/number values cannot be fully validated with regex."
      },
      "<paint>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<color>"
          },
          {
            "$ref": "#/definitions/<url>"
          }
        ],
        "description": "CSS paint values for SVG: none, color, URL, or context keywords"
      },
      "<overflow-wrap>": {
        "type": "string",
        "enum": [
          "normal",
          "break-word",
          "anywhere"
        ],
        "description": "CSS overflow-wrap values (same as word-wrap)"
      },
      "<text-decoration-thickness>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "$ref": "#/definitions/<positive-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "from-font"
            ]
          }
        ],
        "description": "CSS text decoration thickness"
      },
      "<text-underline-offset>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS text underline offset"
      },
      "<text-emphasis-style>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "enum": [
              "filled",
              "open",
              "dot",
              "circle",
              "double-circle",
              "triangle",
              "sesame"
            ]
          },
          {
            "$ref": "#/definitions/<string>"
          }
        ],
        "description": "CSS text emphasis style"
      },
      "<mask-composite>": {
        "type": "string",
        "enum": [
          "add",
          "subtract",
          "intersect",
          "exclude"
        ],
        "description": "CSS mask composite operation values"
      },
      "<mask-mode>": {
        "type": "string",
        "enum": [
          "alpha",
          "luminance",
          "match-source"
        ],
        "description": "CSS mask mode values"
      },
      "<clip-path>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<url>"
          },
          {
            "$ref": "#/definitions/<basic-shape>"
          }
        ],
        "description": "CSS clip-path: none, URL, or basic shape"
      },
      "<shape-outside>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          },
          {
            "$ref": "#/definitions/<basic-shape>"
          }
        ],
        "description": "CSS shape-outside: none, image, or basic shape"
      },
      "<intrinsic-size-keyword>": {
        "type": "string",
        "enum": [
          "auto",
          "min-content",
          "max-content",
          "fit-content"
        ],
        "description": "CSS intrinsic sizing keywords"
      },
      "<step-position>": {
        "type": "string",
        "enum": [
          "jump-start",
          "jump-end",
          "jump-none",
          "jump-both",
          "start",
          "end"
        ],
        "description": "CSS step position for steps() timing function"
      },
      "<system-color>": {
        "type": "string",
        "enum": [
          "AccentColor",
          "AccentColorText",
          "ActiveText",
          "ButtonBorder",
          "ButtonFace",
          "ButtonText",
          "Canvas",
          "CanvasText",
          "Field",
          "FieldText",
          "GrayText",
          "Highlight",
          "HighlightText",
          "LinkText",
          "Mark",
          "MarkText",
          "SelectedItem",
          "SelectedItemText",
          "VisitedText"
        ],
        "description": "CSS system colors"
      },
      "<deprecated-system-color>": {
        "type": "string",
        "enum": [
          "ActiveBorder",
          "ActiveCaption",
          "AppWorkspace",
          "Background",
          "ButtonHighlight",
          "ButtonShadow",
          "CaptionText",
          "InactiveBorder",
          "InactiveCaption",
          "InactiveCaptionText",
          "InfoBackground",
          "InfoText",
          "Menu",
          "MenuText",
          "Scrollbar",
          "ThreeDDarkShadow",
          "ThreeDFace",
          "ThreeDHighlight",
          "ThreeDLightShadow",
          "ThreeDShadow",
          "Window",
          "WindowFrame",
          "WindowText"
        ],
        "description": "CSS deprecated system colors"
      },
      "<bg-size>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "auto",
              "cover",
              "contain"
            ]
          },
          {
            "type": "string",
            "pattern": "^(auto|calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(auto|calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))?)$",
            "description": "complex syntax with multiple values that cannot be fully validated with regex"
          }
        ],
        "description": "CSS background-size values"
      },
      "<bg-position>": {
        "type": "string",
        "description": "CSS background-position values. Complex syntax with multiple position values and combinations cannot be fully validated with regex."
      },
      "<bg-clip>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<visual-box>"
          },
          {
            "type": "string",
            "enum": [
              "text"
            ]
          }
        ],
        "description": "CSS background-clip values"
      },
      "<bg-image>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          }
        ],
        "description": "CSS background-image values"
      },
      "<hue>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<angle>"
          }
        ],
        "description": "CSS hue value: number or angle"
      },
      "<radial-shape>": {
        "type": "string",
        "enum": [
          "circle",
          "ellipse"
        ],
        "description": "CSS radial gradient shape"
      },
      "<radial-extent>": {
        "type": "string",
        "enum": [
          "closest-corner",
          "closest-side",
          "farthest-corner",
          "farthest-side"
        ],
        "description": "CSS radial gradient extent"
      },
      "<side-or-corner>": {
        "type": "string",
        "pattern": "^(left|right|top|bottom)$|^(left|right)\\s+(top|bottom)$|^(top|bottom)\\s+(left|right)$",
        "description": "CSS gradient side or corner direction"
      },
      "<color-stop-length>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "type": "string",
            "pattern": "^\\d+(\\.\\d+)?%\\s+\\d+(\\.\\d+)?%$"
          }
        ],
        "description": "CSS color stop length: single or double length-percentage"
      },
      "<color-stop-angle>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<angle-percentage>"
          },
          {
            "type": "string",
            "pattern": "^\\d+(\\.\\d+)?deg\\s+\\d+(\\.\\d+)?deg$"
          }
        ],
        "description": "CSS color stop angle: single or double angle-percentage"
      },
      "<masking-mode>": {
        "type": "string",
        "enum": [
          "alpha",
          "luminance",
          "match-source"
        ],
        "description": "CSS masking mode values"
      },
      "<mask-reference>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          },
          {
            "$ref": "#/definitions/<url>"
          }
        ],
        "description": "CSS mask reference values"
      },
      "<outline-line-style>": {
        "type": "string",
        "enum": [
          "none",
          "dotted",
          "dashed",
          "solid",
          "double",
          "groove",
          "ridge",
          "inset",
          "outset"
        ],
        "description": "CSS outline line style values"
      },
      "<counter-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<custom-ident>"
          },
          {
            "type": "string",
            "enum": [
              "list-item"
            ]
          }
        ],
        "description": "CSS counter name: custom identifier or list-item"
      },
      "<symbol>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<string>"
          },
          {
            "$ref": "#/definitions/<image>"
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS symbol values for counters"
      },
      "<symbols-type>": {
        "type": "string",
        "enum": [
          "cyclic",
          "numeric",
          "alphabetic",
          "symbolic",
          "fixed"
        ],
        "description": "CSS symbols() function type"
      },
      "<feature-tag-value>": {
        "type": "string",
        "description": "CSS font feature tag value. Complex syntax with string and optional integer/keyword cannot be fully validated with regex."
      },
      "<east-asian-variant-values>": {
        "type": "string",
        "enum": [
          "jis78",
          "jis83",
          "jis90",
          "jis04",
          "simplified",
          "traditional"
        ],
        "description": "CSS East Asian variant values"
      },
      "<east-asian-width-values>": {
        "type": "string",
        "enum": [
          "full-width",
          "proportional-width"
        ],
        "description": "CSS East Asian width values"
      },
      "<numeric-figure-values>": {
        "type": "string",
        "enum": [
          "lining-nums",
          "oldstyle-nums"
        ],
        "description": "CSS numeric figure values"
      },
      "<numeric-fraction-values>": {
        "type": "string",
        "enum": [
          "diagonal-fractions",
          "stacked-fractions"
        ],
        "description": "CSS numeric fraction values"
      },
      "<numeric-spacing-values>": {
        "type": "string",
        "enum": [
          "proportional-nums",
          "tabular-nums"
        ],
        "description": "CSS numeric spacing values"
      },
      "<common-lig-values>": {
        "type": "string",
        "enum": [
          "common-ligatures",
          "no-common-ligatures"
        ],
        "description": "CSS common ligature values"
      },
      "<discretionary-lig-values>": {
        "type": "string",
        "enum": [
          "discretionary-ligatures",
          "no-discretionary-ligatures"
        ],
        "description": "CSS discretionary ligature values"
      },
      "<historical-lig-values>": {
        "type": "string",
        "enum": [
          "historical-ligatures",
          "no-historical-ligatures"
        ],
        "description": "CSS historical ligature values"
      },
      "<contextual-alt-values>": {
        "type": "string",
        "enum": [
          "contextual",
          "no-contextual"
        ],
        "description": "CSS contextual alternates values"
      },
      "<composite-style>": {
        "type": "string",
        "enum": [
          "clear",
          "copy",
          "source-over",
          "source-in",
          "source-out",
          "source-atop",
          "destination-over",
          "destination-in",
          "destination-out",
          "destination-atop",
          "xor"
        ],
        "description": "CSS composite style values"
      },
      "<compositing-operator>": {
        "type": "string",
        "enum": [
          "add",
          "subtract",
          "intersect",
          "exclude"
        ],
        "description": "CSS compositing operator values"
      },
      "<axis>": {
        "type": "string",
        "enum": [
          "block",
          "inline",
          "x",
          "y"
        ],
        "description": "CSS axis values"
      },
      "<scroller>": {
        "type": "string",
        "enum": [
          "root",
          "nearest",
          "self"
        ],
        "description": "CSS scroller values"
      },
      "<try-size>": {
        "type": "string",
        "enum": [
          "most-width",
          "most-height",
          "most-block-size",
          "most-inline-size"
        ],
        "description": "CSS try size values"
      },
      "<try-tactic>": {
        "type": "string",
        "enum": [
          "flip-block",
          "flip-inline",
          "flip-start"
        ],
        "description": "CSS try tactic values"
      },
      "<font>": {
        "type": "string",
        "description": "CSS font shorthand. Complex syntax combining font-style, font-variant, font-weight, font-size/line-height, and font-family cannot be fully validated with regex."
      },
      "<font-variant>": {
        "type": "string",
        "description": "CSS font-variant shorthand. Complex syntax combining normal, small-caps, and various feature values cannot be fully validated with regex."
      },
      "<flex-direction>": {
        "type": "string",
        "enum": [
          "row",
          "row-reverse",
          "column",
          "column-reverse"
        ],
        "description": "CSS flex-direction values"
      },
      "<gap>": {
        "type": "string",
        "pattern": "^(normal|0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s|$){1,2}",
        "description": "CSS gap values"
      },
      "<padding>": {
        "type": "string",
        "pattern": "^((0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s*){1,4}$",
        "description": "CSS padding values"
      },
      "<padding-top>": {
        "$ref": "#/definitions/<positive-length-percentage>",
        "description": "CSS padding-top values"
      },
      "unevaluatedProperties": false,
      "type": "object"
    },
    "title--unrestricted-root": "CSS Value Definitions",
    "description--unrestricted-root": "Individual JSON Schema definitions for CSS value types, suitable for format registration",
    "definitions--unrestricted-root": {
      "<positive-value>": {
        "type": "string",
        "pattern": "^[^-]",
        "description": "CSS positive value"
      },
      "<length>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<basic-math-functions-without-percentage>"
          },
          {
            "type": "string",
            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
          }
        ],
        "description": "CSS numeric length with all valid units"
      },
      "<positive-length>": {
        "allOf": [
          {
            "$ref": "#/definitions/<positive-value>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS positive numeric length with all valid units"
      },
      "<percentage>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<basic-math-functions>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+%$"
          }
        ],
        "description": "Number followed by %"
      },
      "<positive-percentage>": {
        "allOf": [
          {
            "$ref": "#/definitions/<positive-value>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "Positive number followed by %"
      },
      "<length-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "Accepts both <length> and <percentage>"
      },
      "<positive-length-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "$ref": "#/definitions/<positive-percentage>"
          }
        ],
        "description": "Accepts both <positive-length> and <positive-percentage>"
      },
      "<auto>": {
        "type": "string",
        "enum": [
          "auto"
        ],
        "description": "CSS auto keyword"
      },
      "<length-percentage-auto>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          },
          {
            "$ref": "#/definitions/<auto>"
          }
        ],
        "description": "CSS length, percentage, or auto"
      },
      "<positive-length-percentage-auto>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "$ref": "#/definitions/<positive-percentage>"
          },
          {
            "$ref": "#/definitions/<auto>"
          }
        ],
        "description": "CSS positive length, positive percentage, or auto"
      },
      "<number>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<all-math-functions-without-percentage>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+$"
          }
        ],
        "description": "Decimal or integer number"
      },
      "<positive-number>": {
        "allOf": [
          {
            "$ref": "#/definitions/<positive-value>"
          },
          {
            "$ref": "#/definitions/<number>"
          }
        ],
        "description": "Positive decimal or integer number"
      },
      "<integer>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<all-math-functions-without-percentage>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d+$"
          }
        ],
        "description": "Whole numbers only"
      },
      "height": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content"
            ]
          }
        ],
        "description": "CSS height value"
      },
      "<angle>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<all-math-functions>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(deg|rad|grad|turn)$"
          }
        ],
        "description": "Used in rotation, direction, etc."
      },
      "<time>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<basic-math-functions-without-percentage>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(ms|s)$"
          }
        ],
        "description": "CSS durations (s, ms)"
      },
      "<resolution>": {
        "type": "string",
        "pattern": "^-?\\d*\\.?\\d+(dpi|dpcm|dppx|x)$",
        "description": "Screen density/resolution units"
      },
      "<frequency>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<basic-math-functions>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(Hz|kHz)$"
          }
        ],
        "description": "Used in aural CSS or media queries"
      },
      "<dimension>": {
        "type": "string",
        "pattern": "^-?\\d*\\.?\\d+[a-zA-Z]+$",
        "description": "Generic dimension (unit required)"
      },
      "<percentage-or-number>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "Matches numbers or percentages"
      },
      "<custom-ident>": {
        "type": "string",
        "pattern": "^[a-zA-Z_][\\w-]*$",
        "description": "CSS identifiers (excluding keywords)"
      },
      "<ident>": {
        "type": "string",
        "pattern": "^[a-zA-Z_][\\w-]*$",
        "description": "Same as <custom-ident>"
      },
      "<string>": {
        "type": "string",
        "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
        "description": "Quoted strings with escapes"
      },
      "<url>": {
        "type": "string",
        "pattern": "^url\\((['\"]?).*?\\1\\)$",
        "description": "Matches url(...) with optional quotes"
      },
      "<hex-color>": {
        "type": "string",
        "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
        "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
      },
      "<rgb-color>": {
        "type": "string",
        "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
        "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
      },
      "<hsl-color>": {
        "type": "string",
        "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
        "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
      },
      "<named-color>": {
        "type": "string",
        "enum": [
          "transparent",
          "currentColor",
          "aliceblue",
          "antiquewhite",
          "aqua",
          "aquamarine",
          "azure",
          "beige",
          "bisque",
          "black",
          "blanchedalmond",
          "blue",
          "blueviolet",
          "brown",
          "burlywood",
          "cadetblue",
          "chartreuse",
          "chocolate",
          "coral",
          "cornflowerblue",
          "cornsilk",
          "crimson",
          "cyan",
          "darkblue",
          "darkcyan",
          "darkgoldenrod",
          "darkgray",
          "darkgrey",
          "darkgreen",
          "darkkhaki",
          "darkmagenta",
          "darkolivegreen",
          "darkorange",
          "darkorchid",
          "darkred",
          "darksalmon",
          "darkseagreen",
          "darkslateblue",
          "darkslategray",
          "darkslategrey",
          "darkturquoise",
          "darkviolet",
          "deeppink",
          "deepskyblue",
          "dimgray",
          "dimgrey",
          "dodgerblue",
          "firebrick",
          "floralwhite",
          "forestgreen",
          "fuchsia",
          "gainsboro",
          "ghostwhite",
          "gold",
          "goldenrod",
          "gray",
          "grey",
          "green",
          "greenyellow",
          "honeydew",
          "hotpink",
          "indianred",
          "indigo",
          "ivory",
          "khaki",
          "lavender",
          "lavenderblush",
          "lawngreen",
          "lemonchiffon",
          "lightblue",
          "lightcoral",
          "lightcyan",
          "lightgoldenrodyellow",
          "lightgray",
          "lightgrey",
          "lightgreen",
          "lightpink",
          "lightsalmon",
          "lightseagreen",
          "lightskyblue",
          "lightslategray",
          "lightslategrey",
          "lightsteelblue",
          "lightyellow",
          "lime",
          "limegreen",
          "linen",
          "magenta",
          "maroon",
          "mediumaquamarine",
          "mediumblue",
          "mediumorchid",
          "mediumpurple",
          "mediumseagreen",
          "mediumslateblue",
          "mediumspringgreen",
          "mediumturquoise",
          "mediumvioletred",
          "midnightblue",
          "mintcream",
          "mistyrose",
          "moccasin",
          "navajowhite",
          "navy",
          "oldlace",
          "olive",
          "olivedrab",
          "orange",
          "orangered",
          "orchid",
          "palegoldenrod",
          "palegreen",
          "paleturquoise",
          "palevioletred",
          "papayawhip",
          "peachpuff",
          "peru",
          "pink",
          "plum",
          "powderblue",
          "purple",
          "rebeccapurple",
          "red",
          "rosybrown",
          "royalblue",
          "saddlebrown",
          "salmon",
          "sandybrown",
          "seagreen",
          "seashell",
          "sienna",
          "silver",
          "skyblue",
          "slateblue",
          "slategray",
          "slategrey",
          "snow",
          "springgreen",
          "steelblue",
          "tan",
          "teal",
          "thistle",
          "tomato",
          "turquoise",
          "violet",
          "wheat",
          "white",
          "whitesmoke",
          "yellow",
          "yellowgreen"
        ],
        "description": "CSS named colors including transparent and currentColor"
      },
      "<color>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<hex-color>"
          },
          {
            "$ref": "#/definitions/<rgb-color>"
          },
          {
            "$ref": "#/definitions/<hsl-color>"
          },
          {
            "$ref": "#/definitions/<named-color>"
          }
        ],
        "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
      },
      "<image>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<url>"
          },
          {
            "type": "string",
            "pattern": "^(linear-gradient|radial-gradient|conic-gradient|repeating-linear-gradient|repeating-radial-gradient|repeating-conic-gradient)\\(.*\\)$",
            "description": "Gradient functions - arguments cannot be fully validated with regex"
          },
          {
            "type": "string",
            "pattern": "^image\\(.*\\)$",
            "description": "Image function - arguments cannot be fully validated with regex"
          }
        ],
        "description": "CSS image values including URLs, gradients, and image() functions"
      },
      "<position>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<position-one>"
          },
          {
            "$ref": "#/definitions/<position-two>"
          },
          {
            "$ref": "#/definitions/<position-four>"
          }
        ],
        "description": "Single position value. Full position syntax with multiple values and combinations requires complex parsing that cannot be fully validated with regex."
      },
      "<position-one>": {
        "anyOf": [
          {
            "enum": [
              "left",
              "center",
              "right",
              "top",
              "bottom",
              "x-start",
              "x-end",
              "y-start",
              "y-end",
              "block-start",
              "block-end",
              "inline-start",
              "inline-end"
            ]
          },
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          }
        ]
      },
      "<position-two>": {
        "anyOf": [
          {
            "pattern": "^(((left|center|right|x-start|x-end)\\s(top|center|bottom|y-start|y-end))|((top|center|bottom|y-start|y-end)\\s(left|center|right|x-start|x-end)))$"
          },
          {
            "pattern": "^(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))$"
          },
          {
            "pattern": "^((block-start|center|block-end)\\s(inline-start|center|inline-end))|((inline-start|center|inline-end)\\s(block-start|center|block-end))$"
          },
          {
            "pattern": "^((start|center|end)\\s*){2}$"
          }
        ]
      },
      "<position-four>": {
        "anyOf": [
          {
            "pattern": "^((left|right|x-start|x-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(top|bottom|y-start|y-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))|((top|bottom|y-start|y-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(left|right|x-start|x-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))$"
          },
          {
            "pattern": "^((block-start|block-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(inline-start|inline-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))|((inline-start|inline-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(block-start|block-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))$"
          },
          {
            "pattern": "^((start|end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s*){2}$"
          }
        ]
      },
      "<transform-function>": {
        "type": "string",
        "pattern": "^(matrix|matrix3d|perspective|rotate|rotate3d|rotateX|rotateY|rotateZ|scale|scale3d|scaleX|scaleY|scaleZ|skew|skewX|skewY|translate|translate3d|translateX|translateY|translateZ)\\(.*\\)$",
        "description": "Transform functions like rotate(), translate(), scale(). Function arguments cannot be fully validated with regex as they require parsing of nested expressions."
      },
      "<var()>": {
        "type": "string",
        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
        "description": "CSS var() function- resolving a variable value from the variable"
      },
      "<basic-math-functions>": {
        "type": "string",
        "pattern": "^(calc|min|max|clamp|round|mod|rem|abs)\\((?!.*\\/\\s*0\\b).+\\)$",
        "description": "Basic CSS math functions that work with any value type. Percentages allowed where contextually appropriate."
      },
      "<basic-math-functions-without-percentage>": {
        "type": "string",
        "pattern": "^(calc|min|max|clamp|round|mod|rem|abs)\\((?!.*\\/\\s*0\\b)[^%]+\\)$",
        "description": "Basic CSS math functions without percentages or division by zero."
      },
      "<basic-math-functions-with-percentage>": {
        "type": "string",
        "pattern": "(calc|min|max|clamp|round|mod|rem|abs)\\([^)]*%[^)]*\\)",
        "description": "Detects if any basic math function contains percentages"
      },
      "<all-math-functions>": {
        "type": "string",
        "pattern": "^(calc|min|max|clamp|round|mod|rem|abs|sin|cos|tan|asin|acos|atan|atan2|pow|sqrt|hypot|log|exp|sign)\\((?!.*\\/\\s*0\\b).+\\)$",
        "description": "All CSS math functions - basic, trigonometric, and advanced mathematical functions."
      },
      "<all-math-functions-without-percentage>": {
        "type": "string",
        "pattern": "^(calc|min|max|clamp|round|mod|rem|abs|sin|cos|tan|asin|acos|atan|atan2|pow|sqrt|hypot|log|exp|sign)\\((?!.*\\/\\s*0\\b)(?!.*%).+\\)$",
        "description": "All CSS math functions without percentages or division by zero."
      },
      "<attr()>": {
        "type": "string",
        "pattern": "^attr\\(.*\\)$",
        "description": "CSS attr() function. Cannot fully validate fallback values and type hints with regex."
      },
      "<image-set()>": {
        "type": "string",
        "pattern": "^image-set\\(.*\\)$",
        "description": "CSS image-set() function. Cannot parse comma-separated URLs and resolution descriptors with regex."
      },
      "<basic-shape>": {
        "type": "string",
        "pattern": "^(inset|rect|xywh|circle|ellipse|polygon|path|shape)\\(.*\\)$",
        "description": "CSS basic shape functions. Shape-specific arguments cannot be fully validated with regex."
      },
      "<filter-function>": {
        "type": "string",
        "pattern": "^(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\)$",
        "description": "CSS filter functions. Function arguments cannot be fully validated with regex."
      },
      "<filter-value-list>": {
        "type": "string",
        "pattern": "^((blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))(\\s+(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))*$",
        "description": "CSS filter functions - value separated list. Function arguments cannot be fully validated with regex."
      },
      "<filter>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<filter-value-list>"
          }
        ],
        "description": "CSS filter value"
      },
      "<line-width>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "type": "string",
            "enum": [
              "thin",
              "medium",
              "thick"
            ]
          }
        ],
        "description": "CSS line width: length values or predefined keywords"
      },
      "<line-style>": {
        "type": "string",
        "enum": [
          "none",
          "hidden",
          "dotted",
          "dashed",
          "solid",
          "double",
          "groove",
          "ridge",
          "inset",
          "outset"
        ],
        "description": "CSS line style keywords"
      },
      "<global-values>": {
        "type": "string",
        "enum": [
          "inherit",
          "initial",
          "unset",
          "revert",
          "revert-layer"
        ],
        "description": "Global values available for any CSS property"
      },
      "<flex>": {
        "type": "string",
        "pattern": "^\\d*\\.?\\d+fr$",
        "description": "CSS flex unit for grid and flexbox"
      },
      "<none>": {
        "type": "string",
        "enum": [
          "none"
        ],
        "description": "CSS none keyword"
      },
      "<normal>": {
        "type": "string",
        "enum": [
          "normal"
        ],
        "description": "CSS normal keyword"
      },
      "<shadow>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "pattern": "^(inset\\s+)?(-?\\d+\\w*\\s+){2,4}(#[a-fA-F0-9]{3,8}|rgba?\\(.*\\)|hsla?\\(.*\\)|[a-zA-Z]+)?$"
          }
        ],
        "description": "CSS shadow value (box-shadow, text-shadow). Complex syntax with optional inset, multiple length values, and color cannot be fully validated with regex."
      },
      "<font-family>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<family-name>"
          },
          {
            "$ref": "#/definitions/<generic-family>"
          },
          {
            "type": "string",
            "pattern": "^['\"]?([^\\d][\\p{L}\\s\\-\\d]*)['\"]?(,\\s*['\"]?([^\\d][\\p{L}\\s\\-\\d]*)['\"]?)*$",
            "description": "Complex family name with multiple family names separated by commas"
          }
        ],
        "description": "CSS font family: generic families, quoted family names, or unquoted family names"
      },
      "<font-weight>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "bold",
              "bolder",
              "lighter"
            ]
          },
          {
            "type": "string",
            "pattern": "^(100|200|300|400|500|600|700|800|900)$"
          }
        ],
        "description": "CSS font weight: keywords or numeric values"
      },
      "<font-style>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "italic",
              "oblique"
            ]
          },
          {
            "type": "string",
            "pattern": "^oblique\\s+\\d+deg$"
          }
        ],
        "description": "CSS font style: keywords or oblique with angle"
      },
      "<font-size>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<absolute-size>"
          },
          {
            "$ref": "#/definitions/<relative-size>"
          },
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "math"
            ]
          }
        ],
        "description": "CSS font size: length, percentage, or keyword values"
      },
      "<display>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "table-row-group",
              "table-header-group",
              "table-footer-group",
              "table-row",
              "table-cell",
              "table-column-group",
              "table-column",
              "table-caption",
              "ruby-base",
              "ruby-text",
              "ruby-base-container",
              "ruby-text-container",
              "contents",
              "none",
              "inline-block",
              "inline-table",
              "inline-flex",
              "inline-grid"
            ]
          },
          {
            "type": "string",
            "description": "complex display value that cannot be fully validated with regex"
          }
        ],
        "description": "CSS display property values"
      },
      "<overflow-block>": {
        "type": "string",
        "enum": [
          "visible",
          "hidden",
          "clip",
          "scroll",
          "auto"
        ],
        "description": "CSS overflow-x and overflow-y property values"
      },
      "<overflow>": {
        "type": "string",
        "pattern": "^(visible|hidden|scroll|auto|clip)(\\s+(visible|hidden|scroll|auto|clip))?$",
        "description": "CSS overflow property values"
      },
      "<text-align>": {
        "type": "string",
        "enum": [
          "left",
          "right",
          "center",
          "justify",
          "start",
          "end",
          "match-parent"
        ],
        "description": "CSS text-align property values"
      },
      "<align-items>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "type": "string",
            "enum": [
              "stretch"
            ]
          },
          {
            "$ref": "#/definitions/<baseline-position>"
          },
          {
            "type": "string",
            "pattern": "^((safe|unsafe)\\s+)?(center|start|end|self-start|self-end|flex-start|flex-end)$"
          }
        ],
        "description": "CSS align-items values"
      },
      "<vertical-align>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "baseline",
              "sub",
              "super",
              "text-top",
              "text-bottom",
              "middle",
              "top",
              "bottom"
            ]
          },
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS vertical-align: keywords, length, or percentage"
      },
      "<border-radius>": {
        "type": "string",
        "pattern": "^(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)\\s*){1,4}(/\\s*(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)\\s*){1,4})?$",
        "description": "CSS border-radius shorthand. Complex syntax combining multiple radius values cannot be fully validated with regex."
      },
      "<border-top-left-radius>": {
        "type": "string",
        "pattern": "^(calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))?$",
        "description": "CSS border-top-left-radius shorthand"
      },
      "<border-style>": {
        "type": "string",
        "pattern": "^(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)(\\s+(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)){0,3}$",
        "description": "CSS border-style shorthand"
      },
      "<border-width>": {
        "type": "string",
        "pattern": "^(thin|medium|thick|(calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))(\\s+(thin|medium|thick|(calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))){0,3}$",
        "description": "CSS border-width shorthand"
      },
      "<border>": {
        "type": "string",
        "pattern": "^(?!.*\\/\\s*0).*$",
        "description": "CSS border shorthand with division by zero rejection in calc expressions. Detailed syntax validation handled by css-tree."
      },
      "<background>": {
        "type": "string",
        "description": "CSS background shorthand. Extremely complex syntax combining multiple background layers with image, position, size, repeat, attachment, origin, clip, and color cannot be fully validated with regex."
      },
      "<transition>": {
        "type": "string",
        "description": "CSS transition shorthand. Complex syntax combining property, duration, timing-function, and delay cannot be fully validated with regex."
      },
      "<animation>": {
        "type": "string",
        "description": "CSS animation shorthand. Complex syntax combining name, duration, timing-function, delay, iteration-count, direction, fill-mode, and play-state cannot be fully validated with regex."
      },
      "<grid-template>": {
        "type": "string",
        "description": "CSS grid template properties. Complex syntax with track sizes, line names, and repeat functions cannot be fully validated with regex."
      },
      "<flex-shorthand>": {
        "type": "string",
        "description": "CSS flex shorthand combining flex-grow, flex-shrink, and flex-basis. Complex parsing required to validate the various combinations."
      },
      "<blend-mode>": {
        "type": "string",
        "enum": [
          "normal",
          "multiply",
          "screen",
          "overlay",
          "darken",
          "lighten",
          "color-dodge",
          "color-burn",
          "hard-light",
          "soft-light",
          "difference",
          "exclusion",
          "hue",
          "saturation",
          "color",
          "luminosity"
        ],
        "description": "CSS blend mode values for mix-blend-mode and background-blend-mode"
      },
      "<mix-blend-mode>": {
        "$ref": "#/definitions/<blend-mode>",
        "description": "CSS mix-blend-mode property values"
      },
      "<background-blend-mode>": {
        "$ref": "#/definitions/<blend-mode>",
        "description": "CSS background-blend-mode property values"
      },
      "<timing-function>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "ease",
              "ease-in",
              "ease-out",
              "ease-in-out",
              "linear",
              "step-start",
              "step-end"
            ]
          },
          {
            "type": "string",
            "pattern": "^cubic-bezier\\(\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*\\)$"
          },
          {
            "type": "string",
            "pattern": "^steps\\(\\s*\\d+\\s*(,\\s*(start|end)\\s*)?\\)$"
          }
        ],
        "description": "CSS timing function: keywords, cubic-bezier(), or steps()"
      },
      "<repeat-style>": {
        "type": "string",
        "enum": [
          "repeat",
          "repeat-x",
          "repeat-y",
          "no-repeat",
          "space",
          "round"
        ],
        "description": "CSS background-repeat values"
      },
      "<attachment>": {
        "type": "string",
        "enum": [
          "scroll",
          "fixed",
          "local"
        ],
        "description": "CSS background-attachment values"
      },
      "<origin>": {
        "type": "string",
        "enum": [
          "border-box",
          "padding-box",
          "content-box"
        ],
        "description": "CSS background-origin values"
      },
      "<clip>": {
        "type": "string",
        "enum": [
          "border-box",
          "padding-box",
          "content-box",
          "text"
        ],
        "description": "CSS background-clip values"
      },
      "<sizing>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto",
              "cover",
              "contain"
            ]
          },
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS background-size values"
      },
      "<cursor>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto",
              "default",
              "none",
              "context-menu",
              "help",
              "pointer",
              "progress",
              "wait",
              "cell",
              "crosshair",
              "text",
              "vertical-text",
              "alias",
              "copy",
              "move",
              "no-drop",
              "not-allowed",
              "grab",
              "grabbing",
              "all-scroll",
              "col-resize",
              "row-resize",
              "n-resize",
              "e-resize",
              "s-resize",
              "w-resize",
              "ne-resize",
              "nw-resize",
              "se-resize",
              "sw-resize",
              "ew-resize",
              "ns-resize",
              "nesw-resize",
              "nwse-resize",
              "zoom-in",
              "zoom-out"
            ]
          },
          {
            "$ref": "#/definitions/<url>"
          }
        ],
        "description": "CSS cursor: keywords or custom cursor URLs"
      },
      "<list-style-type>": {
        "type": "string",
        "enum": [
          "disc",
          "circle",
          "square",
          "decimal",
          "decimal-leading-zero",
          "lower-roman",
          "upper-roman",
          "lower-greek",
          "lower-latin",
          "upper-latin",
          "armenian",
          "georgian",
          "lower-alpha",
          "upper-alpha",
          "none"
        ],
        "description": "CSS list-style-type values"
      },
      "<z-index>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<integer>"
          }
        ],
        "description": "CSS z-index: auto or integer"
      },
      "<opacity>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS opacity: number (0-1) or percentage"
      },
      "<visibility>": {
        "type": "string",
        "enum": [
          "visible",
          "hidden",
          "collapse"
        ],
        "description": "CSS visibility values"
      },
      "<white-space>": {
        "type": "string",
        "enum": [
          "normal",
          "nowrap",
          "pre",
          "pre-wrap",
          "pre-line",
          "break-spaces"
        ],
        "description": "CSS white-space values"
      },
      "<text-decoration-line>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none",
              "underline",
              "overline",
              "line-through",
              "blink"
            ],
            "description": "single value text decoration line"
          },
          {
            "type": "string",
            "pattern": "^(underline|overline|line-through|blink)(\\s+(underline|overline|line-through|blink))*$",
            "description": "multiple values text decoration line that cannot be fully validated with regex"
          }
        ],
        "description": "CSS text-decoration-line values"
      },
      "<text-decoration-style>": {
        "type": "string",
        "enum": [
          "solid",
          "double",
          "dotted",
          "dashed",
          "wavy"
        ],
        "description": "CSS text-decoration-style values"
      },
      "<text-transform>": {
        "type": "string",
        "enum": [
          "none",
          "capitalize",
          "uppercase",
          "lowercase",
          "full-width",
          "full-size-kana"
        ],
        "description": "CSS text-transform values"
      },
      "<word-wrap>": {
        "type": "string",
        "enum": [
          "normal",
          "break-word",
          "anywhere"
        ],
        "description": "CSS word-wrap/overflow-wrap values"
      },
      "<user-select>": {
        "type": "string",
        "enum": [
          "auto",
          "text",
          "none",
          "contain",
          "all"
        ],
        "description": "CSS user-select values"
      },
      "<pointer-events>": {
        "type": "string",
        "enum": [
          "auto",
          "bounding-box",
          "none",
          "visiblePainted",
          "visibleFill",
          "visibleStroke",
          "visible",
          "painted",
          "fill",
          "stroke",
          "all"
        ],
        "description": "CSS pointer-events values"
      },
      "<box-sizing>": {
        "type": "string",
        "enum": [
          "content-box",
          "border-box"
        ],
        "description": "CSS box-sizing values"
      },
      "<resize>": {
        "type": "string",
        "enum": [
          "none",
          "both",
          "horizontal",
          "vertical",
          "block",
          "inline"
        ],
        "description": "CSS resize values"
      },
      "<outline>": {
        "type": "string",
        "description": "CSS outline shorthand. Complex syntax combining outline-width, outline-style, and outline-color cannot be fully validated with regex."
      },
      "<quotes>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none",
              "auto"
            ]
          },
          {
            "$ref": "#/definitions/<string>"
          }
        ],
        "description": "CSS quotes: none, auto, or quoted string pairs"
      },
      "<content>": {
        "type": "string",
        "description": "CSS content property. Complex syntax with strings, counters, attr(), and url() cannot be fully validated with regex."
      },
      "<will-change>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "type": "string",
            "enum": [
              "scroll-position",
              "contents"
            ]
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS will-change: auto or property names"
      },
      "<contain>": {
        "type": "string",
        "enum": [
          "none",
          "strict",
          "content",
          "size",
          "inline-size",
          "layout",
          "style",
          "paint"
        ],
        "description": "CSS contain values"
      },
      "<isolation>": {
        "type": "string",
        "enum": [
          "auto",
          "isolate"
        ],
        "description": "CSS isolation values"
      },
      "<writing-mode>": {
        "type": "string",
        "enum": [
          "horizontal-tb",
          "vertical-rl",
          "vertical-lr",
          "sideways-rl",
          "sideways-lr"
        ],
        "description": "CSS writing-mode values"
      },
      "<direction>": {
        "type": "string",
        "enum": [
          "ltr",
          "rtl"
        ],
        "description": "CSS direction values"
      },
      "<unicode-bidi>": {
        "type": "string",
        "enum": [
          "normal",
          "embed",
          "isolate",
          "bidi-override",
          "isolate-override",
          "plaintext"
        ],
        "description": "CSS unicode-bidi values"
      },
      "<object-fit>": {
        "type": "string",
        "enum": [
          "fill",
          "contain",
          "cover",
          "none",
          "scale-down"
        ],
        "description": "CSS object-fit values"
      },
      "<object-position>": {
        "$ref": "#/definitions/<position>",
        "description": "CSS object-position: similar to position."
      },
      "<scroll-behavior>": {
        "type": "string",
        "enum": [
          "auto",
          "smooth"
        ],
        "description": "CSS scroll-behavior values"
      },
      "<appearance>": {
        "type": "string",
        "enum": [
          "none",
          "auto",
          "base-select",
          "textfield",
          "searchfield",
          "textarea",
          "checkbox",
          "radio",
          "menulist",
          "menulist-button",
          "listbox",
          "meter",
          "progress-bar",
          "button"
        ],
        "description": "CSS appearance values"
      },
      "<outline-offset>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS outline-offset: length values"
      },
      "<tab-size>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<integer>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS tab-size: integer or length"
      },
      "<hyphens>": {
        "type": "string",
        "enum": [
          "none",
          "manual",
          "auto"
        ],
        "description": "CSS hyphens values"
      },
      "<word-break>": {
        "type": "string",
        "enum": [
          "normal",
          "break-all",
          "keep-all",
          "break-word"
        ],
        "description": "CSS word-break values"
      },
      "<line-break>": {
        "type": "string",
        "enum": [
          "auto",
          "loose",
          "normal",
          "strict",
          "anywhere"
        ],
        "description": "CSS line-break values"
      },
      "<letter-spacing>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS letter-spacing: normal or length"
      },
      "<word-spacing>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS word-spacing: normal, length, or percentage"
      },
      "<line-height>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<positive-number>"
          },
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          }
        ],
        "description": "CSS line-height: normal, number, length, or percentage"
      },
      "<text-indent>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "type": "string",
            "pattern": "(?:^((calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(?=(?:\\shanging|\\seach-line){0,2}$))|(?:^(?:hanging\\s?|each-line\\s?){1,2}\\s((calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s?(?:hanging|each-line)?$)",
            "description": "css text-indent string"
          }
        ],
        "description": "CSS text-indent: length or percentage, with optional 'hanging' or 'each-line' keywords"
      },
      "<text-overflow>": {
        "type": "string",
        "enum": [
          "clip",
          "ellipsis"
        ],
        "description": "CSS text-overflow values"
      },
      "<text-decoration>": {
        "type": "string",
        "description": "CSS text-decoration shorthand. Complex syntax combining text-decoration-line, text-decoration-style, text-decoration-color, and text-decoration-thickness cannot be fully validated with regex."
      },
      "<text-shadow>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "not": {
              "$ref": "#/definitions/<basic-math-functions-with-percentage>"
            }
          }
        ],
        "description": "CSS text-shadow: complex shadow value cannot be fully validated with regex"
      },
      "<box-shadow>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "not": {
              "$ref": "#/definitions/<basic-math-functions-with-percentage>"
            },
            "description": "complex shadow value that cannot be fully validated with regex"
          }
        ],
        "description": "CSS box-shadow: none or shadow values (h-offset v-offset take <length>, no percentages allowed)"
      },
      "<list-style>": {
        "type": "string",
        "description": "CSS list-style shorthand. Complex syntax combining list-style-type, list-style-position, and list-style-image cannot be fully validated with regex."
      },
      "<list-style-position>": {
        "type": "string",
        "enum": [
          "inside",
          "outside"
        ],
        "description": "CSS list-style-position values"
      },
      "<list-style-image>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          }
        ],
        "description": "CSS list-style-image: none or URL"
      },
      "<alpha-value>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS alpha value for colors: number (0-1) or percentage"
      },
      "<absolute-size>": {
        "type": "string",
        "enum": [
          "xx-small",
          "x-small",
          "small",
          "medium",
          "large",
          "x-large",
          "xx-large",
          "xxx-large"
        ],
        "description": "CSS absolute font sizes"
      },
      "<relative-size>": {
        "type": "string",
        "enum": [
          "larger",
          "smaller"
        ],
        "description": "CSS relative font sizes"
      },
      "<angle-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<angle>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS angle or percentage"
      },
      "<number-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS number or percentage"
      },
      "<time-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<time>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS time or percentage"
      },
      "<frequency-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<frequency>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS frequency or percentage"
      },
      "<baseline-position>": {
        "type": "string",
        "pattern": "^(first\\s+baseline|last\\s+baseline|baseline)$",
        "description": "CSS baseline position: baseline, first baseline, or last baseline"
      },
      "<content-distribution>": {
        "type": "string",
        "enum": [
          "space-between",
          "space-around",
          "space-evenly",
          "stretch"
        ],
        "description": "CSS content distribution values for alignment"
      },
      "<content-position>": {
        "type": "string",
        "enum": [
          "center",
          "start",
          "end",
          "flex-start",
          "flex-end"
        ],
        "description": "CSS content position values for alignment"
      },
      "<self-position>": {
        "type": "string",
        "enum": [
          "center",
          "start",
          "end",
          "self-start",
          "self-end",
          "flex-start",
          "flex-end"
        ],
        "description": "CSS self position values for alignment"
      },
      "<overflow-position>": {
        "type": "string",
        "enum": [
          "unsafe",
          "safe"
        ],
        "description": "CSS overflow position modifiers"
      },
      "<justify-content>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<content-distribution>"
          },
          {
            "$ref": "#/definitions/<content-position>"
          },
          {
            "type": "string",
            "enum": [
              "left",
              "right"
            ]
          },
          {
            "type": "string",
            "pattern": "^(safe|unsafe)?\\s+(left|right|center|start|end|flex-start|flex-end)$"
          }
        ],
        "description": "CSS justify-content values"
      },
      "<visual-box>": {
        "type": "string",
        "enum": [
          "content-box",
          "padding-box",
          "border-box"
        ],
        "description": "CSS visual box types"
      },
      "<shape-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<visual-box>"
          },
          {
            "type": "string",
            "enum": [
              "margin-box"
            ]
          }
        ],
        "description": "CSS shape box types"
      },
      "<geometry-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<shape-box>"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box",
              "view-box"
            ]
          }
        ],
        "description": "CSS geometry box types including visual box and additional geometry boxes"
      },
      "<paint-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<visual-box>"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box"
            ]
          }
        ],
        "description": "CSS paint box types"
      },
      "<coord-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<paint-box>"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box",
              "view-box"
            ]
          }
        ],
        "description": "CSS coordinate box types"
      },
      "<generic-family>": {
        "type": "string",
        "enum": [
          "serif",
          "sans-serif",
          "monospace",
          "cursive",
          "fantasy",
          "system-ui",
          "ui-serif",
          "ui-sans-serif",
          "ui-monospace",
          "ui-rounded",
          "math",
          "emoji",
          "fangsong"
        ],
        "description": "CSS generic font families"
      },
      "<family-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<string>"
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS font family name: quoted string or unquoted identifier"
      },
      "<system-family-name>": {
        "type": "string",
        "enum": [
          "caption",
          "icon",
          "menu",
          "message-box",
          "small-caption",
          "status-bar"
        ],
        "description": "CSS system font family names"
      },
      "<font-stretch-absolute>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "ultra-condensed",
              "extra-condensed",
              "condensed",
              "semi-condensed",
              "semi-expanded",
              "expanded",
              "extra-expanded",
              "ultra-expanded"
            ]
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS font stretch absolute values"
      },
      "<font-weight-absolute>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "bold"
            ]
          },
          {
            "type": "string",
            "pattern": "^(100|200|300|400|500|600|700|800|900|[1-9][0-9]{0,2})$"
          }
        ],
        "description": "CSS font weight absolute values: normal, bold, or number 1-1000"
      },
      "<grid-line>": {
        "type": "string",
        "description": "CSS grid line: auto, custom identifier, integer with optional identifier, or span notation. Complex syntax cannot be fully validated with regex."
      },
      "<track-breadth>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "$ref": "#/definitions/<flex>"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content",
              "auto"
            ]
          }
        ],
        "description": "CSS grid track breadth"
      },
      "<inflexible-breadth>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content",
              "auto"
            ]
          }
        ],
        "description": "CSS inflexible breadth (track breadth without flex)"
      },
      "<track-size>": {
        "type": "string",
        "description": "CSS grid track size: track-breadth, minmax(), or fit-content(). Complex syntax cannot be fully validated with regex."
      },
      "<easing-function>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<timing-function>"
          },
          {
            "type": "string",
            "pattern": "^linear\\(.*\\)$",
            "description": "Linear easing function - arguments cannot be fully validated with regex"
          },
          {
            "type": "string",
            "pattern": "^steps\\(\\s*\\d+\\s*(,\\s*(start|end|jump-start|jump-end|jump-none|jump-both)\\s*)?\\)$"
          }
        ],
        "description": "CSS easing functions including cubic-bezier, steps, and linear"
      },
      "<single-animation-direction>": {
        "type": "string",
        "enum": [
          "normal",
          "reverse",
          "alternate",
          "alternate-reverse"
        ],
        "description": "CSS animation direction values"
      },
      "<single-animation-fill-mode>": {
        "type": "string",
        "enum": [
          "none",
          "forwards",
          "backwards",
          "both"
        ],
        "description": "CSS animation fill mode values"
      },
      "<single-animation-play-state>": {
        "type": "string",
        "enum": [
          "running",
          "paused"
        ],
        "description": "CSS animation play state values"
      },
      "<single-animation-iteration-count>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "type": "string",
            "enum": [
              "infinite"
            ]
          }
        ],
        "description": "CSS animation iteration count: number or infinite"
      },
      "<keyframes-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<custom-ident>"
          },
          {
            "$ref": "#/definitions/<string>"
          }
        ],
        "description": "CSS keyframes name: identifier or string"
      },
      "<single-transition-property>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "all"
            ]
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS transition property: all or property name"
      },
      "<quote>": {
        "type": "string",
        "enum": [
          "open-quote",
          "close-quote",
          "no-open-quote",
          "no-close-quote"
        ],
        "description": "CSS quote values for generated content"
      },
      "<counter-style-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<custom-ident>"
          },
          {
            "type": "string",
            "enum": [
              "decimal",
              "decimal-leading-zero",
              "lower-roman",
              "upper-roman",
              "lower-greek",
              "lower-latin",
              "upper-latin",
              "armenian",
              "georgian",
              "lower-alpha",
              "upper-alpha",
              "disc",
              "circle",
              "square",
              "none"
            ]
          }
        ],
        "description": "CSS counter style: predefined or custom identifier"
      },
      "<ratio>": {
        "type": "string",
        "pattern": "^\\d+(\\.\\d+)?\\s*/\\s*\\d+(\\.\\d+)?$",
        "description": "CSS ratio: number/number"
      },
      "<dasharray>": {
        "type": "string",
        "description": "CSS dash array for stroke-dasharray. Complex syntax with multiple length/percentage/number values cannot be fully validated with regex."
      },
      "<paint>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<color>"
          },
          {
            "$ref": "#/definitions/<url>"
          }
        ],
        "description": "CSS paint values for SVG: none, color, URL, or context keywords"
      },
      "<overflow-wrap>": {
        "type": "string",
        "enum": [
          "normal",
          "break-word",
          "anywhere"
        ],
        "description": "CSS overflow-wrap values (same as word-wrap)"
      },
      "<text-decoration-thickness>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "$ref": "#/definitions/<positive-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "from-font"
            ]
          }
        ],
        "description": "CSS text decoration thickness"
      },
      "<text-underline-offset>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS text underline offset"
      },
      "<text-emphasis-style>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "enum": [
              "filled",
              "open",
              "dot",
              "circle",
              "double-circle",
              "triangle",
              "sesame"
            ]
          },
          {
            "$ref": "#/definitions/<string>"
          }
        ],
        "description": "CSS text emphasis style"
      },
      "<mask-composite>": {
        "type": "string",
        "enum": [
          "add",
          "subtract",
          "intersect",
          "exclude"
        ],
        "description": "CSS mask composite operation values"
      },
      "<mask-mode>": {
        "type": "string",
        "enum": [
          "alpha",
          "luminance",
          "match-source"
        ],
        "description": "CSS mask mode values"
      },
      "<clip-path>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<url>"
          },
          {
            "$ref": "#/definitions/<basic-shape>"
          }
        ],
        "description": "CSS clip-path: none, URL, or basic shape"
      },
      "<shape-outside>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          },
          {
            "$ref": "#/definitions/<basic-shape>"
          }
        ],
        "description": "CSS shape-outside: none, image, or basic shape"
      },
      "<intrinsic-size-keyword>": {
        "type": "string",
        "enum": [
          "auto",
          "min-content",
          "max-content",
          "fit-content"
        ],
        "description": "CSS intrinsic sizing keywords"
      },
      "<step-position>": {
        "type": "string",
        "enum": [
          "jump-start",
          "jump-end",
          "jump-none",
          "jump-both",
          "start",
          "end"
        ],
        "description": "CSS step position for steps() timing function"
      },
      "<system-color>": {
        "type": "string",
        "enum": [
          "AccentColor",
          "AccentColorText",
          "ActiveText",
          "ButtonBorder",
          "ButtonFace",
          "ButtonText",
          "Canvas",
          "CanvasText",
          "Field",
          "FieldText",
          "GrayText",
          "Highlight",
          "HighlightText",
          "LinkText",
          "Mark",
          "MarkText",
          "SelectedItem",
          "SelectedItemText",
          "VisitedText"
        ],
        "description": "CSS system colors"
      },
      "<deprecated-system-color>": {
        "type": "string",
        "enum": [
          "ActiveBorder",
          "ActiveCaption",
          "AppWorkspace",
          "Background",
          "ButtonHighlight",
          "ButtonShadow",
          "CaptionText",
          "InactiveBorder",
          "InactiveCaption",
          "InactiveCaptionText",
          "InfoBackground",
          "InfoText",
          "Menu",
          "MenuText",
          "Scrollbar",
          "ThreeDDarkShadow",
          "ThreeDFace",
          "ThreeDHighlight",
          "ThreeDLightShadow",
          "ThreeDShadow",
          "Window",
          "WindowFrame",
          "WindowText"
        ],
        "description": "CSS deprecated system colors"
      },
      "<bg-size>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "auto",
              "cover",
              "contain"
            ]
          },
          {
            "type": "string",
            "pattern": "^(auto|calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(auto|calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))?)$",
            "description": "complex syntax with multiple values that cannot be fully validated with regex"
          }
        ],
        "description": "CSS background-size values"
      },
      "<bg-position>": {
        "type": "string",
        "description": "CSS background-position values. Complex syntax with multiple position values and combinations cannot be fully validated with regex."
      },
      "<bg-clip>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<visual-box>"
          },
          {
            "type": "string",
            "enum": [
              "text"
            ]
          }
        ],
        "description": "CSS background-clip values"
      },
      "<bg-image>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          }
        ],
        "description": "CSS background-image values"
      },
      "<hue>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<angle>"
          }
        ],
        "description": "CSS hue value: number or angle"
      },
      "<radial-shape>": {
        "type": "string",
        "enum": [
          "circle",
          "ellipse"
        ],
        "description": "CSS radial gradient shape"
      },
      "<radial-extent>": {
        "type": "string",
        "enum": [
          "closest-corner",
          "closest-side",
          "farthest-corner",
          "farthest-side"
        ],
        "description": "CSS radial gradient extent"
      },
      "<side-or-corner>": {
        "type": "string",
        "pattern": "^(left|right|top|bottom)$|^(left|right)\\s+(top|bottom)$|^(top|bottom)\\s+(left|right)$",
        "description": "CSS gradient side or corner direction"
      },
      "<color-stop-length>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "type": "string",
            "pattern": "^\\d+(\\.\\d+)?%\\s+\\d+(\\.\\d+)?%$"
          }
        ],
        "description": "CSS color stop length: single or double length-percentage"
      },
      "<color-stop-angle>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<angle-percentage>"
          },
          {
            "type": "string",
            "pattern": "^\\d+(\\.\\d+)?deg\\s+\\d+(\\.\\d+)?deg$"
          }
        ],
        "description": "CSS color stop angle: single or double angle-percentage"
      },
      "<masking-mode>": {
        "type": "string",
        "enum": [
          "alpha",
          "luminance",
          "match-source"
        ],
        "description": "CSS masking mode values"
      },
      "<mask-reference>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          },
          {
            "$ref": "#/definitions/<url>"
          }
        ],
        "description": "CSS mask reference values"
      },
      "<outline-line-style>": {
        "type": "string",
        "enum": [
          "none",
          "dotted",
          "dashed",
          "solid",
          "double",
          "groove",
          "ridge",
          "inset",
          "outset"
        ],
        "description": "CSS outline line style values"
      },
      "<counter-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<custom-ident>"
          },
          {
            "type": "string",
            "enum": [
              "list-item"
            ]
          }
        ],
        "description": "CSS counter name: custom identifier or list-item"
      },
      "<symbol>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<string>"
          },
          {
            "$ref": "#/definitions/<image>"
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS symbol values for counters"
      },
      "<symbols-type>": {
        "type": "string",
        "enum": [
          "cyclic",
          "numeric",
          "alphabetic",
          "symbolic",
          "fixed"
        ],
        "description": "CSS symbols() function type"
      },
      "<feature-tag-value>": {
        "type": "string",
        "description": "CSS font feature tag value. Complex syntax with string and optional integer/keyword cannot be fully validated with regex."
      },
      "<east-asian-variant-values>": {
        "type": "string",
        "enum": [
          "jis78",
          "jis83",
          "jis90",
          "jis04",
          "simplified",
          "traditional"
        ],
        "description": "CSS East Asian variant values"
      },
      "<east-asian-width-values>": {
        "type": "string",
        "enum": [
          "full-width",
          "proportional-width"
        ],
        "description": "CSS East Asian width values"
      },
      "<numeric-figure-values>": {
        "type": "string",
        "enum": [
          "lining-nums",
          "oldstyle-nums"
        ],
        "description": "CSS numeric figure values"
      },
      "<numeric-fraction-values>": {
        "type": "string",
        "enum": [
          "diagonal-fractions",
          "stacked-fractions"
        ],
        "description": "CSS numeric fraction values"
      },
      "<numeric-spacing-values>": {
        "type": "string",
        "enum": [
          "proportional-nums",
          "tabular-nums"
        ],
        "description": "CSS numeric spacing values"
      },
      "<common-lig-values>": {
        "type": "string",
        "enum": [
          "common-ligatures",
          "no-common-ligatures"
        ],
        "description": "CSS common ligature values"
      },
      "<discretionary-lig-values>": {
        "type": "string",
        "enum": [
          "discretionary-ligatures",
          "no-discretionary-ligatures"
        ],
        "description": "CSS discretionary ligature values"
      },
      "<historical-lig-values>": {
        "type": "string",
        "enum": [
          "historical-ligatures",
          "no-historical-ligatures"
        ],
        "description": "CSS historical ligature values"
      },
      "<contextual-alt-values>": {
        "type": "string",
        "enum": [
          "contextual",
          "no-contextual"
        ],
        "description": "CSS contextual alternates values"
      },
      "<composite-style>": {
        "type": "string",
        "enum": [
          "clear",
          "copy",
          "source-over",
          "source-in",
          "source-out",
          "source-atop",
          "destination-over",
          "destination-in",
          "destination-out",
          "destination-atop",
          "xor"
        ],
        "description": "CSS composite style values"
      },
      "<compositing-operator>": {
        "type": "string",
        "enum": [
          "add",
          "subtract",
          "intersect",
          "exclude"
        ],
        "description": "CSS compositing operator values"
      },
      "<axis>": {
        "type": "string",
        "enum": [
          "block",
          "inline",
          "x",
          "y"
        ],
        "description": "CSS axis values"
      },
      "<scroller>": {
        "type": "string",
        "enum": [
          "root",
          "nearest",
          "self"
        ],
        "description": "CSS scroller values"
      },
      "<try-size>": {
        "type": "string",
        "enum": [
          "most-width",
          "most-height",
          "most-block-size",
          "most-inline-size"
        ],
        "description": "CSS try size values"
      },
      "<try-tactic>": {
        "type": "string",
        "enum": [
          "flip-block",
          "flip-inline",
          "flip-start"
        ],
        "description": "CSS try tactic values"
      },
      "<font>": {
        "type": "string",
        "description": "CSS font shorthand. Complex syntax combining font-style, font-variant, font-weight, font-size/line-height, and font-family cannot be fully validated with regex."
      },
      "<font-variant>": {
        "type": "string",
        "description": "CSS font-variant shorthand. Complex syntax combining normal, small-caps, and various feature values cannot be fully validated with regex."
      },
      "<flex-direction>": {
        "type": "string",
        "enum": [
          "row",
          "row-reverse",
          "column",
          "column-reverse"
        ],
        "description": "CSS flex-direction values"
      },
      "<gap>": {
        "type": "string",
        "pattern": "^(normal|0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s|$){1,2}",
        "description": "CSS gap values"
      },
      "<padding>": {
        "type": "string",
        "pattern": "^((0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s*){1,4}$",
        "description": "CSS padding values"
      },
      "<padding-top>": {
        "$ref": "#/definitions/<positive-length-percentage>",
        "description": "CSS padding-top values"
      },
      "type": "object"
    }
  },
  "cssPropertySchemas.json": {
    "$id": "urn:dm:schemas:cssPropertySchemas.json",
    "title": "CSS Property Schemas",
    "description": "Individual JSON Schema definitions for CSS property value types used within Wix",
    "definitions": {
      "CSS.Color": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<color>",
                "format": "css-color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BlendMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<blend-mode>",
                "format": "css-blend-mode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Angle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<angle>",
                "format": "css-angle"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LengthPercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage>",
                "format": "css-length-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveLengthPercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage>",
                "format": "css-length-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Length": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length>",
                "format": "css-length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveLength": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length>",
                "format": "css-length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Number": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<number>",
                "format": "css-number"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveNumber": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-number>",
                "format": "css-number"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Percentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<percentage>",
                "format": "css-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositivePercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-percentage>",
                "format": "css-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.String": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<string>",
                "format": "css-string"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Time": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<time>",
                "format": "css-time"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-style>",
                "format": "css-border-top-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-width>",
                "format": "css-border-top-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-width>",
                "format": "css-border-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-style>",
                "format": "css-border-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderColor": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<color>",
                "format": "css-border-color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Border": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border>",
                "format": "css-border"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderRadius": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-radius>",
                "description": "border radius shorthand syntax",
                "format": "css-border-radius"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopLeftRadius": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-top-left-radius>",
                "format": "css-border-top-left-radius"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Font": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font>",
                "format": "css-font"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontFamily": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.String"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-family>",
                "format": "css-font-family"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontSize": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-size>",
                "format": "css-font-size"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontStretch": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-stretch-absolute>",
                "format": "css-font-stretch"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-style>",
                "format": "css-font-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontVariant": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-variant>",
                "format": "css-font-variant"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontWeight": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-weight>",
                "format": "css-font-weight"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LineHeight": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveNumber"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-height>",
                "format": "css-line-height"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LetterSpacing": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<letter-spacing>",
                "format": "css-letter-spacing"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextAlign": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-align>",
                "format": "css-text-align"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextTransform": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-transform>",
                "format": "css-text-transform"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextShadow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-shadow>",
                "format": "css-text-shadow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecoration": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration>",
                "format": "css-text-decoration"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationLine": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-line>",
                "format": "css-text-decoration-line"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-style>",
                "format": "css-text-decoration-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationThickness": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-thickness>",
                "format": "css-text-decoration-thickness"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextOverflow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-overflow>",
                "format": "css-text-overflow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextIndent": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-indent>",
                "format": "css-text-indent"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Padding": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<padding>",
                "format": "css-padding",
                "description": "padding shorthand syntax"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PaddingTop": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<padding-top>",
                "format": "css-padding-top"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Margin": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "margin shorthand syntax",
                "format": "css-margin"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.MarginTop": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage-auto>",
                "format": "css-margin-top"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BoxShadow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<box-shadow>",
                "format": "css-box-shadow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Opacity": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<opacity>",
                "format": "css-opacity"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Background": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<background>",
                "format": "css-background"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundSize": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-size>",
                "format": "css-background-size"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundImage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-image>",
                "format": "css-background-image"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.AlignSelf": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<self-position>",
                "format": "css-align-self"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.HeightOrWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage-auto>",
                "format": "css-height-or-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundClip": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-clip>",
                "format": "css-background-clip"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundOrigin": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<origin>",
                "format": "css-background-origin"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundPosition": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-position>",
                "format": "css-background-position"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundRepeat": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<repeat-style>",
                "format": "css-background-repeat"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundAttachment": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<attachment>",
                "format": "css-background-attachment"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Overflow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow>",
                "format": "css-overflow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.OverflowX": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow-block>",
                "format": "css-overflow-x"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.OverflowY": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow-block>",
                "format": "css-overflow-y"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.AlignItems": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<align-items>",
                "format": "css-align-items"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FlexDirection": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<flex-direction>",
                "format": "css-flex-direction"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Gap": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.SingleValueGap"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<gap>",
                "format": "css-gap"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.SingleValueGap": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage>",
                "format": "css-single-value-gap"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.JustifyContent": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<justify-content>",
                "format": "css-justify-content"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FillWithURL": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<paint>",
                "format": "css-fill-with-url"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Isolation": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<isolation>",
                "format": "css-isolation"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.MixBlendMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BlendMode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<mix-blend-mode>",
                "format": "css-mix-blend-mode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.ObjectFit": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<object-fit>",
                "format": "css-object-fit"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.ObjectPosition": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<object-position>",
                "format": "css-object-position"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FillOpacity": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<alpha-value>",
                "format": "css-fill-opacity"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Stroke": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<paint>",
                "format": "css-stroke"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.StrokeWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage>",
                "format": "css-stroke-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.StrokeOpacity": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<alpha-value>",
                "format": "css-stroke-opacity"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Display": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<display>",
                "format": "css-display"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Filter": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<filter>",
                "format": "css-filter"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.WritingMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<writing-mode>",
                "format": "css-writing-mode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "unevaluatedProperties": false,
      "type": "object"
    },
    "title--unrestricted-root": "CSS Property Schemas",
    "description--unrestricted-root": "Individual JSON Schema definitions for CSS property value types used within Wix",
    "definitions--unrestricted-root": {
      "CSS.Color": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<color>",
                "format": "css-color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BlendMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<blend-mode>",
                "format": "css-blend-mode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Angle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<angle>",
                "format": "css-angle"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LengthPercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage>",
                "format": "css-length-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveLengthPercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage>",
                "format": "css-length-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Length": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length>",
                "format": "css-length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveLength": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length>",
                "format": "css-length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Number": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<number>",
                "format": "css-number"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveNumber": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-number>",
                "format": "css-number"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Percentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<percentage>",
                "format": "css-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositivePercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-percentage>",
                "format": "css-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.String": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<string>",
                "format": "css-string"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Time": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<time>",
                "format": "css-time"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-style>",
                "format": "css-border-top-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-width>",
                "format": "css-border-top-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-width>",
                "format": "css-border-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-style>",
                "format": "css-border-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderColor": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<color>",
                "format": "css-border-color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Border": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border>",
                "format": "css-border"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderRadius": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-radius>",
                "description": "border radius shorthand syntax",
                "format": "css-border-radius"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopLeftRadius": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-top-left-radius>",
                "format": "css-border-top-left-radius"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Font": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font>",
                "format": "css-font"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontFamily": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.String"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-family>",
                "format": "css-font-family"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontSize": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-size>",
                "format": "css-font-size"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontStretch": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-stretch-absolute>",
                "format": "css-font-stretch"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-style>",
                "format": "css-font-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontVariant": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-variant>",
                "format": "css-font-variant"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontWeight": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-weight>",
                "format": "css-font-weight"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LineHeight": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveNumber"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-height>",
                "format": "css-line-height"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LetterSpacing": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<letter-spacing>",
                "format": "css-letter-spacing"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextAlign": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-align>",
                "format": "css-text-align"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextTransform": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-transform>",
                "format": "css-text-transform"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextShadow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-shadow>",
                "format": "css-text-shadow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecoration": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration>",
                "format": "css-text-decoration"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationLine": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-line>",
                "format": "css-text-decoration-line"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-style>",
                "format": "css-text-decoration-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationThickness": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-thickness>",
                "format": "css-text-decoration-thickness"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextOverflow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-overflow>",
                "format": "css-text-overflow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextIndent": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-indent>",
                "format": "css-text-indent"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Padding": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<padding>",
                "format": "css-padding",
                "description": "padding shorthand syntax"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PaddingTop": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<padding-top>",
                "format": "css-padding-top"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Margin": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "margin shorthand syntax",
                "format": "css-margin"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.MarginTop": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage-auto>",
                "format": "css-margin-top"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BoxShadow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<box-shadow>",
                "format": "css-box-shadow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Opacity": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<opacity>",
                "format": "css-opacity"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Background": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<background>",
                "format": "css-background"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundSize": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-size>",
                "format": "css-background-size"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundImage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-image>",
                "format": "css-background-image"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.AlignSelf": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<self-position>",
                "format": "css-align-self"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.HeightOrWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage-auto>",
                "format": "css-height-or-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundClip": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-clip>",
                "format": "css-background-clip"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundOrigin": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<origin>",
                "format": "css-background-origin"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundPosition": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-position>",
                "format": "css-background-position"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundRepeat": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<repeat-style>",
                "format": "css-background-repeat"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundAttachment": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<attachment>",
                "format": "css-background-attachment"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Overflow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow>",
                "format": "css-overflow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.OverflowX": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow-block>",
                "format": "css-overflow-x"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.OverflowY": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow-block>",
                "format": "css-overflow-y"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.AlignItems": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<align-items>",
                "format": "css-align-items"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FlexDirection": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<flex-direction>",
                "format": "css-flex-direction"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Gap": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.SingleValueGap"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<gap>",
                "format": "css-gap"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.SingleValueGap": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage>",
                "format": "css-single-value-gap"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.JustifyContent": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<justify-content>",
                "format": "css-justify-content"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FillWithURL": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<paint>",
                "format": "css-fill-with-url"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Isolation": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<isolation>",
                "format": "css-isolation"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.MixBlendMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BlendMode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<mix-blend-mode>",
                "format": "css-mix-blend-mode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.ObjectFit": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<object-fit>",
                "format": "css-object-fit"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.ObjectPosition": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<object-position>",
                "format": "css-object-position"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FillOpacity": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<alpha-value>",
                "format": "css-fill-opacity"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Stroke": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<paint>",
                "format": "css-stroke"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.StrokeWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage>",
                "format": "css-stroke-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.StrokeOpacity": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<alpha-value>",
                "format": "css-stroke-opacity"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Display": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<display>",
                "format": "css-display"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Filter": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<filter>",
                "format": "css-filter"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.WritingMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<writing-mode>",
                "format": "css-writing-mode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "type": "object"
    }
  },
  "cursor.json": {
    "$id": "urn:dm:schemas:cursor.json",
    "Cursor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "media": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            },
            "offsetX": {
              "type": "number",
              "default": 0,
              "minimum": 0,
              "maximum": 128,
              "multipleOf": 1
            },
            "offsetY": {
              "type": "number",
              "default": 0,
              "minimum": 0,
              "maximum": 128,
              "multipleOf": 1
            },
            "width": {
              "type": "number",
              "default": 32,
              "minimum": 0,
              "maximum": 128,
              "multipleOf": 1
            },
            "height": {
              "type": "number",
              "default": 32,
              "minimum": 0,
              "maximum": 128,
              "multipleOf": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Image": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/Common_Image"
    },
    "SVGItem": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/Common_SVGItem"
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "Cursor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "media": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            },
            "offsetX": {
              "type": "number",
              "default": 0,
              "minimum": 0,
              "maximum": 128,
              "multipleOf": 1
            },
            "offsetY": {
              "type": "number",
              "default": 0,
              "minimum": 0,
              "maximum": 128,
              "multipleOf": 1
            },
            "width": {
              "type": "number",
              "default": 32,
              "minimum": 0,
              "maximum": 128,
              "multipleOf": 1
            },
            "height": {
              "type": "number",
              "default": 32,
              "minimum": 0,
              "maximum": 128,
              "multipleOf": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "Image--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/Common_Image"
    },
    "SVGItem--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/Common_SVGItem"
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    }
  },
  "design_data.json": {
    "$id": "urn:dm:schemas:design_data.json",
    "MediaContainerDesignData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "charas": {
              "type": [
                "string",
                "null"
              ]
            },
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "dataChangeBehaviors": {
              "$ref": "#/dataChangeBehaviors"
            },
            "cssStyle": {
              "$ref": "#/cssStyle"
            },
            "themeMappings": {
              "type": "object",
              "additionalProperties": {
                "type": "string"
              },
              "unevaluatedProperties": false
            },
            "mediaRef": {
              "unevaluatedProperties": false,
              "type": "object"
            },
            "posterImageRef": {
              "unevaluatedProperties": false,
              "type": "object"
            },
            "imageOverlay": {
              "unevaluatedProperties": false,
              "type": "object"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MediaContainerWithDividers": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "dividerTop": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "dividerBottom": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ShapeDivider": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "svgId"
          ],
          "properties": {
            "svgId": {
              "type": "string"
            },
            "color": {
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "padding": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "height": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "offsetX": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "flip": {
              "type": "boolean"
            },
            "invert": {
              "type": "boolean"
            },
            "keepAspectRatio": {
              "type": "boolean"
            },
            "shouldRepeat": {
              "type": "boolean"
            },
            "repeatCount": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "layersEffect": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "$ref": "#/LayersEffect--unrestricted-root"
                }
              ]
            },
            "presetId": {
              "type": "string",
              "maxLength": 20
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MediaPlayerDesignData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "charas": {
              "type": [
                "string",
                "null"
              ]
            },
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "cssStyle": {
              "$ref": "#/cssStyle"
            },
            "themeMappings": {
              "type": "object",
              "additionalProperties": {
                "type": "string"
              },
              "unevaluatedProperties": false
            },
            "posterImageRef": {
              "unevaluatedProperties": false,
              "type": "object"
            },
            "mediaRef": {
              "unevaluatedProperties": false,
              "type": "object"
            },
            "imageOverlay": {
              "unevaluatedProperties": false,
              "type": "object"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextFxDesign": {
      "type": "object",
      "properties": {
        "autoScale": {
          "type": "boolean",
          "default": true,
          "description": "true - scale the text dynamically by layout, false - no scaling (text size by font size)"
        },
        "align": {
          "enum": [
            "start",
            "middle",
            "end"
          ],
          "default": "middle"
        },
        "family": {
          "type": "string",
          "maxLength": 150
        },
        "size": {
          "type": "number",
          "minimum": 6,
          "maximum": 999
        },
        "weight": {
          "enum": [
            "normal",
            "bold",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ],
          "default": "normal"
        },
        "style": {
          "enum": [
            "normal",
            "italic"
          ],
          "default": "normal"
        },
        "decoration": {
          "enum": [
            "none",
            "underline",
            "line-through"
          ],
          "default": "none"
        },
        "transform": {
          "enum": [
            "none",
            "capitalize",
            "uppercase",
            "lowercase"
          ],
          "default": "none"
        },
        "letterSpacing": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
        },
        "lineHeight": {
          "type": "number",
          "minimum": 0,
          "maximum": 7,
          "default": 1
        },
        "outlineColor": {
          "maxLength": 40,
          "$ref": "urn:dm:schemas:common.json#/color"
        },
        "outlineOpacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "outlineWidth": {
          "type": "number",
          "minimum": 0
        },
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "#/Shadow--unrestricted-root"
            }
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "TextFxMask": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/TextFxDesign--unrestricted-root"
            },
            {
              "properties": {
                "media": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                },
                "mediaRotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360
                },
                "mediaFlip": {
                  "enum": [
                    "none",
                    "horizontal",
                    "vertical",
                    "both"
                  ],
                  "default": "none"
                },
                "viewBox": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "minimum": 7,
                  "maximum": 200
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextFxPath": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/TextFxDesign--unrestricted-root"
            },
            {
              "properties": {
                "path": {
                  "type": "string",
                  "maxLength": 1024
                },
                "keepAspectRatio": {
                  "type": "boolean"
                },
                "keepFontSize": {
                  "type": "boolean"
                },
                "inside": {
                  "type": "boolean"
                },
                "verticalAlign": {
                  "enum": [
                    "top",
                    "middle",
                    "bottom"
                  ],
                  "default": "bottom"
                },
                "verticalOffset": {
                  "type": "number"
                },
                "horizontalOffset": {
                  "type": "number"
                },
                "spread": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "textColor": {
                  "maxLength": 40,
                  "$ref": "urn:dm:schemas:common.json#/color"
                },
                "textOpacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "fillColor": {
                  "maxLength": 40,
                  "$ref": "urn:dm:schemas:common.json#/color"
                },
                "fillOpacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "strokeColor": {
                  "maxLength": 40,
                  "$ref": "urn:dm:schemas:common.json#/color"
                },
                "strokeOpacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "strokeWidth": {
                  "type": "number",
                  "minimum": 0
                },
                "viewBox": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "minimum": 7,
                  "maximum": 200
                },
                "presetId": {
                  "type": "string",
                  "maxLength": 20
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "css-keyword": {
      "type": "boolean",
      "additionalProperties": false
    },
    "css-percentage": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "value": {
          "type": "number"
        },
        "unit": {
          "enum": [
            "%"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "css-absolute-length-unit": {
      "enum": [
        "px",
        "cm",
        "mm",
        "q",
        "in",
        "pt",
        "pc"
      ]
    },
    "css-relative-length-unit": {
      "enum": [
        "em",
        "ex",
        "ch",
        "rem",
        "vw",
        "vh",
        "vmin",
        "vmax"
      ]
    },
    "css-length": {
      "type": "object",
      "required": [
        "unit",
        "value"
      ],
      "additionalProperties": false,
      "properties": {
        "unit": {
          "type": "string",
          "oneOf": [
            {
              "$ref": "#/css-absolute-length-unit--unrestricted-root"
            },
            {
              "$ref": "#/css-relative-length-unit--unrestricted-root"
            }
          ]
        },
        "value": {
          "type": "number"
        }
      },
      "unevaluatedProperties": false
    },
    "css-length-or-percentage": {
      "type": "object",
      "oneOf": [
        {
          "$ref": "#/css-length--unrestricted-root"
        },
        {
          "$ref": "#/css-percentage--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "css-byte": {
      "type": "number",
      "default": 0,
      "multipleOf": 1,
      "minimum": 0,
      "maximum": 255
    },
    "css-color": {
      "type": "object",
      "required": [
        "red",
        "green",
        "blue",
        "alpha"
      ],
      "additionalProperties": false,
      "properties": {
        "red": {
          "$ref": "#/css-byte"
        },
        "green": {
          "$ref": "#/css-byte"
        },
        "blue": {
          "$ref": "#/css-byte"
        },
        "alpha": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "unevaluatedProperties": false
    },
    "css-box-shadow": {
      "type": "array",
      "items": {
        "required": [
          "inset",
          "offsetX",
          "offsetY",
          "blurRadius",
          "spreadRadius",
          "color"
        ],
        "additionalProperties": false,
        "properties": {
          "inset": {
            "$ref": "#/css-keyword"
          },
          "offsetX": {
            "$ref": "#/css-length"
          },
          "offsetY": {
            "$ref": "#/css-length"
          },
          "blurRadius": {
            "$ref": "#/css-length"
          },
          "spreadRadius": {
            "$ref": "#/css-length"
          },
          "color": {
            "$ref": "#/css-color"
          }
        },
        "unevaluatedProperties": false,
        "type": "object"
      },
      "minItems": 1
    },
    "css-border-radius": {
      "type": "object",
      "required": [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
      ],
      "additionalProperties": false,
      "properties": {
        "topLeft": {
          "$ref": "#/css-length-or-percentage"
        },
        "topRight": {
          "$ref": "#/css-length-or-percentage"
        },
        "bottomLeft": {
          "$ref": "#/css-length-or-percentage"
        },
        "bottomRight": {
          "$ref": "#/css-length-or-percentage"
        }
      },
      "unevaluatedProperties": false
    },
    "css-br-width": {
      "type": "object",
      "oneOf": [
        {
          "$ref": "#/css-length--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "css-border-width": {
      "type": "object",
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "additionalProperties": false,
      "properties": {
        "top": {
          "$ref": "#/css-br-width"
        },
        "right": {
          "$ref": "#/css-br-width"
        },
        "bottom": {
          "$ref": "#/css-br-width"
        },
        "left": {
          "$ref": "#/css-br-width"
        }
      },
      "unevaluatedProperties": false
    },
    "css-br-style": {
      "enum": [
        "none",
        "hidden",
        "dotted",
        "dashed",
        "solid",
        "double",
        "groove",
        "ridge",
        "inset",
        "outset"
      ]
    },
    "css-border-style": {
      "type": "object",
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "additionalProperties": false,
      "properties": {
        "top": {
          "$ref": "#/css-br-style"
        },
        "right": {
          "$ref": "#/css-br-style"
        },
        "bottom": {
          "$ref": "#/css-br-style"
        },
        "left": {
          "$ref": "#/css-br-style"
        }
      },
      "unevaluatedProperties": false
    },
    "css-border-color": {
      "type": "object",
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "additionalProperties": false,
      "properties": {
        "top": {
          "$ref": "#/css-color"
        },
        "right": {
          "$ref": "#/css-color"
        },
        "bottom": {
          "$ref": "#/css-color"
        },
        "left": {
          "$ref": "#/css-color"
        }
      },
      "unevaluatedProperties": false
    },
    "css-border": {
      "type": "object",
      "required": [
        "width",
        "style",
        "color"
      ],
      "additionalProperties": false,
      "properties": {
        "width": {
          "$ref": "#/css-border-width"
        },
        "style": {
          "$ref": "#/css-border-style"
        },
        "color": {
          "$ref": "#/css-border-color"
        }
      },
      "unevaluatedProperties": false
    },
    "cssBorder": {
      "$ref": "#/css-border"
    },
    "cssBorderRadius": {
      "$ref": "#/css-border-radius"
    },
    "cssBoxShadow": {
      "$ref": "#/css-box-shadow"
    },
    "cssStyle": {
      "type": "object",
      "properties": {
        "cssBorder": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "#/cssBorder--unrestricted-root"
            }
          ]
        },
        "cssBoxShadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "#/cssBoxShadow--unrestricted-root"
            }
          ]
        },
        "cssBorderRadius": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "#/cssBorderRadius--unrestricted-root"
            }
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "LayersEffect": {
      "type": "object",
      "required": [
        "size"
      ],
      "properties": {
        "size": {
          "type": "number",
          "minimum": 1,
          "maximum": 10
        },
        "y": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
        },
        "x": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
        },
        "pin": {
          "type": "string",
          "enum": [
            "in",
            "out"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "dataChangeBehaviors": {
      "type": [
        "array",
        "null"
      ],
      "items": {
        "type": "object",
        "properties": {
          "trigger": {
            "type": "string"
          },
          "type": {
            "type": "string"
          },
          "part": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "params": {
            "type": "object",
            "unevaluatedProperties": false
          }
        },
        "unevaluatedProperties": false
      }
    },
    "BackgroundMedia": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "mediaRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mediaTransforms": {
              "$ref": "#/BackgroundTransforms"
            },
            "overlayTransforms": {
              "$ref": "#/BackgroundTransforms"
            },
            "color": {
              "oneOf": [
                {
                  "enum": [
                    "transparent",
                    "noColor"
                  ]
                },
                {
                  "$ref": "urn:dm:schemas:common.json#/color--unrestricted-root"
                }
              ]
            },
            "colorOpacity": {
              "type": "number"
            },
            "alignType": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "left",
                "right",
                "center",
                "top_left",
                "top_right",
                "bottom_left",
                "bottom_right"
              ]
            },
            "fittingType": {
              "type": "string",
              "enum": [
                "fill",
                "fit",
                "stretch",
                "actual_size",
                "original_size",
                "tile",
                "tile_horizontal",
                "tile_vertical",
                "fit_and_tile",
                "legacy_tile",
                "legacy_tile_horizontal",
                "legacy_tile_vertical",
                "legacy_normal"
              ]
            },
            "scrollType": {
              "type": "string",
              "enum": [
                "none",
                "fixed",
                "scroll",
                "local",
                "parallax"
              ]
            },
            "showOverlayForMediaType": {
              "type": "string",
              "enum": [
                "all",
                "WixVideo",
                "Image"
              ],
              "default": "WixVideo"
            },
            "imageOverlay": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "colorOverlay": {
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "colorOverlayOpacity": {
              "type": "number"
            },
            "overlayBlending": {
              "$ref": "#/overlayBlending"
            },
            "filterEffect": {
              "$ref": "#/filterEffect"
            },
            "colorLayers": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/ColorLayers"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BlendMode": {
      "type": "string",
      "enum": [
        "normal",
        "multiply",
        "screen",
        "darken",
        "lighten",
        "overlay",
        "colorDodge",
        "colorBurn",
        "hardLight",
        "softLight",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ]
    },
    "Shadow": {
      "type": "object",
      "properties": {
        "x": {
          "type": "number"
        },
        "y": {
          "type": "number"
        },
        "spreadRadius": {
          "type": "number"
        },
        "blurRadius": {
          "type": "number",
          "minimum": 0
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "color": {
          "type": "string",
          "description": "Hex or RGB color"
        }
      },
      "unevaluatedProperties": false
    },
    "filterEffect": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "effectType": {
          "type": "string",
          "enum": [
            "none",
            "normal",
            "ink",
            "kennedy",
            "feathered",
            "blur",
            "whistler",
            "3d",
            "blueray",
            "lighten",
            "darken",
            "pinkrinse",
            "redrum",
            "greenwash",
            "yellowstreak",
            "neonsky",
            "seaweed",
            "soledad",
            "sangria",
            "malibu",
            "candyfloss",
            "elmo",
            "unicorn",
            "kerouac",
            "koolaid",
            "hydra",
            "pixie",
            "nightrain",
            "bauhaus",
            "neptune",
            "orca",
            "manhattan",
            "goldie",
            "flamingo",
            "faded",
            "gotham",
            "hulk",
            "midnight",
            "lucille",
            "organic",
            "grayscale",
            "tvDuotone",
            "tvMonotoneDark",
            "tvMonotoneLight",
            "tvHue"
          ]
        },
        "brightness": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "contrast": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "saturation": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "hue": {
          "type": "number",
          "minimum": -180,
          "maximum": 180
        },
        "duotoneDark": {
          "type": "string"
        },
        "duotoneLight": {
          "type": "string"
        },
        "invert": {
          "type": "boolean",
          "default": false
        },
        "isCustom": {
          "type": "boolean"
        }
      },
      "unevaluatedProperties": false
    },
    "overlayBlending": {
      "type": "object",
      "properties": {
        "color": {
          "type": "string"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "contrast": {
          "type": "number",
          "minimum": 0,
          "maximum": 2
        },
        "saturate": {
          "type": "number",
          "minimum": 0,
          "maximum": 2
        },
        "blendMode": {
          "$ref": "#/BlendMode"
        }
      },
      "unevaluatedProperties": false
    },
    "BackgroundTransforms": {
      "type": "object",
      "properties": {
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "unevaluatedProperties": false
    },
    "ImageMask": {
      "type": "object",
      "description": "CSS mask using an image",
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "y": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "width": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "height": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "svgId": {
          "type": "string"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ],
          "description": "Defines whether the mask is flipped on the v or h axis"
        },
        "rotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "mode": {
          "type": "string",
          "enum": [
            "alpha",
            "luminance"
          ],
          "default": "alpha"
        }
      },
      "unevaluatedProperties": false
    },
    "WixVideo": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string",
              "maxLength": 100
            },
            "alt": {
              "type": "string",
              "maxLength": 1000
            },
            "videoId": {
              "type": "string"
            },
            "generatedPosters": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "qualities": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "quality": {
                    "type": "string"
                  },
                  "width": {
                    "type": "number"
                  },
                  "height": {
                    "type": "number"
                  },
                  "formats": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    },
                    "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
                  },
                  "format": {
                    "type": "string",
                    "enum": [
                      "mp4",
                      "webm"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "adaptiveVideo": {
              "type": [
                "array",
                "null"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "format": {
                    "type": "string",
                    "enum": [
                      "hls",
                      "dash"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "posterImageRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "duration": {
              "type": "number"
            },
            "loop": {
              "type": "boolean"
            },
            "autoplay": {
              "type": "boolean"
            },
            "playbackSpeed": {
              "type": "number"
            },
            "fps": {
              "type": "string",
              "maxLength": 50
            },
            "preload": {
              "type": "string",
              "enum": [
                "auto",
                "metadata",
                "none"
              ]
            },
            "controls": {
              "type": "string",
              "enum": [
                "none",
                "full"
              ]
            },
            "mute": {
              "type": "boolean",
              "description": "deprecated, moved to properties"
            },
            "hasAudio": {
              "type": "boolean",
              "description": "video has no audio"
            },
            "opacity": {
              "type": "number"
            },
            "artist": {
              "type": "object",
              "properties": {
                "name": {
                  "type": "string"
                },
                "id": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            },
            "mediaFeatures": {
              "description": "Annotate which features does this video have, for example 'media is a video with alpha'",
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "array",
                  "items": {
                    "type": "string",
                    "enum": [
                      "alpha",
                      "360"
                    ]
                  }
                }
              ]
            },
            "mask": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "$ref": "#/ImageMask--unrestricted-root"
                }
              ]
            },
            "focalPoint": {
              "$ref": "urn:dm:schemas:document_data.json#/FocalPoint"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Video": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "videoId": {
              "type": "string"
            },
            "userId": {
              "type": "string"
            },
            "posterImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "videoType": {
              "type": "string",
              "enum": [
                "YOUTUBE",
                "VIMEO",
                "FACEBOOK",
                "DAILYMOTION"
              ],
              "default": "YOUTUBE"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Image": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/Common_Image"
    },
    "MediaControlsDesignData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "iconsDefaultDesign": {
              "description": "VectorImageDesignData reference to design all icons",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "icons": {
              "description": "ControlIconDesignData references",
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "iconDesign": {
              "unevaluatedProperties": false,
              "type": "object"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ControlIconDesignData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 50
            },
            "svgId": {
              "type": "string",
              "maxLength": 100
            },
            "iconDesign": {
              "description": "VectorImageDesignData reference to override the default design",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VectorImageDesignData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "shadow": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "$ref": "#/Shadow--unrestricted-root"
                }
              ]
            },
            "shapeStyle": {
              "type": "object",
              "properties": {
                "opacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "strokeWidth": {
                  "type": "number"
                },
                "fill": {
                  "type": "string"
                },
                "fillOpacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "stroke": {
                  "type": "string"
                },
                "strokeOpacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "enableStroke": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "overrideColors": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "minProperties": 1,
                  "properties": {
                    "color1": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color2": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color3": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color4": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color5": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color6": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color7": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color8": {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  }
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GradientMesh": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientMesh"
          ]
        },
        "gradients": {
          "type": "array",
          "items": {
            "type": "object",
            "oneOf": [
              {
                "$ref": "urn:dm:schemas:commonSchemas.json#/GradientLinear--unrestricted-root"
              },
              {
                "$ref": "urn:dm:schemas:commonSchemas.json#/GradientCircle--unrestricted-root"
              },
              {
                "$ref": "urn:dm:schemas:commonSchemas.json#/GradientEllipse--unrestricted-root"
              },
              {
                "$ref": "urn:dm:schemas:commonSchemas.json#/GradientConic--unrestricted-root"
              }
            ],
            "unevaluatedProperties": false
          }
        }
      },
      "unevaluatedProperties": false
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "GradientLinearLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientLinearLayer"
    },
    "GradientCircleLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientCircleLayer"
    },
    "GradientEllipseLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientEllipseLayer"
    },
    "GradientMeshLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientMeshLayer"
    },
    "GradientConicLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientConicLayer"
    },
    "SolidColorLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/SolidColorLayer"
    },
    "MediaContainerDesignData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "charas": {
              "type": [
                "string",
                "null"
              ]
            },
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "dataChangeBehaviors": {
              "$ref": "#/dataChangeBehaviors"
            },
            "cssStyle": {
              "$ref": "#/cssStyle"
            },
            "themeMappings": {
              "type": "object",
              "additionalProperties": {
                "type": "string"
              },
              "unevaluatedProperties": false
            },
            "mediaRef": {
              "unevaluatedProperties": false,
              "type": "object"
            },
            "posterImageRef": {
              "unevaluatedProperties": false,
              "type": "object"
            },
            "imageOverlay": {
              "unevaluatedProperties": false,
              "type": "object"
            }
          }
        }
      ],
      "type": "object"
    },
    "MediaContainerWithDividers--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "dividerTop": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "dividerBottom": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "ShapeDivider--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "svgId"
          ],
          "properties": {
            "svgId": {
              "type": "string"
            },
            "color": {
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "padding": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "height": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "offsetX": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "flip": {
              "type": "boolean"
            },
            "invert": {
              "type": "boolean"
            },
            "keepAspectRatio": {
              "type": "boolean"
            },
            "shouldRepeat": {
              "type": "boolean"
            },
            "repeatCount": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "layersEffect": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "$ref": "#/LayersEffect--unrestricted-root"
                }
              ]
            },
            "presetId": {
              "type": "string",
              "maxLength": 20
            }
          }
        }
      ],
      "type": "object"
    },
    "MediaPlayerDesignData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "charas": {
              "type": [
                "string",
                "null"
              ]
            },
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "cssStyle": {
              "$ref": "#/cssStyle"
            },
            "themeMappings": {
              "type": "object",
              "additionalProperties": {
                "type": "string"
              },
              "unevaluatedProperties": false
            },
            "posterImageRef": {
              "unevaluatedProperties": false,
              "type": "object"
            },
            "mediaRef": {
              "unevaluatedProperties": false,
              "type": "object"
            },
            "imageOverlay": {
              "unevaluatedProperties": false,
              "type": "object"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextFxDesign--unrestricted-root": {
      "type": "object",
      "properties": {
        "autoScale": {
          "type": "boolean",
          "default": true,
          "description": "true - scale the text dynamically by layout, false - no scaling (text size by font size)"
        },
        "align": {
          "enum": [
            "start",
            "middle",
            "end"
          ],
          "default": "middle"
        },
        "family": {
          "type": "string",
          "maxLength": 150
        },
        "size": {
          "type": "number",
          "minimum": 6,
          "maximum": 999
        },
        "weight": {
          "enum": [
            "normal",
            "bold",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ],
          "default": "normal"
        },
        "style": {
          "enum": [
            "normal",
            "italic"
          ],
          "default": "normal"
        },
        "decoration": {
          "enum": [
            "none",
            "underline",
            "line-through"
          ],
          "default": "none"
        },
        "transform": {
          "enum": [
            "none",
            "capitalize",
            "uppercase",
            "lowercase"
          ],
          "default": "none"
        },
        "letterSpacing": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
        },
        "lineHeight": {
          "type": "number",
          "minimum": 0,
          "maximum": 7,
          "default": 1
        },
        "outlineColor": {
          "maxLength": 40,
          "$ref": "urn:dm:schemas:common.json#/color"
        },
        "outlineOpacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "outlineWidth": {
          "type": "number",
          "minimum": 0
        },
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "#/Shadow--unrestricted-root"
            }
          ]
        }
      }
    },
    "TextFxMask--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/TextFxDesign--unrestricted-root"
            },
            {
              "properties": {
                "media": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                },
                "mediaRotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360
                },
                "mediaFlip": {
                  "enum": [
                    "none",
                    "horizontal",
                    "vertical",
                    "both"
                  ],
                  "default": "none"
                },
                "viewBox": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "minimum": 7,
                  "maximum": 200
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "TextFxPath--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/TextFxDesign--unrestricted-root"
            },
            {
              "properties": {
                "path": {
                  "type": "string",
                  "maxLength": 1024
                },
                "keepAspectRatio": {
                  "type": "boolean"
                },
                "keepFontSize": {
                  "type": "boolean"
                },
                "inside": {
                  "type": "boolean"
                },
                "verticalAlign": {
                  "enum": [
                    "top",
                    "middle",
                    "bottom"
                  ],
                  "default": "bottom"
                },
                "verticalOffset": {
                  "type": "number"
                },
                "horizontalOffset": {
                  "type": "number"
                },
                "spread": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "textColor": {
                  "maxLength": 40,
                  "$ref": "urn:dm:schemas:common.json#/color"
                },
                "textOpacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "fillColor": {
                  "maxLength": 40,
                  "$ref": "urn:dm:schemas:common.json#/color"
                },
                "fillOpacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "strokeColor": {
                  "maxLength": 40,
                  "$ref": "urn:dm:schemas:common.json#/color"
                },
                "strokeOpacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "strokeWidth": {
                  "type": "number",
                  "minimum": 0
                },
                "viewBox": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "minimum": 7,
                  "maximum": 200
                },
                "presetId": {
                  "type": "string",
                  "maxLength": 20
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "css-keyword--unrestricted-root": {
      "type": "boolean"
    },
    "css-percentage--unrestricted-root": {
      "type": "object",
      "properties": {
        "value": {
          "type": "number"
        },
        "unit": {
          "enum": [
            "%"
          ]
        }
      }
    },
    "css-absolute-length-unit--unrestricted-root": {
      "enum": [
        "px",
        "cm",
        "mm",
        "q",
        "in",
        "pt",
        "pc"
      ]
    },
    "css-relative-length-unit--unrestricted-root": {
      "enum": [
        "em",
        "ex",
        "ch",
        "rem",
        "vw",
        "vh",
        "vmin",
        "vmax"
      ]
    },
    "css-length--unrestricted-root": {
      "type": "object",
      "required": [
        "unit",
        "value"
      ],
      "properties": {
        "unit": {
          "type": "string",
          "oneOf": [
            {
              "$ref": "#/css-absolute-length-unit--unrestricted-root"
            },
            {
              "$ref": "#/css-relative-length-unit--unrestricted-root"
            }
          ]
        },
        "value": {
          "type": "number"
        }
      }
    },
    "css-length-or-percentage--unrestricted-root": {
      "type": "object",
      "oneOf": [
        {
          "$ref": "#/css-length--unrestricted-root"
        },
        {
          "$ref": "#/css-percentage--unrestricted-root"
        }
      ]
    },
    "css-byte--unrestricted-root": {
      "type": "number",
      "default": 0,
      "multipleOf": 1,
      "minimum": 0,
      "maximum": 255
    },
    "css-color--unrestricted-root": {
      "type": "object",
      "required": [
        "red",
        "green",
        "blue",
        "alpha"
      ],
      "properties": {
        "red": {
          "$ref": "#/css-byte"
        },
        "green": {
          "$ref": "#/css-byte"
        },
        "blue": {
          "$ref": "#/css-byte"
        },
        "alpha": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      }
    },
    "css-box-shadow--unrestricted-root": {
      "type": "array",
      "items": {
        "required": [
          "inset",
          "offsetX",
          "offsetY",
          "blurRadius",
          "spreadRadius",
          "color"
        ],
        "additionalProperties": false,
        "properties": {
          "inset": {
            "$ref": "#/css-keyword"
          },
          "offsetX": {
            "$ref": "#/css-length"
          },
          "offsetY": {
            "$ref": "#/css-length"
          },
          "blurRadius": {
            "$ref": "#/css-length"
          },
          "spreadRadius": {
            "$ref": "#/css-length"
          },
          "color": {
            "$ref": "#/css-color"
          }
        },
        "unevaluatedProperties": false,
        "type": "object"
      },
      "minItems": 1
    },
    "css-border-radius--unrestricted-root": {
      "type": "object",
      "required": [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
      ],
      "properties": {
        "topLeft": {
          "$ref": "#/css-length-or-percentage"
        },
        "topRight": {
          "$ref": "#/css-length-or-percentage"
        },
        "bottomLeft": {
          "$ref": "#/css-length-or-percentage"
        },
        "bottomRight": {
          "$ref": "#/css-length-or-percentage"
        }
      }
    },
    "css-br-width--unrestricted-root": {
      "type": "object",
      "oneOf": [
        {
          "$ref": "#/css-length--unrestricted-root"
        }
      ]
    },
    "css-border-width--unrestricted-root": {
      "type": "object",
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "properties": {
        "top": {
          "$ref": "#/css-br-width"
        },
        "right": {
          "$ref": "#/css-br-width"
        },
        "bottom": {
          "$ref": "#/css-br-width"
        },
        "left": {
          "$ref": "#/css-br-width"
        }
      }
    },
    "css-br-style--unrestricted-root": {
      "enum": [
        "none",
        "hidden",
        "dotted",
        "dashed",
        "solid",
        "double",
        "groove",
        "ridge",
        "inset",
        "outset"
      ]
    },
    "css-border-style--unrestricted-root": {
      "type": "object",
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "properties": {
        "top": {
          "$ref": "#/css-br-style"
        },
        "right": {
          "$ref": "#/css-br-style"
        },
        "bottom": {
          "$ref": "#/css-br-style"
        },
        "left": {
          "$ref": "#/css-br-style"
        }
      }
    },
    "css-border-color--unrestricted-root": {
      "type": "object",
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "properties": {
        "top": {
          "$ref": "#/css-color"
        },
        "right": {
          "$ref": "#/css-color"
        },
        "bottom": {
          "$ref": "#/css-color"
        },
        "left": {
          "$ref": "#/css-color"
        }
      }
    },
    "css-border--unrestricted-root": {
      "type": "object",
      "required": [
        "width",
        "style",
        "color"
      ],
      "properties": {
        "width": {
          "$ref": "#/css-border-width"
        },
        "style": {
          "$ref": "#/css-border-style"
        },
        "color": {
          "$ref": "#/css-border-color"
        }
      }
    },
    "cssBorder--unrestricted-root": {
      "$ref": "#/css-border"
    },
    "cssBorderRadius--unrestricted-root": {
      "$ref": "#/css-border-radius"
    },
    "cssBoxShadow--unrestricted-root": {
      "$ref": "#/css-box-shadow"
    },
    "cssStyle--unrestricted-root": {
      "type": "object",
      "properties": {
        "cssBorder": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "#/cssBorder--unrestricted-root"
            }
          ]
        },
        "cssBoxShadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "#/cssBoxShadow--unrestricted-root"
            }
          ]
        },
        "cssBorderRadius": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "#/cssBorderRadius--unrestricted-root"
            }
          ]
        }
      }
    },
    "LayersEffect--unrestricted-root": {
      "type": "object",
      "required": [
        "size"
      ],
      "properties": {
        "size": {
          "type": "number",
          "minimum": 1,
          "maximum": 10
        },
        "y": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
        },
        "x": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
        },
        "pin": {
          "type": "string",
          "enum": [
            "in",
            "out"
          ]
        }
      }
    },
    "dataChangeBehaviors--unrestricted-root": {
      "type": [
        "array",
        "null"
      ],
      "items": {
        "type": "object",
        "properties": {
          "trigger": {
            "type": "string"
          },
          "type": {
            "type": "string"
          },
          "part": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "params": {
            "type": "object",
            "unevaluatedProperties": false
          }
        },
        "unevaluatedProperties": false
      }
    },
    "BackgroundMedia--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "mediaRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mediaTransforms": {
              "$ref": "#/BackgroundTransforms"
            },
            "overlayTransforms": {
              "$ref": "#/BackgroundTransforms"
            },
            "color": {
              "oneOf": [
                {
                  "enum": [
                    "transparent",
                    "noColor"
                  ]
                },
                {
                  "$ref": "urn:dm:schemas:common.json#/color--unrestricted-root"
                }
              ]
            },
            "colorOpacity": {
              "type": "number"
            },
            "alignType": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "left",
                "right",
                "center",
                "top_left",
                "top_right",
                "bottom_left",
                "bottom_right"
              ]
            },
            "fittingType": {
              "type": "string",
              "enum": [
                "fill",
                "fit",
                "stretch",
                "actual_size",
                "original_size",
                "tile",
                "tile_horizontal",
                "tile_vertical",
                "fit_and_tile",
                "legacy_tile",
                "legacy_tile_horizontal",
                "legacy_tile_vertical",
                "legacy_normal"
              ]
            },
            "scrollType": {
              "type": "string",
              "enum": [
                "none",
                "fixed",
                "scroll",
                "local",
                "parallax"
              ]
            },
            "showOverlayForMediaType": {
              "type": "string",
              "enum": [
                "all",
                "WixVideo",
                "Image"
              ],
              "default": "WixVideo"
            },
            "imageOverlay": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "colorOverlay": {
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "colorOverlayOpacity": {
              "type": "number"
            },
            "overlayBlending": {
              "$ref": "#/overlayBlending"
            },
            "filterEffect": {
              "$ref": "#/filterEffect"
            },
            "colorLayers": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/ColorLayers"
            }
          }
        }
      ],
      "type": "object"
    },
    "BlendMode--unrestricted-root": {
      "type": "string",
      "enum": [
        "normal",
        "multiply",
        "screen",
        "darken",
        "lighten",
        "overlay",
        "colorDodge",
        "colorBurn",
        "hardLight",
        "softLight",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ]
    },
    "Shadow--unrestricted-root": {
      "type": "object",
      "properties": {
        "x": {
          "type": "number"
        },
        "y": {
          "type": "number"
        },
        "spreadRadius": {
          "type": "number"
        },
        "blurRadius": {
          "type": "number",
          "minimum": 0
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "color": {
          "type": "string",
          "description": "Hex or RGB color"
        }
      }
    },
    "filterEffect--unrestricted-root": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "effectType": {
          "type": "string",
          "enum": [
            "none",
            "normal",
            "ink",
            "kennedy",
            "feathered",
            "blur",
            "whistler",
            "3d",
            "blueray",
            "lighten",
            "darken",
            "pinkrinse",
            "redrum",
            "greenwash",
            "yellowstreak",
            "neonsky",
            "seaweed",
            "soledad",
            "sangria",
            "malibu",
            "candyfloss",
            "elmo",
            "unicorn",
            "kerouac",
            "koolaid",
            "hydra",
            "pixie",
            "nightrain",
            "bauhaus",
            "neptune",
            "orca",
            "manhattan",
            "goldie",
            "flamingo",
            "faded",
            "gotham",
            "hulk",
            "midnight",
            "lucille",
            "organic",
            "grayscale",
            "tvDuotone",
            "tvMonotoneDark",
            "tvMonotoneLight",
            "tvHue"
          ]
        },
        "brightness": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "contrast": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "saturation": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "hue": {
          "type": "number",
          "minimum": -180,
          "maximum": 180
        },
        "duotoneDark": {
          "type": "string"
        },
        "duotoneLight": {
          "type": "string"
        },
        "invert": {
          "type": "boolean",
          "default": false
        },
        "isCustom": {
          "type": "boolean"
        }
      }
    },
    "overlayBlending--unrestricted-root": {
      "type": "object",
      "properties": {
        "color": {
          "type": "string"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "contrast": {
          "type": "number",
          "minimum": 0,
          "maximum": 2
        },
        "saturate": {
          "type": "number",
          "minimum": 0,
          "maximum": 2
        },
        "blendMode": {
          "$ref": "#/BlendMode"
        }
      }
    },
    "BackgroundTransforms--unrestricted-root": {
      "type": "object",
      "properties": {
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      }
    },
    "ImageMask--unrestricted-root": {
      "type": "object",
      "description": "CSS mask using an image",
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "y": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "width": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "height": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "svgId": {
          "type": "string"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ],
          "description": "Defines whether the mask is flipped on the v or h axis"
        },
        "rotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "mode": {
          "type": "string",
          "enum": [
            "alpha",
            "luminance"
          ],
          "default": "alpha"
        }
      }
    },
    "WixVideo--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string",
              "maxLength": 100
            },
            "alt": {
              "type": "string",
              "maxLength": 1000
            },
            "videoId": {
              "type": "string"
            },
            "generatedPosters": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "qualities": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "quality": {
                    "type": "string"
                  },
                  "width": {
                    "type": "number"
                  },
                  "height": {
                    "type": "number"
                  },
                  "formats": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    },
                    "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
                  },
                  "format": {
                    "type": "string",
                    "enum": [
                      "mp4",
                      "webm"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "adaptiveVideo": {
              "type": [
                "array",
                "null"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "format": {
                    "type": "string",
                    "enum": [
                      "hls",
                      "dash"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "posterImageRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "duration": {
              "type": "number"
            },
            "loop": {
              "type": "boolean"
            },
            "autoplay": {
              "type": "boolean"
            },
            "playbackSpeed": {
              "type": "number"
            },
            "fps": {
              "type": "string",
              "maxLength": 50
            },
            "preload": {
              "type": "string",
              "enum": [
                "auto",
                "metadata",
                "none"
              ]
            },
            "controls": {
              "type": "string",
              "enum": [
                "none",
                "full"
              ]
            },
            "mute": {
              "type": "boolean",
              "description": "deprecated, moved to properties"
            },
            "hasAudio": {
              "type": "boolean",
              "description": "video has no audio"
            },
            "opacity": {
              "type": "number"
            },
            "artist": {
              "type": "object",
              "properties": {
                "name": {
                  "type": "string"
                },
                "id": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            },
            "mediaFeatures": {
              "description": "Annotate which features does this video have, for example 'media is a video with alpha'",
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "array",
                  "items": {
                    "type": "string",
                    "enum": [
                      "alpha",
                      "360"
                    ]
                  }
                }
              ]
            },
            "mask": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "$ref": "#/ImageMask--unrestricted-root"
                }
              ]
            },
            "focalPoint": {
              "$ref": "urn:dm:schemas:document_data.json#/FocalPoint"
            }
          }
        }
      ],
      "type": "object"
    },
    "Video--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "videoId": {
              "type": "string"
            },
            "userId": {
              "type": "string"
            },
            "posterImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "videoType": {
              "type": "string",
              "enum": [
                "YOUTUBE",
                "VIMEO",
                "FACEBOOK",
                "DAILYMOTION"
              ],
              "default": "YOUTUBE"
            }
          }
        }
      ],
      "type": "object"
    },
    "Image--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/Common_Image"
    },
    "MediaControlsDesignData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "iconsDefaultDesign": {
              "description": "VectorImageDesignData reference to design all icons",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "icons": {
              "description": "ControlIconDesignData references",
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "iconDesign": {
              "unevaluatedProperties": false,
              "type": "object"
            }
          }
        }
      ],
      "type": "object"
    },
    "ControlIconDesignData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 50
            },
            "svgId": {
              "type": "string",
              "maxLength": 100
            },
            "iconDesign": {
              "description": "VectorImageDesignData reference to override the default design",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "VectorImageDesignData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "shadow": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "$ref": "#/Shadow--unrestricted-root"
                }
              ]
            },
            "shapeStyle": {
              "type": "object",
              "properties": {
                "opacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "strokeWidth": {
                  "type": "number"
                },
                "fill": {
                  "type": "string"
                },
                "fillOpacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "stroke": {
                  "type": "string"
                },
                "strokeOpacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "enableStroke": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "overrideColors": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "minProperties": 1,
                  "properties": {
                    "color1": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color2": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color3": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color4": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color5": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color6": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color7": {
                      "type": [
                        "null",
                        "string"
                      ]
                    },
                    "color8": {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  }
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "GradientMesh--unrestricted-root": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientMesh"
          ]
        },
        "gradients": {
          "type": "array",
          "items": {
            "type": "object",
            "oneOf": [
              {
                "$ref": "urn:dm:schemas:commonSchemas.json#/GradientLinear--unrestricted-root"
              },
              {
                "$ref": "urn:dm:schemas:commonSchemas.json#/GradientCircle--unrestricted-root"
              },
              {
                "$ref": "urn:dm:schemas:commonSchemas.json#/GradientEllipse--unrestricted-root"
              },
              {
                "$ref": "urn:dm:schemas:commonSchemas.json#/GradientConic--unrestricted-root"
              }
            ],
            "unevaluatedProperties": false
          }
        }
      }
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "GradientLinearLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientLinearLayer"
    },
    "GradientCircleLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientCircleLayer"
    },
    "GradientEllipseLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientEllipseLayer"
    },
    "GradientMeshLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientMeshLayer"
    },
    "GradientConicLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientConicLayer"
    },
    "SolidColorLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/SolidColorLayer"
    }
  },
  "discussions.json": {
    "$id": "urn:dm:schemas:discussions.json",
    "Discussions": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "discussions"
          ],
          "properties": {
            "discussions": {
              "type": "array",
              "items": {
                "type": "string",
                "maxLength": 100
              },
              "default": []
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "Discussions--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "discussions"
          ],
          "properties": {
            "discussions": {
              "type": "array",
              "items": {
                "type": "string",
                "maxLength": 100
              },
              "default": []
            }
          }
        }
      ],
      "type": "object"
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    }
  },
  "document_data.json": {
    "$id": "urn:dm:schemas:document_data.json",
    "Direction": {
      "type": "string",
      "enum": [
        "ltr",
        "rtl",
        "inherit"
      ]
    },
    "AppVars": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "vars": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "value": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "AppPartParam"
                    ]
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "appDefId": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SVGItem": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/Common_SVGItem"
    },
    "SVGReference": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "BackgroundImage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string"
            },
            "positionx": {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "default": "center"
            },
            "imagesizew": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "imagesizeh": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "positiony": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "center"
              ],
              "default": "center"
            },
            "width": {
              "type": "string"
            },
            "repeatx": {
              "type": "string",
              "enum": [
                "no_repeat",
                "repeat"
              ],
              "default": "repeat"
            },
            "repeaty": {
              "type": "string",
              "enum": [
                "no_repeat",
                "repeat"
              ],
              "default": "repeat"
            },
            "attachment": {
              "type": "string",
              "enum": [
                "scroll",
                "fixed",
                "inherit",
                "local"
              ],
              "default": "inherit"
            },
            "color": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BackgroundMedia": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "mediaRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mediaTransforms": {
              "$ref": "urn:dm:schemas:design_data.json#/BackgroundTransforms"
            },
            "overlayTransforms": {
              "$ref": "urn:dm:schemas:design_data.json#/BackgroundTransforms"
            },
            "color": {
              "oneOf": [
                {
                  "enum": [
                    "transparent",
                    "noColor"
                  ]
                },
                {
                  "$ref": "urn:dm:schemas:common.json#/color--unrestricted-root"
                }
              ]
            },
            "colorOpacity": {
              "type": "number"
            },
            "alignType": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "left",
                "right",
                "center",
                "top_left",
                "top_right",
                "bottom_left",
                "bottom_right"
              ]
            },
            "fittingType": {
              "type": "string",
              "enum": [
                "fill",
                "fit",
                "stretch",
                "actual_size",
                "original_size",
                "tile",
                "tile_horizontal",
                "tile_vertical",
                "fit_and_tile",
                "legacy_tile",
                "legacy_tile_horizontal",
                "legacy_tile_vertical",
                "legacy_normal"
              ]
            },
            "scrollType": {
              "type": "string",
              "enum": [
                "none",
                "fixed",
                "scroll",
                "local",
                "parallax"
              ]
            },
            "showOverlayForMediaType": {
              "type": "string",
              "enum": [
                "all",
                "WixVideo",
                "Image"
              ],
              "default": "WixVideo"
            },
            "imageOverlay": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "colorOverlay": {
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "colorOverlayOpacity": {
              "type": "number"
            },
            "overlayBlending": {
              "$ref": "urn:dm:schemas:design_data.json#/overlayBlending"
            },
            "filterEffect": {
              "$ref": "urn:dm:schemas:design_data.json#/filterEffect"
            },
            "colorLayers": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/ColorLayers"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WixVideo": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/WixVideoData--unrestricted-root"
            },
            {
              "properties": {
                "loop": {
                  "type": "boolean"
                },
                "autoplay": {
                  "type": "boolean"
                },
                "playbackSpeed": {
                  "type": "number"
                },
                "preload": {
                  "type": "string",
                  "enum": [
                    "auto",
                    "metadata",
                    "none"
                  ]
                },
                "controls": {
                  "type": "string",
                  "enum": [
                    "none",
                    "full"
                  ]
                },
                "mute": {
                  "type": "boolean",
                  "description": "deprecated, moved to properties"
                },
                "opacity": {
                  "type": "number"
                },
                "mediaFeatures": {
                  "type": "array",
                  "items": {
                    "type": "string",
                    "enum": [
                      "alpha"
                    ]
                  }
                },
                "mask": {
                  "anyOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "urn:dm:schemas:design_data.json#/ImageMask--unrestricted-root"
                    }
                  ]
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WixVideoData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string",
              "maxLength": 100
            },
            "alt": {
              "type": "string",
              "maxLength": 1000
            },
            "videoId": {
              "type": "string"
            },
            "generatedPosters": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "qualities": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "quality": {
                    "type": "string"
                  },
                  "width": {
                    "type": "number"
                  },
                  "height": {
                    "type": "number"
                  },
                  "formats": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    },
                    "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
                  },
                  "format": {
                    "type": "string",
                    "enum": [
                      "mp4",
                      "webm"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "adaptiveVideo": {
              "type": [
                "array",
                "null"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "format": {
                    "type": "string",
                    "enum": [
                      "hls",
                      "dash"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "posterImageRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "duration": {
              "type": "number"
            },
            "fps": {
              "type": "string",
              "maxLength": 50
            },
            "hasAudio": {
              "type": "boolean",
              "description": "video has no audio"
            },
            "artist": {
              "type": "object",
              "properties": {
                "name": {
                  "type": "string"
                },
                "id": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Document": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "siteName": {
              "type": "string",
              "maxLength": 1000
            },
            "usedFonts": {
              "type": "array",
              "items": {
                "type": "string",
                "maxLength": 1000
              }
            },
            "characterSets": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "renderModifiers": {
              "type": "object",
              "properties": {
                "siteWidth": {
                  "type": "number",
                  "minimum": 0
                },
                "pageAutoShrink": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "name": {
              "type": "string"
            },
            "mainPage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mainPageId": {
              "type": "string"
            },
            "smSettings": {
              "type": "object",
              "allOf": [
                {
                  "$ref": "#/SiteMembersData--unrestricted-root"
                }
              ],
              "unevaluatedProperties": false
            },
            "styleSettings": {
              "$ref": "#/StyleSettings"
            },
            "accessibilitySettings": {
              "$ref": "#/AccessibilitySettings"
            },
            "mobileSettings": {
              "$ref": "#/MobileSettings"
            },
            "layoutSettings": {
              "$ref": "#/LayoutSettings"
            },
            "appStudioData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "ignoreBottomBottomAnchors": {
              "type": [
                "boolean"
              ]
            },
            "anchorLockThreshold": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "supportMobile": {
              "type": "boolean"
            },
            "autoDomReorder": {
              "type": "boolean"
            },
            "appsInstallState": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "usesNewAnimations": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AccessibilitySettings": {
      "type": "object",
      "properties": {
        "visualFocusDisabled": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "skipToContent": {
          "default": true,
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "isRtlSupportEnabled": {
          "default": false,
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "currentSiteDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "MobileSettings": {
      "type": "object",
      "properties": {
        "animationsEnabled": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      },
      "unevaluatedProperties": false
    },
    "LayoutSettings": {
      "type": "object",
      "properties": {
        "useDesktopSectionsLayout": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "isFluid": {
          "type": [
            "boolean"
          ]
        },
        "headerToPagesGap": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "pagesToFooterGap": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "mechanism": {
          "type": [
            "string"
          ],
          "enum": [
            "mesh",
            "anchors"
          ]
        },
        "soapCompsAroundPagesContainer": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      },
      "unevaluatedProperties": false
    },
    "StyleSettings": {
      "type": "object",
      "properties": {
        "stylesPerPage": {
          "type": "string",
          "maxLength": 20
        }
      },
      "unevaluatedProperties": false
    },
    "SiteMembersData": {
      "type": "object",
      "properties": {
        "socialLoginGoogleEnabled": {
          "type": "boolean"
        },
        "socialLoginFacebookEnabled": {
          "type": "boolean"
        },
        "privacyNoteType": {
          "type": "string",
          "enum": [
            "CHECKBOX",
            "NOTE"
          ]
        },
        "joinCommunityCheckedByDefault": {
          "type": "boolean"
        },
        "customSignUpPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customSignInPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customNoPermissionsPageId": {
          "type": [
            "string"
          ]
        },
        "termsOfUse": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "privacyPolicy": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "codeOfConduct": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "smFirstDialogLogin": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      },
      "unevaluatedProperties": false
    },
    "AppStudioData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "widgets": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "codePackages": {
              "maxItems": 1,
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "panels": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "dependencies": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "additionalProperties": false,
                "required": [
                  "appDefId"
                ],
                "properties": {
                  "appDefId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "dependencyData": {
                    "type": "array",
                    "items": {
                      "type": "string",
                      "enum": [
                        "PROVISION_ONLY_INSTALLATION",
                        "NOTIFY_USER_ON_DEPENDENCY",
                        "IS_BUNDLE"
                      ]
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "dashboards": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "customDefinitions": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "ssrCache": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CodePackagesDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "displayName": {
              "type": "string",
              "maxLength": 30,
              "minLength": 1
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "minLength": 3
            },
            "description": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WidgetPropertyDefinition": {
      "additionalProperties": true,
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomDefinitionDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "structure": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "additionalProperties": false,
                "required": [
                  "$id",
                  "title",
                  "description",
                  "default",
                  "propertiesOrder"
                ],
                "properties": {
                  "$id": {
                    "type": "string"
                  },
                  "type": {
                    "type": "string",
                    "default": "object"
                  },
                  "title": {
                    "type": "string"
                  },
                  "description": {
                    "type": "string"
                  },
                  "properties": {
                    "type": "object",
                    "additionalProperties": {
                      "$ref": "#/WidgetPropertyDefinition"
                    }
                  },
                  "default": {
                    "type": "object",
                    "default": {}
                  },
                  "propertiesOrder": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    },
                    "default": []
                  }
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WidgetDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "devCenterWidgetId": {
              "type": [
                "string",
                "null"
              ]
            },
            "devCenterEditorReactComponentId": {
              "type": [
                "string",
                "null"
              ]
            },
            "kind": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "container",
                "section"
              ]
            },
            "panels": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "defaultSize": {
              "type": [
                "object",
                "null"
              ],
              "minProperties": 1,
              "properties": {
                "width": {
                  "type": "number"
                },
                "height": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "variations": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "presets": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "plugin": {
              "type": "object",
              "properties": {
                "placements": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "appDefinitionId": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "widgetId": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "slotId": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "containedWidgets": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            },
            "widgetApi": {
              "type": "object",
              "default": {},
              "properties": {
                "functions": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "required": [
                      "name"
                    ],
                    "properties": {
                      "name": {
                        "type": "string"
                      },
                      "description": {
                        "type": [
                          "string",
                          "null"
                        ]
                      },
                      "params": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "name": {
                              "type": "string"
                            },
                            "description": {
                              "type": [
                                "string",
                                "null"
                              ]
                            }
                          },
                          "unevaluatedProperties": false
                        }
                      },
                      "returnsDescription": {
                        "type": [
                          "string",
                          "null"
                        ]
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "propertiesSchemas": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "properties": {
                      "structure": {
                        "type": "object",
                        "additionalProperties": {
                          "$ref": "#/WidgetPropertyDefinition"
                        },
                        "default": {},
                        "unevaluatedProperties": false
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "events": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "required": [
                      "name"
                    ],
                    "properties": {
                      "name": {
                        "type": "string"
                      },
                      "description": {
                        "type": "string"
                      },
                      "args": {
                        "type": "array",
                        "items": {
                          "properties": {
                            "name": {
                              "type": "string"
                            }
                          },
                          "unevaluatedProperties": false,
                          "type": "object"
                        }
                      }
                    },
                    "unevaluatedProperties": false
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "structureRef": {
              "type": "object",
              "properties": {
                "pageId": {
                  "type": "string"
                },
                "rootCompId": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            },
            "compType": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DashboardDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "routePath": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "hideInSidebar": {
              "type": "boolean"
            },
            "activeSidebarPageId": {
              "type": [
                "string",
                "null"
              ]
            },
            "isRoutePathConnectedToTitle": {
              "type": "boolean",
              "default": true
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PanelDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "devCenterPanelId": {
              "type": [
                "string",
                "null"
              ]
            },
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "kind": {
              "type": "string",
              "enum": [
                "settings"
              ]
            },
            "helpId": {
              "type": "string",
              "maxLength": 100
            },
            "pageUrl": {
              "type": "string",
              "minLength": 1,
              "maxLength": 2048
            },
            "height": {
              "type": "number",
              "minimum": 0,
              "default": 0
            },
            "defaultSize": {
              "type": "object",
              "minProperties": 1,
              "properties": {
                "width": {
                  "type": "number"
                },
                "height": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VariationDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PresetDescriptor": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "presetId": {
              "type": "string",
              "maxLength": 100
            },
            "name": {
              "type": "string",
              "maxLength": 100
            },
            "defaultSize": {
              "type": "object",
              "minProperties": 1,
              "properties": {
                "width": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                },
                "height": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlatTheme": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "BG_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "CONTACT_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "NETWORKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "EXTERNAL_LINKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "PAGES_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "WEB_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "BASE_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "font": {
              "type": "string",
              "format": "font-family",
              "default": "Arial,sans-serif"
            },
            "bgId": {
              "type": "string",
              "default": "BG_USES_THEME_IMAGE"
            },
            "bgSize": {
              "type": "string",
              "default": ","
            },
            "bgType": {
              "type": "string",
              "default": "BG_USES_THEME_IMAGE"
            },
            "siteBg": {
              "type": "string",
              "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
            },
            "mobileBg": {
              "type": "string",
              "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
            },
            "siteBgColor": {
              "default": "0,0,0,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "headerTextColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "headerBgColor": {
              "default": "0,0,0,0",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "textColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "areaBgColor": {
              "default": "130,81,13,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "iconBgColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "borderColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "fontHeader": {
              "default": "normal normal bold 2.4em/1.0em [font] {headerTextColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontTitle": {
              "default": "italic normal bold 2.0em/2.0em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontSubTitle": {
              "default": "normal normal bold 1.2em/1.4em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontButton": {
              "default": "normal normal bold 1.4em/2.2em [font] {areaBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontText": {
              "default": "normal normal normal 1.1em/1.1em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontSmallText": {
              "default": "normal normal normal 0.5em/0.7em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "borderContainer": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderThumb": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderButton": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderIcon": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "radiusContainer": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusThumb": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusButton": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusIcon": {
              "default": "0.6em 0.0em 0.0em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "padding1": {
              "default": "1em 1em 1em 1em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding2": {
              "default": "0.0em 0.5em 0.0em 0.5em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding3": {
              "default": "1.0em 0.0em 1.0em 0.0em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "iconSize": {
              "default": "3.2",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "bulletSize": {
              "default": "1.5",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "headerSpacing": {
              "default": "0em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "componentSpacing": {
              "default": "0.45em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "itemSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "thumbSpacing": {
              "default": "0.23em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "iconSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Image": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "allOf": [
            {
              "$ref": "urn:dm:schemas:commonSchemas.json#/Common_Image--unrestricted-root"
            },
            {
              "type": "object",
              "properties": {
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageReference": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "GlobalImageQuality": {
      "$ref": "#/ImageQuality"
    },
    "ImageQuality": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "quality": {
              "$ref": "urn:dm:schemas:common.json#/Int",
              "minimum": 0,
              "maximum": 100
            },
            "unsharpMask": {
              "type": "object",
              "minProperties": 3,
              "additionalProperties": false,
              "properties": {
                "radius": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 500
                },
                "amount": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 10
                },
                "threshold": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 255
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ClassicSectionA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            },
            "level": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripColumnsContainerA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            },
            "level": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripColumnsContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "itemsDirection": {
              "type": "string",
              "enum": [
                "rtl",
                "ltr"
              ],
              "default": "ltr"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ClassicSection": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Link": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AnchorLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "anchorName": {
              "type": "string"
            },
            "anchorDataId": {
              "anyOf": [
                {
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference--unrestricted-root"
                },
                {
                  "enum": [
                    "SCROLL_TO_TOP"
                  ]
                }
              ]
            },
            "pageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DocumentLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "docId": {
              "type": "string"
            },
            "name": {
              "type": "string"
            },
            "indexable": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PhoneLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "phoneNumber": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WhatsAppLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "phoneNumber": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AddressLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "address": {
              "type": "string",
              "maxLength": 200
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "EmailLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "recipient": {
              "type": "string",
              "description": "Email address of the recipient."
            },
            "subject": {
              "type": "string",
              "description": "Subject of the email."
            },
            "body": {
              "type": "string",
              "description": "Body or content of the email."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FormSubmitButtonLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ExternalLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "allOf": [
                {
                  "type": "string"
                },
                {
                  "not": {
                    "type": "string",
                    "pattern": ".*script://.*"
                  }
                }
              ],
              "description": "URL of the external link."
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_blank",
              "description": "Specifies where to open the linked document."
            },
            "rel": {
              "$ref": "#/LinkRelAttribute",
              "default": [
                "noreferrer",
                "noopener"
              ],
              "description": "Specifies the relationship between the current document and the linked document."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LinkRelAttribute": {
      "type": "array",
      "items": {
        "type": "string",
        "enum": [
          "nofollow",
          "noopener",
          "noreferrer",
          "sponsored"
        ]
      },
      "default": []
    },
    "DynamicPageLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "routerId": {
              "type": "string"
            },
            "innerRoute": {
              "type": "string"
            },
            "anchorDataId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "isTpaRoute": {
              "type": "boolean"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TpaPageLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "itemTypeIdentifier",
            "itemId",
            "pageId",
            "appDefinitionId",
            "path"
          ],
          "properties": {
            "itemTypeIdentifier": {
              "type": "string"
            },
            "itemId": {
              "type": "string"
            },
            "pageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "path": {
              "type": "string"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LoginToWixLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "postLoginUrl": {
              "type": "string"
            },
            "postSignupUrl": {
              "type": "string"
            },
            "dialog": {
              "type": "string",
              "enum": [
                "createUser",
                "login",
                "showLogin"
              ],
              "default": "login"
            },
            "sendMail": {
              "type": "boolean",
              "default": true
            },
            "mailTemplate": {
              "type": "string"
            },
            "userColor": {
              "type": "string"
            },
            "loginCompName": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PageLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pageId": {
              "description": "Page ID of the page to link to.",
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self",
              "description": "Specifies where to open the linked document."
            },
            "rel": {
              "$ref": "#/LinkRelAttribute",
              "description": "Specifies the relationship between the current document and the linked document."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MediaItem": {
      "type": "object",
      "properties": {
        "componentType": {
          "type": "string"
        },
        "dateCreated": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "fileName": {
          "type": "string"
        },
        "fileSize": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "width": {
          "type": "number"
        },
        "iconURL": {
          "type": "string"
        },
        "mediaType": {
          "type": "string"
        },
        "mimeType": {
          "type": "string"
        },
        "originalFileName": {
          "type": "string"
        },
        "sourceURL": {
          "type": [
            "null",
            "string"
          ]
        },
        "tags": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "version": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "MediaRichText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000
            },
            "stylesMapId": {
              "type": "string"
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "componentDataList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Page": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "dataClassRef": "core.datatypes.PageDataClass",
          "properties": {
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "hideTitle": {
              "type": "boolean"
            },
            "icon": {
              "type": "string"
            },
            "windowTitle": {
              "type": "string",
              "minLength": 1,
              "maxLength": 512
            },
            "descriptionSEO": {
              "type": "string",
              "maxLength": 1024
            },
            "advancedSeoData": {
              "type": "string",
              "maxLength": 10000
            },
            "metaKeywordsSEO": {
              "type": "string",
              "maxLength": 512
            },
            "pageTitleSEO": {
              "type": "string"
            },
            "pageUriSEO": {
              "type": "string"
            },
            "hidePage": {
              "type": "boolean"
            },
            "underConstruction": {
              "type": "boolean"
            },
            "tpaApplicationId": {
              "type": "number"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "managingAppDefId": {
              "type": [
                "string",
                "null"
              ]
            },
            "tpaPageId": {
              "type": "string"
            },
            "parentPageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "pageSecurity": {
              "type": [
                "object",
                "null"
              ],
              "default": {
                "requireLogin": false,
                "passwordDigest": "",
                "dialogLanguage": ""
              },
              "properties": {
                "requireLogin": {
                  "type": "boolean"
                },
                "passwordDigest": {
                  "type": "string"
                },
                "dialogLanguage": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            },
            "indexable": {
              "type": "boolean",
              "default": true
            },
            "mobileHidePage": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageBackgrounds": {
              "type": "object",
              "properties": {
                "desktop": {
                  "type": "object",
                  "properties": {
                    "custom": {
                      "type": "boolean"
                    },
                    "mediaSizing": {
                      "type": "string",
                      "enum": [
                        "document",
                        "viewport"
                      ]
                    },
                    "ref": {
                      "$ref": "urn:dm:schemas:common.json#/nullableReference"
                    },
                    "isPreset": {
                      "type": "boolean"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "mobile": {
                  "type": "object",
                  "properties": {
                    "custom": {
                      "type": "boolean"
                    },
                    "mediaSizing": {
                      "type": "string",
                      "enum": [
                        "document",
                        "viewport"
                      ],
                      "default": "viewport"
                    },
                    "ref": {
                      "$ref": "urn:dm:schemas:common.json#/nullableReference"
                    },
                    "isPreset": {
                      "type": "boolean"
                    }
                  },
                  "unevaluatedProperties": false
                }
              },
              "unevaluatedProperties": false
            },
            "isLandingPage": {
              "type": "boolean",
              "default": false
            },
            "isMobileLandingPage": {
              "type": "boolean",
              "default": false
            },
            "isPopup": {
              "type": "boolean",
              "default": false
            },
            "translationData": {
              "type": "object",
              "properties": {
                "uriSEOTranslated": {
                  "type": "boolean",
                  "default": false
                }
              },
              "unevaluatedProperties": false
            },
            "ogImage": {
              "type": [
                "string",
                "null"
              ]
            },
            "ogImageRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "ignoreBottomBottomAnchors": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "cacheMode": {
              "enum": [
                "auto",
                "manual",
                "disabled"
              ]
            },
            "cacheMaxAgeHours": {
              "type": [
                "number",
                "null"
              ],
              "multipleOf": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Text": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 4000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RichText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000,
              "default": ""
            },
            "defaultStyle": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RichTextImage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "image": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BaseInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "formGroup": {
              "type": "string",
              "description": "form group that this component belongs to",
              "maxLength": 4000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BaseTextInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "value": {
                  "type": "string",
                  "default": "",
                  "maxLength": 4000
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextInputA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "invalid": {
              "type": "boolean"
            },
            "multiline": {
              "type": "boolean"
            },
            "autocomplete": {
              "type": "boolean"
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "atomic": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "textType": {
                  "type": "string",
                  "default": "text",
                  "enum": [
                    "text",
                    "email",
                    "url",
                    "number",
                    "tel",
                    "password"
                  ],
                  "description": "input data type"
                },
                "maxLength": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "min": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "minimum": -2147483648,
                  "maximum": 2147483647,
                  "description": "minimum allowed value for a numeric type field"
                },
                "max": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "minimum": -2147483648,
                  "maximum": 2147483647,
                  "description": "maximum allowed value for a numeric type field"
                },
                "pattern": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "specifies a regular expression against which the control's value will be validate",
                  "maxLength": 500
                },
                "phoneFormat": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "specifies a phone number format against which the control's value will be validated",
                  "pattern": "^#*(((#+-)*)#+$)",
                  "maxLength": 100
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected"
                },
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                },
                "prefix": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "maxLength": 10
                },
                "step": {
                  "type": "number"
                },
                "autoComplete": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "maxLength": 400
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ],
          "not": {
            "required": [
              "pattern",
              "phoneFormat"
            ]
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextAreaInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "maxLength": {
                  "type": [
                    "number"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "label": {
                  "type": [
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string"
                  ],
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CheckboxInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "checked": {
                  "$ref": "urn:dm:schemas:common.json#/JavaBool",
                  "description": "The checked status of the input"
                },
                "linkLabel": {
                  "type": "string",
                  "default": "",
                  "maxLength": 1000
                },
                "link": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
                },
                "label": {
                  "type": "string",
                  "default": "",
                  "maxLength": 4000
                },
                "indeterminate": {
                  "$ref": "urn:dm:schemas:common.json#/JavaBool",
                  "description": "Used for three state check box"
                },
                "direction": {
                  "$ref": "#/Direction",
                  "description": "direction of the component"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DateItem": {
      "type": "string",
      "format": "date-time"
    },
    "DateString": {
      "type": "string",
      "format": "date"
    },
    "DateRange": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "startDate",
        "endDate"
      ],
      "properties": {
        "startDate": {
          "$ref": "#/DateString"
        },
        "endDate": {
          "$ref": "#/DateString"
        }
      },
      "unevaluatedProperties": false
    },
    "DateRanges": {
      "type": "array",
      "default": [],
      "items": {
        "$ref": "#/DateRange"
      }
    },
    "DatePicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "disabledDates": {
                  "type": "array",
                  "items": {
                    "$ref": "#/DateItem"
                  },
                  "default": [],
                  "description": "array of disabled dates"
                },
                "disabledDaysOfWeek": {
                  "type": "array",
                  "items": {
                    "type": [
                      "number"
                    ],
                    "enum": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6
                    ]
                  },
                  "default": [],
                  "description": "array of disabled days"
                },
                "minDate": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "#/DateItem--unrestricted-root"
                    }
                  ],
                  "description": "date input minimum date value"
                },
                "maxDate": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "#/DateItem--unrestricted-root"
                    }
                  ],
                  "description": "date input maximum date value"
                },
                "allowPastDates": {
                  "type": "boolean",
                  "default": true,
                  "description": "if true all past days are enabled, false otherwise"
                },
                "allowFutureDates": {
                  "type": "boolean",
                  "default": true,
                  "description": "if true all future days are enabled, false otherwise"
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "maxLength": 200,
                  "description": "the placeholder option in case nothing is selected"
                },
                "enabledDateRanges": {
                  "$ref": "#/DateRanges",
                  "description": "array of enabled dates. each date in the format YYYY/MM/DD"
                },
                "disabledDateRanges": {
                  "$ref": "#/DateRanges",
                  "description": "array of disabled dates. each date in the format YYYY/MM/DD"
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Theme": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "properties": {
              "type": [
                "object",
                "null"
              ],
              "additionalProperties": true,
              "default": {}
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TwitterFollow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "accountToFollow": {
              "type": "string",
              "default": "wix"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TwitterTweet": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "defaultText": {
              "type": "string"
            },
            "accountToFollow": {
              "type": "string"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MobileMetaData": {
      "type": "object",
      "required": [
        "adaptiveMobileOn"
      ],
      "properties": {
        "adaptiveMobileOn": {
          "type": "boolean",
          "default": true
        }
      },
      "unevaluatedProperties": false
    },
    "Preloader": {
      "type": "object",
      "required": [
        "enabled",
        "uri"
      ],
      "properties": {
        "enabled": {
          "type": "boolean",
          "default": false
        },
        "uri": {
          "type": "string",
          "default": ""
        }
      },
      "unevaluatedProperties": false
    },
    "ContactInfo": {
      "type": "object",
      "required": [
        "companyName",
        "phone",
        "email",
        "address",
        "fax"
      ],
      "properties": {
        "companyName": {
          "type": "string",
          "default": ""
        },
        "phone": {
          "type": "string",
          "default": ""
        },
        "email": {
          "type": "string",
          "default": ""
        },
        "address": {
          "type": "string",
          "default": ""
        },
        "fax": {
          "type": "string",
          "default": ""
        }
      },
      "unevaluatedProperties": false
    },
    "SocialLink": {
      "type": "object",
      "required": [
        "id",
        "url"
      ],
      "properties": {
        "id": {
          "type": "string",
          "enum": [
            "facebook",
            "twitter",
            "pinterest",
            "google_plus",
            "tumblr",
            "blogger",
            "linkedin",
            "youtube",
            "vimeo",
            "flickr"
          ]
        },
        "url": {
          "type": "string",
          "default": ""
        }
      },
      "unevaluatedProperties": false
    },
    "QuickActions": {
      "type": "object",
      "required": [
        "colorScheme",
        "configuration",
        "socialLinks"
      ],
      "properties": {
        "colorScheme": {
          "type": "string",
          "enum": [
            "dark",
            "light"
          ],
          "default": "dark"
        },
        "configuration": {
          "type": "object",
          "default": {
            "addressEnabled": false,
            "emailEnabled": false,
            "navigationMenuEnabled": true,
            "phoneEnabled": false,
            "quickActionsMenuEnabled": false,
            "socialLinksEnabled": false
          },
          "properties": {
            "addressEnabled": {
              "type": "boolean",
              "default": false
            },
            "emailEnabled": {
              "type": "boolean",
              "default": false
            },
            "navigationMenuEnabled": {
              "type": "boolean",
              "default": true
            },
            "phoneEnabled": {
              "type": "boolean",
              "default": false
            },
            "quickActionsMenuEnabled": {
              "type": "boolean",
              "default": false
            },
            "socialLinksEnabled": {
              "type": "boolean",
              "default": false
            }
          },
          "unevaluatedProperties": false
        },
        "socialLinks": {
          "type": "array",
          "items": {
            "$ref": "#/SocialLink"
          },
          "default": []
        }
      },
      "unevaluatedProperties": false
    },
    "QuickActionBarItem": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "itemType"
          ],
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "itemType": {
              "maxLength": 50,
              "type": "string"
            },
            "text": {
              "maxLength": 40,
              "type": "string",
              "default": ""
            },
            "icon": {
              "maxLength": 200,
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SiteSettings": {
      "type": "object",
      "properties": {
        "siteName": {
          "type": "string",
          "default": ""
        },
        "siteTitleSEO": {
          "type": "string",
          "default": ""
        },
        "siteDescriptionSEO": {
          "type": "string",
          "default": ""
        },
        "keywordsSEO": {
          "type": "string",
          "default": ""
        },
        "allowSEFindSite": {
          "type": "boolean",
          "default": false
        },
        "favicon": {
          "type": "string",
          "default": ""
        },
        "thumbnail": {
          "type": "string",
          "default": ""
        },
        "googleAnalyticsID": {
          "type": "string",
          "default": ""
        },
        "fbAdminsUserId": {
          "type": "string",
          "default": ""
        },
        "suppressTrackingCookies": {
          "type": "boolean",
          "default": false
        }
      },
      "unevaluatedProperties": false
    },
    "AdvancedSeoSettingsDialog": {
      "type": "object",
      "properties": {
        "userMetaTags": {
          "type": "string",
          "default": ""
        }
      },
      "unevaluatedProperties": false
    },
    "Anchor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "compId": {
              "type": "string"
            },
            "urlFragment": {
              "type": "string",
              "maxLength": 60
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BasicMenuItem": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "slot": {
              "type": "string"
            },
            "label": {
              "type": "string"
            },
            "isVisible": {
              "type": "boolean",
              "default": true
            },
            "isVisibleMobile": {
              "type": "boolean",
              "default": true
            },
            "displayCount": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "iconRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomMenu": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "menuType": {
              "type": "string",
              "maxLength": 100
            },
            "syncWithPages": {
              "type": "boolean",
              "default": false
            },
            "appId": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomMenusCollection": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menus": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomMenuDataRef": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menuRef": {
              "default": "#CUSTOM_MAIN_MENU",
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "itemDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 1st (top) level menu items"
            },
            "submenuDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 2nd level menu item (submenu)"
            },
            "submenuSubItemDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 3rd level menu item (submenuSubItem)"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomMenuDataRefA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Menu": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FacebookLikeBox": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "facebookPageId": {
              "type": "string",
              "default": "wix",
              "description": "Facebook page id"
            },
            "showFaces": {
              "type": "boolean",
              "default": true,
              "description": "Show profile photos in the plugin"
            },
            "colorScheme": {
              "type": "string",
              "default": "light",
              "enum": [
                "light",
                "dark"
              ],
              "description": "The color scheme of the plugin. Note that the background is always transparent to match your background color. This setting changes the foreground colors to work well on light or dark backgrounds."
            },
            "showStream": {
              "type": "boolean",
              "default": true,
              "description": "Show the profile stream for the public profile"
            },
            "showBorder": {
              "type": "boolean",
              "default": true,
              "description": "Show a border around the plugin"
            },
            "showHeader": {
              "type": "boolean",
              "default": true,
              "description": "Show the 'Find us on Facebook' bar at top. Only shown when either stream or faces are present"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageButtonA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "alt": {
              "type": "string"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "defaultImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "hoverImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "activeImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "NumericStepper": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "1"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PinItPinWidget": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pinId": {
              "type": "string",
              "default": "http://www.pinterest.com/pin/204421270560540859/"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PinterestPinIt": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "description": {
              "type": "string",
              "default": "Check it out!"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SingleAudioPlayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": "",
              "description": "MP3 uri"
            },
            "originalFileName": {
              "type": "string",
              "default": "",
              "description": "Original MP3 file name"
            },
            "artist": {
              "type": "string",
              "default": "Unknown Artist",
              "description": "Artist Name"
            },
            "track": {
              "type": "string",
              "default": "Unknown Track",
              "description": "Track Name"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SkypeCallButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "skypeName": {
              "type": "string"
            },
            "buttonType": {
              "type": "string",
              "enum": [
                "call",
                "chat"
              ],
              "default": "call"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SpotifyFollow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SpotifyPlayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": "",
              "description": "Spotify URI"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SubscribeForm": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "firstNameFieldLabel": {
              "type": "string",
              "default": "First Name"
            },
            "lastNameFieldLabel": {
              "type": "string",
              "default": "Last Name"
            },
            "emailFieldLabel": {
              "type": "string",
              "default": "Email"
            },
            "phoneFieldLabel": {
              "type": "string",
              "default": "Mobile number"
            },
            "subscribeFormTitle": {
              "type": "string",
              "default": "Subscribe for Updates"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Subscribe Now"
            },
            "successMessage": {
              "type": "string",
              "default": "Congrats! You’re subscribed"
            },
            "errorMessage": {
              "type": "string",
              "default": "Forgot your email? Try again."
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "To subscribe please fill in all the required info"
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "YouTubeSubscribeButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "youtubeChannelId": {
              "type": "string",
              "default": "wix",
              "description": "youtube channel id"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AudioPlayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "autoPlay": {
              "type": "boolean",
              "default": false
            },
            "loop": {
              "type": "boolean",
              "default": false
            },
            "visible": {
              "type": "boolean",
              "default": true
            },
            "volume": {
              "type": "number",
              "default": 100
            },
            "title": {
              "type": "string",
              "default": ""
            },
            "description": {
              "type": "string",
              "default": ""
            },
            "icon_uri": {
              "type": "string",
              "default": ""
            },
            "originalFileName": {
              "type": "string",
              "default": ""
            },
            "showToolTip": {
              "$ref": "urn:dm:schemas:common.json#/JavaBool"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Boolean": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        }
      },
      "unevaluatedProperties": false
    },
    "CheckBox": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        },
        "indeterminate": {
          "type": "boolean",
          "default": false,
          "description": "Used for three state check box"
        }
      },
      "unevaluatedProperties": false
    },
    "Grid": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "dataSource": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "static",
                    "dynamic"
                  ]
                },
                "revision": {
                  "type": "number",
                  "multipleOf": 1
                }
              },
              "unevaluatedProperties": false
            },
            "rows": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": true,
                "unevaluatedProperties": false
              }
            },
            "rowsCount": {
              "type": "number"
            },
            "revision": {
              "type": "number"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ContactForm": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "nameFieldLabel": {
              "type": "string",
              "default": "Name"
            },
            "emailFieldLabel": {
              "type": "string",
              "default": "Email"
            },
            "phoneFieldLabel": {
              "type": "string",
              "default": "Phone"
            },
            "addressFieldLabel": {
              "type": "string",
              "default": "Address"
            },
            "subjectFieldLabel": {
              "type": "string",
              "default": "Subject"
            },
            "messageFieldLabel": {
              "type": "string",
              "default": "Message"
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Send"
            },
            "successMessage": {
              "type": "string",
              "default": "Your details were sent successfully!"
            },
            "errorMessage": {
              "type": "string",
              "default": "Please provide a valid email"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "Please fill in all required fields."
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DynamicContactForm": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Send"
            },
            "successMessage": {
              "type": "string",
              "default": "Your details were sent successfully!"
            },
            "errorMessage": {
              "type": "string",
              "default": "Please provide a valid email"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "Please fill in all required fields."
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "formName": {
              "type": "string",
              "default": ""
            },
            "dynamicFields": {
              "type": "array",
              "default": [
                {
                  "name": "email",
                  "inputType": "email",
                  "displayLabel": "Email",
                  "required": true
                },
                {
                  "name": "name",
                  "inputType": "text",
                  "displayLabel": "Name",
                  "required": true
                },
                {
                  "name": "subject",
                  "inputType": "text",
                  "displayLabel": "Subject",
                  "required": false
                },
                {
                  "name": "message",
                  "inputType": "text",
                  "displayLabel": "Message",
                  "required": false
                }
              ],
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string",
                    "maxLength": 50
                  },
                  "inputType": {
                    "type": "string",
                    "maxLength": 50
                  },
                  "displayLabel": {
                    "type": "string",
                    "maxLength": 200
                  },
                  "required": {
                    "$ref": "urn:dm:schemas:common.json#/JavaBool"
                  },
                  "displayed": {
                    "$ref": "urn:dm:schemas:common.json#/JavaBool"
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "EbayItemsBySeller": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "sellerId": {
              "type": "string"
            },
            "registrationSite": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FacebookShareButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "urlChoice": {
              "type": "string",
              "enum": [
                "Current page",
                "Site"
              ],
              "default": "Current page",
              "description": "Share: current/site url"
            },
            "label": {
              "type": "string",
              "default": "Share",
              "description": ""
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlashComponent": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string"
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            },
            "title": {
              "type": "string",
              "maxLength": 100
            },
            "uri": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 1000
            },
            "height": {
              "type": "number",
              "default": 0
            },
            "width": {
              "type": "number",
              "default": 0
            },
            "placeHolderImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlickrBadgeWidget": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "userId": {
              "type": "string",
              "default": "74009459@N07"
            },
            "userName": {
              "type": "string"
            },
            "tag": {
              "type": "string"
            },
            "imageCount": {
              "type": [
                "string",
                "number"
              ],
              "default": 3
            },
            "whichImages": {
              "type": "string",
              "default": "latest"
            },
            "imageSize": {
              "type": "string",
              "default": "t"
            },
            "layoutOrientation": {
              "type": "string",
              "default": "v"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GeoMapLocation": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "address": {
              "type": "string",
              "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158",
              "maxLength": 1000
            },
            "latitude": {
              "type": "number",
              "default": 37.77065
            },
            "longitude": {
              "type": "number",
              "default": -122.387301
            },
            "title": {
              "type": "string",
              "default": "Wix Office",
              "maxLength": 10000
            },
            "description": {
              "type": "string",
              "default": "Wix HQ",
              "maxLength": 350
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "linkTitle": {
              "type": "string",
              "default": "Visit Wix's Site",
              "maxLength": 140
            },
            "pinIcon": {
              "type": "string",
              "default": "https://static.parastorage.com/services/santa-resources/resources/editor/designPanel/panelTypes/default_pin_icon.png",
              "maxLength": 1000
            },
            "pinColor": {
              "type": "string",
              "default": "#2A3688",
              "maxLength": 20
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GeoMap": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "language": {
              "type": "string",
              "enum": [
                "af",
                "sq",
                "am",
                "ar",
                "hy",
                "az",
                "eu",
                "be",
                "bn",
                "bs",
                "bg",
                "my",
                "ca",
                "zh",
                "zh-CN",
                "zh-HK",
                "zh-TW",
                "hr",
                "cs",
                "da",
                "nl",
                "en",
                "en-AU",
                "en-GB",
                "et",
                "fa",
                "fi",
                "fil",
                "fr",
                "fr-CA",
                "gl",
                "ka",
                "de",
                "el",
                "gu",
                "iw",
                "hi",
                "hu",
                "is",
                "id",
                "it",
                "ja",
                "kn",
                "kk",
                "km",
                "ko",
                "ky",
                "lo",
                "lv",
                "lt",
                "mk",
                "ms",
                "ml",
                "mr",
                "mn",
                "ne",
                "no",
                "pl",
                "pt",
                "pt-BR",
                "pt-PT",
                "pa",
                "ro",
                "ru",
                "sr",
                "si",
                "sk",
                "sl",
                "es",
                "es-419",
                "sw",
                "sv",
                "ta",
                "te",
                "th",
                "tr",
                "uk",
                "ur",
                "uz",
                "vi",
                "zu"
              ]
            },
            "locations": {
              "minItems": 0,
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "address": {
              "type": "string",
              "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158"
            },
            "latitude": {
              "type": "number",
              "default": 37.77065
            },
            "longitude": {
              "type": "number",
              "default": -122.387301
            },
            "addressInfo": {
              "type": "string",
              "default": "Wix Office"
            },
            "defaultLocation": {
              "type": "number",
              "default": 0
            },
            "mapStyle": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "stylers"
                ],
                "properties": {
                  "elementType": {
                    "type": "string",
                    "enum": [
                      "all",
                      "geometry",
                      "geometry.fill",
                      "geometry.stroke",
                      "labels",
                      "labels.icon",
                      "labels.text",
                      "labels.text.fill",
                      "labels.text.stroke"
                    ],
                    "description": "Selects the element type to which a styler should be applied. An element type distinguishes between the different representations of a feature."
                  },
                  "featureType": {
                    "type": "string",
                    "enum": [
                      "administrative",
                      "administrative.country",
                      "administrative.land_parcel",
                      "administrative.locality",
                      "administrative.neighborhood",
                      "administrative.province",
                      "all",
                      "landscape",
                      "landscape.man_made",
                      "landscape.natural",
                      "landscape.natural.landcover",
                      "landscape.natural.terrain",
                      "poi",
                      "poi.attraction",
                      "poi.business",
                      "poi.government",
                      "poi.medical",
                      "poi.park",
                      "poi.place_of_worship",
                      "poi.school",
                      "poi.sports_complex",
                      "road",
                      "road.arterial",
                      "road.highway",
                      "road.highway.controlled_access",
                      "road.local",
                      "transit",
                      "transit.line",
                      "transit.station",
                      "transit.station.airport",
                      "transit.station.bus",
                      "transit.station.rail",
                      "water"
                    ],
                    "description": "Selects the feature, or group of features, to which a styler should be applied."
                  },
                  "stylers": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "maxProperties": 1,
                      "additionalProperties": false,
                      "description": "The style rules to apply to the selectors. The rules are applied to the map's elements in the order they are listed in this array.",
                      "properties": {
                        "color": {
                          "type": "string",
                          "maxLength": 100,
                          "description": "Sets the color of the feature. Valid values: An RGB hex string, i.e. '#ff0000'."
                        },
                        "gamma": {
                          "type": "number",
                          "description": "Modifies the gamma by raising the lightness to the given power.Valid values: Floating point numbers, [0.01, 10], with 1.0 representing no change."
                        },
                        "hue": {
                          "type": "string",
                          "maxLength": 100,
                          "description": "Sets the hue of the feature to match the hue of the color supplied. Note that the saturation and lightness of the feature is conserved, which means that the feature will not match the color supplied exactly. Valid values: An RGB hex string, i.e. '#ff0000'."
                        },
                        "invert_lightness": {
                          "type": "boolean",
                          "description": "A value of true will invert the lightness of the feature while preserving the hue and saturation."
                        },
                        "lightness": {
                          "type": "number",
                          "description": "Shifts lightness of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                        },
                        "saturation": {
                          "type": "number",
                          "description": "Shifts the saturation of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                        },
                        "visibility": {
                          "type": "string",
                          "enum": [
                            "on",
                            "off",
                            "simplified"
                          ],
                          "description": "Sets the visibility of the feature. Valid values: 'on', 'off' or 'simplified'."
                        },
                        "weight": {
                          "type": "number",
                          "description": "Sets the weight of the feature, in pixels. Valid values: Integers greater than or equal to zero."
                        }
                      },
                      "unevaluatedProperties": false
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "HtmlComponent": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "sourceType": {
              "type": "string",
              "default": ""
            },
            "url": {
              "type": "string",
              "default": ""
            },
            "title": {
              "type": "string"
            },
            "freezeFrame": {
              "type": "boolean",
              "default": false
            },
            "allowFullScreen": {
              "type": "boolean",
              "default": false
            },
            "componentConsentPolicy": {
              "type": "string",
              "default": "essential",
              "enum": [
                "essential",
                "functional",
                "analytics",
                "advertising",
                "dataToThirdParty"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DisqusComments": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "disqusId": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ItunesButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "downloadUrl": {
              "type": "string",
              "default": "",
              "description": "Insert band URL"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LinkableFlashComponent": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "title": {
              "type": "string"
            },
            "uri": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "height": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "placeHolderImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LinkableButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LoginButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "language": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TinyMenu": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "loginSocialBarRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "menuRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LoginSocialBar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menuItemsRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "iconItemsRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "language": {
              "type": "string",
              "default": "en",
              "maxLength": 10
            },
            "loggedInMember": {
              "type": "string",
              "enum": [
                "avatarOnly",
                "textOnly",
                "avatarAndText",
                "memberInitials"
              ],
              "default": "avatarAndText"
            },
            "loggedOutMember": {
              "type": "string",
              "enum": [
                "avatarOnly",
                "textOnly",
                "avatarAndText"
              ]
            },
            "loggedInAvatarIcon": {
              "type": "string",
              "enum": [
                "profileImage",
                "initials",
                "custom"
              ]
            },
            "loggedOutAvatarIcon": {
              "type": "string",
              "enum": [
                "profileImage",
                "initials",
                "custom"
              ],
              "default": "profileImage"
            },
            "loggedInCustomAvatar": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "loggedOutCustomAvatar": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "loggedOutText": {
              "type": "string",
              "default": "Log In",
              "maxLength": 50
            },
            "showLoggedInText": {
              "type": "boolean",
              "default": true
            },
            "loggedInTextState": {
              "type": "string",
              "enum": [
                "memberName",
                "custom"
              ]
            },
            "loggedInText": {
              "type": "string",
              "default": "Hello",
              "maxLength": 50
            },
            "customLoggedInText": {
              "type": "string",
              "maxLength": 50
            },
            "logOutText": {
              "type": "string",
              "default": "Log Out",
              "maxLength": 50
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PagesGroupData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appId": {
              "type": [
                "number",
                "null"
              ]
            },
            "appDefinitionId": {
              "type": "string"
            },
            "groupName": {
              "type": "string"
            },
            "pages": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PagesGroupCollection": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "groups": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PayPalButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "merchantID": {
              "type": "string",
              "default": "",
              "description": "some amazing description"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PermaLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "appType"
          ],
          "properties": {
            "appType": {
              "enum": [
                "ListsApps",
                "ThirdPartyApps"
              ]
            },
            "dataItemRef": {
              "default": "",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mutableSeoTitle": {
              "type": "string"
            },
            "correctPermaLinkRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PinterestFollow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "urlChoice": {
              "type": "string",
              "default": "pinterest/",
              "description": ""
            },
            "label": {
              "type": "string",
              "default": "Pinterest",
              "description": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SelectableList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "$ref": "#/Direction",
                  "description": "direction of the component"
                },
                "labelDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the label"
                },
                "inputDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the input"
                },
                "dropdownDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the dropdown"
                },
                "errorDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the error"
                },
                "options": {
                  "description": "a list of SelectOption data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": "object",
                  "properties": {
                    "value": {
                      "type": "string",
                      "default": "-1",
                      "description": "the value of the placeholder option",
                      "maxLength": 400
                    },
                    "text": {
                      "type": "string",
                      "default": "",
                      "description": "the text of the placeholder option",
                      "maxLength": 400
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SelectOption": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "text": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "selectedText": {
              "type": "string",
              "maxLength": 400
            },
            "disabled": {
              "type": "boolean"
            },
            "description": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RadioButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "label": {
                  "type": "string",
                  "default": "",
                  "maxLength": 400
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RadioGroup": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "optionsDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "defaultValue": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "options": {
                  "description": "a list of RadioButton data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": "object",
                  "properties": {
                    "value": {
                      "type": "string",
                      "default": "-1",
                      "description": "the value of the placeholder option",
                      "maxLength": 400
                    },
                    "text": {
                      "type": "string",
                      "default": "",
                      "description": "the text of the placeholder option",
                      "maxLength": 400
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CheckboxGroup": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "optionsDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "options": {
                  "description": "a list of CheckboxInput data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 4000
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FileUploader": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "buttonLabel": {
              "type": "string",
              "default": "Upload File",
              "maxLength": 500
            },
            "placeholderLabel": {
              "type": "string",
              "default": "Max File Size 15MG",
              "maxLength": 500
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "maxLength": 400
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonLabelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "filesDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "iconPosition": {
              "type": [
                "string"
              ],
              "enum": [
                "row",
                "rowReverse",
                "column",
                "columnReverse"
              ],
              "description": "Flex direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "UploadName": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SiteButtonA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pressed": {
              "type": "boolean"
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "haspopup": {
              "type": "string",
              "enum": [
                "true",
                "false",
                "menu",
                "dialog",
                "listbox",
                "tree",
                "grid"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "disabled": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SiteButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SoundCloudWidget": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string",
              "default": ""
            },
            "showArtWork": {
              "type": "boolean",
              "default": true
            },
            "autoPlay": {
              "type": "boolean",
              "default": false
            },
            "embedSource": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StyledTextA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StyledText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000,
              "default": "<p class='font_7'></p>",
              "not": {
                "pattern": "<script"
              }
            },
            "stylesMapId": {
              "type": "string"
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StyledTextLinkHelper": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
        }
      },
      "unevaluatedProperties": false
    },
    "SvgShape": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "alt": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VectorImage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            },
            "alt": {
              "type": "string",
              "description": "Alternative text for the vector image (for accessibility purposes).",
              "default": ""
            },
            "decorative": {
              "type": "boolean"
            },
            "title": {
              "type": "string",
              "maxLength": 100,
              "description": "Title or caption for the vector image."
            },
            "svgId": {
              "type": "string",
              "maxLength": 100,
              "description": "Identifier for the SVG image."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Video": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "videoId": {
              "type": "string"
            },
            "userId": {
              "type": "string"
            },
            "posterImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "videoType": {
              "type": "string",
              "enum": [
                "YOUTUBE",
                "VIMEO",
                "FACEBOOK",
                "DAILYMOTION"
              ],
              "default": "YOUTUBE"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VKShareButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "style": {
              "type": "string",
              "enum": [
                "Button",
                "ButtonWithoutCounter",
                "Link",
                "LinkWithoutIcon",
                "Icon"
              ],
              "default": "Button",
              "description": "the layout of the button"
            },
            "text": {
              "type": "string",
              "default": "Share",
              "description": "the text of the Button"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ButtonWithIcon": {
      "type": "object",
      "properties": {
        "label": {
          "type": "string",
          "format": "resourceKey"
        },
        "toggleMode": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        },
        "iconSrc": {
          "type": "string"
        },
        "iconSize": {
          "type": "object",
          "additionalProperties": true,
          "unevaluatedProperties": false
        },
        "spriteOffset": {
          "type": "object",
          "additionalProperties": true,
          "unevaluatedProperties": false
        },
        "command": {
          "type": "string"
        },
        "commandParameter": {
          "type": "string"
        },
        "action": {
          "type": "string"
        }
      },
      "unevaluatedProperties": false
    },
    "EditorPreferences": {
      "type": "object",
      "properties": {
        "dontShowAgainTooltips": {
          "type": [
            "null",
            "array"
          ]
        },
        "dontShowAgainDialogs": {
          "type": [
            "null",
            "array"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "TPAWidget": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "some amazing description"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TPAData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "content": {
              "type": "string",
              "default": "",
              "description": "storage for app data",
              "maxLength": 4000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TPAGlobalData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "content": {
              "type": "string",
              "default": "",
              "description": "storage for app data"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Definition ID"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TPA": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "referenceId": {
              "type": "string"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "widget id"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TPASection": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TPAMultiSection": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "hidden tpaSection part of multi section app"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RssButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "image": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "type": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AppPart": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appInnerID": {
              "type": [
                "string",
                "number"
              ]
            },
            "appLogicParams": {
              "type": "object",
              "default": {},
              "additionalProperties": true,
              "unevaluatedProperties": false
            },
            "appLogicCustomizations": {
              "type": "array",
              "items": {
                "$ref": "#/AppPartCustomization"
              },
              "default": []
            },
            "appPartName": {
              "type": "string"
            },
            "viewName": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AppPartCustomization": {
      "type": "object",
      "properties": {
        "fieldId": {
          "type": "string"
        },
        "forType": {
          "type": "string"
        },
        "format": {
          "type": "string"
        },
        "key": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "view": {
          "type": "string"
        },
        "mode": {
          "type": [
            "string",
            "null"
          ]
        },
        "value": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "AppPage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "appPageId": {
                  "type": "string",
                  "default": ""
                },
                "appInnerID": {
                  "type": [
                    "string",
                    "number"
                  ],
                  "default": ""
                },
                "appPageType": {
                  "type": "string"
                },
                "repeaterPage": {
                  "type": "boolean",
                  "default": false
                }
              }
            },
            {
              "$ref": "#/Page--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AppBuilderComponent": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appInnerID": {
              "type": [
                "string",
                "null"
              ]
            },
            "appPartName": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BoxSlideShow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BoxSlideShowSlide": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripContainerSlideShow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripContainerSlideShowSlide": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VerticalAnchorsMenu": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pageTopLabel": {
              "type": [
                "null",
                "string"
              ],
              "default": "Page Top"
            },
            "pageBottomLabel": {
              "type": [
                "null",
                "string"
              ],
              "default": "Page Bottom"
            },
            "hiddenAnchorIds": {
              "type": [
                "null",
                "object"
              ],
              "default": {}
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "bulletPosition": {
              "type": [
                "string"
              ],
              "enum": [
                "row",
                "rowReverse",
                "column",
                "columnReverse"
              ],
              "description": "Flex direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WFacebookComment": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WFacebookLike": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AppController": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "applicationId",
            "controllerType"
          ],
          "properties": {
            "applicationId": {
              "type": "string",
              "maxLength": 100
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "default": ""
            },
            "controllerType": {
              "type": "string",
              "maxLength": 100
            },
            "settings": {
              "type": "string",
              "maxLength": 6000
            },
            "externalId": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RepeaterA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "none",
                "radiogroup",
                "list",
                "group"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Repeater": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "items": {
              "type": "array",
              "default": [],
              "items": {
                "type": "string"
              },
              "description": "Unique identifiers for items of the repeater"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RepeatedData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "description": "data used for the serialization of a component inside a repeater component",
          "properties": {
            "original": {
              "type": "object",
              "additionalProperties": true,
              "description": "the original data item of a component inside a repeater according to the specific component schema",
              "unevaluatedProperties": false
            },
            "overrides": {
              "type": "object",
              "additionalProperties": true,
              "description": "a map from itemId in a repeater to its data item according to the specific component schema",
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageButtonWithText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 100
            },
            "icon": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "predefinedClass": {
              "type": "string",
              "maxLength": 20
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Icon": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string"
            },
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "title": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WidgetRef": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appDefinitionId": {
              "type": "string"
            },
            "widgetId": {
              "type": "string"
            },
            "variationId": {
              "type": [
                "string",
                "null"
              ]
            },
            "name": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "InternalRef": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            },
            "pageId": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "InternalBlocksRef": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "type": "string"
            },
            "pageId": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ForwardRef": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LightboxA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LightboxContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ContainerA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "none",
                "status",
                "alert",
                "nav",
                "list",
                "listitem",
                "tablist",
                "tab",
                "tabpanel",
                "menubar",
                "presentation",
                "heading"
              ]
            },
            "roledescription": {
              "type": "string",
              "maxLength": 100
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ],
              "maxLength": 10
            },
            "hidden": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string",
              "enum": [
                "all",
                "additions",
                "text",
                "removals"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ContainerData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MediaBoxData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SlotsPlaceholderData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "interfaces"
          ],
          "properties": {
            "interfaces": {
              "type": "array",
              "items": {
                "type": "string"
              },
              "maxItems": 20
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LinkType": {
      "type": "string",
      "enum": [
        "SMS",
        "CALL",
        "SKYPE",
        "MAP",
        "EMAIL",
        "FACEBOOK",
        "FLICKR",
        "BLOGGER",
        "MYSPACE",
        "LINKEDIN",
        "TWITTER",
        "TUMBLR",
        "YOUTUBE",
        "VIMEO",
        "PAGE",
        "FREE_LINK",
        "TEXT",
        "DELICIOUS",
        "WEBSITE",
        "DOCUMENT",
        "ADMIN_LOGIN",
        "LOGIN"
      ],
      "default": "FREE_LINK"
    },
    "UrlFormat": {
      "type": "string",
      "enum": [
        "hashBang",
        "slash"
      ],
      "default": "slash"
    },
    "MultiStateBoxDataA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MultiStateBoxData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "defaultStateId": {
                  "default": "FIRST_STATE",
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "selectedStateId": {
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AppsInstallState": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "stateMap": {
              "type": "object",
              "default": {},
              "additionalProperties": {
                "type": "object",
                "required": [
                  "status"
                ],
                "properties": {
                  "status": {
                    "type": "string",
                    "enum": [
                      "INSTALLED",
                      "REMOVED"
                    ],
                    "default": "INSTALLED"
                  },
                  "version": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 20
                  },
                  "codeReferenceId": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 40
                  },
                  "overrideCodeReferenceId": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 40
                  }
                }
              },
              "properties": {},
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StateBoxA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StateBox": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StateBoxStateA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StateBoxState": {
      "type": "object",
      "properties": {
        "a11y": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        }
      },
      "unevaluatedProperties": false
    },
    "Builder.MenuItem": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "container": {
              "type": "string"
            },
            "label": {
              "type": "string"
            },
            "isVisible": {
              "type": "boolean",
              "default": true
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Builder.MenuItems": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Builder.Image": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string",
              "maxLength": 1000,
              "description": "Identifier or URL for the image."
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "description": "Human-readable filename to use for the image."
            },
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "alt": {
              "type": "string",
              "maxLength": 1000
            },
            "crop": {
              "type": "object",
              "required": [
                "width",
                "height",
                "x",
                "y"
              ],
              "properties": {
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Builder.Video": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "description": "Unique identifier for the video media",
              "maxLength": 1000
            },
            "sources": {
              "type": "array",
              "description": "Available video sources in different qualities",
              "items": {
                "type": "object",
                "required": [
                  "quality",
                  "width",
                  "height",
                  "types"
                ],
                "properties": {
                  "quality": {
                    "type": "string",
                    "enum": [
                      "1080p",
                      "720p",
                      "480p",
                      "360p"
                    ],
                    "description": "Quality level of the video source"
                  },
                  "width": {
                    "type": "number",
                    "description": "Width of the video in pixels"
                  },
                  "height": {
                    "type": "number",
                    "description": "Height of the video in pixels"
                  },
                  "types": {
                    "type": "array",
                    "description": "Available format types and their URIs for this quality",
                    "items": {
                      "type": "object",
                      "required": [
                        "format",
                        "uri"
                      ],
                      "properties": {
                        "format": {
                          "type": "string",
                          "enum": [
                            "mp4",
                            "mp4-luminance"
                          ],
                          "description": "Video format type"
                        },
                        "uri": {
                          "type": "string",
                          "description": "URI to access the video file"
                        }
                      },
                      "unevaluatedProperties": false
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "adaptiveSources": {
              "type": "array",
              "description": "Sources for adaptive streaming formats",
              "items": {
                "type": "object",
                "required": [
                  "format",
                  "uri"
                ],
                "properties": {
                  "format": {
                    "type": "string",
                    "enum": [
                      "hls",
                      "dash"
                    ],
                    "description": "Adaptive streaming format"
                  },
                  "uri": {
                    "type": "string",
                    "description": "URI to access the stream manifest"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "hasAudio": {
              "type": "boolean",
              "description": "Whether the video contains an audio track"
            },
            "fps": {
              "type": "number",
              "description": "Frames per second of the video"
            },
            "poster": {
              "description": "Poster image for the video",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "duration": {
              "type": "number",
              "description": "Duration of the video in seconds"
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "description": "Human-readable name to use for the video."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Builder.VectorArt": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Builder.RichText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixStudio2Demo.counterContextProvider.Data": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "data"
          ],
          "properties": {
            "data": {
              "type": "object",
              "additionalProperties": true,
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "contentType": {
              "default": "Text",
              "enum": [
                "Text",
                "Icon",
                "Text and icon"
              ],
              "type": "string"
            },
            "label": {
              "default": "Button",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "iconPosition": {
              "default": "Left",
              "enum": [
                "Left",
                "Right"
              ],
              "type": "string"
            },
            "buttonType": {
              "default": "Full",
              "enum": [
                "Full",
                "Outline",
                "Link"
              ],
              "type": "string"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiDatePicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Select Date",
              "maxLength": 120,
              "type": "string"
            },
            "initialText": {
              "default": "today's date",
              "enum": [
                "today's date",
                "placeholder"
              ],
              "type": "string"
            },
            "placeholder": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "fieldType": {
              "default": "form",
              "enum": [
                "form",
                "settings",
                "filter"
              ],
              "type": "string"
            },
            "pickerType": {
              "default": "calendar",
              "enum": [
                "wheel",
                "calendar"
              ],
              "type": "string"
            },
            "pickerTitle": {
              "default": "Select Date",
              "maxLength": 120,
              "type": "string"
            },
            "showPastDates": {
              "default": true,
              "type": "boolean"
            },
            "showFutureDates": {
              "default": true,
              "type": "boolean"
            },
            "wheelMode": {
              "default": "DD/MM/YY",
              "enum": [
                "DD/MM/YY",
                "MM/YY"
              ],
              "type": "string"
            },
            "firstDay": {
              "default": "Monday",
              "enum": [
                "Sunday",
                "Monday"
              ],
              "type": "string"
            },
            "disabledDaysOfWeek": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "enabledDateRanges": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "disabledDateRanges": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "requiredErrorMessage": {
              "default": "This field is required",
              "maxLength": 1200,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "disabledDates": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "minDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "maxDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "timeZone": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "defaultItemSchemaType": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MobuiDateRangeType": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "startDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "endDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiImage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "src": {
              "$ref": "#/ImageReference"
            },
            "isExternalSource": {
              "default": false,
              "type": "boolean"
            },
            "resizeMode": {
              "default": "cover",
              "enum": [
                "cover",
                "contain",
                "stretch",
                "repeat",
                "center"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiPicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldType": {
              "default": "form",
              "enum": [
                "form",
                "filter",
                "settings"
              ],
              "type": "string"
            },
            "label": {
              "default": "Label",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Select an option",
              "maxLength": 120,
              "type": "string"
            },
            "pickerType": {
              "default": "fullScreen",
              "enum": [
                "fullScreen",
                "dialog"
              ],
              "type": "string"
            },
            "optionsDialogTitle": {
              "default": "Select an Option",
              "maxLength": 120,
              "type": "string"
            },
            "optionsDialogSubtitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "hasItemSubtitle": {
              "default": false,
              "type": "boolean"
            },
            "isMultiselect": {
              "default": false,
              "type": "boolean"
            },
            "selectionLimit": {
              "default": 3,
              "type": "number",
              "multipleOf": 1
            },
            "hasSearchBar": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "requiredErrorMessage": {
              "default": "Please fill out this field",
              "maxLength": 120,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "validateOnBlur": {
              "default": false,
              "type": "boolean"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MobuiPickerItemType": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "subtitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isSelected": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiSwitch": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "value": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Add Title",
              "maxLength": 1200,
              "type": "string"
            },
            "selectable": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiTextInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "inputType": {
              "default": "text",
              "enum": [
                "text",
                "password",
                "phone",
                "email",
                "url",
                "number"
              ],
              "type": "string"
            },
            "label": {
              "default": "Label",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "initialValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "hasCharLimit": {
              "default": false,
              "type": "boolean"
            },
            "maxInputLength": {
              "default": 300,
              "maximum": 120000,
              "type": "number",
              "multipleOf": 1
            },
            "prefixValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "suffixValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "requiredErrorMessage": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validatorErrorMessageValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validatorType": {
              "default": "none",
              "enum": [
                "none",
                "number",
                "email",
                "url",
                "required"
              ],
              "type": "string"
            },
            "textContentType": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "autoComplete": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "validateOnBlur": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiVideoPlayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "title": {
              "default": "I am a Title",
              "maxLength": 120,
              "type": "string"
            },
            "src": {
              "default": "https://video.wixstatic.com/video/11062b_5ae1557b0cb244ab80dabfa817f48caa/1080p/mp4/file.mp4",
              "maxLength": 1200,
              "type": "string"
            },
            "poster": {
              "$ref": "#/ImageReference"
            },
            "isPlaying": {
              "default": false,
              "type": "boolean"
            },
            "muteOnStart": {
              "default": false,
              "type": "boolean"
            },
            "playInLoop": {
              "default": false,
              "type": "boolean"
            },
            "enableFullScreen": {
              "default": true,
              "type": "boolean"
            },
            "enableCasting": {
              "default": false,
              "type": "boolean"
            },
            "showVideoSettings": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiMultiStateBoxData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "defaultStateId": {
                  "default": null,
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "selectedStateId": {
                  "default": null,
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.ExternalComponent": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "compProps": {
              "default": "{}",
              "maxLength": 120000,
              "type": "string"
            },
            "isTrusted": {
              "default": false,
              "type": "boolean"
            },
            "importKey": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.HamburgerOverlay": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "showBackgroundOverlay": {
              "default": true,
              "type": "boolean"
            },
            "tapOutsideToClose": {
              "default": true,
              "type": "boolean"
            },
            "isMenuContainerFullscreen": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.Logo": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "isLoadingData": {
              "default": true,
              "type": "boolean"
            },
            "logoId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "alt": {
              "default": "Logo",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "preset": {
              "default": "original",
              "maxLength": 120,
              "type": "string"
            },
            "hasBackground": {
              "default": true,
              "type": "boolean"
            },
            "brandId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "backgroundColor": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "logoUrl": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.LottieEmbed": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "animationUrl": {
              "default": "https://assets7.lottiefiles.com/packages/lf20_bh69rwvr.json",
              "maxLength": 1200,
              "type": "string"
            },
            "speed": {
              "default": 1,
              "minimum": 0,
              "type": "number"
            },
            "loop": {
              "default": true,
              "type": "boolean"
            },
            "autoplay": {
              "default": true,
              "type": "boolean"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isDecorative": {
              "default": false,
              "type": "boolean"
            },
            "showPlaybackControl": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.ProductSpecification": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.RangeSlider": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Set a range value",
              "maxLength": 120,
              "type": "string"
            },
            "sliderType": {
              "default": "Continuous",
              "enum": [
                "Continuous",
                "Stepped"
              ],
              "type": "string"
            },
            "stepType": {
              "default": "Number",
              "enum": [
                "Number",
                "Value"
              ],
              "type": "string"
            },
            "step": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "direction": {
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ],
              "type": "string"
            },
            "rootDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "labelDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "sliderDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "min": {
              "default": 0,
              "type": "number"
            },
            "max": {
              "default": 100,
              "type": "number"
            },
            "prefix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "suffix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "minValue": {
              "default": 0,
              "type": "number"
            },
            "maxValue": {
              "default": 0,
              "type": "number"
            },
            "thumbShape": {
              "default": "Circle",
              "enum": [
                "Circle",
                "Square",
                "Rectangle",
                "Bar"
              ],
              "type": "string"
            },
            "marksTickShape": {
              "default": "Lines",
              "enum": [
                "Lines",
                "Dots"
              ],
              "type": "string"
            },
            "thumbSize": {
              "default": 24,
              "type": "number",
              "multipleOf": 1
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "accessibleName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.Rive": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "animationFileUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "thumbnailFileUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "artboard": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "stateMachine": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "fit": {
              "default": "cover",
              "maxLength": 120,
              "type": "string"
            },
            "alignment": {
              "default": "center",
              "maxLength": 120,
              "type": "string"
            },
            "isAutoPlayOn": {
              "default": true,
              "type": "boolean"
            },
            "isTouchScrollEnabled": {
              "default": true,
              "type": "boolean"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "fileName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isDecorative": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.ShareButtons": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "buttons": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "pageToShare": {
              "default": "home",
              "maxLength": 1200,
              "type": "string"
            },
            "shareUrl": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "direction": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "IShareButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "platformId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            },
            "isHidden": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.SingleTab": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "tabId"
          ],
          "type": "object",
          "properties": {
            "tabId": {
              "maxLength": 120,
              "type": "string"
            },
            "label": {
              "default": "Tab",
              "maxLength": 120,
              "type": "string"
            },
            "isParentStretched": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AccordionContainerData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "items": {
              "type": "array",
              "items": {
                "type": "object",
                "allOf": [
                  {
                    "properties": {
                      "id": {
                        "type": "string"
                      },
                      "label": {
                        "type": "string"
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false
              },
              "default": []
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AccordionItemData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isParentStretched": {
              "type": "boolean",
              "default": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AddressInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "optionsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "locale": {
              "type": "string",
              "maxLength": 100
            },
            "googleMapsApiKey": {
              "type": "string",
              "maxLength": 400
            },
            "filter": {
              "type": "object",
              "properties": {
                "country": {
                  "type": "string",
                  "maxLength": 10
                }
              },
              "unevaluatedProperties": false
            },
            "sorting": {
              "type": "object",
              "properties": {
                "location": {
                  "type": "object",
                  "properties": {
                    "lat": {
                      "type": "number"
                    },
                    "lng": {
                      "type": "number"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "radius": {
                  "type": "number",
                  "default": 100
                },
                "formatted": {
                  "type": "string",
                  "maxLength": 10
                }
              },
              "unevaluatedProperties": false
            },
            "placeholder": {
              "type": "string",
              "description": "The value of the placeholder if chosen",
              "maxLength": 1000
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BoltComponentData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "anyOf": [
            {
              "properties": {}
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BreadcrumbsData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "svgId": {
                  "type": "string",
                  "maxLength": 100
                }
              }
            },
            {
              "$ref": "#/CustomMenuDataRef--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Captcha": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "captchaType": {
              "type": "string",
              "enum": [
                "image",
                "audio"
              ],
              "default": "image",
              "description": "When set changes the type of the challenge (image or audio)"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CollapsibleTextData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "default": "",
              "maxLength": 120000
            },
            "readMoreText": {
              "type": "string",
              "default": "Read More",
              "maxLength": 1200
            },
            "readLessText": {
              "type": "string",
              "default": "Read Less",
              "maxLength": 1200
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "linkText": {
              "type": "string",
              "default": "Read More",
              "maxLength": 1200
            },
            "textDescription": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "tag": {
              "type": "string",
              "default": "p",
              "maxLength": 31
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ComboBoxInputData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "dropdownDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/SelectableList--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomElement": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tagName": {
              "type": "string",
              "default": "wix-default-custom-element"
            },
            "url": {
              "type": "string",
              "default": "https://static.parastorage.com/services/editor-elements-library/dist/assets/CustomElement/wixDefaultCustomElement.js"
            },
            "hostedInCorvid": {
              "type": "boolean",
              "default": false
            },
            "initialAttributes": {
              "type": "string",
              "default": "{}",
              "maxLength": 4096
            },
            "shouldReload": {
              "type": "boolean",
              "description": "if iframe should be reloaded on initialAttributes change"
            },
            "scriptType": {
              "type": "string",
              "enum": [
                "none",
                "module"
              ],
              "default": "none"
            },
            "appDefinitionId": {
              "type": "string",
              "maxLength": 36
            },
            "widgetId": {
              "type": "string",
              "maxLength": 36
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.FastGallery": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "itemClickAction": {
              "default": "ACTION",
              "enum": [
                "ACTION",
                "LINK",
                "NOTHING"
              ],
              "type": "string"
            },
            "downloadProtection": {
              "default": true,
              "type": "boolean"
            },
            "wixSDKItems": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.HamburgerMenuContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.HamburgerMenuRoot": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageX": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "image": {
              "type": "object",
              "properties": {
                "uri": {
                  "type": "string",
                  "default": ""
                },
                "alt": {
                  "type": "string",
                  "default": ""
                },
                "name": {
                  "type": "string",
                  "maxLength": 100
                },
                "height": {
                  "type": "number",
                  "default": 200
                },
                "width": {
                  "type": "number",
                  "default": 200
                },
                "decorative": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "scopedData": {
              "description": "ImageX data per breakpoint",
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "breakpoint": {
                    "type": "string"
                  },
                  "crop": {
                    "$ref": "#/Crop"
                  },
                  "focalPoint": {
                    "$ref": "#/FocalPoint"
                  },
                  "displayMode": {
                    "type": "string",
                    "enum": [
                      "fill",
                      "fit",
                      "fitWidth"
                    ],
                    "default": "fill"
                  },
                  "scrollEffect": {
                    "type": "string",
                    "enum": [
                      "parallax",
                      "fixed",
                      "zoomIn",
                      "fadeIn",
                      "none"
                    ]
                  },
                  "clickAction": {
                    "type": "string",
                    "enum": [
                      "none",
                      "goToLink"
                    ]
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "mask": {
              "type": [
                "object",
                "null"
              ],
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "width": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "height": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "svgId": {
                  "type": "string"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360
                },
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ]
                }
              },
              "unevaluatedProperties": false
            },
            "parallaxSpeed": {
              "type": "number"
            },
            "parallaxDirection": {
              "type": "string",
              "enum": [
                "normal",
                "reverse"
              ]
            },
            "hasAnimation": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Crop": {
      "type": "object",
      "required": [
        "x",
        "y",
        "width",
        "height"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        },
        "width": {
          "type": "number",
          "minimum": 0
        },
        "height": {
          "type": "number",
          "minimum": 0
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "rotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 359,
          "description": "Image rotation degrees"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ],
          "default": "none",
          "description": "Image flip value"
        }
      },
      "unevaluatedProperties": false
    },
    "FocalPoint": {
      "type": "object",
      "required": [
        "x",
        "y"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        }
      },
      "unevaluatedProperties": false
    },
    "LanguageSelector": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.MegaMenuContainerItem": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "type": {
              "default": "wixui.MegaMenuContainerItem",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MenuData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "itemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuItemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuSubItemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "navAriaLabel": {
                  "type": "string",
                  "maxLength": 1000
                }
              }
            },
            {
              "$ref": "#/CustomMenuDataRef--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.MenuList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "menus": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MusicPlayerData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "coverDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "audioRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "audioUrl": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 256
            },
            "playListId": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 255
            },
            "playlist": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "artistName": {
                    "type": "string",
                    "maxLength": 255,
                    "default": "Unknown Artist"
                  },
                  "trackName": {
                    "type": "string",
                    "maxLength": 255,
                    "default": "Unknown Track"
                  },
                  "url": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 2500
                  },
                  "cover": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 2500
                  },
                  "durationFormatted": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 16
                  }
                },
                "unevaluatedProperties": false
              },
              "default": []
            },
            "coverRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "coverUrl": {
              "type": [
                "string",
                "null"
              ]
            },
            "artistName": {
              "type": "string",
              "default": "Unknown Artist",
              "maxLength": 255
            },
            "trackName": {
              "type": "string",
              "default": "Unknown Track",
              "maxLength": 255
            },
            "description": {
              "type": "string",
              "default": "",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WixAudio": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "title": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "duration": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Pagination": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "totalPages": {
              "type": "number",
              "description": "The total number of pages displayed by the component"
            },
            "currentPage": {
              "type": "number",
              "default": 1,
              "description": "The the page number marked as current"
            },
            "nextText": {
              "type": "string",
              "default": "Next",
              "maxLength": 400,
              "description": "Text to appear in NEXT button"
            },
            "previousText": {
              "type": "string",
              "default": "Previous",
              "maxLength": 400,
              "description": "Text to appear in PREVIOUS button"
            },
            "firstText": {
              "type": "string",
              "default": "First",
              "maxLength": 400,
              "description": "Text to appear in FIRST button"
            },
            "lastText": {
              "type": "string",
              "default": "Last",
              "maxLength": 400,
              "description": "Text to appear in LAST button"
            },
            "nextAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the NEXT button"
            },
            "previousAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the PREVIOUS button"
            },
            "firstAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the FIRST button"
            },
            "lastAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the LAST button"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PaginationA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ProgressBar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "number",
              "description": "Current progress value"
            },
            "targetValue": {
              "type": "number",
              "default": 100,
              "description": "Progress target value to be defined as complete"
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "barDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RatingsDisplay": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "ratingsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "rating": {
              "type": "number",
              "description": "The rating displayed by the component",
              "minimum": 1,
              "maximum": 5
            },
            "svgId": {
              "type": "string",
              "maxLength": 100
            },
            "numRatings": {
              "type": "number",
              "description": "The amount of ratings the rating is based on",
              "minimum": 0
            },
            "reviewsCountLabel": {
              "type": "string",
              "default": "Reviews",
              "maxLength": 400,
              "description": "Text that describes the numRatings value"
            },
            "noReviewsPlaceholder": {
              "type": "string",
              "default": "Be the first to rate this item",
              "maxLength": 1000,
              "description": "Placeholder text when there aren't any reviews"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RatingsInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": [
                "number",
                "null"
              ],
              "description": "The rating value currently selected",
              "minimum": 0,
              "maximum": 5
            },
            "titleText": {
              "type": "string",
              "description": "the title before a value is selected",
              "maxLength": 300
            },
            "svgId": {
              "type": "string",
              "description": "the id of the svg that illustrates the rating",
              "maxLength": 100
            },
            "labels": {
              "type": "object",
              "description": "contains the labels for the different values. maps 1-5 as keys to strings",
              "default": {
                "1": "Bad",
                "2": "Fine",
                "3": "OK",
                "4": "Good",
                "5": "Great"
              },
              "additionalProperties": {
                "type": [
                  "string",
                  "number"
                ]
              },
              "unevaluatedProperties": false
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.RichContentViewer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "content": {
              "type": "object",
              "unevaluatedProperties": false
            },
            "trimEnabled": {
              "type": "boolean",
              "default": false
            },
            "trimMode": {
              "type": "string",
              "default": "paragraph",
              "maxLength": 100
            },
            "trimLengthParagraph": {
              "type": "number",
              "default": 3
            },
            "trimLengthWord": {
              "type": "number",
              "default": 10
            },
            "trimExclude": {
              "type": "string",
              "default": "plugins",
              "maxLength": 100
            },
            "trimEllipsisEnabled": {
              "type": "boolean",
              "default": true
            },
            "trimEllipsisExpandText": {
              "type": "string",
              "default": "Show More",
              "maxLength": 1200
            },
            "trimEllipsisCollapseText": {
              "type": "string",
              "default": "Show Less",
              "maxLength": 1200
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RichTextBox": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "maxLength": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SearchBox": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "placeholder": {
              "type": "string",
              "default": "Search...",
              "maxLength": 255
            },
            "suggestionsEnabled": {
              "type": "boolean",
              "default": true,
              "description": "Determines whether the suggestions disabled or not"
            },
            "clearButtonText": {
              "type": "string",
              "default": "Clear",
              "maxLength": 255
            },
            "displaySettingsToggles": {
              "type": "boolean",
              "default": true,
              "description": "Determines whether the settings toggles are displayed or not"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Section": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SectionA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "alert",
                "status"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.SelectableContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.SelectableContainerInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SelectionTagsList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "options": {
              "description": "Array of items which behave like checkboxes and look similar to buttons",
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "value": {
              "description": "Array with the values of the selected options",
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SelectionTag": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "maxLength": 400
            },
            "label": {
              "type": "string",
              "maxLength": 400
            },
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "rel": {
              "type": "string",
              "enum": [
                "nofollow"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SignatureInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "titleText": {
              "type": "string",
              "description": "The title of the field",
              "maxLength": 400
            },
            "clearButtonText": {
              "type": "string",
              "description": "The undo signature text",
              "minLength": 1,
              "maxLength": 400
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "radioButtonsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SiteButtonData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/LinkableButton--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Slider": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "trackDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "tooltipDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "min": {
              "type": "number",
              "default": 0,
              "description": "Minimum value"
            },
            "max": {
              "type": "number",
              "default": 100,
              "description": "Maximum value"
            },
            "value": {
              "type": "number",
              "default": 50,
              "description": "Current value"
            },
            "step": {
              "type": "number",
              "default": 0,
              "description": "Step value"
            },
            "stepType": {
              "type": "string",
              "default": "value",
              "enum": [
                "value",
                "count"
              ],
              "description": "When set to 'value', step represents the value of each step. When set to 'count', step represents the total steps count"
            },
            "disabled": {
              "type": "boolean",
              "default": false,
              "description": "Determines whether the slider is disabled or not"
            },
            "readOnly": {
              "type": "boolean",
              "default": false,
              "description": "Determines whether the slider is read-only or not"
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "description": "Label text",
              "maxLength": 1200
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.Slideshow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "type": {
              "default": "wixui.Slideshow",
              "maxLength": 120,
              "type": "string"
            },
            "direction": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SocialAuth": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StylableButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON",
              "maxLength": 1200
            },
            "svgId": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "isIconAnimated": {
              "type": "boolean"
            },
            "animatedIcon": {
              "type": "object",
              "properties": {
                "svgIdAnimationSelected": {
                  "type": "string",
                  "maxLength": 100
                },
                "customAnimatedIcon": {
                  "type": [
                    "object"
                  ],
                  "properties": {
                    "svgIdAnimationStart": {
                      "type": "string",
                      "maxLength": 100
                    },
                    "svgIdAnimationEnd": {
                      "type": "string",
                      "maxLength": 100
                    },
                    "svgIdAnimationSelected": {
                      "type": "string",
                      "maxLength": 100
                    }
                  },
                  "unevaluatedProperties": false
                },
                "animationDuration": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StylableButtonA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "pressed": {
              "type": "boolean"
            },
            "expanded": {
              "type": "boolean"
            },
            "disabled": {
              "type": "boolean"
            },
            "haspopup": {
              "type": "string",
              "enum": [
                "true",
                "false",
                "dialog",
                "menu"
              ]
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Submenu": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "itemDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "subItemDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SvgImage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "svgId"
          ],
          "properties": {
            "decorative": {
              "type": "boolean"
            },
            "alt": {
              "type": "string",
              "description": "Alternative text for the vector image (for accessibility purposes).",
              "maxLength": 120
            },
            "displayMode": {
              "type": "string",
              "enum": [
                "fit",
                "stretch"
              ],
              "description": "should the shape maintain it's aspect ratio or stretch",
              "default": "fit"
            },
            "svgId": {
              "type": "string",
              "maxLength": 100,
              "description": "Identifier for the SVG image."
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.Tabs": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabIds": {
              "type": "array",
              "items": {
                "type": "string",
                "maxLength": 120
              }
            },
            "defaultTabId": {
              "type": "string",
              "default": "",
              "maxLength": 120
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TabsA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextEffectsSharedData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 500
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "default": "div"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction",
              "default": "inherit"
            },
            "patternScope": {
              "type": "string",
              "enum": [
                "none",
                "character",
                "word"
              ],
              "default": "none"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextMarqueeData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "items",
            "speed"
          ],
          "properties": {
            "movementDirection": {
              "type": "string",
              "description": "direction the text is moving to",
              "default": "rtl",
              "enum": [
                "rtl",
                "ltr"
              ]
            },
            "speed": {
              "type": "number",
              "description": "speed of the animation in pixels per second"
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "pause animation on hover"
            },
            "textDirection": {
              "type": "string",
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ]
            },
            "headingLevel": {
              "type": "number",
              "maximum": 6,
              "minimum": 0,
              "description": "Heading level to wrap the component (deprecated)"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "description": "Semantic tag name to wrap the component"
            },
            "svgId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "description": "array of marquee items",
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextMarqueeItem": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "description": "TextMarquee Item",
          "required": [
            "text"
          ],
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "text": {
              "type": "string",
              "maxLength": 500
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextFxData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 450
            },
            "headingLevel": {
              "type": "number",
              "minimum": 0,
              "maximum": 6,
              "description": "Heading level to wrap the component (deprecated)"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "direction": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ],
              "default": "ltr"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "description": "Semantic tag name to wrap the component"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextOnPathData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isDecorative": {
              "type": "boolean"
            },
            "text": {
              "type": "string",
              "description": "text",
              "maxLength": 500
            },
            "path": {
              "type": "string",
              "description": "path"
            },
            "pathLength": {
              "type": "number",
              "description": "Path length"
            },
            "viewBox": {
              "type": "string",
              "description": "View box"
            },
            "speed": {
              "type": "number",
              "description": "Speed",
              "default": 3
            },
            "movementDirection": {
              "type": "string",
              "description": "Direction the text is moving to",
              "default": "forward",
              "enum": [
                "forward",
                "reverse"
              ]
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "Pause animation on hover"
            },
            "direction": {
              "type": "string",
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ]
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div"
              ],
              "description": "Semantic tag name to wrap the component"
            },
            "fillMode": {
              "type": "string",
              "enum": [
                "normal",
                "repeat",
                "justify"
              ],
              "default": "normal",
              "description": "How the text should be rendered on the path"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            },
            "startOffset": {
              "type": "number",
              "description": "Starting point of the text on the path",
              "minimum": 0,
              "maximum": 100
            },
            "fontSize": {
              "type": "number",
              "description": "Font size as a number in percent",
              "minimum": 0,
              "maximum": 100
            },
            "pathStrokeWidth": {
              "type": "number",
              "description": "Width of the path stroke in em units",
              "minimum": 0,
              "maximum": 3
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextParticlesData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "default": "TextParticles",
              "maxLength": 500,
              "type": "string"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction",
              "default": "inherit"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "default": "div"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "pause animation on hover",
              "default": true
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TimePickerData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "placeholder": {
                  "type": "string",
                  "description": "The value of the placeholder if chosen",
                  "maxLength": 1000
                },
                "step": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 60,
                  "default": 1,
                  "description": "Increment step in minutes"
                },
                "label": {
                  "type": "string",
                  "maxLength": 1000
                },
                "margin": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 30,
                  "description": "Time picker layout label margin"
                },
                "disabledTimes": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "required": [
                      "startTime",
                      "endTime"
                    ],
                    "properties": {
                      "startTime": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "endTime": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  },
                  "default": [],
                  "maxItems": 5,
                  "description": "array of disabled times"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ToggleSwitch": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "checked": {
                  "type": "boolean",
                  "description": "The checked status of the input"
                },
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "UnsupportedComponentData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "migratedFrom": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VideoPlayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "videoType": {
              "type": "string",
              "enum": [
                "dailymotion",
                "facebook",
                "file",
                "twitch",
                "vimeo",
                "youtube"
              ],
              "default": "file"
            },
            "videoRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "videoUrl": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 256
            },
            "posterUrl": {
              "type": [
                "string",
                "null"
              ]
            },
            "videoTitle": {
              "type": "string",
              "default": "",
              "maxLength": 255
            },
            "description": {
              "type": "string",
              "default": "",
              "maxLength": 1000,
              "description": "Video Description"
            },
            "logoRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.ControlTypes": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "shortString": {
              "default": "ShortString",
              "maxLength": 120,
              "type": "string"
            },
            "longString": {
              "default": "LongString",
              "maxLength": 1200,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "dropdown": {
              "default": "Options 1",
              "enum": [
                "Options 1",
                "Options 2",
                "Options 3",
                "Options 4"
              ],
              "type": "string"
            },
            "radioButtons": {
              "default": "Options 1",
              "enum": [
                "Options 1",
                "Options 2",
                "Options 3",
                "Options 4"
              ],
              "type": "string"
            },
            "toggleSwitch": {
              "default": false,
              "type": "boolean"
            },
            "thumbnails": {
              "$ref": "#/SVGReference"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "slider": {
              "default": 1,
              "minimum": 0,
              "maximum": 2,
              "type": "number",
              "multipleOf": 1
            },
            "numericInput": {
              "default": 0,
              "type": "number"
            },
            "colorPickerInput": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "selectedFont": {
              "default": "arial",
              "maxLength": 1200,
              "format": "font-family",
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label"
          ],
          "type": "object",
          "properties": {
            "label": {
              "default": "Save",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Light",
                "Destructive",
                "Premium",
                "Premium light",
                "Dark",
                "Transparent"
              ],
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "priority": {
              "default": "Primary",
              "enum": [
                "Primary",
                "Secondary"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardHeading": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Add Page title H1",
              "maxLength": 1200,
              "type": "string"
            },
            "size": {
              "default": "Page title H1",
              "enum": [
                "Page title H1",
                "Modal title H2",
                "Card title H3",
                "Section title H4",
                "Card section title H5",
                "Caption H6"
              ],
              "type": "string"
            },
            "invertColor": {
              "default": false,
              "type": "boolean"
            },
            "textAlignment": {
              "default": "Left",
              "enum": [
                "Left",
                "Center",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardIconButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "icon": {
              "$ref": "#/SVGReference"
            },
            "tooltip": {
              "default": "More Actions",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Premium",
                "Light",
                "Transparent"
              ],
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "priority": {
              "default": "Secondary",
              "enum": [
                "Primary",
                "Secondary"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardInfoIcon": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "tooltip": {
              "default": "This message explains the purpose of a feature.",
              "maxLength": 1200,
              "type": "string"
            },
            "addLink": {
              "default": false,
              "type": "boolean"
            },
            "tooltipLinkText": {
              "default": "Learn more",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipLink": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Event name",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Enter your event name...",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "prefixValue": {
              "default": "Units",
              "maxLength": 120,
              "type": "string"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixValue": {
              "default": ".com",
              "maxLength": 120,
              "type": "string"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "setMaxLength": {
              "default": false,
              "type": "boolean"
            },
            "maxLength": {
              "default": 20,
              "type": "number",
              "multipleOf": 1
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "border": {
              "default": "Default",
              "enum": [
                "Default",
                "Round",
                "Line",
                "None"
              ],
              "type": "string"
            },
            "labelPosition": {
              "default": "Top",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardNumberInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Number of tickets",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Enter a number...",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": 25,
              "type": "number",
              "multipleOf": 1
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "prefixValue": {
              "default": "Units",
              "maxLength": 120,
              "type": "string"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixValue": {
              "default": "%",
              "maxLength": 120,
              "type": "string"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "minAndMaxValues": {
              "default": false,
              "type": "boolean"
            },
            "min": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "max": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepSize": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "border": {
              "default": "Default",
              "enum": [
                "Default",
                "Round",
                "Line",
                "None"
              ],
              "type": "string"
            },
            "labelPlacement": {
              "default": "Top",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "I’m a paragraph. Add your own text and edit me in settings. It’s easy.",
              "maxLength": 1200,
              "type": "string"
            },
            "preset": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Standard secondary",
                "Light",
                "Light secondary",
                "Success",
                "Destructive",
                "Primary",
                "Premium",
                "Disabled"
              ],
              "type": "string"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "Thin",
              "enum": [
                "Bold",
                "Normal",
                "Thin"
              ],
              "type": "string"
            },
            "textAlignment": {
              "default": "Left",
              "enum": [
                "Left",
                "Center",
                "Right"
              ],
              "type": "string"
            },
            "overflow": {
              "default": "Wrap",
              "enum": [
                "Wrap",
                "Ellipsis"
              ],
              "type": "string"
            },
            "maxLines": {
              "default": 1,
              "minimum": 1,
              "type": "number",
              "multipleOf": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardTextButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "View All",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Premium",
                "Light",
                "Dark",
                "Destructive"
              ],
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "underline": {
              "default": "Never",
              "enum": [
                "Never",
                "On hover",
                "Always"
              ],
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "Regular",
              "enum": [
                "Regular",
                "Medium"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardToggleSwitch": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Set a reminder",
              "maxLength": 120,
              "type": "string"
            },
            "checked": {
              "default": true,
              "type": "boolean"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Success",
                "Destructive"
              ],
              "type": "string"
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Large",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "labelPosition": {
              "default": "Right",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.SettingsPanelContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "theme": {
              "default": "classic",
              "enum": [
                "classic",
                "responsive"
              ],
              "type": "string"
            },
            "debug": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuAccordion": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Label Example",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "openByDefault": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuBackButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Back",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "label": {
              "default": "Button",
              "maxLength": 120,
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "standard secondary",
                "premium",
                "premium secondary",
                "alert",
                "alert secondary",
                "inverted"
              ],
              "type": "string"
            },
            "size": {
              "default": "medium",
              "enum": [
                "small",
                "medium",
                "large"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "fullWidth": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuCheckboxGroup": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Multiple Choices",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuColorPicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Opacity & Color",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "opacity": {
              "default": 100,
              "minimum": 0,
              "maximum": 100,
              "type": "number",
              "multipleOf": 1
            },
            "showPercentage": {
              "default": true,
              "type": "boolean"
            },
            "opacitySliderEnabled": {
              "default": true,
              "type": "boolean"
            },
            "color": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuColorSelector": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Color Selector",
              "maxLength": 120,
              "type": "string"
            },
            "color": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuColumnControllerControl": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Column controller",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "enableReorder": {
              "default": true,
              "type": "boolean"
            },
            "minimumValue": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "dividerType": {
              "default": "none",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            },
            "columns": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuDatePicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Choose a Date",
              "maxLength": 120,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuDrillDown": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Label Title",
              "maxLength": 120,
              "type": "string"
            },
            "description": {
              "default": "This is a description text",
              "maxLength": 1200,
              "type": "string"
            },
            "iconType": {
              "default": "None",
              "enum": [
                "None",
                "Info",
                "Alert"
              ],
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuDropdown": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Dropdown",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Choose an option",
              "maxLength": 120,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuEmptyState": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Link to Lightbox",
              "maxLength": 120,
              "type": "string"
            },
            "description": {
              "default": "Create your own lightboxes and link to them for any place in your site.",
              "maxLength": 1200,
              "type": "string"
            },
            "textButtonLabel": {
              "default": "Start Creating",
              "maxLength": 120,
              "type": "string"
            },
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuFontAndColorPicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Pick Font and Color",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "font": {
              "default": "arial",
              "maxLength": 1200,
              "format": "font-family",
              "type": "string"
            },
            "color": {
              "default": "#FFC233",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuHorizontalTabs": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "tabsStyle": {
              "default": "Folder",
              "enum": [
                "Folder",
                "Arrowed",
                "Arrowed Without a Line"
              ],
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "maxVisibleTabs": {
              "default": 3,
              "minimum": 1,
              "maximum": 10,
              "type": "number",
              "multipleOf": 1
            },
            "tabsToScroll": {
              "default": 3,
              "minimum": 1,
              "maximum": 10,
              "type": "number",
              "multipleOf": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuLeftTextButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Text Button",
              "maxLength": 120,
              "type": "string"
            },
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "size": {
              "default": "medium",
              "enum": [
                "tiny",
                "small",
                "medium"
              ],
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "premium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "normal",
              "enum": [
                "thin",
                "normal"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuMultilineTextInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 120000,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Write text here...",
              "maxLength": 1200,
              "type": "string"
            },
            "maxLength": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "closeOnEnterKeyPress": {
              "default": false,
              "type": "boolean"
            },
            "autoFocus": {
              "default": false,
              "type": "boolean"
            },
            "selectTextOnFocus": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "usePatternValidation": {
              "default": false,
              "type": "boolean"
            },
            "regexPattern": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "validationMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuNotificationBanner": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "premium",
                "alert",
                "success"
              ],
              "type": "string"
            },
            "linkText": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "linkUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "iconTooltipText": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "multiline": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuNumericInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "title": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": 0,
              "type": "number"
            },
            "unitSuffix": {
              "default": "None",
              "enum": [
                "None",
                "Pixels",
                "Percentage",
                "Degrees"
              ],
              "type": "string"
            },
            "numberOfFractions": {
              "default": 2,
              "minimum": 0,
              "maximum": 2,
              "type": "number",
              "multipleOf": 1
            },
            "steps": {
              "default": 1,
              "minimum": 1,
              "maximum": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepControls": {
              "default": false,
              "type": "boolean"
            },
            "minValue": {
              "default": 0,
              "type": "number"
            },
            "maxValue": {
              "default": 100,
              "type": "number"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuRadioButtonGroup": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Radio Buttons",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuRichText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "richTextContent": {
              "default": "Your placeholder text goes here. Write, style and link it.",
              "maxLength": 120000,
              "type": "string"
            },
            "richTextLabel": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "richTextLink": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "alignTextToCenter": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuSectionDivider": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "sectionTitle": {
              "default": "Section Divider",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuSlider": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Slider",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "unitOfMeasurement": {
              "default": "number",
              "enum": [
                "number",
                "percentage",
                "pixels",
                "angle"
              ],
              "type": "string"
            },
            "defaultSelectedValue": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "minimumValue": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "maximumValue": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepValue": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "showNumericInput": {
              "default": true,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuTextInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Text Input",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "defaultText": {
              "default": "Write it here...",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Placeholder text",
              "maxLength": 120,
              "type": "string"
            },
            "prefix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "autofocus": {
              "default": false,
              "type": "boolean"
            },
            "selectedOnFocus": {
              "default": true,
              "type": "boolean"
            },
            "charactersLimit": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "usePatternValidation": {
              "default": false,
              "type": "boolean"
            },
            "regexPattern": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "errorMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuThumbnails": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "options"
          ],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "setNumberOfColumns": {
              "default": 3,
              "minimum": 1,
              "maximum": 5,
              "type": "number",
              "multipleOf": 1
            },
            "showEmptyThumbnail": {
              "default": false,
              "type": "boolean"
            },
            "thumbnailHeight": {
              "default": "Fixed ratio (1:1)",
              "enum": [
                "Fixed ratio (1:1)",
                "Fluid"
              ],
              "type": "string"
            },
            "displayLabels": {
              "default": true,
              "type": "boolean"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ThumbnailItemData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuToggleSwitch": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Toggle Switch",
              "maxLength": 120,
              "type": "string"
            },
            "toggleSwitch": {
              "default": true,
              "type": "boolean"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WutAvatar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "firstName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "lastName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "src": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WutAvatarGroup": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "maxAvatars": {
              "default": 5,
              "minimum": 1,
              "type": "number",
              "multipleOf": 1
            },
            "showHiddenAvatarCount": {
              "default": true,
              "type": "boolean"
            },
            "avatars": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WutBadge": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "My Badge",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "composition": {
              "default": "TextAndIcon",
              "enum": [
                "TextAndIcon",
                "Text",
                "Icon",
                "None"
              ],
              "type": "string"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WutRadioButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "value"
          ],
          "type": "object",
          "properties": {
            "radioGroupName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "checked": {
              "default": false,
              "type": "boolean"
            },
            "required": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Direction--unrestricted-root": {
      "type": "string",
      "enum": [
        "ltr",
        "rtl",
        "inherit"
      ]
    },
    "AppVars--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "vars": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "value": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "AppPartParam"
                    ]
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "appDefId": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "SVGItem--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/Common_SVGItem"
    },
    "SVGReference--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "BackgroundImage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string"
            },
            "positionx": {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "default": "center"
            },
            "imagesizew": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "imagesizeh": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "positiony": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "center"
              ],
              "default": "center"
            },
            "width": {
              "type": "string"
            },
            "repeatx": {
              "type": "string",
              "enum": [
                "no_repeat",
                "repeat"
              ],
              "default": "repeat"
            },
            "repeaty": {
              "type": "string",
              "enum": [
                "no_repeat",
                "repeat"
              ],
              "default": "repeat"
            },
            "attachment": {
              "type": "string",
              "enum": [
                "scroll",
                "fixed",
                "inherit",
                "local"
              ],
              "default": "inherit"
            },
            "color": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "BackgroundMedia--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "mediaRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mediaTransforms": {
              "$ref": "urn:dm:schemas:design_data.json#/BackgroundTransforms"
            },
            "overlayTransforms": {
              "$ref": "urn:dm:schemas:design_data.json#/BackgroundTransforms"
            },
            "color": {
              "oneOf": [
                {
                  "enum": [
                    "transparent",
                    "noColor"
                  ]
                },
                {
                  "$ref": "urn:dm:schemas:common.json#/color--unrestricted-root"
                }
              ]
            },
            "colorOpacity": {
              "type": "number"
            },
            "alignType": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "left",
                "right",
                "center",
                "top_left",
                "top_right",
                "bottom_left",
                "bottom_right"
              ]
            },
            "fittingType": {
              "type": "string",
              "enum": [
                "fill",
                "fit",
                "stretch",
                "actual_size",
                "original_size",
                "tile",
                "tile_horizontal",
                "tile_vertical",
                "fit_and_tile",
                "legacy_tile",
                "legacy_tile_horizontal",
                "legacy_tile_vertical",
                "legacy_normal"
              ]
            },
            "scrollType": {
              "type": "string",
              "enum": [
                "none",
                "fixed",
                "scroll",
                "local",
                "parallax"
              ]
            },
            "showOverlayForMediaType": {
              "type": "string",
              "enum": [
                "all",
                "WixVideo",
                "Image"
              ],
              "default": "WixVideo"
            },
            "imageOverlay": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "colorOverlay": {
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "colorOverlayOpacity": {
              "type": "number"
            },
            "overlayBlending": {
              "$ref": "urn:dm:schemas:design_data.json#/overlayBlending"
            },
            "filterEffect": {
              "$ref": "urn:dm:schemas:design_data.json#/filterEffect"
            },
            "colorLayers": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/ColorLayers"
            }
          }
        }
      ],
      "type": "object"
    },
    "WixVideo--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/WixVideoData--unrestricted-root"
            },
            {
              "properties": {
                "loop": {
                  "type": "boolean"
                },
                "autoplay": {
                  "type": "boolean"
                },
                "playbackSpeed": {
                  "type": "number"
                },
                "preload": {
                  "type": "string",
                  "enum": [
                    "auto",
                    "metadata",
                    "none"
                  ]
                },
                "controls": {
                  "type": "string",
                  "enum": [
                    "none",
                    "full"
                  ]
                },
                "mute": {
                  "type": "boolean",
                  "description": "deprecated, moved to properties"
                },
                "opacity": {
                  "type": "number"
                },
                "mediaFeatures": {
                  "type": "array",
                  "items": {
                    "type": "string",
                    "enum": [
                      "alpha"
                    ]
                  }
                },
                "mask": {
                  "anyOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "urn:dm:schemas:design_data.json#/ImageMask--unrestricted-root"
                    }
                  ]
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "WixVideoData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string",
              "maxLength": 100
            },
            "alt": {
              "type": "string",
              "maxLength": 1000
            },
            "videoId": {
              "type": "string"
            },
            "generatedPosters": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "qualities": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "quality": {
                    "type": "string"
                  },
                  "width": {
                    "type": "number"
                  },
                  "height": {
                    "type": "number"
                  },
                  "formats": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    },
                    "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
                  },
                  "format": {
                    "type": "string",
                    "enum": [
                      "mp4",
                      "webm"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "adaptiveVideo": {
              "type": [
                "array",
                "null"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "format": {
                    "type": "string",
                    "enum": [
                      "hls",
                      "dash"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "posterImageRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "duration": {
              "type": "number"
            },
            "fps": {
              "type": "string",
              "maxLength": 50
            },
            "hasAudio": {
              "type": "boolean",
              "description": "video has no audio"
            },
            "artist": {
              "type": "object",
              "properties": {
                "name": {
                  "type": "string"
                },
                "id": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "Document--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "siteName": {
              "type": "string",
              "maxLength": 1000
            },
            "usedFonts": {
              "type": "array",
              "items": {
                "type": "string",
                "maxLength": 1000
              }
            },
            "characterSets": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "renderModifiers": {
              "type": "object",
              "properties": {
                "siteWidth": {
                  "type": "number",
                  "minimum": 0
                },
                "pageAutoShrink": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "name": {
              "type": "string"
            },
            "mainPage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mainPageId": {
              "type": "string"
            },
            "smSettings": {
              "type": "object",
              "allOf": [
                {
                  "$ref": "#/SiteMembersData--unrestricted-root"
                }
              ],
              "unevaluatedProperties": false
            },
            "styleSettings": {
              "$ref": "#/StyleSettings"
            },
            "accessibilitySettings": {
              "$ref": "#/AccessibilitySettings"
            },
            "mobileSettings": {
              "$ref": "#/MobileSettings"
            },
            "layoutSettings": {
              "$ref": "#/LayoutSettings"
            },
            "appStudioData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "ignoreBottomBottomAnchors": {
              "type": [
                "boolean"
              ]
            },
            "anchorLockThreshold": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "supportMobile": {
              "type": "boolean"
            },
            "autoDomReorder": {
              "type": "boolean"
            },
            "appsInstallState": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "usesNewAnimations": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "AccessibilitySettings--unrestricted-root": {
      "type": "object",
      "properties": {
        "visualFocusDisabled": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "skipToContent": {
          "default": true,
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "isRtlSupportEnabled": {
          "default": false,
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "currentSiteDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        }
      }
    },
    "MobileSettings--unrestricted-root": {
      "type": "object",
      "properties": {
        "animationsEnabled": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      }
    },
    "LayoutSettings--unrestricted-root": {
      "type": "object",
      "properties": {
        "useDesktopSectionsLayout": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "isFluid": {
          "type": [
            "boolean"
          ]
        },
        "headerToPagesGap": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "pagesToFooterGap": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "mechanism": {
          "type": [
            "string"
          ],
          "enum": [
            "mesh",
            "anchors"
          ]
        },
        "soapCompsAroundPagesContainer": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      }
    },
    "StyleSettings--unrestricted-root": {
      "type": "object",
      "properties": {
        "stylesPerPage": {
          "type": "string",
          "maxLength": 20
        }
      }
    },
    "SiteMembersData--unrestricted-root": {
      "type": "object",
      "properties": {
        "socialLoginGoogleEnabled": {
          "type": "boolean"
        },
        "socialLoginFacebookEnabled": {
          "type": "boolean"
        },
        "privacyNoteType": {
          "type": "string",
          "enum": [
            "CHECKBOX",
            "NOTE"
          ]
        },
        "joinCommunityCheckedByDefault": {
          "type": "boolean"
        },
        "customSignUpPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customSignInPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customNoPermissionsPageId": {
          "type": [
            "string"
          ]
        },
        "termsOfUse": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "privacyPolicy": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "codeOfConduct": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "smFirstDialogLogin": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      }
    },
    "AppStudioData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "widgets": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "codePackages": {
              "maxItems": 1,
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "panels": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "dependencies": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "additionalProperties": false,
                "required": [
                  "appDefId"
                ],
                "properties": {
                  "appDefId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "dependencyData": {
                    "type": "array",
                    "items": {
                      "type": "string",
                      "enum": [
                        "PROVISION_ONLY_INSTALLATION",
                        "NOTIFY_USER_ON_DEPENDENCY",
                        "IS_BUNDLE"
                      ]
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "dashboards": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "customDefinitions": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "ssrCache": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "CodePackagesDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "displayName": {
              "type": "string",
              "maxLength": 30,
              "minLength": 1
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "minLength": 3
            },
            "description": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "WidgetPropertyDefinition--unrestricted-root": {
      "type": "object"
    },
    "CustomDefinitionDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "structure": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "additionalProperties": false,
                "required": [
                  "$id",
                  "title",
                  "description",
                  "default",
                  "propertiesOrder"
                ],
                "properties": {
                  "$id": {
                    "type": "string"
                  },
                  "type": {
                    "type": "string",
                    "default": "object"
                  },
                  "title": {
                    "type": "string"
                  },
                  "description": {
                    "type": "string"
                  },
                  "properties": {
                    "type": "object",
                    "additionalProperties": {
                      "$ref": "#/WidgetPropertyDefinition"
                    }
                  },
                  "default": {
                    "type": "object",
                    "default": {}
                  },
                  "propertiesOrder": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    },
                    "default": []
                  }
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "WidgetDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "devCenterWidgetId": {
              "type": [
                "string",
                "null"
              ]
            },
            "devCenterEditorReactComponentId": {
              "type": [
                "string",
                "null"
              ]
            },
            "kind": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "container",
                "section"
              ]
            },
            "panels": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "defaultSize": {
              "type": [
                "object",
                "null"
              ],
              "minProperties": 1,
              "properties": {
                "width": {
                  "type": "number"
                },
                "height": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "variations": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "presets": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "plugin": {
              "type": "object",
              "properties": {
                "placements": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "appDefinitionId": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "widgetId": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "slotId": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "containedWidgets": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            },
            "widgetApi": {
              "type": "object",
              "default": {},
              "properties": {
                "functions": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "required": [
                      "name"
                    ],
                    "properties": {
                      "name": {
                        "type": "string"
                      },
                      "description": {
                        "type": [
                          "string",
                          "null"
                        ]
                      },
                      "params": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "name": {
                              "type": "string"
                            },
                            "description": {
                              "type": [
                                "string",
                                "null"
                              ]
                            }
                          },
                          "unevaluatedProperties": false
                        }
                      },
                      "returnsDescription": {
                        "type": [
                          "string",
                          "null"
                        ]
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "propertiesSchemas": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "properties": {
                      "structure": {
                        "type": "object",
                        "additionalProperties": {
                          "$ref": "#/WidgetPropertyDefinition"
                        },
                        "default": {},
                        "unevaluatedProperties": false
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "events": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "required": [
                      "name"
                    ],
                    "properties": {
                      "name": {
                        "type": "string"
                      },
                      "description": {
                        "type": "string"
                      },
                      "args": {
                        "type": "array",
                        "items": {
                          "properties": {
                            "name": {
                              "type": "string"
                            }
                          },
                          "unevaluatedProperties": false,
                          "type": "object"
                        }
                      }
                    },
                    "unevaluatedProperties": false
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "structureRef": {
              "type": "object",
              "properties": {
                "pageId": {
                  "type": "string"
                },
                "rootCompId": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            },
            "compType": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "DashboardDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "routePath": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "hideInSidebar": {
              "type": "boolean"
            },
            "activeSidebarPageId": {
              "type": [
                "string",
                "null"
              ]
            },
            "isRoutePathConnectedToTitle": {
              "type": "boolean",
              "default": true
            }
          }
        }
      ],
      "type": "object"
    },
    "PanelDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "devCenterPanelId": {
              "type": [
                "string",
                "null"
              ]
            },
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "kind": {
              "type": "string",
              "enum": [
                "settings"
              ]
            },
            "helpId": {
              "type": "string",
              "maxLength": 100
            },
            "pageUrl": {
              "type": "string",
              "minLength": 1,
              "maxLength": 2048
            },
            "height": {
              "type": "number",
              "minimum": 0,
              "default": 0
            },
            "defaultSize": {
              "type": "object",
              "minProperties": 1,
              "properties": {
                "width": {
                  "type": "number"
                },
                "height": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "VariationDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "PresetDescriptor--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "presetId": {
              "type": "string",
              "maxLength": 100
            },
            "name": {
              "type": "string",
              "maxLength": 100
            },
            "defaultSize": {
              "type": "object",
              "minProperties": 1,
              "properties": {
                "width": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                },
                "height": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "FlatTheme--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "BG_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "CONTACT_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "NETWORKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "EXTERNAL_LINKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "PAGES_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "WEB_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "BASE_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "font": {
              "type": "string",
              "format": "font-family",
              "default": "Arial,sans-serif"
            },
            "bgId": {
              "type": "string",
              "default": "BG_USES_THEME_IMAGE"
            },
            "bgSize": {
              "type": "string",
              "default": ","
            },
            "bgType": {
              "type": "string",
              "default": "BG_USES_THEME_IMAGE"
            },
            "siteBg": {
              "type": "string",
              "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
            },
            "mobileBg": {
              "type": "string",
              "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
            },
            "siteBgColor": {
              "default": "0,0,0,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "headerTextColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "headerBgColor": {
              "default": "0,0,0,0",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "textColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "areaBgColor": {
              "default": "130,81,13,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "iconBgColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "borderColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "fontHeader": {
              "default": "normal normal bold 2.4em/1.0em [font] {headerTextColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontTitle": {
              "default": "italic normal bold 2.0em/2.0em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontSubTitle": {
              "default": "normal normal bold 1.2em/1.4em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontButton": {
              "default": "normal normal bold 1.4em/2.2em [font] {areaBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontText": {
              "default": "normal normal normal 1.1em/1.1em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontSmallText": {
              "default": "normal normal normal 0.5em/0.7em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "borderContainer": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderThumb": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderButton": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderIcon": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "radiusContainer": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusThumb": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusButton": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusIcon": {
              "default": "0.6em 0.0em 0.0em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "padding1": {
              "default": "1em 1em 1em 1em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding2": {
              "default": "0.0em 0.5em 0.0em 0.5em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding3": {
              "default": "1.0em 0.0em 1.0em 0.0em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "iconSize": {
              "default": "3.2",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "bulletSize": {
              "default": "1.5",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "headerSpacing": {
              "default": "0em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "componentSpacing": {
              "default": "0.45em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "itemSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "thumbSpacing": {
              "default": "0.23em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "iconSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            }
          }
        }
      ],
      "type": "object"
    },
    "Image--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "allOf": [
            {
              "$ref": "urn:dm:schemas:commonSchemas.json#/Common_Image--unrestricted-root"
            },
            {
              "type": "object",
              "properties": {
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "ImageA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "ImageReference--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "GlobalImageQuality--unrestricted-root": {
      "$ref": "#/ImageQuality"
    },
    "ImageQuality--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "quality": {
              "$ref": "urn:dm:schemas:common.json#/Int",
              "minimum": 0,
              "maximum": 100
            },
            "unsharpMask": {
              "type": "object",
              "minProperties": 3,
              "additionalProperties": false,
              "properties": {
                "radius": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 500
                },
                "amount": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 10
                },
                "threshold": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 255
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "ClassicSectionA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            },
            "level": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "StripColumnsContainerA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            },
            "level": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            }
          }
        }
      ],
      "type": "object"
    },
    "StripColumnsContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "itemsDirection": {
              "type": "string",
              "enum": [
                "rtl",
                "ltr"
              ],
              "default": "ltr"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "ClassicSection--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "StripContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "ImageList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "type": "object"
    },
    "Link--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "AnchorLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "anchorName": {
              "type": "string"
            },
            "anchorDataId": {
              "anyOf": [
                {
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference--unrestricted-root"
                },
                {
                  "enum": [
                    "SCROLL_TO_TOP"
                  ]
                }
              ]
            },
            "pageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "type": "object"
    },
    "DocumentLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "docId": {
              "type": "string"
            },
            "name": {
              "type": "string"
            },
            "indexable": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "PhoneLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "phoneNumber": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "WhatsAppLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "phoneNumber": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "AddressLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "address": {
              "type": "string",
              "maxLength": 200
            }
          }
        }
      ],
      "type": "object"
    },
    "EmailLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "recipient": {
              "type": "string",
              "description": "Email address of the recipient."
            },
            "subject": {
              "type": "string",
              "description": "Subject of the email."
            },
            "body": {
              "type": "string",
              "description": "Body or content of the email."
            }
          }
        }
      ],
      "type": "object"
    },
    "FormSubmitButtonLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "ExternalLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "allOf": [
                {
                  "type": "string"
                },
                {
                  "not": {
                    "type": "string",
                    "pattern": ".*script://.*"
                  }
                }
              ],
              "description": "URL of the external link."
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_blank",
              "description": "Specifies where to open the linked document."
            },
            "rel": {
              "$ref": "#/LinkRelAttribute",
              "default": [
                "noreferrer",
                "noopener"
              ],
              "description": "Specifies the relationship between the current document and the linked document."
            }
          }
        }
      ],
      "type": "object"
    },
    "LinkRelAttribute--unrestricted-root": {
      "type": "array",
      "items": {
        "type": "string",
        "enum": [
          "nofollow",
          "noopener",
          "noreferrer",
          "sponsored"
        ]
      },
      "default": []
    },
    "DynamicPageLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "routerId": {
              "type": "string"
            },
            "innerRoute": {
              "type": "string"
            },
            "anchorDataId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "isTpaRoute": {
              "type": "boolean"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "type": "object"
    },
    "TpaPageLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "itemTypeIdentifier",
            "itemId",
            "pageId",
            "appDefinitionId",
            "path"
          ],
          "properties": {
            "itemTypeIdentifier": {
              "type": "string"
            },
            "itemId": {
              "type": "string"
            },
            "pageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "path": {
              "type": "string"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "type": "object"
    },
    "LoginToWixLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "postLoginUrl": {
              "type": "string"
            },
            "postSignupUrl": {
              "type": "string"
            },
            "dialog": {
              "type": "string",
              "enum": [
                "createUser",
                "login",
                "showLogin"
              ],
              "default": "login"
            },
            "sendMail": {
              "type": "boolean",
              "default": true
            },
            "mailTemplate": {
              "type": "string"
            },
            "userColor": {
              "type": "string"
            },
            "loginCompName": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "PageLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pageId": {
              "description": "Page ID of the page to link to.",
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self",
              "description": "Specifies where to open the linked document."
            },
            "rel": {
              "$ref": "#/LinkRelAttribute",
              "description": "Specifies the relationship between the current document and the linked document."
            }
          }
        }
      ],
      "type": "object"
    },
    "MediaItem--unrestricted-root": {
      "type": "object",
      "properties": {
        "componentType": {
          "type": "string"
        },
        "dateCreated": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "fileName": {
          "type": "string"
        },
        "fileSize": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "width": {
          "type": "number"
        },
        "iconURL": {
          "type": "string"
        },
        "mediaType": {
          "type": "string"
        },
        "mimeType": {
          "type": "string"
        },
        "originalFileName": {
          "type": "string"
        },
        "sourceURL": {
          "type": [
            "null",
            "string"
          ]
        },
        "tags": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "version": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "MediaRichText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000
            },
            "stylesMapId": {
              "type": "string"
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "componentDataList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "Page--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "dataClassRef": "core.datatypes.PageDataClass",
          "properties": {
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "hideTitle": {
              "type": "boolean"
            },
            "icon": {
              "type": "string"
            },
            "windowTitle": {
              "type": "string",
              "minLength": 1,
              "maxLength": 512
            },
            "descriptionSEO": {
              "type": "string",
              "maxLength": 1024
            },
            "advancedSeoData": {
              "type": "string",
              "maxLength": 10000
            },
            "metaKeywordsSEO": {
              "type": "string",
              "maxLength": 512
            },
            "pageTitleSEO": {
              "type": "string"
            },
            "pageUriSEO": {
              "type": "string"
            },
            "hidePage": {
              "type": "boolean"
            },
            "underConstruction": {
              "type": "boolean"
            },
            "tpaApplicationId": {
              "type": "number"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "managingAppDefId": {
              "type": [
                "string",
                "null"
              ]
            },
            "tpaPageId": {
              "type": "string"
            },
            "parentPageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "pageSecurity": {
              "type": [
                "object",
                "null"
              ],
              "default": {
                "requireLogin": false,
                "passwordDigest": "",
                "dialogLanguage": ""
              },
              "properties": {
                "requireLogin": {
                  "type": "boolean"
                },
                "passwordDigest": {
                  "type": "string"
                },
                "dialogLanguage": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            },
            "indexable": {
              "type": "boolean",
              "default": true
            },
            "mobileHidePage": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageBackgrounds": {
              "type": "object",
              "properties": {
                "desktop": {
                  "type": "object",
                  "properties": {
                    "custom": {
                      "type": "boolean"
                    },
                    "mediaSizing": {
                      "type": "string",
                      "enum": [
                        "document",
                        "viewport"
                      ]
                    },
                    "ref": {
                      "$ref": "urn:dm:schemas:common.json#/nullableReference"
                    },
                    "isPreset": {
                      "type": "boolean"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "mobile": {
                  "type": "object",
                  "properties": {
                    "custom": {
                      "type": "boolean"
                    },
                    "mediaSizing": {
                      "type": "string",
                      "enum": [
                        "document",
                        "viewport"
                      ],
                      "default": "viewport"
                    },
                    "ref": {
                      "$ref": "urn:dm:schemas:common.json#/nullableReference"
                    },
                    "isPreset": {
                      "type": "boolean"
                    }
                  },
                  "unevaluatedProperties": false
                }
              },
              "unevaluatedProperties": false
            },
            "isLandingPage": {
              "type": "boolean",
              "default": false
            },
            "isMobileLandingPage": {
              "type": "boolean",
              "default": false
            },
            "isPopup": {
              "type": "boolean",
              "default": false
            },
            "translationData": {
              "type": "object",
              "properties": {
                "uriSEOTranslated": {
                  "type": "boolean",
                  "default": false
                }
              },
              "unevaluatedProperties": false
            },
            "ogImage": {
              "type": [
                "string",
                "null"
              ]
            },
            "ogImageRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "ignoreBottomBottomAnchors": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "cacheMode": {
              "enum": [
                "auto",
                "manual",
                "disabled"
              ]
            },
            "cacheMaxAgeHours": {
              "type": [
                "number",
                "null"
              ],
              "multipleOf": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "Text--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 4000
            }
          }
        }
      ],
      "type": "object"
    },
    "RichText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000,
              "default": ""
            },
            "defaultStyle": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "RichTextImage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "image": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BaseInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "formGroup": {
              "type": "string",
              "description": "form group that this component belongs to",
              "maxLength": 4000
            }
          }
        }
      ],
      "type": "object"
    },
    "BaseTextInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "value": {
                  "type": "string",
                  "default": "",
                  "maxLength": 4000
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "TextInputA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "invalid": {
              "type": "boolean"
            },
            "multiline": {
              "type": "boolean"
            },
            "autocomplete": {
              "type": "boolean"
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "atomic": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "textType": {
                  "type": "string",
                  "default": "text",
                  "enum": [
                    "text",
                    "email",
                    "url",
                    "number",
                    "tel",
                    "password"
                  ],
                  "description": "input data type"
                },
                "maxLength": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "min": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "minimum": -2147483648,
                  "maximum": 2147483647,
                  "description": "minimum allowed value for a numeric type field"
                },
                "max": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "minimum": -2147483648,
                  "maximum": 2147483647,
                  "description": "maximum allowed value for a numeric type field"
                },
                "pattern": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "specifies a regular expression against which the control's value will be validate",
                  "maxLength": 500
                },
                "phoneFormat": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "specifies a phone number format against which the control's value will be validated",
                  "pattern": "^#*(((#+-)*)#+$)",
                  "maxLength": 100
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected"
                },
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                },
                "prefix": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "maxLength": 10
                },
                "step": {
                  "type": "number"
                },
                "autoComplete": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "maxLength": 400
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ],
          "not": {
            "required": [
              "pattern",
              "phoneFormat"
            ]
          }
        }
      ],
      "type": "object"
    },
    "TextAreaInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "maxLength": {
                  "type": [
                    "number"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "label": {
                  "type": [
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string"
                  ],
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "CheckboxInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "checked": {
                  "$ref": "urn:dm:schemas:common.json#/JavaBool",
                  "description": "The checked status of the input"
                },
                "linkLabel": {
                  "type": "string",
                  "default": "",
                  "maxLength": 1000
                },
                "link": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
                },
                "label": {
                  "type": "string",
                  "default": "",
                  "maxLength": 4000
                },
                "indeterminate": {
                  "$ref": "urn:dm:schemas:common.json#/JavaBool",
                  "description": "Used for three state check box"
                },
                "direction": {
                  "$ref": "#/Direction",
                  "description": "direction of the component"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "DateItem--unrestricted-root": {
      "type": "string",
      "format": "date-time"
    },
    "DateString--unrestricted-root": {
      "type": "string",
      "format": "date"
    },
    "DateRange--unrestricted-root": {
      "type": "object",
      "required": [
        "startDate",
        "endDate"
      ],
      "properties": {
        "startDate": {
          "$ref": "#/DateString"
        },
        "endDate": {
          "$ref": "#/DateString"
        }
      }
    },
    "DateRanges--unrestricted-root": {
      "type": "array",
      "default": [],
      "items": {
        "$ref": "#/DateRange"
      }
    },
    "DatePicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "disabledDates": {
                  "type": "array",
                  "items": {
                    "$ref": "#/DateItem"
                  },
                  "default": [],
                  "description": "array of disabled dates"
                },
                "disabledDaysOfWeek": {
                  "type": "array",
                  "items": {
                    "type": [
                      "number"
                    ],
                    "enum": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6
                    ]
                  },
                  "default": [],
                  "description": "array of disabled days"
                },
                "minDate": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "#/DateItem--unrestricted-root"
                    }
                  ],
                  "description": "date input minimum date value"
                },
                "maxDate": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "#/DateItem--unrestricted-root"
                    }
                  ],
                  "description": "date input maximum date value"
                },
                "allowPastDates": {
                  "type": "boolean",
                  "default": true,
                  "description": "if true all past days are enabled, false otherwise"
                },
                "allowFutureDates": {
                  "type": "boolean",
                  "default": true,
                  "description": "if true all future days are enabled, false otherwise"
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "maxLength": 200,
                  "description": "the placeholder option in case nothing is selected"
                },
                "enabledDateRanges": {
                  "$ref": "#/DateRanges",
                  "description": "array of enabled dates. each date in the format YYYY/MM/DD"
                },
                "disabledDateRanges": {
                  "$ref": "#/DateRanges",
                  "description": "array of disabled dates. each date in the format YYYY/MM/DD"
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "Theme--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "properties": {
              "type": [
                "object",
                "null"
              ],
              "additionalProperties": true,
              "default": {}
            }
          }
        }
      ],
      "type": "object"
    },
    "TwitterFollow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "accountToFollow": {
              "type": "string",
              "default": "wix"
            }
          }
        }
      ],
      "type": "object"
    },
    "TwitterTweet--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "defaultText": {
              "type": "string"
            },
            "accountToFollow": {
              "type": "string"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "MobileMetaData--unrestricted-root": {
      "type": "object",
      "required": [
        "adaptiveMobileOn"
      ],
      "properties": {
        "adaptiveMobileOn": {
          "type": "boolean",
          "default": true
        }
      }
    },
    "Preloader--unrestricted-root": {
      "type": "object",
      "required": [
        "enabled",
        "uri"
      ],
      "properties": {
        "enabled": {
          "type": "boolean",
          "default": false
        },
        "uri": {
          "type": "string",
          "default": ""
        }
      }
    },
    "ContactInfo--unrestricted-root": {
      "type": "object",
      "required": [
        "companyName",
        "phone",
        "email",
        "address",
        "fax"
      ],
      "properties": {
        "companyName": {
          "type": "string",
          "default": ""
        },
        "phone": {
          "type": "string",
          "default": ""
        },
        "email": {
          "type": "string",
          "default": ""
        },
        "address": {
          "type": "string",
          "default": ""
        },
        "fax": {
          "type": "string",
          "default": ""
        }
      }
    },
    "SocialLink--unrestricted-root": {
      "type": "object",
      "required": [
        "id",
        "url"
      ],
      "properties": {
        "id": {
          "type": "string",
          "enum": [
            "facebook",
            "twitter",
            "pinterest",
            "google_plus",
            "tumblr",
            "blogger",
            "linkedin",
            "youtube",
            "vimeo",
            "flickr"
          ]
        },
        "url": {
          "type": "string",
          "default": ""
        }
      }
    },
    "QuickActions--unrestricted-root": {
      "type": "object",
      "required": [
        "colorScheme",
        "configuration",
        "socialLinks"
      ],
      "properties": {
        "colorScheme": {
          "type": "string",
          "enum": [
            "dark",
            "light"
          ],
          "default": "dark"
        },
        "configuration": {
          "type": "object",
          "default": {
            "addressEnabled": false,
            "emailEnabled": false,
            "navigationMenuEnabled": true,
            "phoneEnabled": false,
            "quickActionsMenuEnabled": false,
            "socialLinksEnabled": false
          },
          "properties": {
            "addressEnabled": {
              "type": "boolean",
              "default": false
            },
            "emailEnabled": {
              "type": "boolean",
              "default": false
            },
            "navigationMenuEnabled": {
              "type": "boolean",
              "default": true
            },
            "phoneEnabled": {
              "type": "boolean",
              "default": false
            },
            "quickActionsMenuEnabled": {
              "type": "boolean",
              "default": false
            },
            "socialLinksEnabled": {
              "type": "boolean",
              "default": false
            }
          },
          "unevaluatedProperties": false
        },
        "socialLinks": {
          "type": "array",
          "items": {
            "$ref": "#/SocialLink"
          },
          "default": []
        }
      }
    },
    "QuickActionBarItem--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "itemType"
          ],
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "itemType": {
              "maxLength": 50,
              "type": "string"
            },
            "text": {
              "maxLength": 40,
              "type": "string",
              "default": ""
            },
            "icon": {
              "maxLength": 200,
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "SiteSettings--unrestricted-root": {
      "type": "object",
      "properties": {
        "siteName": {
          "type": "string",
          "default": ""
        },
        "siteTitleSEO": {
          "type": "string",
          "default": ""
        },
        "siteDescriptionSEO": {
          "type": "string",
          "default": ""
        },
        "keywordsSEO": {
          "type": "string",
          "default": ""
        },
        "allowSEFindSite": {
          "type": "boolean",
          "default": false
        },
        "favicon": {
          "type": "string",
          "default": ""
        },
        "thumbnail": {
          "type": "string",
          "default": ""
        },
        "googleAnalyticsID": {
          "type": "string",
          "default": ""
        },
        "fbAdminsUserId": {
          "type": "string",
          "default": ""
        },
        "suppressTrackingCookies": {
          "type": "boolean",
          "default": false
        }
      }
    },
    "AdvancedSeoSettingsDialog--unrestricted-root": {
      "type": "object",
      "properties": {
        "userMetaTags": {
          "type": "string",
          "default": ""
        }
      }
    },
    "Anchor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "compId": {
              "type": "string"
            },
            "urlFragment": {
              "type": "string",
              "maxLength": 60
            }
          }
        }
      ],
      "type": "object"
    },
    "BasicMenuItem--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "slot": {
              "type": "string"
            },
            "label": {
              "type": "string"
            },
            "isVisible": {
              "type": "boolean",
              "default": true
            },
            "isVisibleMobile": {
              "type": "boolean",
              "default": true
            },
            "displayCount": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "iconRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "CustomMenu--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "menuType": {
              "type": "string",
              "maxLength": 100
            },
            "syncWithPages": {
              "type": "boolean",
              "default": false
            },
            "appId": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "CustomMenusCollection--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menus": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "CustomMenuDataRef--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menuRef": {
              "default": "#CUSTOM_MAIN_MENU",
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "itemDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 1st (top) level menu items"
            },
            "submenuDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 2nd level menu item (submenu)"
            },
            "submenuSubItemDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 3rd level menu item (submenuSubItem)"
            }
          }
        }
      ],
      "type": "object"
    },
    "CustomMenuDataRefA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "Menu--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "FacebookLikeBox--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "facebookPageId": {
              "type": "string",
              "default": "wix",
              "description": "Facebook page id"
            },
            "showFaces": {
              "type": "boolean",
              "default": true,
              "description": "Show profile photos in the plugin"
            },
            "colorScheme": {
              "type": "string",
              "default": "light",
              "enum": [
                "light",
                "dark"
              ],
              "description": "The color scheme of the plugin. Note that the background is always transparent to match your background color. This setting changes the foreground colors to work well on light or dark backgrounds."
            },
            "showStream": {
              "type": "boolean",
              "default": true,
              "description": "Show the profile stream for the public profile"
            },
            "showBorder": {
              "type": "boolean",
              "default": true,
              "description": "Show a border around the plugin"
            },
            "showHeader": {
              "type": "boolean",
              "default": true,
              "description": "Show the 'Find us on Facebook' bar at top. Only shown when either stream or faces are present"
            }
          }
        }
      ],
      "type": "object"
    },
    "ImageButtonA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "ImageButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "alt": {
              "type": "string"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "defaultImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "hoverImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "activeImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "NumericStepper--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "1"
            }
          }
        }
      ],
      "type": "object"
    },
    "PinItPinWidget--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pinId": {
              "type": "string",
              "default": "http://www.pinterest.com/pin/204421270560540859/"
            }
          }
        }
      ],
      "type": "object"
    },
    "PinterestPinIt--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "description": {
              "type": "string",
              "default": "Check it out!"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "SingleAudioPlayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": "",
              "description": "MP3 uri"
            },
            "originalFileName": {
              "type": "string",
              "default": "",
              "description": "Original MP3 file name"
            },
            "artist": {
              "type": "string",
              "default": "Unknown Artist",
              "description": "Artist Name"
            },
            "track": {
              "type": "string",
              "default": "Unknown Track",
              "description": "Track Name"
            }
          }
        }
      ],
      "type": "object"
    },
    "SkypeCallButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "skypeName": {
              "type": "string"
            },
            "buttonType": {
              "type": "string",
              "enum": [
                "call",
                "chat"
              ],
              "default": "call"
            }
          }
        }
      ],
      "type": "object"
    },
    "SpotifyFollow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "SpotifyPlayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": "",
              "description": "Spotify URI"
            }
          }
        }
      ],
      "type": "object"
    },
    "SubscribeForm--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "firstNameFieldLabel": {
              "type": "string",
              "default": "First Name"
            },
            "lastNameFieldLabel": {
              "type": "string",
              "default": "Last Name"
            },
            "emailFieldLabel": {
              "type": "string",
              "default": "Email"
            },
            "phoneFieldLabel": {
              "type": "string",
              "default": "Mobile number"
            },
            "subscribeFormTitle": {
              "type": "string",
              "default": "Subscribe for Updates"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Subscribe Now"
            },
            "successMessage": {
              "type": "string",
              "default": "Congrats! You’re subscribed"
            },
            "errorMessage": {
              "type": "string",
              "default": "Forgot your email? Try again."
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "To subscribe please fill in all the required info"
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "YouTubeSubscribeButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "youtubeChannelId": {
              "type": "string",
              "default": "wix",
              "description": "youtube channel id"
            }
          }
        }
      ],
      "type": "object"
    },
    "AudioPlayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "autoPlay": {
              "type": "boolean",
              "default": false
            },
            "loop": {
              "type": "boolean",
              "default": false
            },
            "visible": {
              "type": "boolean",
              "default": true
            },
            "volume": {
              "type": "number",
              "default": 100
            },
            "title": {
              "type": "string",
              "default": ""
            },
            "description": {
              "type": "string",
              "default": ""
            },
            "icon_uri": {
              "type": "string",
              "default": ""
            },
            "originalFileName": {
              "type": "string",
              "default": ""
            },
            "showToolTip": {
              "$ref": "urn:dm:schemas:common.json#/JavaBool"
            }
          }
        }
      ],
      "type": "object"
    },
    "Boolean--unrestricted-root": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        }
      }
    },
    "CheckBox--unrestricted-root": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        },
        "indeterminate": {
          "type": "boolean",
          "default": false,
          "description": "Used for three state check box"
        }
      }
    },
    "Grid--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "dataSource": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "static",
                    "dynamic"
                  ]
                },
                "revision": {
                  "type": "number",
                  "multipleOf": 1
                }
              },
              "unevaluatedProperties": false
            },
            "rows": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": true,
                "unevaluatedProperties": false
              }
            },
            "rowsCount": {
              "type": "number"
            },
            "revision": {
              "type": "number"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "ContactForm--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "nameFieldLabel": {
              "type": "string",
              "default": "Name"
            },
            "emailFieldLabel": {
              "type": "string",
              "default": "Email"
            },
            "phoneFieldLabel": {
              "type": "string",
              "default": "Phone"
            },
            "addressFieldLabel": {
              "type": "string",
              "default": "Address"
            },
            "subjectFieldLabel": {
              "type": "string",
              "default": "Subject"
            },
            "messageFieldLabel": {
              "type": "string",
              "default": "Message"
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Send"
            },
            "successMessage": {
              "type": "string",
              "default": "Your details were sent successfully!"
            },
            "errorMessage": {
              "type": "string",
              "default": "Please provide a valid email"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "Please fill in all required fields."
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "DynamicContactForm--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Send"
            },
            "successMessage": {
              "type": "string",
              "default": "Your details were sent successfully!"
            },
            "errorMessage": {
              "type": "string",
              "default": "Please provide a valid email"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "Please fill in all required fields."
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "formName": {
              "type": "string",
              "default": ""
            },
            "dynamicFields": {
              "type": "array",
              "default": [
                {
                  "name": "email",
                  "inputType": "email",
                  "displayLabel": "Email",
                  "required": true
                },
                {
                  "name": "name",
                  "inputType": "text",
                  "displayLabel": "Name",
                  "required": true
                },
                {
                  "name": "subject",
                  "inputType": "text",
                  "displayLabel": "Subject",
                  "required": false
                },
                {
                  "name": "message",
                  "inputType": "text",
                  "displayLabel": "Message",
                  "required": false
                }
              ],
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string",
                    "maxLength": 50
                  },
                  "inputType": {
                    "type": "string",
                    "maxLength": 50
                  },
                  "displayLabel": {
                    "type": "string",
                    "maxLength": 200
                  },
                  "required": {
                    "$ref": "urn:dm:schemas:common.json#/JavaBool"
                  },
                  "displayed": {
                    "$ref": "urn:dm:schemas:common.json#/JavaBool"
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "type": "object"
    },
    "EbayItemsBySeller--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "sellerId": {
              "type": "string"
            },
            "registrationSite": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "FacebookShareButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "urlChoice": {
              "type": "string",
              "enum": [
                "Current page",
                "Site"
              ],
              "default": "Current page",
              "description": "Share: current/site url"
            },
            "label": {
              "type": "string",
              "default": "Share",
              "description": ""
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "FlashComponent--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string"
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            },
            "title": {
              "type": "string",
              "maxLength": 100
            },
            "uri": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 1000
            },
            "height": {
              "type": "number",
              "default": 0
            },
            "width": {
              "type": "number",
              "default": 0
            },
            "placeHolderImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "FlickrBadgeWidget--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "userId": {
              "type": "string",
              "default": "74009459@N07"
            },
            "userName": {
              "type": "string"
            },
            "tag": {
              "type": "string"
            },
            "imageCount": {
              "type": [
                "string",
                "number"
              ],
              "default": 3
            },
            "whichImages": {
              "type": "string",
              "default": "latest"
            },
            "imageSize": {
              "type": "string",
              "default": "t"
            },
            "layoutOrientation": {
              "type": "string",
              "default": "v"
            }
          }
        }
      ],
      "type": "object"
    },
    "GeoMapLocation--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "address": {
              "type": "string",
              "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158",
              "maxLength": 1000
            },
            "latitude": {
              "type": "number",
              "default": 37.77065
            },
            "longitude": {
              "type": "number",
              "default": -122.387301
            },
            "title": {
              "type": "string",
              "default": "Wix Office",
              "maxLength": 10000
            },
            "description": {
              "type": "string",
              "default": "Wix HQ",
              "maxLength": 350
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "linkTitle": {
              "type": "string",
              "default": "Visit Wix's Site",
              "maxLength": 140
            },
            "pinIcon": {
              "type": "string",
              "default": "https://static.parastorage.com/services/santa-resources/resources/editor/designPanel/panelTypes/default_pin_icon.png",
              "maxLength": 1000
            },
            "pinColor": {
              "type": "string",
              "default": "#2A3688",
              "maxLength": 20
            }
          }
        }
      ],
      "type": "object"
    },
    "GeoMap--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "language": {
              "type": "string",
              "enum": [
                "af",
                "sq",
                "am",
                "ar",
                "hy",
                "az",
                "eu",
                "be",
                "bn",
                "bs",
                "bg",
                "my",
                "ca",
                "zh",
                "zh-CN",
                "zh-HK",
                "zh-TW",
                "hr",
                "cs",
                "da",
                "nl",
                "en",
                "en-AU",
                "en-GB",
                "et",
                "fa",
                "fi",
                "fil",
                "fr",
                "fr-CA",
                "gl",
                "ka",
                "de",
                "el",
                "gu",
                "iw",
                "hi",
                "hu",
                "is",
                "id",
                "it",
                "ja",
                "kn",
                "kk",
                "km",
                "ko",
                "ky",
                "lo",
                "lv",
                "lt",
                "mk",
                "ms",
                "ml",
                "mr",
                "mn",
                "ne",
                "no",
                "pl",
                "pt",
                "pt-BR",
                "pt-PT",
                "pa",
                "ro",
                "ru",
                "sr",
                "si",
                "sk",
                "sl",
                "es",
                "es-419",
                "sw",
                "sv",
                "ta",
                "te",
                "th",
                "tr",
                "uk",
                "ur",
                "uz",
                "vi",
                "zu"
              ]
            },
            "locations": {
              "minItems": 0,
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "address": {
              "type": "string",
              "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158"
            },
            "latitude": {
              "type": "number",
              "default": 37.77065
            },
            "longitude": {
              "type": "number",
              "default": -122.387301
            },
            "addressInfo": {
              "type": "string",
              "default": "Wix Office"
            },
            "defaultLocation": {
              "type": "number",
              "default": 0
            },
            "mapStyle": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "stylers"
                ],
                "properties": {
                  "elementType": {
                    "type": "string",
                    "enum": [
                      "all",
                      "geometry",
                      "geometry.fill",
                      "geometry.stroke",
                      "labels",
                      "labels.icon",
                      "labels.text",
                      "labels.text.fill",
                      "labels.text.stroke"
                    ],
                    "description": "Selects the element type to which a styler should be applied. An element type distinguishes between the different representations of a feature."
                  },
                  "featureType": {
                    "type": "string",
                    "enum": [
                      "administrative",
                      "administrative.country",
                      "administrative.land_parcel",
                      "administrative.locality",
                      "administrative.neighborhood",
                      "administrative.province",
                      "all",
                      "landscape",
                      "landscape.man_made",
                      "landscape.natural",
                      "landscape.natural.landcover",
                      "landscape.natural.terrain",
                      "poi",
                      "poi.attraction",
                      "poi.business",
                      "poi.government",
                      "poi.medical",
                      "poi.park",
                      "poi.place_of_worship",
                      "poi.school",
                      "poi.sports_complex",
                      "road",
                      "road.arterial",
                      "road.highway",
                      "road.highway.controlled_access",
                      "road.local",
                      "transit",
                      "transit.line",
                      "transit.station",
                      "transit.station.airport",
                      "transit.station.bus",
                      "transit.station.rail",
                      "water"
                    ],
                    "description": "Selects the feature, or group of features, to which a styler should be applied."
                  },
                  "stylers": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "maxProperties": 1,
                      "additionalProperties": false,
                      "description": "The style rules to apply to the selectors. The rules are applied to the map's elements in the order they are listed in this array.",
                      "properties": {
                        "color": {
                          "type": "string",
                          "maxLength": 100,
                          "description": "Sets the color of the feature. Valid values: An RGB hex string, i.e. '#ff0000'."
                        },
                        "gamma": {
                          "type": "number",
                          "description": "Modifies the gamma by raising the lightness to the given power.Valid values: Floating point numbers, [0.01, 10], with 1.0 representing no change."
                        },
                        "hue": {
                          "type": "string",
                          "maxLength": 100,
                          "description": "Sets the hue of the feature to match the hue of the color supplied. Note that the saturation and lightness of the feature is conserved, which means that the feature will not match the color supplied exactly. Valid values: An RGB hex string, i.e. '#ff0000'."
                        },
                        "invert_lightness": {
                          "type": "boolean",
                          "description": "A value of true will invert the lightness of the feature while preserving the hue and saturation."
                        },
                        "lightness": {
                          "type": "number",
                          "description": "Shifts lightness of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                        },
                        "saturation": {
                          "type": "number",
                          "description": "Shifts the saturation of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                        },
                        "visibility": {
                          "type": "string",
                          "enum": [
                            "on",
                            "off",
                            "simplified"
                          ],
                          "description": "Sets the visibility of the feature. Valid values: 'on', 'off' or 'simplified'."
                        },
                        "weight": {
                          "type": "number",
                          "description": "Sets the weight of the feature, in pixels. Valid values: Integers greater than or equal to zero."
                        }
                      },
                      "unevaluatedProperties": false
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "type": "object"
    },
    "HtmlComponent--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "sourceType": {
              "type": "string",
              "default": ""
            },
            "url": {
              "type": "string",
              "default": ""
            },
            "title": {
              "type": "string"
            },
            "freezeFrame": {
              "type": "boolean",
              "default": false
            },
            "allowFullScreen": {
              "type": "boolean",
              "default": false
            },
            "componentConsentPolicy": {
              "type": "string",
              "default": "essential",
              "enum": [
                "essential",
                "functional",
                "analytics",
                "advertising",
                "dataToThirdParty"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "DisqusComments--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "disqusId": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "ItunesButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "downloadUrl": {
              "type": "string",
              "default": "",
              "description": "Insert band URL"
            }
          }
        }
      ],
      "type": "object"
    },
    "LinkableFlashComponent--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "title": {
              "type": "string"
            },
            "uri": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "height": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "placeHolderImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LinkableButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LoginButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "language": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "TinyMenu--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "loginSocialBarRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "menuRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LoginSocialBar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menuItemsRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "iconItemsRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "language": {
              "type": "string",
              "default": "en",
              "maxLength": 10
            },
            "loggedInMember": {
              "type": "string",
              "enum": [
                "avatarOnly",
                "textOnly",
                "avatarAndText",
                "memberInitials"
              ],
              "default": "avatarAndText"
            },
            "loggedOutMember": {
              "type": "string",
              "enum": [
                "avatarOnly",
                "textOnly",
                "avatarAndText"
              ]
            },
            "loggedInAvatarIcon": {
              "type": "string",
              "enum": [
                "profileImage",
                "initials",
                "custom"
              ]
            },
            "loggedOutAvatarIcon": {
              "type": "string",
              "enum": [
                "profileImage",
                "initials",
                "custom"
              ],
              "default": "profileImage"
            },
            "loggedInCustomAvatar": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "loggedOutCustomAvatar": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "loggedOutText": {
              "type": "string",
              "default": "Log In",
              "maxLength": 50
            },
            "showLoggedInText": {
              "type": "boolean",
              "default": true
            },
            "loggedInTextState": {
              "type": "string",
              "enum": [
                "memberName",
                "custom"
              ]
            },
            "loggedInText": {
              "type": "string",
              "default": "Hello",
              "maxLength": 50
            },
            "customLoggedInText": {
              "type": "string",
              "maxLength": 50
            },
            "logOutText": {
              "type": "string",
              "default": "Log Out",
              "maxLength": 50
            }
          }
        }
      ],
      "type": "object"
    },
    "PagesGroupData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appId": {
              "type": [
                "number",
                "null"
              ]
            },
            "appDefinitionId": {
              "type": "string"
            },
            "groupName": {
              "type": "string"
            },
            "pages": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            }
          }
        }
      ],
      "type": "object"
    },
    "PagesGroupCollection--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "groups": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "PayPalButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "merchantID": {
              "type": "string",
              "default": "",
              "description": "some amazing description"
            }
          }
        }
      ],
      "type": "object"
    },
    "PermaLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "appType"
          ],
          "properties": {
            "appType": {
              "enum": [
                "ListsApps",
                "ThirdPartyApps"
              ]
            },
            "dataItemRef": {
              "default": "",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mutableSeoTitle": {
              "type": "string"
            },
            "correctPermaLinkRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "PinterestFollow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "urlChoice": {
              "type": "string",
              "default": "pinterest/",
              "description": ""
            },
            "label": {
              "type": "string",
              "default": "Pinterest",
              "description": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "SelectableList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "$ref": "#/Direction",
                  "description": "direction of the component"
                },
                "labelDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the label"
                },
                "inputDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the input"
                },
                "dropdownDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the dropdown"
                },
                "errorDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the error"
                },
                "options": {
                  "description": "a list of SelectOption data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": "object",
                  "properties": {
                    "value": {
                      "type": "string",
                      "default": "-1",
                      "description": "the value of the placeholder option",
                      "maxLength": 400
                    },
                    "text": {
                      "type": "string",
                      "default": "",
                      "description": "the text of the placeholder option",
                      "maxLength": 400
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SelectOption--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "text": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "selectedText": {
              "type": "string",
              "maxLength": 400
            },
            "disabled": {
              "type": "boolean"
            },
            "description": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "RadioButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "label": {
                  "type": "string",
                  "default": "",
                  "maxLength": 400
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RadioGroup--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "optionsDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "defaultValue": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "options": {
                  "description": "a list of RadioButton data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": "object",
                  "properties": {
                    "value": {
                      "type": "string",
                      "default": "-1",
                      "description": "the value of the placeholder option",
                      "maxLength": 400
                    },
                    "text": {
                      "type": "string",
                      "default": "",
                      "description": "the text of the placeholder option",
                      "maxLength": 400
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "CheckboxGroup--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "optionsDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "options": {
                  "description": "a list of CheckboxInput data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 4000
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "FileUploader--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "buttonLabel": {
              "type": "string",
              "default": "Upload File",
              "maxLength": 500
            },
            "placeholderLabel": {
              "type": "string",
              "default": "Max File Size 15MG",
              "maxLength": 500
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "maxLength": 400
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonLabelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "filesDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "iconPosition": {
              "type": [
                "string"
              ],
              "enum": [
                "row",
                "rowReverse",
                "column",
                "columnReverse"
              ],
              "description": "Flex direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "UploadName--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "SiteButtonA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pressed": {
              "type": "boolean"
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "haspopup": {
              "type": "string",
              "enum": [
                "true",
                "false",
                "menu",
                "dialog",
                "listbox",
                "tree",
                "grid"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "disabled": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "SiteButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON"
            }
          }
        }
      ],
      "type": "object"
    },
    "SoundCloudWidget--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string",
              "default": ""
            },
            "showArtWork": {
              "type": "boolean",
              "default": true
            },
            "autoPlay": {
              "type": "boolean",
              "default": false
            },
            "embedSource": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "StyledTextA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "StyledText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000,
              "default": "<p class='font_7'></p>",
              "not": {
                "pattern": "<script"
              }
            },
            "stylesMapId": {
              "type": "string"
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "StyledTextLinkHelper--unrestricted-root": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
        }
      }
    },
    "SvgShape--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "alt": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "VectorImage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            },
            "alt": {
              "type": "string",
              "description": "Alternative text for the vector image (for accessibility purposes).",
              "default": ""
            },
            "decorative": {
              "type": "boolean"
            },
            "title": {
              "type": "string",
              "maxLength": 100,
              "description": "Title or caption for the vector image."
            },
            "svgId": {
              "type": "string",
              "maxLength": 100,
              "description": "Identifier for the SVG image."
            }
          }
        }
      ],
      "type": "object"
    },
    "Video--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "videoId": {
              "type": "string"
            },
            "userId": {
              "type": "string"
            },
            "posterImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "videoType": {
              "type": "string",
              "enum": [
                "YOUTUBE",
                "VIMEO",
                "FACEBOOK",
                "DAILYMOTION"
              ],
              "default": "YOUTUBE"
            }
          }
        }
      ],
      "type": "object"
    },
    "VKShareButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "style": {
              "type": "string",
              "enum": [
                "Button",
                "ButtonWithoutCounter",
                "Link",
                "LinkWithoutIcon",
                "Icon"
              ],
              "default": "Button",
              "description": "the layout of the button"
            },
            "text": {
              "type": "string",
              "default": "Share",
              "description": "the text of the Button"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "ButtonWithIcon--unrestricted-root": {
      "type": "object",
      "properties": {
        "label": {
          "type": "string",
          "format": "resourceKey"
        },
        "toggleMode": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        },
        "iconSrc": {
          "type": "string"
        },
        "iconSize": {
          "type": "object",
          "additionalProperties": true,
          "unevaluatedProperties": false
        },
        "spriteOffset": {
          "type": "object",
          "additionalProperties": true,
          "unevaluatedProperties": false
        },
        "command": {
          "type": "string"
        },
        "commandParameter": {
          "type": "string"
        },
        "action": {
          "type": "string"
        }
      }
    },
    "EditorPreferences--unrestricted-root": {
      "type": "object",
      "properties": {
        "dontShowAgainTooltips": {
          "type": [
            "null",
            "array"
          ]
        },
        "dontShowAgainDialogs": {
          "type": [
            "null",
            "array"
          ]
        }
      }
    },
    "TPAWidget--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "some amazing description"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TPAData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "content": {
              "type": "string",
              "default": "",
              "description": "storage for app data",
              "maxLength": 4000
            }
          }
        }
      ],
      "type": "object"
    },
    "TPAGlobalData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "content": {
              "type": "string",
              "default": "",
              "description": "storage for app data"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Definition ID"
            }
          }
        }
      ],
      "type": "object"
    },
    "TPA--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "referenceId": {
              "type": "string"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "widget id"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TPASection--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TPAMultiSection--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "hidden tpaSection part of multi section app"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "RssButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "image": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "type": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "AppPart--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appInnerID": {
              "type": [
                "string",
                "number"
              ]
            },
            "appLogicParams": {
              "type": "object",
              "default": {},
              "additionalProperties": true,
              "unevaluatedProperties": false
            },
            "appLogicCustomizations": {
              "type": "array",
              "items": {
                "$ref": "#/AppPartCustomization"
              },
              "default": []
            },
            "appPartName": {
              "type": "string"
            },
            "viewName": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "AppPartCustomization--unrestricted-root": {
      "type": "object",
      "properties": {
        "fieldId": {
          "type": "string"
        },
        "forType": {
          "type": "string"
        },
        "format": {
          "type": "string"
        },
        "key": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "view": {
          "type": "string"
        },
        "mode": {
          "type": [
            "string",
            "null"
          ]
        },
        "value": {
          "type": [
            "string",
            "null"
          ]
        }
      }
    },
    "AppPage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "appPageId": {
                  "type": "string",
                  "default": ""
                },
                "appInnerID": {
                  "type": [
                    "string",
                    "number"
                  ],
                  "default": ""
                },
                "appPageType": {
                  "type": "string"
                },
                "repeaterPage": {
                  "type": "boolean",
                  "default": false
                }
              }
            },
            {
              "$ref": "#/Page--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "AppBuilderComponent--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appInnerID": {
              "type": [
                "string",
                "null"
              ]
            },
            "appPartName": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "BoxSlideShow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "type": "object"
    },
    "BoxSlideShowSlide--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "StripContainerSlideShow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "type": "object"
    },
    "StripContainerSlideShowSlide--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "VerticalAnchorsMenu--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pageTopLabel": {
              "type": [
                "null",
                "string"
              ],
              "default": "Page Top"
            },
            "pageBottomLabel": {
              "type": [
                "null",
                "string"
              ],
              "default": "Page Bottom"
            },
            "hiddenAnchorIds": {
              "type": [
                "null",
                "object"
              ],
              "default": {}
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "bulletPosition": {
              "type": [
                "string"
              ],
              "enum": [
                "row",
                "rowReverse",
                "column",
                "columnReverse"
              ],
              "description": "Flex direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "WFacebookComment--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "WFacebookLike--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "AppController--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "applicationId",
            "controllerType"
          ],
          "properties": {
            "applicationId": {
              "type": "string",
              "maxLength": 100
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "default": ""
            },
            "controllerType": {
              "type": "string",
              "maxLength": 100
            },
            "settings": {
              "type": "string",
              "maxLength": 6000
            },
            "externalId": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "RepeaterA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "none",
                "radiogroup",
                "list",
                "group"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "Repeater--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "items": {
              "type": "array",
              "default": [],
              "items": {
                "type": "string"
              },
              "description": "Unique identifiers for items of the repeater"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "RepeatedData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "description": "data used for the serialization of a component inside a repeater component",
          "properties": {
            "original": {
              "type": "object",
              "additionalProperties": true,
              "description": "the original data item of a component inside a repeater according to the specific component schema",
              "unevaluatedProperties": false
            },
            "overrides": {
              "type": "object",
              "additionalProperties": true,
              "description": "a map from itemId in a repeater to its data item according to the specific component schema",
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "ImageButtonWithText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 100
            },
            "icon": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "predefinedClass": {
              "type": "string",
              "maxLength": 20
            }
          }
        }
      ],
      "type": "object"
    },
    "Icon--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string"
            },
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "title": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "WidgetRef--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appDefinitionId": {
              "type": "string"
            },
            "widgetId": {
              "type": "string"
            },
            "variationId": {
              "type": [
                "string",
                "null"
              ]
            },
            "name": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "InternalRef--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            },
            "pageId": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "InternalBlocksRef--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "type": "string"
            },
            "pageId": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "ForwardRef--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LightboxA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "LightboxContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "ContainerA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "none",
                "status",
                "alert",
                "nav",
                "list",
                "listitem",
                "tablist",
                "tab",
                "tabpanel",
                "menubar",
                "presentation",
                "heading"
              ]
            },
            "roledescription": {
              "type": "string",
              "maxLength": 100
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ],
              "maxLength": 10
            },
            "hidden": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string",
              "enum": [
                "all",
                "additions",
                "text",
                "removals"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "ContainerData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "MediaBoxData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "SlotsPlaceholderData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "interfaces"
          ],
          "properties": {
            "interfaces": {
              "type": "array",
              "items": {
                "type": "string"
              },
              "maxItems": 20
            }
          }
        }
      ],
      "type": "object"
    },
    "LinkType--unrestricted-root": {
      "type": "string",
      "enum": [
        "SMS",
        "CALL",
        "SKYPE",
        "MAP",
        "EMAIL",
        "FACEBOOK",
        "FLICKR",
        "BLOGGER",
        "MYSPACE",
        "LINKEDIN",
        "TWITTER",
        "TUMBLR",
        "YOUTUBE",
        "VIMEO",
        "PAGE",
        "FREE_LINK",
        "TEXT",
        "DELICIOUS",
        "WEBSITE",
        "DOCUMENT",
        "ADMIN_LOGIN",
        "LOGIN"
      ],
      "default": "FREE_LINK"
    },
    "UrlFormat--unrestricted-root": {
      "type": "string",
      "enum": [
        "hashBang",
        "slash"
      ],
      "default": "slash"
    },
    "MultiStateBoxDataA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "MultiStateBoxData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "defaultStateId": {
                  "default": "FIRST_STATE",
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "selectedStateId": {
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "AppsInstallState--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "stateMap": {
              "type": "object",
              "default": {},
              "additionalProperties": {
                "type": "object",
                "required": [
                  "status"
                ],
                "properties": {
                  "status": {
                    "type": "string",
                    "enum": [
                      "INSTALLED",
                      "REMOVED"
                    ],
                    "default": "INSTALLED"
                  },
                  "version": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 20
                  },
                  "codeReferenceId": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 40
                  },
                  "overrideCodeReferenceId": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 40
                  }
                }
              },
              "properties": {},
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "StateBoxA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "StateBox--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "StateBoxStateA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "StateBoxState--unrestricted-root": {
      "type": "object",
      "properties": {
        "a11y": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        }
      }
    },
    "Builder.MenuItem--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "container": {
              "type": "string"
            },
            "label": {
              "type": "string"
            },
            "isVisible": {
              "type": "boolean",
              "default": true
            }
          }
        }
      ],
      "type": "object"
    },
    "Builder.MenuItems--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "Builder.Image--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string",
              "maxLength": 1000,
              "description": "Identifier or URL for the image."
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "description": "Human-readable filename to use for the image."
            },
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "alt": {
              "type": "string",
              "maxLength": 1000
            },
            "crop": {
              "type": "object",
              "required": [
                "width",
                "height",
                "x",
                "y"
              ],
              "properties": {
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "Builder.Video--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "description": "Unique identifier for the video media",
              "maxLength": 1000
            },
            "sources": {
              "type": "array",
              "description": "Available video sources in different qualities",
              "items": {
                "type": "object",
                "required": [
                  "quality",
                  "width",
                  "height",
                  "types"
                ],
                "properties": {
                  "quality": {
                    "type": "string",
                    "enum": [
                      "1080p",
                      "720p",
                      "480p",
                      "360p"
                    ],
                    "description": "Quality level of the video source"
                  },
                  "width": {
                    "type": "number",
                    "description": "Width of the video in pixels"
                  },
                  "height": {
                    "type": "number",
                    "description": "Height of the video in pixels"
                  },
                  "types": {
                    "type": "array",
                    "description": "Available format types and their URIs for this quality",
                    "items": {
                      "type": "object",
                      "required": [
                        "format",
                        "uri"
                      ],
                      "properties": {
                        "format": {
                          "type": "string",
                          "enum": [
                            "mp4",
                            "mp4-luminance"
                          ],
                          "description": "Video format type"
                        },
                        "uri": {
                          "type": "string",
                          "description": "URI to access the video file"
                        }
                      },
                      "unevaluatedProperties": false
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "adaptiveSources": {
              "type": "array",
              "description": "Sources for adaptive streaming formats",
              "items": {
                "type": "object",
                "required": [
                  "format",
                  "uri"
                ],
                "properties": {
                  "format": {
                    "type": "string",
                    "enum": [
                      "hls",
                      "dash"
                    ],
                    "description": "Adaptive streaming format"
                  },
                  "uri": {
                    "type": "string",
                    "description": "URI to access the stream manifest"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "hasAudio": {
              "type": "boolean",
              "description": "Whether the video contains an audio track"
            },
            "fps": {
              "type": "number",
              "description": "Frames per second of the video"
            },
            "poster": {
              "description": "Poster image for the video",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "duration": {
              "type": "number",
              "description": "Duration of the video in seconds"
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "description": "Human-readable name to use for the video."
            }
          }
        }
      ],
      "type": "object"
    },
    "Builder.VectorArt--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "Builder.RichText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "wixStudio2Demo.counterContextProvider.Data--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "data"
          ],
          "properties": {
            "data": {
              "type": "object",
              "additionalProperties": true,
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "contentType": {
              "default": "Text",
              "enum": [
                "Text",
                "Icon",
                "Text and icon"
              ],
              "type": "string"
            },
            "label": {
              "default": "Button",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "iconPosition": {
              "default": "Left",
              "enum": [
                "Left",
                "Right"
              ],
              "type": "string"
            },
            "buttonType": {
              "default": "Full",
              "enum": [
                "Full",
                "Outline",
                "Link"
              ],
              "type": "string"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiDatePicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Select Date",
              "maxLength": 120,
              "type": "string"
            },
            "initialText": {
              "default": "today's date",
              "enum": [
                "today's date",
                "placeholder"
              ],
              "type": "string"
            },
            "placeholder": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "fieldType": {
              "default": "form",
              "enum": [
                "form",
                "settings",
                "filter"
              ],
              "type": "string"
            },
            "pickerType": {
              "default": "calendar",
              "enum": [
                "wheel",
                "calendar"
              ],
              "type": "string"
            },
            "pickerTitle": {
              "default": "Select Date",
              "maxLength": 120,
              "type": "string"
            },
            "showPastDates": {
              "default": true,
              "type": "boolean"
            },
            "showFutureDates": {
              "default": true,
              "type": "boolean"
            },
            "wheelMode": {
              "default": "DD/MM/YY",
              "enum": [
                "DD/MM/YY",
                "MM/YY"
              ],
              "type": "string"
            },
            "firstDay": {
              "default": "Monday",
              "enum": [
                "Sunday",
                "Monday"
              ],
              "type": "string"
            },
            "disabledDaysOfWeek": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "enabledDateRanges": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "disabledDateRanges": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "requiredErrorMessage": {
              "default": "This field is required",
              "maxLength": 1200,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "disabledDates": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "minDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "maxDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "timeZone": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "defaultItemSchemaType--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "MobuiDateRangeType--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "startDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "endDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiImage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "src": {
              "$ref": "#/ImageReference"
            },
            "isExternalSource": {
              "default": false,
              "type": "boolean"
            },
            "resizeMode": {
              "default": "cover",
              "enum": [
                "cover",
                "contain",
                "stretch",
                "repeat",
                "center"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiPicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldType": {
              "default": "form",
              "enum": [
                "form",
                "filter",
                "settings"
              ],
              "type": "string"
            },
            "label": {
              "default": "Label",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Select an option",
              "maxLength": 120,
              "type": "string"
            },
            "pickerType": {
              "default": "fullScreen",
              "enum": [
                "fullScreen",
                "dialog"
              ],
              "type": "string"
            },
            "optionsDialogTitle": {
              "default": "Select an Option",
              "maxLength": 120,
              "type": "string"
            },
            "optionsDialogSubtitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "hasItemSubtitle": {
              "default": false,
              "type": "boolean"
            },
            "isMultiselect": {
              "default": false,
              "type": "boolean"
            },
            "selectionLimit": {
              "default": 3,
              "type": "number",
              "multipleOf": 1
            },
            "hasSearchBar": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "requiredErrorMessage": {
              "default": "Please fill out this field",
              "maxLength": 120,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "validateOnBlur": {
              "default": false,
              "type": "boolean"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "MobuiPickerItemType--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "subtitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isSelected": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiSwitch--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "value": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Add Title",
              "maxLength": 1200,
              "type": "string"
            },
            "selectable": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiTextInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "inputType": {
              "default": "text",
              "enum": [
                "text",
                "password",
                "phone",
                "email",
                "url",
                "number"
              ],
              "type": "string"
            },
            "label": {
              "default": "Label",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "initialValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "hasCharLimit": {
              "default": false,
              "type": "boolean"
            },
            "maxInputLength": {
              "default": 300,
              "maximum": 120000,
              "type": "number",
              "multipleOf": 1
            },
            "prefixValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "suffixValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "requiredErrorMessage": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validatorErrorMessageValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validatorType": {
              "default": "none",
              "enum": [
                "none",
                "number",
                "email",
                "url",
                "required"
              ],
              "type": "string"
            },
            "textContentType": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "autoComplete": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "validateOnBlur": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiVideoPlayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "title": {
              "default": "I am a Title",
              "maxLength": 120,
              "type": "string"
            },
            "src": {
              "default": "https://video.wixstatic.com/video/11062b_5ae1557b0cb244ab80dabfa817f48caa/1080p/mp4/file.mp4",
              "maxLength": 1200,
              "type": "string"
            },
            "poster": {
              "$ref": "#/ImageReference"
            },
            "isPlaying": {
              "default": false,
              "type": "boolean"
            },
            "muteOnStart": {
              "default": false,
              "type": "boolean"
            },
            "playInLoop": {
              "default": false,
              "type": "boolean"
            },
            "enableFullScreen": {
              "default": true,
              "type": "boolean"
            },
            "enableCasting": {
              "default": false,
              "type": "boolean"
            },
            "showVideoSettings": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiMultiStateBoxData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "defaultStateId": {
                  "default": null,
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "selectedStateId": {
                  "default": null,
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "wixui.ExternalComponent--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "compProps": {
              "default": "{}",
              "maxLength": 120000,
              "type": "string"
            },
            "isTrusted": {
              "default": false,
              "type": "boolean"
            },
            "importKey": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.HamburgerOverlay--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "showBackgroundOverlay": {
              "default": true,
              "type": "boolean"
            },
            "tapOutsideToClose": {
              "default": true,
              "type": "boolean"
            },
            "isMenuContainerFullscreen": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.Logo--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "isLoadingData": {
              "default": true,
              "type": "boolean"
            },
            "logoId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "alt": {
              "default": "Logo",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "preset": {
              "default": "original",
              "maxLength": 120,
              "type": "string"
            },
            "hasBackground": {
              "default": true,
              "type": "boolean"
            },
            "brandId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "backgroundColor": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "logoUrl": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.LottieEmbed--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "animationUrl": {
              "default": "https://assets7.lottiefiles.com/packages/lf20_bh69rwvr.json",
              "maxLength": 1200,
              "type": "string"
            },
            "speed": {
              "default": 1,
              "minimum": 0,
              "type": "number"
            },
            "loop": {
              "default": true,
              "type": "boolean"
            },
            "autoplay": {
              "default": true,
              "type": "boolean"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isDecorative": {
              "default": false,
              "type": "boolean"
            },
            "showPlaybackControl": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.ProductSpecification--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.RangeSlider--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Set a range value",
              "maxLength": 120,
              "type": "string"
            },
            "sliderType": {
              "default": "Continuous",
              "enum": [
                "Continuous",
                "Stepped"
              ],
              "type": "string"
            },
            "stepType": {
              "default": "Number",
              "enum": [
                "Number",
                "Value"
              ],
              "type": "string"
            },
            "step": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "direction": {
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ],
              "type": "string"
            },
            "rootDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "labelDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "sliderDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "min": {
              "default": 0,
              "type": "number"
            },
            "max": {
              "default": 100,
              "type": "number"
            },
            "prefix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "suffix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "minValue": {
              "default": 0,
              "type": "number"
            },
            "maxValue": {
              "default": 0,
              "type": "number"
            },
            "thumbShape": {
              "default": "Circle",
              "enum": [
                "Circle",
                "Square",
                "Rectangle",
                "Bar"
              ],
              "type": "string"
            },
            "marksTickShape": {
              "default": "Lines",
              "enum": [
                "Lines",
                "Dots"
              ],
              "type": "string"
            },
            "thumbSize": {
              "default": 24,
              "type": "number",
              "multipleOf": 1
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "accessibleName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.Rive--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "animationFileUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "thumbnailFileUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "artboard": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "stateMachine": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "fit": {
              "default": "cover",
              "maxLength": 120,
              "type": "string"
            },
            "alignment": {
              "default": "center",
              "maxLength": 120,
              "type": "string"
            },
            "isAutoPlayOn": {
              "default": true,
              "type": "boolean"
            },
            "isTouchScrollEnabled": {
              "default": true,
              "type": "boolean"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "fileName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isDecorative": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.ShareButtons--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "buttons": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "pageToShare": {
              "default": "home",
              "maxLength": 1200,
              "type": "string"
            },
            "shareUrl": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "direction": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "IShareButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "platformId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            },
            "isHidden": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.SingleTab--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "tabId"
          ],
          "type": "object",
          "properties": {
            "tabId": {
              "maxLength": 120,
              "type": "string"
            },
            "label": {
              "default": "Tab",
              "maxLength": 120,
              "type": "string"
            },
            "isParentStretched": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "AccordionContainerData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "items": {
              "type": "array",
              "items": {
                "type": "object",
                "allOf": [
                  {
                    "properties": {
                      "id": {
                        "type": "string"
                      },
                      "label": {
                        "type": "string"
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false
              },
              "default": []
            }
          }
        }
      ],
      "type": "object"
    },
    "AccordionItemData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isParentStretched": {
              "type": "boolean",
              "default": false
            }
          }
        }
      ],
      "type": "object"
    },
    "AddressInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "optionsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "locale": {
              "type": "string",
              "maxLength": 100
            },
            "googleMapsApiKey": {
              "type": "string",
              "maxLength": 400
            },
            "filter": {
              "type": "object",
              "properties": {
                "country": {
                  "type": "string",
                  "maxLength": 10
                }
              },
              "unevaluatedProperties": false
            },
            "sorting": {
              "type": "object",
              "properties": {
                "location": {
                  "type": "object",
                  "properties": {
                    "lat": {
                      "type": "number"
                    },
                    "lng": {
                      "type": "number"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "radius": {
                  "type": "number",
                  "default": 100
                },
                "formatted": {
                  "type": "string",
                  "maxLength": 10
                }
              },
              "unevaluatedProperties": false
            },
            "placeholder": {
              "type": "string",
              "description": "The value of the placeholder if chosen",
              "maxLength": 1000
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "BoltComponentData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "anyOf": [
            {
              "properties": {}
            }
          ]
        }
      ],
      "type": "object"
    },
    "BreadcrumbsData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "svgId": {
                  "type": "string",
                  "maxLength": 100
                }
              }
            },
            {
              "$ref": "#/CustomMenuDataRef--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "Captcha--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "captchaType": {
              "type": "string",
              "enum": [
                "image",
                "audio"
              ],
              "default": "image",
              "description": "When set changes the type of the challenge (image or audio)"
            }
          }
        }
      ],
      "type": "object"
    },
    "CollapsibleTextData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "default": "",
              "maxLength": 120000
            },
            "readMoreText": {
              "type": "string",
              "default": "Read More",
              "maxLength": 1200
            },
            "readLessText": {
              "type": "string",
              "default": "Read Less",
              "maxLength": 1200
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "linkText": {
              "type": "string",
              "default": "Read More",
              "maxLength": 1200
            },
            "textDescription": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "tag": {
              "type": "string",
              "default": "p",
              "maxLength": 31
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "ComboBoxInputData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "dropdownDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/SelectableList--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "CustomElement--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tagName": {
              "type": "string",
              "default": "wix-default-custom-element"
            },
            "url": {
              "type": "string",
              "default": "https://static.parastorage.com/services/editor-elements-library/dist/assets/CustomElement/wixDefaultCustomElement.js"
            },
            "hostedInCorvid": {
              "type": "boolean",
              "default": false
            },
            "initialAttributes": {
              "type": "string",
              "default": "{}",
              "maxLength": 4096
            },
            "shouldReload": {
              "type": "boolean",
              "description": "if iframe should be reloaded on initialAttributes change"
            },
            "scriptType": {
              "type": "string",
              "enum": [
                "none",
                "module"
              ],
              "default": "none"
            },
            "appDefinitionId": {
              "type": "string",
              "maxLength": 36
            },
            "widgetId": {
              "type": "string",
              "maxLength": 36
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.FastGallery--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "itemClickAction": {
              "default": "ACTION",
              "enum": [
                "ACTION",
                "LINK",
                "NOTHING"
              ],
              "type": "string"
            },
            "downloadProtection": {
              "default": true,
              "type": "boolean"
            },
            "wixSDKItems": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.HamburgerMenuContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "wixui.HamburgerMenuRoot--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "ImageX--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "image": {
              "type": "object",
              "properties": {
                "uri": {
                  "type": "string",
                  "default": ""
                },
                "alt": {
                  "type": "string",
                  "default": ""
                },
                "name": {
                  "type": "string",
                  "maxLength": 100
                },
                "height": {
                  "type": "number",
                  "default": 200
                },
                "width": {
                  "type": "number",
                  "default": 200
                },
                "decorative": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "scopedData": {
              "description": "ImageX data per breakpoint",
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "breakpoint": {
                    "type": "string"
                  },
                  "crop": {
                    "$ref": "#/Crop"
                  },
                  "focalPoint": {
                    "$ref": "#/FocalPoint"
                  },
                  "displayMode": {
                    "type": "string",
                    "enum": [
                      "fill",
                      "fit",
                      "fitWidth"
                    ],
                    "default": "fill"
                  },
                  "scrollEffect": {
                    "type": "string",
                    "enum": [
                      "parallax",
                      "fixed",
                      "zoomIn",
                      "fadeIn",
                      "none"
                    ]
                  },
                  "clickAction": {
                    "type": "string",
                    "enum": [
                      "none",
                      "goToLink"
                    ]
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "mask": {
              "type": [
                "object",
                "null"
              ],
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "width": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "height": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "svgId": {
                  "type": "string"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360
                },
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ]
                }
              },
              "unevaluatedProperties": false
            },
            "parallaxSpeed": {
              "type": "number"
            },
            "parallaxDirection": {
              "type": "string",
              "enum": [
                "normal",
                "reverse"
              ]
            },
            "hasAnimation": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "Crop--unrestricted-root": {
      "type": "object",
      "required": [
        "x",
        "y",
        "width",
        "height"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        },
        "width": {
          "type": "number",
          "minimum": 0
        },
        "height": {
          "type": "number",
          "minimum": 0
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "rotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 359,
          "description": "Image rotation degrees"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ],
          "default": "none",
          "description": "Image flip value"
        }
      }
    },
    "FocalPoint--unrestricted-root": {
      "type": "object",
      "required": [
        "x",
        "y"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        }
      }
    },
    "LanguageSelector--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "wixui.MegaMenuContainerItem--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "type": {
              "default": "wixui.MegaMenuContainerItem",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "MenuData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "itemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuItemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuSubItemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "navAriaLabel": {
                  "type": "string",
                  "maxLength": 1000
                }
              }
            },
            {
              "$ref": "#/CustomMenuDataRef--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "wixui.MenuList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "menus": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "MusicPlayerData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "coverDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "audioRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "audioUrl": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 256
            },
            "playListId": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 255
            },
            "playlist": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "artistName": {
                    "type": "string",
                    "maxLength": 255,
                    "default": "Unknown Artist"
                  },
                  "trackName": {
                    "type": "string",
                    "maxLength": 255,
                    "default": "Unknown Track"
                  },
                  "url": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 2500
                  },
                  "cover": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 2500
                  },
                  "durationFormatted": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 16
                  }
                },
                "unevaluatedProperties": false
              },
              "default": []
            },
            "coverRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "coverUrl": {
              "type": [
                "string",
                "null"
              ]
            },
            "artistName": {
              "type": "string",
              "default": "Unknown Artist",
              "maxLength": 255
            },
            "trackName": {
              "type": "string",
              "default": "Unknown Track",
              "maxLength": 255
            },
            "description": {
              "type": "string",
              "default": "",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "WixAudio--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "title": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "duration": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "Pagination--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "totalPages": {
              "type": "number",
              "description": "The total number of pages displayed by the component"
            },
            "currentPage": {
              "type": "number",
              "default": 1,
              "description": "The the page number marked as current"
            },
            "nextText": {
              "type": "string",
              "default": "Next",
              "maxLength": 400,
              "description": "Text to appear in NEXT button"
            },
            "previousText": {
              "type": "string",
              "default": "Previous",
              "maxLength": 400,
              "description": "Text to appear in PREVIOUS button"
            },
            "firstText": {
              "type": "string",
              "default": "First",
              "maxLength": 400,
              "description": "Text to appear in FIRST button"
            },
            "lastText": {
              "type": "string",
              "default": "Last",
              "maxLength": 400,
              "description": "Text to appear in LAST button"
            },
            "nextAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the NEXT button"
            },
            "previousAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the PREVIOUS button"
            },
            "firstAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the FIRST button"
            },
            "lastAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the LAST button"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "PaginationA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "ProgressBar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "number",
              "description": "Current progress value"
            },
            "targetValue": {
              "type": "number",
              "default": 100,
              "description": "Progress target value to be defined as complete"
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "barDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "RatingsDisplay--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "ratingsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "rating": {
              "type": "number",
              "description": "The rating displayed by the component",
              "minimum": 1,
              "maximum": 5
            },
            "svgId": {
              "type": "string",
              "maxLength": 100
            },
            "numRatings": {
              "type": "number",
              "description": "The amount of ratings the rating is based on",
              "minimum": 0
            },
            "reviewsCountLabel": {
              "type": "string",
              "default": "Reviews",
              "maxLength": 400,
              "description": "Text that describes the numRatings value"
            },
            "noReviewsPlaceholder": {
              "type": "string",
              "default": "Be the first to rate this item",
              "maxLength": 1000,
              "description": "Placeholder text when there aren't any reviews"
            }
          }
        }
      ],
      "type": "object"
    },
    "RatingsInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": [
                "number",
                "null"
              ],
              "description": "The rating value currently selected",
              "minimum": 0,
              "maximum": 5
            },
            "titleText": {
              "type": "string",
              "description": "the title before a value is selected",
              "maxLength": 300
            },
            "svgId": {
              "type": "string",
              "description": "the id of the svg that illustrates the rating",
              "maxLength": 100
            },
            "labels": {
              "type": "object",
              "description": "contains the labels for the different values. maps 1-5 as keys to strings",
              "default": {
                "1": "Bad",
                "2": "Fine",
                "3": "OK",
                "4": "Good",
                "5": "Great"
              },
              "additionalProperties": {
                "type": [
                  "string",
                  "number"
                ]
              },
              "unevaluatedProperties": false
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.RichContentViewer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "content": {
              "type": "object",
              "unevaluatedProperties": false
            },
            "trimEnabled": {
              "type": "boolean",
              "default": false
            },
            "trimMode": {
              "type": "string",
              "default": "paragraph",
              "maxLength": 100
            },
            "trimLengthParagraph": {
              "type": "number",
              "default": 3
            },
            "trimLengthWord": {
              "type": "number",
              "default": 10
            },
            "trimExclude": {
              "type": "string",
              "default": "plugins",
              "maxLength": 100
            },
            "trimEllipsisEnabled": {
              "type": "boolean",
              "default": true
            },
            "trimEllipsisExpandText": {
              "type": "string",
              "default": "Show More",
              "maxLength": 1200
            },
            "trimEllipsisCollapseText": {
              "type": "string",
              "default": "Show Less",
              "maxLength": 1200
            }
          }
        }
      ],
      "type": "object"
    },
    "RichTextBox--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "maxLength": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SearchBox--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "placeholder": {
              "type": "string",
              "default": "Search...",
              "maxLength": 255
            },
            "suggestionsEnabled": {
              "type": "boolean",
              "default": true,
              "description": "Determines whether the suggestions disabled or not"
            },
            "clearButtonText": {
              "type": "string",
              "default": "Clear",
              "maxLength": 255
            },
            "displaySettingsToggles": {
              "type": "boolean",
              "default": true,
              "description": "Determines whether the settings toggles are displayed or not"
            }
          }
        }
      ],
      "type": "object"
    },
    "Section--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "SectionA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "alert",
                "status"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.SelectableContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "wixui.SelectableContainerInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "SelectionTagsList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "options": {
              "description": "Array of items which behave like checkboxes and look similar to buttons",
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "value": {
              "description": "Array with the values of the selected options",
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "SelectionTag--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "maxLength": 400
            },
            "label": {
              "type": "string",
              "maxLength": 400
            },
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "rel": {
              "type": "string",
              "enum": [
                "nofollow"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "SignatureInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "titleText": {
              "type": "string",
              "description": "The title of the field",
              "maxLength": 400
            },
            "clearButtonText": {
              "type": "string",
              "description": "The undo signature text",
              "minLength": 1,
              "maxLength": 400
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "radioButtonsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "SiteButtonData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/LinkableButton--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "Slider--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "trackDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "tooltipDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "min": {
              "type": "number",
              "default": 0,
              "description": "Minimum value"
            },
            "max": {
              "type": "number",
              "default": 100,
              "description": "Maximum value"
            },
            "value": {
              "type": "number",
              "default": 50,
              "description": "Current value"
            },
            "step": {
              "type": "number",
              "default": 0,
              "description": "Step value"
            },
            "stepType": {
              "type": "string",
              "default": "value",
              "enum": [
                "value",
                "count"
              ],
              "description": "When set to 'value', step represents the value of each step. When set to 'count', step represents the total steps count"
            },
            "disabled": {
              "type": "boolean",
              "default": false,
              "description": "Determines whether the slider is disabled or not"
            },
            "readOnly": {
              "type": "boolean",
              "default": false,
              "description": "Determines whether the slider is read-only or not"
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "description": "Label text",
              "maxLength": 1200
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.Slideshow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "type": {
              "default": "wixui.Slideshow",
              "maxLength": 120,
              "type": "string"
            },
            "direction": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "SocialAuth--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "StylableButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON",
              "maxLength": 1200
            },
            "svgId": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "isIconAnimated": {
              "type": "boolean"
            },
            "animatedIcon": {
              "type": "object",
              "properties": {
                "svgIdAnimationSelected": {
                  "type": "string",
                  "maxLength": 100
                },
                "customAnimatedIcon": {
                  "type": [
                    "object"
                  ],
                  "properties": {
                    "svgIdAnimationStart": {
                      "type": "string",
                      "maxLength": 100
                    },
                    "svgIdAnimationEnd": {
                      "type": "string",
                      "maxLength": 100
                    },
                    "svgIdAnimationSelected": {
                      "type": "string",
                      "maxLength": 100
                    }
                  },
                  "unevaluatedProperties": false
                },
                "animationDuration": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "StylableButtonA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "pressed": {
              "type": "boolean"
            },
            "expanded": {
              "type": "boolean"
            },
            "disabled": {
              "type": "boolean"
            },
            "haspopup": {
              "type": "string",
              "enum": [
                "true",
                "false",
                "dialog",
                "menu"
              ]
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "Submenu--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "itemDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "subItemDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "SvgImage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "svgId"
          ],
          "properties": {
            "decorative": {
              "type": "boolean"
            },
            "alt": {
              "type": "string",
              "description": "Alternative text for the vector image (for accessibility purposes).",
              "maxLength": 120
            },
            "displayMode": {
              "type": "string",
              "enum": [
                "fit",
                "stretch"
              ],
              "description": "should the shape maintain it's aspect ratio or stretch",
              "default": "fit"
            },
            "svgId": {
              "type": "string",
              "maxLength": 100,
              "description": "Identifier for the SVG image."
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.Tabs--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabIds": {
              "type": "array",
              "items": {
                "type": "string",
                "maxLength": 120
              }
            },
            "defaultTabId": {
              "type": "string",
              "default": "",
              "maxLength": 120
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "TabsA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "TextEffectsSharedData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 500
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "default": "div"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction",
              "default": "inherit"
            },
            "patternScope": {
              "type": "string",
              "enum": [
                "none",
                "character",
                "word"
              ],
              "default": "none"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextMarqueeData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "items",
            "speed"
          ],
          "properties": {
            "movementDirection": {
              "type": "string",
              "description": "direction the text is moving to",
              "default": "rtl",
              "enum": [
                "rtl",
                "ltr"
              ]
            },
            "speed": {
              "type": "number",
              "description": "speed of the animation in pixels per second"
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "pause animation on hover"
            },
            "textDirection": {
              "type": "string",
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ]
            },
            "headingLevel": {
              "type": "number",
              "maximum": 6,
              "minimum": 0,
              "description": "Heading level to wrap the component (deprecated)"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "description": "Semantic tag name to wrap the component"
            },
            "svgId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "description": "array of marquee items",
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "TextMarqueeItem--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "description": "TextMarquee Item",
          "required": [
            "text"
          ],
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "text": {
              "type": "string",
              "maxLength": 500
            }
          }
        }
      ],
      "type": "object"
    },
    "TextFxData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 450
            },
            "headingLevel": {
              "type": "number",
              "minimum": 0,
              "maximum": 6,
              "description": "Heading level to wrap the component (deprecated)"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "direction": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ],
              "default": "ltr"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "description": "Semantic tag name to wrap the component"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextOnPathData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isDecorative": {
              "type": "boolean"
            },
            "text": {
              "type": "string",
              "description": "text",
              "maxLength": 500
            },
            "path": {
              "type": "string",
              "description": "path"
            },
            "pathLength": {
              "type": "number",
              "description": "Path length"
            },
            "viewBox": {
              "type": "string",
              "description": "View box"
            },
            "speed": {
              "type": "number",
              "description": "Speed",
              "default": 3
            },
            "movementDirection": {
              "type": "string",
              "description": "Direction the text is moving to",
              "default": "forward",
              "enum": [
                "forward",
                "reverse"
              ]
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "Pause animation on hover"
            },
            "direction": {
              "type": "string",
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ]
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div"
              ],
              "description": "Semantic tag name to wrap the component"
            },
            "fillMode": {
              "type": "string",
              "enum": [
                "normal",
                "repeat",
                "justify"
              ],
              "default": "normal",
              "description": "How the text should be rendered on the path"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            },
            "startOffset": {
              "type": "number",
              "description": "Starting point of the text on the path",
              "minimum": 0,
              "maximum": 100
            },
            "fontSize": {
              "type": "number",
              "description": "Font size as a number in percent",
              "minimum": 0,
              "maximum": 100
            },
            "pathStrokeWidth": {
              "type": "number",
              "description": "Width of the path stroke in em units",
              "minimum": 0,
              "maximum": 3
            }
          }
        }
      ],
      "type": "object"
    },
    "TextParticlesData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "default": "TextParticles",
              "maxLength": 500,
              "type": "string"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction",
              "default": "inherit"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "default": "div"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "pause animation on hover",
              "default": true
            }
          }
        }
      ],
      "type": "object"
    },
    "TimePickerData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "placeholder": {
                  "type": "string",
                  "description": "The value of the placeholder if chosen",
                  "maxLength": 1000
                },
                "step": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 60,
                  "default": 1,
                  "description": "Increment step in minutes"
                },
                "label": {
                  "type": "string",
                  "maxLength": 1000
                },
                "margin": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 30,
                  "description": "Time picker layout label margin"
                },
                "disabledTimes": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "required": [
                      "startTime",
                      "endTime"
                    ],
                    "properties": {
                      "startTime": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "endTime": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  },
                  "default": [],
                  "maxItems": 5,
                  "description": "array of disabled times"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ToggleSwitch--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "checked": {
                  "type": "boolean",
                  "description": "The checked status of the input"
                },
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "UnsupportedComponentData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "migratedFrom": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "VideoPlayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "videoType": {
              "type": "string",
              "enum": [
                "dailymotion",
                "facebook",
                "file",
                "twitch",
                "vimeo",
                "youtube"
              ],
              "default": "file"
            },
            "videoRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "videoUrl": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 256
            },
            "posterUrl": {
              "type": [
                "string",
                "null"
              ]
            },
            "videoTitle": {
              "type": "string",
              "default": "",
              "maxLength": 255
            },
            "description": {
              "type": "string",
              "default": "",
              "maxLength": 1000,
              "description": "Video Description"
            },
            "logoRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.ControlTypes--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "shortString": {
              "default": "ShortString",
              "maxLength": 120,
              "type": "string"
            },
            "longString": {
              "default": "LongString",
              "maxLength": 1200,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "dropdown": {
              "default": "Options 1",
              "enum": [
                "Options 1",
                "Options 2",
                "Options 3",
                "Options 4"
              ],
              "type": "string"
            },
            "radioButtons": {
              "default": "Options 1",
              "enum": [
                "Options 1",
                "Options 2",
                "Options 3",
                "Options 4"
              ],
              "type": "string"
            },
            "toggleSwitch": {
              "default": false,
              "type": "boolean"
            },
            "thumbnails": {
              "$ref": "#/SVGReference"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "slider": {
              "default": 1,
              "minimum": 0,
              "maximum": 2,
              "type": "number",
              "multipleOf": 1
            },
            "numericInput": {
              "default": 0,
              "type": "number"
            },
            "colorPickerInput": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "selectedFont": {
              "default": "arial",
              "maxLength": 1200,
              "format": "font-family",
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label"
          ],
          "type": "object",
          "properties": {
            "label": {
              "default": "Save",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Light",
                "Destructive",
                "Premium",
                "Premium light",
                "Dark",
                "Transparent"
              ],
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "priority": {
              "default": "Primary",
              "enum": [
                "Primary",
                "Secondary"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardHeading--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Add Page title H1",
              "maxLength": 1200,
              "type": "string"
            },
            "size": {
              "default": "Page title H1",
              "enum": [
                "Page title H1",
                "Modal title H2",
                "Card title H3",
                "Section title H4",
                "Card section title H5",
                "Caption H6"
              ],
              "type": "string"
            },
            "invertColor": {
              "default": false,
              "type": "boolean"
            },
            "textAlignment": {
              "default": "Left",
              "enum": [
                "Left",
                "Center",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardIconButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "icon": {
              "$ref": "#/SVGReference"
            },
            "tooltip": {
              "default": "More Actions",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Premium",
                "Light",
                "Transparent"
              ],
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "priority": {
              "default": "Secondary",
              "enum": [
                "Primary",
                "Secondary"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardInfoIcon--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "tooltip": {
              "default": "This message explains the purpose of a feature.",
              "maxLength": 1200,
              "type": "string"
            },
            "addLink": {
              "default": false,
              "type": "boolean"
            },
            "tooltipLinkText": {
              "default": "Learn more",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipLink": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Event name",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Enter your event name...",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "prefixValue": {
              "default": "Units",
              "maxLength": 120,
              "type": "string"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixValue": {
              "default": ".com",
              "maxLength": 120,
              "type": "string"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "setMaxLength": {
              "default": false,
              "type": "boolean"
            },
            "maxLength": {
              "default": 20,
              "type": "number",
              "multipleOf": 1
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "border": {
              "default": "Default",
              "enum": [
                "Default",
                "Round",
                "Line",
                "None"
              ],
              "type": "string"
            },
            "labelPosition": {
              "default": "Top",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardNumberInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Number of tickets",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Enter a number...",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": 25,
              "type": "number",
              "multipleOf": 1
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "prefixValue": {
              "default": "Units",
              "maxLength": 120,
              "type": "string"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixValue": {
              "default": "%",
              "maxLength": 120,
              "type": "string"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "minAndMaxValues": {
              "default": false,
              "type": "boolean"
            },
            "min": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "max": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepSize": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "border": {
              "default": "Default",
              "enum": [
                "Default",
                "Round",
                "Line",
                "None"
              ],
              "type": "string"
            },
            "labelPlacement": {
              "default": "Top",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "I’m a paragraph. Add your own text and edit me in settings. It’s easy.",
              "maxLength": 1200,
              "type": "string"
            },
            "preset": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Standard secondary",
                "Light",
                "Light secondary",
                "Success",
                "Destructive",
                "Primary",
                "Premium",
                "Disabled"
              ],
              "type": "string"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "Thin",
              "enum": [
                "Bold",
                "Normal",
                "Thin"
              ],
              "type": "string"
            },
            "textAlignment": {
              "default": "Left",
              "enum": [
                "Left",
                "Center",
                "Right"
              ],
              "type": "string"
            },
            "overflow": {
              "default": "Wrap",
              "enum": [
                "Wrap",
                "Ellipsis"
              ],
              "type": "string"
            },
            "maxLines": {
              "default": 1,
              "minimum": 1,
              "type": "number",
              "multipleOf": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardTextButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "View All",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Premium",
                "Light",
                "Dark",
                "Destructive"
              ],
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "underline": {
              "default": "Never",
              "enum": [
                "Never",
                "On hover",
                "Always"
              ],
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "Regular",
              "enum": [
                "Regular",
                "Medium"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardToggleSwitch--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Set a reminder",
              "maxLength": 120,
              "type": "string"
            },
            "checked": {
              "default": true,
              "type": "boolean"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Success",
                "Destructive"
              ],
              "type": "string"
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Large",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "labelPosition": {
              "default": "Right",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.SettingsPanelContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "theme": {
              "default": "classic",
              "enum": [
                "classic",
                "responsive"
              ],
              "type": "string"
            },
            "debug": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuAccordion--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Label Example",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "openByDefault": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuBackButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Back",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "label": {
              "default": "Button",
              "maxLength": 120,
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "standard secondary",
                "premium",
                "premium secondary",
                "alert",
                "alert secondary",
                "inverted"
              ],
              "type": "string"
            },
            "size": {
              "default": "medium",
              "enum": [
                "small",
                "medium",
                "large"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "fullWidth": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuCheckboxGroup--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Multiple Choices",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuColorPicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Opacity & Color",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "opacity": {
              "default": 100,
              "minimum": 0,
              "maximum": 100,
              "type": "number",
              "multipleOf": 1
            },
            "showPercentage": {
              "default": true,
              "type": "boolean"
            },
            "opacitySliderEnabled": {
              "default": true,
              "type": "boolean"
            },
            "color": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuColorSelector--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Color Selector",
              "maxLength": 120,
              "type": "string"
            },
            "color": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuColumnControllerControl--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Column controller",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "enableReorder": {
              "default": true,
              "type": "boolean"
            },
            "minimumValue": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "dividerType": {
              "default": "none",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            },
            "columns": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuDatePicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Choose a Date",
              "maxLength": 120,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuDrillDown--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Label Title",
              "maxLength": 120,
              "type": "string"
            },
            "description": {
              "default": "This is a description text",
              "maxLength": 1200,
              "type": "string"
            },
            "iconType": {
              "default": "None",
              "enum": [
                "None",
                "Info",
                "Alert"
              ],
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuDropdown--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Dropdown",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Choose an option",
              "maxLength": 120,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuEmptyState--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Link to Lightbox",
              "maxLength": 120,
              "type": "string"
            },
            "description": {
              "default": "Create your own lightboxes and link to them for any place in your site.",
              "maxLength": 1200,
              "type": "string"
            },
            "textButtonLabel": {
              "default": "Start Creating",
              "maxLength": 120,
              "type": "string"
            },
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuFontAndColorPicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Pick Font and Color",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "font": {
              "default": "arial",
              "maxLength": 1200,
              "format": "font-family",
              "type": "string"
            },
            "color": {
              "default": "#FFC233",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuHorizontalTabs--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "tabsStyle": {
              "default": "Folder",
              "enum": [
                "Folder",
                "Arrowed",
                "Arrowed Without a Line"
              ],
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "maxVisibleTabs": {
              "default": 3,
              "minimum": 1,
              "maximum": 10,
              "type": "number",
              "multipleOf": 1
            },
            "tabsToScroll": {
              "default": 3,
              "minimum": 1,
              "maximum": 10,
              "type": "number",
              "multipleOf": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuLeftTextButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Text Button",
              "maxLength": 120,
              "type": "string"
            },
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "size": {
              "default": "medium",
              "enum": [
                "tiny",
                "small",
                "medium"
              ],
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "premium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "normal",
              "enum": [
                "thin",
                "normal"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuMultilineTextInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 120000,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Write text here...",
              "maxLength": 1200,
              "type": "string"
            },
            "maxLength": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "closeOnEnterKeyPress": {
              "default": false,
              "type": "boolean"
            },
            "autoFocus": {
              "default": false,
              "type": "boolean"
            },
            "selectTextOnFocus": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "usePatternValidation": {
              "default": false,
              "type": "boolean"
            },
            "regexPattern": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "validationMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuNotificationBanner--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "premium",
                "alert",
                "success"
              ],
              "type": "string"
            },
            "linkText": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "linkUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "iconTooltipText": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "multiline": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuNumericInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "title": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": 0,
              "type": "number"
            },
            "unitSuffix": {
              "default": "None",
              "enum": [
                "None",
                "Pixels",
                "Percentage",
                "Degrees"
              ],
              "type": "string"
            },
            "numberOfFractions": {
              "default": 2,
              "minimum": 0,
              "maximum": 2,
              "type": "number",
              "multipleOf": 1
            },
            "steps": {
              "default": 1,
              "minimum": 1,
              "maximum": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepControls": {
              "default": false,
              "type": "boolean"
            },
            "minValue": {
              "default": 0,
              "type": "number"
            },
            "maxValue": {
              "default": 100,
              "type": "number"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuRadioButtonGroup--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Radio Buttons",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuRichText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "richTextContent": {
              "default": "Your placeholder text goes here. Write, style and link it.",
              "maxLength": 120000,
              "type": "string"
            },
            "richTextLabel": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "richTextLink": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "alignTextToCenter": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuSectionDivider--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "sectionTitle": {
              "default": "Section Divider",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuSlider--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Slider",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "unitOfMeasurement": {
              "default": "number",
              "enum": [
                "number",
                "percentage",
                "pixels",
                "angle"
              ],
              "type": "string"
            },
            "defaultSelectedValue": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "minimumValue": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "maximumValue": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepValue": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "showNumericInput": {
              "default": true,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuTextInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Text Input",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "defaultText": {
              "default": "Write it here...",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Placeholder text",
              "maxLength": 120,
              "type": "string"
            },
            "prefix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "autofocus": {
              "default": false,
              "type": "boolean"
            },
            "selectedOnFocus": {
              "default": true,
              "type": "boolean"
            },
            "charactersLimit": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "usePatternValidation": {
              "default": false,
              "type": "boolean"
            },
            "regexPattern": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "errorMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuThumbnails--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "options"
          ],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "setNumberOfColumns": {
              "default": 3,
              "minimum": 1,
              "maximum": 5,
              "type": "number",
              "multipleOf": 1
            },
            "showEmptyThumbnail": {
              "default": false,
              "type": "boolean"
            },
            "thumbnailHeight": {
              "default": "Fixed ratio (1:1)",
              "enum": [
                "Fixed ratio (1:1)",
                "Fluid"
              ],
              "type": "string"
            },
            "displayLabels": {
              "default": true,
              "type": "boolean"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "ThumbnailItemData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuToggleSwitch--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Toggle Switch",
              "maxLength": 120,
              "type": "string"
            },
            "toggleSwitch": {
              "default": true,
              "type": "boolean"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WutAvatar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "firstName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "lastName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "src": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WutAvatarGroup--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "maxAvatars": {
              "default": 5,
              "minimum": 1,
              "type": "number",
              "multipleOf": 1
            },
            "showHiddenAvatarCount": {
              "default": true,
              "type": "boolean"
            },
            "avatars": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WutBadge--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "My Badge",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "composition": {
              "default": "TextAndIcon",
              "enum": [
                "TextAndIcon",
                "Text",
                "Icon",
                "None"
              ],
              "type": "string"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WutRadioButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "value"
          ],
          "type": "object",
          "properties": {
            "radioGroupName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "checked": {
              "default": false,
              "type": "boolean"
            },
            "required": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "editorsettings.json": {
    "$id": "urn:dm:schemas:editorsettings.json",
    "EditorSettings": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "dockingBehavior": {
              "type": "string",
              "enum": [
                "heuristic",
                "keep"
              ]
            },
            "layoutIntent": {
              "type": "string",
              "enum": [
                "SuperGrid",
                "CssGrid",
                "Mesh"
              ]
            },
            "sizingBehavior": {
              "type": "string",
              "enum": [
                "preset",
                "advanced"
              ]
            },
            "aspectRatioLock": {
              "type": "boolean"
            },
            "disableAutoDOMOrder": {
              "type": "boolean"
            },
            "domOrderStrategy": {
              "type": "string",
              "enum": [
                "N-shape",
                "Z-shape"
              ]
            },
            "thumbnailId": {
              "type": "string"
            },
            "progressStatus": {
              "type": "string",
              "enum": [
                "UNKNOWN",
                "TO_DO",
                "IN_PROGRESS",
                "ITERATE",
                "DONE"
              ]
            },
            "linkedComponents": {
              "type": "object",
              "patternProperties": {
                "^comp-": {
                  "$ref": "urn:dm:schemas:common.json#/weakReference"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "EditorSettings--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "dockingBehavior": {
              "type": "string",
              "enum": [
                "heuristic",
                "keep"
              ]
            },
            "layoutIntent": {
              "type": "string",
              "enum": [
                "SuperGrid",
                "CssGrid",
                "Mesh"
              ]
            },
            "sizingBehavior": {
              "type": "string",
              "enum": [
                "preset",
                "advanced"
              ]
            },
            "aspectRatioLock": {
              "type": "boolean"
            },
            "disableAutoDOMOrder": {
              "type": "boolean"
            },
            "domOrderStrategy": {
              "type": "string",
              "enum": [
                "N-shape",
                "Z-shape"
              ]
            },
            "thumbnailId": {
              "type": "string"
            },
            "progressStatus": {
              "type": "string",
              "enum": [
                "UNKNOWN",
                "TO_DO",
                "IN_PROGRESS",
                "ITERATE",
                "DONE"
              ]
            },
            "linkedComponents": {
              "type": "object",
              "patternProperties": {
                "^comp-": {
                  "$ref": "urn:dm:schemas:common.json#/weakReference"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "effects.json": {
    "$id": "urn:dm:schemas:effects.json",
    "KeyframeEffect": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "An Effect that is a list of custom Keyframe animations",
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "keyframes": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": {
                  "type": [
                    "string"
                  ]
                },
                "properties": {
                  "offset": {
                    "type": "number"
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "EffectsList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Ref List of different types of Animation Effects",
          "type": "object",
          "properties": {
            "values": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CanvasAnimation": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "A canvas-based animation",
          "type": "object",
          "required": [
            "name",
            "value"
          ],
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CanvasAnimationOptions": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Properties of canvas-based animations",
          "type": "object",
          "properties": {
            "namedEffect": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TimeAnimationOptions": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Properties of a time-based animation: duration, delay, end-delay, replay type and all Base Animation Properties",
          "type": "object",
          "allOf": [
            {
              "properties": {
                "duration": {
                  "type": "number",
                  "multipleOf": 1,
                  "minimum": 0
                },
                "delay": {
                  "type": "number",
                  "multipleOf": 1,
                  "minimum": 0
                },
                "endDelay": {
                  "type": "number",
                  "minimum": 0,
                  "multipleOf": 1
                },
                "allowReplay": {
                  "type": "string",
                  "enum": [
                    "perPageView",
                    "always",
                    "never"
                  ],
                  "default": "perPageView"
                }
              }
            },
            {
              "$ref": "#/AnimationCommonOptions--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TimeAnimation": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "A time-based animation",
          "type": "object",
          "required": [
            "name",
            "value"
          ],
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ScrubAnimationOptions": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Common options for a Scrub Animation: duration, start offset, end offset and all Common Animation Options",
          "type": "object",
          "allOf": [
            {
              "properties": {
                "duration": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
                },
                "startOffset": {
                  "$ref": "#/RangeOffset"
                },
                "endOffset": {
                  "$ref": "#/RangeOffset"
                },
                "centeredToTarget": {
                  "type": "boolean"
                },
                "playbackRate": {
                  "type": "number",
                  "description": "Adds a lerp effect to animations",
                  "minimum": 0,
                  "maximum": 1
                },
                "transitionDuration": {
                  "type": "number",
                  "minimum": 0
                },
                "transitionDelay": {
                  "type": "number",
                  "minimum": 0
                },
                "transitionEasing": {
                  "$ref": "#/Easing"
                }
              }
            },
            {
              "$ref": "#/AnimationCommonOptions--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ScrubAnimation": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "A Scrub Animation",
          "type": "object",
          "required": [
            "name",
            "value"
          ],
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AnimationCommonOptions": {
      "description": "Common options for all animations: named effect, keyframe effect, easing, iterations, alternate, fill, reversed",
      "type": "object",
      "oneOf": [
        {
          "type": "object",
          "required": [
            "keyframeEffect"
          ]
        },
        {
          "type": "object",
          "required": [
            "namedEffect"
          ]
        },
        {
          "type": "object",
          "not": {
            "anyOf": [
              {
                "type": "object",
                "required": [
                  "keyframeEffect"
                ]
              },
              {
                "type": "object",
                "required": [
                  "namedEffect"
                ]
              }
            ]
          }
        }
      ],
      "properties": {
        "keyframeEffect": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "namedEffect": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "customEffect": {
          "type": "object",
          "required": [
            "ranges"
          ],
          "properties": {
            "ranges": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "name",
                  "min",
                  "max"
                ],
                "properties": {
                  "name": {
                    "type": "string",
                    "enum": [
                      "offset",
                      "intensity",
                      "mouse",
                      "scroll",
                      "mouseIntensity"
                    ]
                  },
                  "min": {
                    "type": "number",
                    "default": 0
                  },
                  "max": {
                    "type": "number",
                    "default": 1
                  },
                  "step": {
                    "type": "number"
                  }
                },
                "unevaluatedProperties": false
              },
              "maxItems": 10,
              "minItems": 1
            }
          },
          "unevaluatedProperties": false
        },
        "easing": {
          "$ref": "#/Easing"
        },
        "iterations": {
          "type": "number",
          "minimum": 0,
          "default": 1
        },
        "alternate": {
          "type": "boolean"
        },
        "fill": {
          "type": "string",
          "enum": [
            "none",
            "backwards",
            "forwards",
            "both"
          ]
        },
        "reversed": {
          "type": "boolean"
        }
      },
      "unevaluatedProperties": false
    },
    "RangeOffset": {
      "description": "Scrub animation range and offset",
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "enum": [
            "entry",
            "exit",
            "contain",
            "cover"
          ]
        },
        "offset": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
        }
      },
      "unevaluatedProperties": false
    },
    "Easing": {
      "description": "Easing function names",
      "type": "string",
      "enum": [
        "linear",
        "ease",
        "easeIn",
        "easeOut",
        "easeInOut",
        "sineIn",
        "sineOut",
        "sineInOut",
        "quadIn",
        "quadOut",
        "quadInOut",
        "cubicIn",
        "cubicOut",
        "cubicInOut",
        "quartIn",
        "quartOut",
        "quartInOut",
        "quintIn",
        "quintOut",
        "quintInOut",
        "expoIn",
        "expoOut",
        "expoInOut",
        "circIn",
        "circOut",
        "circInOut",
        "backIn",
        "backOut",
        "backInOut",
        "hardBackOut"
      ]
    },
    "EffectPower": {
      "type": "string",
      "enum": [
        "soft",
        "medium",
        "hard"
      ]
    },
    "EffectScrollRange": {
      "type": "string",
      "enum": [
        "in",
        "out",
        "continuous"
      ]
    },
    "EffectScaleDirection": {
      "type": "string",
      "enum": [
        "up",
        "down"
      ]
    },
    "EffectFourDirections": {
      "type": "string",
      "enum": [
        "left",
        "right",
        "top",
        "bottom"
      ]
    },
    "EffectFourCorners": {
      "type": "string",
      "enum": [
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
      ]
    },
    "EffectEightDirections": {
      "type": "string",
      "enum": [
        "right",
        "top-right",
        "top",
        "top-left",
        "left",
        "bottom-left",
        "bottom",
        "bottom-right"
      ]
    },
    "EffectNineDirections": {
      "type": "string",
      "enum": [
        "right",
        "top-right",
        "top",
        "top-left",
        "left",
        "bottom-left",
        "bottom",
        "bottom-right",
        "center"
      ]
    },
    "EffectAxes": {
      "type": "string",
      "enum": [
        "horizontal",
        "vertical",
        "both"
      ]
    },
    "ArcIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CurveIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Previous version of ArcIn",
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DropIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialScale"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "initialScale": {
              "type": "number",
              "minimum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ExpandIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialScale",
                "direction"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "$ref": "#/EffectNineDirections"
            },
            "initialScale": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FadeIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlipIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialRotate",
                "direction"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "initialRotate": {
              "type": "number",
              "minimum": 0,
              "maximum": 90
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FloatIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ShuttersIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction",
            "shutters"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "shutters": {
              "type": "number",
              "minimum": 2
            },
            "staggered": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FoldIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialRotate",
                "direction"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "initialRotate": {
              "type": "number",
              "minimum": 0,
              "maximum": 90
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SlideIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialTranslate",
                "direction"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "initialTranslate": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SpinIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction",
                "spins"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialScale",
                "direction",
                "spins"
              ]
            }
          ],
          "properties": {
            "spins": {
              "type": "number",
              "minimum": 0.25
            },
            "direction": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "initialScale": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BounceIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "distanceFactor",
                "direction"
              ]
            }
          ],
          "properties": {
            "direction": {
              "anyOf": [
                {
                  "$ref": "#/EffectFourDirections--unrestricted-root"
                },
                {
                  "type": "string",
                  "enum": [
                    "center"
                  ]
                }
              ]
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "distanceFactor": {
              "type": "number",
              "minimum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PunchIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Previous version of BounceIn",
          "type": "object",
          "properties": {
            "direction": {
              "anyOf": [
                {
                  "$ref": "#/EffectFourCorners--unrestricted-root"
                },
                {
                  "type": "string",
                  "enum": [
                    "center"
                  ]
                }
              ]
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GlideIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction",
            "distance"
          ],
          "properties": {
            "direction": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "startFromOffScreen": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GlitchIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction",
            "distance"
          ],
          "properties": {
            "direction": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "startFromOffScreen": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TurnIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourCorners"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CircleIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Previous version of TurnIn",
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WinkIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TiltIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ShapeIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "shape",
            "direction"
          ],
          "properties": {
            "shape": {
              "type": "string",
              "enum": [
                "ellipse",
                "circle",
                "rectangle",
                "diamond",
                "window"
              ]
            },
            "direction": {
              "$ref": "#/EffectNineDirections"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GrowIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "distance",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialScale",
                "distance",
                "direction"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "initialScale": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlyIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectEightDirections"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RevealIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BlurIn": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "blur"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "blur": {
              "type": "number",
              "minimum": 0
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Breathe": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction",
            "distance"
          ],
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal",
                "center"
              ]
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Blink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "distance",
                "scale"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "scale": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Pulse": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Spin": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Poke": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity",
                "direction"
              ]
            }
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Flash": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Swing": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "swing"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "swing": {
              "type": "number"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Flip": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Rubber": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Fold": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "angle",
                "direction"
              ]
            }
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "angle": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Jello": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Wiggle": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Bounce": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Cross": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectEightDirections"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DVD": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "power"
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ArcScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "direction": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BlurScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "blur"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "blur": {
              "type": "number",
              "minimum": 0
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FadeScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlipScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "direction",
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "direction",
                "rotate"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "rotate": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GrowScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "scale"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "distance": {
              "type": "number"
            },
            "speed": {
              "type": "number"
            },
            "direction": {
              "$ref": "#/EffectNineDirections"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MoveScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "angle"
              ]
            },
            {
              "type": "object",
              "required": [
                "distance",
                "angle"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PanScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction",
            "distance",
            "startFromOffScreen"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "startFromOffScreen": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ParallaxScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "speed"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "speed": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RevealScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ShapeScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "shape"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity",
                "shape"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "shape": {
              "type": "string",
              "enum": [
                "ellipse",
                "circle",
                "rectangle",
                "diamond",
                "window"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ShrinkScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "scale"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "distance": {
              "type": "number"
            },
            "speed": {
              "type": "number"
            },
            "direction": {
              "$ref": "#/EffectNineDirections"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ShuttersScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "shutters",
            "direction"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "shutters": {
              "type": "number",
              "minimum": 2
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "staggered": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SkewPanScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "direction",
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "direction",
                "skew"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            },
            "skew": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SlideScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Spin3dScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "rotate"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "rotate": {
              "type": "number"
            },
            "distance": {
              "type": "number"
            },
            "speed": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SpinScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "direction",
                "spins",
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "direction",
                "spins",
                "scale"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "spins": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StretchScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "stretch"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "stretch": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TiltScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            },
            "distance": {
              "type": "number"
            },
            "speed": {
              "type": "number"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TurnScroll": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "direction",
                "spin",
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "direction",
                "spin",
                "scale"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "spin": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TrackMouse": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "axis": {
              "$ref": "#/EffectAxes"
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Tilt3DMouse": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "angle",
                "perspective"
              ]
            },
            {
              "type": "object",
              "required": [
                "power"
              ]
            }
          ],
          "properties": {
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 90
            },
            "perspective": {
              "type": "number",
              "minimum": 0
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SwivelMouse": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "angle",
                "perspective"
              ]
            },
            {
              "type": "object",
              "required": [
                "power"
              ]
            }
          ],
          "properties": {
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 90
            },
            "perspective": {
              "type": "number",
              "minimum": 0
            },
            "inverted": {
              "type": "boolean"
            },
            "pivotAxis": {
              "type": "string",
              "enum": [
                "center-vertical",
                "center-horizontal",
                "top",
                "bottom",
                "left",
                "right"
              ]
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BlobMouse": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "scale"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ScaleMouse": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "scaleDirection"
              ]
            },
            {
              "type": "object",
              "required": [
                "scale"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "axis": {
              "$ref": "#/EffectAxes"
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "scaleDirection": {
              "$ref": "#/EffectScaleDirection"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Track3DMouse": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "angle",
                "perspective"
              ]
            },
            {
              "type": "object",
              "required": [
                "power"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "angle": {
              "type": "number",
              "minimum": -90,
              "maximum": 90
            },
            "perspective": {
              "type": "number",
              "minimum": 0
            },
            "axis": {
              "$ref": "#/EffectAxes"
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AiryMouse": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "angle"
              ]
            },
            {
              "type": "object",
              "required": [
                "power"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "angle": {
              "type": "number",
              "minimum": -90,
              "maximum": 90
            },
            "axis": {
              "$ref": "#/EffectAxes"
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BlurMouse": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "angle",
                "scale"
              ]
            }
          ],
          "properties": {
            "blur": {
              "type": "number",
              "minimum": 1
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "angle": {
              "type": "number",
              "minimum": -90,
              "maximum": 90
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SkewMouse": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "angle"
              ]
            },
            {
              "type": "object",
              "required": [
                "power"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "axis": {
              "$ref": "#/EffectAxes"
            },
            "angle": {
              "type": "number",
              "minimum": -90,
              "maximum": 90
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgCloseUp": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgFade": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "range"
          ],
          "properties": {
            "range": {
              "type": "string",
              "enum": [
                "in",
                "out"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgFadeBack": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgFake3D": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "zoom": {
              "type": "number"
            },
            "stretch": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgPan": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "speed": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgParallax": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "speed": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgPullBack": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgReveal": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgRotate": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "angle": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgSkew": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "angle": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BgZoom": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "zoom": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "in",
                "out"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageParallax": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "speed": {
              "type": "number"
            },
            "inverted": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Kaleidoscope": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "segments": {
              "type": "number"
            },
            "rotation": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RGBSplit": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "splitType": {
              "type": "string",
              "enum": [
                "all",
                "red-cyan",
                "green-magenta",
                "blue-yellow"
              ]
            },
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "intensity": {
              "type": "number"
            },
            "frequency": {
              "type": "number"
            },
            "octaves": {
              "type": "number",
              "minimum": 1
            },
            "speed": {
              "type": "number"
            },
            "radius": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RGBOrb": {
      "$ref": "#/RGBSplit"
    },
    "SlitScan": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "speed": {
              "type": "number"
            },
            "intensity": {
              "type": "number"
            },
            "frequency": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "x",
                "y"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "NoisyTrack": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "radius": {
              "type": "number"
            },
            "spread": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Smear": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "radius": {
              "type": "number"
            },
            "intensity": {
              "type": "number"
            },
            "duration": {
              "type": "number",
              "minimum": 1
            },
            "decayPower": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Ripples": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "frequency": {
              "type": "number"
            },
            "octaves": {
              "type": "number",
              "minimum": 1
            },
            "aspectRatio": {
              "type": "number"
            },
            "intensity": {
              "type": "number"
            },
            "speed": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "KeyframeEffect--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "An Effect that is a list of custom Keyframe animations",
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "keyframes": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": {
                  "type": [
                    "string"
                  ]
                },
                "properties": {
                  "offset": {
                    "type": "number"
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "type": "object"
    },
    "EffectsList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Ref List of different types of Animation Effects",
          "type": "object",
          "properties": {
            "values": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "CanvasAnimation--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "A canvas-based animation",
          "type": "object",
          "required": [
            "name",
            "value"
          ],
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "CanvasAnimationOptions--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Properties of canvas-based animations",
          "type": "object",
          "properties": {
            "namedEffect": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TimeAnimationOptions--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Properties of a time-based animation: duration, delay, end-delay, replay type and all Base Animation Properties",
          "type": "object",
          "allOf": [
            {
              "properties": {
                "duration": {
                  "type": "number",
                  "multipleOf": 1,
                  "minimum": 0
                },
                "delay": {
                  "type": "number",
                  "multipleOf": 1,
                  "minimum": 0
                },
                "endDelay": {
                  "type": "number",
                  "minimum": 0,
                  "multipleOf": 1
                },
                "allowReplay": {
                  "type": "string",
                  "enum": [
                    "perPageView",
                    "always",
                    "never"
                  ],
                  "default": "perPageView"
                }
              }
            },
            {
              "$ref": "#/AnimationCommonOptions--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "TimeAnimation--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "A time-based animation",
          "type": "object",
          "required": [
            "name",
            "value"
          ],
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "ScrubAnimationOptions--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Common options for a Scrub Animation: duration, start offset, end offset and all Common Animation Options",
          "type": "object",
          "allOf": [
            {
              "properties": {
                "duration": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
                },
                "startOffset": {
                  "$ref": "#/RangeOffset"
                },
                "endOffset": {
                  "$ref": "#/RangeOffset"
                },
                "centeredToTarget": {
                  "type": "boolean"
                },
                "playbackRate": {
                  "type": "number",
                  "description": "Adds a lerp effect to animations",
                  "minimum": 0,
                  "maximum": 1
                },
                "transitionDuration": {
                  "type": "number",
                  "minimum": 0
                },
                "transitionDelay": {
                  "type": "number",
                  "minimum": 0
                },
                "transitionEasing": {
                  "$ref": "#/Easing"
                }
              }
            },
            {
              "$ref": "#/AnimationCommonOptions--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ScrubAnimation--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "A Scrub Animation",
          "type": "object",
          "required": [
            "name",
            "value"
          ],
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "AnimationCommonOptions--unrestricted-root": {
      "description": "Common options for all animations: named effect, keyframe effect, easing, iterations, alternate, fill, reversed",
      "type": "object",
      "oneOf": [
        {
          "type": "object",
          "required": [
            "keyframeEffect"
          ]
        },
        {
          "type": "object",
          "required": [
            "namedEffect"
          ]
        },
        {
          "type": "object",
          "not": {
            "anyOf": [
              {
                "type": "object",
                "required": [
                  "keyframeEffect"
                ]
              },
              {
                "type": "object",
                "required": [
                  "namedEffect"
                ]
              }
            ]
          }
        }
      ],
      "properties": {
        "keyframeEffect": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "namedEffect": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "customEffect": {
          "type": "object",
          "required": [
            "ranges"
          ],
          "properties": {
            "ranges": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "name",
                  "min",
                  "max"
                ],
                "properties": {
                  "name": {
                    "type": "string",
                    "enum": [
                      "offset",
                      "intensity",
                      "mouse",
                      "scroll",
                      "mouseIntensity"
                    ]
                  },
                  "min": {
                    "type": "number",
                    "default": 0
                  },
                  "max": {
                    "type": "number",
                    "default": 1
                  },
                  "step": {
                    "type": "number"
                  }
                },
                "unevaluatedProperties": false
              },
              "maxItems": 10,
              "minItems": 1
            }
          },
          "unevaluatedProperties": false
        },
        "easing": {
          "$ref": "#/Easing"
        },
        "iterations": {
          "type": "number",
          "minimum": 0,
          "default": 1
        },
        "alternate": {
          "type": "boolean"
        },
        "fill": {
          "type": "string",
          "enum": [
            "none",
            "backwards",
            "forwards",
            "both"
          ]
        },
        "reversed": {
          "type": "boolean"
        }
      }
    },
    "RangeOffset--unrestricted-root": {
      "description": "Scrub animation range and offset",
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "enum": [
            "entry",
            "exit",
            "contain",
            "cover"
          ]
        },
        "offset": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
        }
      }
    },
    "Easing--unrestricted-root": {
      "description": "Easing function names",
      "type": "string",
      "enum": [
        "linear",
        "ease",
        "easeIn",
        "easeOut",
        "easeInOut",
        "sineIn",
        "sineOut",
        "sineInOut",
        "quadIn",
        "quadOut",
        "quadInOut",
        "cubicIn",
        "cubicOut",
        "cubicInOut",
        "quartIn",
        "quartOut",
        "quartInOut",
        "quintIn",
        "quintOut",
        "quintInOut",
        "expoIn",
        "expoOut",
        "expoInOut",
        "circIn",
        "circOut",
        "circInOut",
        "backIn",
        "backOut",
        "backInOut",
        "hardBackOut"
      ]
    },
    "EffectPower--unrestricted-root": {
      "type": "string",
      "enum": [
        "soft",
        "medium",
        "hard"
      ]
    },
    "EffectScrollRange--unrestricted-root": {
      "type": "string",
      "enum": [
        "in",
        "out",
        "continuous"
      ]
    },
    "EffectScaleDirection--unrestricted-root": {
      "type": "string",
      "enum": [
        "up",
        "down"
      ]
    },
    "EffectFourDirections--unrestricted-root": {
      "type": "string",
      "enum": [
        "left",
        "right",
        "top",
        "bottom"
      ]
    },
    "EffectFourCorners--unrestricted-root": {
      "type": "string",
      "enum": [
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
      ]
    },
    "EffectEightDirections--unrestricted-root": {
      "type": "string",
      "enum": [
        "right",
        "top-right",
        "top",
        "top-left",
        "left",
        "bottom-left",
        "bottom",
        "bottom-right"
      ]
    },
    "EffectNineDirections--unrestricted-root": {
      "type": "string",
      "enum": [
        "right",
        "top-right",
        "top",
        "top-left",
        "left",
        "bottom-left",
        "bottom",
        "bottom-right",
        "center"
      ]
    },
    "EffectAxes--unrestricted-root": {
      "type": "string",
      "enum": [
        "horizontal",
        "vertical",
        "both"
      ]
    },
    "ArcIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "CurveIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Previous version of ArcIn",
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "DropIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialScale"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "initialScale": {
              "type": "number",
              "minimum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "ExpandIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialScale",
                "direction"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "$ref": "#/EffectNineDirections"
            },
            "initialScale": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "FadeIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "FlipIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialRotate",
                "direction"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "initialRotate": {
              "type": "number",
              "minimum": 0,
              "maximum": 90
            }
          }
        }
      ],
      "type": "object"
    },
    "FloatIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            }
          }
        }
      ],
      "type": "object"
    },
    "ShuttersIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction",
            "shutters"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "shutters": {
              "type": "number",
              "minimum": 2
            },
            "staggered": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "FoldIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialRotate",
                "direction"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "initialRotate": {
              "type": "number",
              "minimum": 0,
              "maximum": 90
            }
          }
        }
      ],
      "type": "object"
    },
    "SlideIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialTranslate",
                "direction"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "initialTranslate": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "SpinIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction",
                "spins"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialScale",
                "direction",
                "spins"
              ]
            }
          ],
          "properties": {
            "spins": {
              "type": "number",
              "minimum": 0.25
            },
            "direction": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "initialScale": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "BounceIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "distanceFactor",
                "direction"
              ]
            }
          ],
          "properties": {
            "direction": {
              "anyOf": [
                {
                  "$ref": "#/EffectFourDirections--unrestricted-root"
                },
                {
                  "type": "string",
                  "enum": [
                    "center"
                  ]
                }
              ]
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "distanceFactor": {
              "type": "number",
              "minimum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "PunchIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Previous version of BounceIn",
          "type": "object",
          "properties": {
            "direction": {
              "anyOf": [
                {
                  "$ref": "#/EffectFourCorners--unrestricted-root"
                },
                {
                  "type": "string",
                  "enum": [
                    "center"
                  ]
                }
              ]
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "GlideIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction",
            "distance"
          ],
          "properties": {
            "direction": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "startFromOffScreen": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            }
          }
        }
      ],
      "type": "object"
    },
    "GlitchIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction",
            "distance"
          ],
          "properties": {
            "direction": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "startFromOffScreen": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            }
          }
        }
      ],
      "type": "object"
    },
    "TurnIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourCorners"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "CircleIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "description": "Previous version of TurnIn",
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "WinkIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "TiltIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "ShapeIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "shape",
            "direction"
          ],
          "properties": {
            "shape": {
              "type": "string",
              "enum": [
                "ellipse",
                "circle",
                "rectangle",
                "diamond",
                "window"
              ]
            },
            "direction": {
              "$ref": "#/EffectNineDirections"
            }
          }
        }
      ],
      "type": "object"
    },
    "GrowIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "distance",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "initialScale",
                "distance",
                "direction"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "initialScale": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            }
          }
        }
      ],
      "type": "object"
    },
    "FlyIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectEightDirections"
            }
          }
        }
      ],
      "type": "object"
    },
    "RevealIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            }
          }
        }
      ],
      "type": "object"
    },
    "BlurIn--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "blur"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "blur": {
              "type": "number",
              "minimum": 0
            }
          }
        }
      ],
      "type": "object"
    },
    "Breathe--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction",
            "distance"
          ],
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal",
                "center"
              ]
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            }
          }
        }
      ],
      "type": "object"
    },
    "Blink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "distance",
                "scale"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "scale": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "Pulse--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "Spin--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "Poke--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity",
                "direction"
              ]
            }
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "Flash--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "Swing--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "swing"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "swing": {
              "type": "number"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            }
          }
        }
      ],
      "type": "object"
    },
    "Flip--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "Rubber--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "Fold--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "direction"
              ]
            },
            {
              "type": "object",
              "required": [
                "angle",
                "direction"
              ]
            }
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "angle": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "Jello--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "Wiggle--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "Bounce--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity"
              ]
            }
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "Cross--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "$ref": "#/EffectEightDirections"
            }
          }
        }
      ],
      "type": "object"
    },
    "DVD--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "power"
          ],
          "properties": {
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "ArcScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "direction": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "BlurScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "blur"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "blur": {
              "type": "number",
              "minimum": 0
            }
          }
        }
      ],
      "type": "object"
    },
    "FadeScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "FlipScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "direction",
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "direction",
                "rotate"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "rotate": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "GrowScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "scale"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "distance": {
              "type": "number"
            },
            "speed": {
              "type": "number"
            },
            "direction": {
              "$ref": "#/EffectNineDirections"
            }
          }
        }
      ],
      "type": "object"
    },
    "MoveScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "angle"
              ]
            },
            {
              "type": "object",
              "required": [
                "distance",
                "angle"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            }
          }
        }
      ],
      "type": "object"
    },
    "PanScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction",
            "distance",
            "startFromOffScreen"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "startFromOffScreen": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "ParallaxScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "speed"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "speed": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "RevealScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            }
          }
        }
      ],
      "type": "object"
    },
    "ShapeScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "shape"
              ]
            },
            {
              "type": "object",
              "required": [
                "intensity",
                "shape"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "intensity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "shape": {
              "type": "string",
              "enum": [
                "ellipse",
                "circle",
                "rectangle",
                "diamond",
                "window"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "ShrinkScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "scale"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "distance": {
              "type": "number"
            },
            "speed": {
              "type": "number"
            },
            "direction": {
              "$ref": "#/EffectNineDirections"
            }
          }
        }
      ],
      "type": "object"
    },
    "ShuttersScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "shutters",
            "direction"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "shutters": {
              "type": "number",
              "minimum": 2
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            },
            "staggered": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "SkewPanScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "direction",
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "direction",
                "skew"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            },
            "skew": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "SlideScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "direction": {
              "$ref": "#/EffectFourDirections"
            }
          }
        }
      ],
      "type": "object"
    },
    "Spin3dScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "rotate"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "rotate": {
              "type": "number"
            },
            "distance": {
              "type": "number"
            },
            "speed": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "SpinScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "direction",
                "spins",
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "direction",
                "spins",
                "scale"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "spins": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            }
          }
        }
      ],
      "type": "object"
    },
    "StretchScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "stretch"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "stretch": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "TiltScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            },
            "distance": {
              "type": "number"
            },
            "speed": {
              "type": "number"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "TurnScroll--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "direction",
                "spin",
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "direction",
                "spin",
                "scale"
              ]
            }
          ],
          "properties": {
            "range": {
              "$ref": "#/EffectScrollRange"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "spin": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "TrackMouse--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "axis": {
              "$ref": "#/EffectAxes"
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "Tilt3DMouse--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "angle",
                "perspective"
              ]
            },
            {
              "type": "object",
              "required": [
                "power"
              ]
            }
          ],
          "properties": {
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 90
            },
            "perspective": {
              "type": "number",
              "minimum": 0
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "SwivelMouse--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "angle",
                "perspective"
              ]
            },
            {
              "type": "object",
              "required": [
                "power"
              ]
            }
          ],
          "properties": {
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 90
            },
            "perspective": {
              "type": "number",
              "minimum": 0
            },
            "inverted": {
              "type": "boolean"
            },
            "pivotAxis": {
              "type": "string",
              "enum": [
                "center-vertical",
                "center-horizontal",
                "top",
                "bottom",
                "left",
                "right"
              ]
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "BlobMouse--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "scale"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "ScaleMouse--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power",
                "scaleDirection"
              ]
            },
            {
              "type": "object",
              "required": [
                "scale"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "axis": {
              "$ref": "#/EffectAxes"
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            },
            "scaleDirection": {
              "$ref": "#/EffectScaleDirection"
            }
          }
        }
      ],
      "type": "object"
    },
    "Track3DMouse--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "angle",
                "perspective"
              ]
            },
            {
              "type": "object",
              "required": [
                "power"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "angle": {
              "type": "number",
              "minimum": -90,
              "maximum": 90
            },
            "perspective": {
              "type": "number",
              "minimum": 0
            },
            "axis": {
              "$ref": "#/EffectAxes"
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "AiryMouse--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "angle"
              ]
            },
            {
              "type": "object",
              "required": [
                "power"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "angle": {
              "type": "number",
              "minimum": -90,
              "maximum": 90
            },
            "axis": {
              "$ref": "#/EffectAxes"
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "BlurMouse--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "power"
              ]
            },
            {
              "type": "object",
              "required": [
                "angle",
                "scale"
              ]
            }
          ],
          "properties": {
            "blur": {
              "type": "number",
              "minimum": 1
            },
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "angle": {
              "type": "number",
              "minimum": -90,
              "maximum": 90
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "SkewMouse--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "oneOf": [
            {
              "type": "object",
              "required": [
                "angle"
              ]
            },
            {
              "type": "object",
              "required": [
                "power"
              ]
            }
          ],
          "properties": {
            "distance": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitLengthPercentage"
            },
            "axis": {
              "$ref": "#/EffectAxes"
            },
            "angle": {
              "type": "number",
              "minimum": -90,
              "maximum": 90
            },
            "inverted": {
              "type": "boolean"
            },
            "power": {
              "$ref": "#/EffectPower"
            }
          }
        }
      ],
      "type": "object"
    },
    "BgCloseUp--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "BgFade--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "range"
          ],
          "properties": {
            "range": {
              "type": "string",
              "enum": [
                "in",
                "out"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "BgFadeBack--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "BgFake3D--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "zoom": {
              "type": "number"
            },
            "stretch": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "BgPan--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "speed": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "BgParallax--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "speed": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "BgPullBack--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "BgReveal--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "BgRotate--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "angle": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "BgSkew--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "angle": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "clockwise",
                "counter-clockwise"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "BgZoom--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "direction"
          ],
          "properties": {
            "zoom": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "in",
                "out"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "ImageParallax--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "speed": {
              "type": "number"
            },
            "inverted": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "Kaleidoscope--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "segments": {
              "type": "number"
            },
            "rotation": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            }
          }
        }
      ],
      "type": "object"
    },
    "RGBSplit--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "splitType": {
              "type": "string",
              "enum": [
                "all",
                "red-cyan",
                "green-magenta",
                "blue-yellow"
              ]
            },
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "intensity": {
              "type": "number"
            },
            "frequency": {
              "type": "number"
            },
            "octaves": {
              "type": "number",
              "minimum": 1
            },
            "speed": {
              "type": "number"
            },
            "radius": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "RGBOrb--unrestricted-root": {
      "$ref": "#/RGBSplit"
    },
    "SlitScan--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "speed": {
              "type": "number"
            },
            "intensity": {
              "type": "number"
            },
            "frequency": {
              "type": "number"
            },
            "direction": {
              "type": "string",
              "enum": [
                "x",
                "y"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "NoisyTrack--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "radius": {
              "type": "number"
            },
            "spread": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "Smear--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "radius": {
              "type": "number"
            },
            "intensity": {
              "type": "number"
            },
            "duration": {
              "type": "number",
              "minimum": 1
            },
            "decayPower": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "Ripples--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoplay": {
              "type": "boolean"
            },
            "isTriggeredByMouse": {
              "type": "boolean"
            },
            "isTriggeredByScroll": {
              "type": "boolean"
            },
            "frequency": {
              "type": "number"
            },
            "octaves": {
              "type": "number",
              "minimum": 1
            },
            "aspectRatio": {
              "type": "number"
            },
            "intensity": {
              "type": "number"
            },
            "speed": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    }
  },
  "fixerVersions.json": {
    "$id": "urn:dm:schemas:fixerVersions.json",
    "FixerVersions": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "viewer_fixer": {
              "oneOf": [
                {
                  "type": "object",
                  "additionalProperties": {
                    "type": "number"
                  }
                },
                {
                  "type": "string",
                  "maxLength": 400
                }
              ]
            },
            "migration_fixer": {
              "oneOf": [
                {
                  "type": "object",
                  "additionalProperties": {
                    "type": "number"
                  }
                },
                {
                  "type": "string",
                  "maxLength": 400
                }
              ]
            },
            "ds_fixer": {
              "oneOf": [
                {
                  "type": "object",
                  "additionalProperties": {
                    "type": "number"
                  }
                },
                {
                  "type": "string",
                  "maxLength": 400
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FixerVersions--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "viewer_fixer": {
              "oneOf": [
                {
                  "type": "object",
                  "additionalProperties": {
                    "type": "number"
                  }
                },
                {
                  "type": "string",
                  "maxLength": 400
                }
              ]
            },
            "migration_fixer": {
              "oneOf": [
                {
                  "type": "object",
                  "additionalProperties": {
                    "type": "number"
                  }
                },
                {
                  "type": "string",
                  "maxLength": 400
                }
              ]
            },
            "ds_fixer": {
              "oneOf": [
                {
                  "type": "object",
                  "additionalProperties": {
                    "type": "number"
                  }
                },
                {
                  "type": "string",
                  "maxLength": 400
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "grouping.json": {
    "$id": "urn:dm:schemas:grouping.json",
    "GroupRelation": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "groupId": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GroupRelation--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "groupId": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "innerElements.json": {
    "$id": "urn:dm:schemas:innerElements.json",
    "InnerElementQueries": {
      "type": "object",
      "properties": {
        "bindings": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "dataQuery": {
          "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
        },
        "innerElementsQuery": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "presetsQuery": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "slotsQuery": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "styleId": {
          "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
        }
      },
      "unevaluatedProperties": false
    },
    "InnerElement": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "allOf": [
            {
              "type": "object",
              "required": [
                "referredType"
              ],
              "properties": {
                "referredType": {
                  "type": "string"
                }
              }
            },
            {
              "type": "object",
              "$ref": "#/InnerElementQueries--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "InnerElementQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "bindings": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "dataQuery": {
          "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
        },
        "innerElementsQuery": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "presetsQuery": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "slotsQuery": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        },
        "styleId": {
          "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
        }
      }
    },
    "InnerElement--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "allOf": [
            {
              "type": "object",
              "required": [
                "referredType"
              ],
              "properties": {
                "referredType": {
                  "type": "string"
                }
              }
            },
            {
              "type": "object",
              "$ref": "#/InnerElementQueries--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    }
  },
  "intent.json": {
    "$id": "urn:dm:schemas:intent.json",
    "Intent": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "intent"
          ],
          "properties": {
            "intent": {
              "type": "string",
              "maxLength": 30
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Intent--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "intent"
          ],
          "properties": {
            "intent": {
              "type": "string",
              "maxLength": 30
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "layoutSettings.json": {
    "$id": "urn:dm:schemas:layoutSettings.json",
    "LayoutSettings": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoResponsivenessSettings": {
              "type": "object",
              "properties": {
                "mode": {
                  "enum": [
                    "adaptive"
                  ]
                },
                "lastGroupingsHash": {
                  "type": "string"
                },
                "lastMobileAlgoVersion": {
                  "type": "string"
                },
                "isSynced": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "type": {
              "enum": [
                "LayoutSettings"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "LayoutSettings--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "autoResponsivenessSettings": {
              "type": "object",
              "properties": {
                "mode": {
                  "enum": [
                    "adaptive"
                  ]
                },
                "lastGroupingsHash": {
                  "type": "string"
                },
                "lastMobileAlgoVersion": {
                  "type": "string"
                },
                "isSynced": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "type": {
              "enum": [
                "LayoutSettings"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    }
  },
  "layout_data.json": {
    "$id": "urn:dm:schemas:layout_data.json",
    "KeywordSize": {
      "type": "object",
      "required": [
        "type"
      ],
      "properties": {
        "type": {
          "enum": [
            "auto",
            "maxContent",
            "minContent",
            "unset",
            "fit"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "Calculation": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "type": {
          "enum": [
            "Calc"
          ]
        },
        "value": {
          "type": "string"
        }
      },
      "unevaluatedProperties": false
    },
    "CalculationFormula": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "additionalProperties": false,
      "properties": {
        "type": {
          "enum": [
            "CalcFormula"
          ]
        },
        "value": {
          "type": "object",
          "required": [
            "formula",
            "values"
          ],
          "properties": {
            "formula": {
              "type": "string",
              "description": "A valid css calc formula, with constants formatted like ${constName}"
            },
            "values": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "anyOf": [
                  {
                    "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                  },
                  {
                    "$ref": "#/SystemVariableSize"
                  },
                  {
                    "$ref": "#/NumberSize"
                  }
                ]
              },
              "minProperties": 1,
              "properties": {},
              "unevaluatedProperties": false
            }
          },
          "unevaluatedProperties": false
        }
      },
      "unevaluatedProperties": false
    },
    "AspectRatioSize": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "type": {
          "enum": [
            "aspectRatio"
          ]
        },
        "value": {
          "type": "number"
        }
      },
      "unevaluatedProperties": false
    },
    "SystemVariableSize": {
      "type": "object",
      "required": [
        "type",
        "value"
      ],
      "properties": {
        "type": {
          "enum": [
            "SystemVariable"
          ]
        },
        "value": {
          "enum": [
            "siteWidth",
            "topBannerHeight"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "NumberSize": {
      "type": "object",
      "required": [
        "type",
        "value"
      ],
      "properties": {
        "type": {
          "enum": [
            "Number"
          ]
        },
        "value": {
          "type": "number"
        }
      },
      "unevaluatedProperties": false
    },
    "LayoutSize": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize--unrestricted-root"
        },
        {
          "$ref": "#/Calculation--unrestricted-root"
        },
        {
          "$ref": "#/CalculationFormula--unrestricted-root"
        },
        {
          "$ref": "#/SystemVariableSize--unrestricted-root"
        },
        {
          "$ref": "#/KeywordSize--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "SpxStopper": {
      "type": "object",
      "properties": {
        "min": {
          "$ref": "#/LayoutSize"
        },
        "max": {
          "$ref": "#/LayoutSize"
        }
      },
      "unevaluatedProperties": false
    },
    "StretchWithSoftMargins": {
      "type": "object",
      "required": [
        "type",
        "value"
      ],
      "properties": {
        "type": {
          "enum": [
            "StretchWithSoftMargins"
          ]
        },
        "value": {
          "type": "object",
          "properties": {
            "margins": {
              "type": "object",
              "properties": {
                "left": {
                  "$ref": "#/LayoutSize"
                },
                "right": {
                  "$ref": "#/LayoutSize"
                }
              },
              "unevaluatedProperties": false
            }
          },
          "unevaluatedProperties": false
        }
      },
      "unevaluatedProperties": false
    },
    "Height": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "#/AspectRatioSize--unrestricted-root"
        },
        {
          "$ref": "#/LayoutSize--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "MinMaxSize": {
      "type": "object",
      "required": [
        "min",
        "max",
        "type"
      ],
      "properties": {
        "type": {
          "type": "string",
          "default": "MinMaxSize"
        },
        "min": {
          "$ref": "#/LayoutSize"
        },
        "max": {
          "$ref": "#/LayoutSize"
        }
      },
      "unevaluatedProperties": false
    },
    "GridTrackSize": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "min": {
          "$ref": "#/LayoutSize"
        },
        "max": {
          "$ref": "#/LayoutSize"
        },
        "value": {
          "type": [
            "string",
            "number",
            "array"
          ],
          "items": {
            "$ref": "#/BaseGridTrackSize"
          }
        },
        "length": {
          "type": "string",
          "anyOf": [
            {
              "type": "number",
              "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable--unrestricted-root"
            },
            {
              "type": "string",
              "$ref": "#/KeywordLength--unrestricted-root"
            }
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "BaseGridTrackSize": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "min": {
          "$ref": "#/LayoutSize"
        },
        "max": {
          "$ref": "#/LayoutSize"
        },
        "value": {
          "type": [
            "string",
            "number"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "KeywordLength": {
      "enum": [
        "auto-fill",
        "auto-fit"
      ]
    },
    "ItemsAlignment": {
      "type": "string",
      "enum": [
        "start",
        "end",
        "center",
        "stretch",
        "content"
      ]
    },
    "ContainerLayoutIntent": {
      "type": "object",
      "properties": {
        "layoutIntent": {
          "type": "string",
          "enum": [
            "Rows",
            "Cols",
            "Mosaic",
            "Slider",
            "SlideShow",
            "Bricks"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "Alignment": {
      "type": "string",
      "enum": [
        "auto",
        "stretch",
        "start",
        "center",
        "end"
      ]
    },
    "Direction": {
      "enum": [
        "rtl",
        "ltr"
      ]
    },
    "Margins": {
      "type": "object",
      "properties": {
        "top": {
          "$ref": "#/LayoutSize"
        },
        "bottom": {
          "$ref": "#/LayoutSize"
        },
        "left": {
          "$ref": "#/LayoutSize"
        },
        "right": {
          "$ref": "#/LayoutSize"
        }
      },
      "unevaluatedProperties": false
    },
    "Padding": {
      "type": "object",
      "properties": {
        "top": {
          "$ref": "#/LayoutSize"
        },
        "bottom": {
          "$ref": "#/LayoutSize"
        },
        "left": {
          "$ref": "#/LayoutSize"
        },
        "right": {
          "$ref": "#/LayoutSize"
        }
      },
      "unevaluatedProperties": false
    },
    "FlexDirection": {
      "enum": [
        "row",
        "rowReverse",
        "column",
        "columnReverse"
      ]
    },
    "FlexWrap": {
      "enum": [
        "nowrap",
        "wrap"
      ]
    },
    "Overflow": {
      "enum": [
        "auto",
        "scroll",
        "hidden",
        "visible",
        "clip"
      ]
    },
    "Contain": {
      "enum": [
        "none",
        "paint"
      ]
    },
    "AutoFlow": {
      "enum": [
        "row",
        "column",
        "dense",
        "row dense",
        "column dense"
      ]
    },
    "JustifyContent": {
      "enum": [
        "start",
        "center",
        "end",
        "spaceBetween",
        "spaceAround",
        "spaceEvenly"
      ]
    },
    "AlignContent": {
      "enum": [
        "start",
        "center",
        "end",
        "spaceBetween",
        "spaceAround",
        "spaceEvenly"
      ]
    },
    "GridArea": {
      "type": "object",
      "required": [
        "rowStart",
        "rowEnd",
        "columnStart",
        "columnEnd"
      ],
      "properties": {
        "rowStart": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable"
        },
        "columnStart": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable"
        },
        "rowEnd": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable"
        },
        "columnEnd": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable"
        }
      },
      "unevaluatedProperties": false
    },
    "LayoutData": {
      "type": "object",
      "properties": {
        "componentLayouts": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "itemLayouts": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "containerLayouts": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "SingleLayoutData": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/contentMaxWidth\\/maxWidth|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/contentMaxWidth\\/maxWidth|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:componentLayout\\/height)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:componentLayout\\/height)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:itemLayout\\/position|containerLayout\\/position)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:itemLayout\\/position|containerLayout\\/position)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:itemLayout\\/gridArea\\/rowStart|itemLayout\\/gridArea\\/columnStart|itemLayout\\/gridArea\\/rowEnd|itemLayout\\/gridArea\\/columnEnd|containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:itemLayout\\/gridArea\\/rowStart|itemLayout\\/gridArea\\/columnStart|itemLayout\\/gridArea\\/rowEnd|itemLayout\\/gridArea\\/columnEnd|containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:itemLayout\\/alignSelf|itemLayout\\/justifySelf|containerLayout\\/alignItems)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:itemLayout\\/alignSelf|itemLayout\\/justifySelf|containerLayout\\/alignItems)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:containerLayout\\/justifyContent)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:containerLayout\\/justifyContent)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "itemLayout",
            "componentLayout",
            "containerLayout"
          ],
          "properties": {
            "componentLayout": {
              "type": "object",
              "default": {},
              "anyOf": [
                {
                  "$ref": "#/ComponentLayout--unrestricted-root"
                },
                {
                  "$ref": "#/ClassicComponentLayout--unrestricted-root"
                }
              ],
              "unevaluatedProperties": false
            },
            "itemLayout": {
              "type": "object",
              "default": {},
              "anyOf": [
                {
                  "$ref": "#/GridItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/FixedItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/FlexItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/OrganizerItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/StackItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/MultiColumnsItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/BackgroundLayerItemLayout--unrestricted-root"
                }
              ],
              "unevaluatedProperties": false
            },
            "containerLayout": {
              "type": "object",
              "default": {},
              "anyOf": [
                {
                  "$ref": "#/GridContainerLayout--unrestricted-root"
                },
                {
                  "$ref": "#/FlexContainerLayout--unrestricted-root"
                },
                {
                  "$ref": "#/OrganizerContainerLayout--unrestricted-root"
                },
                {
                  "$ref": "#/StackContainerLayout--unrestricted-root"
                },
                {
                  "$ref": "#/MultiColumnsContainerLayout--unrestricted-root"
                }
              ],
              "unevaluatedProperties": false
            },
            "spx": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/SPXReferenceDefinition"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ScrollSnapType": {
      "enum": [
        "mandatory",
        "proximity",
        "none"
      ]
    },
    "ScrollSnapDirection": {
      "enum": [
        "x",
        "y"
      ]
    },
    "ScrollBehavior": {
      "enum": [
        "auto",
        "smooth"
      ]
    },
    "ScrollSnapAlignType": {
      "enum": [
        "center",
        "end",
        "start",
        "none"
      ]
    },
    "ScrollSnapData": {
      "type": "object",
      "properties": {
        "scrollSnapType": {
          "$ref": "#/ScrollSnapType"
        },
        "scrollSnapDirection": {
          "$ref": "#/ScrollSnapDirection"
        }
      },
      "unevaluatedProperties": false
    },
    "ContentMaxWidth": {
      "type": "object",
      "properties": {
        "maxWidth": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
        },
        "align": {
          "type": "string",
          "enum": [
            "center",
            "right",
            "left"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "GridContainerLayout": {
      "type": "object",
      "required": [
        "rows",
        "columns"
      ],
      "properties": {
        "rows": {
          "type": "array",
          "items": {
            "$ref": "#/GridTrackSize"
          }
        },
        "columns": {
          "type": "array",
          "items": {
            "$ref": "#/GridTrackSize"
          }
        },
        "rowGap": {
          "$ref": "#/LayoutSize"
        },
        "columnGap": {
          "$ref": "#/LayoutSize"
        },
        "autoRows": {
          "type": "array",
          "items": {
            "$ref": "#/GridTrackSize"
          }
        },
        "autoColumns": {
          "type": "array",
          "items": {
            "$ref": "#/GridTrackSize"
          }
        },
        "autoFlow": {
          "$ref": "#/AutoFlow"
        },
        "overflowY": {
          "$ref": "#/Overflow"
        },
        "overflowX": {
          "$ref": "#/Overflow"
        },
        "hideScrollbar": {
          "type": "boolean"
        },
        "padding": {
          "$ref": "#/Padding"
        },
        "scrollSnap": {
          "$ref": "#/ScrollSnapData"
        },
        "scrollBehavior": {
          "$ref": "#/ScrollBehavior"
        },
        "contentMaxWidth": {
          "$ref": "#/ContentMaxWidth"
        },
        "type": {
          "type": "string",
          "enum": [
            "GridContainerLayout"
          ]
        },
        "contain": {
          "$ref": "#/Contain"
        },
        "spxStopper": {
          "$ref": "#/SpxStopper"
        }
      },
      "unevaluatedProperties": false
    },
    "ComponentLayout": {
      "allOf": [
        {
          "$ref": "#/BaseComponentLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "ComponentLayout"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ClassicComponentLayout": {
      "allOf": [
        {
          "$ref": "#/BaseComponentLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "ClassicComponentLayout"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BaseComponentLayout": {
      "type": "object",
      "properties": {
        "containerType": {
          "type": "string",
          "enum": [
            "inline-size"
          ],
          "description": "The css container type. This property is correct for normal components as well as containers,is used to define the type of containment used in a css container query."
        },
        "width": {
          "type": "object",
          "oneOf": [
            {
              "$ref": "#/LayoutSize--unrestricted-root"
            },
            {
              "$ref": "#/StretchWithSoftMargins--unrestricted-root"
            }
          ],
          "unevaluatedProperties": false
        },
        "height": {
          "$ref": "#/Height"
        },
        "minWidth": {
          "$ref": "#/LayoutSize"
        },
        "minHeight": {
          "$ref": "#/LayoutSize"
        },
        "maxWidth": {
          "$ref": "#/LayoutSize"
        },
        "maxHeight": {
          "$ref": "#/LayoutSize"
        },
        "margins": {
          "$ref": "#/Margins"
        },
        "direction": {
          "$ref": "#/Direction"
        },
        "rotationInDegrees": {
          "type": "number"
        },
        "fixed": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        }
      },
      "unevaluatedProperties": false
    },
    "GridItemLayout": {
      "allOf": [
        {
          "$ref": "#/BaseItemLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "gridArea": {
              "$ref": "#/GridArea"
            },
            "alignSelf": {
              "$ref": "#/ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "#/ItemsAlignment"
            },
            "type": {
              "type": "string",
              "enum": [
                "GridItemLayout"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FixedItemLayout": {
      "allOf": [
        {
          "$ref": "#/BaseItemLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "alignSelf": {
              "$ref": "#/ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "#/ItemsAlignment"
            },
            "type": {
              "type": "string",
              "enum": [
                "FixedItemLayout"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BackgroundLayerItemLayout": {
      "allOf": [
        {
          "$ref": "#/BaseItemLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "alignSelf": {
              "$ref": "#/ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "#/ItemsAlignment"
            },
            "type": {
              "type": "string",
              "enum": [
                "BackgroundLayerItemLayout"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlexContainerLayoutBase": {
      "allOf": [
        {
          "$ref": "#/BaseItemLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/FlexDirection"
            },
            "wrap": {
              "$ref": "#/FlexWrap"
            },
            "alignItems": {
              "$ref": "#/ItemsAlignment"
            },
            "justifyContent": {
              "$ref": "#/JustifyContent"
            },
            "alignContent": {
              "$ref": "#/AlignContent"
            },
            "overflowY": {
              "$ref": "#/Overflow"
            },
            "overflowX": {
              "$ref": "#/Overflow"
            },
            "hideScrollbar": {
              "type": "boolean"
            },
            "padding": {
              "$ref": "#/Padding"
            },
            "scrollSnap": {
              "$ref": "#/ScrollSnapData"
            },
            "scrollBehaviour": {
              "$ref": "#/ScrollBehavior"
            },
            "contentMaxWidth": {
              "$ref": "#/ContentMaxWidth"
            },
            "spxStopper": {
              "$ref": "#/SpxStopper"
            },
            "rowGap": {
              "$ref": "#/LayoutSize"
            },
            "columnGap": {
              "$ref": "#/LayoutSize"
            },
            "contain": {
              "$ref": "#/Contain"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlexContainerLayout": {
      "allOf": [
        {
          "$ref": "#/FlexContainerLayoutBase--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "FlexContainerLayout"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlexItemLayoutBase": {
      "allOf": [
        {
          "$ref": "#/BaseItemLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "order": {
              "type": "number"
            },
            "alignSelf": {
              "$ref": "#/ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "#/ItemsAlignment"
            },
            "basis": {
              "$ref": "#/LayoutSize"
            },
            "grow": {
              "type": "number"
            },
            "shrink": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlexItemLayout": {
      "allOf": [
        {
          "$ref": "#/FlexItemLayoutBase--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "FlexItemLayout"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "OrganizerContainerLayout": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/ContainerLayoutIntent--unrestricted-root"
        },
        {
          "$ref": "#/FlexContainerLayoutBase--unrestricted-root"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "OrganizerContainerLayout"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "MultiColumnsContainerLayout": {
      "type": "object",
      "required": [
        "columnCount",
        "type"
      ],
      "properties": {
        "alignContent": {
          "$ref": "#/Alignment"
        },
        "columnCount": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        },
        "padding": {
          "$ref": "#/Padding"
        },
        "rowGap": {
          "$ref": "#/LayoutSize"
        },
        "columnGap": {
          "$ref": "#/LayoutSize"
        },
        "spxStopper": {
          "$ref": "#/SpxStopper"
        },
        "type": {
          "type": "string",
          "enum": [
            "MultiColumnsContainerLayout"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "MultiColumnsItemLayout": {
      "type": "object",
      "required": [
        "type"
      ],
      "properties": {
        "margins": {
          "$ref": "#/Margins"
        },
        "type": {
          "type": "string",
          "enum": [
            "MultiColumnsItemLayout"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "OrganizerItemLayout": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/FlexItemLayoutBase--unrestricted-root"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "OrganizerItemLayout"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "StackContainerLayout": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/FlexContainerLayoutBase--unrestricted-root"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "StackContainerLayout"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "StackItemLayout": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/FlexItemLayoutBase--unrestricted-root"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "StackItemLayout"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "LayoutDataItem": {
      "type": "object",
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "BaseItemLayout": {
      "allOf": [
        {
          "$ref": "#/LayoutDataItem--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "scrollSnapAlign": {
              "$ref": "#/ScrollSnapAlignType"
            },
            "pinnedToContainer": {
              "type": "boolean"
            },
            "margins": {
              "$ref": "#/Margins"
            },
            "position": {
              "$ref": "#/PositionType"
            },
            "isInFront": {
              "type": "boolean"
            },
            "top": {
              "$ref": "#/LayoutSize"
            },
            "bottom": {
              "$ref": "#/LayoutSize"
            },
            "left": {
              "$ref": "#/LayoutSize"
            },
            "right": {
              "$ref": "#/LayoutSize"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PositionType": {
      "enum": [
        "sticky",
        "stickyToHeader",
        "absolute",
        "relative"
      ]
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "KeywordSize--unrestricted-root": {
      "type": "object",
      "required": [
        "type"
      ],
      "properties": {
        "type": {
          "enum": [
            "auto",
            "maxContent",
            "minContent",
            "unset",
            "fit"
          ]
        }
      }
    },
    "Calculation--unrestricted-root": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "type": {
          "enum": [
            "Calc"
          ]
        },
        "value": {
          "type": "string"
        }
      }
    },
    "CalculationFormula--unrestricted-root": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "type": {
          "enum": [
            "CalcFormula"
          ]
        },
        "value": {
          "type": "object",
          "required": [
            "formula",
            "values"
          ],
          "properties": {
            "formula": {
              "type": "string",
              "description": "A valid css calc formula, with constants formatted like ${constName}"
            },
            "values": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "anyOf": [
                  {
                    "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                  },
                  {
                    "$ref": "#/SystemVariableSize"
                  },
                  {
                    "$ref": "#/NumberSize"
                  }
                ]
              },
              "minProperties": 1,
              "properties": {},
              "unevaluatedProperties": false
            }
          },
          "unevaluatedProperties": false
        }
      }
    },
    "AspectRatioSize--unrestricted-root": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "type": {
          "enum": [
            "aspectRatio"
          ]
        },
        "value": {
          "type": "number"
        }
      }
    },
    "SystemVariableSize--unrestricted-root": {
      "type": "object",
      "required": [
        "type",
        "value"
      ],
      "properties": {
        "type": {
          "enum": [
            "SystemVariable"
          ]
        },
        "value": {
          "enum": [
            "siteWidth",
            "topBannerHeight"
          ]
        }
      }
    },
    "NumberSize--unrestricted-root": {
      "type": "object",
      "required": [
        "type",
        "value"
      ],
      "properties": {
        "type": {
          "enum": [
            "Number"
          ]
        },
        "value": {
          "type": "number"
        }
      }
    },
    "LayoutSize--unrestricted-root": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize--unrestricted-root"
        },
        {
          "$ref": "#/Calculation--unrestricted-root"
        },
        {
          "$ref": "#/CalculationFormula--unrestricted-root"
        },
        {
          "$ref": "#/SystemVariableSize--unrestricted-root"
        },
        {
          "$ref": "#/KeywordSize--unrestricted-root"
        }
      ]
    },
    "SpxStopper--unrestricted-root": {
      "type": "object",
      "properties": {
        "min": {
          "$ref": "#/LayoutSize"
        },
        "max": {
          "$ref": "#/LayoutSize"
        }
      }
    },
    "StretchWithSoftMargins--unrestricted-root": {
      "type": "object",
      "required": [
        "type",
        "value"
      ],
      "properties": {
        "type": {
          "enum": [
            "StretchWithSoftMargins"
          ]
        },
        "value": {
          "type": "object",
          "properties": {
            "margins": {
              "type": "object",
              "properties": {
                "left": {
                  "$ref": "#/LayoutSize"
                },
                "right": {
                  "$ref": "#/LayoutSize"
                }
              },
              "unevaluatedProperties": false
            }
          },
          "unevaluatedProperties": false
        }
      }
    },
    "Height--unrestricted-root": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "#/AspectRatioSize--unrestricted-root"
        },
        {
          "$ref": "#/LayoutSize--unrestricted-root"
        }
      ]
    },
    "MinMaxSize--unrestricted-root": {
      "type": "object",
      "required": [
        "min",
        "max",
        "type"
      ],
      "properties": {
        "type": {
          "type": "string",
          "default": "MinMaxSize"
        },
        "min": {
          "$ref": "#/LayoutSize"
        },
        "max": {
          "$ref": "#/LayoutSize"
        }
      }
    },
    "GridTrackSize--unrestricted-root": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "min": {
          "$ref": "#/LayoutSize"
        },
        "max": {
          "$ref": "#/LayoutSize"
        },
        "value": {
          "type": [
            "string",
            "number",
            "array"
          ],
          "items": {
            "$ref": "#/BaseGridTrackSize"
          }
        },
        "length": {
          "type": "string",
          "anyOf": [
            {
              "type": "number",
              "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable--unrestricted-root"
            },
            {
              "type": "string",
              "$ref": "#/KeywordLength--unrestricted-root"
            }
          ]
        }
      }
    },
    "BaseGridTrackSize--unrestricted-root": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "min": {
          "$ref": "#/LayoutSize"
        },
        "max": {
          "$ref": "#/LayoutSize"
        },
        "value": {
          "type": [
            "string",
            "number"
          ]
        }
      }
    },
    "KeywordLength--unrestricted-root": {
      "enum": [
        "auto-fill",
        "auto-fit"
      ]
    },
    "ItemsAlignment--unrestricted-root": {
      "type": "string",
      "enum": [
        "start",
        "end",
        "center",
        "stretch",
        "content"
      ]
    },
    "ContainerLayoutIntent--unrestricted-root": {
      "type": "object",
      "properties": {
        "layoutIntent": {
          "type": "string",
          "enum": [
            "Rows",
            "Cols",
            "Mosaic",
            "Slider",
            "SlideShow",
            "Bricks"
          ]
        }
      }
    },
    "Alignment--unrestricted-root": {
      "type": "string",
      "enum": [
        "auto",
        "stretch",
        "start",
        "center",
        "end"
      ]
    },
    "Direction--unrestricted-root": {
      "enum": [
        "rtl",
        "ltr"
      ]
    },
    "Margins--unrestricted-root": {
      "type": "object",
      "properties": {
        "top": {
          "$ref": "#/LayoutSize"
        },
        "bottom": {
          "$ref": "#/LayoutSize"
        },
        "left": {
          "$ref": "#/LayoutSize"
        },
        "right": {
          "$ref": "#/LayoutSize"
        }
      }
    },
    "Padding--unrestricted-root": {
      "type": "object",
      "properties": {
        "top": {
          "$ref": "#/LayoutSize"
        },
        "bottom": {
          "$ref": "#/LayoutSize"
        },
        "left": {
          "$ref": "#/LayoutSize"
        },
        "right": {
          "$ref": "#/LayoutSize"
        }
      }
    },
    "FlexDirection--unrestricted-root": {
      "enum": [
        "row",
        "rowReverse",
        "column",
        "columnReverse"
      ]
    },
    "FlexWrap--unrestricted-root": {
      "enum": [
        "nowrap",
        "wrap"
      ]
    },
    "Overflow--unrestricted-root": {
      "enum": [
        "auto",
        "scroll",
        "hidden",
        "visible",
        "clip"
      ]
    },
    "Contain--unrestricted-root": {
      "enum": [
        "none",
        "paint"
      ]
    },
    "AutoFlow--unrestricted-root": {
      "enum": [
        "row",
        "column",
        "dense",
        "row dense",
        "column dense"
      ]
    },
    "JustifyContent--unrestricted-root": {
      "enum": [
        "start",
        "center",
        "end",
        "spaceBetween",
        "spaceAround",
        "spaceEvenly"
      ]
    },
    "AlignContent--unrestricted-root": {
      "enum": [
        "start",
        "center",
        "end",
        "spaceBetween",
        "spaceAround",
        "spaceEvenly"
      ]
    },
    "GridArea--unrestricted-root": {
      "type": "object",
      "required": [
        "rowStart",
        "rowEnd",
        "columnStart",
        "columnEnd"
      ],
      "properties": {
        "rowStart": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable"
        },
        "columnStart": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable"
        },
        "rowEnd": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable"
        },
        "columnEnd": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable"
        }
      }
    },
    "LayoutData--unrestricted-root": {
      "type": "object",
      "properties": {
        "componentLayouts": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "itemLayouts": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "containerLayouts": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "SingleLayoutData--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/contentMaxWidth\\/maxWidth|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/contentMaxWidth\\/maxWidth|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:componentLayout\\/height)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:componentLayout\\/height)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:itemLayout\\/position|containerLayout\\/position)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:itemLayout\\/position|containerLayout\\/position)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:itemLayout\\/gridArea\\/rowStart|itemLayout\\/gridArea\\/columnStart|itemLayout\\/gridArea\\/rowEnd|itemLayout\\/gridArea\\/columnEnd|containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:itemLayout\\/gridArea\\/rowStart|itemLayout\\/gridArea\\/columnStart|itemLayout\\/gridArea\\/rowEnd|itemLayout\\/gridArea\\/columnEnd|containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:itemLayout\\/alignSelf|itemLayout\\/justifySelf|containerLayout\\/alignItems)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:itemLayout\\/alignSelf|itemLayout\\/justifySelf|containerLayout\\/alignItems)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:containerLayout\\/justifyContent)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:containerLayout\\/justifyContent)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "itemLayout",
            "componentLayout",
            "containerLayout"
          ],
          "properties": {
            "componentLayout": {
              "type": "object",
              "default": {},
              "anyOf": [
                {
                  "$ref": "#/ComponentLayout--unrestricted-root"
                },
                {
                  "$ref": "#/ClassicComponentLayout--unrestricted-root"
                }
              ],
              "unevaluatedProperties": false
            },
            "itemLayout": {
              "type": "object",
              "default": {},
              "anyOf": [
                {
                  "$ref": "#/GridItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/FixedItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/FlexItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/OrganizerItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/StackItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/MultiColumnsItemLayout--unrestricted-root"
                },
                {
                  "$ref": "#/BackgroundLayerItemLayout--unrestricted-root"
                }
              ],
              "unevaluatedProperties": false
            },
            "containerLayout": {
              "type": "object",
              "default": {},
              "anyOf": [
                {
                  "$ref": "#/GridContainerLayout--unrestricted-root"
                },
                {
                  "$ref": "#/FlexContainerLayout--unrestricted-root"
                },
                {
                  "$ref": "#/OrganizerContainerLayout--unrestricted-root"
                },
                {
                  "$ref": "#/StackContainerLayout--unrestricted-root"
                },
                {
                  "$ref": "#/MultiColumnsContainerLayout--unrestricted-root"
                }
              ],
              "unevaluatedProperties": false
            },
            "spx": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/SPXReferenceDefinition"
            }
          }
        }
      ],
      "type": "object"
    },
    "ScrollSnapType--unrestricted-root": {
      "enum": [
        "mandatory",
        "proximity",
        "none"
      ]
    },
    "ScrollSnapDirection--unrestricted-root": {
      "enum": [
        "x",
        "y"
      ]
    },
    "ScrollBehavior--unrestricted-root": {
      "enum": [
        "auto",
        "smooth"
      ]
    },
    "ScrollSnapAlignType--unrestricted-root": {
      "enum": [
        "center",
        "end",
        "start",
        "none"
      ]
    },
    "ScrollSnapData--unrestricted-root": {
      "type": "object",
      "properties": {
        "scrollSnapType": {
          "$ref": "#/ScrollSnapType"
        },
        "scrollSnapDirection": {
          "$ref": "#/ScrollSnapDirection"
        }
      }
    },
    "ContentMaxWidth--unrestricted-root": {
      "type": "object",
      "properties": {
        "maxWidth": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
        },
        "align": {
          "type": "string",
          "enum": [
            "center",
            "right",
            "left"
          ]
        }
      }
    },
    "GridContainerLayout--unrestricted-root": {
      "type": "object",
      "required": [
        "rows",
        "columns"
      ],
      "properties": {
        "rows": {
          "type": "array",
          "items": {
            "$ref": "#/GridTrackSize"
          }
        },
        "columns": {
          "type": "array",
          "items": {
            "$ref": "#/GridTrackSize"
          }
        },
        "rowGap": {
          "$ref": "#/LayoutSize"
        },
        "columnGap": {
          "$ref": "#/LayoutSize"
        },
        "autoRows": {
          "type": "array",
          "items": {
            "$ref": "#/GridTrackSize"
          }
        },
        "autoColumns": {
          "type": "array",
          "items": {
            "$ref": "#/GridTrackSize"
          }
        },
        "autoFlow": {
          "$ref": "#/AutoFlow"
        },
        "overflowY": {
          "$ref": "#/Overflow"
        },
        "overflowX": {
          "$ref": "#/Overflow"
        },
        "hideScrollbar": {
          "type": "boolean"
        },
        "padding": {
          "$ref": "#/Padding"
        },
        "scrollSnap": {
          "$ref": "#/ScrollSnapData"
        },
        "scrollBehavior": {
          "$ref": "#/ScrollBehavior"
        },
        "contentMaxWidth": {
          "$ref": "#/ContentMaxWidth"
        },
        "type": {
          "type": "string",
          "enum": [
            "GridContainerLayout"
          ]
        },
        "contain": {
          "$ref": "#/Contain"
        },
        "spxStopper": {
          "$ref": "#/SpxStopper"
        }
      }
    },
    "ComponentLayout--unrestricted-root": {
      "allOf": [
        {
          "$ref": "#/BaseComponentLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "ComponentLayout"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "ClassicComponentLayout--unrestricted-root": {
      "allOf": [
        {
          "$ref": "#/BaseComponentLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "ClassicComponentLayout"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "BaseComponentLayout--unrestricted-root": {
      "type": "object",
      "properties": {
        "containerType": {
          "type": "string",
          "enum": [
            "inline-size"
          ],
          "description": "The css container type. This property is correct for normal components as well as containers,is used to define the type of containment used in a css container query."
        },
        "width": {
          "type": "object",
          "oneOf": [
            {
              "$ref": "#/LayoutSize--unrestricted-root"
            },
            {
              "$ref": "#/StretchWithSoftMargins--unrestricted-root"
            }
          ],
          "unevaluatedProperties": false
        },
        "height": {
          "$ref": "#/Height"
        },
        "minWidth": {
          "$ref": "#/LayoutSize"
        },
        "minHeight": {
          "$ref": "#/LayoutSize"
        },
        "maxWidth": {
          "$ref": "#/LayoutSize"
        },
        "maxHeight": {
          "$ref": "#/LayoutSize"
        },
        "margins": {
          "$ref": "#/Margins"
        },
        "direction": {
          "$ref": "#/Direction"
        },
        "rotationInDegrees": {
          "type": "number"
        },
        "fixed": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        }
      }
    },
    "GridItemLayout--unrestricted-root": {
      "allOf": [
        {
          "$ref": "#/BaseItemLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "gridArea": {
              "$ref": "#/GridArea"
            },
            "alignSelf": {
              "$ref": "#/ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "#/ItemsAlignment"
            },
            "type": {
              "type": "string",
              "enum": [
                "GridItemLayout"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "FixedItemLayout--unrestricted-root": {
      "allOf": [
        {
          "$ref": "#/BaseItemLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "alignSelf": {
              "$ref": "#/ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "#/ItemsAlignment"
            },
            "type": {
              "type": "string",
              "enum": [
                "FixedItemLayout"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "BackgroundLayerItemLayout--unrestricted-root": {
      "allOf": [
        {
          "$ref": "#/BaseItemLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "alignSelf": {
              "$ref": "#/ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "#/ItemsAlignment"
            },
            "type": {
              "type": "string",
              "enum": [
                "BackgroundLayerItemLayout"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "FlexContainerLayoutBase--unrestricted-root": {
      "allOf": [
        {
          "$ref": "#/BaseItemLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/FlexDirection"
            },
            "wrap": {
              "$ref": "#/FlexWrap"
            },
            "alignItems": {
              "$ref": "#/ItemsAlignment"
            },
            "justifyContent": {
              "$ref": "#/JustifyContent"
            },
            "alignContent": {
              "$ref": "#/AlignContent"
            },
            "overflowY": {
              "$ref": "#/Overflow"
            },
            "overflowX": {
              "$ref": "#/Overflow"
            },
            "hideScrollbar": {
              "type": "boolean"
            },
            "padding": {
              "$ref": "#/Padding"
            },
            "scrollSnap": {
              "$ref": "#/ScrollSnapData"
            },
            "scrollBehaviour": {
              "$ref": "#/ScrollBehavior"
            },
            "contentMaxWidth": {
              "$ref": "#/ContentMaxWidth"
            },
            "spxStopper": {
              "$ref": "#/SpxStopper"
            },
            "rowGap": {
              "$ref": "#/LayoutSize"
            },
            "columnGap": {
              "$ref": "#/LayoutSize"
            },
            "contain": {
              "$ref": "#/Contain"
            }
          }
        }
      ],
      "type": "object"
    },
    "FlexContainerLayout--unrestricted-root": {
      "allOf": [
        {
          "$ref": "#/FlexContainerLayoutBase--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "FlexContainerLayout"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "FlexItemLayoutBase--unrestricted-root": {
      "allOf": [
        {
          "$ref": "#/BaseItemLayout--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "order": {
              "type": "number"
            },
            "alignSelf": {
              "$ref": "#/ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "#/ItemsAlignment"
            },
            "basis": {
              "$ref": "#/LayoutSize"
            },
            "grow": {
              "type": "number"
            },
            "shrink": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "FlexItemLayout--unrestricted-root": {
      "allOf": [
        {
          "$ref": "#/FlexItemLayoutBase--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "FlexItemLayout"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "OrganizerContainerLayout--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/ContainerLayoutIntent--unrestricted-root"
        },
        {
          "$ref": "#/FlexContainerLayoutBase--unrestricted-root"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "OrganizerContainerLayout"
              ]
            }
          }
        }
      ]
    },
    "MultiColumnsContainerLayout--unrestricted-root": {
      "type": "object",
      "required": [
        "columnCount",
        "type"
      ],
      "properties": {
        "alignContent": {
          "$ref": "#/Alignment"
        },
        "columnCount": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        },
        "padding": {
          "$ref": "#/Padding"
        },
        "rowGap": {
          "$ref": "#/LayoutSize"
        },
        "columnGap": {
          "$ref": "#/LayoutSize"
        },
        "spxStopper": {
          "$ref": "#/SpxStopper"
        },
        "type": {
          "type": "string",
          "enum": [
            "MultiColumnsContainerLayout"
          ]
        }
      }
    },
    "MultiColumnsItemLayout--unrestricted-root": {
      "type": "object",
      "required": [
        "type"
      ],
      "properties": {
        "margins": {
          "$ref": "#/Margins"
        },
        "type": {
          "type": "string",
          "enum": [
            "MultiColumnsItemLayout"
          ]
        }
      }
    },
    "OrganizerItemLayout--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/FlexItemLayoutBase--unrestricted-root"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "OrganizerItemLayout"
              ]
            }
          }
        }
      ]
    },
    "StackContainerLayout--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/FlexContainerLayoutBase--unrestricted-root"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "StackContainerLayout"
              ]
            }
          }
        }
      ]
    },
    "StackItemLayout--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/FlexItemLayoutBase--unrestricted-root"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "StackItemLayout"
              ]
            }
          }
        }
      ]
    },
    "LayoutDataItem--unrestricted-root": {
      "type": "object",
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": [
            "string",
            "null"
          ]
        }
      }
    },
    "BaseItemLayout--unrestricted-root": {
      "allOf": [
        {
          "$ref": "#/LayoutDataItem--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "scrollSnapAlign": {
              "$ref": "#/ScrollSnapAlignType"
            },
            "pinnedToContainer": {
              "type": "boolean"
            },
            "margins": {
              "$ref": "#/Margins"
            },
            "position": {
              "$ref": "#/PositionType"
            },
            "isInFront": {
              "type": "boolean"
            },
            "top": {
              "$ref": "#/LayoutSize"
            },
            "bottom": {
              "$ref": "#/LayoutSize"
            },
            "left": {
              "$ref": "#/LayoutSize"
            },
            "right": {
              "$ref": "#/LayoutSize"
            }
          }
        }
      ],
      "type": "object"
    },
    "PositionType--unrestricted-root": {
      "enum": [
        "sticky",
        "stickyToHeader",
        "absolute",
        "relative"
      ]
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    }
  },
  "manifest.json": {
    "$id": "urn:dm:schemas:manifest.json",
    "Manifest": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "gfpp": {
              "$ref": "#/GfppConfig"
            },
            "behavior": {
              "$ref": "#/ComponentStageBehavior"
            },
            "displayName": {
              "$ref": "#/TranslatableString"
            },
            "connections": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "*": {
                  "type": "object",
                  "additionalProperties": false,
                  "properties": {
                    "gfpp": {
                      "$ref": "#/GfppConfig"
                    }
                  },
                  "unevaluatedProperties": false
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ComponentStageBehavior": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "duplicatable": {
          "type": "boolean"
        },
        "resizable": {
          "type": "boolean"
        },
        "preventHide": {
          "type": "boolean"
        },
        "dataEditOptions": {
          "type": "string",
          "maxLength": 50
        },
        "closed": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "selectable": {
              "type": "boolean"
            },
            "hideFromHierarchy": {
              "type": "boolean"
            }
          },
          "unevaluatedProperties": false
        }
      },
      "unevaluatedProperties": false
    },
    "GfppConfig": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "desktop": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "mainAction1": {
              "$ref": "#/MainActionConfig"
            },
            "mainAction2": {
              "$ref": "#/MainActionConfig"
            },
            "iconButtons": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "settings": {
                  "$ref": "#/IconButtonConfig"
                },
                "add": {
                  "$ref": "#/IconButtonConfig"
                },
                "design": {
                  "$ref": "#/IconButtonConfig"
                },
                "crop": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "filters": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "animation": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "link": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "stretch": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "layout": {
                  "$ref": "#/IconButtonConfig"
                },
                "upgrade": {
                  "type": "object",
                  "anyOf": [
                    {
                      "$ref": "#/IconButtonConfig--unrestricted-root"
                    },
                    {
                      "$ref": "#/GfppUpgradeConfig--unrestricted-root"
                    }
                  ],
                  "unevaluatedProperties": false
                },
                "connect": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "pinMode": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "customConnect": {
                  "$ref": "#/GfppIconActionConfig"
                },
                "focalPoint": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "presets": {
                  "$ref": "#/GfppIconButtonConfig"
                }
              },
              "unevaluatedProperties": false
            },
            "helpId": {
              "type": "string",
              "maxLength": 50
            }
          },
          "unevaluatedProperties": false
        }
      },
      "unevaluatedProperties": false
    },
    "MainActionConfig": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "#/GfppMainActionDefinition--unrestricted-root"
        },
        {
          "$ref": "#/GfppMainActionButtonConfig--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "GfppMainActionButtonConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "HIDE",
            "DEFAULT",
            "DEFAULT1",
            "DEFAULT2"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "GfppMainActionDefinition": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior",
        "label"
      ],
      "oneOf": [
        {
          "required": [
            "actionId"
          ]
        },
        {
          "required": [
            "actionType"
          ]
        }
      ],
      "properties": {
        "behavior": {
          "enum": [
            "CUSTOM_ACTION"
          ]
        },
        "actionId": {
          "type": "string",
          "maxLength": 50
        },
        "label": {
          "$ref": "#/TranslatableString"
        },
        "actionType": {
          "enum": [
            "settings",
            "layout",
            "design",
            "manage",
            "background"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "IconButtonConfig": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "#/GfppIconActionConfig--unrestricted-root"
        },
        {
          "$ref": "#/GfppIconButtonConfig--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "GfppIconButtonConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "HIDE",
            "DEFAULT"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "GfppIconActionConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior",
        "actionId"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "CUSTOM_ACTION"
          ]
        },
        "actionId": {
          "type": "string",
          "maxLength": 50
        }
      },
      "unevaluatedProperties": false
    },
    "GfppUpgradeConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "SITE_UPGRADE"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "TranslatableString": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "value",
        "shouldTranslate"
      ],
      "properties": {
        "value": {
          "type": "string",
          "maxLength": 100
        },
        "shouldTranslate": {
          "type": "boolean"
        }
      },
      "unevaluatedProperties": false
    },
    "Manifest--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "gfpp": {
              "$ref": "#/GfppConfig"
            },
            "behavior": {
              "$ref": "#/ComponentStageBehavior"
            },
            "displayName": {
              "$ref": "#/TranslatableString"
            },
            "connections": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "*": {
                  "type": "object",
                  "additionalProperties": false,
                  "properties": {
                    "gfpp": {
                      "$ref": "#/GfppConfig"
                    }
                  },
                  "unevaluatedProperties": false
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "ComponentStageBehavior--unrestricted-root": {
      "type": "object",
      "properties": {
        "duplicatable": {
          "type": "boolean"
        },
        "resizable": {
          "type": "boolean"
        },
        "preventHide": {
          "type": "boolean"
        },
        "dataEditOptions": {
          "type": "string",
          "maxLength": 50
        },
        "closed": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "selectable": {
              "type": "boolean"
            },
            "hideFromHierarchy": {
              "type": "boolean"
            }
          },
          "unevaluatedProperties": false
        }
      }
    },
    "GfppConfig--unrestricted-root": {
      "type": "object",
      "properties": {
        "desktop": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "mainAction1": {
              "$ref": "#/MainActionConfig"
            },
            "mainAction2": {
              "$ref": "#/MainActionConfig"
            },
            "iconButtons": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "settings": {
                  "$ref": "#/IconButtonConfig"
                },
                "add": {
                  "$ref": "#/IconButtonConfig"
                },
                "design": {
                  "$ref": "#/IconButtonConfig"
                },
                "crop": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "filters": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "animation": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "link": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "stretch": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "layout": {
                  "$ref": "#/IconButtonConfig"
                },
                "upgrade": {
                  "type": "object",
                  "anyOf": [
                    {
                      "$ref": "#/IconButtonConfig--unrestricted-root"
                    },
                    {
                      "$ref": "#/GfppUpgradeConfig--unrestricted-root"
                    }
                  ],
                  "unevaluatedProperties": false
                },
                "connect": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "pinMode": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "customConnect": {
                  "$ref": "#/GfppIconActionConfig"
                },
                "focalPoint": {
                  "$ref": "#/GfppIconButtonConfig"
                },
                "presets": {
                  "$ref": "#/GfppIconButtonConfig"
                }
              },
              "unevaluatedProperties": false
            },
            "helpId": {
              "type": "string",
              "maxLength": 50
            }
          },
          "unevaluatedProperties": false
        }
      }
    },
    "MainActionConfig--unrestricted-root": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "#/GfppMainActionDefinition--unrestricted-root"
        },
        {
          "$ref": "#/GfppMainActionButtonConfig--unrestricted-root"
        }
      ]
    },
    "GfppMainActionButtonConfig--unrestricted-root": {
      "type": "object",
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "HIDE",
            "DEFAULT",
            "DEFAULT1",
            "DEFAULT2"
          ]
        }
      }
    },
    "GfppMainActionDefinition--unrestricted-root": {
      "type": "object",
      "required": [
        "behavior",
        "label"
      ],
      "oneOf": [
        {
          "required": [
            "actionId"
          ]
        },
        {
          "required": [
            "actionType"
          ]
        }
      ],
      "properties": {
        "behavior": {
          "enum": [
            "CUSTOM_ACTION"
          ]
        },
        "actionId": {
          "type": "string",
          "maxLength": 50
        },
        "label": {
          "$ref": "#/TranslatableString"
        },
        "actionType": {
          "enum": [
            "settings",
            "layout",
            "design",
            "manage",
            "background"
          ]
        }
      }
    },
    "IconButtonConfig--unrestricted-root": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "#/GfppIconActionConfig--unrestricted-root"
        },
        {
          "$ref": "#/GfppIconButtonConfig--unrestricted-root"
        }
      ]
    },
    "GfppIconButtonConfig--unrestricted-root": {
      "type": "object",
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "HIDE",
            "DEFAULT"
          ]
        }
      }
    },
    "GfppIconActionConfig--unrestricted-root": {
      "type": "object",
      "required": [
        "behavior",
        "actionId"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "CUSTOM_ACTION"
          ]
        },
        "actionId": {
          "type": "string",
          "maxLength": 50
        }
      }
    },
    "GfppUpgradeConfig--unrestricted-root": {
      "type": "object",
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "SITE_UPGRADE"
          ]
        }
      }
    },
    "TranslatableString--unrestricted-root": {
      "type": "object",
      "required": [
        "value",
        "shouldTranslate"
      ],
      "properties": {
        "value": {
          "type": "string",
          "maxLength": 100
        },
        "shouldTranslate": {
          "type": "boolean"
        }
      }
    }
  },
  "measurements.json": {
    "$id": "urn:dm:schemas:measurements.json",
    "MeasurementsData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "type",
            "width",
            "height",
            "x",
            "y",
            "viewportSize"
          ],
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "MeasurementsData"
              ]
            },
            "width": {
              "type": "number",
              "minimum": 0
            },
            "height": {
              "type": "number",
              "minimum": 0
            },
            "x": {
              "type": "number"
            },
            "y": {
              "type": "number"
            },
            "viewportSize": {
              "type": "number",
              "minimum": 0
            },
            "isFixedPosition": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MeasurementsData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "type",
            "width",
            "height",
            "x",
            "y",
            "viewportSize"
          ],
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "MeasurementsData"
              ]
            },
            "width": {
              "type": "number",
              "minimum": 0
            },
            "height": {
              "type": "number",
              "minimum": 0
            },
            "x": {
              "type": "number"
            },
            "y": {
              "type": "number"
            },
            "viewportSize": {
              "type": "number",
              "minimum": 0
            },
            "isFixedPosition": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "migration.json": {
    "$id": "urn:dm:schemas:migration.json",
    "migration": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "migrationStatus",
            "migrationSource"
          ],
          "properties": {
            "migrationStatus": {
              "type": "string",
              "maxLength": 50
            },
            "migrationSource": {
              "enum": [
                "classic",
                "figma",
                "site-description-file",
                "editor-x",
                "editor-x-force-migration",
                "site-generation"
              ]
            },
            "migrationRevision": {
              "type": "string",
              "maxLength": 50
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "migration--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "migrationStatus",
            "migrationSource"
          ],
          "properties": {
            "migrationStatus": {
              "type": "string",
              "maxLength": 50
            },
            "migrationSource": {
              "enum": [
                "classic",
                "figma",
                "site-description-file",
                "editor-x",
                "editor-x-force-migration",
                "site-generation"
              ]
            },
            "migrationRevision": {
              "type": "string",
              "maxLength": 50
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "mobile_hints.json": {
    "$id": "urn:dm:schemas:mobile_hints.json",
    "MobileHints": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "author": {
              "enum": [
                "studio",
                "duplicate"
              ],
              "description": "Data source"
            },
            "isLocked": {
              "type": "boolean",
              "description": "Skip element because user locked this element"
            },
            "hidden": {
              "type": "boolean",
              "description": "Should hide component on mobile"
            },
            "offsetX": {
              "type": "number",
              "description": "Horizontal distance from the corner of the previous sibling"
            },
            "offsetY": {
              "type": "number",
              "description": "Vertical distance from the corner of the previous sibling"
            },
            "offsetOrigin": {
              "enum": [
                "leftTop",
                "rightTop",
                "leftBottom"
              ],
              "description": "The corner of the previous sibling that the offsets are applied to"
            },
            "originalCompId": {
              "type": "string",
              "description": "Id of source component"
            },
            "recommendedScale": {
              "type": "number",
              "description": "Recommended component scale on mobile"
            },
            "recommendedWidth": {
              "type": "number",
              "description": "Recommended component width on mobile"
            },
            "recommendedHeight": {
              "type": "number",
              "description": "Recommended component height on mobile"
            },
            "orderIndex": {
              "type": "number",
              "description": "Recommended index of component in parent container"
            },
            "modifiedByUser": {
              "type": "boolean",
              "description": "Indicate is component was changed by user on mobile"
            },
            "shouldBeForceConverted": {
              "type": "boolean",
              "description": "Indicate that component need to be force converted to mobile"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MobileHints--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "author": {
              "enum": [
                "studio",
                "duplicate"
              ],
              "description": "Data source"
            },
            "isLocked": {
              "type": "boolean",
              "description": "Skip element because user locked this element"
            },
            "hidden": {
              "type": "boolean",
              "description": "Should hide component on mobile"
            },
            "offsetX": {
              "type": "number",
              "description": "Horizontal distance from the corner of the previous sibling"
            },
            "offsetY": {
              "type": "number",
              "description": "Vertical distance from the corner of the previous sibling"
            },
            "offsetOrigin": {
              "enum": [
                "leftTop",
                "rightTop",
                "leftBottom"
              ],
              "description": "The corner of the previous sibling that the offsets are applied to"
            },
            "originalCompId": {
              "type": "string",
              "description": "Id of source component"
            },
            "recommendedScale": {
              "type": "number",
              "description": "Recommended component scale on mobile"
            },
            "recommendedWidth": {
              "type": "number",
              "description": "Recommended component width on mobile"
            },
            "recommendedHeight": {
              "type": "number",
              "description": "Recommended component height on mobile"
            },
            "orderIndex": {
              "type": "number",
              "description": "Recommended index of component in parent container"
            },
            "modifiedByUser": {
              "type": "boolean",
              "description": "Indicate is component was changed by user on mobile"
            },
            "shouldBeForceConverted": {
              "type": "boolean",
              "description": "Indicate that component need to be force converted to mobile"
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "multilingualTranslations.json": {
    "$id": "urn:dm:schemas:multilingualTranslations.json",
    "Direction": {
      "type": "string",
      "enum": [
        "ltr",
        "rtl",
        "inherit"
      ]
    },
    "AppVars": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "vars": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "value": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "AppPartParam"
                    ]
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "appDefId": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SVGItem": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/Common_SVGItem"
    },
    "SVGReference": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "BackgroundImage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string"
            },
            "positionx": {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "default": "center"
            },
            "imagesizew": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "imagesizeh": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "positiony": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "center"
              ],
              "default": "center"
            },
            "width": {
              "type": "string"
            },
            "repeatx": {
              "type": "string",
              "enum": [
                "no_repeat",
                "repeat"
              ],
              "default": "repeat"
            },
            "repeaty": {
              "type": "string",
              "enum": [
                "no_repeat",
                "repeat"
              ],
              "default": "repeat"
            },
            "attachment": {
              "type": "string",
              "enum": [
                "scroll",
                "fixed",
                "inherit",
                "local"
              ],
              "default": "inherit"
            },
            "color": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BackgroundMedia": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "mediaRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mediaTransforms": {
              "$ref": "urn:dm:schemas:design_data.json#/BackgroundTransforms"
            },
            "overlayTransforms": {
              "$ref": "urn:dm:schemas:design_data.json#/BackgroundTransforms"
            },
            "color": {
              "oneOf": [
                {
                  "enum": [
                    "transparent",
                    "noColor"
                  ]
                },
                {
                  "$ref": "urn:dm:schemas:common.json#/color--unrestricted-root"
                }
              ]
            },
            "colorOpacity": {
              "type": "number"
            },
            "alignType": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "left",
                "right",
                "center",
                "top_left",
                "top_right",
                "bottom_left",
                "bottom_right"
              ]
            },
            "fittingType": {
              "type": "string",
              "enum": [
                "fill",
                "fit",
                "stretch",
                "actual_size",
                "original_size",
                "tile",
                "tile_horizontal",
                "tile_vertical",
                "fit_and_tile",
                "legacy_tile",
                "legacy_tile_horizontal",
                "legacy_tile_vertical",
                "legacy_normal"
              ]
            },
            "scrollType": {
              "type": "string",
              "enum": [
                "none",
                "fixed",
                "scroll",
                "local",
                "parallax"
              ]
            },
            "showOverlayForMediaType": {
              "type": "string",
              "enum": [
                "all",
                "WixVideo",
                "Image"
              ],
              "default": "WixVideo"
            },
            "imageOverlay": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "colorOverlay": {
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "colorOverlayOpacity": {
              "type": "number"
            },
            "overlayBlending": {
              "$ref": "urn:dm:schemas:design_data.json#/overlayBlending"
            },
            "filterEffect": {
              "$ref": "urn:dm:schemas:design_data.json#/filterEffect"
            },
            "colorLayers": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/ColorLayers"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WixVideo": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/WixVideoData--unrestricted-root"
            },
            {
              "properties": {
                "loop": {
                  "type": "boolean"
                },
                "autoplay": {
                  "type": "boolean"
                },
                "playbackSpeed": {
                  "type": "number"
                },
                "preload": {
                  "type": "string",
                  "enum": [
                    "auto",
                    "metadata",
                    "none"
                  ]
                },
                "controls": {
                  "type": "string",
                  "enum": [
                    "none",
                    "full"
                  ]
                },
                "mute": {
                  "type": "boolean",
                  "description": "deprecated, moved to properties"
                },
                "opacity": {
                  "type": "number"
                },
                "mediaFeatures": {
                  "type": "array",
                  "items": {
                    "type": "string",
                    "enum": [
                      "alpha"
                    ]
                  }
                },
                "mask": {
                  "anyOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "urn:dm:schemas:design_data.json#/ImageMask--unrestricted-root"
                    }
                  ]
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WixVideoData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string",
              "maxLength": 100
            },
            "alt": {
              "type": "string",
              "maxLength": 1000
            },
            "videoId": {
              "type": "string"
            },
            "generatedPosters": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "qualities": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "quality": {
                    "type": "string"
                  },
                  "width": {
                    "type": "number"
                  },
                  "height": {
                    "type": "number"
                  },
                  "formats": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    },
                    "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
                  },
                  "format": {
                    "type": "string",
                    "enum": [
                      "mp4",
                      "webm"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "adaptiveVideo": {
              "type": [
                "array",
                "null"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "format": {
                    "type": "string",
                    "enum": [
                      "hls",
                      "dash"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "posterImageRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "duration": {
              "type": "number"
            },
            "fps": {
              "type": "string",
              "maxLength": 50
            },
            "hasAudio": {
              "type": "boolean",
              "description": "video has no audio"
            },
            "artist": {
              "type": "object",
              "properties": {
                "name": {
                  "type": "string"
                },
                "id": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Document": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "siteName": {
              "type": "string",
              "maxLength": 1000
            },
            "usedFonts": {
              "type": "array",
              "items": {
                "type": "string",
                "maxLength": 1000
              }
            },
            "characterSets": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "renderModifiers": {
              "type": "object",
              "properties": {
                "siteWidth": {
                  "type": "number",
                  "minimum": 0
                },
                "pageAutoShrink": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "name": {
              "type": "string"
            },
            "mainPage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mainPageId": {
              "type": "string"
            },
            "smSettings": {
              "type": "object",
              "allOf": [
                {
                  "$ref": "#/SiteMembersData--unrestricted-root"
                }
              ],
              "unevaluatedProperties": false
            },
            "styleSettings": {
              "$ref": "#/StyleSettings"
            },
            "accessibilitySettings": {
              "$ref": "#/AccessibilitySettings"
            },
            "mobileSettings": {
              "$ref": "#/MobileSettings"
            },
            "layoutSettings": {
              "$ref": "#/LayoutSettings"
            },
            "appStudioData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "ignoreBottomBottomAnchors": {
              "type": [
                "boolean"
              ]
            },
            "anchorLockThreshold": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "supportMobile": {
              "type": "boolean"
            },
            "autoDomReorder": {
              "type": "boolean"
            },
            "appsInstallState": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "usesNewAnimations": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AccessibilitySettings": {
      "type": "object",
      "properties": {
        "visualFocusDisabled": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "skipToContent": {
          "default": true,
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "isRtlSupportEnabled": {
          "default": false,
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "currentSiteDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "MobileSettings": {
      "type": "object",
      "properties": {
        "animationsEnabled": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      },
      "unevaluatedProperties": false
    },
    "LayoutSettings": {
      "type": "object",
      "properties": {
        "useDesktopSectionsLayout": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "isFluid": {
          "type": [
            "boolean"
          ]
        },
        "headerToPagesGap": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "pagesToFooterGap": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "mechanism": {
          "type": [
            "string"
          ],
          "enum": [
            "mesh",
            "anchors"
          ]
        },
        "soapCompsAroundPagesContainer": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      },
      "unevaluatedProperties": false
    },
    "StyleSettings": {
      "type": "object",
      "properties": {
        "stylesPerPage": {
          "type": "string",
          "maxLength": 20
        }
      },
      "unevaluatedProperties": false
    },
    "SiteMembersData": {
      "type": "object",
      "properties": {
        "socialLoginGoogleEnabled": {
          "type": "boolean"
        },
        "socialLoginFacebookEnabled": {
          "type": "boolean"
        },
        "privacyNoteType": {
          "type": "string",
          "enum": [
            "CHECKBOX",
            "NOTE"
          ]
        },
        "joinCommunityCheckedByDefault": {
          "type": "boolean"
        },
        "customSignUpPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customSignInPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customNoPermissionsPageId": {
          "type": [
            "string"
          ]
        },
        "termsOfUse": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "privacyPolicy": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "codeOfConduct": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "smFirstDialogLogin": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      },
      "unevaluatedProperties": false
    },
    "AppStudioData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "widgets": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "codePackages": {
              "maxItems": 1,
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "panels": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "dependencies": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "additionalProperties": false,
                "required": [
                  "appDefId"
                ],
                "properties": {
                  "appDefId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "dependencyData": {
                    "type": "array",
                    "items": {
                      "type": "string",
                      "enum": [
                        "PROVISION_ONLY_INSTALLATION",
                        "NOTIFY_USER_ON_DEPENDENCY",
                        "IS_BUNDLE"
                      ]
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "dashboards": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "customDefinitions": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "ssrCache": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CodePackagesDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "displayName": {
              "type": "string",
              "maxLength": 30,
              "minLength": 1
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "minLength": 3
            },
            "description": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WidgetPropertyDefinition": {
      "additionalProperties": true,
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomDefinitionDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "structure": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "additionalProperties": false,
                "required": [
                  "$id",
                  "title",
                  "description",
                  "default",
                  "propertiesOrder"
                ],
                "properties": {
                  "$id": {
                    "type": "string"
                  },
                  "type": {
                    "type": "string",
                    "default": "object"
                  },
                  "title": {
                    "type": "string"
                  },
                  "description": {
                    "type": "string"
                  },
                  "properties": {
                    "type": "object",
                    "additionalProperties": {
                      "$ref": "#/WidgetPropertyDefinition"
                    }
                  },
                  "default": {
                    "type": "object",
                    "default": {}
                  },
                  "propertiesOrder": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    },
                    "default": []
                  }
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WidgetDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "devCenterWidgetId": {
              "type": [
                "string",
                "null"
              ]
            },
            "devCenterEditorReactComponentId": {
              "type": [
                "string",
                "null"
              ]
            },
            "kind": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "container",
                "section"
              ]
            },
            "panels": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "defaultSize": {
              "type": [
                "object",
                "null"
              ],
              "minProperties": 1,
              "properties": {
                "width": {
                  "type": "number"
                },
                "height": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "variations": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "presets": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "plugin": {
              "type": "object",
              "properties": {
                "placements": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "appDefinitionId": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "widgetId": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "slotId": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "containedWidgets": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            },
            "widgetApi": {
              "type": "object",
              "default": {},
              "properties": {
                "functions": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "required": [
                      "name"
                    ],
                    "properties": {
                      "name": {
                        "type": "string"
                      },
                      "description": {
                        "type": [
                          "string",
                          "null"
                        ]
                      },
                      "params": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "name": {
                              "type": "string"
                            },
                            "description": {
                              "type": [
                                "string",
                                "null"
                              ]
                            }
                          },
                          "unevaluatedProperties": false
                        }
                      },
                      "returnsDescription": {
                        "type": [
                          "string",
                          "null"
                        ]
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "propertiesSchemas": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "properties": {
                      "structure": {
                        "type": "object",
                        "additionalProperties": {
                          "$ref": "#/WidgetPropertyDefinition"
                        },
                        "default": {},
                        "unevaluatedProperties": false
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "events": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "required": [
                      "name"
                    ],
                    "properties": {
                      "name": {
                        "type": "string"
                      },
                      "description": {
                        "type": "string"
                      },
                      "args": {
                        "type": "array",
                        "items": {
                          "properties": {
                            "name": {
                              "type": "string"
                            }
                          },
                          "unevaluatedProperties": false,
                          "type": "object"
                        }
                      }
                    },
                    "unevaluatedProperties": false
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "structureRef": {
              "type": "object",
              "properties": {
                "pageId": {
                  "type": "string"
                },
                "rootCompId": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            },
            "compType": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DashboardDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "routePath": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "hideInSidebar": {
              "type": "boolean"
            },
            "activeSidebarPageId": {
              "type": [
                "string",
                "null"
              ]
            },
            "isRoutePathConnectedToTitle": {
              "type": "boolean",
              "default": true
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PanelDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "devCenterPanelId": {
              "type": [
                "string",
                "null"
              ]
            },
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "kind": {
              "type": "string",
              "enum": [
                "settings"
              ]
            },
            "helpId": {
              "type": "string",
              "maxLength": 100
            },
            "pageUrl": {
              "type": "string",
              "minLength": 1,
              "maxLength": 2048
            },
            "height": {
              "type": "number",
              "minimum": 0,
              "default": 0
            },
            "defaultSize": {
              "type": "object",
              "minProperties": 1,
              "properties": {
                "width": {
                  "type": "number"
                },
                "height": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VariationDescriptor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PresetDescriptor": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "presetId": {
              "type": "string",
              "maxLength": 100
            },
            "name": {
              "type": "string",
              "maxLength": 100
            },
            "defaultSize": {
              "type": "object",
              "minProperties": 1,
              "properties": {
                "width": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                },
                "height": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlatTheme": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "BG_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "CONTACT_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "NETWORKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "EXTERNAL_LINKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "PAGES_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "WEB_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "BASE_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "font": {
              "type": "string",
              "format": "font-family",
              "default": "Arial,sans-serif"
            },
            "bgId": {
              "type": "string",
              "default": "BG_USES_THEME_IMAGE"
            },
            "bgSize": {
              "type": "string",
              "default": ","
            },
            "bgType": {
              "type": "string",
              "default": "BG_USES_THEME_IMAGE"
            },
            "siteBg": {
              "type": "string",
              "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
            },
            "mobileBg": {
              "type": "string",
              "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
            },
            "siteBgColor": {
              "default": "0,0,0,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "headerTextColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "headerBgColor": {
              "default": "0,0,0,0",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "textColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "areaBgColor": {
              "default": "130,81,13,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "iconBgColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "borderColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "fontHeader": {
              "default": "normal normal bold 2.4em/1.0em [font] {headerTextColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontTitle": {
              "default": "italic normal bold 2.0em/2.0em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontSubTitle": {
              "default": "normal normal bold 1.2em/1.4em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontButton": {
              "default": "normal normal bold 1.4em/2.2em [font] {areaBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontText": {
              "default": "normal normal normal 1.1em/1.1em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontSmallText": {
              "default": "normal normal normal 0.5em/0.7em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "borderContainer": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderThumb": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderButton": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderIcon": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "radiusContainer": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusThumb": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusButton": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusIcon": {
              "default": "0.6em 0.0em 0.0em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "padding1": {
              "default": "1em 1em 1em 1em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding2": {
              "default": "0.0em 0.5em 0.0em 0.5em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding3": {
              "default": "1.0em 0.0em 1.0em 0.0em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "iconSize": {
              "default": "3.2",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "bulletSize": {
              "default": "1.5",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "headerSpacing": {
              "default": "0em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "componentSpacing": {
              "default": "0.45em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "itemSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "thumbSpacing": {
              "default": "0.23em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "iconSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Image": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "allOf": [
            {
              "$ref": "urn:dm:schemas:commonSchemas.json#/Common_Image--unrestricted-root"
            },
            {
              "type": "object",
              "properties": {
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageReference": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "GlobalImageQuality": {
      "$ref": "#/ImageQuality"
    },
    "ImageQuality": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "quality": {
              "$ref": "urn:dm:schemas:common.json#/Int",
              "minimum": 0,
              "maximum": 100
            },
            "unsharpMask": {
              "type": "object",
              "minProperties": 3,
              "additionalProperties": false,
              "properties": {
                "radius": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 500
                },
                "amount": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 10
                },
                "threshold": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 255
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ClassicSectionA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            },
            "level": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripColumnsContainerA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            },
            "level": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripColumnsContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "itemsDirection": {
              "type": "string",
              "enum": [
                "rtl",
                "ltr"
              ],
              "default": "ltr"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ClassicSection": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Link": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AnchorLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "anchorName": {
              "type": "string"
            },
            "anchorDataId": {
              "anyOf": [
                {
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference--unrestricted-root"
                },
                {
                  "enum": [
                    "SCROLL_TO_TOP"
                  ]
                }
              ]
            },
            "pageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DocumentLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "docId": {
              "type": "string"
            },
            "name": {
              "type": "string"
            },
            "indexable": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PhoneLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "phoneNumber": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WhatsAppLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "phoneNumber": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AddressLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "address": {
              "type": "string",
              "maxLength": 200
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "EmailLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "recipient": {
              "type": "string",
              "description": "Email address of the recipient."
            },
            "subject": {
              "type": "string",
              "description": "Subject of the email."
            },
            "body": {
              "type": "string",
              "description": "Body or content of the email."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FormSubmitButtonLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ExternalLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "allOf": [
                {
                  "type": "string"
                },
                {
                  "not": {
                    "type": "string",
                    "pattern": ".*script://.*"
                  }
                }
              ],
              "description": "URL of the external link."
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_blank",
              "description": "Specifies where to open the linked document."
            },
            "rel": {
              "$ref": "#/LinkRelAttribute",
              "default": [
                "noreferrer",
                "noopener"
              ],
              "description": "Specifies the relationship between the current document and the linked document."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LinkRelAttribute": {
      "type": "array",
      "items": {
        "type": "string",
        "enum": [
          "nofollow",
          "noopener",
          "noreferrer",
          "sponsored"
        ]
      },
      "default": []
    },
    "DynamicPageLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "routerId": {
              "type": "string"
            },
            "innerRoute": {
              "type": "string"
            },
            "anchorDataId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "isTpaRoute": {
              "type": "boolean"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TpaPageLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "itemTypeIdentifier",
            "itemId",
            "pageId",
            "appDefinitionId",
            "path"
          ],
          "properties": {
            "itemTypeIdentifier": {
              "type": "string"
            },
            "itemId": {
              "type": "string"
            },
            "pageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "path": {
              "type": "string"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LoginToWixLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "postLoginUrl": {
              "type": "string"
            },
            "postSignupUrl": {
              "type": "string"
            },
            "dialog": {
              "type": "string",
              "enum": [
                "createUser",
                "login",
                "showLogin"
              ],
              "default": "login"
            },
            "sendMail": {
              "type": "boolean",
              "default": true
            },
            "mailTemplate": {
              "type": "string"
            },
            "userColor": {
              "type": "string"
            },
            "loginCompName": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PageLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pageId": {
              "description": "Page ID of the page to link to.",
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self",
              "description": "Specifies where to open the linked document."
            },
            "rel": {
              "$ref": "#/LinkRelAttribute",
              "description": "Specifies the relationship between the current document and the linked document."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MediaItem": {
      "type": "object",
      "properties": {
        "componentType": {
          "type": "string"
        },
        "dateCreated": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "fileName": {
          "type": "string"
        },
        "fileSize": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "width": {
          "type": "number"
        },
        "iconURL": {
          "type": "string"
        },
        "mediaType": {
          "type": "string"
        },
        "mimeType": {
          "type": "string"
        },
        "originalFileName": {
          "type": "string"
        },
        "sourceURL": {
          "type": [
            "null",
            "string"
          ]
        },
        "tags": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "version": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "MediaRichText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000
            },
            "stylesMapId": {
              "type": "string"
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "componentDataList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Page": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "dataClassRef": "core.datatypes.PageDataClass",
          "properties": {
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "hideTitle": {
              "type": "boolean"
            },
            "icon": {
              "type": "string"
            },
            "windowTitle": {
              "type": "string",
              "minLength": 1,
              "maxLength": 512
            },
            "descriptionSEO": {
              "type": "string",
              "maxLength": 1024
            },
            "advancedSeoData": {
              "type": "string",
              "maxLength": 10000
            },
            "metaKeywordsSEO": {
              "type": "string",
              "maxLength": 512
            },
            "pageTitleSEO": {
              "type": "string"
            },
            "pageUriSEO": {
              "type": "string"
            },
            "hidePage": {
              "type": "boolean"
            },
            "underConstruction": {
              "type": "boolean"
            },
            "tpaApplicationId": {
              "type": "number"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "managingAppDefId": {
              "type": [
                "string",
                "null"
              ]
            },
            "tpaPageId": {
              "type": "string"
            },
            "parentPageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "pageSecurity": {
              "type": [
                "object",
                "null"
              ],
              "default": {
                "requireLogin": false,
                "passwordDigest": "",
                "dialogLanguage": ""
              },
              "properties": {
                "requireLogin": {
                  "type": "boolean"
                },
                "passwordDigest": {
                  "type": "string"
                },
                "dialogLanguage": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            },
            "indexable": {
              "type": "boolean",
              "default": true
            },
            "mobileHidePage": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageBackgrounds": {
              "type": "object",
              "properties": {
                "desktop": {
                  "type": "object",
                  "properties": {
                    "custom": {
                      "type": "boolean"
                    },
                    "mediaSizing": {
                      "type": "string",
                      "enum": [
                        "document",
                        "viewport"
                      ]
                    },
                    "ref": {
                      "$ref": "urn:dm:schemas:common.json#/nullableReference"
                    },
                    "isPreset": {
                      "type": "boolean"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "mobile": {
                  "type": "object",
                  "properties": {
                    "custom": {
                      "type": "boolean"
                    },
                    "mediaSizing": {
                      "type": "string",
                      "enum": [
                        "document",
                        "viewport"
                      ],
                      "default": "viewport"
                    },
                    "ref": {
                      "$ref": "urn:dm:schemas:common.json#/nullableReference"
                    },
                    "isPreset": {
                      "type": "boolean"
                    }
                  },
                  "unevaluatedProperties": false
                }
              },
              "unevaluatedProperties": false
            },
            "isLandingPage": {
              "type": "boolean",
              "default": false
            },
            "isMobileLandingPage": {
              "type": "boolean",
              "default": false
            },
            "isPopup": {
              "type": "boolean",
              "default": false
            },
            "translationData": {
              "type": "object",
              "properties": {
                "uriSEOTranslated": {
                  "type": "boolean",
                  "default": false
                }
              },
              "unevaluatedProperties": false
            },
            "ogImage": {
              "type": [
                "string",
                "null"
              ]
            },
            "ogImageRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "ignoreBottomBottomAnchors": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "cacheMode": {
              "enum": [
                "auto",
                "manual",
                "disabled"
              ]
            },
            "cacheMaxAgeHours": {
              "type": [
                "number",
                "null"
              ],
              "multipleOf": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Text": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 4000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RichText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000,
              "default": ""
            },
            "defaultStyle": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RichTextImage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "image": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BaseInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "formGroup": {
              "type": "string",
              "description": "form group that this component belongs to",
              "maxLength": 4000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BaseTextInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "value": {
                  "type": "string",
                  "default": "",
                  "maxLength": 4000
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextInputA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "invalid": {
              "type": "boolean"
            },
            "multiline": {
              "type": "boolean"
            },
            "autocomplete": {
              "type": "boolean"
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "atomic": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "textType": {
                  "type": "string",
                  "default": "text",
                  "enum": [
                    "text",
                    "email",
                    "url",
                    "number",
                    "tel",
                    "password"
                  ],
                  "description": "input data type"
                },
                "maxLength": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "min": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "minimum": -2147483648,
                  "maximum": 2147483647,
                  "description": "minimum allowed value for a numeric type field"
                },
                "max": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "minimum": -2147483648,
                  "maximum": 2147483647,
                  "description": "maximum allowed value for a numeric type field"
                },
                "pattern": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "specifies a regular expression against which the control's value will be validate",
                  "maxLength": 500
                },
                "phoneFormat": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "specifies a phone number format against which the control's value will be validated",
                  "pattern": "^#*(((#+-)*)#+$)",
                  "maxLength": 100
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected"
                },
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                },
                "prefix": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "maxLength": 10
                },
                "step": {
                  "type": "number"
                },
                "autoComplete": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "maxLength": 400
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ],
          "not": {
            "required": [
              "pattern",
              "phoneFormat"
            ]
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextAreaInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "maxLength": {
                  "type": [
                    "number"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "label": {
                  "type": [
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string"
                  ],
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CheckboxInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "checked": {
                  "$ref": "urn:dm:schemas:common.json#/JavaBool",
                  "description": "The checked status of the input"
                },
                "linkLabel": {
                  "type": "string",
                  "default": "",
                  "maxLength": 1000
                },
                "link": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
                },
                "label": {
                  "type": "string",
                  "default": "",
                  "maxLength": 4000
                },
                "indeterminate": {
                  "$ref": "urn:dm:schemas:common.json#/JavaBool",
                  "description": "Used for three state check box"
                },
                "direction": {
                  "$ref": "#/Direction",
                  "description": "direction of the component"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DateItem": {
      "type": "string",
      "format": "date-time"
    },
    "DateString": {
      "type": "string",
      "format": "date"
    },
    "DateRange": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "startDate",
        "endDate"
      ],
      "properties": {
        "startDate": {
          "$ref": "#/DateString"
        },
        "endDate": {
          "$ref": "#/DateString"
        }
      },
      "unevaluatedProperties": false
    },
    "DateRanges": {
      "type": "array",
      "default": [],
      "items": {
        "$ref": "#/DateRange"
      }
    },
    "DatePicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "disabledDates": {
                  "type": "array",
                  "items": {
                    "$ref": "#/DateItem"
                  },
                  "default": [],
                  "description": "array of disabled dates"
                },
                "disabledDaysOfWeek": {
                  "type": "array",
                  "items": {
                    "type": [
                      "number"
                    ],
                    "enum": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6
                    ]
                  },
                  "default": [],
                  "description": "array of disabled days"
                },
                "minDate": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "#/DateItem--unrestricted-root"
                    }
                  ],
                  "description": "date input minimum date value"
                },
                "maxDate": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "#/DateItem--unrestricted-root"
                    }
                  ],
                  "description": "date input maximum date value"
                },
                "allowPastDates": {
                  "type": "boolean",
                  "default": true,
                  "description": "if true all past days are enabled, false otherwise"
                },
                "allowFutureDates": {
                  "type": "boolean",
                  "default": true,
                  "description": "if true all future days are enabled, false otherwise"
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "maxLength": 200,
                  "description": "the placeholder option in case nothing is selected"
                },
                "enabledDateRanges": {
                  "$ref": "#/DateRanges",
                  "description": "array of enabled dates. each date in the format YYYY/MM/DD"
                },
                "disabledDateRanges": {
                  "$ref": "#/DateRanges",
                  "description": "array of disabled dates. each date in the format YYYY/MM/DD"
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Theme": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "properties": {
              "type": [
                "object",
                "null"
              ],
              "additionalProperties": true,
              "default": {}
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TwitterFollow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "accountToFollow": {
              "type": "string",
              "default": "wix"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TwitterTweet": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "defaultText": {
              "type": "string"
            },
            "accountToFollow": {
              "type": "string"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MobileMetaData": {
      "type": "object",
      "required": [
        "adaptiveMobileOn"
      ],
      "properties": {
        "adaptiveMobileOn": {
          "type": "boolean",
          "default": true
        }
      },
      "unevaluatedProperties": false
    },
    "Preloader": {
      "type": "object",
      "required": [
        "enabled",
        "uri"
      ],
      "properties": {
        "enabled": {
          "type": "boolean",
          "default": false
        },
        "uri": {
          "type": "string",
          "default": ""
        }
      },
      "unevaluatedProperties": false
    },
    "ContactInfo": {
      "type": "object",
      "required": [
        "companyName",
        "phone",
        "email",
        "address",
        "fax"
      ],
      "properties": {
        "companyName": {
          "type": "string",
          "default": ""
        },
        "phone": {
          "type": "string",
          "default": ""
        },
        "email": {
          "type": "string",
          "default": ""
        },
        "address": {
          "type": "string",
          "default": ""
        },
        "fax": {
          "type": "string",
          "default": ""
        }
      },
      "unevaluatedProperties": false
    },
    "SocialLink": {
      "type": "object",
      "required": [
        "id",
        "url"
      ],
      "properties": {
        "id": {
          "type": "string",
          "enum": [
            "facebook",
            "twitter",
            "pinterest",
            "google_plus",
            "tumblr",
            "blogger",
            "linkedin",
            "youtube",
            "vimeo",
            "flickr"
          ]
        },
        "url": {
          "type": "string",
          "default": ""
        }
      },
      "unevaluatedProperties": false
    },
    "QuickActions": {
      "type": "object",
      "required": [
        "colorScheme",
        "configuration",
        "socialLinks"
      ],
      "properties": {
        "colorScheme": {
          "type": "string",
          "enum": [
            "dark",
            "light"
          ],
          "default": "dark"
        },
        "configuration": {
          "type": "object",
          "default": {
            "addressEnabled": false,
            "emailEnabled": false,
            "navigationMenuEnabled": true,
            "phoneEnabled": false,
            "quickActionsMenuEnabled": false,
            "socialLinksEnabled": false
          },
          "properties": {
            "addressEnabled": {
              "type": "boolean",
              "default": false
            },
            "emailEnabled": {
              "type": "boolean",
              "default": false
            },
            "navigationMenuEnabled": {
              "type": "boolean",
              "default": true
            },
            "phoneEnabled": {
              "type": "boolean",
              "default": false
            },
            "quickActionsMenuEnabled": {
              "type": "boolean",
              "default": false
            },
            "socialLinksEnabled": {
              "type": "boolean",
              "default": false
            }
          },
          "unevaluatedProperties": false
        },
        "socialLinks": {
          "type": "array",
          "items": {
            "$ref": "#/SocialLink"
          },
          "default": []
        }
      },
      "unevaluatedProperties": false
    },
    "QuickActionBarItem": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "itemType"
          ],
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "itemType": {
              "maxLength": 50,
              "type": "string"
            },
            "text": {
              "maxLength": 40,
              "type": "string",
              "default": ""
            },
            "icon": {
              "maxLength": 200,
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SiteSettings": {
      "type": "object",
      "properties": {
        "siteName": {
          "type": "string",
          "default": ""
        },
        "siteTitleSEO": {
          "type": "string",
          "default": ""
        },
        "siteDescriptionSEO": {
          "type": "string",
          "default": ""
        },
        "keywordsSEO": {
          "type": "string",
          "default": ""
        },
        "allowSEFindSite": {
          "type": "boolean",
          "default": false
        },
        "favicon": {
          "type": "string",
          "default": ""
        },
        "thumbnail": {
          "type": "string",
          "default": ""
        },
        "googleAnalyticsID": {
          "type": "string",
          "default": ""
        },
        "fbAdminsUserId": {
          "type": "string",
          "default": ""
        },
        "suppressTrackingCookies": {
          "type": "boolean",
          "default": false
        }
      },
      "unevaluatedProperties": false
    },
    "AdvancedSeoSettingsDialog": {
      "type": "object",
      "properties": {
        "userMetaTags": {
          "type": "string",
          "default": ""
        }
      },
      "unevaluatedProperties": false
    },
    "Anchor": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "compId": {
              "type": "string"
            },
            "urlFragment": {
              "type": "string",
              "maxLength": 60
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BasicMenuItem": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "slot": {
              "type": "string"
            },
            "label": {
              "type": "string"
            },
            "isVisible": {
              "type": "boolean",
              "default": true
            },
            "isVisibleMobile": {
              "type": "boolean",
              "default": true
            },
            "displayCount": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "iconRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomMenu": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "menuType": {
              "type": "string",
              "maxLength": 100
            },
            "syncWithPages": {
              "type": "boolean",
              "default": false
            },
            "appId": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomMenusCollection": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menus": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomMenuDataRef": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menuRef": {
              "default": "#CUSTOM_MAIN_MENU",
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "itemDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 1st (top) level menu items"
            },
            "submenuDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 2nd level menu item (submenu)"
            },
            "submenuSubItemDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 3rd level menu item (submenuSubItem)"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomMenuDataRefA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Menu": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FacebookLikeBox": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "facebookPageId": {
              "type": "string",
              "default": "wix",
              "description": "Facebook page id"
            },
            "showFaces": {
              "type": "boolean",
              "default": true,
              "description": "Show profile photos in the plugin"
            },
            "colorScheme": {
              "type": "string",
              "default": "light",
              "enum": [
                "light",
                "dark"
              ],
              "description": "The color scheme of the plugin. Note that the background is always transparent to match your background color. This setting changes the foreground colors to work well on light or dark backgrounds."
            },
            "showStream": {
              "type": "boolean",
              "default": true,
              "description": "Show the profile stream for the public profile"
            },
            "showBorder": {
              "type": "boolean",
              "default": true,
              "description": "Show a border around the plugin"
            },
            "showHeader": {
              "type": "boolean",
              "default": true,
              "description": "Show the 'Find us on Facebook' bar at top. Only shown when either stream or faces are present"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageButtonA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "alt": {
              "type": "string"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "defaultImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "hoverImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "activeImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "NumericStepper": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "1"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PinItPinWidget": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pinId": {
              "type": "string",
              "default": "http://www.pinterest.com/pin/204421270560540859/"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PinterestPinIt": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "description": {
              "type": "string",
              "default": "Check it out!"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SingleAudioPlayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": "",
              "description": "MP3 uri"
            },
            "originalFileName": {
              "type": "string",
              "default": "",
              "description": "Original MP3 file name"
            },
            "artist": {
              "type": "string",
              "default": "Unknown Artist",
              "description": "Artist Name"
            },
            "track": {
              "type": "string",
              "default": "Unknown Track",
              "description": "Track Name"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SkypeCallButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "skypeName": {
              "type": "string"
            },
            "buttonType": {
              "type": "string",
              "enum": [
                "call",
                "chat"
              ],
              "default": "call"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SpotifyFollow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SpotifyPlayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": "",
              "description": "Spotify URI"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SubscribeForm": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "firstNameFieldLabel": {
              "type": "string",
              "default": "First Name"
            },
            "lastNameFieldLabel": {
              "type": "string",
              "default": "Last Name"
            },
            "emailFieldLabel": {
              "type": "string",
              "default": "Email"
            },
            "phoneFieldLabel": {
              "type": "string",
              "default": "Mobile number"
            },
            "subscribeFormTitle": {
              "type": "string",
              "default": "Subscribe for Updates"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Subscribe Now"
            },
            "successMessage": {
              "type": "string",
              "default": "Congrats! You’re subscribed"
            },
            "errorMessage": {
              "type": "string",
              "default": "Forgot your email? Try again."
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "To subscribe please fill in all the required info"
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "YouTubeSubscribeButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "youtubeChannelId": {
              "type": "string",
              "default": "wix",
              "description": "youtube channel id"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AudioPlayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "autoPlay": {
              "type": "boolean",
              "default": false
            },
            "loop": {
              "type": "boolean",
              "default": false
            },
            "visible": {
              "type": "boolean",
              "default": true
            },
            "volume": {
              "type": "number",
              "default": 100
            },
            "title": {
              "type": "string",
              "default": ""
            },
            "description": {
              "type": "string",
              "default": ""
            },
            "icon_uri": {
              "type": "string",
              "default": ""
            },
            "originalFileName": {
              "type": "string",
              "default": ""
            },
            "showToolTip": {
              "$ref": "urn:dm:schemas:common.json#/JavaBool"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Boolean": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        }
      },
      "unevaluatedProperties": false
    },
    "CheckBox": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        },
        "indeterminate": {
          "type": "boolean",
          "default": false,
          "description": "Used for three state check box"
        }
      },
      "unevaluatedProperties": false
    },
    "Grid": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "dataSource": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "static",
                    "dynamic"
                  ]
                },
                "revision": {
                  "type": "number",
                  "multipleOf": 1
                }
              },
              "unevaluatedProperties": false
            },
            "rows": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": true,
                "unevaluatedProperties": false
              }
            },
            "rowsCount": {
              "type": "number"
            },
            "revision": {
              "type": "number"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ContactForm": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "nameFieldLabel": {
              "type": "string",
              "default": "Name"
            },
            "emailFieldLabel": {
              "type": "string",
              "default": "Email"
            },
            "phoneFieldLabel": {
              "type": "string",
              "default": "Phone"
            },
            "addressFieldLabel": {
              "type": "string",
              "default": "Address"
            },
            "subjectFieldLabel": {
              "type": "string",
              "default": "Subject"
            },
            "messageFieldLabel": {
              "type": "string",
              "default": "Message"
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Send"
            },
            "successMessage": {
              "type": "string",
              "default": "Your details were sent successfully!"
            },
            "errorMessage": {
              "type": "string",
              "default": "Please provide a valid email"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "Please fill in all required fields."
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DynamicContactForm": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Send"
            },
            "successMessage": {
              "type": "string",
              "default": "Your details were sent successfully!"
            },
            "errorMessage": {
              "type": "string",
              "default": "Please provide a valid email"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "Please fill in all required fields."
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "formName": {
              "type": "string",
              "default": ""
            },
            "dynamicFields": {
              "type": "array",
              "default": [
                {
                  "name": "email",
                  "inputType": "email",
                  "displayLabel": "Email",
                  "required": true
                },
                {
                  "name": "name",
                  "inputType": "text",
                  "displayLabel": "Name",
                  "required": true
                },
                {
                  "name": "subject",
                  "inputType": "text",
                  "displayLabel": "Subject",
                  "required": false
                },
                {
                  "name": "message",
                  "inputType": "text",
                  "displayLabel": "Message",
                  "required": false
                }
              ],
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string",
                    "maxLength": 50
                  },
                  "inputType": {
                    "type": "string",
                    "maxLength": 50
                  },
                  "displayLabel": {
                    "type": "string",
                    "maxLength": 200
                  },
                  "required": {
                    "$ref": "urn:dm:schemas:common.json#/JavaBool"
                  },
                  "displayed": {
                    "$ref": "urn:dm:schemas:common.json#/JavaBool"
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "EbayItemsBySeller": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "sellerId": {
              "type": "string"
            },
            "registrationSite": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FacebookShareButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "urlChoice": {
              "type": "string",
              "enum": [
                "Current page",
                "Site"
              ],
              "default": "Current page",
              "description": "Share: current/site url"
            },
            "label": {
              "type": "string",
              "default": "Share",
              "description": ""
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlashComponent": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string"
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            },
            "title": {
              "type": "string",
              "maxLength": 100
            },
            "uri": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 1000
            },
            "height": {
              "type": "number",
              "default": 0
            },
            "width": {
              "type": "number",
              "default": 0
            },
            "placeHolderImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FlickrBadgeWidget": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "userId": {
              "type": "string",
              "default": "74009459@N07"
            },
            "userName": {
              "type": "string"
            },
            "tag": {
              "type": "string"
            },
            "imageCount": {
              "type": [
                "string",
                "number"
              ],
              "default": 3
            },
            "whichImages": {
              "type": "string",
              "default": "latest"
            },
            "imageSize": {
              "type": "string",
              "default": "t"
            },
            "layoutOrientation": {
              "type": "string",
              "default": "v"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GeoMapLocation": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "address": {
              "type": "string",
              "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158",
              "maxLength": 1000
            },
            "latitude": {
              "type": "number",
              "default": 37.77065
            },
            "longitude": {
              "type": "number",
              "default": -122.387301
            },
            "title": {
              "type": "string",
              "default": "Wix Office",
              "maxLength": 10000
            },
            "description": {
              "type": "string",
              "default": "Wix HQ",
              "maxLength": 350
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "linkTitle": {
              "type": "string",
              "default": "Visit Wix's Site",
              "maxLength": 140
            },
            "pinIcon": {
              "type": "string",
              "default": "https://static.parastorage.com/services/santa-resources/resources/editor/designPanel/panelTypes/default_pin_icon.png",
              "maxLength": 1000
            },
            "pinColor": {
              "type": "string",
              "default": "#2A3688",
              "maxLength": 20
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GeoMap": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "language": {
              "type": "string",
              "enum": [
                "af",
                "sq",
                "am",
                "ar",
                "hy",
                "az",
                "eu",
                "be",
                "bn",
                "bs",
                "bg",
                "my",
                "ca",
                "zh",
                "zh-CN",
                "zh-HK",
                "zh-TW",
                "hr",
                "cs",
                "da",
                "nl",
                "en",
                "en-AU",
                "en-GB",
                "et",
                "fa",
                "fi",
                "fil",
                "fr",
                "fr-CA",
                "gl",
                "ka",
                "de",
                "el",
                "gu",
                "iw",
                "hi",
                "hu",
                "is",
                "id",
                "it",
                "ja",
                "kn",
                "kk",
                "km",
                "ko",
                "ky",
                "lo",
                "lv",
                "lt",
                "mk",
                "ms",
                "ml",
                "mr",
                "mn",
                "ne",
                "no",
                "pl",
                "pt",
                "pt-BR",
                "pt-PT",
                "pa",
                "ro",
                "ru",
                "sr",
                "si",
                "sk",
                "sl",
                "es",
                "es-419",
                "sw",
                "sv",
                "ta",
                "te",
                "th",
                "tr",
                "uk",
                "ur",
                "uz",
                "vi",
                "zu"
              ]
            },
            "locations": {
              "minItems": 0,
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "address": {
              "type": "string",
              "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158"
            },
            "latitude": {
              "type": "number",
              "default": 37.77065
            },
            "longitude": {
              "type": "number",
              "default": -122.387301
            },
            "addressInfo": {
              "type": "string",
              "default": "Wix Office"
            },
            "defaultLocation": {
              "type": "number",
              "default": 0
            },
            "mapStyle": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "stylers"
                ],
                "properties": {
                  "elementType": {
                    "type": "string",
                    "enum": [
                      "all",
                      "geometry",
                      "geometry.fill",
                      "geometry.stroke",
                      "labels",
                      "labels.icon",
                      "labels.text",
                      "labels.text.fill",
                      "labels.text.stroke"
                    ],
                    "description": "Selects the element type to which a styler should be applied. An element type distinguishes between the different representations of a feature."
                  },
                  "featureType": {
                    "type": "string",
                    "enum": [
                      "administrative",
                      "administrative.country",
                      "administrative.land_parcel",
                      "administrative.locality",
                      "administrative.neighborhood",
                      "administrative.province",
                      "all",
                      "landscape",
                      "landscape.man_made",
                      "landscape.natural",
                      "landscape.natural.landcover",
                      "landscape.natural.terrain",
                      "poi",
                      "poi.attraction",
                      "poi.business",
                      "poi.government",
                      "poi.medical",
                      "poi.park",
                      "poi.place_of_worship",
                      "poi.school",
                      "poi.sports_complex",
                      "road",
                      "road.arterial",
                      "road.highway",
                      "road.highway.controlled_access",
                      "road.local",
                      "transit",
                      "transit.line",
                      "transit.station",
                      "transit.station.airport",
                      "transit.station.bus",
                      "transit.station.rail",
                      "water"
                    ],
                    "description": "Selects the feature, or group of features, to which a styler should be applied."
                  },
                  "stylers": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "maxProperties": 1,
                      "additionalProperties": false,
                      "description": "The style rules to apply to the selectors. The rules are applied to the map's elements in the order they are listed in this array.",
                      "properties": {
                        "color": {
                          "type": "string",
                          "maxLength": 100,
                          "description": "Sets the color of the feature. Valid values: An RGB hex string, i.e. '#ff0000'."
                        },
                        "gamma": {
                          "type": "number",
                          "description": "Modifies the gamma by raising the lightness to the given power.Valid values: Floating point numbers, [0.01, 10], with 1.0 representing no change."
                        },
                        "hue": {
                          "type": "string",
                          "maxLength": 100,
                          "description": "Sets the hue of the feature to match the hue of the color supplied. Note that the saturation and lightness of the feature is conserved, which means that the feature will not match the color supplied exactly. Valid values: An RGB hex string, i.e. '#ff0000'."
                        },
                        "invert_lightness": {
                          "type": "boolean",
                          "description": "A value of true will invert the lightness of the feature while preserving the hue and saturation."
                        },
                        "lightness": {
                          "type": "number",
                          "description": "Shifts lightness of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                        },
                        "saturation": {
                          "type": "number",
                          "description": "Shifts the saturation of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                        },
                        "visibility": {
                          "type": "string",
                          "enum": [
                            "on",
                            "off",
                            "simplified"
                          ],
                          "description": "Sets the visibility of the feature. Valid values: 'on', 'off' or 'simplified'."
                        },
                        "weight": {
                          "type": "number",
                          "description": "Sets the weight of the feature, in pixels. Valid values: Integers greater than or equal to zero."
                        }
                      },
                      "unevaluatedProperties": false
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "HtmlComponent": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "sourceType": {
              "type": "string",
              "default": ""
            },
            "url": {
              "type": "string",
              "default": ""
            },
            "title": {
              "type": "string"
            },
            "freezeFrame": {
              "type": "boolean",
              "default": false
            },
            "allowFullScreen": {
              "type": "boolean",
              "default": false
            },
            "componentConsentPolicy": {
              "type": "string",
              "default": "essential",
              "enum": [
                "essential",
                "functional",
                "analytics",
                "advertising",
                "dataToThirdParty"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DisqusComments": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "disqusId": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ItunesButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "downloadUrl": {
              "type": "string",
              "default": "",
              "description": "Insert band URL"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LinkableFlashComponent": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "title": {
              "type": "string"
            },
            "uri": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "height": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "placeHolderImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LinkableButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LoginButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "language": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TinyMenu": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "loginSocialBarRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "menuRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LoginSocialBar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menuItemsRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "iconItemsRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "language": {
              "type": "string",
              "default": "en",
              "maxLength": 10
            },
            "loggedInMember": {
              "type": "string",
              "enum": [
                "avatarOnly",
                "textOnly",
                "avatarAndText",
                "memberInitials"
              ],
              "default": "avatarAndText"
            },
            "loggedOutMember": {
              "type": "string",
              "enum": [
                "avatarOnly",
                "textOnly",
                "avatarAndText"
              ]
            },
            "loggedInAvatarIcon": {
              "type": "string",
              "enum": [
                "profileImage",
                "initials",
                "custom"
              ]
            },
            "loggedOutAvatarIcon": {
              "type": "string",
              "enum": [
                "profileImage",
                "initials",
                "custom"
              ],
              "default": "profileImage"
            },
            "loggedInCustomAvatar": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "loggedOutCustomAvatar": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "loggedOutText": {
              "type": "string",
              "default": "Log In",
              "maxLength": 50
            },
            "showLoggedInText": {
              "type": "boolean",
              "default": true
            },
            "loggedInTextState": {
              "type": "string",
              "enum": [
                "memberName",
                "custom"
              ]
            },
            "loggedInText": {
              "type": "string",
              "default": "Hello",
              "maxLength": 50
            },
            "customLoggedInText": {
              "type": "string",
              "maxLength": 50
            },
            "logOutText": {
              "type": "string",
              "default": "Log Out",
              "maxLength": 50
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PagesGroupData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appId": {
              "type": [
                "number",
                "null"
              ]
            },
            "appDefinitionId": {
              "type": "string"
            },
            "groupName": {
              "type": "string"
            },
            "pages": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PagesGroupCollection": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "groups": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PayPalButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "merchantID": {
              "type": "string",
              "default": "",
              "description": "some amazing description"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PermaLink": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "appType"
          ],
          "properties": {
            "appType": {
              "enum": [
                "ListsApps",
                "ThirdPartyApps"
              ]
            },
            "dataItemRef": {
              "default": "",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mutableSeoTitle": {
              "type": "string"
            },
            "correctPermaLinkRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PinterestFollow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "urlChoice": {
              "type": "string",
              "default": "pinterest/",
              "description": ""
            },
            "label": {
              "type": "string",
              "default": "Pinterest",
              "description": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SelectableList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "$ref": "#/Direction",
                  "description": "direction of the component"
                },
                "labelDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the label"
                },
                "inputDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the input"
                },
                "dropdownDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the dropdown"
                },
                "errorDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the error"
                },
                "options": {
                  "description": "a list of SelectOption data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": "object",
                  "properties": {
                    "value": {
                      "type": "string",
                      "default": "-1",
                      "description": "the value of the placeholder option",
                      "maxLength": 400
                    },
                    "text": {
                      "type": "string",
                      "default": "",
                      "description": "the text of the placeholder option",
                      "maxLength": 400
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SelectOption": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "text": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "selectedText": {
              "type": "string",
              "maxLength": 400
            },
            "disabled": {
              "type": "boolean"
            },
            "description": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RadioButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "label": {
                  "type": "string",
                  "default": "",
                  "maxLength": 400
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RadioGroup": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "optionsDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "defaultValue": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "options": {
                  "description": "a list of RadioButton data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": "object",
                  "properties": {
                    "value": {
                      "type": "string",
                      "default": "-1",
                      "description": "the value of the placeholder option",
                      "maxLength": 400
                    },
                    "text": {
                      "type": "string",
                      "default": "",
                      "description": "the text of the placeholder option",
                      "maxLength": 400
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CheckboxGroup": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "optionsDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "options": {
                  "description": "a list of CheckboxInput data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 4000
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FileUploader": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "buttonLabel": {
              "type": "string",
              "default": "Upload File",
              "maxLength": 500
            },
            "placeholderLabel": {
              "type": "string",
              "default": "Max File Size 15MG",
              "maxLength": 500
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "maxLength": 400
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonLabelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "filesDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "iconPosition": {
              "type": [
                "string"
              ],
              "enum": [
                "row",
                "rowReverse",
                "column",
                "columnReverse"
              ],
              "description": "Flex direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "UploadName": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SiteButtonA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pressed": {
              "type": "boolean"
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "haspopup": {
              "type": "string",
              "enum": [
                "true",
                "false",
                "menu",
                "dialog",
                "listbox",
                "tree",
                "grid"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "disabled": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SiteButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SoundCloudWidget": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string",
              "default": ""
            },
            "showArtWork": {
              "type": "boolean",
              "default": true
            },
            "autoPlay": {
              "type": "boolean",
              "default": false
            },
            "embedSource": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StyledTextA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StyledText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000,
              "default": "<p class='font_7'></p>",
              "not": {
                "pattern": "<script"
              }
            },
            "stylesMapId": {
              "type": "string"
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StyledTextLinkHelper": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
        }
      },
      "unevaluatedProperties": false
    },
    "SvgShape": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "alt": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VectorImage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            },
            "alt": {
              "type": "string",
              "description": "Alternative text for the vector image (for accessibility purposes).",
              "default": ""
            },
            "decorative": {
              "type": "boolean"
            },
            "title": {
              "type": "string",
              "maxLength": 100,
              "description": "Title or caption for the vector image."
            },
            "svgId": {
              "type": "string",
              "maxLength": 100,
              "description": "Identifier for the SVG image."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Video": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "videoId": {
              "type": "string"
            },
            "userId": {
              "type": "string"
            },
            "posterImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "videoType": {
              "type": "string",
              "enum": [
                "YOUTUBE",
                "VIMEO",
                "FACEBOOK",
                "DAILYMOTION"
              ],
              "default": "YOUTUBE"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VKShareButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "style": {
              "type": "string",
              "enum": [
                "Button",
                "ButtonWithoutCounter",
                "Link",
                "LinkWithoutIcon",
                "Icon"
              ],
              "default": "Button",
              "description": "the layout of the button"
            },
            "text": {
              "type": "string",
              "default": "Share",
              "description": "the text of the Button"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ButtonWithIcon": {
      "type": "object",
      "properties": {
        "label": {
          "type": "string",
          "format": "resourceKey"
        },
        "toggleMode": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        },
        "iconSrc": {
          "type": "string"
        },
        "iconSize": {
          "type": "object",
          "additionalProperties": true,
          "unevaluatedProperties": false
        },
        "spriteOffset": {
          "type": "object",
          "additionalProperties": true,
          "unevaluatedProperties": false
        },
        "command": {
          "type": "string"
        },
        "commandParameter": {
          "type": "string"
        },
        "action": {
          "type": "string"
        }
      },
      "unevaluatedProperties": false
    },
    "EditorPreferences": {
      "type": "object",
      "properties": {
        "dontShowAgainTooltips": {
          "type": [
            "null",
            "array"
          ]
        },
        "dontShowAgainDialogs": {
          "type": [
            "null",
            "array"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "TPAWidget": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "some amazing description"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TPAData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "content": {
              "type": "string",
              "default": "",
              "description": "storage for app data",
              "maxLength": 4000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TPAGlobalData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "content": {
              "type": "string",
              "default": "",
              "description": "storage for app data"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Definition ID"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TPA": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "referenceId": {
              "type": "string"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "widget id"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TPASection": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TPAMultiSection": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "hidden tpaSection part of multi section app"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RssButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "image": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "type": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AppPart": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appInnerID": {
              "type": [
                "string",
                "number"
              ]
            },
            "appLogicParams": {
              "type": "object",
              "default": {},
              "additionalProperties": true,
              "unevaluatedProperties": false
            },
            "appLogicCustomizations": {
              "type": "array",
              "items": {
                "$ref": "#/AppPartCustomization"
              },
              "default": []
            },
            "appPartName": {
              "type": "string"
            },
            "viewName": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AppPartCustomization": {
      "type": "object",
      "properties": {
        "fieldId": {
          "type": "string"
        },
        "forType": {
          "type": "string"
        },
        "format": {
          "type": "string"
        },
        "key": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "view": {
          "type": "string"
        },
        "mode": {
          "type": [
            "string",
            "null"
          ]
        },
        "value": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "AppPage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "appPageId": {
                  "type": "string",
                  "default": ""
                },
                "appInnerID": {
                  "type": [
                    "string",
                    "number"
                  ],
                  "default": ""
                },
                "appPageType": {
                  "type": "string"
                },
                "repeaterPage": {
                  "type": "boolean",
                  "default": false
                }
              }
            },
            {
              "$ref": "#/Page--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AppBuilderComponent": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appInnerID": {
              "type": [
                "string",
                "null"
              ]
            },
            "appPartName": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BoxSlideShow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BoxSlideShowSlide": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripContainerSlideShow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StripContainerSlideShowSlide": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VerticalAnchorsMenu": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pageTopLabel": {
              "type": [
                "null",
                "string"
              ],
              "default": "Page Top"
            },
            "pageBottomLabel": {
              "type": [
                "null",
                "string"
              ],
              "default": "Page Bottom"
            },
            "hiddenAnchorIds": {
              "type": [
                "null",
                "object"
              ],
              "default": {}
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "bulletPosition": {
              "type": [
                "string"
              ],
              "enum": [
                "row",
                "rowReverse",
                "column",
                "columnReverse"
              ],
              "description": "Flex direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WFacebookComment": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WFacebookLike": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AppController": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "applicationId",
            "controllerType"
          ],
          "properties": {
            "applicationId": {
              "type": "string",
              "maxLength": 100
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "default": ""
            },
            "controllerType": {
              "type": "string",
              "maxLength": 100
            },
            "settings": {
              "type": "string",
              "maxLength": 6000
            },
            "externalId": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RepeaterA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "none",
                "radiogroup",
                "list",
                "group"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Repeater": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "items": {
              "type": "array",
              "default": [],
              "items": {
                "type": "string"
              },
              "description": "Unique identifiers for items of the repeater"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RepeatedData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "description": "data used for the serialization of a component inside a repeater component",
          "properties": {
            "original": {
              "type": "object",
              "additionalProperties": true,
              "description": "the original data item of a component inside a repeater according to the specific component schema",
              "unevaluatedProperties": false
            },
            "overrides": {
              "type": "object",
              "additionalProperties": true,
              "description": "a map from itemId in a repeater to its data item according to the specific component schema",
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageButtonWithText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 100
            },
            "icon": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "predefinedClass": {
              "type": "string",
              "maxLength": 20
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Icon": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string"
            },
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "title": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WidgetRef": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appDefinitionId": {
              "type": "string"
            },
            "widgetId": {
              "type": "string"
            },
            "variationId": {
              "type": [
                "string",
                "null"
              ]
            },
            "name": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "InternalRef": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            },
            "pageId": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "InternalBlocksRef": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "type": "string"
            },
            "pageId": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ForwardRef": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LightboxA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LightboxContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ContainerA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "none",
                "status",
                "alert",
                "nav",
                "list",
                "listitem",
                "tablist",
                "tab",
                "tabpanel",
                "menubar",
                "presentation",
                "heading"
              ]
            },
            "roledescription": {
              "type": "string",
              "maxLength": 100
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ],
              "maxLength": 10
            },
            "hidden": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string",
              "enum": [
                "all",
                "additions",
                "text",
                "removals"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ContainerData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MediaBoxData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SlotsPlaceholderData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "interfaces"
          ],
          "properties": {
            "interfaces": {
              "type": "array",
              "items": {
                "type": "string"
              },
              "maxItems": 20
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LinkType": {
      "type": "string",
      "enum": [
        "SMS",
        "CALL",
        "SKYPE",
        "MAP",
        "EMAIL",
        "FACEBOOK",
        "FLICKR",
        "BLOGGER",
        "MYSPACE",
        "LINKEDIN",
        "TWITTER",
        "TUMBLR",
        "YOUTUBE",
        "VIMEO",
        "PAGE",
        "FREE_LINK",
        "TEXT",
        "DELICIOUS",
        "WEBSITE",
        "DOCUMENT",
        "ADMIN_LOGIN",
        "LOGIN"
      ],
      "default": "FREE_LINK"
    },
    "UrlFormat": {
      "type": "string",
      "enum": [
        "hashBang",
        "slash"
      ],
      "default": "slash"
    },
    "MultiStateBoxDataA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MultiStateBoxData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "defaultStateId": {
                  "default": "FIRST_STATE",
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "selectedStateId": {
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AppsInstallState": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "stateMap": {
              "type": "object",
              "default": {},
              "additionalProperties": {
                "type": "object",
                "required": [
                  "status"
                ],
                "properties": {
                  "status": {
                    "type": "string",
                    "enum": [
                      "INSTALLED",
                      "REMOVED"
                    ],
                    "default": "INSTALLED"
                  },
                  "version": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 20
                  },
                  "codeReferenceId": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 40
                  },
                  "overrideCodeReferenceId": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 40
                  }
                }
              },
              "properties": {},
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StateBoxA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StateBox": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StateBoxStateA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StateBoxState": {
      "type": "object",
      "properties": {
        "a11y": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        }
      },
      "unevaluatedProperties": false
    },
    "Builder.MenuItem": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "container": {
              "type": "string"
            },
            "label": {
              "type": "string"
            },
            "isVisible": {
              "type": "boolean",
              "default": true
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Builder.MenuItems": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Builder.Image": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string",
              "maxLength": 1000,
              "description": "Identifier or URL for the image."
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "description": "Human-readable filename to use for the image."
            },
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "alt": {
              "type": "string",
              "maxLength": 1000
            },
            "crop": {
              "type": "object",
              "required": [
                "width",
                "height",
                "x",
                "y"
              ],
              "properties": {
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Builder.Video": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "description": "Unique identifier for the video media",
              "maxLength": 1000
            },
            "sources": {
              "type": "array",
              "description": "Available video sources in different qualities",
              "items": {
                "type": "object",
                "required": [
                  "quality",
                  "width",
                  "height",
                  "types"
                ],
                "properties": {
                  "quality": {
                    "type": "string",
                    "enum": [
                      "1080p",
                      "720p",
                      "480p",
                      "360p"
                    ],
                    "description": "Quality level of the video source"
                  },
                  "width": {
                    "type": "number",
                    "description": "Width of the video in pixels"
                  },
                  "height": {
                    "type": "number",
                    "description": "Height of the video in pixels"
                  },
                  "types": {
                    "type": "array",
                    "description": "Available format types and their URIs for this quality",
                    "items": {
                      "type": "object",
                      "required": [
                        "format",
                        "uri"
                      ],
                      "properties": {
                        "format": {
                          "type": "string",
                          "enum": [
                            "mp4",
                            "mp4-luminance"
                          ],
                          "description": "Video format type"
                        },
                        "uri": {
                          "type": "string",
                          "description": "URI to access the video file"
                        }
                      },
                      "unevaluatedProperties": false
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "adaptiveSources": {
              "type": "array",
              "description": "Sources for adaptive streaming formats",
              "items": {
                "type": "object",
                "required": [
                  "format",
                  "uri"
                ],
                "properties": {
                  "format": {
                    "type": "string",
                    "enum": [
                      "hls",
                      "dash"
                    ],
                    "description": "Adaptive streaming format"
                  },
                  "uri": {
                    "type": "string",
                    "description": "URI to access the stream manifest"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "hasAudio": {
              "type": "boolean",
              "description": "Whether the video contains an audio track"
            },
            "fps": {
              "type": "number",
              "description": "Frames per second of the video"
            },
            "poster": {
              "description": "Poster image for the video",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "duration": {
              "type": "number",
              "description": "Duration of the video in seconds"
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "description": "Human-readable name to use for the video."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Builder.VectorArt": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Builder.RichText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixStudio2Demo.counterContextProvider.Data": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "data"
          ],
          "properties": {
            "data": {
              "type": "object",
              "additionalProperties": true,
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "contentType": {
              "default": "Text",
              "enum": [
                "Text",
                "Icon",
                "Text and icon"
              ],
              "type": "string"
            },
            "label": {
              "default": "Button",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "iconPosition": {
              "default": "Left",
              "enum": [
                "Left",
                "Right"
              ],
              "type": "string"
            },
            "buttonType": {
              "default": "Full",
              "enum": [
                "Full",
                "Outline",
                "Link"
              ],
              "type": "string"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiDatePicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Select Date",
              "maxLength": 120,
              "type": "string"
            },
            "initialText": {
              "default": "today's date",
              "enum": [
                "today's date",
                "placeholder"
              ],
              "type": "string"
            },
            "placeholder": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "fieldType": {
              "default": "form",
              "enum": [
                "form",
                "settings",
                "filter"
              ],
              "type": "string"
            },
            "pickerType": {
              "default": "calendar",
              "enum": [
                "wheel",
                "calendar"
              ],
              "type": "string"
            },
            "pickerTitle": {
              "default": "Select Date",
              "maxLength": 120,
              "type": "string"
            },
            "showPastDates": {
              "default": true,
              "type": "boolean"
            },
            "showFutureDates": {
              "default": true,
              "type": "boolean"
            },
            "wheelMode": {
              "default": "DD/MM/YY",
              "enum": [
                "DD/MM/YY",
                "MM/YY"
              ],
              "type": "string"
            },
            "firstDay": {
              "default": "Monday",
              "enum": [
                "Sunday",
                "Monday"
              ],
              "type": "string"
            },
            "disabledDaysOfWeek": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "enabledDateRanges": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "disabledDateRanges": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "requiredErrorMessage": {
              "default": "This field is required",
              "maxLength": 1200,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "disabledDates": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "minDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "maxDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "timeZone": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "defaultItemSchemaType": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MobuiDateRangeType": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "startDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "endDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiImage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "src": {
              "$ref": "#/ImageReference"
            },
            "isExternalSource": {
              "default": false,
              "type": "boolean"
            },
            "resizeMode": {
              "default": "cover",
              "enum": [
                "cover",
                "contain",
                "stretch",
                "repeat",
                "center"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiPicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldType": {
              "default": "form",
              "enum": [
                "form",
                "filter",
                "settings"
              ],
              "type": "string"
            },
            "label": {
              "default": "Label",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Select an option",
              "maxLength": 120,
              "type": "string"
            },
            "pickerType": {
              "default": "fullScreen",
              "enum": [
                "fullScreen",
                "dialog"
              ],
              "type": "string"
            },
            "optionsDialogTitle": {
              "default": "Select an Option",
              "maxLength": 120,
              "type": "string"
            },
            "optionsDialogSubtitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "hasItemSubtitle": {
              "default": false,
              "type": "boolean"
            },
            "isMultiselect": {
              "default": false,
              "type": "boolean"
            },
            "selectionLimit": {
              "default": 3,
              "type": "number",
              "multipleOf": 1
            },
            "hasSearchBar": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "requiredErrorMessage": {
              "default": "Please fill out this field",
              "maxLength": 120,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "validateOnBlur": {
              "default": false,
              "type": "boolean"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MobuiPickerItemType": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "subtitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isSelected": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiSwitch": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "value": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Add Title",
              "maxLength": 1200,
              "type": "string"
            },
            "selectable": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiTextInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "inputType": {
              "default": "text",
              "enum": [
                "text",
                "password",
                "phone",
                "email",
                "url",
                "number"
              ],
              "type": "string"
            },
            "label": {
              "default": "Label",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "initialValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "hasCharLimit": {
              "default": false,
              "type": "boolean"
            },
            "maxInputLength": {
              "default": 300,
              "maximum": 120000,
              "type": "number",
              "multipleOf": 1
            },
            "prefixValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "suffixValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "requiredErrorMessage": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validatorErrorMessageValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validatorType": {
              "default": "none",
              "enum": [
                "none",
                "number",
                "email",
                "url",
                "required"
              ],
              "type": "string"
            },
            "textContentType": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "autoComplete": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "validateOnBlur": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiVideoPlayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "title": {
              "default": "I am a Title",
              "maxLength": 120,
              "type": "string"
            },
            "src": {
              "default": "https://video.wixstatic.com/video/11062b_5ae1557b0cb244ab80dabfa817f48caa/1080p/mp4/file.mp4",
              "maxLength": 1200,
              "type": "string"
            },
            "poster": {
              "$ref": "#/ImageReference"
            },
            "isPlaying": {
              "default": false,
              "type": "boolean"
            },
            "muteOnStart": {
              "default": false,
              "type": "boolean"
            },
            "playInLoop": {
              "default": false,
              "type": "boolean"
            },
            "enableFullScreen": {
              "default": true,
              "type": "boolean"
            },
            "enableCasting": {
              "default": false,
              "type": "boolean"
            },
            "showVideoSettings": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "mobui.MobuiMultiStateBoxData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "defaultStateId": {
                  "default": null,
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "selectedStateId": {
                  "default": null,
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.ExternalComponent": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "compProps": {
              "default": "{}",
              "maxLength": 120000,
              "type": "string"
            },
            "isTrusted": {
              "default": false,
              "type": "boolean"
            },
            "importKey": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.HamburgerOverlay": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "showBackgroundOverlay": {
              "default": true,
              "type": "boolean"
            },
            "tapOutsideToClose": {
              "default": true,
              "type": "boolean"
            },
            "isMenuContainerFullscreen": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.Logo": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "isLoadingData": {
              "default": true,
              "type": "boolean"
            },
            "logoId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "alt": {
              "default": "Logo",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "preset": {
              "default": "original",
              "maxLength": 120,
              "type": "string"
            },
            "hasBackground": {
              "default": true,
              "type": "boolean"
            },
            "brandId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "backgroundColor": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "logoUrl": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.LottieEmbed": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "animationUrl": {
              "default": "https://assets7.lottiefiles.com/packages/lf20_bh69rwvr.json",
              "maxLength": 1200,
              "type": "string"
            },
            "speed": {
              "default": 1,
              "minimum": 0,
              "type": "number"
            },
            "loop": {
              "default": true,
              "type": "boolean"
            },
            "autoplay": {
              "default": true,
              "type": "boolean"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isDecorative": {
              "default": false,
              "type": "boolean"
            },
            "showPlaybackControl": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.ProductSpecification": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.RangeSlider": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Set a range value",
              "maxLength": 120,
              "type": "string"
            },
            "sliderType": {
              "default": "Continuous",
              "enum": [
                "Continuous",
                "Stepped"
              ],
              "type": "string"
            },
            "stepType": {
              "default": "Number",
              "enum": [
                "Number",
                "Value"
              ],
              "type": "string"
            },
            "step": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "direction": {
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ],
              "type": "string"
            },
            "rootDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "labelDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "sliderDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "min": {
              "default": 0,
              "type": "number"
            },
            "max": {
              "default": 100,
              "type": "number"
            },
            "prefix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "suffix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "minValue": {
              "default": 0,
              "type": "number"
            },
            "maxValue": {
              "default": 0,
              "type": "number"
            },
            "thumbShape": {
              "default": "Circle",
              "enum": [
                "Circle",
                "Square",
                "Rectangle",
                "Bar"
              ],
              "type": "string"
            },
            "marksTickShape": {
              "default": "Lines",
              "enum": [
                "Lines",
                "Dots"
              ],
              "type": "string"
            },
            "thumbSize": {
              "default": 24,
              "type": "number",
              "multipleOf": 1
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "accessibleName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.Rive": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "animationFileUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "thumbnailFileUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "artboard": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "stateMachine": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "fit": {
              "default": "cover",
              "maxLength": 120,
              "type": "string"
            },
            "alignment": {
              "default": "center",
              "maxLength": 120,
              "type": "string"
            },
            "isAutoPlayOn": {
              "default": true,
              "type": "boolean"
            },
            "isTouchScrollEnabled": {
              "default": true,
              "type": "boolean"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "fileName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isDecorative": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.ShareButtons": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "buttons": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "pageToShare": {
              "default": "home",
              "maxLength": 1200,
              "type": "string"
            },
            "shareUrl": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "direction": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "IShareButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "platformId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            },
            "isHidden": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.SingleTab": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "tabId"
          ],
          "type": "object",
          "properties": {
            "tabId": {
              "maxLength": 120,
              "type": "string"
            },
            "label": {
              "default": "Tab",
              "maxLength": 120,
              "type": "string"
            },
            "isParentStretched": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AccordionContainerData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "items": {
              "type": "array",
              "items": {
                "type": "object",
                "allOf": [
                  {
                    "properties": {
                      "id": {
                        "type": "string"
                      },
                      "label": {
                        "type": "string"
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false
              },
              "default": []
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AccordionItemData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isParentStretched": {
              "type": "boolean",
              "default": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AddressInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "optionsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "locale": {
              "type": "string",
              "maxLength": 100
            },
            "googleMapsApiKey": {
              "type": "string",
              "maxLength": 400
            },
            "filter": {
              "type": "object",
              "properties": {
                "country": {
                  "type": "string",
                  "maxLength": 10
                }
              },
              "unevaluatedProperties": false
            },
            "sorting": {
              "type": "object",
              "properties": {
                "location": {
                  "type": "object",
                  "properties": {
                    "lat": {
                      "type": "number"
                    },
                    "lng": {
                      "type": "number"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "radius": {
                  "type": "number",
                  "default": 100
                },
                "formatted": {
                  "type": "string",
                  "maxLength": 10
                }
              },
              "unevaluatedProperties": false
            },
            "placeholder": {
              "type": "string",
              "description": "The value of the placeholder if chosen",
              "maxLength": 1000
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BoltComponentData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "anyOf": [
            {
              "properties": {}
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BreadcrumbsData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "svgId": {
                  "type": "string",
                  "maxLength": 100
                }
              }
            },
            {
              "$ref": "#/CustomMenuDataRef--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Captcha": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "captchaType": {
              "type": "string",
              "enum": [
                "image",
                "audio"
              ],
              "default": "image",
              "description": "When set changes the type of the challenge (image or audio)"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CollapsibleTextData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "default": "",
              "maxLength": 120000
            },
            "readMoreText": {
              "type": "string",
              "default": "Read More",
              "maxLength": 1200
            },
            "readLessText": {
              "type": "string",
              "default": "Read Less",
              "maxLength": 1200
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "linkText": {
              "type": "string",
              "default": "Read More",
              "maxLength": 1200
            },
            "textDescription": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "tag": {
              "type": "string",
              "default": "p",
              "maxLength": 31
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ComboBoxInputData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "dropdownDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/SelectableList--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CustomElement": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tagName": {
              "type": "string",
              "default": "wix-default-custom-element"
            },
            "url": {
              "type": "string",
              "default": "https://static.parastorage.com/services/editor-elements-library/dist/assets/CustomElement/wixDefaultCustomElement.js"
            },
            "hostedInCorvid": {
              "type": "boolean",
              "default": false
            },
            "initialAttributes": {
              "type": "string",
              "default": "{}",
              "maxLength": 4096
            },
            "shouldReload": {
              "type": "boolean",
              "description": "if iframe should be reloaded on initialAttributes change"
            },
            "scriptType": {
              "type": "string",
              "enum": [
                "none",
                "module"
              ],
              "default": "none"
            },
            "appDefinitionId": {
              "type": "string",
              "maxLength": 36
            },
            "widgetId": {
              "type": "string",
              "maxLength": 36
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.FastGallery": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "itemClickAction": {
              "default": "ACTION",
              "enum": [
                "ACTION",
                "LINK",
                "NOTHING"
              ],
              "type": "string"
            },
            "downloadProtection": {
              "default": true,
              "type": "boolean"
            },
            "wixSDKItems": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.HamburgerMenuContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.HamburgerMenuRoot": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ImageX": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "image": {
              "type": "object",
              "properties": {
                "uri": {
                  "type": "string",
                  "default": ""
                },
                "alt": {
                  "type": "string",
                  "default": ""
                },
                "name": {
                  "type": "string",
                  "maxLength": 100
                },
                "height": {
                  "type": "number",
                  "default": 200
                },
                "width": {
                  "type": "number",
                  "default": 200
                },
                "decorative": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "scopedData": {
              "description": "ImageX data per breakpoint",
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "breakpoint": {
                    "type": "string"
                  },
                  "crop": {
                    "$ref": "#/Crop"
                  },
                  "focalPoint": {
                    "$ref": "#/FocalPoint"
                  },
                  "displayMode": {
                    "type": "string",
                    "enum": [
                      "fill",
                      "fit",
                      "fitWidth"
                    ],
                    "default": "fill"
                  },
                  "scrollEffect": {
                    "type": "string",
                    "enum": [
                      "parallax",
                      "fixed",
                      "zoomIn",
                      "fadeIn",
                      "none"
                    ]
                  },
                  "clickAction": {
                    "type": "string",
                    "enum": [
                      "none",
                      "goToLink"
                    ]
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "mask": {
              "type": [
                "object",
                "null"
              ],
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "width": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "height": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "svgId": {
                  "type": "string"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360
                },
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ]
                }
              },
              "unevaluatedProperties": false
            },
            "parallaxSpeed": {
              "type": "number"
            },
            "parallaxDirection": {
              "type": "string",
              "enum": [
                "normal",
                "reverse"
              ]
            },
            "hasAnimation": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Crop": {
      "type": "object",
      "required": [
        "x",
        "y",
        "width",
        "height"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        },
        "width": {
          "type": "number",
          "minimum": 0
        },
        "height": {
          "type": "number",
          "minimum": 0
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "rotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 359,
          "description": "Image rotation degrees"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ],
          "default": "none",
          "description": "Image flip value"
        }
      },
      "unevaluatedProperties": false
    },
    "FocalPoint": {
      "type": "object",
      "required": [
        "x",
        "y"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        }
      },
      "unevaluatedProperties": false
    },
    "LanguageSelector": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.MegaMenuContainerItem": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "type": {
              "default": "wixui.MegaMenuContainerItem",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MenuData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "itemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuItemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuSubItemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "navAriaLabel": {
                  "type": "string",
                  "maxLength": 1000
                }
              }
            },
            {
              "$ref": "#/CustomMenuDataRef--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.MenuList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "menus": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MusicPlayerData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "coverDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "audioRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "audioUrl": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 256
            },
            "playListId": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 255
            },
            "playlist": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "artistName": {
                    "type": "string",
                    "maxLength": 255,
                    "default": "Unknown Artist"
                  },
                  "trackName": {
                    "type": "string",
                    "maxLength": 255,
                    "default": "Unknown Track"
                  },
                  "url": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 2500
                  },
                  "cover": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 2500
                  },
                  "durationFormatted": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 16
                  }
                },
                "unevaluatedProperties": false
              },
              "default": []
            },
            "coverRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "coverUrl": {
              "type": [
                "string",
                "null"
              ]
            },
            "artistName": {
              "type": "string",
              "default": "Unknown Artist",
              "maxLength": 255
            },
            "trackName": {
              "type": "string",
              "default": "Unknown Track",
              "maxLength": 255
            },
            "description": {
              "type": "string",
              "default": "",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WixAudio": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "title": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "duration": {
              "type": "number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Pagination": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "totalPages": {
              "type": "number",
              "description": "The total number of pages displayed by the component"
            },
            "currentPage": {
              "type": "number",
              "default": 1,
              "description": "The the page number marked as current"
            },
            "nextText": {
              "type": "string",
              "default": "Next",
              "maxLength": 400,
              "description": "Text to appear in NEXT button"
            },
            "previousText": {
              "type": "string",
              "default": "Previous",
              "maxLength": 400,
              "description": "Text to appear in PREVIOUS button"
            },
            "firstText": {
              "type": "string",
              "default": "First",
              "maxLength": 400,
              "description": "Text to appear in FIRST button"
            },
            "lastText": {
              "type": "string",
              "default": "Last",
              "maxLength": 400,
              "description": "Text to appear in LAST button"
            },
            "nextAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the NEXT button"
            },
            "previousAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the PREVIOUS button"
            },
            "firstAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the FIRST button"
            },
            "lastAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the LAST button"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PaginationA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ProgressBar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "number",
              "description": "Current progress value"
            },
            "targetValue": {
              "type": "number",
              "default": 100,
              "description": "Progress target value to be defined as complete"
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "barDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RatingsDisplay": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "ratingsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "rating": {
              "type": "number",
              "description": "The rating displayed by the component",
              "minimum": 1,
              "maximum": 5
            },
            "svgId": {
              "type": "string",
              "maxLength": 100
            },
            "numRatings": {
              "type": "number",
              "description": "The amount of ratings the rating is based on",
              "minimum": 0
            },
            "reviewsCountLabel": {
              "type": "string",
              "default": "Reviews",
              "maxLength": 400,
              "description": "Text that describes the numRatings value"
            },
            "noReviewsPlaceholder": {
              "type": "string",
              "default": "Be the first to rate this item",
              "maxLength": 1000,
              "description": "Placeholder text when there aren't any reviews"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RatingsInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": [
                "number",
                "null"
              ],
              "description": "The rating value currently selected",
              "minimum": 0,
              "maximum": 5
            },
            "titleText": {
              "type": "string",
              "description": "the title before a value is selected",
              "maxLength": 300
            },
            "svgId": {
              "type": "string",
              "description": "the id of the svg that illustrates the rating",
              "maxLength": 100
            },
            "labels": {
              "type": "object",
              "description": "contains the labels for the different values. maps 1-5 as keys to strings",
              "default": {
                "1": "Bad",
                "2": "Fine",
                "3": "OK",
                "4": "Good",
                "5": "Great"
              },
              "additionalProperties": {
                "type": [
                  "string",
                  "number"
                ]
              },
              "unevaluatedProperties": false
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.RichContentViewer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "content": {
              "type": "object",
              "unevaluatedProperties": false
            },
            "trimEnabled": {
              "type": "boolean",
              "default": false
            },
            "trimMode": {
              "type": "string",
              "default": "paragraph",
              "maxLength": 100
            },
            "trimLengthParagraph": {
              "type": "number",
              "default": 3
            },
            "trimLengthWord": {
              "type": "number",
              "default": 10
            },
            "trimExclude": {
              "type": "string",
              "default": "plugins",
              "maxLength": 100
            },
            "trimEllipsisEnabled": {
              "type": "boolean",
              "default": true
            },
            "trimEllipsisExpandText": {
              "type": "string",
              "default": "Show More",
              "maxLength": 1200
            },
            "trimEllipsisCollapseText": {
              "type": "string",
              "default": "Show Less",
              "maxLength": 1200
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RichTextBox": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "maxLength": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SearchBox": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "placeholder": {
              "type": "string",
              "default": "Search...",
              "maxLength": 255
            },
            "suggestionsEnabled": {
              "type": "boolean",
              "default": true,
              "description": "Determines whether the suggestions disabled or not"
            },
            "clearButtonText": {
              "type": "string",
              "default": "Clear",
              "maxLength": 255
            },
            "displaySettingsToggles": {
              "type": "boolean",
              "default": true,
              "description": "Determines whether the settings toggles are displayed or not"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Section": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SectionA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "alert",
                "status"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.SelectableContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.SelectableContainerInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SelectionTagsList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "options": {
              "description": "Array of items which behave like checkboxes and look similar to buttons",
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "value": {
              "description": "Array with the values of the selected options",
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SelectionTag": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "maxLength": 400
            },
            "label": {
              "type": "string",
              "maxLength": 400
            },
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "rel": {
              "type": "string",
              "enum": [
                "nofollow"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SignatureInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "titleText": {
              "type": "string",
              "description": "The title of the field",
              "maxLength": 400
            },
            "clearButtonText": {
              "type": "string",
              "description": "The undo signature text",
              "minLength": 1,
              "maxLength": 400
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "radioButtonsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SiteButtonData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/LinkableButton--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Slider": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "trackDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "tooltipDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "min": {
              "type": "number",
              "default": 0,
              "description": "Minimum value"
            },
            "max": {
              "type": "number",
              "default": 100,
              "description": "Maximum value"
            },
            "value": {
              "type": "number",
              "default": 50,
              "description": "Current value"
            },
            "step": {
              "type": "number",
              "default": 0,
              "description": "Step value"
            },
            "stepType": {
              "type": "string",
              "default": "value",
              "enum": [
                "value",
                "count"
              ],
              "description": "When set to 'value', step represents the value of each step. When set to 'count', step represents the total steps count"
            },
            "disabled": {
              "type": "boolean",
              "default": false,
              "description": "Determines whether the slider is disabled or not"
            },
            "readOnly": {
              "type": "boolean",
              "default": false,
              "description": "Determines whether the slider is read-only or not"
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "description": "Label text",
              "maxLength": 1200
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.Slideshow": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "type": {
              "default": "wixui.Slideshow",
              "maxLength": 120,
              "type": "string"
            },
            "direction": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SocialAuth": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StylableButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON",
              "maxLength": 1200
            },
            "svgId": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "isIconAnimated": {
              "type": "boolean"
            },
            "animatedIcon": {
              "type": "object",
              "properties": {
                "svgIdAnimationSelected": {
                  "type": "string",
                  "maxLength": 100
                },
                "customAnimatedIcon": {
                  "type": [
                    "object"
                  ],
                  "properties": {
                    "svgIdAnimationStart": {
                      "type": "string",
                      "maxLength": 100
                    },
                    "svgIdAnimationEnd": {
                      "type": "string",
                      "maxLength": 100
                    },
                    "svgIdAnimationSelected": {
                      "type": "string",
                      "maxLength": 100
                    }
                  },
                  "unevaluatedProperties": false
                },
                "animationDuration": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StylableButtonA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "pressed": {
              "type": "boolean"
            },
            "expanded": {
              "type": "boolean"
            },
            "disabled": {
              "type": "boolean"
            },
            "haspopup": {
              "type": "string",
              "enum": [
                "true",
                "false",
                "dialog",
                "menu"
              ]
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Submenu": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "itemDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "subItemDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SvgImage": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "svgId"
          ],
          "properties": {
            "decorative": {
              "type": "boolean"
            },
            "alt": {
              "type": "string",
              "description": "Alternative text for the vector image (for accessibility purposes).",
              "maxLength": 120
            },
            "displayMode": {
              "type": "string",
              "enum": [
                "fit",
                "stretch"
              ],
              "description": "should the shape maintain it's aspect ratio or stretch",
              "default": "fit"
            },
            "svgId": {
              "type": "string",
              "maxLength": 100,
              "description": "Identifier for the SVG image."
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "wixui.Tabs": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabIds": {
              "type": "array",
              "items": {
                "type": "string",
                "maxLength": 120
              }
            },
            "defaultTabId": {
              "type": "string",
              "default": "",
              "maxLength": 120
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TabsA11y": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextEffectsSharedData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 500
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "default": "div"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction",
              "default": "inherit"
            },
            "patternScope": {
              "type": "string",
              "enum": [
                "none",
                "character",
                "word"
              ],
              "default": "none"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextMarqueeData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "items",
            "speed"
          ],
          "properties": {
            "movementDirection": {
              "type": "string",
              "description": "direction the text is moving to",
              "default": "rtl",
              "enum": [
                "rtl",
                "ltr"
              ]
            },
            "speed": {
              "type": "number",
              "description": "speed of the animation in pixels per second"
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "pause animation on hover"
            },
            "textDirection": {
              "type": "string",
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ]
            },
            "headingLevel": {
              "type": "number",
              "maximum": 6,
              "minimum": 0,
              "description": "Heading level to wrap the component (deprecated)"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "description": "Semantic tag name to wrap the component"
            },
            "svgId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "description": "array of marquee items",
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextMarqueeItem": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "description": "TextMarquee Item",
          "required": [
            "text"
          ],
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "text": {
              "type": "string",
              "maxLength": 500
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextFxData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 450
            },
            "headingLevel": {
              "type": "number",
              "minimum": 0,
              "maximum": 6,
              "description": "Heading level to wrap the component (deprecated)"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "direction": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ],
              "default": "ltr"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "description": "Semantic tag name to wrap the component"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextOnPathData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isDecorative": {
              "type": "boolean"
            },
            "text": {
              "type": "string",
              "description": "text",
              "maxLength": 500
            },
            "path": {
              "type": "string",
              "description": "path"
            },
            "pathLength": {
              "type": "number",
              "description": "Path length"
            },
            "viewBox": {
              "type": "string",
              "description": "View box"
            },
            "speed": {
              "type": "number",
              "description": "Speed",
              "default": 3
            },
            "movementDirection": {
              "type": "string",
              "description": "Direction the text is moving to",
              "default": "forward",
              "enum": [
                "forward",
                "reverse"
              ]
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "Pause animation on hover"
            },
            "direction": {
              "type": "string",
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ]
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div"
              ],
              "description": "Semantic tag name to wrap the component"
            },
            "fillMode": {
              "type": "string",
              "enum": [
                "normal",
                "repeat",
                "justify"
              ],
              "default": "normal",
              "description": "How the text should be rendered on the path"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            },
            "startOffset": {
              "type": "number",
              "description": "Starting point of the text on the path",
              "minimum": 0,
              "maximum": 100
            },
            "fontSize": {
              "type": "number",
              "description": "Font size as a number in percent",
              "minimum": 0,
              "maximum": 100
            },
            "pathStrokeWidth": {
              "type": "number",
              "description": "Width of the path stroke in em units",
              "minimum": 0,
              "maximum": 3
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextParticlesData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "default": "TextParticles",
              "maxLength": 500,
              "type": "string"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction",
              "default": "inherit"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "default": "div"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "pause animation on hover",
              "default": true
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TimePickerData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "placeholder": {
                  "type": "string",
                  "description": "The value of the placeholder if chosen",
                  "maxLength": 1000
                },
                "step": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 60,
                  "default": 1,
                  "description": "Increment step in minutes"
                },
                "label": {
                  "type": "string",
                  "maxLength": 1000
                },
                "margin": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 30,
                  "description": "Time picker layout label margin"
                },
                "disabledTimes": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "required": [
                      "startTime",
                      "endTime"
                    ],
                    "properties": {
                      "startTime": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "endTime": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  },
                  "default": [],
                  "maxItems": 5,
                  "description": "array of disabled times"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ToggleSwitch": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "checked": {
                  "type": "boolean",
                  "description": "The checked status of the input"
                },
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "UnsupportedComponentData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "migratedFrom": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VideoPlayer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "videoType": {
              "type": "string",
              "enum": [
                "dailymotion",
                "facebook",
                "file",
                "twitch",
                "vimeo",
                "youtube"
              ],
              "default": "file"
            },
            "videoRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "videoUrl": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 256
            },
            "posterUrl": {
              "type": [
                "string",
                "null"
              ]
            },
            "videoTitle": {
              "type": "string",
              "default": "",
              "maxLength": 255
            },
            "description": {
              "type": "string",
              "default": "",
              "maxLength": 1000,
              "description": "Video Description"
            },
            "logoRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.ControlTypes": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "shortString": {
              "default": "ShortString",
              "maxLength": 120,
              "type": "string"
            },
            "longString": {
              "default": "LongString",
              "maxLength": 1200,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "dropdown": {
              "default": "Options 1",
              "enum": [
                "Options 1",
                "Options 2",
                "Options 3",
                "Options 4"
              ],
              "type": "string"
            },
            "radioButtons": {
              "default": "Options 1",
              "enum": [
                "Options 1",
                "Options 2",
                "Options 3",
                "Options 4"
              ],
              "type": "string"
            },
            "toggleSwitch": {
              "default": false,
              "type": "boolean"
            },
            "thumbnails": {
              "$ref": "#/SVGReference"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "slider": {
              "default": 1,
              "minimum": 0,
              "maximum": 2,
              "type": "number",
              "multipleOf": 1
            },
            "numericInput": {
              "default": 0,
              "type": "number"
            },
            "colorPickerInput": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "selectedFont": {
              "default": "arial",
              "maxLength": 1200,
              "format": "font-family",
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label"
          ],
          "type": "object",
          "properties": {
            "label": {
              "default": "Save",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Light",
                "Destructive",
                "Premium",
                "Premium light",
                "Dark",
                "Transparent"
              ],
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "priority": {
              "default": "Primary",
              "enum": [
                "Primary",
                "Secondary"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardHeading": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Add Page title H1",
              "maxLength": 1200,
              "type": "string"
            },
            "size": {
              "default": "Page title H1",
              "enum": [
                "Page title H1",
                "Modal title H2",
                "Card title H3",
                "Section title H4",
                "Card section title H5",
                "Caption H6"
              ],
              "type": "string"
            },
            "invertColor": {
              "default": false,
              "type": "boolean"
            },
            "textAlignment": {
              "default": "Left",
              "enum": [
                "Left",
                "Center",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardIconButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "icon": {
              "$ref": "#/SVGReference"
            },
            "tooltip": {
              "default": "More Actions",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Premium",
                "Light",
                "Transparent"
              ],
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "priority": {
              "default": "Secondary",
              "enum": [
                "Primary",
                "Secondary"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardInfoIcon": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "tooltip": {
              "default": "This message explains the purpose of a feature.",
              "maxLength": 1200,
              "type": "string"
            },
            "addLink": {
              "default": false,
              "type": "boolean"
            },
            "tooltipLinkText": {
              "default": "Learn more",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipLink": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Event name",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Enter your event name...",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "prefixValue": {
              "default": "Units",
              "maxLength": 120,
              "type": "string"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixValue": {
              "default": ".com",
              "maxLength": 120,
              "type": "string"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "setMaxLength": {
              "default": false,
              "type": "boolean"
            },
            "maxLength": {
              "default": 20,
              "type": "number",
              "multipleOf": 1
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "border": {
              "default": "Default",
              "enum": [
                "Default",
                "Round",
                "Line",
                "None"
              ],
              "type": "string"
            },
            "labelPosition": {
              "default": "Top",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardNumberInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Number of tickets",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Enter a number...",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": 25,
              "type": "number",
              "multipleOf": 1
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "prefixValue": {
              "default": "Units",
              "maxLength": 120,
              "type": "string"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixValue": {
              "default": "%",
              "maxLength": 120,
              "type": "string"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "minAndMaxValues": {
              "default": false,
              "type": "boolean"
            },
            "min": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "max": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepSize": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "border": {
              "default": "Default",
              "enum": [
                "Default",
                "Round",
                "Line",
                "None"
              ],
              "type": "string"
            },
            "labelPlacement": {
              "default": "Top",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "I’m a paragraph. Add your own text and edit me in settings. It’s easy.",
              "maxLength": 1200,
              "type": "string"
            },
            "preset": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Standard secondary",
                "Light",
                "Light secondary",
                "Success",
                "Destructive",
                "Primary",
                "Premium",
                "Disabled"
              ],
              "type": "string"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "Thin",
              "enum": [
                "Bold",
                "Normal",
                "Thin"
              ],
              "type": "string"
            },
            "textAlignment": {
              "default": "Left",
              "enum": [
                "Left",
                "Center",
                "Right"
              ],
              "type": "string"
            },
            "overflow": {
              "default": "Wrap",
              "enum": [
                "Wrap",
                "Ellipsis"
              ],
              "type": "string"
            },
            "maxLines": {
              "default": 1,
              "minimum": 1,
              "type": "number",
              "multipleOf": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardTextButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "View All",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Premium",
                "Light",
                "Dark",
                "Destructive"
              ],
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "underline": {
              "default": "Never",
              "enum": [
                "Never",
                "On hover",
                "Always"
              ],
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "Regular",
              "enum": [
                "Regular",
                "Medium"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.DashboardToggleSwitch": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Set a reminder",
              "maxLength": 120,
              "type": "string"
            },
            "checked": {
              "default": true,
              "type": "boolean"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Success",
                "Destructive"
              ],
              "type": "string"
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Large",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "labelPosition": {
              "default": "Right",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.SettingsPanelContainer": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "theme": {
              "default": "classic",
              "enum": [
                "classic",
                "responsive"
              ],
              "type": "string"
            },
            "debug": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuAccordion": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Label Example",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "openByDefault": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuBackButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Back",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "label": {
              "default": "Button",
              "maxLength": 120,
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "standard secondary",
                "premium",
                "premium secondary",
                "alert",
                "alert secondary",
                "inverted"
              ],
              "type": "string"
            },
            "size": {
              "default": "medium",
              "enum": [
                "small",
                "medium",
                "large"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "fullWidth": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuCheckboxGroup": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Multiple Choices",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuColorPicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Opacity & Color",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "opacity": {
              "default": 100,
              "minimum": 0,
              "maximum": 100,
              "type": "number",
              "multipleOf": 1
            },
            "showPercentage": {
              "default": true,
              "type": "boolean"
            },
            "opacitySliderEnabled": {
              "default": true,
              "type": "boolean"
            },
            "color": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuColorSelector": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Color Selector",
              "maxLength": 120,
              "type": "string"
            },
            "color": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuColumnControllerControl": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Column controller",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "enableReorder": {
              "default": true,
              "type": "boolean"
            },
            "minimumValue": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "dividerType": {
              "default": "none",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            },
            "columns": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuDatePicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Choose a Date",
              "maxLength": 120,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuDrillDown": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Label Title",
              "maxLength": 120,
              "type": "string"
            },
            "description": {
              "default": "This is a description text",
              "maxLength": 1200,
              "type": "string"
            },
            "iconType": {
              "default": "None",
              "enum": [
                "None",
                "Info",
                "Alert"
              ],
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuDropdown": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Dropdown",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Choose an option",
              "maxLength": 120,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuEmptyState": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Link to Lightbox",
              "maxLength": 120,
              "type": "string"
            },
            "description": {
              "default": "Create your own lightboxes and link to them for any place in your site.",
              "maxLength": 1200,
              "type": "string"
            },
            "textButtonLabel": {
              "default": "Start Creating",
              "maxLength": 120,
              "type": "string"
            },
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuFontAndColorPicker": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Pick Font and Color",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "font": {
              "default": "arial",
              "maxLength": 1200,
              "format": "font-family",
              "type": "string"
            },
            "color": {
              "default": "#FFC233",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuHorizontalTabs": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "tabsStyle": {
              "default": "Folder",
              "enum": [
                "Folder",
                "Arrowed",
                "Arrowed Without a Line"
              ],
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "maxVisibleTabs": {
              "default": 3,
              "minimum": 1,
              "maximum": 10,
              "type": "number",
              "multipleOf": 1
            },
            "tabsToScroll": {
              "default": 3,
              "minimum": 1,
              "maximum": 10,
              "type": "number",
              "multipleOf": 1
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuLeftTextButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Text Button",
              "maxLength": 120,
              "type": "string"
            },
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "size": {
              "default": "medium",
              "enum": [
                "tiny",
                "small",
                "medium"
              ],
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "premium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "normal",
              "enum": [
                "thin",
                "normal"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuMultilineTextInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 120000,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Write text here...",
              "maxLength": 1200,
              "type": "string"
            },
            "maxLength": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "closeOnEnterKeyPress": {
              "default": false,
              "type": "boolean"
            },
            "autoFocus": {
              "default": false,
              "type": "boolean"
            },
            "selectTextOnFocus": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "usePatternValidation": {
              "default": false,
              "type": "boolean"
            },
            "regexPattern": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "validationMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuNotificationBanner": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "premium",
                "alert",
                "success"
              ],
              "type": "string"
            },
            "linkText": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "linkUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "iconTooltipText": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "multiline": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuNumericInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "title": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": 0,
              "type": "number"
            },
            "unitSuffix": {
              "default": "None",
              "enum": [
                "None",
                "Pixels",
                "Percentage",
                "Degrees"
              ],
              "type": "string"
            },
            "numberOfFractions": {
              "default": 2,
              "minimum": 0,
              "maximum": 2,
              "type": "number",
              "multipleOf": 1
            },
            "steps": {
              "default": 1,
              "minimum": 1,
              "maximum": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepControls": {
              "default": false,
              "type": "boolean"
            },
            "minValue": {
              "default": 0,
              "type": "number"
            },
            "maxValue": {
              "default": 100,
              "type": "number"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuRadioButtonGroup": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Radio Buttons",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuRichText": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "richTextContent": {
              "default": "Your placeholder text goes here. Write, style and link it.",
              "maxLength": 120000,
              "type": "string"
            },
            "richTextLabel": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "richTextLink": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "alignTextToCenter": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuSectionDivider": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "sectionTitle": {
              "default": "Section Divider",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuSlider": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Slider",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "unitOfMeasurement": {
              "default": "number",
              "enum": [
                "number",
                "percentage",
                "pixels",
                "angle"
              ],
              "type": "string"
            },
            "defaultSelectedValue": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "minimumValue": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "maximumValue": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepValue": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "showNumericInput": {
              "default": true,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuTextInput": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Text Input",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "defaultText": {
              "default": "Write it here...",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Placeholder text",
              "maxLength": 120,
              "type": "string"
            },
            "prefix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "autofocus": {
              "default": false,
              "type": "boolean"
            },
            "selectedOnFocus": {
              "default": true,
              "type": "boolean"
            },
            "charactersLimit": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "usePatternValidation": {
              "default": false,
              "type": "boolean"
            },
            "regexPattern": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "errorMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuThumbnails": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "options"
          ],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "setNumberOfColumns": {
              "default": 3,
              "minimum": 1,
              "maximum": 5,
              "type": "number",
              "multipleOf": 1
            },
            "showEmptyThumbnail": {
              "default": false,
              "type": "boolean"
            },
            "thumbnailHeight": {
              "default": "Fixed ratio (1:1)",
              "enum": [
                "Fixed ratio (1:1)",
                "Fluid"
              ],
              "type": "string"
            },
            "displayLabels": {
              "default": true,
              "type": "boolean"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ThumbnailItemData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WbuToggleSwitch": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Toggle Switch",
              "maxLength": 120,
              "type": "string"
            },
            "toggleSwitch": {
              "default": true,
              "type": "boolean"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WutAvatar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "firstName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "lastName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "src": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WutAvatarGroup": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "maxAvatars": {
              "default": 5,
              "minimum": 1,
              "type": "number",
              "multipleOf": 1
            },
            "showHiddenAvatarCount": {
              "default": true,
              "type": "boolean"
            },
            "avatars": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WutBadge": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "My Badge",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "composition": {
              "default": "TextAndIcon",
              "enum": [
                "TextAndIcon",
                "Text",
                "Icon",
                "None"
              ],
              "type": "string"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "dsgnsys.WutRadioButton": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "value"
          ],
          "type": "object",
          "properties": {
            "radioGroupName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "checked": {
              "default": false,
              "type": "boolean"
            },
            "required": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Direction--unrestricted-root": {
      "type": "string",
      "enum": [
        "ltr",
        "rtl",
        "inherit"
      ]
    },
    "AppVars--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "vars": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "value": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "AppPartParam"
                    ]
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "appDefId": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "SVGItem--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/Common_SVGItem"
    },
    "SVGReference--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "BackgroundImage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string"
            },
            "positionx": {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "default": "center"
            },
            "imagesizew": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "imagesizeh": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "positiony": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "center"
              ],
              "default": "center"
            },
            "width": {
              "type": "string"
            },
            "repeatx": {
              "type": "string",
              "enum": [
                "no_repeat",
                "repeat"
              ],
              "default": "repeat"
            },
            "repeaty": {
              "type": "string",
              "enum": [
                "no_repeat",
                "repeat"
              ],
              "default": "repeat"
            },
            "attachment": {
              "type": "string",
              "enum": [
                "scroll",
                "fixed",
                "inherit",
                "local"
              ],
              "default": "inherit"
            },
            "color": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "BackgroundMedia--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "mediaRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mediaTransforms": {
              "$ref": "urn:dm:schemas:design_data.json#/BackgroundTransforms"
            },
            "overlayTransforms": {
              "$ref": "urn:dm:schemas:design_data.json#/BackgroundTransforms"
            },
            "color": {
              "oneOf": [
                {
                  "enum": [
                    "transparent",
                    "noColor"
                  ]
                },
                {
                  "$ref": "urn:dm:schemas:common.json#/color--unrestricted-root"
                }
              ]
            },
            "colorOpacity": {
              "type": "number"
            },
            "alignType": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "left",
                "right",
                "center",
                "top_left",
                "top_right",
                "bottom_left",
                "bottom_right"
              ]
            },
            "fittingType": {
              "type": "string",
              "enum": [
                "fill",
                "fit",
                "stretch",
                "actual_size",
                "original_size",
                "tile",
                "tile_horizontal",
                "tile_vertical",
                "fit_and_tile",
                "legacy_tile",
                "legacy_tile_horizontal",
                "legacy_tile_vertical",
                "legacy_normal"
              ]
            },
            "scrollType": {
              "type": "string",
              "enum": [
                "none",
                "fixed",
                "scroll",
                "local",
                "parallax"
              ]
            },
            "showOverlayForMediaType": {
              "type": "string",
              "enum": [
                "all",
                "WixVideo",
                "Image"
              ],
              "default": "WixVideo"
            },
            "imageOverlay": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "colorOverlay": {
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "colorOverlayOpacity": {
              "type": "number"
            },
            "overlayBlending": {
              "$ref": "urn:dm:schemas:design_data.json#/overlayBlending"
            },
            "filterEffect": {
              "$ref": "urn:dm:schemas:design_data.json#/filterEffect"
            },
            "colorLayers": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/ColorLayers"
            }
          }
        }
      ],
      "type": "object"
    },
    "WixVideo--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/WixVideoData--unrestricted-root"
            },
            {
              "properties": {
                "loop": {
                  "type": "boolean"
                },
                "autoplay": {
                  "type": "boolean"
                },
                "playbackSpeed": {
                  "type": "number"
                },
                "preload": {
                  "type": "string",
                  "enum": [
                    "auto",
                    "metadata",
                    "none"
                  ]
                },
                "controls": {
                  "type": "string",
                  "enum": [
                    "none",
                    "full"
                  ]
                },
                "mute": {
                  "type": "boolean",
                  "description": "deprecated, moved to properties"
                },
                "opacity": {
                  "type": "number"
                },
                "mediaFeatures": {
                  "type": "array",
                  "items": {
                    "type": "string",
                    "enum": [
                      "alpha"
                    ]
                  }
                },
                "mask": {
                  "anyOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "urn:dm:schemas:design_data.json#/ImageMask--unrestricted-root"
                    }
                  ]
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "WixVideoData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string",
              "maxLength": 100
            },
            "alt": {
              "type": "string",
              "maxLength": 1000
            },
            "videoId": {
              "type": "string"
            },
            "generatedPosters": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "qualities": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "quality": {
                    "type": "string"
                  },
                  "width": {
                    "type": "number"
                  },
                  "height": {
                    "type": "number"
                  },
                  "formats": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    },
                    "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
                  },
                  "format": {
                    "type": "string",
                    "enum": [
                      "mp4",
                      "webm"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "adaptiveVideo": {
              "type": [
                "array",
                "null"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "format": {
                    "type": "string",
                    "enum": [
                      "hls",
                      "dash"
                    ]
                  },
                  "url": {
                    "type": "string"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "posterImageRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "duration": {
              "type": "number"
            },
            "fps": {
              "type": "string",
              "maxLength": 50
            },
            "hasAudio": {
              "type": "boolean",
              "description": "video has no audio"
            },
            "artist": {
              "type": "object",
              "properties": {
                "name": {
                  "type": "string"
                },
                "id": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "Document--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "siteName": {
              "type": "string",
              "maxLength": 1000
            },
            "usedFonts": {
              "type": "array",
              "items": {
                "type": "string",
                "maxLength": 1000
              }
            },
            "characterSets": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "renderModifiers": {
              "type": "object",
              "properties": {
                "siteWidth": {
                  "type": "number",
                  "minimum": 0
                },
                "pageAutoShrink": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "name": {
              "type": "string"
            },
            "mainPage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mainPageId": {
              "type": "string"
            },
            "smSettings": {
              "type": "object",
              "allOf": [
                {
                  "$ref": "#/SiteMembersData--unrestricted-root"
                }
              ],
              "unevaluatedProperties": false
            },
            "styleSettings": {
              "$ref": "#/StyleSettings"
            },
            "accessibilitySettings": {
              "$ref": "#/AccessibilitySettings"
            },
            "mobileSettings": {
              "$ref": "#/MobileSettings"
            },
            "layoutSettings": {
              "$ref": "#/LayoutSettings"
            },
            "appStudioData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "ignoreBottomBottomAnchors": {
              "type": [
                "boolean"
              ]
            },
            "anchorLockThreshold": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "supportMobile": {
              "type": "boolean"
            },
            "autoDomReorder": {
              "type": "boolean"
            },
            "appsInstallState": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "usesNewAnimations": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "AccessibilitySettings--unrestricted-root": {
      "type": "object",
      "properties": {
        "visualFocusDisabled": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "skipToContent": {
          "default": true,
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "isRtlSupportEnabled": {
          "default": false,
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "currentSiteDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        }
      }
    },
    "MobileSettings--unrestricted-root": {
      "type": "object",
      "properties": {
        "animationsEnabled": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      }
    },
    "LayoutSettings--unrestricted-root": {
      "type": "object",
      "properties": {
        "useDesktopSectionsLayout": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "isFluid": {
          "type": [
            "boolean"
          ]
        },
        "headerToPagesGap": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "pagesToFooterGap": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "mechanism": {
          "type": [
            "string"
          ],
          "enum": [
            "mesh",
            "anchors"
          ]
        },
        "soapCompsAroundPagesContainer": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      }
    },
    "StyleSettings--unrestricted-root": {
      "type": "object",
      "properties": {
        "stylesPerPage": {
          "type": "string",
          "maxLength": 20
        }
      }
    },
    "SiteMembersData--unrestricted-root": {
      "type": "object",
      "properties": {
        "socialLoginGoogleEnabled": {
          "type": "boolean"
        },
        "socialLoginFacebookEnabled": {
          "type": "boolean"
        },
        "privacyNoteType": {
          "type": "string",
          "enum": [
            "CHECKBOX",
            "NOTE"
          ]
        },
        "joinCommunityCheckedByDefault": {
          "type": "boolean"
        },
        "customSignUpPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customSignInPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customNoPermissionsPageId": {
          "type": [
            "string"
          ]
        },
        "termsOfUse": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "privacyPolicy": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "codeOfConduct": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          },
          "unevaluatedProperties": false
        },
        "smFirstDialogLogin": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      }
    },
    "AppStudioData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "widgets": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "codePackages": {
              "maxItems": 1,
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "panels": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "dependencies": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "additionalProperties": false,
                "required": [
                  "appDefId"
                ],
                "properties": {
                  "appDefId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "dependencyData": {
                    "type": "array",
                    "items": {
                      "type": "string",
                      "enum": [
                        "PROVISION_ONLY_INSTALLATION",
                        "NOTIFY_USER_ON_DEPENDENCY",
                        "IS_BUNDLE"
                      ]
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "dashboards": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "customDefinitions": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "ssrCache": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "CodePackagesDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "displayName": {
              "type": "string",
              "maxLength": 30,
              "minLength": 1
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "minLength": 3
            },
            "description": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "WidgetPropertyDefinition--unrestricted-root": {
      "type": "object"
    },
    "CustomDefinitionDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "structure": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "additionalProperties": false,
                "required": [
                  "$id",
                  "title",
                  "description",
                  "default",
                  "propertiesOrder"
                ],
                "properties": {
                  "$id": {
                    "type": "string"
                  },
                  "type": {
                    "type": "string",
                    "default": "object"
                  },
                  "title": {
                    "type": "string"
                  },
                  "description": {
                    "type": "string"
                  },
                  "properties": {
                    "type": "object",
                    "additionalProperties": {
                      "$ref": "#/WidgetPropertyDefinition"
                    }
                  },
                  "default": {
                    "type": "object",
                    "default": {}
                  },
                  "propertiesOrder": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    },
                    "default": []
                  }
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "WidgetDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "devCenterWidgetId": {
              "type": [
                "string",
                "null"
              ]
            },
            "devCenterEditorReactComponentId": {
              "type": [
                "string",
                "null"
              ]
            },
            "kind": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "container",
                "section"
              ]
            },
            "panels": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "defaultSize": {
              "type": [
                "object",
                "null"
              ],
              "minProperties": 1,
              "properties": {
                "width": {
                  "type": "number"
                },
                "height": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "variations": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "presets": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "plugin": {
              "type": "object",
              "properties": {
                "placements": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "appDefinitionId": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "widgetId": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "slotId": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "containedWidgets": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            },
            "widgetApi": {
              "type": "object",
              "default": {},
              "properties": {
                "functions": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "required": [
                      "name"
                    ],
                    "properties": {
                      "name": {
                        "type": "string"
                      },
                      "description": {
                        "type": [
                          "string",
                          "null"
                        ]
                      },
                      "params": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "name": {
                              "type": "string"
                            },
                            "description": {
                              "type": [
                                "string",
                                "null"
                              ]
                            }
                          },
                          "unevaluatedProperties": false
                        }
                      },
                      "returnsDescription": {
                        "type": [
                          "string",
                          "null"
                        ]
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "propertiesSchemas": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "properties": {
                      "structure": {
                        "type": "object",
                        "additionalProperties": {
                          "$ref": "#/WidgetPropertyDefinition"
                        },
                        "default": {},
                        "unevaluatedProperties": false
                      }
                    },
                    "unevaluatedProperties": false
                  }
                },
                "events": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "object",
                    "required": [
                      "name"
                    ],
                    "properties": {
                      "name": {
                        "type": "string"
                      },
                      "description": {
                        "type": "string"
                      },
                      "args": {
                        "type": "array",
                        "items": {
                          "properties": {
                            "name": {
                              "type": "string"
                            }
                          },
                          "unevaluatedProperties": false,
                          "type": "object"
                        }
                      }
                    },
                    "unevaluatedProperties": false
                  }
                }
              },
              "unevaluatedProperties": false
            },
            "structureRef": {
              "type": "object",
              "properties": {
                "pageId": {
                  "type": "string"
                },
                "rootCompId": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            },
            "compType": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "DashboardDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "routePath": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "hideInSidebar": {
              "type": "boolean"
            },
            "activeSidebarPageId": {
              "type": [
                "string",
                "null"
              ]
            },
            "isRoutePathConnectedToTitle": {
              "type": "boolean",
              "default": true
            }
          }
        }
      ],
      "type": "object"
    },
    "PanelDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "devCenterPanelId": {
              "type": [
                "string",
                "null"
              ]
            },
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "kind": {
              "type": "string",
              "enum": [
                "settings"
              ]
            },
            "helpId": {
              "type": "string",
              "maxLength": 100
            },
            "pageUrl": {
              "type": "string",
              "minLength": 1,
              "maxLength": 2048
            },
            "height": {
              "type": "number",
              "minimum": 0,
              "default": 0
            },
            "defaultSize": {
              "type": "object",
              "minProperties": 1,
              "properties": {
                "width": {
                  "type": "number"
                },
                "height": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "VariationDescriptor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "PresetDescriptor--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "presetId": {
              "type": "string",
              "maxLength": 100
            },
            "name": {
              "type": "string",
              "maxLength": 100
            },
            "defaultSize": {
              "type": "object",
              "minProperties": 1,
              "properties": {
                "width": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                },
                "height": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "FlatTheme--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "BG_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "CONTACT_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "NETWORKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "EXTERNAL_LINKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "PAGES_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "WEB_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "BASE_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "font": {
              "type": "string",
              "format": "font-family",
              "default": "Arial,sans-serif"
            },
            "bgId": {
              "type": "string",
              "default": "BG_USES_THEME_IMAGE"
            },
            "bgSize": {
              "type": "string",
              "default": ","
            },
            "bgType": {
              "type": "string",
              "default": "BG_USES_THEME_IMAGE"
            },
            "siteBg": {
              "type": "string",
              "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
            },
            "mobileBg": {
              "type": "string",
              "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
            },
            "siteBgColor": {
              "default": "0,0,0,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "headerTextColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "headerBgColor": {
              "default": "0,0,0,0",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "textColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "areaBgColor": {
              "default": "130,81,13,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "iconBgColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "borderColor": {
              "default": "255,255,255,1",
              "$ref": "urn:dm:schemas:common.json#/color"
            },
            "fontHeader": {
              "default": "normal normal bold 2.4em/1.0em [font] {headerTextColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontTitle": {
              "default": "italic normal bold 2.0em/2.0em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontSubTitle": {
              "default": "normal normal bold 1.2em/1.4em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontButton": {
              "default": "normal normal bold 1.4em/2.2em [font] {areaBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontText": {
              "default": "normal normal normal 1.1em/1.1em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "fontSmallText": {
              "default": "normal normal normal 0.5em/0.7em [font] {siteBgColor}",
              "$ref": "urn:dm:schemas:common.json#/font"
            },
            "borderContainer": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderThumb": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderButton": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "borderIcon": {
              "default": "0.15em solid [borderColor]",
              "$ref": "urn:dm:schemas:common.json#/border"
            },
            "radiusContainer": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusThumb": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusButton": {
              "default": "0.6em 0.6em 0.6em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "radiusIcon": {
              "default": "0.6em 0.0em 0.0em 0.6em",
              "$ref": "urn:dm:schemas:common.json#/radius"
            },
            "padding1": {
              "default": "1em 1em 1em 1em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding2": {
              "default": "0.0em 0.5em 0.0em 0.5em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding3": {
              "default": "1.0em 0.0em 1.0em 0.0em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "iconSize": {
              "default": "3.2",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "bulletSize": {
              "default": "1.5",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "headerSpacing": {
              "default": "0em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "componentSpacing": {
              "default": "0.45em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "itemSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "thumbSpacing": {
              "default": "0.23em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "iconSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            }
          }
        }
      ],
      "type": "object"
    },
    "Image--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "allOf": [
            {
              "$ref": "urn:dm:schemas:commonSchemas.json#/Common_Image--unrestricted-root"
            },
            {
              "type": "object",
              "properties": {
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "ImageA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "ImageReference--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "GlobalImageQuality--unrestricted-root": {
      "$ref": "#/ImageQuality"
    },
    "ImageQuality--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "quality": {
              "$ref": "urn:dm:schemas:common.json#/Int",
              "minimum": 0,
              "maximum": 100
            },
            "unsharpMask": {
              "type": "object",
              "minProperties": 3,
              "additionalProperties": false,
              "properties": {
                "radius": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 500
                },
                "amount": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 10
                },
                "threshold": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 255
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "ClassicSectionA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            },
            "level": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "StripColumnsContainerA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            },
            "level": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            }
          }
        }
      ],
      "type": "object"
    },
    "StripColumnsContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "itemsDirection": {
              "type": "string",
              "enum": [
                "rtl",
                "ltr"
              ],
              "default": "ltr"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "ClassicSection--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "StripContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "ImageList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "type": "object"
    },
    "Link--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "AnchorLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "anchorName": {
              "type": "string"
            },
            "anchorDataId": {
              "anyOf": [
                {
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference--unrestricted-root"
                },
                {
                  "enum": [
                    "SCROLL_TO_TOP"
                  ]
                }
              ]
            },
            "pageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "type": "object"
    },
    "DocumentLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "docId": {
              "type": "string"
            },
            "name": {
              "type": "string"
            },
            "indexable": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "PhoneLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "phoneNumber": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "WhatsAppLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "phoneNumber": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "AddressLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "address": {
              "type": "string",
              "maxLength": 200
            }
          }
        }
      ],
      "type": "object"
    },
    "EmailLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "recipient": {
              "type": "string",
              "description": "Email address of the recipient."
            },
            "subject": {
              "type": "string",
              "description": "Subject of the email."
            },
            "body": {
              "type": "string",
              "description": "Body or content of the email."
            }
          }
        }
      ],
      "type": "object"
    },
    "FormSubmitButtonLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "ExternalLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "allOf": [
                {
                  "type": "string"
                },
                {
                  "not": {
                    "type": "string",
                    "pattern": ".*script://.*"
                  }
                }
              ],
              "description": "URL of the external link."
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_blank",
              "description": "Specifies where to open the linked document."
            },
            "rel": {
              "$ref": "#/LinkRelAttribute",
              "default": [
                "noreferrer",
                "noopener"
              ],
              "description": "Specifies the relationship between the current document and the linked document."
            }
          }
        }
      ],
      "type": "object"
    },
    "LinkRelAttribute--unrestricted-root": {
      "type": "array",
      "items": {
        "type": "string",
        "enum": [
          "nofollow",
          "noopener",
          "noreferrer",
          "sponsored"
        ]
      },
      "default": []
    },
    "DynamicPageLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "routerId": {
              "type": "string"
            },
            "innerRoute": {
              "type": "string"
            },
            "anchorDataId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "isTpaRoute": {
              "type": "boolean"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "type": "object"
    },
    "TpaPageLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "itemTypeIdentifier",
            "itemId",
            "pageId",
            "appDefinitionId",
            "path"
          ],
          "properties": {
            "itemTypeIdentifier": {
              "type": "string"
            },
            "itemId": {
              "type": "string"
            },
            "pageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "path": {
              "type": "string"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self"
            },
            "rel": {
              "$ref": "#/LinkRelAttribute"
            }
          }
        }
      ],
      "type": "object"
    },
    "LoginToWixLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "postLoginUrl": {
              "type": "string"
            },
            "postSignupUrl": {
              "type": "string"
            },
            "dialog": {
              "type": "string",
              "enum": [
                "createUser",
                "login",
                "showLogin"
              ],
              "default": "login"
            },
            "sendMail": {
              "type": "boolean",
              "default": true
            },
            "mailTemplate": {
              "type": "string"
            },
            "userColor": {
              "type": "string"
            },
            "loginCompName": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "PageLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pageId": {
              "description": "Page ID of the page to link to.",
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_self",
              "description": "Specifies where to open the linked document."
            },
            "rel": {
              "$ref": "#/LinkRelAttribute",
              "description": "Specifies the relationship between the current document and the linked document."
            }
          }
        }
      ],
      "type": "object"
    },
    "MediaItem--unrestricted-root": {
      "type": "object",
      "properties": {
        "componentType": {
          "type": "string"
        },
        "dateCreated": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "fileName": {
          "type": "string"
        },
        "fileSize": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "width": {
          "type": "number"
        },
        "iconURL": {
          "type": "string"
        },
        "mediaType": {
          "type": "string"
        },
        "mimeType": {
          "type": "string"
        },
        "originalFileName": {
          "type": "string"
        },
        "sourceURL": {
          "type": [
            "null",
            "string"
          ]
        },
        "tags": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "version": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "MediaRichText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000
            },
            "stylesMapId": {
              "type": "string"
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "componentDataList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "Page--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "dataClassRef": "core.datatypes.PageDataClass",
          "properties": {
            "title": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            },
            "hideTitle": {
              "type": "boolean"
            },
            "icon": {
              "type": "string"
            },
            "windowTitle": {
              "type": "string",
              "minLength": 1,
              "maxLength": 512
            },
            "descriptionSEO": {
              "type": "string",
              "maxLength": 1024
            },
            "advancedSeoData": {
              "type": "string",
              "maxLength": 10000
            },
            "metaKeywordsSEO": {
              "type": "string",
              "maxLength": 512
            },
            "pageTitleSEO": {
              "type": "string"
            },
            "pageUriSEO": {
              "type": "string"
            },
            "hidePage": {
              "type": "boolean"
            },
            "underConstruction": {
              "type": "boolean"
            },
            "tpaApplicationId": {
              "type": "number"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "managingAppDefId": {
              "type": [
                "string",
                "null"
              ]
            },
            "tpaPageId": {
              "type": "string"
            },
            "parentPageId": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "pageSecurity": {
              "type": [
                "object",
                "null"
              ],
              "default": {
                "requireLogin": false,
                "passwordDigest": "",
                "dialogLanguage": ""
              },
              "properties": {
                "requireLogin": {
                  "type": "boolean"
                },
                "passwordDigest": {
                  "type": "string"
                },
                "dialogLanguage": {
                  "type": "string"
                }
              },
              "unevaluatedProperties": false
            },
            "indexable": {
              "type": "boolean",
              "default": true
            },
            "mobileHidePage": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageBackgrounds": {
              "type": "object",
              "properties": {
                "desktop": {
                  "type": "object",
                  "properties": {
                    "custom": {
                      "type": "boolean"
                    },
                    "mediaSizing": {
                      "type": "string",
                      "enum": [
                        "document",
                        "viewport"
                      ]
                    },
                    "ref": {
                      "$ref": "urn:dm:schemas:common.json#/nullableReference"
                    },
                    "isPreset": {
                      "type": "boolean"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "mobile": {
                  "type": "object",
                  "properties": {
                    "custom": {
                      "type": "boolean"
                    },
                    "mediaSizing": {
                      "type": "string",
                      "enum": [
                        "document",
                        "viewport"
                      ],
                      "default": "viewport"
                    },
                    "ref": {
                      "$ref": "urn:dm:schemas:common.json#/nullableReference"
                    },
                    "isPreset": {
                      "type": "boolean"
                    }
                  },
                  "unevaluatedProperties": false
                }
              },
              "unevaluatedProperties": false
            },
            "isLandingPage": {
              "type": "boolean",
              "default": false
            },
            "isMobileLandingPage": {
              "type": "boolean",
              "default": false
            },
            "isPopup": {
              "type": "boolean",
              "default": false
            },
            "translationData": {
              "type": "object",
              "properties": {
                "uriSEOTranslated": {
                  "type": "boolean",
                  "default": false
                }
              },
              "unevaluatedProperties": false
            },
            "ogImage": {
              "type": [
                "string",
                "null"
              ]
            },
            "ogImageRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "ignoreBottomBottomAnchors": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "cacheMode": {
              "enum": [
                "auto",
                "manual",
                "disabled"
              ]
            },
            "cacheMaxAgeHours": {
              "type": [
                "number",
                "null"
              ],
              "multipleOf": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "Text--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 4000
            }
          }
        }
      ],
      "type": "object"
    },
    "RichText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000,
              "default": ""
            },
            "defaultStyle": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "RichTextImage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "image": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BaseInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 400
            },
            "formGroup": {
              "type": "string",
              "description": "form group that this component belongs to",
              "maxLength": 4000
            }
          }
        }
      ],
      "type": "object"
    },
    "BaseTextInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "value": {
                  "type": "string",
                  "default": "",
                  "maxLength": 4000
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "TextInputA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "invalid": {
              "type": "boolean"
            },
            "multiline": {
              "type": "boolean"
            },
            "autocomplete": {
              "type": "boolean"
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "atomic": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "textType": {
                  "type": "string",
                  "default": "text",
                  "enum": [
                    "text",
                    "email",
                    "url",
                    "number",
                    "tel",
                    "password"
                  ],
                  "description": "input data type"
                },
                "maxLength": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "min": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "minimum": -2147483648,
                  "maximum": 2147483647,
                  "description": "minimum allowed value for a numeric type field"
                },
                "max": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "minimum": -2147483648,
                  "maximum": 2147483647,
                  "description": "maximum allowed value for a numeric type field"
                },
                "pattern": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "specifies a regular expression against which the control's value will be validate",
                  "maxLength": 500
                },
                "phoneFormat": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "description": "specifies a phone number format against which the control's value will be validated",
                  "pattern": "^#*(((#+-)*)#+$)",
                  "maxLength": 100
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected"
                },
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                },
                "prefix": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "maxLength": 10
                },
                "step": {
                  "type": "number"
                },
                "autoComplete": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "maxLength": 400
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ],
          "not": {
            "required": [
              "pattern",
              "phoneFormat"
            ]
          }
        }
      ],
      "type": "object"
    },
    "TextAreaInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "maxLength": {
                  "type": [
                    "number"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "label": {
                  "type": [
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string"
                  ],
                  "maxLength": 4000,
                  "description": "the placeholder option in case nothing is selected"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "CheckboxInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "checked": {
                  "$ref": "urn:dm:schemas:common.json#/JavaBool",
                  "description": "The checked status of the input"
                },
                "linkLabel": {
                  "type": "string",
                  "default": "",
                  "maxLength": 1000
                },
                "link": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
                },
                "label": {
                  "type": "string",
                  "default": "",
                  "maxLength": 4000
                },
                "indeterminate": {
                  "$ref": "urn:dm:schemas:common.json#/JavaBool",
                  "description": "Used for three state check box"
                },
                "direction": {
                  "$ref": "#/Direction",
                  "description": "direction of the component"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "DateItem--unrestricted-root": {
      "type": "string",
      "format": "date-time"
    },
    "DateString--unrestricted-root": {
      "type": "string",
      "format": "date"
    },
    "DateRange--unrestricted-root": {
      "type": "object",
      "required": [
        "startDate",
        "endDate"
      ],
      "properties": {
        "startDate": {
          "$ref": "#/DateString"
        },
        "endDate": {
          "$ref": "#/DateString"
        }
      }
    },
    "DateRanges--unrestricted-root": {
      "type": "array",
      "default": [],
      "items": {
        "$ref": "#/DateRange"
      }
    },
    "DatePicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "disabledDates": {
                  "type": "array",
                  "items": {
                    "$ref": "#/DateItem"
                  },
                  "default": [],
                  "description": "array of disabled dates"
                },
                "disabledDaysOfWeek": {
                  "type": "array",
                  "items": {
                    "type": [
                      "number"
                    ],
                    "enum": [
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6
                    ]
                  },
                  "default": [],
                  "description": "array of disabled days"
                },
                "minDate": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "#/DateItem--unrestricted-root"
                    }
                  ],
                  "description": "date input minimum date value"
                },
                "maxDate": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "$ref": "#/DateItem--unrestricted-root"
                    }
                  ],
                  "description": "date input maximum date value"
                },
                "allowPastDates": {
                  "type": "boolean",
                  "default": true,
                  "description": "if true all past days are enabled, false otherwise"
                },
                "allowFutureDates": {
                  "type": "boolean",
                  "default": true,
                  "description": "if true all future days are enabled, false otherwise"
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "maxLength": 200,
                  "description": "the placeholder option in case nothing is selected"
                },
                "enabledDateRanges": {
                  "$ref": "#/DateRanges",
                  "description": "array of enabled dates. each date in the format YYYY/MM/DD"
                },
                "disabledDateRanges": {
                  "$ref": "#/DateRanges",
                  "description": "array of disabled dates. each date in the format YYYY/MM/DD"
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "Theme--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "properties": {
              "type": [
                "object",
                "null"
              ],
              "additionalProperties": true,
              "default": {}
            }
          }
        }
      ],
      "type": "object"
    },
    "TwitterFollow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "accountToFollow": {
              "type": "string",
              "default": "wix"
            }
          }
        }
      ],
      "type": "object"
    },
    "TwitterTweet--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "defaultText": {
              "type": "string"
            },
            "accountToFollow": {
              "type": "string"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "MobileMetaData--unrestricted-root": {
      "type": "object",
      "required": [
        "adaptiveMobileOn"
      ],
      "properties": {
        "adaptiveMobileOn": {
          "type": "boolean",
          "default": true
        }
      }
    },
    "Preloader--unrestricted-root": {
      "type": "object",
      "required": [
        "enabled",
        "uri"
      ],
      "properties": {
        "enabled": {
          "type": "boolean",
          "default": false
        },
        "uri": {
          "type": "string",
          "default": ""
        }
      }
    },
    "ContactInfo--unrestricted-root": {
      "type": "object",
      "required": [
        "companyName",
        "phone",
        "email",
        "address",
        "fax"
      ],
      "properties": {
        "companyName": {
          "type": "string",
          "default": ""
        },
        "phone": {
          "type": "string",
          "default": ""
        },
        "email": {
          "type": "string",
          "default": ""
        },
        "address": {
          "type": "string",
          "default": ""
        },
        "fax": {
          "type": "string",
          "default": ""
        }
      }
    },
    "SocialLink--unrestricted-root": {
      "type": "object",
      "required": [
        "id",
        "url"
      ],
      "properties": {
        "id": {
          "type": "string",
          "enum": [
            "facebook",
            "twitter",
            "pinterest",
            "google_plus",
            "tumblr",
            "blogger",
            "linkedin",
            "youtube",
            "vimeo",
            "flickr"
          ]
        },
        "url": {
          "type": "string",
          "default": ""
        }
      }
    },
    "QuickActions--unrestricted-root": {
      "type": "object",
      "required": [
        "colorScheme",
        "configuration",
        "socialLinks"
      ],
      "properties": {
        "colorScheme": {
          "type": "string",
          "enum": [
            "dark",
            "light"
          ],
          "default": "dark"
        },
        "configuration": {
          "type": "object",
          "default": {
            "addressEnabled": false,
            "emailEnabled": false,
            "navigationMenuEnabled": true,
            "phoneEnabled": false,
            "quickActionsMenuEnabled": false,
            "socialLinksEnabled": false
          },
          "properties": {
            "addressEnabled": {
              "type": "boolean",
              "default": false
            },
            "emailEnabled": {
              "type": "boolean",
              "default": false
            },
            "navigationMenuEnabled": {
              "type": "boolean",
              "default": true
            },
            "phoneEnabled": {
              "type": "boolean",
              "default": false
            },
            "quickActionsMenuEnabled": {
              "type": "boolean",
              "default": false
            },
            "socialLinksEnabled": {
              "type": "boolean",
              "default": false
            }
          },
          "unevaluatedProperties": false
        },
        "socialLinks": {
          "type": "array",
          "items": {
            "$ref": "#/SocialLink"
          },
          "default": []
        }
      }
    },
    "QuickActionBarItem--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "itemType"
          ],
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "itemType": {
              "maxLength": 50,
              "type": "string"
            },
            "text": {
              "maxLength": 40,
              "type": "string",
              "default": ""
            },
            "icon": {
              "maxLength": 200,
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "SiteSettings--unrestricted-root": {
      "type": "object",
      "properties": {
        "siteName": {
          "type": "string",
          "default": ""
        },
        "siteTitleSEO": {
          "type": "string",
          "default": ""
        },
        "siteDescriptionSEO": {
          "type": "string",
          "default": ""
        },
        "keywordsSEO": {
          "type": "string",
          "default": ""
        },
        "allowSEFindSite": {
          "type": "boolean",
          "default": false
        },
        "favicon": {
          "type": "string",
          "default": ""
        },
        "thumbnail": {
          "type": "string",
          "default": ""
        },
        "googleAnalyticsID": {
          "type": "string",
          "default": ""
        },
        "fbAdminsUserId": {
          "type": "string",
          "default": ""
        },
        "suppressTrackingCookies": {
          "type": "boolean",
          "default": false
        }
      }
    },
    "AdvancedSeoSettingsDialog--unrestricted-root": {
      "type": "object",
      "properties": {
        "userMetaTags": {
          "type": "string",
          "default": ""
        }
      }
    },
    "Anchor--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "compId": {
              "type": "string"
            },
            "urlFragment": {
              "type": "string",
              "maxLength": 60
            }
          }
        }
      ],
      "type": "object"
    },
    "BasicMenuItem--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "slot": {
              "type": "string"
            },
            "label": {
              "type": "string"
            },
            "isVisible": {
              "type": "boolean",
              "default": true
            },
            "isVisibleMobile": {
              "type": "boolean",
              "default": true
            },
            "displayCount": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "iconRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "CustomMenu--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "menuType": {
              "type": "string",
              "maxLength": 100
            },
            "syncWithPages": {
              "type": "boolean",
              "default": false
            },
            "appId": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "CustomMenusCollection--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menus": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "CustomMenuDataRef--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menuRef": {
              "default": "#CUSTOM_MAIN_MENU",
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "itemDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 1st (top) level menu items"
            },
            "submenuDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 2nd level menu item (submenu)"
            },
            "submenuSubItemDirection": {
              "$ref": "#/Direction",
              "description": "direction of the 3rd level menu item (submenuSubItem)"
            }
          }
        }
      ],
      "type": "object"
    },
    "CustomMenuDataRefA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "Menu--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "FacebookLikeBox--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "facebookPageId": {
              "type": "string",
              "default": "wix",
              "description": "Facebook page id"
            },
            "showFaces": {
              "type": "boolean",
              "default": true,
              "description": "Show profile photos in the plugin"
            },
            "colorScheme": {
              "type": "string",
              "default": "light",
              "enum": [
                "light",
                "dark"
              ],
              "description": "The color scheme of the plugin. Note that the background is always transparent to match your background color. This setting changes the foreground colors to work well on light or dark backgrounds."
            },
            "showStream": {
              "type": "boolean",
              "default": true,
              "description": "Show the profile stream for the public profile"
            },
            "showBorder": {
              "type": "boolean",
              "default": true,
              "description": "Show a border around the plugin"
            },
            "showHeader": {
              "type": "boolean",
              "default": true,
              "description": "Show the 'Find us on Facebook' bar at top. Only shown when either stream or faces are present"
            }
          }
        }
      ],
      "type": "object"
    },
    "ImageButtonA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "ImageButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "alt": {
              "type": "string"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "defaultImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "hoverImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "activeImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "NumericStepper--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "1"
            }
          }
        }
      ],
      "type": "object"
    },
    "PinItPinWidget--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pinId": {
              "type": "string",
              "default": "http://www.pinterest.com/pin/204421270560540859/"
            }
          }
        }
      ],
      "type": "object"
    },
    "PinterestPinIt--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "description": {
              "type": "string",
              "default": "Check it out!"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "SingleAudioPlayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": "",
              "description": "MP3 uri"
            },
            "originalFileName": {
              "type": "string",
              "default": "",
              "description": "Original MP3 file name"
            },
            "artist": {
              "type": "string",
              "default": "Unknown Artist",
              "description": "Artist Name"
            },
            "track": {
              "type": "string",
              "default": "Unknown Track",
              "description": "Track Name"
            }
          }
        }
      ],
      "type": "object"
    },
    "SkypeCallButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "skypeName": {
              "type": "string"
            },
            "buttonType": {
              "type": "string",
              "enum": [
                "call",
                "chat"
              ],
              "default": "call"
            }
          }
        }
      ],
      "type": "object"
    },
    "SpotifyFollow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "SpotifyPlayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": "",
              "description": "Spotify URI"
            }
          }
        }
      ],
      "type": "object"
    },
    "SubscribeForm--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "firstNameFieldLabel": {
              "type": "string",
              "default": "First Name"
            },
            "lastNameFieldLabel": {
              "type": "string",
              "default": "Last Name"
            },
            "emailFieldLabel": {
              "type": "string",
              "default": "Email"
            },
            "phoneFieldLabel": {
              "type": "string",
              "default": "Mobile number"
            },
            "subscribeFormTitle": {
              "type": "string",
              "default": "Subscribe for Updates"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Subscribe Now"
            },
            "successMessage": {
              "type": "string",
              "default": "Congrats! You’re subscribed"
            },
            "errorMessage": {
              "type": "string",
              "default": "Forgot your email? Try again."
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "To subscribe please fill in all the required info"
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "YouTubeSubscribeButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "youtubeChannelId": {
              "type": "string",
              "default": "wix",
              "description": "youtube channel id"
            }
          }
        }
      ],
      "type": "object"
    },
    "AudioPlayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "autoPlay": {
              "type": "boolean",
              "default": false
            },
            "loop": {
              "type": "boolean",
              "default": false
            },
            "visible": {
              "type": "boolean",
              "default": true
            },
            "volume": {
              "type": "number",
              "default": 100
            },
            "title": {
              "type": "string",
              "default": ""
            },
            "description": {
              "type": "string",
              "default": ""
            },
            "icon_uri": {
              "type": "string",
              "default": ""
            },
            "originalFileName": {
              "type": "string",
              "default": ""
            },
            "showToolTip": {
              "$ref": "urn:dm:schemas:common.json#/JavaBool"
            }
          }
        }
      ],
      "type": "object"
    },
    "Boolean--unrestricted-root": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        }
      }
    },
    "CheckBox--unrestricted-root": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        },
        "indeterminate": {
          "type": "boolean",
          "default": false,
          "description": "Used for three state check box"
        }
      }
    },
    "Grid--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "dataSource": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "static",
                    "dynamic"
                  ]
                },
                "revision": {
                  "type": "number",
                  "multipleOf": 1
                }
              },
              "unevaluatedProperties": false
            },
            "rows": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": true,
                "unevaluatedProperties": false
              }
            },
            "rowsCount": {
              "type": "number"
            },
            "revision": {
              "type": "number"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "ContactForm--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "nameFieldLabel": {
              "type": "string",
              "default": "Name"
            },
            "emailFieldLabel": {
              "type": "string",
              "default": "Email"
            },
            "phoneFieldLabel": {
              "type": "string",
              "default": "Phone"
            },
            "addressFieldLabel": {
              "type": "string",
              "default": "Address"
            },
            "subjectFieldLabel": {
              "type": "string",
              "default": "Subject"
            },
            "messageFieldLabel": {
              "type": "string",
              "default": "Message"
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Send"
            },
            "successMessage": {
              "type": "string",
              "default": "Your details were sent successfully!"
            },
            "errorMessage": {
              "type": "string",
              "default": "Please provide a valid email"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "Please fill in all required fields."
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "DynamicContactForm--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "toEmailAddress": {
              "type": "string",
              "default": ""
            },
            "bccEmailAddress": {
              "type": "string",
              "default": ""
            },
            "submitButtonLabel": {
              "type": "string",
              "default": "Send"
            },
            "successMessage": {
              "type": "string",
              "default": "Your details were sent successfully!"
            },
            "errorMessage": {
              "type": "string",
              "default": "Please provide a valid email"
            },
            "textDirection": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "validationErrorMessage": {
              "type": "string",
              "default": "Please fill in all required fields."
            },
            "onSubmitBehavior": {
              "type": "string",
              "default": "message",
              "enum": [
                "message",
                "link"
              ]
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "formName": {
              "type": "string",
              "default": ""
            },
            "dynamicFields": {
              "type": "array",
              "default": [
                {
                  "name": "email",
                  "inputType": "email",
                  "displayLabel": "Email",
                  "required": true
                },
                {
                  "name": "name",
                  "inputType": "text",
                  "displayLabel": "Name",
                  "required": true
                },
                {
                  "name": "subject",
                  "inputType": "text",
                  "displayLabel": "Subject",
                  "required": false
                },
                {
                  "name": "message",
                  "inputType": "text",
                  "displayLabel": "Message",
                  "required": false
                }
              ],
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string",
                    "maxLength": 50
                  },
                  "inputType": {
                    "type": "string",
                    "maxLength": 50
                  },
                  "displayLabel": {
                    "type": "string",
                    "maxLength": 200
                  },
                  "required": {
                    "$ref": "urn:dm:schemas:common.json#/JavaBool"
                  },
                  "displayed": {
                    "$ref": "urn:dm:schemas:common.json#/JavaBool"
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "type": "object"
    },
    "EbayItemsBySeller--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "sellerId": {
              "type": "string"
            },
            "registrationSite": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "FacebookShareButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "urlChoice": {
              "type": "string",
              "enum": [
                "Current page",
                "Site"
              ],
              "default": "Current page",
              "description": "Share: current/site url"
            },
            "label": {
              "type": "string",
              "default": "Share",
              "description": ""
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "FlashComponent--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string"
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            },
            "title": {
              "type": "string",
              "maxLength": 100
            },
            "uri": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 1000
            },
            "height": {
              "type": "number",
              "default": 0
            },
            "width": {
              "type": "number",
              "default": 0
            },
            "placeHolderImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "FlickrBadgeWidget--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "userId": {
              "type": "string",
              "default": "74009459@N07"
            },
            "userName": {
              "type": "string"
            },
            "tag": {
              "type": "string"
            },
            "imageCount": {
              "type": [
                "string",
                "number"
              ],
              "default": 3
            },
            "whichImages": {
              "type": "string",
              "default": "latest"
            },
            "imageSize": {
              "type": "string",
              "default": "t"
            },
            "layoutOrientation": {
              "type": "string",
              "default": "v"
            }
          }
        }
      ],
      "type": "object"
    },
    "GeoMapLocation--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "address": {
              "type": "string",
              "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158",
              "maxLength": 1000
            },
            "latitude": {
              "type": "number",
              "default": 37.77065
            },
            "longitude": {
              "type": "number",
              "default": -122.387301
            },
            "title": {
              "type": "string",
              "default": "Wix Office",
              "maxLength": 10000
            },
            "description": {
              "type": "string",
              "default": "Wix HQ",
              "maxLength": 350
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "linkTitle": {
              "type": "string",
              "default": "Visit Wix's Site",
              "maxLength": 140
            },
            "pinIcon": {
              "type": "string",
              "default": "https://static.parastorage.com/services/santa-resources/resources/editor/designPanel/panelTypes/default_pin_icon.png",
              "maxLength": 1000
            },
            "pinColor": {
              "type": "string",
              "default": "#2A3688",
              "maxLength": 20
            }
          }
        }
      ],
      "type": "object"
    },
    "GeoMap--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "language": {
              "type": "string",
              "enum": [
                "af",
                "sq",
                "am",
                "ar",
                "hy",
                "az",
                "eu",
                "be",
                "bn",
                "bs",
                "bg",
                "my",
                "ca",
                "zh",
                "zh-CN",
                "zh-HK",
                "zh-TW",
                "hr",
                "cs",
                "da",
                "nl",
                "en",
                "en-AU",
                "en-GB",
                "et",
                "fa",
                "fi",
                "fil",
                "fr",
                "fr-CA",
                "gl",
                "ka",
                "de",
                "el",
                "gu",
                "iw",
                "hi",
                "hu",
                "is",
                "id",
                "it",
                "ja",
                "kn",
                "kk",
                "km",
                "ko",
                "ky",
                "lo",
                "lv",
                "lt",
                "mk",
                "ms",
                "ml",
                "mr",
                "mn",
                "ne",
                "no",
                "pl",
                "pt",
                "pt-BR",
                "pt-PT",
                "pa",
                "ro",
                "ru",
                "sr",
                "si",
                "sk",
                "sl",
                "es",
                "es-419",
                "sw",
                "sv",
                "ta",
                "te",
                "th",
                "tr",
                "uk",
                "ur",
                "uz",
                "vi",
                "zu"
              ]
            },
            "locations": {
              "minItems": 0,
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "address": {
              "type": "string",
              "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158"
            },
            "latitude": {
              "type": "number",
              "default": 37.77065
            },
            "longitude": {
              "type": "number",
              "default": -122.387301
            },
            "addressInfo": {
              "type": "string",
              "default": "Wix Office"
            },
            "defaultLocation": {
              "type": "number",
              "default": 0
            },
            "mapStyle": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "stylers"
                ],
                "properties": {
                  "elementType": {
                    "type": "string",
                    "enum": [
                      "all",
                      "geometry",
                      "geometry.fill",
                      "geometry.stroke",
                      "labels",
                      "labels.icon",
                      "labels.text",
                      "labels.text.fill",
                      "labels.text.stroke"
                    ],
                    "description": "Selects the element type to which a styler should be applied. An element type distinguishes between the different representations of a feature."
                  },
                  "featureType": {
                    "type": "string",
                    "enum": [
                      "administrative",
                      "administrative.country",
                      "administrative.land_parcel",
                      "administrative.locality",
                      "administrative.neighborhood",
                      "administrative.province",
                      "all",
                      "landscape",
                      "landscape.man_made",
                      "landscape.natural",
                      "landscape.natural.landcover",
                      "landscape.natural.terrain",
                      "poi",
                      "poi.attraction",
                      "poi.business",
                      "poi.government",
                      "poi.medical",
                      "poi.park",
                      "poi.place_of_worship",
                      "poi.school",
                      "poi.sports_complex",
                      "road",
                      "road.arterial",
                      "road.highway",
                      "road.highway.controlled_access",
                      "road.local",
                      "transit",
                      "transit.line",
                      "transit.station",
                      "transit.station.airport",
                      "transit.station.bus",
                      "transit.station.rail",
                      "water"
                    ],
                    "description": "Selects the feature, or group of features, to which a styler should be applied."
                  },
                  "stylers": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "maxProperties": 1,
                      "additionalProperties": false,
                      "description": "The style rules to apply to the selectors. The rules are applied to the map's elements in the order they are listed in this array.",
                      "properties": {
                        "color": {
                          "type": "string",
                          "maxLength": 100,
                          "description": "Sets the color of the feature. Valid values: An RGB hex string, i.e. '#ff0000'."
                        },
                        "gamma": {
                          "type": "number",
                          "description": "Modifies the gamma by raising the lightness to the given power.Valid values: Floating point numbers, [0.01, 10], with 1.0 representing no change."
                        },
                        "hue": {
                          "type": "string",
                          "maxLength": 100,
                          "description": "Sets the hue of the feature to match the hue of the color supplied. Note that the saturation and lightness of the feature is conserved, which means that the feature will not match the color supplied exactly. Valid values: An RGB hex string, i.e. '#ff0000'."
                        },
                        "invert_lightness": {
                          "type": "boolean",
                          "description": "A value of true will invert the lightness of the feature while preserving the hue and saturation."
                        },
                        "lightness": {
                          "type": "number",
                          "description": "Shifts lightness of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                        },
                        "saturation": {
                          "type": "number",
                          "description": "Shifts the saturation of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                        },
                        "visibility": {
                          "type": "string",
                          "enum": [
                            "on",
                            "off",
                            "simplified"
                          ],
                          "description": "Sets the visibility of the feature. Valid values: 'on', 'off' or 'simplified'."
                        },
                        "weight": {
                          "type": "number",
                          "description": "Sets the weight of the feature, in pixels. Valid values: Integers greater than or equal to zero."
                        }
                      },
                      "unevaluatedProperties": false
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "type": "object"
    },
    "HtmlComponent--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "sourceType": {
              "type": "string",
              "default": ""
            },
            "url": {
              "type": "string",
              "default": ""
            },
            "title": {
              "type": "string"
            },
            "freezeFrame": {
              "type": "boolean",
              "default": false
            },
            "allowFullScreen": {
              "type": "boolean",
              "default": false
            },
            "componentConsentPolicy": {
              "type": "string",
              "default": "essential",
              "enum": [
                "essential",
                "functional",
                "analytics",
                "advertising",
                "dataToThirdParty"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "DisqusComments--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "disqusId": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "ItunesButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "downloadUrl": {
              "type": "string",
              "default": "",
              "description": "Insert band URL"
            }
          }
        }
      ],
      "type": "object"
    },
    "LinkableFlashComponent--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "title": {
              "type": "string"
            },
            "uri": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "height": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "placeHolderImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LinkableButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LoginButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "language": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "TinyMenu--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "loginSocialBarRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            },
            "menuRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LoginSocialBar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "menuItemsRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "iconItemsRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "language": {
              "type": "string",
              "default": "en",
              "maxLength": 10
            },
            "loggedInMember": {
              "type": "string",
              "enum": [
                "avatarOnly",
                "textOnly",
                "avatarAndText",
                "memberInitials"
              ],
              "default": "avatarAndText"
            },
            "loggedOutMember": {
              "type": "string",
              "enum": [
                "avatarOnly",
                "textOnly",
                "avatarAndText"
              ]
            },
            "loggedInAvatarIcon": {
              "type": "string",
              "enum": [
                "profileImage",
                "initials",
                "custom"
              ]
            },
            "loggedOutAvatarIcon": {
              "type": "string",
              "enum": [
                "profileImage",
                "initials",
                "custom"
              ],
              "default": "profileImage"
            },
            "loggedInCustomAvatar": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "loggedOutCustomAvatar": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "loggedOutText": {
              "type": "string",
              "default": "Log In",
              "maxLength": 50
            },
            "showLoggedInText": {
              "type": "boolean",
              "default": true
            },
            "loggedInTextState": {
              "type": "string",
              "enum": [
                "memberName",
                "custom"
              ]
            },
            "loggedInText": {
              "type": "string",
              "default": "Hello",
              "maxLength": 50
            },
            "customLoggedInText": {
              "type": "string",
              "maxLength": 50
            },
            "logOutText": {
              "type": "string",
              "default": "Log Out",
              "maxLength": 50
            }
          }
        }
      ],
      "type": "object"
    },
    "PagesGroupData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appId": {
              "type": [
                "number",
                "null"
              ]
            },
            "appDefinitionId": {
              "type": "string"
            },
            "groupName": {
              "type": "string"
            },
            "pages": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            }
          }
        }
      ],
      "type": "object"
    },
    "PagesGroupCollection--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "groups": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "PayPalButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "merchantID": {
              "type": "string",
              "default": "",
              "description": "some amazing description"
            }
          }
        }
      ],
      "type": "object"
    },
    "PermaLink--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "appType"
          ],
          "properties": {
            "appType": {
              "enum": [
                "ListsApps",
                "ThirdPartyApps"
              ]
            },
            "dataItemRef": {
              "default": "",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "mutableSeoTitle": {
              "type": "string"
            },
            "correctPermaLinkRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "PinterestFollow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "urlChoice": {
              "type": "string",
              "default": "pinterest/",
              "description": ""
            },
            "label": {
              "type": "string",
              "default": "Pinterest",
              "description": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "SelectableList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "$ref": "#/Direction",
                  "description": "direction of the component"
                },
                "labelDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the label"
                },
                "inputDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the input"
                },
                "dropdownDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the dropdown"
                },
                "errorDirection": {
                  "$ref": "#/Direction",
                  "description": "direction of the error"
                },
                "options": {
                  "description": "a list of SelectOption data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": "object",
                  "properties": {
                    "value": {
                      "type": "string",
                      "default": "-1",
                      "description": "the value of the placeholder option",
                      "maxLength": 400
                    },
                    "text": {
                      "type": "string",
                      "default": "",
                      "description": "the text of the placeholder option",
                      "maxLength": 400
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SelectOption--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "text": {
              "type": "string",
              "default": "",
              "maxLength": 400
            },
            "selectedText": {
              "type": "string",
              "maxLength": 400
            },
            "disabled": {
              "type": "boolean"
            },
            "description": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "RadioButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "label": {
                  "type": "string",
                  "default": "",
                  "maxLength": 400
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RadioGroup--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "optionsDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "defaultValue": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "options": {
                  "description": "a list of RadioButton data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 400
                },
                "placeholder": {
                  "type": "object",
                  "properties": {
                    "value": {
                      "type": "string",
                      "default": "-1",
                      "description": "the value of the placeholder option",
                      "maxLength": 400
                    },
                    "text": {
                      "type": "string",
                      "default": "",
                      "description": "the text of the placeholder option",
                      "maxLength": 400
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "CheckboxGroup--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "optionsDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "options": {
                  "description": "a list of CheckboxInput data items",
                  "default": [],
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                },
                "label": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "default": "",
                  "maxLength": 4000
                }
              }
            },
            {
              "$ref": "#/BaseInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "FileUploader--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "buttonLabel": {
              "type": "string",
              "default": "Upload File",
              "maxLength": 500
            },
            "placeholderLabel": {
              "type": "string",
              "default": "Max File Size 15MG",
              "maxLength": 500
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "maxLength": 400
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonLabelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "filesDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "iconPosition": {
              "type": [
                "string"
              ],
              "enum": [
                "row",
                "rowReverse",
                "column",
                "columnReverse"
              ],
              "description": "Flex direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "UploadName--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "SiteButtonA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pressed": {
              "type": "boolean"
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "haspopup": {
              "type": "string",
              "enum": [
                "true",
                "false",
                "menu",
                "dialog",
                "listbox",
                "tree",
                "grid"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "disabled": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "SiteButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "linkType": {
              "$ref": "#/LinkType"
            },
            "href": {
              "type": "string"
            },
            "text": {
              "type": "string",
              "maxLength": 1200
            },
            "target": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON"
            }
          }
        }
      ],
      "type": "object"
    },
    "SoundCloudWidget--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string",
              "default": ""
            },
            "showArtWork": {
              "type": "boolean",
              "default": true
            },
            "autoPlay": {
              "type": "boolean",
              "default": false
            },
            "embedSource": {
              "type": "string",
              "default": ""
            }
          }
        }
      ],
      "type": "object"
    },
    "StyledTextA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "status",
                "alert"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "StyledText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000,
              "default": "<p class='font_7'></p>",
              "not": {
                "pattern": "<script"
              }
            },
            "stylesMapId": {
              "type": "string"
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "StyledTextLinkHelper--unrestricted-root": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
        }
      }
    },
    "SvgShape--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "alt": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "VectorImage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            },
            "alt": {
              "type": "string",
              "description": "Alternative text for the vector image (for accessibility purposes).",
              "default": ""
            },
            "decorative": {
              "type": "boolean"
            },
            "title": {
              "type": "string",
              "maxLength": 100,
              "description": "Title or caption for the vector image."
            },
            "svgId": {
              "type": "string",
              "maxLength": 100,
              "description": "Identifier for the SVG image."
            }
          }
        }
      ],
      "type": "object"
    },
    "Video--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "videoId": {
              "type": "string"
            },
            "userId": {
              "type": "string"
            },
            "posterImage": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "videoType": {
              "type": "string",
              "enum": [
                "YOUTUBE",
                "VIMEO",
                "FACEBOOK",
                "DAILYMOTION"
              ],
              "default": "YOUTUBE"
            }
          }
        }
      ],
      "type": "object"
    },
    "VKShareButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "style": {
              "type": "string",
              "enum": [
                "Button",
                "ButtonWithoutCounter",
                "Link",
                "LinkWithoutIcon",
                "Icon"
              ],
              "default": "Button",
              "description": "the layout of the button"
            },
            "text": {
              "type": "string",
              "default": "Share",
              "description": "the text of the Button"
            },
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "ButtonWithIcon--unrestricted-root": {
      "type": "object",
      "properties": {
        "label": {
          "type": "string",
          "format": "resourceKey"
        },
        "toggleMode": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        },
        "iconSrc": {
          "type": "string"
        },
        "iconSize": {
          "type": "object",
          "additionalProperties": true,
          "unevaluatedProperties": false
        },
        "spriteOffset": {
          "type": "object",
          "additionalProperties": true,
          "unevaluatedProperties": false
        },
        "command": {
          "type": "string"
        },
        "commandParameter": {
          "type": "string"
        },
        "action": {
          "type": "string"
        }
      }
    },
    "EditorPreferences--unrestricted-root": {
      "type": "object",
      "properties": {
        "dontShowAgainTooltips": {
          "type": [
            "null",
            "array"
          ]
        },
        "dontShowAgainDialogs": {
          "type": [
            "null",
            "array"
          ]
        }
      }
    },
    "TPAWidget--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "some amazing description"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TPAData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "content": {
              "type": "string",
              "default": "",
              "description": "storage for app data",
              "maxLength": 4000
            }
          }
        }
      ],
      "type": "object"
    },
    "TPAGlobalData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "content": {
              "type": "string",
              "default": "",
              "description": "storage for app data"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Definition ID"
            }
          }
        }
      ],
      "type": "object"
    },
    "TPA--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "referenceId": {
              "type": "string"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "widget id"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TPASection--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TPAMultiSection--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "applicationId": {
              "type": "string",
              "default": "",
              "description": "application ID"
            },
            "appDefinitionId": {
              "type": "string",
              "default": "",
              "description": "app Defitintion ID"
            },
            "widgetId": {
              "type": "string",
              "default": "",
              "description": "hidden tpaSection part of multi section app"
            },
            "referenceId": {
              "type": "string"
            },
            "usesCssPerBreakpoint": {
              "type": [
                "boolean"
              ],
              "description": "does the TPA supports CSS Per breakpoint"
            },
            "tpaData": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "RssButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "image": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "type": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "AppPart--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appInnerID": {
              "type": [
                "string",
                "number"
              ]
            },
            "appLogicParams": {
              "type": "object",
              "default": {},
              "additionalProperties": true,
              "unevaluatedProperties": false
            },
            "appLogicCustomizations": {
              "type": "array",
              "items": {
                "$ref": "#/AppPartCustomization"
              },
              "default": []
            },
            "appPartName": {
              "type": "string"
            },
            "viewName": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "AppPartCustomization--unrestricted-root": {
      "type": "object",
      "properties": {
        "fieldId": {
          "type": "string"
        },
        "forType": {
          "type": "string"
        },
        "format": {
          "type": "string"
        },
        "key": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "view": {
          "type": "string"
        },
        "mode": {
          "type": [
            "string",
            "null"
          ]
        },
        "value": {
          "type": [
            "string",
            "null"
          ]
        }
      }
    },
    "AppPage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "appPageId": {
                  "type": "string",
                  "default": ""
                },
                "appInnerID": {
                  "type": [
                    "string",
                    "number"
                  ],
                  "default": ""
                },
                "appPageType": {
                  "type": "string"
                },
                "repeaterPage": {
                  "type": "boolean",
                  "default": false
                }
              }
            },
            {
              "$ref": "#/Page--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "AppBuilderComponent--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appInnerID": {
              "type": [
                "string",
                "null"
              ]
            },
            "appPartName": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "BoxSlideShow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "type": "object"
    },
    "BoxSlideShowSlide--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "StripContainerSlideShow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            }
          }
        }
      ],
      "type": "object"
    },
    "StripContainerSlideShowSlide--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "background": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "VerticalAnchorsMenu--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "pageTopLabel": {
              "type": [
                "null",
                "string"
              ],
              "default": "Page Top"
            },
            "pageBottomLabel": {
              "type": [
                "null",
                "string"
              ],
              "default": "Page Bottom"
            },
            "hiddenAnchorIds": {
              "type": [
                "null",
                "object"
              ],
              "default": {}
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "bulletPosition": {
              "type": [
                "string"
              ],
              "enum": [
                "row",
                "rowReverse",
                "column",
                "columnReverse"
              ],
              "description": "Flex direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "WFacebookComment--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "WFacebookLike--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isHttpsEnabled": {
              "type": "boolean",
              "default": false
            },
            "urlFormat": {
              "$ref": "#/UrlFormat"
            }
          }
        }
      ],
      "type": "object"
    },
    "AppController--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "applicationId",
            "controllerType"
          ],
          "properties": {
            "applicationId": {
              "type": "string",
              "maxLength": 100
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "default": ""
            },
            "controllerType": {
              "type": "string",
              "maxLength": 100
            },
            "settings": {
              "type": "string",
              "maxLength": 6000
            },
            "externalId": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "RepeaterA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "none",
                "radiogroup",
                "list",
                "group"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "Repeater--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "#/Direction",
              "description": "direction of the component"
            },
            "items": {
              "type": "array",
              "default": [],
              "items": {
                "type": "string"
              },
              "description": "Unique identifiers for items of the repeater"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "RepeatedData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "description": "data used for the serialization of a component inside a repeater component",
          "properties": {
            "original": {
              "type": "object",
              "additionalProperties": true,
              "description": "the original data item of a component inside a repeater according to the specific component schema",
              "unevaluatedProperties": false
            },
            "overrides": {
              "type": "object",
              "additionalProperties": true,
              "description": "a map from itemId in a repeater to its data item according to the specific component schema",
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "ImageButtonWithText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 100
            },
            "icon": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "predefinedClass": {
              "type": "string",
              "maxLength": 20
            }
          }
        }
      ],
      "type": "object"
    },
    "Icon--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "url": {
              "type": "string"
            },
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "title": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "WidgetRef--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "appDefinitionId": {
              "type": "string"
            },
            "widgetId": {
              "type": "string"
            },
            "variationId": {
              "type": [
                "string",
                "null"
              ]
            },
            "name": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "InternalRef--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            },
            "pageId": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "InternalBlocksRef--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "type": "string"
            },
            "pageId": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "ForwardRef--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "rootCompId": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LightboxA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "LightboxContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "ContainerA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "none",
                "status",
                "alert",
                "nav",
                "list",
                "listitem",
                "tablist",
                "tab",
                "tabpanel",
                "menubar",
                "presentation",
                "heading"
              ]
            },
            "roledescription": {
              "type": "string",
              "maxLength": 100
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false"
              ],
              "maxLength": 10
            },
            "hidden": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string",
              "enum": [
                "all",
                "additions",
                "text",
                "removals"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "ContainerData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "MediaBoxData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "SlotsPlaceholderData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "interfaces"
          ],
          "properties": {
            "interfaces": {
              "type": "array",
              "items": {
                "type": "string"
              },
              "maxItems": 20
            }
          }
        }
      ],
      "type": "object"
    },
    "LinkType--unrestricted-root": {
      "type": "string",
      "enum": [
        "SMS",
        "CALL",
        "SKYPE",
        "MAP",
        "EMAIL",
        "FACEBOOK",
        "FLICKR",
        "BLOGGER",
        "MYSPACE",
        "LINKEDIN",
        "TWITTER",
        "TUMBLR",
        "YOUTUBE",
        "VIMEO",
        "PAGE",
        "FREE_LINK",
        "TEXT",
        "DELICIOUS",
        "WEBSITE",
        "DOCUMENT",
        "ADMIN_LOGIN",
        "LOGIN"
      ],
      "default": "FREE_LINK"
    },
    "UrlFormat--unrestricted-root": {
      "type": "string",
      "enum": [
        "hashBang",
        "slash"
      ],
      "default": "slash"
    },
    "MultiStateBoxDataA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "MultiStateBoxData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "defaultStateId": {
                  "default": "FIRST_STATE",
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "selectedStateId": {
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "a11y": {
                  "$ref": "urn:dm:schemas:common.json#/nullableReference"
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "AppsInstallState--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "stateMap": {
              "type": "object",
              "default": {},
              "additionalProperties": {
                "type": "object",
                "required": [
                  "status"
                ],
                "properties": {
                  "status": {
                    "type": "string",
                    "enum": [
                      "INSTALLED",
                      "REMOVED"
                    ],
                    "default": "INSTALLED"
                  },
                  "version": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 20
                  },
                  "codeReferenceId": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 40
                  },
                  "overrideCodeReferenceId": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "minLength": 1,
                    "maxLength": 40
                  }
                }
              },
              "properties": {},
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "StateBoxA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "StateBox--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "StateBoxStateA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "role": {
              "type": "string",
              "enum": [
                "region",
                "group",
                "tablist",
                "tab",
                "tabpanel",
                "alert",
                "status",
                "list",
                "menubar",
                "presentation",
                "none",
                "nav",
                "listitem"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "expanded": {
              "type": "boolean"
            },
            "relevant": {
              "type": "string"
            },
            "busy": {
              "type": "boolean"
            },
            "owns": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "StateBoxState--unrestricted-root": {
      "type": "object",
      "properties": {
        "a11y": {
          "$ref": "urn:dm:schemas:common.json#/nullableReference"
        }
      }
    },
    "Builder.MenuItem--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "container": {
              "type": "string"
            },
            "label": {
              "type": "string"
            },
            "isVisible": {
              "type": "boolean",
              "default": true
            }
          }
        }
      ],
      "type": "object"
    },
    "Builder.MenuItems--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "appDefinitionId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "Builder.Image--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string",
              "maxLength": 1000,
              "description": "Identifier or URL for the image."
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "description": "Human-readable filename to use for the image."
            },
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "alt": {
              "type": "string",
              "maxLength": 1000
            },
            "crop": {
              "type": "object",
              "required": [
                "width",
                "height",
                "x",
                "y"
              ],
              "properties": {
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "Builder.Video--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "description": "Unique identifier for the video media",
              "maxLength": 1000
            },
            "sources": {
              "type": "array",
              "description": "Available video sources in different qualities",
              "items": {
                "type": "object",
                "required": [
                  "quality",
                  "width",
                  "height",
                  "types"
                ],
                "properties": {
                  "quality": {
                    "type": "string",
                    "enum": [
                      "1080p",
                      "720p",
                      "480p",
                      "360p"
                    ],
                    "description": "Quality level of the video source"
                  },
                  "width": {
                    "type": "number",
                    "description": "Width of the video in pixels"
                  },
                  "height": {
                    "type": "number",
                    "description": "Height of the video in pixels"
                  },
                  "types": {
                    "type": "array",
                    "description": "Available format types and their URIs for this quality",
                    "items": {
                      "type": "object",
                      "required": [
                        "format",
                        "uri"
                      ],
                      "properties": {
                        "format": {
                          "type": "string",
                          "enum": [
                            "mp4",
                            "mp4-luminance"
                          ],
                          "description": "Video format type"
                        },
                        "uri": {
                          "type": "string",
                          "description": "URI to access the video file"
                        }
                      },
                      "unevaluatedProperties": false
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "adaptiveSources": {
              "type": "array",
              "description": "Sources for adaptive streaming formats",
              "items": {
                "type": "object",
                "required": [
                  "format",
                  "uri"
                ],
                "properties": {
                  "format": {
                    "type": "string",
                    "enum": [
                      "hls",
                      "dash"
                    ],
                    "description": "Adaptive streaming format"
                  },
                  "uri": {
                    "type": "string",
                    "description": "URI to access the stream manifest"
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "hasAudio": {
              "type": "boolean",
              "description": "Whether the video contains an audio track"
            },
            "fps": {
              "type": "number",
              "description": "Frames per second of the video"
            },
            "poster": {
              "description": "Poster image for the video",
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "duration": {
              "type": "number",
              "description": "Duration of the video in seconds"
            },
            "name": {
              "type": "string",
              "maxLength": 100,
              "description": "Human-readable name to use for the video."
            }
          }
        }
      ],
      "type": "object"
    },
    "Builder.VectorArt--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "uri"
          ],
          "properties": {
            "uri": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "Builder.RichText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 120000
            },
            "linkList": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "wixStudio2Demo.counterContextProvider.Data--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "data"
          ],
          "properties": {
            "data": {
              "type": "object",
              "additionalProperties": true,
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "contentType": {
              "default": "Text",
              "enum": [
                "Text",
                "Icon",
                "Text and icon"
              ],
              "type": "string"
            },
            "label": {
              "default": "Button",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "iconPosition": {
              "default": "Left",
              "enum": [
                "Left",
                "Right"
              ],
              "type": "string"
            },
            "buttonType": {
              "default": "Full",
              "enum": [
                "Full",
                "Outline",
                "Link"
              ],
              "type": "string"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiDatePicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Select Date",
              "maxLength": 120,
              "type": "string"
            },
            "initialText": {
              "default": "today's date",
              "enum": [
                "today's date",
                "placeholder"
              ],
              "type": "string"
            },
            "placeholder": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "fieldType": {
              "default": "form",
              "enum": [
                "form",
                "settings",
                "filter"
              ],
              "type": "string"
            },
            "pickerType": {
              "default": "calendar",
              "enum": [
                "wheel",
                "calendar"
              ],
              "type": "string"
            },
            "pickerTitle": {
              "default": "Select Date",
              "maxLength": 120,
              "type": "string"
            },
            "showPastDates": {
              "default": true,
              "type": "boolean"
            },
            "showFutureDates": {
              "default": true,
              "type": "boolean"
            },
            "wheelMode": {
              "default": "DD/MM/YY",
              "enum": [
                "DD/MM/YY",
                "MM/YY"
              ],
              "type": "string"
            },
            "firstDay": {
              "default": "Monday",
              "enum": [
                "Sunday",
                "Monday"
              ],
              "type": "string"
            },
            "disabledDaysOfWeek": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "enabledDateRanges": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "disabledDateRanges": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "requiredErrorMessage": {
              "default": "This field is required",
              "maxLength": 1200,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "disabledDates": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "minDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "maxDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "timeZone": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "defaultItemSchemaType--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "MobuiDateRangeType--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "startDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "endDate": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiImage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "src": {
              "$ref": "#/ImageReference"
            },
            "isExternalSource": {
              "default": false,
              "type": "boolean"
            },
            "resizeMode": {
              "default": "cover",
              "enum": [
                "cover",
                "contain",
                "stretch",
                "repeat",
                "center"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiPicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldType": {
              "default": "form",
              "enum": [
                "form",
                "filter",
                "settings"
              ],
              "type": "string"
            },
            "label": {
              "default": "Label",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Select an option",
              "maxLength": 120,
              "type": "string"
            },
            "pickerType": {
              "default": "fullScreen",
              "enum": [
                "fullScreen",
                "dialog"
              ],
              "type": "string"
            },
            "optionsDialogTitle": {
              "default": "Select an Option",
              "maxLength": 120,
              "type": "string"
            },
            "optionsDialogSubtitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "hasItemSubtitle": {
              "default": false,
              "type": "boolean"
            },
            "isMultiselect": {
              "default": false,
              "type": "boolean"
            },
            "selectionLimit": {
              "default": 3,
              "type": "number",
              "multipleOf": 1
            },
            "hasSearchBar": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "requiredErrorMessage": {
              "default": "Please fill out this field",
              "maxLength": 120,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "validateOnBlur": {
              "default": false,
              "type": "boolean"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "MobuiPickerItemType--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "subtitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isSelected": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiSwitch--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "value": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Add Title",
              "maxLength": 1200,
              "type": "string"
            },
            "selectable": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiTextInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "inputType": {
              "default": "text",
              "enum": [
                "text",
                "password",
                "phone",
                "email",
                "url",
                "number"
              ],
              "type": "string"
            },
            "label": {
              "default": "Label",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "initialValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "hasCharLimit": {
              "default": false,
              "type": "boolean"
            },
            "maxInputLength": {
              "default": 300,
              "maximum": 120000,
              "type": "number",
              "multipleOf": 1
            },
            "prefixValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "suffixValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "requiredErrorMessage": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validatorErrorMessageValue": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validatorType": {
              "default": "none",
              "enum": [
                "none",
                "number",
                "email",
                "url",
                "required"
              ],
              "type": "string"
            },
            "textContentType": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "autoComplete": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "validateOnStart": {
              "default": false,
              "type": "boolean"
            },
            "validateOnChange": {
              "default": false,
              "type": "boolean"
            },
            "validateOnBlur": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiVideoPlayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "title": {
              "default": "I am a Title",
              "maxLength": 120,
              "type": "string"
            },
            "src": {
              "default": "https://video.wixstatic.com/video/11062b_5ae1557b0cb244ab80dabfa817f48caa/1080p/mp4/file.mp4",
              "maxLength": 1200,
              "type": "string"
            },
            "poster": {
              "$ref": "#/ImageReference"
            },
            "isPlaying": {
              "default": false,
              "type": "boolean"
            },
            "muteOnStart": {
              "default": false,
              "type": "boolean"
            },
            "playInLoop": {
              "default": false,
              "type": "boolean"
            },
            "enableFullScreen": {
              "default": true,
              "type": "boolean"
            },
            "enableCasting": {
              "default": false,
              "type": "boolean"
            },
            "showVideoSettings": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "mobui.MobuiMultiStateBoxData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "defaultStateId": {
                  "default": null,
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                },
                "selectedStateId": {
                  "default": null,
                  "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "wixui.ExternalComponent--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "compProps": {
              "default": "{}",
              "maxLength": 120000,
              "type": "string"
            },
            "isTrusted": {
              "default": false,
              "type": "boolean"
            },
            "importKey": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.HamburgerOverlay--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "showBackgroundOverlay": {
              "default": true,
              "type": "boolean"
            },
            "tapOutsideToClose": {
              "default": true,
              "type": "boolean"
            },
            "isMenuContainerFullscreen": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.Logo--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "isLoadingData": {
              "default": true,
              "type": "boolean"
            },
            "logoId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "alt": {
              "default": "Logo",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "preset": {
              "default": "original",
              "maxLength": 120,
              "type": "string"
            },
            "hasBackground": {
              "default": true,
              "type": "boolean"
            },
            "brandId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "backgroundColor": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "logoUrl": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.LottieEmbed--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "animationUrl": {
              "default": "https://assets7.lottiefiles.com/packages/lf20_bh69rwvr.json",
              "maxLength": 1200,
              "type": "string"
            },
            "speed": {
              "default": 1,
              "minimum": 0,
              "type": "number"
            },
            "loop": {
              "default": true,
              "type": "boolean"
            },
            "autoplay": {
              "default": true,
              "type": "boolean"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isDecorative": {
              "default": false,
              "type": "boolean"
            },
            "showPlaybackControl": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.ProductSpecification--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.RangeSlider--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Set a range value",
              "maxLength": 120,
              "type": "string"
            },
            "sliderType": {
              "default": "Continuous",
              "enum": [
                "Continuous",
                "Stepped"
              ],
              "type": "string"
            },
            "stepType": {
              "default": "Number",
              "enum": [
                "Number",
                "Value"
              ],
              "type": "string"
            },
            "step": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "direction": {
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ],
              "type": "string"
            },
            "rootDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "labelDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "sliderDirection": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            },
            "min": {
              "default": 0,
              "type": "number"
            },
            "max": {
              "default": 100,
              "type": "number"
            },
            "prefix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "suffix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "minValue": {
              "default": 0,
              "type": "number"
            },
            "maxValue": {
              "default": 0,
              "type": "number"
            },
            "thumbShape": {
              "default": "Circle",
              "enum": [
                "Circle",
                "Square",
                "Rectangle",
                "Bar"
              ],
              "type": "string"
            },
            "marksTickShape": {
              "default": "Lines",
              "enum": [
                "Lines",
                "Dots"
              ],
              "type": "string"
            },
            "thumbSize": {
              "default": 24,
              "type": "number",
              "multipleOf": 1
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "accessibleName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.Rive--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "animationFileUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "thumbnailFileUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "artboard": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "stateMachine": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "fit": {
              "default": "cover",
              "maxLength": 120,
              "type": "string"
            },
            "alignment": {
              "default": "center",
              "maxLength": 120,
              "type": "string"
            },
            "isAutoPlayOn": {
              "default": true,
              "type": "boolean"
            },
            "isTouchScrollEnabled": {
              "default": true,
              "type": "boolean"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "fileName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "isDecorative": {
              "default": true,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.ShareButtons--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "buttons": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "pageToShare": {
              "default": "home",
              "maxLength": 1200,
              "type": "string"
            },
            "shareUrl": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "direction": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "IShareButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "platformId": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            },
            "isHidden": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.SingleTab--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "tabId"
          ],
          "type": "object",
          "properties": {
            "tabId": {
              "maxLength": 120,
              "type": "string"
            },
            "label": {
              "default": "Tab",
              "maxLength": 120,
              "type": "string"
            },
            "isParentStretched": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "AccordionContainerData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "items": {
              "type": "array",
              "items": {
                "type": "object",
                "allOf": [
                  {
                    "properties": {
                      "id": {
                        "type": "string"
                      },
                      "label": {
                        "type": "string"
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false
              },
              "default": []
            }
          }
        }
      ],
      "type": "object"
    },
    "AccordionItemData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isParentStretched": {
              "type": "boolean",
              "default": false
            }
          }
        }
      ],
      "type": "object"
    },
    "AddressInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "optionsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "locale": {
              "type": "string",
              "maxLength": 100
            },
            "googleMapsApiKey": {
              "type": "string",
              "maxLength": 400
            },
            "filter": {
              "type": "object",
              "properties": {
                "country": {
                  "type": "string",
                  "maxLength": 10
                }
              },
              "unevaluatedProperties": false
            },
            "sorting": {
              "type": "object",
              "properties": {
                "location": {
                  "type": "object",
                  "properties": {
                    "lat": {
                      "type": "number"
                    },
                    "lng": {
                      "type": "number"
                    }
                  },
                  "unevaluatedProperties": false
                },
                "radius": {
                  "type": "number",
                  "default": 100
                },
                "formatted": {
                  "type": "string",
                  "maxLength": 10
                }
              },
              "unevaluatedProperties": false
            },
            "placeholder": {
              "type": "string",
              "description": "The value of the placeholder if chosen",
              "maxLength": 1000
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "BoltComponentData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "anyOf": [
            {
              "properties": {}
            }
          ]
        }
      ],
      "type": "object"
    },
    "BreadcrumbsData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "svgId": {
                  "type": "string",
                  "maxLength": 100
                }
              }
            },
            {
              "$ref": "#/CustomMenuDataRef--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "Captcha--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "captchaType": {
              "type": "string",
              "enum": [
                "image",
                "audio"
              ],
              "default": "image",
              "description": "When set changes the type of the challenge (image or audio)"
            }
          }
        }
      ],
      "type": "object"
    },
    "CollapsibleTextData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "default": "",
              "maxLength": 120000
            },
            "readMoreText": {
              "type": "string",
              "default": "Read More",
              "maxLength": 1200
            },
            "readLessText": {
              "type": "string",
              "default": "Read Less",
              "maxLength": 1200
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "linkText": {
              "type": "string",
              "default": "Read More",
              "maxLength": 1200
            },
            "textDescription": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "tag": {
              "type": "string",
              "default": "p",
              "maxLength": 31
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "ComboBoxInputData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "dropdownDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "errorDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/SelectableList--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "CustomElement--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tagName": {
              "type": "string",
              "default": "wix-default-custom-element"
            },
            "url": {
              "type": "string",
              "default": "https://static.parastorage.com/services/editor-elements-library/dist/assets/CustomElement/wixDefaultCustomElement.js"
            },
            "hostedInCorvid": {
              "type": "boolean",
              "default": false
            },
            "initialAttributes": {
              "type": "string",
              "default": "{}",
              "maxLength": 4096
            },
            "shouldReload": {
              "type": "boolean",
              "description": "if iframe should be reloaded on initialAttributes change"
            },
            "scriptType": {
              "type": "string",
              "enum": [
                "none",
                "module"
              ],
              "default": "none"
            },
            "appDefinitionId": {
              "type": "string",
              "maxLength": 36
            },
            "widgetId": {
              "type": "string",
              "maxLength": 36
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.FastGallery--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "itemClickAction": {
              "default": "ACTION",
              "enum": [
                "ACTION",
                "LINK",
                "NOTHING"
              ],
              "type": "string"
            },
            "downloadProtection": {
              "default": true,
              "type": "boolean"
            },
            "wixSDKItems": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.HamburgerMenuContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "wixui.HamburgerMenuRoot--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "ImageX--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "image": {
              "type": "object",
              "properties": {
                "uri": {
                  "type": "string",
                  "default": ""
                },
                "alt": {
                  "type": "string",
                  "default": ""
                },
                "name": {
                  "type": "string",
                  "maxLength": 100
                },
                "height": {
                  "type": "number",
                  "default": 200
                },
                "width": {
                  "type": "number",
                  "default": 200
                },
                "decorative": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            },
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "scopedData": {
              "description": "ImageX data per breakpoint",
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "breakpoint": {
                    "type": "string"
                  },
                  "crop": {
                    "$ref": "#/Crop"
                  },
                  "focalPoint": {
                    "$ref": "#/FocalPoint"
                  },
                  "displayMode": {
                    "type": "string",
                    "enum": [
                      "fill",
                      "fit",
                      "fitWidth"
                    ],
                    "default": "fill"
                  },
                  "scrollEffect": {
                    "type": "string",
                    "enum": [
                      "parallax",
                      "fixed",
                      "zoomIn",
                      "fadeIn",
                      "none"
                    ]
                  },
                  "clickAction": {
                    "type": "string",
                    "enum": [
                      "none",
                      "goToLink"
                    ]
                  }
                },
                "unevaluatedProperties": false
              }
            },
            "mask": {
              "type": [
                "object",
                "null"
              ],
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "width": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "height": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "svgId": {
                  "type": "string"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360
                },
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ]
                }
              },
              "unevaluatedProperties": false
            },
            "parallaxSpeed": {
              "type": "number"
            },
            "parallaxDirection": {
              "type": "string",
              "enum": [
                "normal",
                "reverse"
              ]
            },
            "hasAnimation": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "Crop--unrestricted-root": {
      "type": "object",
      "required": [
        "x",
        "y",
        "width",
        "height"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        },
        "width": {
          "type": "number",
          "minimum": 0
        },
        "height": {
          "type": "number",
          "minimum": 0
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "rotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 359,
          "description": "Image rotation degrees"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ],
          "default": "none",
          "description": "Image flip value"
        }
      }
    },
    "FocalPoint--unrestricted-root": {
      "type": "object",
      "required": [
        "x",
        "y"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        }
      }
    },
    "LanguageSelector--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "wixui.MegaMenuContainerItem--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "type": {
              "default": "wixui.MegaMenuContainerItem",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "MenuData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "itemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuItemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "submenuSubItemDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "navAriaLabel": {
                  "type": "string",
                  "maxLength": 1000
                }
              }
            },
            {
              "$ref": "#/CustomMenuDataRef--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "wixui.MenuList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "menus": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "MusicPlayerData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "coverDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "audioRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "audioUrl": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 256
            },
            "playListId": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 255
            },
            "playlist": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "artistName": {
                    "type": "string",
                    "maxLength": 255,
                    "default": "Unknown Artist"
                  },
                  "trackName": {
                    "type": "string",
                    "maxLength": 255,
                    "default": "Unknown Track"
                  },
                  "url": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 2500
                  },
                  "cover": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 2500
                  },
                  "durationFormatted": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "maxLength": 16
                  }
                },
                "unevaluatedProperties": false
              },
              "default": []
            },
            "coverRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "coverUrl": {
              "type": [
                "string",
                "null"
              ]
            },
            "artistName": {
              "type": "string",
              "default": "Unknown Artist",
              "maxLength": 255
            },
            "trackName": {
              "type": "string",
              "default": "Unknown Track",
              "maxLength": 255
            },
            "description": {
              "type": "string",
              "default": "",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "WixAudio--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "title": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "duration": {
              "type": "number"
            }
          }
        }
      ],
      "type": "object"
    },
    "Pagination--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "totalPages": {
              "type": "number",
              "description": "The total number of pages displayed by the component"
            },
            "currentPage": {
              "type": "number",
              "default": 1,
              "description": "The the page number marked as current"
            },
            "nextText": {
              "type": "string",
              "default": "Next",
              "maxLength": 400,
              "description": "Text to appear in NEXT button"
            },
            "previousText": {
              "type": "string",
              "default": "Previous",
              "maxLength": 400,
              "description": "Text to appear in PREVIOUS button"
            },
            "firstText": {
              "type": "string",
              "default": "First",
              "maxLength": 400,
              "description": "Text to appear in FIRST button"
            },
            "lastText": {
              "type": "string",
              "default": "Last",
              "maxLength": 400,
              "description": "Text to appear in LAST button"
            },
            "nextAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the NEXT button"
            },
            "previousAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the PREVIOUS button"
            },
            "firstAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the FIRST button"
            },
            "lastAriaLabel": {
              "type": "string",
              "maxLength": 400,
              "description": "Accessible name for the LAST button"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "PaginationA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "ProgressBar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "number",
              "description": "Current progress value"
            },
            "targetValue": {
              "type": "number",
              "default": 100,
              "description": "Progress target value to be defined as complete"
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "barDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "RatingsDisplay--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "ratingsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "rating": {
              "type": "number",
              "description": "The rating displayed by the component",
              "minimum": 1,
              "maximum": 5
            },
            "svgId": {
              "type": "string",
              "maxLength": 100
            },
            "numRatings": {
              "type": "number",
              "description": "The amount of ratings the rating is based on",
              "minimum": 0
            },
            "reviewsCountLabel": {
              "type": "string",
              "default": "Reviews",
              "maxLength": 400,
              "description": "Text that describes the numRatings value"
            },
            "noReviewsPlaceholder": {
              "type": "string",
              "default": "Be the first to rate this item",
              "maxLength": 1000,
              "description": "Placeholder text when there aren't any reviews"
            }
          }
        }
      ],
      "type": "object"
    },
    "RatingsInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": [
                "number",
                "null"
              ],
              "description": "The rating value currently selected",
              "minimum": 0,
              "maximum": 5
            },
            "titleText": {
              "type": "string",
              "description": "the title before a value is selected",
              "maxLength": 300
            },
            "svgId": {
              "type": "string",
              "description": "the id of the svg that illustrates the rating",
              "maxLength": 100
            },
            "labels": {
              "type": "object",
              "description": "contains the labels for the different values. maps 1-5 as keys to strings",
              "default": {
                "1": "Bad",
                "2": "Fine",
                "3": "OK",
                "4": "Good",
                "5": "Great"
              },
              "additionalProperties": {
                "type": [
                  "string",
                  "number"
                ]
              },
              "unevaluatedProperties": false
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.RichContentViewer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "content": {
              "type": "object",
              "unevaluatedProperties": false
            },
            "trimEnabled": {
              "type": "boolean",
              "default": false
            },
            "trimMode": {
              "type": "string",
              "default": "paragraph",
              "maxLength": 100
            },
            "trimLengthParagraph": {
              "type": "number",
              "default": 3
            },
            "trimLengthWord": {
              "type": "number",
              "default": 10
            },
            "trimExclude": {
              "type": "string",
              "default": "plugins",
              "maxLength": 100
            },
            "trimEllipsisEnabled": {
              "type": "boolean",
              "default": true
            },
            "trimEllipsisExpandText": {
              "type": "string",
              "default": "Show More",
              "maxLength": 1200
            },
            "trimEllipsisCollapseText": {
              "type": "string",
              "default": "Show Less",
              "maxLength": 1200
            }
          }
        }
      ],
      "type": "object"
    },
    "RichTextBox--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "maxLength": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "description": "maximum number of characters allowed"
                },
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "SearchBox--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "placeholder": {
              "type": "string",
              "default": "Search...",
              "maxLength": 255
            },
            "suggestionsEnabled": {
              "type": "boolean",
              "default": true,
              "description": "Determines whether the suggestions disabled or not"
            },
            "clearButtonText": {
              "type": "string",
              "default": "Clear",
              "maxLength": 255
            },
            "displaySettingsToggles": {
              "type": "boolean",
              "default": true,
              "description": "Determines whether the settings toggles are displayed or not"
            }
          }
        }
      ],
      "type": "object"
    },
    "Section--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "SectionA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            },
            "role": {
              "type": "string",
              "enum": [
                "heading",
                "alert",
                "status"
              ]
            },
            "atomic": {
              "type": "boolean"
            },
            "hidden": {
              "type": "boolean"
            },
            "current": {
              "type": "string",
              "enum": [
                "step",
                "page",
                "true",
                "false",
                "location",
                "date",
                "time"
              ]
            },
            "level": {
              "type": "number",
              "minimum": 1,
              "maximum": 6
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.SelectableContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "wixui.SelectableContainerInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "SelectionTagsList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "options": {
              "description": "Array of items which behave like checkboxes and look similar to buttons",
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "value": {
              "description": "Array with the values of the selected options",
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "SelectionTag--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "maxLength": 400
            },
            "label": {
              "type": "string",
              "maxLength": 400
            },
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "rel": {
              "type": "string",
              "enum": [
                "nofollow"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "SignatureInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "titleText": {
              "type": "string",
              "description": "The title of the field",
              "maxLength": 400
            },
            "clearButtonText": {
              "type": "string",
              "description": "The undo signature text",
              "minLength": 1,
              "maxLength": 400
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "buttonDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "radioButtonsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "SiteButtonData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/LinkableButton--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "Slider--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "trackDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "tooltipDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "min": {
              "type": "number",
              "default": 0,
              "description": "Minimum value"
            },
            "max": {
              "type": "number",
              "default": 100,
              "description": "Maximum value"
            },
            "value": {
              "type": "number",
              "default": 50,
              "description": "Current value"
            },
            "step": {
              "type": "number",
              "default": 0,
              "description": "Step value"
            },
            "stepType": {
              "type": "string",
              "default": "value",
              "enum": [
                "value",
                "count"
              ],
              "description": "When set to 'value', step represents the value of each step. When set to 'count', step represents the total steps count"
            },
            "disabled": {
              "type": "boolean",
              "default": false,
              "description": "Determines whether the slider is disabled or not"
            },
            "readOnly": {
              "type": "boolean",
              "default": false,
              "description": "Determines whether the slider is read-only or not"
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "description": "Label text",
              "maxLength": 1200
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.Slideshow--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "type": {
              "default": "wixui.Slideshow",
              "maxLength": 120,
              "type": "string"
            },
            "direction": {
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "SocialAuth--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "StylableButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "label": {
              "type": "string",
              "default": "MY BUTTON",
              "maxLength": 1200
            },
            "svgId": {
              "type": "string",
              "default": "",
              "maxLength": 100
            },
            "isIconAnimated": {
              "type": "boolean"
            },
            "animatedIcon": {
              "type": "object",
              "properties": {
                "svgIdAnimationSelected": {
                  "type": "string",
                  "maxLength": 100
                },
                "customAnimatedIcon": {
                  "type": [
                    "object"
                  ],
                  "properties": {
                    "svgIdAnimationStart": {
                      "type": "string",
                      "maxLength": 100
                    },
                    "svgIdAnimationEnd": {
                      "type": "string",
                      "maxLength": 100
                    },
                    "svgIdAnimationSelected": {
                      "type": "string",
                      "maxLength": 100
                    }
                  },
                  "unevaluatedProperties": false
                },
                "animationDuration": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "StylableButtonA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "pressed": {
              "type": "boolean"
            },
            "expanded": {
              "type": "boolean"
            },
            "disabled": {
              "type": "boolean"
            },
            "haspopup": {
              "type": "string",
              "enum": [
                "true",
                "false",
                "dialog",
                "menu"
              ]
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "live": {
              "type": "string",
              "enum": [
                "polite",
                "assertive"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "Submenu--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "direction"
          ],
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "itemDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "subItemDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "SvgImage--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "svgId"
          ],
          "properties": {
            "decorative": {
              "type": "boolean"
            },
            "alt": {
              "type": "string",
              "description": "Alternative text for the vector image (for accessibility purposes).",
              "maxLength": 120
            },
            "displayMode": {
              "type": "string",
              "enum": [
                "fit",
                "stretch"
              ],
              "description": "should the shape maintain it's aspect ratio or stretch",
              "default": "fit"
            },
            "svgId": {
              "type": "string",
              "maxLength": 100,
              "description": "Identifier for the SVG image."
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            }
          }
        }
      ],
      "type": "object"
    },
    "wixui.Tabs--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabIds": {
              "type": "array",
              "items": {
                "type": "string",
                "maxLength": 120
              }
            },
            "defaultTabId": {
              "type": "string",
              "default": "",
              "maxLength": 120
            },
            "a11y": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "type": "object"
    },
    "TabsA11y--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "tabindex": {
              "type": "number",
              "minimum": -1,
              "maximum": 0
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            }
          }
        }
      ],
      "type": "object"
    },
    "TextEffectsSharedData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 500
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "default": "div"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction",
              "default": "inherit"
            },
            "patternScope": {
              "type": "string",
              "enum": [
                "none",
                "character",
                "word"
              ],
              "default": "none"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextMarqueeData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "items",
            "speed"
          ],
          "properties": {
            "movementDirection": {
              "type": "string",
              "description": "direction the text is moving to",
              "default": "rtl",
              "enum": [
                "rtl",
                "ltr"
              ]
            },
            "speed": {
              "type": "number",
              "description": "speed of the animation in pixels per second"
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "pause animation on hover"
            },
            "textDirection": {
              "type": "string",
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ]
            },
            "headingLevel": {
              "type": "number",
              "maximum": 6,
              "minimum": 0,
              "description": "Heading level to wrap the component (deprecated)"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "description": "Semantic tag name to wrap the component"
            },
            "svgId": {
              "type": "string"
            },
            "items": {
              "default": [],
              "description": "array of marquee items",
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "TextMarqueeItem--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "description": "TextMarquee Item",
          "required": [
            "text"
          ],
          "properties": {
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "text": {
              "type": "string",
              "maxLength": 500
            }
          }
        }
      ],
      "type": "object"
    },
    "TextFxData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "type": "string",
              "maxLength": 450
            },
            "headingLevel": {
              "type": "number",
              "minimum": 0,
              "maximum": 6,
              "description": "Heading level to wrap the component (deprecated)"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "direction": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ],
              "default": "ltr"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "description": "Semantic tag name to wrap the component"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextOnPathData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isDecorative": {
              "type": "boolean"
            },
            "text": {
              "type": "string",
              "description": "text",
              "maxLength": 500
            },
            "path": {
              "type": "string",
              "description": "path"
            },
            "pathLength": {
              "type": "number",
              "description": "Path length"
            },
            "viewBox": {
              "type": "string",
              "description": "View box"
            },
            "speed": {
              "type": "number",
              "description": "Speed",
              "default": 3
            },
            "movementDirection": {
              "type": "string",
              "description": "Direction the text is moving to",
              "default": "forward",
              "enum": [
                "forward",
                "reverse"
              ]
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "Pause animation on hover"
            },
            "direction": {
              "type": "string",
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ]
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div"
              ],
              "description": "Semantic tag name to wrap the component"
            },
            "fillMode": {
              "type": "string",
              "enum": [
                "normal",
                "repeat",
                "justify"
              ],
              "default": "normal",
              "description": "How the text should be rendered on the path"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference",
              "description": "Reference to a link associated with the vector image."
            },
            "startOffset": {
              "type": "number",
              "description": "Starting point of the text on the path",
              "minimum": 0,
              "maximum": 100
            },
            "fontSize": {
              "type": "number",
              "description": "Font size as a number in percent",
              "minimum": 0,
              "maximum": 100
            },
            "pathStrokeWidth": {
              "type": "number",
              "description": "Width of the path stroke in em units",
              "minimum": 0,
              "maximum": 3
            }
          }
        }
      ],
      "type": "object"
    },
    "TextParticlesData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "text": {
              "default": "TextParticles",
              "maxLength": 500,
              "type": "string"
            },
            "textDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction",
              "default": "inherit"
            },
            "tagName": {
              "type": "string",
              "enum": [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "div",
                "p"
              ],
              "default": "div"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "isDecorative": {
              "type": "boolean"
            },
            "pauseOnHover": {
              "type": "boolean",
              "description": "pause animation on hover",
              "default": true
            }
          }
        }
      ],
      "type": "object"
    },
    "TimePickerData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "labelDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "inputDirection": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                },
                "placeholder": {
                  "type": "string",
                  "description": "The value of the placeholder if chosen",
                  "maxLength": 1000
                },
                "step": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 60,
                  "default": 1,
                  "description": "Increment step in minutes"
                },
                "label": {
                  "type": "string",
                  "maxLength": 1000
                },
                "margin": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 30,
                  "description": "Time picker layout label margin"
                },
                "disabledTimes": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "additionalProperties": false,
                    "required": [
                      "startTime",
                      "endTime"
                    ],
                    "properties": {
                      "startTime": {
                        "type": "string",
                        "maxLength": 100
                      },
                      "endTime": {
                        "type": "string",
                        "maxLength": 100
                      }
                    },
                    "unevaluatedProperties": false
                  },
                  "default": [],
                  "maxItems": 5,
                  "description": "array of disabled times"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ToggleSwitch--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "properties": {
                "checked": {
                  "type": "boolean",
                  "description": "The checked status of the input"
                },
                "direction": {
                  "type": [
                    "string"
                  ],
                  "enum": [
                    "ltr",
                    "rtl",
                    "inherit"
                  ],
                  "description": "direction"
                }
              }
            },
            {
              "$ref": "#/BaseTextInput--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "UnsupportedComponentData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "migratedFrom": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "VideoPlayer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "videoType": {
              "type": "string",
              "enum": [
                "dailymotion",
                "facebook",
                "file",
                "twitch",
                "vimeo",
                "youtube"
              ],
              "default": "file"
            },
            "videoRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            },
            "videoUrl": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 256
            },
            "posterUrl": {
              "type": [
                "string",
                "null"
              ]
            },
            "videoTitle": {
              "type": "string",
              "default": "",
              "maxLength": 255
            },
            "description": {
              "type": "string",
              "default": "",
              "maxLength": 1000,
              "description": "Video Description"
            },
            "logoRef": {
              "$ref": "urn:dm:schemas:common.json#/nullableReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.ControlTypes--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "shortString": {
              "default": "ShortString",
              "maxLength": 120,
              "type": "string"
            },
            "longString": {
              "default": "LongString",
              "maxLength": 1200,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "dropdown": {
              "default": "Options 1",
              "enum": [
                "Options 1",
                "Options 2",
                "Options 3",
                "Options 4"
              ],
              "type": "string"
            },
            "radioButtons": {
              "default": "Options 1",
              "enum": [
                "Options 1",
                "Options 2",
                "Options 3",
                "Options 4"
              ],
              "type": "string"
            },
            "toggleSwitch": {
              "default": false,
              "type": "boolean"
            },
            "thumbnails": {
              "$ref": "#/SVGReference"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "slider": {
              "default": 1,
              "minimum": 0,
              "maximum": 2,
              "type": "number",
              "multipleOf": 1
            },
            "numericInput": {
              "default": 0,
              "type": "number"
            },
            "colorPickerInput": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "selectedFont": {
              "default": "arial",
              "maxLength": 1200,
              "format": "font-family",
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label"
          ],
          "type": "object",
          "properties": {
            "label": {
              "default": "Save",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Light",
                "Destructive",
                "Premium",
                "Premium light",
                "Dark",
                "Transparent"
              ],
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "priority": {
              "default": "Primary",
              "enum": [
                "Primary",
                "Secondary"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardHeading--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Add Page title H1",
              "maxLength": 1200,
              "type": "string"
            },
            "size": {
              "default": "Page title H1",
              "enum": [
                "Page title H1",
                "Modal title H2",
                "Card title H3",
                "Section title H4",
                "Card section title H5",
                "Caption H6"
              ],
              "type": "string"
            },
            "invertColor": {
              "default": false,
              "type": "boolean"
            },
            "textAlignment": {
              "default": "Left",
              "enum": [
                "Left",
                "Center",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardIconButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "icon": {
              "$ref": "#/SVGReference"
            },
            "tooltip": {
              "default": "More Actions",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Premium",
                "Light",
                "Transparent"
              ],
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "priority": {
              "default": "Secondary",
              "enum": [
                "Primary",
                "Secondary"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardInfoIcon--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "tooltip": {
              "default": "This message explains the purpose of a feature.",
              "maxLength": 1200,
              "type": "string"
            },
            "addLink": {
              "default": false,
              "type": "boolean"
            },
            "tooltipLinkText": {
              "default": "Learn more",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipLink": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Event name",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Enter your event name...",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "prefixValue": {
              "default": "Units",
              "maxLength": 120,
              "type": "string"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixValue": {
              "default": ".com",
              "maxLength": 120,
              "type": "string"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "setMaxLength": {
              "default": false,
              "type": "boolean"
            },
            "maxLength": {
              "default": 20,
              "type": "number",
              "multipleOf": 1
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "border": {
              "default": "Default",
              "enum": [
                "Default",
                "Round",
                "Line",
                "None"
              ],
              "type": "string"
            },
            "labelPosition": {
              "default": "Top",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardNumberInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Number of tickets",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Enter a number...",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": 25,
              "type": "number",
              "multipleOf": 1
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "prefixValue": {
              "default": "Units",
              "maxLength": 120,
              "type": "string"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixType": {
              "default": "Icon",
              "enum": [
                "Icon",
                "Text"
              ],
              "type": "string"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixValue": {
              "default": "%",
              "maxLength": 120,
              "type": "string"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "minAndMaxValues": {
              "default": false,
              "type": "boolean"
            },
            "min": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "max": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepSize": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "border": {
              "default": "Default",
              "enum": [
                "Default",
                "Round",
                "Line",
                "None"
              ],
              "type": "string"
            },
            "labelPlacement": {
              "default": "Top",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "I’m a paragraph. Add your own text and edit me in settings. It’s easy.",
              "maxLength": 1200,
              "type": "string"
            },
            "preset": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Standard secondary",
                "Light",
                "Light secondary",
                "Success",
                "Destructive",
                "Primary",
                "Premium",
                "Disabled"
              ],
              "type": "string"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "Thin",
              "enum": [
                "Bold",
                "Normal",
                "Thin"
              ],
              "type": "string"
            },
            "textAlignment": {
              "default": "Left",
              "enum": [
                "Left",
                "Center",
                "Right"
              ],
              "type": "string"
            },
            "overflow": {
              "default": "Wrap",
              "enum": [
                "Wrap",
                "Ellipsis"
              ],
              "type": "string"
            },
            "maxLines": {
              "default": 1,
              "minimum": 1,
              "type": "number",
              "multipleOf": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardTextButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "View All",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Premium",
                "Light",
                "Dark",
                "Destructive"
              ],
              "type": "string"
            },
            "showPrefix": {
              "default": false,
              "type": "boolean"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "showSuffix": {
              "default": false,
              "type": "boolean"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "underline": {
              "default": "Never",
              "enum": [
                "Never",
                "On hover",
                "Always"
              ],
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Medium",
              "enum": [
                "Tiny",
                "Small",
                "Medium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "Regular",
              "enum": [
                "Regular",
                "Medium"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.DashboardToggleSwitch--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Set a reminder",
              "maxLength": 120,
              "type": "string"
            },
            "checked": {
              "default": true,
              "type": "boolean"
            },
            "skin": {
              "default": "Standard",
              "enum": [
                "Standard",
                "Success",
                "Destructive"
              ],
              "type": "string"
            },
            "showTooltip": {
              "default": false,
              "type": "boolean"
            },
            "tooltip": {
              "default": "This message explains the purpose of a field.",
              "maxLength": 1200,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "size": {
              "default": "Large",
              "enum": [
                "Small",
                "Medium",
                "Large"
              ],
              "type": "string"
            },
            "labelPosition": {
              "default": "Right",
              "enum": [
                "Top",
                "Left",
                "Right"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.SettingsPanelContainer--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "theme": {
              "default": "classic",
              "enum": [
                "classic",
                "responsive"
              ],
              "type": "string"
            },
            "debug": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuAccordion--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Label Example",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "openByDefault": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuBackButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Back",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "label": {
              "default": "Button",
              "maxLength": 120,
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "standard secondary",
                "premium",
                "premium secondary",
                "alert",
                "alert secondary",
                "inverted"
              ],
              "type": "string"
            },
            "size": {
              "default": "medium",
              "enum": [
                "small",
                "medium",
                "large"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "fullWidth": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuCheckboxGroup--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Multiple Choices",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuColorPicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Opacity & Color",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "opacity": {
              "default": 100,
              "minimum": 0,
              "maximum": 100,
              "type": "number",
              "multipleOf": 1
            },
            "showPercentage": {
              "default": true,
              "type": "boolean"
            },
            "opacitySliderEnabled": {
              "default": true,
              "type": "boolean"
            },
            "color": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuColorSelector--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Color Selector",
              "maxLength": 120,
              "type": "string"
            },
            "color": {
              "default": "#EEE",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuColumnControllerControl--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Column controller",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "enableReorder": {
              "default": true,
              "type": "boolean"
            },
            "minimumValue": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "dividerType": {
              "default": "none",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            },
            "columns": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuDatePicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Choose a Date",
              "maxLength": 120,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuDrillDown--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Label Title",
              "maxLength": 120,
              "type": "string"
            },
            "description": {
              "default": "This is a description text",
              "maxLength": 1200,
              "type": "string"
            },
            "iconType": {
              "default": "None",
              "enum": [
                "None",
                "Info",
                "Alert"
              ],
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuDropdown--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Dropdown",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Choose an option",
              "maxLength": 120,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuEmptyState--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Link to Lightbox",
              "maxLength": 120,
              "type": "string"
            },
            "description": {
              "default": "Create your own lightboxes and link to them for any place in your site.",
              "maxLength": 1200,
              "type": "string"
            },
            "textButtonLabel": {
              "default": "Start Creating",
              "maxLength": 120,
              "type": "string"
            },
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuFontAndColorPicker--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Pick Font and Color",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "font": {
              "default": "arial",
              "maxLength": 1200,
              "format": "font-family",
              "type": "string"
            },
            "color": {
              "default": "#FFC233",
              "maxLength": 120000,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuHorizontalTabs--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "tabsStyle": {
              "default": "Folder",
              "enum": [
                "Folder",
                "Arrowed",
                "Arrowed Without a Line"
              ],
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "maxVisibleTabs": {
              "default": 3,
              "minimum": 1,
              "maximum": 10,
              "type": "number",
              "multipleOf": 1
            },
            "tabsToScroll": {
              "default": 3,
              "minimum": 1,
              "maximum": 10,
              "type": "number",
              "multipleOf": 1
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuLeftTextButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "Text Button",
              "maxLength": 120,
              "type": "string"
            },
            "url": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "size": {
              "default": "medium",
              "enum": [
                "tiny",
                "small",
                "medium"
              ],
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "premium"
              ],
              "type": "string"
            },
            "weight": {
              "default": "normal",
              "enum": [
                "thin",
                "normal"
              ],
              "type": "string"
            },
            "prefixIcon": {
              "$ref": "#/SVGReference"
            },
            "suffixIcon": {
              "$ref": "#/SVGReference"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuMultilineTextInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltip": {
              "default": "",
              "maxLength": 120000,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "placeholder": {
              "default": "Write text here...",
              "maxLength": 1200,
              "type": "string"
            },
            "maxLength": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "closeOnEnterKeyPress": {
              "default": false,
              "type": "boolean"
            },
            "autoFocus": {
              "default": false,
              "type": "boolean"
            },
            "selectTextOnFocus": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "usePatternValidation": {
              "default": false,
              "type": "boolean"
            },
            "regexPattern": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "validationMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuNotificationBanner--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "skin": {
              "default": "standard",
              "enum": [
                "standard",
                "premium",
                "alert",
                "success"
              ],
              "type": "string"
            },
            "linkText": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "linkUrl": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "iconTooltipText": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "multiline": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuNumericInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "title": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": 0,
              "type": "number"
            },
            "unitSuffix": {
              "default": "None",
              "enum": [
                "None",
                "Pixels",
                "Percentage",
                "Degrees"
              ],
              "type": "string"
            },
            "numberOfFractions": {
              "default": 2,
              "minimum": 0,
              "maximum": 2,
              "type": "number",
              "multipleOf": 1
            },
            "steps": {
              "default": 1,
              "minimum": 1,
              "maximum": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepControls": {
              "default": false,
              "type": "boolean"
            },
            "minValue": {
              "default": 0,
              "type": "number"
            },
            "maxValue": {
              "default": 100,
              "type": "number"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuRadioButtonGroup--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Radio Buttons",
              "maxLength": 120,
              "type": "string"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuRichText--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "richTextContent": {
              "default": "Your placeholder text goes here. Write, style and link it.",
              "maxLength": 120000,
              "type": "string"
            },
            "richTextLabel": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "link": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/LinkReference"
            },
            "richTextLink": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "alignTextToCenter": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuSectionDivider--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "sectionTitle": {
              "default": "Section Divider",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuSlider--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Slider",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "unitOfMeasurement": {
              "default": "number",
              "enum": [
                "number",
                "percentage",
                "pixels",
                "angle"
              ],
              "type": "string"
            },
            "defaultSelectedValue": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "minimumValue": {
              "default": 0,
              "type": "number",
              "multipleOf": 1
            },
            "maximumValue": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "stepValue": {
              "default": 1,
              "type": "number",
              "multipleOf": 1
            },
            "showNumericInput": {
              "default": true,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuTextInput--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Text Input",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "defaultText": {
              "default": "Write it here...",
              "maxLength": 120,
              "type": "string"
            },
            "placeholder": {
              "default": "Placeholder text",
              "maxLength": 120,
              "type": "string"
            },
            "prefix": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "autofocus": {
              "default": false,
              "type": "boolean"
            },
            "selectedOnFocus": {
              "default": true,
              "type": "boolean"
            },
            "charactersLimit": {
              "default": 100,
              "type": "number",
              "multipleOf": 1
            },
            "usePatternValidation": {
              "default": false,
              "type": "boolean"
            },
            "regexPattern": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "errorMessage": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuThumbnails--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "options"
          ],
          "type": "object",
          "properties": {
            "fieldTitle": {
              "default": "Field Title",
              "maxLength": 120,
              "type": "string"
            },
            "tooltipInfo": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            },
            "setNumberOfColumns": {
              "default": 3,
              "minimum": 1,
              "maximum": 5,
              "type": "number",
              "multipleOf": 1
            },
            "showEmptyThumbnail": {
              "default": false,
              "type": "boolean"
            },
            "thumbnailHeight": {
              "default": "Fixed ratio (1:1)",
              "enum": [
                "Fixed ratio (1:1)",
                "Fluid"
              ],
              "type": "string"
            },
            "displayLabels": {
              "default": true,
              "type": "boolean"
            },
            "options": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "ThumbnailItemData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "label",
            "value"
          ],
          "type": "object",
          "properties": {
            "label": {
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "maxLength": 120,
              "type": "string"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "isDefault": {
              "default": false,
              "type": "boolean"
            },
            "unavailable": {
              "default": false,
              "type": "boolean"
            },
            "illustration": {
              "$ref": "#/SVGReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WbuToggleSwitch--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "label": {
              "default": "Toggle Switch",
              "maxLength": 120,
              "type": "string"
            },
            "toggleSwitch": {
              "default": true,
              "type": "boolean"
            },
            "disabled": {
              "default": false,
              "type": "boolean"
            },
            "divider": {
              "default": "long",
              "enum": [
                "long",
                "short",
                "none"
              ],
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WutAvatar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "firstName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "lastName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "src": {
              "default": "",
              "maxLength": 1200,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WutAvatarGroup--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "maxAvatars": {
              "default": 5,
              "minimum": 1,
              "type": "number",
              "multipleOf": 1
            },
            "showHiddenAvatarCount": {
              "default": true,
              "type": "boolean"
            },
            "avatars": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WutBadge--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [],
          "type": "object",
          "properties": {
            "text": {
              "default": "My Badge",
              "maxLength": 120,
              "type": "string"
            },
            "icon": {
              "$ref": "#/SVGReference"
            },
            "composition": {
              "default": "TextAndIcon",
              "enum": [
                "TextAndIcon",
                "Text",
                "Icon",
                "None"
              ],
              "type": "string"
            },
            "alt": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "dsgnsys.WutRadioButton--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "required": [
            "value"
          ],
          "type": "object",
          "properties": {
            "radioGroupName": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "value": {
              "default": "",
              "maxLength": 120,
              "type": "string"
            },
            "checked": {
              "default": false,
              "type": "boolean"
            },
            "required": {
              "default": false,
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "naming.json": {
    "$id": "urn:dm:schemas:naming.json",
    "naming": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "name"
          ],
          "properties": {
            "name": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "naming--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "name"
          ],
          "properties": {
            "name": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "notifications.json": {
    "$id": "urn:dm:schemas:notifications.json",
    "Notifications": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "type": "array",
              "items": {
                "type": "object",
                "anyOf": [
                  {
                    "$ref": "#/SectionsFixer--unrestricted-root"
                  },
                  {
                    "$ref": "#/PinToSticky--unrestricted-root"
                  }
                ],
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SectionsFixer": {
      "type": "object",
      "properties": {
        "fixedPages": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 50
          }
        },
        "type": {
          "type": "string",
          "enum": [
            "SectionsFixer"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "PinToSticky": {
      "type": "object",
      "required": [],
      "properties": {
        "sticky": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 0,
          "default": 0
        },
        "pinned": {
          "type": "number",
          "minimum": 0,
          "default": 0
        },
        "masterVertical": {
          "type": "number",
          "minimum": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "PinToSticky"
          ]
        }
      },
      "unevaluatedProperties": false
    },
    "Notifications--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "items": {
              "type": "array",
              "items": {
                "type": "object",
                "anyOf": [
                  {
                    "$ref": "#/SectionsFixer--unrestricted-root"
                  },
                  {
                    "$ref": "#/PinToSticky--unrestricted-root"
                  }
                ],
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "type": "object"
    },
    "SectionsFixer--unrestricted-root": {
      "type": "object",
      "properties": {
        "fixedPages": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 50
          }
        },
        "type": {
          "type": "string",
          "enum": [
            "SectionsFixer"
          ]
        }
      }
    },
    "PinToSticky--unrestricted-root": {
      "type": "object",
      "required": [],
      "properties": {
        "sticky": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 0,
          "default": 0
        },
        "pinned": {
          "type": "number",
          "minimum": 0,
          "default": 0
        },
        "masterVertical": {
          "type": "number",
          "minimum": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "PinToSticky"
          ]
        }
      }
    }
  },
  "pageSections.json": {
    "$id": "urn:dm:schemas:pageSections.json",
    "pageSections": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isSectionsEnabled": {
              "type": "boolean"
            },
            "isMigratedFromAdi": {
              "type": "boolean",
              "default": false
            },
            "preserveEditorFontsOrder": {
              "type": "boolean",
              "default": false
            },
            "migrationVersion": {
              "type": "string",
              "maxLength": 20
            },
            "migrationSkipCount": {
              "type": "number"
            },
            "sections": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string"
                  },
                  "contentRole": {
                    "type": "string"
                  },
                  "children": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "pageSections--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "isSectionsEnabled": {
              "type": "boolean"
            },
            "isMigratedFromAdi": {
              "type": "boolean",
              "default": false
            },
            "preserveEditorFontsOrder": {
              "type": "boolean",
              "default": false
            },
            "migrationVersion": {
              "type": "string",
              "maxLength": 20
            },
            "migrationSkipCount": {
              "type": "number"
            },
            "sections": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string"
                  },
                  "contentRole": {
                    "type": "string"
                  },
                  "children": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  }
                },
                "unevaluatedProperties": false
              }
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "patterns.json": {
    "$id": "urn:dm:schemas:patterns.json",
    "Pattern": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "items"
          ],
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "NthChild": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "offset",
            "variant"
          ],
          "properties": {
            "repeat": {
              "type": "number",
              "multipleOf": 1,
              "minimum": 0,
              "default": 0
            },
            "offset": {
              "type": "number",
              "multipleOf": 1
            },
            "variant": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Pattern--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "items"
          ],
          "properties": {
            "items": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "NthChild--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "offset",
            "variant"
          ],
          "properties": {
            "repeat": {
              "type": "number",
              "multipleOf": 1,
              "minimum": 0,
              "default": 0
            },
            "offset": {
              "type": "number",
              "multipleOf": 1
            },
            "variant": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "presets.json": {
    "$id": "urn:dm:schemas:presets.json",
    "PresetData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "layout",
            "style"
          ],
          "properties": {
            "layout": {
              "type": "string",
              "maxLength": 100
            },
            "style": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "PresetData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "layout",
            "style"
          ],
          "properties": {
            "layout": {
              "type": "string",
              "maxLength": 100
            },
            "style": {
              "type": "string",
              "maxLength": 100
            }
          }
        }
      ],
      "type": "object"
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    }
  },
  "reactions.json": {
    "$id": "urn:dm:schemas:reactions.json",
    "Reactions": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "values"
          ],
          "properties": {
            "values": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BaseStateReaction": {
      "type": "object",
      "required": [
        "state"
      ],
      "properties": {
        "presetKey": {
          "type": "string",
          "maxLength": 100
        },
        "state": {
          "$ref": "urn:dm:schemas:common.json#/weakReference"
        }
      },
      "unevaluatedProperties": false
    },
    "ToggleState": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/BaseStateReaction--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RemoveState": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/BaseStateReaction--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AddState": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/BaseStateReaction--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RemoveAllStates": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ScrollForward": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ScrollBackward": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Play": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "effect"
          ],
          "properties": {
            "effect": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            },
            "once": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TogglePlay": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "effect"
          ],
          "properties": {
            "effect": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Scrub": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "effect"
          ],
          "properties": {
            "effect": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "Reactions--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "values"
          ],
          "properties": {
            "values": {
              "default": [],
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "BaseStateReaction--unrestricted-root": {
      "type": "object",
      "required": [
        "state"
      ],
      "properties": {
        "presetKey": {
          "type": "string",
          "maxLength": 100
        },
        "state": {
          "$ref": "urn:dm:schemas:common.json#/weakReference"
        }
      }
    },
    "ToggleState--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/BaseStateReaction--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RemoveState--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/BaseStateReaction--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "AddState--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/BaseStateReaction--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "RemoveAllStates--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "ScrollForward--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "ScrollBackward--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {}
        }
      ],
      "type": "object"
    },
    "Play--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "effect"
          ],
          "properties": {
            "effect": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            },
            "once": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "TogglePlay--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "effect"
          ],
          "properties": {
            "effect": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "Scrub--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "effect"
          ],
          "properties": {
            "effect": {
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            }
          }
        }
      ],
      "type": "object"
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    }
  },
  "slots.json": {
    "$id": "urn:dm:schemas:slots.json",
    "PlaceholderSlot": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "slots": {
              "type": "object",
              "properties": {
                "slot": {
                  "$ref": "#/SlotRef"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DynamicSlots": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "slots": {
              "type": "object",
              "additionalProperties": {
                "$ref": "#/SlotRef"
              },
              "properties": {},
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SlotRef": {
      "$ref": "urn:dm:schemas:common.json#/weakReference"
    },
    "PlaceholderSlot--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "slots": {
              "type": "object",
              "properties": {
                "slot": {
                  "$ref": "#/SlotRef"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "DynamicSlots--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "slots": {
              "type": "object",
              "additionalProperties": {
                "$ref": "#/SlotRef"
              },
              "properties": {},
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "SlotRef--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/weakReference"
    }
  },
  "source.json": {
    "$id": "urn:dm:schemas:source.json",
    "Source": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "original": {
              "$ref": "#/SourceEnumType"
            },
            "current": {
              "$ref": "#/SourceEnumType"
            },
            "changed": {
              "type": "boolean",
              "default": false
            },
            "ai_semantics": {
              "type": "string",
              "maxLength": 4000,
              "description": "experimental field to add context for AI. This field is only for use within a POC for AI and may be removed. It should not be relied on in production"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SourceEnumType": {
      "type": "string",
      "enum": [
        "template",
        "preset",
        "user",
        "application",
        "translation",
        "caas",
        "ai"
      ]
    },
    "Source--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "original": {
              "$ref": "#/SourceEnumType"
            },
            "current": {
              "$ref": "#/SourceEnumType"
            },
            "changed": {
              "type": "boolean",
              "default": false
            },
            "ai_semantics": {
              "type": "string",
              "maxLength": 4000,
              "description": "experimental field to add context for AI. This field is only for use within a POC for AI and may be removed. It should not be relied on in production"
            }
          }
        }
      ],
      "type": "object"
    },
    "SourceEnumType--unrestricted-root": {
      "type": "string",
      "enum": [
        "template",
        "preset",
        "user",
        "application",
        "translation",
        "caas",
        "ai"
      ]
    }
  },
  "states.json": {
    "$id": "urn:dm:schemas:states.json",
    "States": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "values"
          ],
          "properties": {
            "values": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "States--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "values"
          ],
          "properties": {
            "values": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "structure.json": {
    "$id": "urn:dm:schemas:structure.json",
    "DesignQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "DataQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "PropertyQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "VariantsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StyleId": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "MobileHintsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BehaviorQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ConnectionQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ControllersQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "LayoutQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AnchorQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BreakpointVariantsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransformationQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransitionQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "Bindings": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContextsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ModesDefinition": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeId",
              "type"
            ],
            "properties": {
              "label": {
                "type": "string"
              },
              "modeId": {
                "type": "string"
              },
              "params": {
                "type": "string"
              },
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": {
                    "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                  }
                },
                "unevaluatedProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "unevaluatedProperties": false
          }
        },
        "isHiddenByModes": {
          "type": "boolean"
        },
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeIds"
            ],
            "properties": {
              "isHiddenByModes": {
                "type": "boolean"
              },
              "modeIds": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "layout": {
                "$ref": "#/LayoutObjectForComponents"
              },
              "designQuery": {
                "$ref": "#/DesignQuery"
              },
              "propertyQuery": {
                "$ref": "#/PropertyQuery"
              },
              "styleId": {
                "$ref": "#/StyleId"
              }
            },
            "unevaluatedProperties": false
          }
        }
      },
      "unevaluatedProperties": false
    },
    "AnchorDefinition": {
      "type": "object",
      "properties": {
        "distance": {
          "type": "number",
          "default": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": {
          "type": "boolean",
          "default": false
        },
        "targetComponent": {
          "type": "string"
        }
      },
      "unevaluatedProperties": false
    },
    "PartialLayoutObjectForMasterPage": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      },
      "unevaluatedProperties": false
    },
    "DockingUnitSize": {
      "type": "object",
      "properties": {
        "px": {
          "type": "number"
        },
        "pct": {
          "type": "number"
        },
        "vw": {
          "type": "number"
        },
        "vh": {
          "type": "number"
        }
      },
      "unevaluatedProperties": false
    },
    "DockingDefinition": {
      "type": "object",
      "properties": {
        "left": {
          "$ref": "#/DockingUnitSize"
        },
        "right": {
          "$ref": "#/DockingUnitSize"
        },
        "top": {
          "$ref": "#/DockingUnitSize"
        },
        "bottom": {
          "$ref": "#/DockingUnitSize"
        },
        "hCenter": {
          "$ref": "#/DockingUnitSize"
        },
        "vCenter": {
          "$ref": "#/DockingUnitSize"
        }
      },
      "unevaluatedProperties": false
    },
    "BaseComponentObject": {
      "type": "object",
      "required": [
        "id",
        "type"
      ],
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "unevaluatedProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "$ref": "#/Parent"
        }
      },
      "unevaluatedProperties": false
    },
    "MetaDataForComponents": {
      "type": "object",
      "properties": {},
      "unevaluatedProperties": false
    },
    "LayoutObjectForComponents": {
      "type": "object",
      "properties": {
        "x": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "y": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "width": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "height": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "rotationInDegrees": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "fixedPosition": {
          "type": "boolean"
        },
        "scale": {
          "type": "number"
        },
        "docked": {
          "$ref": "#/DockingDefinition"
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      },
      "unevaluatedProperties": false
    },
    "ShouldReallyBeAnIntAtSomePoint": {
      "type": "number",
      "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
      "default": 0,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "ComponentsList": {
      "uniqueItems": true,
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "Component": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/BaseComponentObject--unrestricted-root"
        },
        {
          "$ref": "#/ComponentQueries--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentType"
          ],
          "properties": {
            "componentType": {
              "type": "string"
            },
            "skin": {
              "type": "string"
            },
            "modes": {
              "$ref": "#/ModesDefinition"
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "ComponentQueries": {
      "type": "object",
      "properties": {
        "dataQuery": {
          "$ref": "#/DataQuery"
        },
        "propertyQuery": {
          "$ref": "#/PropertyQuery"
        },
        "designQuery": {
          "$ref": "#/DesignQuery"
        },
        "mobileHintsQuery": {
          "$ref": "#/MobileHintsQuery"
        },
        "behaviorQuery": {
          "$ref": "#/BehaviorQuery"
        },
        "connectionQuery": {
          "$ref": "#/ConnectionQuery"
        },
        "controllersQuery": {
          "$ref": "#/ControllersQuery"
        },
        "layoutQuery": {
          "$ref": "#/LayoutQuery"
        },
        "anchorQuery": {
          "$ref": "#/AnchorQuery"
        },
        "breakpointVariantsQuery": {
          "$ref": "#/BreakpointVariantsQuery"
        },
        "transformationQuery": {
          "$ref": "#/TransformationQuery"
        },
        "transitionQuery": {
          "$ref": "#/TransitionQuery"
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "bindings": {
          "$ref": "#/Bindings"
        },
        "styleId": {
          "$ref": "#/StyleId"
        },
        "layout": {
          "$ref": "#/LayoutObjectForComponents"
        },
        "accessibilityQuery": {
          "$ref": "#/AccessibilityQuery"
        },
        "classnamesQuery": {
          "$ref": "#/ClassnamesQuery"
        },
        "contentRoleQuery": {
          "$ref": "#/ContentRoleQuery"
        },
        "cursorQuery": {
          "$ref": "#/CursorQuery"
        },
        "discussionsQuery": {
          "$ref": "#/DiscussionsQuery"
        },
        "editorsettingsQuery": {
          "$ref": "#/EditorsettingsQuery"
        },
        "effectsQuery": {
          "$ref": "#/EffectsQuery"
        },
        "groupingQuery": {
          "$ref": "#/GroupingQuery"
        },
        "innerElementsQuery": {
          "$ref": "#/InnerElementsQuery"
        },
        "intentQuery": {
          "$ref": "#/IntentQuery"
        },
        "layoutSettingsQuery": {
          "$ref": "#/LayoutSettingsQuery"
        },
        "manifestQuery": {
          "$ref": "#/ManifestQuery"
        },
        "measurementsQuery": {
          "$ref": "#/MeasurementsQuery"
        },
        "migrationQuery": {
          "$ref": "#/MigrationQuery"
        },
        "namingQuery": {
          "$ref": "#/NamingQuery"
        },
        "notificationsQuery": {
          "$ref": "#/NotificationsQuery"
        },
        "pageSectionsQuery": {
          "$ref": "#/PageSectionsQuery"
        },
        "presetsQuery": {
          "$ref": "#/PresetsQuery"
        },
        "reactionsQuery": {
          "$ref": "#/ReactionsQuery"
        },
        "slotsQuery": {
          "$ref": "#/SlotsQuery"
        },
        "sourceQuery": {
          "$ref": "#/SourceQuery"
        },
        "statesQuery": {
          "$ref": "#/StatesQuery"
        },
        "triggersQuery": {
          "$ref": "#/TriggersQuery"
        },
        "variablesQuery": {
          "$ref": "#/VariablesQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "RefComponent": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "RepeaterContainer": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/RepeaterQueries--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "RepeaterVariantsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "RepeaterQueries": {
      "type": "object",
      "properties": {
        "variantsQuery": {
          "$ref": "#/RepeaterVariantsQuery"
        },
        "patternsQuery": {
          "$ref": "#/PatternsQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "ContainerQueries": {
      "type": "object",
      "properties": {
        "contexts": {
          "$ref": "#/ContextsQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "Container": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "$ref": "#/ContainerQueries--unrestricted-root"
        },
        {
          "required": [
            "components"
          ],
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ],
      "unevaluatedProperties": false
    },
    "PageQueries": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "Page": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/PageQueries--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "DocumentProperties": {
      "type": "object",
      "required": [
        "documentType",
        "components"
      ],
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "$ref": "#/PartialLayoutObjectForMasterPage"
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        },
        "themeConfigQuery": {
          "$ref": "#/ThemeConfigQuery"
        }
      },
      "unevaluatedProperties": false
    },
    "Document": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/DocumentProperties--unrestricted-root"
        }
      ],
      "unevaluatedProperties": false
    },
    "Parent": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AccessibilityQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ClassnamesQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContentRoleQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "CursorQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "DiscussionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EditorsettingsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EffectsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "FixerVersionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "GroupingQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "InnerElementsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "IntentQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "LayoutSettingsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ManifestQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MeasurementsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MigrationQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NamingQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NotificationsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PageSectionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PatternsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PresetsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ReactionsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SlotsQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SourceQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StatesQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ThemeConfigQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "TriggersQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "VariablesQuery": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "DesignQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "DataQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "PropertyQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "VariantsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StyleId--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "MobileHintsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BehaviorQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ConnectionQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "ControllersQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "LayoutQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AnchorQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "BreakpointVariantsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransformationQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "TransitionQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "Bindings--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContextsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ModesDefinition--unrestricted-root": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeId",
              "type"
            ],
            "properties": {
              "label": {
                "type": "string"
              },
              "modeId": {
                "type": "string"
              },
              "params": {
                "type": "string"
              },
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": {
                    "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
                  }
                },
                "unevaluatedProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "unevaluatedProperties": false
          }
        },
        "isHiddenByModes": {
          "type": "boolean"
        },
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeIds"
            ],
            "properties": {
              "isHiddenByModes": {
                "type": "boolean"
              },
              "modeIds": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "layout": {
                "$ref": "#/LayoutObjectForComponents"
              },
              "designQuery": {
                "$ref": "#/DesignQuery"
              },
              "propertyQuery": {
                "$ref": "#/PropertyQuery"
              },
              "styleId": {
                "$ref": "#/StyleId"
              }
            },
            "unevaluatedProperties": false
          }
        }
      }
    },
    "AnchorDefinition--unrestricted-root": {
      "type": "object",
      "properties": {
        "distance": {
          "type": "number",
          "default": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": {
          "type": "boolean",
          "default": false
        },
        "targetComponent": {
          "type": "string"
        }
      }
    },
    "PartialLayoutObjectForMasterPage--unrestricted-root": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      }
    },
    "DockingUnitSize--unrestricted-root": {
      "type": "object",
      "properties": {
        "px": {
          "type": "number"
        },
        "pct": {
          "type": "number"
        },
        "vw": {
          "type": "number"
        },
        "vh": {
          "type": "number"
        }
      }
    },
    "DockingDefinition--unrestricted-root": {
      "type": "object",
      "properties": {
        "left": {
          "$ref": "#/DockingUnitSize"
        },
        "right": {
          "$ref": "#/DockingUnitSize"
        },
        "top": {
          "$ref": "#/DockingUnitSize"
        },
        "bottom": {
          "$ref": "#/DockingUnitSize"
        },
        "hCenter": {
          "$ref": "#/DockingUnitSize"
        },
        "vCenter": {
          "$ref": "#/DockingUnitSize"
        }
      }
    },
    "BaseComponentObject--unrestricted-root": {
      "type": "object",
      "required": [
        "id",
        "type"
      ],
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "unevaluatedProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "$ref": "#/Parent"
        }
      }
    },
    "MetaDataForComponents--unrestricted-root": {
      "type": "object",
      "properties": {}
    },
    "LayoutObjectForComponents--unrestricted-root": {
      "type": "object",
      "properties": {
        "x": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "y": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint"
        },
        "width": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "height": {
          "$ref": "#/ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "rotationInDegrees": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "fixedPosition": {
          "type": "boolean"
        },
        "scale": {
          "type": "number"
        },
        "docked": {
          "$ref": "#/DockingDefinition"
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "#/AnchorDefinition"
          }
        }
      }
    },
    "ShouldReallyBeAnIntAtSomePoint--unrestricted-root": {
      "type": "number",
      "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
      "default": 0,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "ComponentsList--unrestricted-root": {
      "uniqueItems": true,
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "Component--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/BaseComponentObject--unrestricted-root"
        },
        {
          "$ref": "#/ComponentQueries--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentType"
          ],
          "properties": {
            "componentType": {
              "type": "string"
            },
            "skin": {
              "type": "string"
            },
            "modes": {
              "$ref": "#/ModesDefinition"
            }
          }
        }
      ]
    },
    "ComponentQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "dataQuery": {
          "$ref": "#/DataQuery"
        },
        "propertyQuery": {
          "$ref": "#/PropertyQuery"
        },
        "designQuery": {
          "$ref": "#/DesignQuery"
        },
        "mobileHintsQuery": {
          "$ref": "#/MobileHintsQuery"
        },
        "behaviorQuery": {
          "$ref": "#/BehaviorQuery"
        },
        "connectionQuery": {
          "$ref": "#/ConnectionQuery"
        },
        "controllersQuery": {
          "$ref": "#/ControllersQuery"
        },
        "layoutQuery": {
          "$ref": "#/LayoutQuery"
        },
        "anchorQuery": {
          "$ref": "#/AnchorQuery"
        },
        "breakpointVariantsQuery": {
          "$ref": "#/BreakpointVariantsQuery"
        },
        "transformationQuery": {
          "$ref": "#/TransformationQuery"
        },
        "transitionQuery": {
          "$ref": "#/TransitionQuery"
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "bindings": {
          "$ref": "#/Bindings"
        },
        "styleId": {
          "$ref": "#/StyleId"
        },
        "layout": {
          "$ref": "#/LayoutObjectForComponents"
        },
        "accessibilityQuery": {
          "$ref": "#/AccessibilityQuery"
        },
        "classnamesQuery": {
          "$ref": "#/ClassnamesQuery"
        },
        "contentRoleQuery": {
          "$ref": "#/ContentRoleQuery"
        },
        "cursorQuery": {
          "$ref": "#/CursorQuery"
        },
        "discussionsQuery": {
          "$ref": "#/DiscussionsQuery"
        },
        "editorsettingsQuery": {
          "$ref": "#/EditorsettingsQuery"
        },
        "effectsQuery": {
          "$ref": "#/EffectsQuery"
        },
        "groupingQuery": {
          "$ref": "#/GroupingQuery"
        },
        "innerElementsQuery": {
          "$ref": "#/InnerElementsQuery"
        },
        "intentQuery": {
          "$ref": "#/IntentQuery"
        },
        "layoutSettingsQuery": {
          "$ref": "#/LayoutSettingsQuery"
        },
        "manifestQuery": {
          "$ref": "#/ManifestQuery"
        },
        "measurementsQuery": {
          "$ref": "#/MeasurementsQuery"
        },
        "migrationQuery": {
          "$ref": "#/MigrationQuery"
        },
        "namingQuery": {
          "$ref": "#/NamingQuery"
        },
        "notificationsQuery": {
          "$ref": "#/NotificationsQuery"
        },
        "pageSectionsQuery": {
          "$ref": "#/PageSectionsQuery"
        },
        "presetsQuery": {
          "$ref": "#/PresetsQuery"
        },
        "reactionsQuery": {
          "$ref": "#/ReactionsQuery"
        },
        "slotsQuery": {
          "$ref": "#/SlotsQuery"
        },
        "sourceQuery": {
          "$ref": "#/SourceQuery"
        },
        "statesQuery": {
          "$ref": "#/StatesQuery"
        },
        "triggersQuery": {
          "$ref": "#/TriggersQuery"
        },
        "variablesQuery": {
          "$ref": "#/VariablesQuery"
        }
      }
    },
    "RefComponent--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ]
    },
    "RepeaterContainer--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/RepeaterQueries--unrestricted-root"
        }
      ]
    },
    "RepeaterVariantsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "RepeaterQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "variantsQuery": {
          "$ref": "#/RepeaterVariantsQuery"
        },
        "patternsQuery": {
          "$ref": "#/PatternsQuery"
        }
      }
    },
    "ContainerQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "contexts": {
          "$ref": "#/ContextsQuery"
        }
      }
    },
    "Container--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Component--unrestricted-root"
        },
        {
          "$ref": "#/ContainerQueries--unrestricted-root"
        },
        {
          "required": [
            "components"
          ],
          "properties": {
            "components": {
              "$ref": "#/ComponentsList"
            }
          }
        }
      ]
    },
    "PageQueries--unrestricted-root": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        }
      }
    },
    "Page--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/PageQueries--unrestricted-root"
        }
      ]
    },
    "DocumentProperties--unrestricted-root": {
      "type": "object",
      "required": [
        "documentType",
        "components"
      ],
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "$ref": "#/PartialLayoutObjectForMasterPage"
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "unevaluatedProperties": false
        },
        "variantsQuery": {
          "$ref": "#/VariantsQuery"
        },
        "fixerVersionsQuery": {
          "$ref": "#/FixerVersionsQuery"
        },
        "themeConfigQuery": {
          "$ref": "#/ThemeConfigQuery"
        }
      }
    },
    "Document--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/Container--unrestricted-root"
        },
        {
          "$ref": "#/DocumentProperties--unrestricted-root"
        }
      ]
    },
    "Parent--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableWeakReference"
    },
    "AccessibilityQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ClassnamesQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ContentRoleQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "CursorQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "DiscussionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EditorsettingsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "EffectsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "FixerVersionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "GroupingQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "InnerElementsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "IntentQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "LayoutSettingsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ManifestQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MeasurementsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "MigrationQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NamingQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "NotificationsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PageSectionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PatternsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "PresetsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ReactionsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SlotsQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "SourceQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "StatesQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "ThemeConfigQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "TriggersQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    },
    "VariablesQuery--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/nullableReference"
    }
  },
  "themeConfig.json": {
    "$id": "urn:dm:schemas:themeConfig.json",
    "themeConfig": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "colorMapping": {
              "patternProperties": {
                "^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$": {
                  "type": "string",
                  "pattern": "^$|^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$|__empty__"
                }
              },
              "unevaluatedProperties": false,
              "type": "object"
            },
            "colorNaming": {
              "propertyNames": {
                "type": "string",
                "maxLength": 100
              },
              "additionalProperties": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "order": {
                    "type": "number",
                    "default": 0
                  },
                  "hidden": {
                    "type": "boolean"
                  }
                }
              },
              "unevaluatedProperties": false,
              "type": "object"
            },
            "fontNaming": {
              "patternProperties": {
                "^font_([0-9]|10)$": {
                  "type": "object",
                  "properties": {
                    "name": {
                      "type": "string",
                      "maxLength": 100
                    },
                    "order": {
                      "type": "number",
                      "default": 0
                    },
                    "hidden": {
                      "type": "boolean"
                    }
                  }
                }
              },
              "unevaluatedProperties": false,
              "type": "object"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "themeConfig--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "colorMapping": {
              "patternProperties": {
                "^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$": {
                  "type": "string",
                  "pattern": "^$|^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$|__empty__"
                }
              },
              "unevaluatedProperties": false,
              "type": "object"
            },
            "colorNaming": {
              "propertyNames": {
                "type": "string",
                "maxLength": 100
              },
              "additionalProperties": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "order": {
                    "type": "number",
                    "default": 0
                  },
                  "hidden": {
                    "type": "boolean"
                  }
                }
              },
              "unevaluatedProperties": false,
              "type": "object"
            },
            "fontNaming": {
              "patternProperties": {
                "^font_([0-9]|10)$": {
                  "type": "object",
                  "properties": {
                    "name": {
                      "type": "string",
                      "maxLength": 100
                    },
                    "order": {
                      "type": "number",
                      "default": 0
                    },
                    "hidden": {
                      "type": "boolean"
                    }
                  }
                }
              },
              "unevaluatedProperties": false,
              "type": "object"
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "theme_data.json": {
    "$id": "urn:dm:schemas:theme_data.json",
    "WFlatTheme": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "BG_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "CONTACT_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "NETWORKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "EXTERNAL_LINKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "PAGES_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "WEB_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "BASE_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "siteBg": {
              "type": "string",
              "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
            },
            "color": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/nullableColor"
              },
              "default": [
                "#000000",
                "#000000",
                "#FFFFFF",
                "#FF0000",
                "#00FF00",
                "#0000FF",
                "#333333",
                "#666666",
                "#999999",
                "#AAAAAA",
                "#DCDCDC",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF"
              ]
            },
            "font": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/nullableFont"
              },
              "default": [
                "normal normal normal 24px/1.2em Arial {color_5}",
                "normal normal bold 16px/1.1em Arial {color_5}",
                "italic normal bold 18px/1.1em Lobster {color_5}",
                "normal normal bold 22px/1.1em Arial {color_5}",
                "normal normal bold 20px/1.1em Arial {color_5}",
                "normal normal normal 18px/1.3em Arial {color_5}",
                "normal normal normal 16px/1.2em Arial {color_6}",
                "normal normal normal 14px/1.3em Arial {color_6}",
                "normal normal normal 12px/1.3em Arial {color_6}",
                "normal normal normal 10px/1.3em Arial {color_6}",
                "normal normal normal 8px/1.3em Arial {color_6}"
              ]
            },
            "textTheme": {
              "type": "array",
              "items": {
                "$ref": "#/TextTheme"
              },
              "default": [
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "24px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.2em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "bold",
                  "fontSize": "16px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.1em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "italic",
                  "fontVariant": "normal",
                  "fontWeight": "bold",
                  "fontSize": "18px",
                  "fontFamily": "Lobster",
                  "lineHeight": "1.1em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "bold",
                  "fontSize": "22px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.1em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "bold",
                  "fontSize": "20px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.1em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "18px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.3em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "16px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.2em",
                  "color": "{color_6}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "14px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.3em",
                  "color": "{color_6}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "12px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.3em",
                  "color": "{color_6}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "10px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.3em",
                  "color": "{color_6}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "8px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.3em",
                  "color": "{color_6}",
                  "letterSpacing": "0em"
                }
              ]
            },
            "theme": {
              "$ref": "#/OverridableTheme"
            },
            "fontDisplay": {
              "type": "string",
              "enum": [
                "auto",
                "block",
                "swap",
                "fallback",
                "optional"
              ],
              "description": "font-display css property. The default is 'block' in the viewer rendering"
            },
            "border": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/nullableBorder"
              },
              "default": [
                "0.15em solid [color_0]",
                "0.15em solid [color_0]",
                "0.15em solid [color_0]"
              ]
            },
            "padding1": {
              "default": "0 0 0 0",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding2": {
              "default": "0.0em 0.5em 0.0em 0.5em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding3": {
              "default": "1.0em 0.0em 1.0em 0.0em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "iconSize": {
              "default": "3.2",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "bulletSize": {
              "default": "1.5",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "headerSpacing": {
              "default": "0em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "componentSpacing": {
              "default": "0.45em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "itemSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "thumbSpacing": {
              "default": "0.23em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "iconSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "mobileBg": {
              "type": "string",
              "default": "[siteBg]"
            },
            "themePresets": {
              "type": [
                "object",
                "null"
              ],
              "properties": {
                "mobileBg": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "OverridableTheme": {
      "type": "object",
      "properties": {
        "spx": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/SPXReferenceDefinition"
        }
      },
      "unevaluatedProperties": false
    },
    "TextTheme": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/TextThemeWithDefaults--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "fontStyle",
            "fontWeight",
            "fontVariant",
            "fontSize",
            "lineHeight",
            "fontFamily"
          ]
        }
      ],
      "unevaluatedProperties": false
    },
    "FontStyle": {
      "type": "string",
      "enum": [
        "normal",
        "italic"
      ]
    },
    "FontSize": {
      "$ref": "urn:dm:schemas:common.json#/cssMeasureWithUnit"
    },
    "FontWeight": {
      "type": "string",
      "enum": [
        "normal",
        "bold",
        "bolder",
        "lighter",
        "100",
        "200",
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900"
      ]
    },
    "FontVariant": {
      "type": "string",
      "enum": [
        "normal",
        "small-caps",
        "inherit"
      ]
    },
    "FontFamily": {
      "type": "string",
      "format": "font-family"
    },
    "TextColor": {
      "$ref": "urn:dm:schemas:common.json#/color"
    },
    "LineHeight": {
      "$ref": "urn:dm:schemas:common.json#/cssMeasureWithUnit"
    },
    "LetterSpacing": {
      "$ref": "urn:dm:schemas:common.json#/cssMeasureWithUnit"
    },
    "PartialTextTheme": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "fontStyle": {
          "$ref": "#/FontStyle"
        },
        "fontWeight": {
          "$ref": "#/FontWeight"
        },
        "fontVariant": {
          "$ref": "#/FontVariant"
        },
        "fontSize": {
          "$ref": "#/FontSize"
        },
        "maxFontSize": {
          "$ref": "#/FontSize"
        },
        "minFontSize": {
          "$ref": "#/FontSize"
        },
        "scale_maxFontSize": {
          "$ref": "#/FontSize"
        },
        "scale_minFontSize": {
          "$ref": "#/FontSize"
        },
        "fontFamily": {
          "$ref": "#/FontFamily"
        },
        "color": {
          "$ref": "#/TextColor"
        },
        "lineHeight": {
          "$ref": "#/LineHeight"
        },
        "letterSpacing": {
          "$ref": "#/LetterSpacing"
        }
      },
      "unevaluatedProperties": false
    },
    "TextThemeWithDefaults": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "fontStyle": {
          "$ref": "#/FontStyle",
          "default": "normal"
        },
        "fontWeight": {
          "$ref": "#/FontWeight",
          "default": "normal"
        },
        "fontVariant": {
          "$ref": "#/FontVariant",
          "default": "normal"
        },
        "fontSize": {
          "$ref": "#/FontSize",
          "default": "60px"
        },
        "minFontSize": {
          "$ref": "#/FontSize"
        },
        "maxFontSize": {
          "$ref": "#/FontSize"
        },
        "scale_maxFontSize": {
          "$ref": "#/FontSize"
        },
        "scale_minFontSize": {
          "$ref": "#/FontSize"
        },
        "fontFamily": {
          "$ref": "#/FontFamily",
          "default": "proxima-n-w01-reg"
        },
        "color": {
          "$ref": "#/TextColor",
          "default": "{color_15}"
        },
        "lineHeight": {
          "$ref": "#/LineHeight",
          "default": "normal"
        },
        "letterSpacing": {
          "$ref": "#/LetterSpacing",
          "default": "normal"
        }
      },
      "unevaluatedProperties": false
    },
    "TopLevelStyle": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/StyleObjectDefinition--unrestricted-root"
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ComponentStyle": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/StyleObjectDefinition--unrestricted-root"
            },
            {
              "properties": {
                "styleType": {
                  "type": "string",
                  "enum": [
                    "custom"
                  ],
                  "description": "style type for custom styles",
                  "default": "custom"
                },
                "spx": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/SPXReferenceDefinition"
                },
                "themeOverrides": {
                  "$ref": "#/OverridableTheme"
                }
              }
            }
          ]
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GlobalStylesCollection": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "styles": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GlobalStyle": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "styleType"
          ],
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 100
            },
            "styleType": {
              "type": "string",
              "maxLength": 200
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            },
            "innerElementStyles": {
              "type": "object",
              "additionalProperties": {
                "type": "array",
                "items": {
                  "type": "array",
                  "minItems": 1,
                  "maxItems": 20,
                  "items": {
                    "type": "string"
                  }
                },
                "maxItems": 20
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "StyleObjectDefinition": {
      "type": "object",
      "properties": {
        "skin": {
          "type": "string"
        },
        "style": {
          "type": "object",
          "properties": {
            "properties": {
              "type": "object",
              "default": {},
              "additionalProperties": true,
              "unevaluatedProperties": false
            },
            "background": {
              "type": "object",
              "properties": {
                "gradient": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/ColorLayers"
                }
              },
              "unevaluatedProperties": false
            },
            "propertiesSource": {
              "type": "object",
              "additionalProperties": {
                "type": "string",
                "enum": [
                  "theme",
                  "value"
                ]
              },
              "default": {},
              "unevaluatedProperties": false
            },
            "groups": {
              "type": "object",
              "additionalProperties": true,
              "unevaluatedProperties": false
            },
            "propertiesOverride": {
              "type": "object",
              "additionalProperties": {
                "$ref": "#/PartialTextTheme"
              },
              "properties": {},
              "unevaluatedProperties": false
            }
          },
          "unevaluatedProperties": false
        },
        "styleType": {
          "type": "string",
          "enum": [
            "system",
            "custom",
            "userDefined"
          ],
          "description": "type of the style, defaults to custom",
          "default": "custom"
        },
        "pageId": {
          "type": "string",
          "description": "for custom styles - id of the page where the component is"
        },
        "compId": {
          "type": "string",
          "description": "for custom styles - id of the component that has the custom style"
        },
        "componentClassName": {
          "type": "string",
          "description": "class name of the component type this style applies to"
        }
      },
      "unevaluatedProperties": false
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "GradientLinearLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientLinearLayer"
    },
    "GradientCircleLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientCircleLayer"
    },
    "GradientEllipseLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientEllipseLayer"
    },
    "GradientMeshLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientMeshLayer"
    },
    "GradientConicLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientConicLayer"
    },
    "SolidColorLayer": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/SolidColorLayer"
    },
    "WFlatTheme--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "BG_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "CONTACT_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "NETWORKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "EXTERNAL_LINKS_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "PAGES_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/themeUrl"
            },
            "WEB_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "BASE_THEME_DIRECTORY": {
              "default": "base",
              "$ref": "urn:dm:schemas:common.json#/webThemeUrl"
            },
            "siteBg": {
              "type": "string",
              "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
            },
            "color": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/nullableColor"
              },
              "default": [
                "#000000",
                "#000000",
                "#FFFFFF",
                "#FF0000",
                "#00FF00",
                "#0000FF",
                "#333333",
                "#666666",
                "#999999",
                "#AAAAAA",
                "#DCDCDC",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF"
              ]
            },
            "font": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/nullableFont"
              },
              "default": [
                "normal normal normal 24px/1.2em Arial {color_5}",
                "normal normal bold 16px/1.1em Arial {color_5}",
                "italic normal bold 18px/1.1em Lobster {color_5}",
                "normal normal bold 22px/1.1em Arial {color_5}",
                "normal normal bold 20px/1.1em Arial {color_5}",
                "normal normal normal 18px/1.3em Arial {color_5}",
                "normal normal normal 16px/1.2em Arial {color_6}",
                "normal normal normal 14px/1.3em Arial {color_6}",
                "normal normal normal 12px/1.3em Arial {color_6}",
                "normal normal normal 10px/1.3em Arial {color_6}",
                "normal normal normal 8px/1.3em Arial {color_6}"
              ]
            },
            "textTheme": {
              "type": "array",
              "items": {
                "$ref": "#/TextTheme"
              },
              "default": [
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "24px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.2em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "bold",
                  "fontSize": "16px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.1em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "italic",
                  "fontVariant": "normal",
                  "fontWeight": "bold",
                  "fontSize": "18px",
                  "fontFamily": "Lobster",
                  "lineHeight": "1.1em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "bold",
                  "fontSize": "22px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.1em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "bold",
                  "fontSize": "20px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.1em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "18px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.3em",
                  "color": "{color_5}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "16px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.2em",
                  "color": "{color_6}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "14px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.3em",
                  "color": "{color_6}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "12px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.3em",
                  "color": "{color_6}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "10px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.3em",
                  "color": "{color_6}",
                  "letterSpacing": "0em"
                },
                {
                  "fontStyle": "normal",
                  "fontVariant": "normal",
                  "fontWeight": "normal",
                  "fontSize": "8px",
                  "fontFamily": "Arial",
                  "lineHeight": "1.3em",
                  "color": "{color_6}",
                  "letterSpacing": "0em"
                }
              ]
            },
            "theme": {
              "$ref": "#/OverridableTheme"
            },
            "fontDisplay": {
              "type": "string",
              "enum": [
                "auto",
                "block",
                "swap",
                "fallback",
                "optional"
              ],
              "description": "font-display css property. The default is 'block' in the viewer rendering"
            },
            "border": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/nullableBorder"
              },
              "default": [
                "0.15em solid [color_0]",
                "0.15em solid [color_0]",
                "0.15em solid [color_0]"
              ]
            },
            "padding1": {
              "default": "0 0 0 0",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding2": {
              "default": "0.0em 0.5em 0.0em 0.5em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "padding3": {
              "default": "1.0em 0.0em 1.0em 0.0em",
              "$ref": "urn:dm:schemas:common.json#/padding"
            },
            "iconSize": {
              "default": "3.2",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "bulletSize": {
              "default": "1.5",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "headerSpacing": {
              "default": "0em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "componentSpacing": {
              "default": "0.45em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "itemSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "thumbSpacing": {
              "default": "0.23em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "iconSpacing": {
              "default": "0.75em",
              "$ref": "urn:dm:schemas:common.json#/cssMeasure"
            },
            "mobileBg": {
              "type": "string",
              "default": "[siteBg]"
            },
            "themePresets": {
              "type": [
                "object",
                "null"
              ],
              "properties": {
                "mobileBg": {
                  "type": "boolean"
                }
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "OverridableTheme--unrestricted-root": {
      "type": "object",
      "properties": {
        "spx": {
          "$ref": "urn:dm:schemas:commonSchemas.json#/SPXReferenceDefinition"
        }
      }
    },
    "TextTheme--unrestricted-root": {
      "type": "object",
      "allOf": [
        {
          "$ref": "#/TextThemeWithDefaults--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "fontStyle",
            "fontWeight",
            "fontVariant",
            "fontSize",
            "lineHeight",
            "fontFamily"
          ]
        }
      ]
    },
    "FontStyle--unrestricted-root": {
      "type": "string",
      "enum": [
        "normal",
        "italic"
      ]
    },
    "FontSize--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/cssMeasureWithUnit"
    },
    "FontWeight--unrestricted-root": {
      "type": "string",
      "enum": [
        "normal",
        "bold",
        "bolder",
        "lighter",
        "100",
        "200",
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900"
      ]
    },
    "FontVariant--unrestricted-root": {
      "type": "string",
      "enum": [
        "normal",
        "small-caps",
        "inherit"
      ]
    },
    "FontFamily--unrestricted-root": {
      "type": "string",
      "format": "font-family"
    },
    "TextColor--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/color"
    },
    "LineHeight--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/cssMeasureWithUnit"
    },
    "LetterSpacing--unrestricted-root": {
      "$ref": "urn:dm:schemas:common.json#/cssMeasureWithUnit"
    },
    "PartialTextTheme--unrestricted-root": {
      "type": "object",
      "properties": {
        "fontStyle": {
          "$ref": "#/FontStyle"
        },
        "fontWeight": {
          "$ref": "#/FontWeight"
        },
        "fontVariant": {
          "$ref": "#/FontVariant"
        },
        "fontSize": {
          "$ref": "#/FontSize"
        },
        "maxFontSize": {
          "$ref": "#/FontSize"
        },
        "minFontSize": {
          "$ref": "#/FontSize"
        },
        "scale_maxFontSize": {
          "$ref": "#/FontSize"
        },
        "scale_minFontSize": {
          "$ref": "#/FontSize"
        },
        "fontFamily": {
          "$ref": "#/FontFamily"
        },
        "color": {
          "$ref": "#/TextColor"
        },
        "lineHeight": {
          "$ref": "#/LineHeight"
        },
        "letterSpacing": {
          "$ref": "#/LetterSpacing"
        }
      }
    },
    "TextThemeWithDefaults--unrestricted-root": {
      "type": "object",
      "properties": {
        "fontStyle": {
          "$ref": "#/FontStyle",
          "default": "normal"
        },
        "fontWeight": {
          "$ref": "#/FontWeight",
          "default": "normal"
        },
        "fontVariant": {
          "$ref": "#/FontVariant",
          "default": "normal"
        },
        "fontSize": {
          "$ref": "#/FontSize",
          "default": "60px"
        },
        "minFontSize": {
          "$ref": "#/FontSize"
        },
        "maxFontSize": {
          "$ref": "#/FontSize"
        },
        "scale_maxFontSize": {
          "$ref": "#/FontSize"
        },
        "scale_minFontSize": {
          "$ref": "#/FontSize"
        },
        "fontFamily": {
          "$ref": "#/FontFamily",
          "default": "proxima-n-w01-reg"
        },
        "color": {
          "$ref": "#/TextColor",
          "default": "{color_15}"
        },
        "lineHeight": {
          "$ref": "#/LineHeight",
          "default": "normal"
        },
        "letterSpacing": {
          "$ref": "#/LetterSpacing",
          "default": "normal"
        }
      }
    },
    "TopLevelStyle--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/StyleObjectDefinition--unrestricted-root"
            }
          ]
        }
      ],
      "type": "object"
    },
    "ComponentStyle--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "allOf": [
            {
              "$ref": "#/StyleObjectDefinition--unrestricted-root"
            },
            {
              "properties": {
                "styleType": {
                  "type": "string",
                  "enum": [
                    "custom"
                  ],
                  "description": "style type for custom styles",
                  "default": "custom"
                },
                "spx": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/SPXReferenceDefinition"
                },
                "themeOverrides": {
                  "$ref": "#/OverridableTheme"
                }
              }
            }
          ]
        }
      ],
      "type": "object"
    },
    "GlobalStylesCollection--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "styles": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "GlobalStyle--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "styleType"
          ],
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 100
            },
            "styleType": {
              "type": "string",
              "maxLength": 200
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            },
            "innerElementStyles": {
              "type": "object",
              "additionalProperties": {
                "type": "array",
                "items": {
                  "type": "array",
                  "minItems": 1,
                  "maxItems": 20,
                  "items": {
                    "type": "string"
                  }
                },
                "maxItems": 20
              },
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "StyleObjectDefinition--unrestricted-root": {
      "type": "object",
      "properties": {
        "skin": {
          "type": "string"
        },
        "style": {
          "type": "object",
          "properties": {
            "properties": {
              "type": "object",
              "default": {},
              "additionalProperties": true,
              "unevaluatedProperties": false
            },
            "background": {
              "type": "object",
              "properties": {
                "gradient": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/ColorLayers"
                }
              },
              "unevaluatedProperties": false
            },
            "propertiesSource": {
              "type": "object",
              "additionalProperties": {
                "type": "string",
                "enum": [
                  "theme",
                  "value"
                ]
              },
              "default": {},
              "unevaluatedProperties": false
            },
            "groups": {
              "type": "object",
              "additionalProperties": true,
              "unevaluatedProperties": false
            },
            "propertiesOverride": {
              "type": "object",
              "additionalProperties": {
                "$ref": "#/PartialTextTheme"
              },
              "properties": {},
              "unevaluatedProperties": false
            }
          },
          "unevaluatedProperties": false
        },
        "styleType": {
          "type": "string",
          "enum": [
            "system",
            "custom",
            "userDefined"
          ],
          "description": "type of the style, defaults to custom",
          "default": "custom"
        },
        "pageId": {
          "type": "string",
          "description": "for custom styles - id of the page where the component is"
        },
        "compId": {
          "type": "string",
          "description": "for custom styles - id of the component that has the custom style"
        },
        "componentClassName": {
          "type": "string",
          "description": "class name of the component type this style applies to"
        }
      }
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "GradientLinearLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientLinearLayer"
    },
    "GradientCircleLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientCircleLayer"
    },
    "GradientEllipseLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientEllipseLayer"
    },
    "GradientMeshLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientMeshLayer"
    },
    "GradientConicLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/GradientConicLayer"
    },
    "SolidColorLayer--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/SolidColorLayer"
    }
  },
  "transformations_data.json": {
    "$id": "urn:dm:schemas:transformations_data.json",
    "TransformData": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:translate\\/x|translate\\/y|origin\\/x|origin\\/y)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:translate\\/x|translate\\/y|origin\\/x|origin\\/y)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "scale": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "number"
                },
                "y": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "rotate": {
              "type": "number"
            },
            "translate": {
              "type": "object",
              "properties": {
                "x": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                },
                "y": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                }
              },
              "unevaluatedProperties": false
            },
            "skew": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "number"
                },
                "y": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "origin": {
              "type": "object",
              "properties": {
                "x": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                },
                "y": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                }
              },
              "unevaluatedProperties": false
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "hidden": {
              "type": "boolean"
            },
            "zLayer": {
              "type": "string",
              "enum": [
                "BELOW_PINNED",
                "ABOVE_PINNED",
                "ABOVE_ALL_COMPS"
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "TransformData--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:translate\\/x|translate\\/y|origin\\/x|origin\\/y)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:translate\\/x|translate\\/y|origin\\/x|origin\\/y)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "scale": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "number"
                },
                "y": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "rotate": {
              "type": "number"
            },
            "translate": {
              "type": "object",
              "properties": {
                "x": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                },
                "y": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                }
              },
              "unevaluatedProperties": false
            },
            "skew": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "number"
                },
                "y": {
                  "type": "number"
                }
              },
              "unevaluatedProperties": false
            },
            "origin": {
              "type": "object",
              "properties": {
                "x": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                },
                "y": {
                  "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
                }
              },
              "unevaluatedProperties": false
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "hidden": {
              "type": "boolean"
            },
            "zLayer": {
              "type": "string",
              "enum": [
                "BELOW_PINNED",
                "ABOVE_PINNED",
                "ABOVE_ALL_COMPS"
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    }
  },
  "transitions_data.json": {
    "$id": "urn:dm:schemas:transitions_data.json",
    "TransitionData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "timing-function"
          ],
          "properties": {
            "timing-function": {
              "oneOf": [
                {
                  "type": "string",
                  "enum": [
                    "ease",
                    "linear",
                    "ease-in",
                    "ease-out",
                    "ease-in-out"
                  ]
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "params"
                  ],
                  "properties": {
                    "type": {
                      "type": "string",
                      "enum": [
                        "cubic-bezier"
                      ],
                      "description": "cubic bazier timing function"
                    },
                    "params": {
                      "type": "array",
                      "default": [],
                      "items": {
                        "type": "number"
                      }
                    }
                  }
                }
              ],
              "description": "the placeholder option in case nothing is selected"
            },
            "duration": {
              "type": "number",
              "default": 0
            },
            "delay": {
              "type": "number",
              "default": 0
            },
            "viewPortThreshold": {
              "type": "number",
              "exclusiveMinimum": 0,
              "maximum": 1
            },
            "isLegacyCrossFade": {
              "type": "boolean"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "TransitionData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "timing-function"
          ],
          "properties": {
            "timing-function": {
              "oneOf": [
                {
                  "type": "string",
                  "enum": [
                    "ease",
                    "linear",
                    "ease-in",
                    "ease-out",
                    "ease-in-out"
                  ]
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "params"
                  ],
                  "properties": {
                    "type": {
                      "type": "string",
                      "enum": [
                        "cubic-bezier"
                      ],
                      "description": "cubic bazier timing function"
                    },
                    "params": {
                      "type": "array",
                      "default": [],
                      "items": {
                        "type": "number"
                      }
                    }
                  }
                }
              ],
              "description": "the placeholder option in case nothing is selected"
            },
            "duration": {
              "type": "number",
              "default": 0
            },
            "delay": {
              "type": "number",
              "default": 0
            },
            "viewPortThreshold": {
              "type": "number",
              "exclusiveMinimum": 0,
              "maximum": 1
            },
            "isLegacyCrossFade": {
              "type": "boolean"
            }
          }
        }
      ],
      "type": "object"
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    }
  },
  "triggers.json": {
    "$id": "urn:dm:schemas:triggers.json",
    "Triggers": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "values"
          ],
          "properties": {
            "values": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Triggers--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "values"
          ],
          "properties": {
            "values": {
              "type": "array",
              "items": {
                "$ref": "urn:dm:schemas:common.json#/weakReference"
              },
              "default": []
            }
          }
        }
      ],
      "type": "object"
    }
  },
  "variables.json": {
    "$id": "urn:dm:schemas:variables.json",
    "VariablesList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "variables"
          ],
          "properties": {
            "variables": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "UnitSizeVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "UnitSizeValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "NumberVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "NumberValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ItemsAlignmentVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ItemsAlignmentValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/ItemsAlignment"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "JustifyContentVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "JustifyContentValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/JustifyContent"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PositionTypeVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PositionTypeValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/PositionType"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LayoutSizeVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LayoutSizeValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/LayoutSize"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "HeightVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "HeightValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/Height"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "KeywordLengthVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "KeywordLengthValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/KeywordLength"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "NumVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "NumValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LengthVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LengthValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PositiveLengthVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PositiveLengthValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AngleVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "AngleValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Angle"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ColorVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "ColorValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PercentageVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PercentageValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderEdgeStyleVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderEdgeStyleValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderTopStyle"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderEdgeWidthVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderEdgeWidthValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderTopWidth"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderWidthVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderWidthValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderWidth"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderStyleVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderStyleValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderStyle"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderColorVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderColorValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderColor"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Border"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderCornerRadiusVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderCornerRadiusValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderTopLeftRadius"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderRadiusVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BorderRadiusValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderRadius"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Font"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontSizeVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontSizeValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontSize"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontStretchVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontStretchValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontStretch"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontStyleVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontStyleValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontStyle"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontVariantVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontVariantValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontVariant"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontWeightVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontWeightValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontWeight"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontFamilyVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FontFamilyValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontFamily"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LineHeightVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LineHeightValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LineHeight"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LetterSpacingVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "LetterSpacingValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LetterSpacing"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextAlignVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextAlignValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextAlign"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextTransformVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextTransformValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextTransform"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextShadowVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextShadowValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextShadow"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextDecorationVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextDecorationValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecoration"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextDecorationLineVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextDecorationLineValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecorationLine"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextDecorationStyleVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextDecorationStyleValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecorationStyle"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextDecorationThicknessVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextDecorationThicknessValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecorationThickness"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextIndentVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "TextIndentValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextIndent"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PaddingVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PaddingValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Padding"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PaddingEdgeVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "PaddingEdgeValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PaddingTop"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MarginVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MarginValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Margin"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MarginEdgeVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "MarginEdgeValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.MarginTop"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BoxShadowVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BoxShadowValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BoxShadow"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "OpacityVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "OpacityValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Opacity"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CssJustifyContentVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "CssJustifyContentValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.JustifyContent"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BackgroundVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BackgroundValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Background"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WritingModeVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "WritingModeValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.WritingMode"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DisplayVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "DisplayValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Display"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FilterVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "FilterValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Filter"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GapVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "GapValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Gap"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SingleValueGapVar": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "SingleValueGapValue": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.SingleValueGap"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RefArray": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    },
    "VariablesList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "variables"
          ],
          "properties": {
            "variables": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "UnitSizeVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "UnitSizeValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/UnitSize"
            }
          }
        }
      ],
      "type": "object"
    },
    "NumberVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "NumberValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:commonSchemas.json#/NumberThatCanConnectToAVariable"
            }
          }
        }
      ],
      "type": "object"
    },
    "ItemsAlignmentVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "ItemsAlignmentValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/ItemsAlignment"
            }
          }
        }
      ],
      "type": "object"
    },
    "JustifyContentVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "JustifyContentValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/JustifyContent"
            }
          }
        }
      ],
      "type": "object"
    },
    "PositionTypeVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "PositionTypeValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/PositionType"
            }
          }
        }
      ],
      "type": "object"
    },
    "LayoutSizeVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LayoutSizeValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/LayoutSize"
            }
          }
        }
      ],
      "type": "object"
    },
    "HeightVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "HeightValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/Height"
            }
          }
        }
      ],
      "type": "object"
    },
    "KeywordLengthVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "KeywordLengthValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:layout_data.json#/KeywordLength"
            }
          }
        }
      ],
      "type": "object"
    },
    "NumVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "NumValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
            }
          }
        }
      ],
      "type": "object"
    },
    "LengthVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LengthValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
            }
          }
        }
      ],
      "type": "object"
    },
    "PositiveLengthVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "PositiveLengthValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            }
          }
        }
      ],
      "type": "object"
    },
    "AngleVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "AngleValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Angle"
            }
          }
        }
      ],
      "type": "object"
    },
    "ColorVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "ColorValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
            }
          }
        }
      ],
      "type": "object"
    },
    "PercentageVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "PercentageValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderEdgeStyleVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderEdgeStyleValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderTopStyle"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderEdgeWidthVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderEdgeWidthValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderTopWidth"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderWidthVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderWidthValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderWidth"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderStyleVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderStyleValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderStyle"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderColorVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderColorValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderColor"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Border"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderCornerRadiusVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderCornerRadiusValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderTopLeftRadius"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderRadiusVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BorderRadiusValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderRadius"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Font"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontSizeVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontSizeValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontSize"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontStretchVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontStretchValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontStretch"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontStyleVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontStyleValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontStyle"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontVariantVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontVariantValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontVariant"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontWeightVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontWeightValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontWeight"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontFamilyVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "FontFamilyValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontFamily"
            }
          }
        }
      ],
      "type": "object"
    },
    "LineHeightVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LineHeightValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LineHeight"
            }
          }
        }
      ],
      "type": "object"
    },
    "LetterSpacingVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "LetterSpacingValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LetterSpacing"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextAlignVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextAlignValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextAlign"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextTransformVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextTransformValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextTransform"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextShadowVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextShadowValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextShadow"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextDecorationVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextDecorationValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecoration"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextDecorationLineVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextDecorationLineValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecorationLine"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextDecorationStyleVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextDecorationStyleValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecorationStyle"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextDecorationThicknessVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextDecorationThicknessValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecorationThickness"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextIndentVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "TextIndentValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextIndent"
            }
          }
        }
      ],
      "type": "object"
    },
    "PaddingVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "PaddingValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Padding"
            }
          }
        }
      ],
      "type": "object"
    },
    "PaddingEdgeVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "PaddingEdgeValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PaddingTop"
            }
          }
        }
      ],
      "type": "object"
    },
    "MarginVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "MarginValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Margin"
            }
          }
        }
      ],
      "type": "object"
    },
    "MarginEdgeVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "MarginEdgeValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.MarginTop"
            }
          }
        }
      ],
      "type": "object"
    },
    "BoxShadowVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BoxShadowValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BoxShadow"
            }
          }
        }
      ],
      "type": "object"
    },
    "OpacityVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "OpacityValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Opacity"
            }
          }
        }
      ],
      "type": "object"
    },
    "CssJustifyContentVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "CssJustifyContentValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.JustifyContent"
            }
          }
        }
      ],
      "type": "object"
    },
    "BackgroundVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "BackgroundValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Background"
            }
          }
        }
      ],
      "type": "object"
    },
    "WritingModeVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "WritingModeValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.WritingMode"
            }
          }
        }
      ],
      "type": "object"
    },
    "DisplayVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "DisplayValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Display"
            }
          }
        }
      ],
      "type": "object"
    },
    "FilterVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "FilterValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Filter"
            }
          }
        }
      ],
      "type": "object"
    },
    "GapVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "GapValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Gap"
            }
          }
        }
      ],
      "type": "object"
    },
    "SingleValueGapVar--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "cssVarName": {
              "type": "string"
            },
            "value": {
              "$ref": "urn:dm:schemas:common.json#/reference"
            }
          }
        }
      ],
      "type": "object"
    },
    "SingleValueGapValue--unrestricted-root": {
      "allOf": [
        {
          "type": "object",
          "properties": {
            "variableConnections": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "path": {
                        "type": "string",
                        "pattern": "^(?:value)$"
                      },
                      "variableId": {
                        "$ref": "urn:dm:schemas:common.json#/reference",
                        "variableTypesByPattern": {
                          "items": [
                            {
                              "pattern": "^(?:value)$"
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                "unevaluatedProperties": false,
                "type": "object"
              }
            }
          }
        },
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "value"
          ],
          "properties": {
            "value": {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.SingleValueGap"
            }
          }
        }
      ],
      "type": "object"
    },
    "RefArray--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/RefArray"
    },
    "VariantRelation--unrestricted-root": {
      "$ref": "urn:dm:schemas:commonSchemas.json#/VariantRelation"
    }
  },
  "variants_data.json": {
    "$id": "urn:dm:schemas:variants_data.json",
    "Hover": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Mobile": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "State": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId",
            "name"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            },
            "name": {
              "type": "string",
              "default": "state"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Selected": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Trigger": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "discriminator": {
            "propertyName": "trigger"
          },
          "oneOf": [
            {
              "additionalProperties": true,
              "properties": {
                "trigger": {
                  "type": "string",
                  "enum": [
                    "viewport-enter",
                    "viewport-leave"
                  ]
                },
                "params": {
                  "type": "object",
                  "properties": {
                    "threshold": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 1
                    },
                    "margin": {
                      "type": "object",
                      "properties": {
                        "top": {
                          "$ref": "urn:dm:schemas:commonSchemas.json#/MinimalUnitSize"
                        },
                        "bottom": {
                          "$ref": "urn:dm:schemas:commonSchemas.json#/MinimalUnitSize"
                        },
                        "left": {
                          "$ref": "urn:dm:schemas:commonSchemas.json#/MinimalUnitSize"
                        },
                        "right": {
                          "$ref": "urn:dm:schemas:commonSchemas.json#/MinimalUnitSize"
                        }
                      },
                      "unevaluatedProperties": false
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "additionalProperties": true,
              "required": [
                "params"
              ],
              "properties": {
                "trigger": {
                  "type": "string",
                  "enum": [
                    "animation-start",
                    "animation-end"
                  ]
                },
                "params": {
                  "type": "object",
                  "required": [
                    "effect"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "effect": {
                      "$ref": "urn:dm:schemas:common.json#/reference"
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "additionalProperties": true,
              "properties": {
                "trigger": {
                  "type": "string",
                  "enum": [
                    "pointer-move"
                  ]
                },
                "params": {
                  "type": "object",
                  "required": [
                    "hitArea"
                  ],
                  "properties": {
                    "hitArea": {
                      "type": "string",
                      "default": "self",
                      "enum": [
                        "self",
                        "root"
                      ]
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "additionalProperties": true,
              "properties": {
                "trigger": {
                  "type": "string",
                  "default": "click",
                  "enum": [
                    "click",
                    "tap",
                    "mouse-in",
                    "mouse-out",
                    "hover",
                    "view-progress",
                    "scroll-progress",
                    "page-visible"
                  ]
                },
                "params": {
                  "type": "object",
                  "additionalProperties": false,
                  "unevaluatedProperties": false
                }
              }
            }
          ],
          "required": [
            "componentId",
            "trigger"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            },
            "trigger": {
              "type": "string"
            },
            "params": {
              "type": "object",
              "additionalProperties": true,
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Preset": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RepeaterPattern": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId",
            "tag"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            },
            "tag": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "RepeaterPatternList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId",
            "values"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            },
            "values": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "VariantsList": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId",
            "values"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            },
            "values": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BreakpointsData": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "values"
          ],
          "properties": {
            "values": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "namedRanges": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "componentId": {
              "type": "string"
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "BreakpointRange": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "min": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "max": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "canvasSize": {
              "type": "number",
              "multipleOf": 1
            },
            "namedRange": {
              "type": "string",
              "maxLength": 30
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "NamedRange": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 30
            }
          }
        }
      ],
      "unevaluatedProperties": false,
      "type": "object"
    },
    "Hover--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "Mobile--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "State--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId",
            "name"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            },
            "name": {
              "type": "string",
              "default": "state"
            }
          }
        }
      ],
      "type": "object"
    },
    "Selected--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "Trigger--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "discriminator": {
            "propertyName": "trigger"
          },
          "oneOf": [
            {
              "additionalProperties": true,
              "properties": {
                "trigger": {
                  "type": "string",
                  "enum": [
                    "viewport-enter",
                    "viewport-leave"
                  ]
                },
                "params": {
                  "type": "object",
                  "properties": {
                    "threshold": {
                      "type": "number",
                      "minimum": 0,
                      "maximum": 1
                    },
                    "margin": {
                      "type": "object",
                      "properties": {
                        "top": {
                          "$ref": "urn:dm:schemas:commonSchemas.json#/MinimalUnitSize"
                        },
                        "bottom": {
                          "$ref": "urn:dm:schemas:commonSchemas.json#/MinimalUnitSize"
                        },
                        "left": {
                          "$ref": "urn:dm:schemas:commonSchemas.json#/MinimalUnitSize"
                        },
                        "right": {
                          "$ref": "urn:dm:schemas:commonSchemas.json#/MinimalUnitSize"
                        }
                      },
                      "unevaluatedProperties": false
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "additionalProperties": true,
              "required": [
                "params"
              ],
              "properties": {
                "trigger": {
                  "type": "string",
                  "enum": [
                    "animation-start",
                    "animation-end"
                  ]
                },
                "params": {
                  "type": "object",
                  "required": [
                    "effect"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "effect": {
                      "$ref": "urn:dm:schemas:common.json#/reference"
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "additionalProperties": true,
              "properties": {
                "trigger": {
                  "type": "string",
                  "enum": [
                    "pointer-move"
                  ]
                },
                "params": {
                  "type": "object",
                  "required": [
                    "hitArea"
                  ],
                  "properties": {
                    "hitArea": {
                      "type": "string",
                      "default": "self",
                      "enum": [
                        "self",
                        "root"
                      ]
                    }
                  },
                  "unevaluatedProperties": false
                }
              }
            },
            {
              "additionalProperties": true,
              "properties": {
                "trigger": {
                  "type": "string",
                  "default": "click",
                  "enum": [
                    "click",
                    "tap",
                    "mouse-in",
                    "mouse-out",
                    "hover",
                    "view-progress",
                    "scroll-progress",
                    "page-visible"
                  ]
                },
                "params": {
                  "type": "object",
                  "additionalProperties": false,
                  "unevaluatedProperties": false
                }
              }
            }
          ],
          "required": [
            "componentId",
            "trigger"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            },
            "trigger": {
              "type": "string"
            },
            "params": {
              "type": "object",
              "additionalProperties": true,
              "unevaluatedProperties": false
            }
          }
        }
      ],
      "type": "object"
    },
    "Preset--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "RepeaterPattern--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId",
            "tag"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            },
            "tag": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "RepeaterPatternList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId",
            "values"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            },
            "values": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "VariantsList--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "componentId",
            "values"
          ],
          "properties": {
            "componentId": {
              "type": "string"
            },
            "values": {
              "default": [],
              "type": [
                "array"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            }
          }
        }
      ],
      "type": "object"
    },
    "BreakpointsData--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "required": [
            "values"
          ],
          "properties": {
            "values": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "namedRanges": {
              "type": [
                "array",
                "null"
              ],
              "items": [
                {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              ]
            },
            "componentId": {
              "type": "string"
            }
          }
        }
      ],
      "type": "object"
    },
    "BreakpointRange--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "min": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "max": {
              "$ref": "urn:dm:schemas:common.json#/JavaInt"
            },
            "canvasSize": {
              "type": "number",
              "multipleOf": 1
            },
            "namedRange": {
              "type": "string",
              "maxLength": 30
            }
          }
        }
      ],
      "type": "object"
    },
    "NamedRange--unrestricted-root": {
      "allOf": [
        {
          "$ref": "urn:dm:schemas:common.json#/DataNode--unrestricted-root"
        },
        {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 30
            }
          }
        }
      ],
      "type": "object"
    }
  }
}
